// AJAX TO WRITE SESSION VARIABLE FOR TEXT SIZE CHANGE

var http = false;
var tbl_resources = '';
var tbl_resources_data_row = '';
var tbl_subheadings_data_row = '';
var tbl_staff = '';
var cmsLoadingStatus = false;
var tbl_announcements = '';
var tbl_projects      = '';
var tbl_afec_schools  = '';
var tbl_student_profiles = '';
var tbl_afec_assessors = '';
var tbl_faculty_profiles = '';
var unsavedValues     = [];
var unsaved           = false; 
var tbl_certifications = ''; 
var tbl_regulations = '';
var tbl_knowledge_tests = '';
var tbl_assessment_question_bank = '';
var tbl_assessment_question_bank_filtered = '';
var tbl_assessment_question_bank_filtered_randomisation = '';
var tbl_certification_courses = '';
var tbl_regulation_courses = '';
var textChangeArrayCMS  = {};
var oldValueCMS         = '';
var isDirty             = false; 
var languageList        = ['en', 'ru', 'fr', 'es', 'ar', 'zhcn', 'ja', 'pt', 'vi', 'ko', 'lb', 'sv', 'in', 'tr'];
var submission_tabel    = '';


function launchModal() {
    var entry = getEntries();
    $('body').append("\n    <div class=\"modal fade in\" id=\"ie-modal\">\n        <div class=\"modal-dialog\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n                    <div class=\"row\">\n                        <div class=\"col-md-2\">\n                            <i class=\"fab fa-internet-explorer\"></i>\n                        </div>\n                        <div class=\"col-md-9\">\n                            <h5 class=\"modal-title\">"+entry[3064]+"</h5>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"modal-body\">\n                    <div class=\"row\">\n                        <div class=\"col-md-10\">\n                            <img src=\"../images/ie_modal/happiness.png\" alt=\"\" />\n                            <div class=\"speech-bubble\">"+entry[3065]+"</div>\n                        </div>\n                        <div class=\"col-md-2\">\n                        <a class=\"mb_3\" href=\"https://www.google.com/chrome/\" target=\"_blank\"> \n                            <i class=\"fab fa-chrome\"></i>\n                        </a>\n                        <a class=\"mb_3\" href=\"https://www.intowindows.com/how-to-install-microsoft-edge-in-windows-10/\" target=\"_blank\"> \n                            <i class=\"fab fa-edge\"></i>\n                        </a>\n                        <a class=\"mb_3\" href=\"https://support.apple.com/downloads/safari-for-windows\" target=\"_blank\"> \n                            <i class=\"fab fa-safari\"></i>\n                        </a>\n                        <a class=\"mb_3\" href=\"https://www.mozilla.org/en-US/firefox/new/\" target=\"_blank\"> \n                            <i class=\"fab fa-firefox\"></i>\n                            </a>\n                        </div>\n                    </div>\n                    \n                </div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">"+entry[3066]+"</button>\n                </div>\n            </div>\n        </div>\n    </div>");
    $('#ie-modal').modal('show');
}

if (navigator.appName == "Microsoft Internet Explorer")
{
    http = new ActiveXObject("Microsoft.XMLHTTP");
}
else
{
    http = new XMLHttpRequest();
}


function settextsize(textsize)
{
    http.abort();
    http.open("GET", "content/ajax_change_text_size.php?textsize=" + textsize);
    http.onreadystatechange = function () {
        if (http.readyState == 4) {

        }
    }
    http.send(null);
}


// MAKE TEXT SIZE CHANGE
var min = 0.58;
var max = 0.98;
function increaseFontSize()
{
    var p = document.getElementsByTagName('body');
    for (i = 0; i < p.length; i++) {
        if (p[i].style.fontSize) {
            var s = eval(p[i].style.fontSize.replace("em", ""));
        } else {
            var s = 0.68;
        }
        if (s < max) {
            s += 0.1;
        }
        p[i].style.fontSize = s + "em";
        settextsize(s);
    }
}


function decreaseFontSize() {
    var p = document.getElementsByTagName('body');
    for (i = 0; i < p.length; i++) {
        if (p[i].style.fontSize) {
            var s = eval(p[i].style.fontSize.replace("em", ""));
        } else {
            var s = 0.68;
        }
        if (s > min) {
            s -= 0.1;
        }
        p[i].style.fontSize = s + "em";
        settextsize(s);
    }
}

function resetFontSize() {
    document.getElementById('body').style.fontSize = "0.68em";
    settextsize("0.68");

}


function playPause() {
    var myVideo = document.getElementsByTagName('video')[0];
    if (myVideo.paused)
        myVideo.play();
    else
        myVideo.pause();
}


function triggerSubmit(e) {

    e.which = e.which || e.keyCode;

    if (e.which == 13) {
        // submit
        $("a[name='submitbutton']").click();
    }
}

function setTextareaHeight(jq_in) {
    jq_in.each(function (index, elem) {
        // This line will work with pure Javascript (taken from NicB's answer):
        elem.style.height = elem.scrollHeight + 'px';
    });
}

function getCurrentDate()
{ 
    var tdate = new Date();
    var dd = tdate.getDate();
    var MM = tdate.getMonth() + 1; //starts from 0
    var yyyy = tdate.getFullYear();
    var hh = tdate.getHours();
    var min = tdate.getMinutes();
    var sec = tdate.getSeconds();

    if (hh < 10)
    {
        hh = "0" + hh;
    }

    if (MM < 10)
    {
        MM = "0" + MM;
    }

    if (dd < 10)
    {
        dd = "0" + dd;
    }

    if (sec < 10)
    {
        sec = "0" + sec;
    }


    var currentDate = yyyy + "-" + MM + "-" + dd + "_" + hh + "-" + min + "-" + sec;

    return currentDate;
}

function getCourseFunction(programmeId, courseId, functionValue, participantsList, formId, workshopId, reminderType) {

    if (functionValue == 'select')
    {
        return false;
    }
    else
    {
        var is_deliverer_feedback = false;
        var academy_id = "";
        academy_id = getParameterByName('academy');
        var currentDate = getCurrentDate();
        var feedbackType = "attendee";

        if ((functionValue == "download_all_results_csv") || (functionValue == "download_all_results_excel"))
        {
            var filename_suffix = "all_";
        }
        else
        {
            var filename_suffix = "";
        }

        if (functionValue == "send_reminder")
        {
            if ($("#feedback-form-type option:selected").val() == "course_deliverers")
            {
                functionValue = "send_deliverer_reminder";
            }
        }

        if ((functionValue == "download_visit_result_csv") || (functionValue == "download_visit_result_excel") || (functionValue == "download_all_results_csv") || (functionValue == "download_all_results_excel"))
        {
            $("#function-wrapper").html("<label>Preparing to download...</label>");

            if ($("#feedback-form-type option:selected").val() == "course_deliverers")
            {
                feedbackType = "deliverer";
            }
        }

        var filename = "../fileshare/files/feedback_raw_" + filename_suffix + currentDate;

        if ((functionValue == "download_all_results_csv") || (functionValue == "download_visit_result_csv"))
            filename += ".csv";

        if ((functionValue == "download_all_results_excel") || (functionValue == "download_visit_result_excel"))
            filename += ".xlsx";

        var token = $('input[name="token"]').val();

        var online_course = $("#programmes").val();
        if(online_course == 'online_courses')
        {
            courseId = $("#online_courses").val();
        }

        $.post("/course_admin/ajax_get_course_function.php", {file_name: filename, programme_id: programmeId, course_id: courseId, function_value: functionValue, participants: participantsList, form_id: formId, workshop_id: workshopId, academy: academy_id, reminder_type: reminderType, feedback_type: feedbackType, ptToken : token}, function (result) {

            $("#reports-header-wrapper").html("");
            $("#reports-results-wrapper").html("");

            if (functionValue == 'email_for_feedback')
            {
                 $("#function-wrapper").show();
            }
           
            $("#function-wrapper").html(result);

            if ((functionValue == "download_visit_result_csv") || (functionValue == "download_visit_result_excel") || (functionValue == "download_all_results_csv") || (functionValue == "download_all_results_excel"))
            {
                if (result.indexOf("No") < 0)
                {
                    location.href = filename;
                    $("#function-wrapper").html("<label>Feedback Downloaded.</label>");
                }
                else
                {
                    $("#function-wrapper").html(result);
                }
            }

            $("#function-wrapper button").click(function () {

                if ($("#function-wrapper button").html() == "Sending")
                {
                    return false;
                }
                else
                {
                    var is_reminder = false;
                    var is_deliverer_feedback = false;

                    if ($("#programme-function option:selected").val() == "send_reminder")
                    {
                        is_reminder = true;
                    }

                    if ($("#feedback-form-type option:selected").val() == "course_deliverers")
                    {
                        is_deliverer_feedback = true;
                    }

                    var participants = $('input[name="participant"]:checked').map(function () {
                        return this.value;
                    }).get();


                    if (participants.length != 0)
                    {
                        $("#function-wrapper button").html("Sending");

                        if (($("#feedback-form-type").val() == "course") || ($("#feedback-form-type").val() == "course_deliverers"))
                        {
                            var feedbackFormId = $("#feedback-form-course").val();
                            var workshopId = null;
                        }
                        else
                        {
                            var feedbackFormId = $("#feedback-form-workshop").val();
                            var workshopId = $("#course-" + courseId + "-workshops").val();
                        }

                        if ((!is_reminder) && (!is_deliverer_feedback))
                        {
                            getCourseFunction(programmeId, courseId, "send_feedback", participants, feedbackFormId, workshopId); //Send Feedback Email to participants
                        }
                        else if ((!is_reminder) && (is_deliverer_feedback))
                        {
                            getCourseFunction(programmeId, courseId, "send_deliverer_feedback", participants, feedbackFormId, workshopId); //Send feedback email to Deliverers
                        }
                        else if ((is_deliverer_feedback) && (is_reminder))
                        {
                            getCourseFunction(programmeId, courseId, "send_deliverer_reminder_email", participants, feedbackFormId, workshopId, reminderType); //Send Reminder to Deliverers
                        }
                        else
                        {
                            getCourseFunction(programmeId, courseId, "send_feedback_reminder", participants, feedbackFormId, workshopId, reminderType); //Send reminder to participants
                        }
                    }

                }

            });

            $("#function-wrapper input[type='radio']").click(function () {

                alert("To be developed");
            });

            $("#toggle-all").click(function () {

                $(".email-form input[type='checkbox']").each(function (index) {

                    $(this).prop("checked", $("#toggle-all").prop("checked"));
                });

            });

        });
    }
}

function setRestrictionMessages()
{
    var adminType;

    if (window.location.href.indexOf("coursesettings") > -1)
    {
        adminType = "course";
    }
    else
    {
        adminType = "academy";
    }

    if ($("#valid-domains").children().length == 0)
    {
        $("#all-emails").show();

        $("#emails-message").html("All email addresses can register for this " + adminType);
    }
    else
    {
        $("#all-emails").hide();

        $("#emails-message").html("Only email addresses within valid domains can currently register for this " + adminType);
    }

    if ($("#valid-emails").children().length == 0)
    {
        $("#emails-message").show();

        $("#all-emails").html("All email addresses can register for this " + adminType);
    }
    else
    {
        $("#emails-message").hide();

        $("#all-emails").html("Only email addresses within the valid registration emails list can currently register for this " + adminType);
    }
}

function removeDomain(removeDiv, domainType, referenceId) {
    var token = $('input[name="token"]').val();
    domainName = $(removeDiv).parent().children(".valid-item-name").html();

    $.post("course_admin/ajax_remove_valid_domain.php", {id: referenceId, domain: domainName, type: domainType, ptToken : token}, function (result) {

        data = JSON.parse(result);
        if(data.message == "Invalid Token")
        {
            alert("Something went wrong!");
        }
        else
        {
            $(removeDiv).parent().remove();
            setRestrictionMessages();
        }
    });
}

function addDomain(e, domainType, referenceId) {

    var domainHtml = $("#valid-domains").html();
    var domainName = $("#domain").val();
    var token = $('input[name="token"]').val();

    if (domainName != "") {

        $.post("course_admin/ajax_add_valid_domain.php", {id: referenceId, domain: domainName, type: domainType, ptToken : token}, function (result) {

            if(result == "")
            {
                alert("Something went wrong!");
                $("#domain").val("");
                $("#domain").focus();
            }
            else
            {
                domainHtml = domainHtml + "<div class='valid-item'><div class='valid-item-name'>" + domainName + "</div>";
                domainHtml = domainHtml + "<a class='remove-item' onclick='removeDomain(this, " + '"' + domainType + '",' + referenceId + ")'>Remove</a>"
                domainHtml = domainHtml + "</div>";

                $("#valid-domains").html(domainHtml);
                $("#domain").val("");
                $("#domain").focus();

                setRestrictionMessages();
            }
        });
    }

    e.preventDefault();
    return false;
}

/* Note this function also is shared by the course admin feature */
function removeAcademyEmail(removeDiv, emailType, referenceId) {

    emailAddress = $(removeDiv).parent().children(".valid-item-name").html();
    var token = $('input[name="token"]').val();
    $.post("course_admin/ajax_remove_valid_email.php", {id: referenceId, email: emailAddress, type: emailType, ptToken : token}, function (result) {
        data = JSON.parse(result);
        if(data.message == "Invalid Token")
        {
            alert("Something went wrong!");
        }
        else
        {
            $(removeDiv).parent().remove();
            setRestrictionMessages();
        }
    });
}

/* Note this function also is shared by the course admin feature */
function addAcademyEmail(e, emailType, referenceId) {

    var emailHtml = $("#valid-emails").html();
    var emailAddress = $("#emailAddress").val();
    var token = $('input[name="token"]').val();
    if (emailAddress != "") {

        $.post("course_admin/ajax_add_valid_email.php", {id: referenceId, email: emailAddress, type: emailType, ptToken : token}, function (result) {

            if(result == "")
            {
                alert("Something went wrong!");
                $("#emailAddress").val("");
                $("#emailAddress").focus();
            }
            else
            {
                emailHtml = emailHtml + "<div class='valid-item'><div class='valid-item-name'>" + emailAddress + "</div>";
                emailHtml = emailHtml + "<a class='remove-item' onclick='removeAcademyEmail(this, " + '"' + emailType + '",' + referenceId + ")'>Remove</a>"
                emailHtml = emailHtml + "</div>";

                $("#valid-emails").html(emailHtml);
                $("#emailAddress").val("");
                $("#emailAddress").focus();

                setRestrictionMessages();
            }
        });
    }

    e.preventDefault();
    return false;
}

function addAdminUser(e, academyId) {

    var adminHtml = $("#valid-administrators").html();
    var emailAddress = $("#email").val();
    var token = $('input[name="token"]').val();

    $("#admin-error").html("");

    if (emailAddress != "") {

        $.post("course_admin/ajax_add_administrator.php", {academy_id: academyId, email: emailAddress, ptToken : token}, function (result) {

            if (result == "")
            {
                $("#admin-error").html("Something went wrong!");
                $("#email").val("");
            }
            else
            {
                adminHtml = adminHtml + "<div class='valid-item'><div class='valid-item-name'>" + emailAddress + "</div>";
                adminHtml = adminHtml + "<a class='remove-item' onclick='removeAdminUser(this, " + '"' + result + '"' + ")'>Remove</a>"
                adminHtml = adminHtml + "</div>";

                $("#valid-administrators").html(adminHtml);
                $("#email").val("");
            }

            $("#email").focus();
        });
    }

    e.preventDefault();
    return false;
}

function applyEdit(divId, source, editId, moduleId, courseId, pageId, contentId)
{
    var path  = "course_admin/ajax_apply_edit.php";
    var token = $('input[name="token"]').val();

    if (source == "admin_page")
    {
        path = "../course_admin/ajax_apply_edit.php";
    }

    $.post(path, {source: source, edit_id: editId, module_id: moduleId, course_id: courseId, page_id: pageId, content_id: contentId, ptToken : token}, function (result) {

        if (result == "")
        {
            // TODO - handle error
        }
        else
        {
            var obj = JSON.parse(result);

            $(".edit-history").html(obj.edit_history);
            $(".latest-version").html(obj.latest_version);
            $(".request-edit-form").html(obj.request_edit);
        }

    });

    //e.preventDefault();
    return false;
}

function declineEdit(divId, source, editId, moduleId, courseId, pageId, contentId) {

    var path = "course_admin/ajax_decline_edit.php";
    var token = $('input[name="token"]').val();

    if (source == "admin_page")
    {
        path = "../course_admin/ajax_decline_edit.php";
    }

    $.post(path, {source: source, edit_id: editId, module_id: moduleId, course_id: courseId, page_id: pageId, content_id: contentId, ptToken : token}, function (result) {

        if (result == "")
        {
            // TODO - handle error
        }
        else
        {
            var obj = JSON.parse(result);

            $(".edit-history").html(obj.edit_history);
            $(".latest-version").html(obj.latest_version);

        }

    });

    //e.preventDefault();
    return false;
}

function getParameterByName(name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function changeFormLanguage() {

    var token = getParameterByName('token');
    var academy = "";
    academy = getParameterByName('academy');

    if (academy > 0)
    {
        window.location.href = "/?view=feedback&token=" + token + "&lang=" + $("#language").val() + "&academy=" + academy;
    }
    else
    {
        window.location.href = "/?view=feedback&token=" + token + "&lang=" + $("#language").val();
    }


}

function removeAdminUser(removeDiv, userId) {

    var token = $('input[name="token"]').val();
    administrator = $(removeDiv).parent().children(".valid-item-name").html();

    $.post("course_admin/ajax_remove_administrator.php", {user_id: userId, ptToken : token}, function (result) {
        data = JSON.parse(result);
        if(data.message == "Invalid Token")
        {
            alert("Something went wrong!");
        }
        else
        {
            $(removeDiv).parent().remove();
        }
    });
}

var currentColour = '#75082a';

function showBio(bioNumber) {

    $(".member").hide();
    $("#member-profile-" + bioNumber).show();
    $(".faculty .intro-text").hide();

    return false;
}

function backToProfiles(bioNumber) {

    $(".member").show();
    $("#member-profile-" + bioNumber).hide();
    $(".faculty .intro-text").show();

    return false;
}

function showHideKey() {

    if ($("html.ogkm #body-dashboard .key").is(":visible")) {

        $("html.ogkm #body-dashboard .key").fadeOut();

    } else {

        $("html.ogkm #body-dashboard .key").fadeIn();

    }
}

function setInterventionIcons(interventionNumber)
{
    $(".type-icon img:last-child").remove();
    $(".type-icon").removeClass("workshop");
    $(".type-icon").removeClass("games-debrief");
    $(".type-icon").removeClass("observers");
    $(".type-icon").removeClass("needs");
    $(".type-icon").removeClass("visio");

    if(interventions[interventionNumber].icon != '' && interventions[interventionNumber].icon != null)
    {
        var path = "https://d22u7g0jugykn9.cloudfront.net/images/intervention_type_icons/"+interventions[interventionNumber].icon;
        $(".type-icon").prepend('<img style="margin-top:4px; width:36px; height:40px;" src="'+path+'" />');
    }
    else
    {
        if ((interventions[interventionNumber].type == "Workshop (multi-day)") || (interventions[interventionNumber].type == "Workshop (single-day)")) {

            $(".type-icon").addClass("workshop");

        } else if (interventions[interventionNumber].type == "Games Debrief") {

            $(".type-icon").addClass("games-debrief");

        } else if (interventions[interventionNumber].type == "Observation and Experience") {

            $(".type-icon").addClass("observers");

        } else if (interventions[interventionNumber].type == "Needs-based solution defined with OCOG") {

            $(".type-icon").addClass("needs");

        } else if ((interventions[interventionNumber].type == "Visio Meeting") || (interventions[interventionNumber].type == "Visio/On-site Meeting")) {

            $(".type-icon").addClass("visio");
        }
    }
}

function setInterventionProperties(classname, interventionNumber) {
    
    $(classname + " .type").html(interventions[interventionNumber].type);
    $(classname + " .name").html(interventions[interventionNumber].name);
    $(classname + " .timeframe").html(interventions[interventionNumber].actual_timeframe);

    var this_color_code = interventions[interventionNumber].color_code;

    var default_color_code = 1;

    if ((this_color_code == 0) || (this_color_code == undefined))
    {
        this_color_code = default_color_code;
    }

    //Adding these two conditions as per Hiam's email on 05 April 2018
    if ((this_color_code == 4) || (this_color_code == 5))
    {
        this_color_code = default_color_code;
    }
    else if (this_color_code == 2)
    {
        this_color_code = 5;
    }

    var is_ioc = interventions[interventionNumber].is_ioc;

    if (this_color_code == 1) // red
    {
        if(is_ioc)
        {
            $(classname + " .detail-panel").css('border-bottom-color', "#e13551");
            $(classname + " .detail-panel").removeClass('is-striped');
        }
        else
        {
            $(classname + " .detail-panel").css('border-bottom-color', "#e13551");
            $(classname + " .detail-panel").addClass('is-striped');
        }
    }
    else if (this_color_code == 5) // blue
    {
        if(is_ioc)
        {
            $(classname + " .detail-panel").css('border-bottom-color', "#3883c4");
            $(classname + " .detail-panel").removeClass('is-striped');
        }
        else
        {
            $(classname + " .detail-panel").css('border-bottom-color', "#3883c4");
            $(classname + " .detail-panel").addClass('is-striped');
        }
    }
    else if (this_color_code == 3) // yellow
    {
        if(is_ioc)
        {
            $(classname + " .detail-panel").css('border-bottom-color', "#f4af35");
            $(classname + " .detail-panel").removeClass('is-striped');
        }
        else
        {
            $(classname + " .detail-panel").css('border-bottom-color', "#f4af35");
            $(classname + " .detail-panel").addClass('is-striped');
        }
    }
}

function setBackgroundColor(color_code, is_ioc)
{
    var default_color_code = 1;

    if ((color_code == 0) || (color_code == undefined))
    {
        color_code = default_color_code;
    }

    //Adding these two conditions as per Hiam's email on 05 April 2018
    if ((color_code == 4) || (color_code == 5))
    {
        color_code = default_color_code;
    }
    else if (color_code == 2)
    {
        color_code = 5;
    }

    if (color_code == 1) // red
    {
        if(is_ioc)
        {
            $("#main-link").css("border-color", "#e13551").removeClass('is-striped');
            $(".current-intervention:not(#main-link) .detail-panel").css('border-bottom-color', "#e13551");
            $(".current-intervention:not(#main-link) .detail-panel").removeClass('is-striped');
        }
        else
        {
            $("#main-link").css("border-color", "#e13551").addClass('is-striped');
            $(".current-intervention:not(#main-link) .detail-panel").css('border-bottom-color', "#e13551");
            $(".current-intervention:not(#main-link) .detail-panel").addClass('is-striped');
        }
    }
    else if (color_code == 5) // blue
    {
        if(is_ioc)
        {
            $("#main-link").css("border-color", "#3883c4").removeClass('is-striped');
            $(".current-intervention:not(#main-link) .detail-panel").css('border-bottom-color', "#3883c4");
            $(".current-intervention:not(#main-link) .detail-panel").removeClass('is-striped');
        }
        else
        {
            $("#main-link").css("border-color", "#3883c4").addClass('is-striped');
            $(".current-intervention:not(#main-link) .detail-panel").css('border-bottom-color', "#3883c4");
            $(".current-intervention:not(#main-link) .detail-panel").addClass('is-striped');
        }
    }
    else if (color_code == 3) // yellow
    {
        if(is_ioc)
        {
            $("#main-link").css("border-color", "#f4af35").removeClass('is-striped');
            $(".current-intervention:not(#main-link) .detail-panel").css('border-bottom-color', "#f4af35");
            $(".current-intervention:not(#main-link) .detail-panel").removeClass('is-striped');
        }
        else
        {
            $("#main-link").css("border-color", "#f4af35").addClass('is-striped');
            $(".current-intervention:not(#main-link) .detail-panel").css('border-bottom-color', "#f4af35");
            $(".current-intervention:not(#main-link) .detail-panel").addClass('is-striped');
        }
    }
}

function changePathwayColour(direction) {

    if ((direction == 'left') && (currentInterventionIndex > 0)) {

        currentInterventionIndex--;

    }
    else if ((direction == 'right') && (currentInterventionIndex < (interventions.length - 1))) {

        currentInterventionIndex++;
    }

    if (currentInterventionIndex > 0) {

        $("#green-dot-3 label").html("G" + interventions[currentInterventionIndex - 1].games_timeframe);
        $("#green-link-3").attr("href", "/?academy=8&view=intervention&intervention=" + interventions[currentInterventionIndex - 1].id);

        setInterventionProperties("#green-link-3", (currentInterventionIndex - 1));

        $("#green-dot-3").fadeIn();
        $("#green-link-3").fadeIn();
        $("#green-extension-1").fadeIn();
    }
    else {

        $("#green-dot-3").fadeOut();
        $("#green-link-3").fadeOut();
        $("#green-extension-1").fadeOut();
    }

    if (currentInterventionIndex > 1) {

        $("#green-dot-2 label").html("G" + interventions[currentInterventionIndex - 2].games_timeframe);
        $("#green-link-2").attr("href", "/?academy=8&view=intervention&intervention=" + interventions[currentInterventionIndex - 2].id);

        setInterventionProperties("#green-link-2", (currentInterventionIndex - 2));

        $("#green-dot-2").fadeIn();
        $("#green-link-2").fadeIn();
    }
    else {

        $("#green-dot-2").fadeOut();
        $("#green-link-2").fadeOut();
    }

    if (currentInterventionIndex > 2) {

        $("#green-dot-1 label").html("G" + interventions[currentInterventionIndex - 3].games_timeframe);
        $("#green-link-1").attr("href", "/?academy=8&view=intervention&intervention=" + interventions[currentInterventionIndex - 3].id);

        setInterventionProperties("#green-link-1", (currentInterventionIndex - 3));

        $("#green-dot-1").fadeIn();
        $("#green-link-1").fadeIn();
    }
    else {

        $("#green-dot-1").fadeOut();
        $("#green-link-1").fadeOut();
    }

    if (currentInterventionIndex < (interventions.length - 1)) {

        $("#red-dot-1 label").html("G" + interventions[currentInterventionIndex + 1].games_timeframe);
        $("#red-link-1").attr("href", "/?academy=8&view=intervention&intervention=" + interventions[currentInterventionIndex + 1].id);

        setInterventionProperties("#red-link-1", (currentInterventionIndex + 1));

        $("#red-dot-1").fadeIn();
        $("#red-link-1").fadeIn();
        $("#red-extension-1").fadeIn();
    }
    else {

        $("#red-dot-1").fadeOut();
        $("#red-link-1").fadeOut();
        $("#red-extension-1").fadeOut();
    }

    if (currentInterventionIndex < (interventions.length - 2)) {

        $("#red-dot-2 label").html("G" + interventions[currentInterventionIndex + 2].games_timeframe);
        $("#red-link-2").attr("href", "/?academy=8&view=intervention&intervention=" + interventions[currentInterventionIndex + 2].id);

        setInterventionProperties("#red-link-2", (currentInterventionIndex + 2));

        $("#red-dot-2").fadeIn();
        $("#red-link-2").fadeIn();
    }
    else {

        $("#red-dot-2").fadeOut();
        $("#red-link-2").fadeOut();
    }

    if (currentInterventionIndex < (interventions.length - 3)) {

        $("#red-dot-3 label").html("G" + interventions[currentInterventionIndex + 3].games_timeframe);
        $("#red-link-3").attr("href", "/?academy=8&view=intervention&intervention=" + interventions[currentInterventionIndex + 3].id);

        setInterventionProperties("#red-link-3", (currentInterventionIndex + 3));

        $("#red-dot-3").fadeIn();
        $("#red-link-3").fadeIn();
    }
    else {

        $("#red-dot-3").fadeOut();
        $("#red-link-3").fadeOut();
    }

    $("#main-link").attr("href", "/?academy=8&view=intervention&intervention=" + interventions[currentInterventionIndex].id);
    $(".current-intervention .btn").attr("href", "/?academy=8&view=intervention&intervention=" + interventions[currentInterventionIndex].id);

    $(".current-intervention .name").html(interventions[currentInterventionIndex].name);
    $(".current-intervention .timeframe").html("G" + interventions[currentInterventionIndex].games_timeframe + ", " + interventions[currentInterventionIndex].actual_timeframe);

    setInterventionProperties("#main-link", currentInterventionIndex);
    setInterventionIcons(currentInterventionIndex);
    setBackgroundColor(interventions[currentInterventionIndex].color_code, interventions[currentInterventionIndex].is_ioc);
}

function onRemoveLinkClicked(e)
{
    var link = $(e.target);
    var url_field   = link.prev();
    var name_field  = url_field.prev();

    if ($(".link-name").length > 1)
    {
        url_field.remove();
        name_field.remove();
        link.remove();
    }
    else
    {
        url_field.val("");
        name_field.val("");
    }
}

function onRemoveStreamField(e)
{
    var link      = $(e.target);
    var url_field = link.prev();

    if ($(".link-streams").length > 1)
    {
        url_field.remove();
        link.remove();
    }
    else
    {
        url_field.val("");
    }
}

var originalFeaturesOptions    = '';
function toggleEntityValueRolesSection()
{
    if ( ($("#entity_id").val() == 1) || ($("#entity_id").val() == 2)) //Learning Pathway & All Activities
    {
        if ($("#entity_id").val() == 1)
        {
            $("#entity_value").show();
            $("#entity_value").parent().parent().find('label').show();
        }
        else
        {
            $("#entity_value").val("");
            $("#entity_value").hide();
            $("#entity_value").parent().parent().find('label').hide();
        }
       
        $("#related-academies-select2-box").parent().hide();
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide();  
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide(); 
        $(".related-activities-programmes").hide();     
        $(".related-activities-programmes").parent().parent().hide();  
        
        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);

        $('#feature_id option').each(function()
        {           
            if (($(this).val() == 11) || ($(this).val() == 12) || ($(this).val() == 13))
            {               
                $(this).remove();
            }
        })

    }
    else if ( $("#entity_id").val() == 3) // ITF Admin
    {
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide();  
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide(); 
        $("#country_regions").val('');
        $("#countries").hide();     
        $("#countries").parent().parent().hide();          
        
        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);

        $('#feature_id option').each(function()
        {
            if (($(this).val() == 11) || ($(this).val() == 12) || ($(this).val() == 13) || ($(this).val() == 6) 
               || ($(this).val() == 10) || ($(this).val() == 7) || ($(this).val() == 9) || ($(this).val() == 8))
            {               
                $(this).remove();
            }
        })
    }
    else if ($("#entity_id").val() == 4) //Voucher
    {
        $("#related-academies-select2-box").parent().show();
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#countries").hide();     
        $("#countries").parent().parent().hide();    
        $("#countries").val('');

        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide();  
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide();
        $(".related-activities-programmes").hide();     
        $(".related-activities-programmes").parent().parent().hide();   

      
        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);
        
        $('#feature_id option').each(function()
        {

            if ($(this).val() != 2)
            {
                $(this).remove();

            }
        })
    }
    else if (($("#entity_id").val() == 5) || ($("#entity_id").val() == 19) || ($("#entity_id").val() == 20) || ($("#entity_id").val() == 26)) // OGKM Dashboard Reports
    {
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#related-academies-select2-box").parent().hide();
        $("#feature_id option").remove();
        $("#feature_id").append('<option value = "1">View</option>');

        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide();  
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide(); 
        $(".related-activities-programmes").hide();     
        $(".related-activities-programmes").parent().parent().hide();  
    }
    else if ($("#entity_id").val() == 6) // Reports
    {
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#related-academies-select2-box").parent().hide();
        $("#feature_id option").remove();
        $("#feature_id").append('<option value = "1">View</option><option value = "3">Edit</option>');
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide();  
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide(); 
        $(".related-activities-programmes").hide();     
        $(".related-activities-programmes").parent().parent().hide();  
    }
    else if ($("#entity_id").val() == 7) //Full Ocog
    {
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#related-academies-select2-box").parent().hide();
        $("#feature_id option").remove();
        $("#feature_id").append('<option value = "9">Send Feedback Form</option>');
        $("#feature_id").append('<option value = "8">Track Attendance</option>');

        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide();  
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide(); 
        $(".related-activities-programmes").hide();     
        $(".related-activities-programmes").parent().parent().hide();  
    }
    else if ($("#entity_id").val() == 8) // Regional Reports
    {
        $("#country_regions").show();     
        $("#country_regions").parent().parent().show();  
        $("#academies_regions").show();     
        $("#academies_regions").parent().parent().show(); 
        $("#countries").hide();     
        $("#countries").parent().parent().hide();    
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#countries").val(''); 
        $(".related-activities-programmes").hide();     
        $(".related-activities-programmes").parent().parent().hide(); 
        

        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);

        $('#feature_id option').each(function()
        {
           
            if ($(this).val() != 1)
            {
                $(this).remove();
            }
        })
    }
    else if ($("#entity_id").val() == 9) // Country Reports
    {
        $("#countries").show();     
        $("#countries").parent().parent().show();  
        $("#academies_regions").show();     
        $("#academies_regions").parent().parent().show();  
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide(); 
        $("#country_regions").val('');
        $(".related-activities-programmes").hide();     
        $(".related-activities-programmes").parent().parent().hide();  

        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);

        $('#feature_id option').each(function()
        {
            if ($(this).val() != 1)
            {
                $(this).remove();
            }
        })
    }
    else if ($("#entity_id").val() == 11) // GEP Experience Oppurtunities
    {               
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide();  
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide(); 
        $("#country_regions").val('');
        $("#countries").hide();     
        $("#countries").parent().parent().hide();          
        
        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);

        $('#feature_id option').each(function()
        {
            if ($(this).val() != 3)
            {
                $(this).remove();
            }
        })
    }
    else if (($("#entity_id").val() == 10) || ($("#entity_id").val() == 13) || ($("#entity_id").val() == 17) || ($("#entity_id").val() == 22) || ($("#entity_id").val() == 23) || ($("#entity_id").val() == 24)) //Course Builder
    {       
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide();  
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide(); 
        $("#country_regions").val('');
        $("#countries").hide();     
        $("#countries").parent().parent().hide();
        
        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);

        $('#feature_id option').each(function()
        {
            if ($(this).val() != 13)
            {
                $(this).remove();
            }
        })
    }
    else if ($("#entity_id").val() == 25) // Form Access
    {       
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide();  
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide(); 
        $("#country_regions").val('');
        $("#countries").hide();     
        $("#countries").parent().parent().hide();
        
        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);

        $('#feature_id option').each(function()
        {
            if ($(this).val() != 2)
            {
                $(this).remove();
            }
        })
    }
    else if ($("#entity_id").val() == 18) //Whitelabeling
    {       
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide();  
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide(); 
        $("#country_regions").val('');
        $("#countries").hide();     
        $("#countries").parent().parent().hide();
        
        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);

        $('#feature_id option').each(function()
        {
            if (($(this).val() != 14) && ($(this).val() != 15))
            {
                console.log($(this).val());
                $(this).remove();
            }
        })
    }
    else if ($("#entity_id").val() == 12) //Gep Delegations
    {        
       
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide();  
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide(); 
        $("#country_regions").val('');
        $("#countries").hide();     
        $("#countries").parent().parent().hide();
        
        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);

        $('#feature_id option').each(function()
        {
            if ($(this).val() != 2) 
            {
                $(this).remove();
            }
        })
    }
    else if ( ($("#entity_id").val() == 14) || ($("#entity_id").val() == 15)) //ITF Content items only
    {        
       
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide();  
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide(); 
        $("#country_regions").val('');
        $("#countries").hide();     
        $("#countries").parent().parent().hide();
        
        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);

        $("#feature_id option").remove();
        $("#feature_id").append('<option value = "2">Add</option>');
        $("#feature_id").append('<option value = "3">Edit</option>');
        $("#feature_id").append('<option value = "5">Delete</option>');
    }
    else if (($("#entity_id").val() == 16)  || ($("#entity_id").val() == 21)) //Certificate Types cms
    {        
       
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide();  
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide(); 
        $("#country_regions").val('');
        $("#countries").hide();     
        $("#countries").parent().parent().hide();
        
        $("#feature_id option").remove();        
        $("#feature_id").append(originalFeaturesOptions);

        $("#feature_id option").remove();
        $("#feature_id").append('<option value = "2">Add</option>');
       
    }
    else
    {
        $("#entity_value").val("");
        $("#entity_value").hide();
        $("#entity_value").parent().parent().find('label').hide();
        $("#related-academies-select2-box").parent().hide();
        $("#country_regions").hide();     
        $("#country_regions").parent().parent().hide(); 
        $("#countries").hide();     
        $("#countries").parent().parent().hide();   
        $("#academies_regions").hide();     
        $("#academies_regions").parent().parent().hide(); 
        $("#feature_id option").remove();
        $(".related-activities-programmes").hide();     
        $(".related-activities-programmes").parent().parent().hide();  
        $("#feature_id").append(originalFeaturesOptions);
    }   
}


//Load intervention details on click of Details button, link on grid view or on click of intervention itself.
function showInterventionDetailPage(currentElement, intervention) {

    $(".dash-loader").css('display', 'flex');
    $("#interventions-list").hide();
    $("#pathway-filter").hide();
    var currentGamesEditionLogo = $(".games-logo").attr("src");
    var currentGamesEdId = $(".games-logo").attr("data-index");

    var viewActive = "timeline";

    if ($("#interventions-grid-list-section").is(":visible"))
    {
        viewActive = "grid";
        $("#interventions-grid-list-section").hide();
    }

    window.history.pushState({"viewActive" : viewActive},"Intervention Detail view", null);

    var pathwayVersionId = $(".lp-select-header option:selected").val();
    var interventionId;
    var hrefParts = [];
    var interventionHref;
    var functionVal = "loadInterventionDetails";
    var pathwayCategory  = $("#pathway-category-select option:selected").val();
    var token = $('input[name="token"]').val();

    if (currentElement !== '')
    {
        interventionHref = currentElement.attr("href");
        hrefParts = interventionHref.split("intervention=");
        interventionId = hrefParts[1];   
    }
    else
    {
        interventionId = intervention;
    }

    var pageURL     = window.location.href;
    var requestList = pageURL.split("&");
    var newURL      = '';
    requestList.forEach(function(entry) {
        newURL += entry +"&";
    });
    if (!newURL.includes("intervention_id"))
    {
        newURL += "intervention_id="+interventionId;
    }
    else 
    {
        var urlLength = newURL.length;
        newURL        = newURL.substring(0, (urlLength-1)); 
    }
    window.history.pushState("", "", newURL);
    newURL = '';

    $.post("/course_admin/ajax_load_intervention_detail.php", {
        functionVal: functionVal, 
        interventionId: interventionId, 
        pathwayVersionId: pathwayVersionId, 
        pathway_category:pathwayCategory, 
        ptToken:token
    }, function (result) {
        $(".pathway").hide();
        $("#online-courses-header").hide();
        $('.learning-pathways-header').hide();
        $(".online-courses").hide();
        $('.dash-loader').hide();
        $(".learning-pathways-section").append('<div class="single-intervention">' + result + '</div>');
        $(".intervention-panel").hide();
        $(".intervention-panel").fadeIn(300);
        $(".games-logo").attr("src", currentGamesEditionLogo);
        $(".games-logo").attr("data-index", currentGamesEdId);

        $('html, body').animate({
            scrollTop: $(".single-intervention").offset().top
        }, 200);

        window.addEventListener('popstate', function(e) {
                onInterventionDetailBackClicked(viewActive);
        });

        $(".back-to-ogkm-home-btn button").on('click', function (e) {

            var pageURL     = window.location.href;
            var requestList = pageURL.split("&");
            var newURL      = '';
            requestList.forEach(function(entry) {
                if (!entry.includes("intervention_id"))
                {
                    newURL += entry +"&";
                }
                else if (entry.includes("intervention_id"))
                {
                    var urlLength = newURL.length;
                    newURL    = newURL.substring(0, (urlLength-1)); 
                }
            });
            window.history.pushState("", "", newURL);
            newURL = '';          

            $(".single-intervention").remove();

            if (viewActive == "timeline")
            {
                $("#interventions-list").fadeIn(500);
            }
            else if (viewActive == "grid")
            {
                $("#interventions-grid-list-section").fadeIn(500);
            }

            $(".pathway").css('display', '');
            $('.learning-pathways-header').css('display', '');
            $(".dash-loader").hide();
            $("#pathway-filter").css('display', '');
            $("#online-courses-header").show();
            $(".online-courses").show();

            $('html, body').animate({
                scrollTop: $("#pathway-filter").offset().top
            }, 100);

        });
    });
}

function manageLearningPathway(key, value)
{
    if(key != null && value != null)
    {
        var pathway_id = $("#"+key).attr('data-index');
        var functionType = "manage_learning_pathway";
        var token = $('input[name="token"]').val();

        $.ajax({
            url : '../course_admin/ajax_publish_intervention_as_course.php',
            dataType: "json",
            data: {
                function    : functionType,
                pathway_id  : pathway_id,
                ptToken     : token,
                key         : key,
                value       : value
            },
            success: function (data) 
            {
                    
            }
        }); 
    }
}

function loadLearningPathwaysForUserRoles()
{
    var selectedGamesEdition = $("#geList").val();
    var lp_list              = readLearningPathways();
    var userRoleLpList       = readUserRoleLearningPathways(); 
    var length               = lp_list.length;
    var output               = '';
    $("#lp_target").empty();
    for (var i = 0; i < length; i++)
    {
        var id           = lp_list[i].lpv_id;
        var name         = lp_list[i].lpv_name;
        var gamesEdition = lp_list[i].games_edition;
        var checked      = 0;

        userRoleLpList.forEach(function(element) {
            if(element.games_edition_id === gamesEdition && id === element.learning_pathway_id) {
                checked = 1;
            }          
        });

        if(selectedGamesEdition == gamesEdition)
        {
            output  += "<div class='cms-row lp-interventions'>";
            output  += "<input class='lp-check' type='checkbox' name='lp-id[]'' value='"+id+"' ";
            if(checked === 1)
            {
                output  += "checked='yes'";
            }
            output  += "/>"+name+"</div>";
        }            
    }
    output += "<div class='cms-row lp-interventions'><input type='checkbox' id='select_all_lp' onclick='selectAllPathways()'/>Select All</div>";
    $("#lp_target").html(output);
}

function selectAllPathways()
{
    if ($('#select_all_lp').is(":checked"))
    {
        $(".lp-check").prop('checked',true);
    }
    else
    {
        $(".lp-check").prop('checked',false)
    }
}

function selectAllFunctionalAreas(fa_type)
{    
    if ($('#select_all_fas_'+fa_type+'').is(":checked"))
    {
        $(".fa-check-list_"+fa_type+"").prop('checked',true);
    }
    else
    {
        $(".fa-check-list_"+fa_type+"").prop('checked',false)
    }
}

function selectAllStreams()
{
    if ($('#select_all_streams').is(":checked"))
    {
        $(".cb-cms").prop('checked',true);
    }
    else
    {
        $(".cb-cms").prop('checked',false);
    }
}

function selectAllPathwaysByCategory(lp_category)
{    
    if ($('#select_all_pathways_'+lp_category+'').is(":checked"))
    {
        $(".lp-check-"+lp_category+"").prop('checked',true);
    }
    else
    {
        $(".lp-check-"+lp_category+"").prop('checked',false)
    }
}

function get_user_timezone_offset_minutes()
{
    var timezone_offset_minutes = new Date().getTimezoneOffset();
    timezone_offset_minutes     = timezone_offset_minutes == 0 ? 0 : -timezone_offset_minutes;
    return timezone_offset_minutes;
}

function manageAcademyAccess(academyId, operation, userId, label_name)
{
    if(academyId != null && operation != null && userId != null)
    {
        var token       = $('input[name="token"]').val();
        var action      = null;
        var academyHtml = $("#user-academy-access-div").html();

        if (operation)
        {
            action = 'create_academy_access';
        }
        else
        {
            action = 'remove_academy_access';
        }

        $.ajax({
            url : '../content/ajax_user_management.php',
            dataType: "json",
            data: {
                ptToken     : token,
                action      : action,
                academy_id  : academyId,
                user_id     : userId
            },
            success: function (data) 
            {
                if (data.message === 'academy_access_granted')
                {
                    academyHtml = academyHtml + "<div class='form-group row'><label class='col-form-label'>"+label_name+"</label></div>";
                    $("#user-academy-access-div").html(academyHtml);
                }
                else
                {
                    var academyArray = data.message;
                    academyHtml = '';
                    academyArray.forEach(function(element) {
                        academyHtml += "<div class='form-group row'><label class='col-form-label'>"+element+"</label></div>";
                    });
                    $("#user-academy-access-div").html(academyHtml);
                }
            }
        }); 
    }
}

function manageUserRoles(roleId, operation, userId)
{
    var token       = $('input[name="token"]').val();
    var action      = null;

    if (operation)
    {
        action = 'create_user_role_access';
        $.ajax({
            url : '../content/ajax_user_management.php',
            dataType: "json",
            data: {
                ptToken     : token,
                action      : action,
                role_id     : roleId,
                user_id     : userId
            },
            success: function (data) 
            {   
                $("#roles-messages").hide();
                $("#div-roles-user").append(data.output);
                var new_item = '#tree-roles-user-management-' + roleId;
                $(''+new_item+'').treed({openedClass:'fa-chevron-right', closedClass:'fa-chevron-down'});
            }
        }); 
    }
    else
    {
        action = 'remove_user_role_access';
        $.ajax({
            url : '../content/ajax_user_management.php',
            dataType: "json",
            data: {
                ptToken     : token,
                action      : action,
                role_id     : roleId,
                user_id     : userId
            },
            success: function (data) 
            {
                if (data.count == 0)
                {
                    $("#roles-messages").show();
                }                

                $("#div-roles-user").html(data.output);
                $('#tree-roles-user-management').treed({openedClass:'fa-chevron-right', closedClass:'fa-chevron-down'});
            }
        }); 
    }    
}

function OnReportLevel()
{
    var reportLevel = $("#ogkm-report-level").val();
    if (reportLevel === 'executive-level-area')
    {
        document.getElementById("report-lp-area").style.display = "none";
        document.getElementById("report-product-area").style.display = "none"; 
        $("#ogkm-dash-report-body").hide(); 
        $("#ge-list-dropdown").parent().hide(); 
        $('#date-selectors-ogkm-reports').parent().show();  
        $('.search-btn-area').show();    
        $('.search-btn-prod-area').hide();     
    }
    else if (reportLevel === 'product-area')
    {
        document.getElementById("report-lp-area").style.display = "none";     
        document.getElementById("report-product-area").style.display = "block";
        $("#ge-list-dropdown").parent().show(); 
        $('#date-selectors-ogkm-reports').parent().hide();  
        $('.search-btn-area').hide();
        $('.search-btn-prod-area').show();
        $("#ogkm-dash-report-body").hide(); 
        $('#activity_visits').hide();

        $('#ogkm-report-level').css('border-color', "#d2d6de");
        loadFiltersInStages('#rpt-report-areas-frm');
        DisableApplyFilterBtn();
    }
    else if (reportLevel === 'lp-area')
    {
        document.getElementById("report-product-area").style.display = "none";        
        document.getElementById("report-lp-area").style.display = "block";
        $("#ge-list-dropdown").parent().show();  
        $('#date-selectors-ogkm-reports').parent().show(); 
        $('.search-btn-area').show();  
        $('.search-btn-prod-area').hide();
        $("#ogkm-dash-report-body").hide(); 
    }
}

function OnAcademyChangeFilter()
{
    var userInfoUrl = "admin/ajax_get_user_management_users.php?ptToken="+$("input[name=token]").val()+"&academy_id="+$('#academy-list-user-management').val();
    $('#tbl_user_management').DataTable().ajax.url(userInfoUrl).load();
}

function publishStaffRecords()
{
    $('body').on('click', '.staff_active', function() {

        var contentid    = $(this).attr("data-content-id");
        var availability = $(this).attr("data-content-availability");
        var button       = $(this);
        var svg          = button.find('.svg-inline--fa');
        var token        = $("input[name=token]").val();

        var action = "unpublish_staff_member";

        if (availability === '0')
        {
            action = "publish_staff_member";
        }

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                staff_id  : contentid,
                action    : action,
                ptToken   : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        setTimeout(function(){
                            if (action == "publish_staff_member")
                            {
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-on fa-w-18 fa itf-icons-success ");
                                button.attr("data-original-title", "Deactivate user");
                            }
                            else
                            {
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-off fa-w-18 fa");
                                button.attr("data-original-title", "Activate user");
                            }
                        },500);
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                    reload_staff_table();
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

function publishAnnouncementRecords()
{
    $('body').on('click', '.announcement_active', function() {

        var contentid    = $(this).attr("data-content-id");
        var onLive       = $(this).attr("data-content-on-live");
        var button       = $(this);
        var svg          = button.find('.announcement_active .svg-inline--fa');
        var token        = $("input[name=token]").val();

        var action = "unpublish_announcement";

        if (onLive === '0')
        {
            action = "publish_announcement";
        }

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                announcement_id  : contentid,
                action           : action,
                ptToken          : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        reload_announcements_table();
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

function archiveAnnouncementRecords()
{
    $('body').on('click', '.announcement_archive', function() {

        var contentid    = $(this).attr("data-content-id");
        var isArchived   = $(this).attr("data-content-is-archived");
        var button       = $(this);
        var svg          = button.find('.announcement_archive .svg-inline--fa');
        var token        = $("input[name=token]").val();

        var action = "unarchive_announcement";

        if (isArchived === '0')
        {
            action = "archive_announcement";
        }        

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                announcement_id  : contentid,
                action           : action,
                ptToken          : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        reload_announcements_table();
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

function archiveIstudyAnnouncementRecords()
{
    $('body').on('click', '.announcement_istudy_archive', function() {

        var contentid    = $(this).attr("data-content-id-istudy");
        var isArchived   = $(this).attr("data-content-is-archived-istudy");
        var button       = $(this);
        var svg          = button.find('.announcement_istudy_archive .svg-inline--fa');
        var token        = $("input[name=token]").val();

        var action = "unarchive_istudy_announcement";

        if (isArchived === '0')
        {
            action = "archive_istudy_announcement";
        }        

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                announcement_id  : contentid,
                action           : action,
                ptToken          : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        reload_announcements_table();
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

function publishProjects()
{
    $('body').on('click', '.project_active', function() {

        var contentid     = $(this).attr("data-content-id");
        var publishStatus = $(this).attr("data-content-publish-status");
        var button        = $(this);
        var svg           = button.find('.svg-inline--fa');
        var token         = $("input[name=token]").val();

        var action = "unpublish_project";

        if (publishStatus === '0')
        {
            action = "publish_project";
        }

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                project_id  : contentid,
                action      : action,
                ptToken     : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        reload_projects_table();
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

function publishAFECSchool()
{
    $('body').on('click', '.afec_centres_active', function() {

        var contentid     = $(this).attr("data-content-id");
        var publishStatus = $(this).attr("data-content-publish-status");
        var button        = $(this);
        var svg           = button.find('.svg-inline--fa');
        var token         = $("input[name=token]").val();

        var action = "unpublish_afec_centres";

        if (publishStatus === '0')
        {
            action = "publish_afec_centres";
        }

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                centre_id   : contentid,
                action      : action,
                ptToken     : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        reload_afac_school_table();
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

function publishStudentProfile()
{
    $('body').on('click', '.student_profiles_active', function() {

        var contentid     = $(this).attr("data-content-id");
        var publishStatus = $(this).attr("data-content-publish-status");
        var button        = $(this);
        var svg           = button.find('.svg-inline--fa');
        var token         = $("input[name=token]").val();

        var action = "unpublish_student_profile";

        if (publishStatus === '0')
        {
            action = "publish_student_profile";
        }

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                student_profile_id   : contentid,
                action      : action,
                ptToken     : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        reload_student_profiles_table();
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

function publishAFECAssessor()
{
    $('body').on('click', '.afec_assessor_active', function() {

        var contentid     = $(this).attr("data-content-id");
        var publishStatus = $(this).attr("data-content-publish-status");
        var button        = $(this);
        var svg           = button.find('.svg-inline--fa');
        var token         = $("input[name=token]").val();

        var action = "unpublish_afec_assessor";

        if (publishStatus === '0')
        {
            action = "publish_afec_assessor";
        }

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                afec_assessor_id   : contentid,
                action      : action,
                ptToken     : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        reload_afec_assessors_table();
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

function publishFacultyProfile()
{
    $('body').on('click', '.faculty_profile_active', function() {

        var contentid     = $(this).attr("data-content-id");
        var publishStatus = $(this).attr("data-content-publish-status");
        var button        = $(this);
        var svg           = button.find('.svg-inline--fa');
        var token         = $("input[name=token]").val();

        var action = "unpublish_faculty_profile";

        if (publishStatus === '0')
        {
            action = "publish_faculty_profile";
        }

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                faculty_profile_id   : contentid,
                action      : action,
                ptToken     : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        reload_faculty_profiles_table();
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

function publishWebsiteCMS()
{
    $('body').on('click', '#publish-website-cms-btn', function() {

        var token     = $("input[name=token]").val();
        var bckColor  = $(this).css('background-color'); console.log(bckColor);
        $("#publish-website-cms-btn").val("Publishing");

        $.ajax({
            url: '../api/v1/people_admin.php',
            dataType: "json",
            data: {              
                action      : 'publish_website_cms',
                ptToken     : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output == "success")
                    {
                        setTimeout(function(){
                            $("#publish-website-cms-btn").val("Published");
                            $("#publish-website-cms-btn").css('background-color', 'green');
                            
                            setTimeout(function(){
                                $("#publish-website-cms-btn").val("Publish");
                                $("#publish-website-cms-btn").css('background-color', bckColor);
                            }, 1000);
                        }, 500);
                    }
                    else if(data.errormessage !== "")
                    {
                        $("#publish-website-cms-btn").val("Publish");
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    $("#publish-website-cms-btn").val("Publish");
                    alert("Something went wrong.");
                }
            }
        });
    });
}

// function publishAcademyResourceItems() {
    $(document).on('click', '.resource_active', function() {

        var contentid = $(this).attr("data-content-id");
        var button    = $(this);
        var svg       = button.find('.svg-inline--fa');
        var title     = $(this).attr("data-original-title");
        var token     = $("input[name=token]").val();
        title         = title.trim();

        button.toggleClass('active');

        var action = "unpublish_resource_items";

        if (title === "Publish Content")
        {
            action = "publish_resource_items";
        }

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                resource_id  : contentid,
                action       : action,
                ptToken      : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        setTimeout(function(){
                            var tbl_resources_row =  tbl_resources_data_row[0] - 1;
                            var status_text       = document.getElementsByClassName("status_text");

                            if (button.hasClass('active'))
                            {
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-on fa-w-18 fa itf-icons-success ");
                                button.attr("data-original-title", "Deactivate Content");
                                // status_text[(tbl_resources_row)].innerText = "Publish";

                                button.parents('tr').find('.availability_text').text("Publish");
                            }
                            else
                            {
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-off fa-w-18 fa");
                                button.attr("data-original-title", "Publish Content");
                                // status_text[(tbl_resources_row)].innerText = "Unpublish";
                                button.parents('tr').find('.availability_text').text("Un-publish");
                            }
                        },500);
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
// }

function updateFeedbackLiveStatus()
{
    $('body').on('click', '.feedback_form_is_live', function() {

        var feedbackFormId     = $(this).attr("data-content-id");
        var feedbackFormStatus = $(this).attr("data-content-status");
        var button             = $(this);
        var svg                = button.find('.svg-inline--fa');
        var token              = $("input[name=token]").val();
        var action             = "edit_feedback_form_live_status";
        var isLive             = 1;

        if (feedbackFormStatus === '1')
        {
            isLive = 0;
        }

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                feedback_form_id : feedbackFormId,
                action           : action,
                ptToken          : token,
                is_live          : isLive     
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        setTimeout(function(){
                            if (feedbackFormStatus == "1")
                            {
                                $('[data-toggle="tooltip"]').tooltip({
                                    trigger: 'hover'
                                });
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-off fa-w-18 fa");
                                button.attr("data-original-title", "Inactive");
                                button.attr("data-content-status", "0");
                            }
                            else
                            {
                                $('[data-toggle="tooltip"]').tooltip({
                                    trigger: 'hover'
                                });
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-on fa-w-18 fa itf-icons-success ");
                                button.attr("data-original-title", "Active");
                                button.attr("data-content-status", "1");
                            }
                        },500);
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

$(document).on('click', '.availability_academy_resources', function() {

    var contentid = $(this).attr("data-content-id");
    var button    = $(this);
    var svg       = button.find('.svg-inline--fa');
    var title     = $(this).attr("data-availablity");
    var token     = $("input[name=token]").val();
    title         = title.trim();
    var action    = "update_resource_availability";
    var action_value = 0;

    button.toggleClass('active');

    if (title === "Publish for Public")
    {
        action_value = 1;
    }

    svg.attr("class", "fa fa-spinner fa-fw fa-pulse spinner-btn");

    $.ajax({
        url: '../cms/ajax_cms.php',
        dataType: "json",
        async: false,
        data: {
            ptToken      : token,
            resource_id  : contentid,
            action       : action,
            action_value : action_value                
        },
        success: function(data)
        {
            try
            {
                if (data.output != "")
                {
                    setTimeout(function(){
                        var tbl_resources_row =  (tbl_resources_data_row[0] - 1);
                        var availability_text = $("availability_text");

                        if (button.hasClass('active'))
                        {
                            button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-on fa-w-18 fa itf-icons-success ");
                            button.attr("data-original-title", "Publish for Registered Users only");
                            // availability_text[(tbl_resources_row)].innerText = "Public";

                            button.parents('tr').find('.availability_text').text("Public");
                        }
                        else
                        {
                            button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-off fa-w-18 fa");
                            button.attr("data-original-title", "Publish for Public");
                            // availability_text[(tbl_resources_row)].innerText = "Registered Users";
                            button.parents('tr').find('.availability_text').html("Registered Users");
                        }                          
                    },500);
                }
                else if(data.errormessage !== "")
                {
                    alert(data.errormessage);
                }
            }
            catch (e)
            {
                alert("Something went wrong.");
            }
        }
    });
});

function publishAcademyResourceSubheadings()
{
    $('body').on('click', '.subheading_active', function() {

        var contentid = $(this).attr("data-content-id");
        var button = $(this);
        var svg = button.find('.svg-inline--fa');
        var title = $(this).attr("data-original-title");
        var token = $("input[name=token]").val();
        title = title.trim();

        var action = "unpublish_resource_subheadings";

        if (title === "Publish")
        {
            action = "publish_resource_subheadings";
        }

        svg.attr("class", "fa fa-spinner fa-fw fa-pulse itf-icons-success spinner-btn");

        $.ajax({
            url: '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                subheading_id  : contentid,
                action         : action,
                ptToken        : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        setTimeout(function(){

                            var tbl_resources_row =  (tbl_subheadings_data_row[0] - 1);
                            var status_text       = document.getElementsByClassName("status_text_subheadings");

                            if (action == "publish_resource_subheadings")
                            {
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-on fa-w-18 fa itf-icons-success ");
                                button.attr("data-original-title", "Un-publish");
                                status_text[tbl_resources_row].innerText = "Publish";
                            }
                            else
                            {
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-off fa-w-18 fa");
                                button.attr("data-original-title", "Publish");
                                status_text[tbl_resources_row].innerText = "Un-publish";
                            }
                        },500);
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

function checkInterventionName(interventionName, programmeName)
{
    if (interventionName === programmeName)
    {
        $("input[name='submit']").attr("disabled", false);
        $("#assign-program-error").hide();
    }
    else
    {
        $("input[name='submit']").attr("disabled", true);
        $("#assign-program-error").show();
    }
}

function getPhaseByGamesTimeframe(gamesTimeframe)
{
    if ((-3 <= gamesTimeframe) && (gamesTimeframe <= 0))
    {
        return "operations"; // Games
    }
    else if ((-24 <= gamesTimeframe) && (gamesTimeframe <= -4))
    {
        return "readiness"; // Readiness
    }
    else if ((-48 <= gamesTimeframe) && (gamesTimeframe <= -25))
    {
        return "planning"; // Planning
    }
    else if ((-84 <= gamesTimeframe) && (gamesTimeframe <= -49))
    {
        return "foundation"; // Strategy 
    }
    else if (gamesTimeframe > 0)
    {
        return "dissolution"; // Legacy Realisation
    }
    else
    {
        return gamesTimeframe;
    }
}

function dateDiff(startDate, endDate) 
{
    var startdateMoment = moment(startDate);
    var enddateMoment   = moment(endDate);

    if (startdateMoment.isValid() === true && enddateMoment.isValid() === true) 
    {
        var years = enddateMoment.diff(startdateMoment, 'years');
        var months = enddateMoment.diff(startdateMoment, 'months') - (years * 12);

        startdateMoment.add(years, 'years').add(months, 'months');
        var days = enddateMoment.diff(startdateMoment, 'days');

        return {
            years: years,
            months: months,
            days: days
        };
    }
    else
    {
      return undefined;
    }
}

function readFeedbackFormsByAcademy()
{
    var action      = "read_feedback_forms_by_academy";
    var academyId   = $("#academy-list-feedback_forms").val();
    var ptToken     = $("input[name=token]").val();
    var page        = $("input[name=page]").val();
    var academy     = $("input[name=academy]").val();
    var programmeId = $("input[name=programme_id]").val();
    var onLive      = $("#on_live_feedback_forms").prop('checked');

    cmsLoadingStatus = true;
    loadOverlay();

    $.post('../cms/ajax_cms.php', 
    {
        action       : action,
        ptToken      : ptToken,
        academy_id   : academyId,
        page         : page,
        academy      : academy,
        programme_id : programmeId,
        on_live      : onLive
    },
    function (result) {
        if (page == 'feedback_forms')
        {
            $("#feedback-forms-flex-table").empty();
            $("#feedback-forms-flex-table").html(result);
            $('.delete-btn').click(function(evt){
                evt.stopImmediatePropagation();
                return confirm('Are you sure you want to delete this?');
            });
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }
        else if (page == 'programme')
        {
            $("#feedback_form_list").empty();
            if (result == "")
            {
                $("#feedback_form_list").html("<h1>No feedback forms found.</h1>");
            }
            else
            {
                $("#feedback_form_list").html(result);
            }            
        }
        cmsLoadingStatus = false;                     
    });
}

function displayFeedbackForms()
{
    $('#on_live_feedback_forms').change(function() {
        readFeedbackFormsByAcademy();
    });
}

$(document).on('click', '#save-source-academy', function() 
{
    var action         = "edit_source_academy";
    var ptToken        = $('input[name="token"]').val();
    var user_id        = $('input[name="user_id"]').val();
    var source_academy = $("#academy_list option:selected").val();

    $('#update-source-academy-div').removeClass("alert-danger");
    $('#update-source-academy-div').removeClass("alert-success");

    if ((source_academy == '') || (source_academy == null))
    {
        $('#update-source-academy-div').show();
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Home academy is empty!");
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../content/ajax_user_management.php',
            dataType: "json",
            data: {
                action         : action,
                ptToken        : ptToken,
                user_id        : user_id,
                source_academy : source_academy
            },
            success: function (data)
            {
                cmsLoadingStatus = false;
                $('#update-source-academy-div').show();
                if (data.output)
                {
                    $('#update-source-academy-div').addClass("alert-success");
                    $('#update-source-academy-div').html("Home academy is successfully updated!");

                    if (source_academy == 8)
                    {
                        $("#tab-organisation").show();
                        $("#tab-games-edition").show();
                    }
                    else
                    {
                        $("#tab-organisation").hide();
                        $("#tab-games-edition").hide();
                    }
                }
                else
                {
                    $('#update-source-academy-div').addClass("alert-danger");
                    $('#update-source-academy-div').html("Home academy is successfully updated!");
                }
                $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);            
            }
        });
    }
});

function showErrorMessage(message)
{
    $('#copy-activity-alert').addClass("alert-danger");
    $('#copy-activity-alert').html(message);
    $("#copy-activity-alert").fadeIn(300).delay(2000).fadeOut(400);
}

function showSuccessMessage(message)
{
    $('#copy-activity-alert').addClass("alert-success");
    $('#copy-activity-alert').html(message);
    $("#copy-activity-alert").fadeIn(300).delay(2000).fadeOut(400);
}

function set_colpick_on_input(input, theColour)
{
    $('' + input + '').colpick(
    {
        layout:'rgbhex',
        submit:0,
        colorScheme:'dark',
        color: theColour,
        onChange:function(hsb,hex,rgb,el,bySetColor) 
        {
            $(el).css('border-color', '#' + hex);
            $(el).css('border-right-width','35px');
            $(el).css('border-right-style','solid');
            if(!bySetColor) $(el).val('#'+hex);

            if (input == "#loggedin_sidebar_bg")
            {
                $(".main-sidebar").css("cssText", "background-color: #"+hex+" !important;");
                $(".menu-item").css("cssText", "background-color: #"+hex+" !important;");
            }
            else if (input == "#loggedin_sidebar_colour")
            {
                $(".main-sidebar li a").css("cssText", "color: #"+hex+" !important;");
            }
            else if (input == "#loggedin_header_backround")
            {
                $(".navbar.navbar-static-top").css("cssText", "background-color: #"+hex+" !important;");
                $('.main-header').before("<style>.main-header .navbar-custom-menu:before {border-right-color: #"+hex+" !important}</style>");
            } 
            else if (input == "#loggedin_header_link_colour")
            {
                $(".main-header a").css("cssText", "color: #"+hex+" !important;");
            }
            else if (input == "#loggedin_sidebar_svg")
            {
                $(".main-sidebar li a svg").attr('style', 'color: #'+ hex + ' !important');
            }
            else if (input == "#loggedin_sidebar_hover")
            {
                var sidebar_bg = $("input[name=loggedin_sidebar_bg]").val();
                $(".main-sidebar li a").hover(function(){
                    $(this).css("cssText", "background-color : #"+hex+" !important");
                    }, function(){
                    $(this).css("cssText", "background-color : "+sidebar_bg+" !important");
                });
            }
            else if (input == "#loggedin_sidebar_hover_svg")
            {
                var sidebar_svg = $("input[name=loggedin_sidebar_svg]").val();
                $(".main-sidebar li a").hover(function(){
                    $(this).children('svg').attr('style', 'color: #'+ hex + ' !important');
                }, function(){
                    $(this).children('svg').attr('style', 'color: '+ sidebar_svg + ' !important');
                });
            }
            else if (input == "#loggedin_header_link_hover")
            {
                var link_colour = $("input[name=loggedin_header_link_colour]").val();
                $(".main-header a").hover(function(){
                    $(this).attr('style', 'color: #'+ hex + ' !important');
                }, function(){
                    $(this).attr('style', 'color: '+ link_colour + ' !important');
                });
            }
            else if (input == "#btn_background_colour")
            {
                $("#whitelabel_config_save_btn").css("cssText", "background-color: #"+hex+" !important;");
            }
            else if (input == "#btn_colour")
            {
                $("#whitelabel_config_save_btn").css("cssText", "color: #"+hex+" !important;");
            }
            else if (input == "#primary_color")
            {              
                var overall_theme             = $("#overall_theme").prop('checked');
                var btn_background_colour     = $("input[name=btn_background_colour]").val();
                var loggedin_sidebar_hover    = $("input[name=loggedin_sidebar_hover]").val();
                var loggedin_header_backround = $("input[name=loggedin_header_backround]").val();
                var loggedin_sidebar_bg       = $("input[name=loggedin_sidebar_bg]").val();
                var loggedin_sidebar_hover_svg = $("input[name=loggedin_sidebar_hover_svg]").val();
                var secondary_color             = $("input[name=secondary_color]").val();

                if (overall_theme)
                {
                    $(".btn-success").css("cssText", "background-color: #"+hex+" !important; border-color : #"+hex+" !important; width: 114px; height: 40px;");
                    $(".main-header li.user-header").css("cssText", "background-color: #"+hex+" !important;");

                    if (loggedin_header_backround == '')
                    {
                        $(".navbar.navbar-static-top").css("cssText", "background-color: #"+hex+" !important;");
                        $('.main-header').before("<style>.main-header .navbar-custom-menu:before {border-right-color: #"+hex+" !important}</style>");
                    }

                    if (loggedin_sidebar_bg == '')
                    {
                        $(".main-sidebar").css("cssText", "background-color: #"+hex+" !important;");
                        $(".menu-item").css("cssText", "background-color: #"+hex+" !important;");
                    }

                    if (loggedin_sidebar_hover == '')
                    {
                        $(".main-sidebar li a").hover(function(){
                            $(this).css("cssText", "background-color : "+secondary_color+" !important");
                            }, function(){
                            $(this).css("cssText", "background-color : #"+hex+" !important");
                        });
                    }                    

                    if (loggedin_sidebar_hover_svg == '')
                    {
                        $(".main-sidebar li a").hover(function(){
                            $(this).children('svg').attr('style', 'color: #'+ hex + ' !important');
                        }, function(){
                            $(this).children('svg').attr('style', 'color: #FFFFFF !important');
                        });
                    }
                }
                else 
                {
                    $(".title-background-wrap .title-background").css("cssText", "background-color: #"+hex+" !important;");
                    $(".main-header .navbar-custom-menu #user-profile-header svg").css("cssText", "color: #"+hex+" !important;");

                    if (btn_background_colour == '')
                    {
                        $("#whitelabel_config_save_btn").css("cssText", "background-color: #"+hex+" !important;");
                    } 

                    if (loggedin_sidebar_hover == '')
                    {
                        var sidebar_bg = "#B1B1B1";
                        $(".main-sidebar li a").hover(function(){
                            $(this).css("cssText", "background-color : #"+hex+" !important");
                            }, function(){
                            $(this).css("cssText", "background-color : "+sidebar_bg+" !important");
                        });
                    }
                }
            }
            else if (input == "#secondary_color")
            {
                var overall_theme              = $("#overall_theme").prop('checked');
                var btn_background_colour      = $("input[name=btn_background_colour]").val();
                var loggedin_sidebar_hover     = $("input[name=loggedin_sidebar_hover]").val();
                var loggedin_header_backround  = $("input[name=loggedin_header_backround]").val();
                var loggedin_sidebar_bg        = $("input[name=loggedin_sidebar_bg]").val();
                var loggedin_sidebar_hover_svg = $("input[name=loggedin_sidebar_hover_svg]").val();
                var primary_color              = $("input[name=primary_color]").val();
                var loggedin_header_link_hover = $("input[name=loggedin_header_link_hover]").val();

                $(".new-main-footer a").css("cssText", "color: #"+hex+" !important;");

                if (overall_theme)
                {
                    $(".title-background-wrap .title-background").css("cssText", "background-color: #"+hex+" !important;");
                    $(".main-header .navbar-custom-menu #user-profile-header svg").css("cssText", "color: #"+hex+" !important;");

                    if (btn_background_colour == '')
                    {
                        $("#whitelabel_config_save_btn").css("cssText", "background-color: #"+hex+" !important;");
                    } 

                    if (loggedin_sidebar_hover == '')
                    {
                        $(".main-sidebar li a").hover(function(){
                            $(this).css("cssText", "background-color : #"+hex+" !important");
                            }, function(){
                            $(this).css("cssText", "background-color : "+primary_color+" !important");
                        });
                    }

                    if (loggedin_header_link_hover == '')
                    {
                        $(".main-header a").hover(function(){
                            $(this).attr('style', 'color: #'+ hex + ' !important');
                        }, function(){
                            $(this).attr('style', 'color: #FFFFFF !important');
                        });
                    }
                }
                else
                {
                    $(".main-header li.user-header").css("cssText", "background-color: #"+hex+" !important;");
                    
                    if (loggedin_sidebar_hover_svg == '')
                    {
                        $(".main-sidebar li a").hover(function(){
                            $(this).children('svg').attr('style', 'color: #'+ hex + ' !important');
                        }, function(){
                            $(this).children('svg').attr('style', 'color: #FFFFFF !important');
                        });
                    }

                    if (loggedin_header_link_hover == '')
                    {
                        $(".main-header a").hover(function(){
                            $(this).attr('style', 'color: #FFFFFF !important');
                        }, function(){
                            $(this).attr('style', 'color: #FFFFFF !important');
                        });
                    }
                }
            }
        }
    }).keyup(function() {
        $(this).colpickSetColor(this.value);
    });

    $(input).on('click', function(event) {
        $(this).colpickSetColor(this.value);
    });

    $(input).addClass('colpick-added');
}

$(document).on('change', '#is_learning_service_project', function() 
{
    var is_learning_service_project = $("#is_learning_service_project").prop('checked');
    if (is_learning_service_project)
    {
        $("#div_learning_service_type").show();
    }
    else
    {
        $("#div_learning_service_type").hide();
    }
});

$(document).on('change', '#overall_theme', function() 
{
    var overall_theme = $("#overall_theme").prop('checked');

    var primary_color               = $("input[name=primary_color]").val();
    var secondary_color             = $("input[name=secondary_color]").val();

    var loggedin_header_backround   = $("input[name=loggedin_header_backround]").val();
    var loggedin_header_link_colour = $("input[name=loggedin_header_link_colour]").val();
    var loggedin_header_link_hover  = $("input[name=loggedin_header_link_hover]").val();
    
    var loggedin_sidebar_bg         = $("input[name=loggedin_sidebar_bg]").val();
    var loggedin_sidebar_colour     = $("input[name=loggedin_sidebar_colour]").val();
    var loggedin_sidebar_svg        = $("input[name=loggedin_sidebar_svg]").val();
    var loggedin_sidebar_hover      = $("input[name=loggedin_sidebar_hover]").val();
    var loggedin_sidebar_hover_svg  = $("input[name=loggedin_sidebar_hover_svg]").val();

    var login_link_colour           = $("input[name=login_link_colour]").val();
    var login_link_hover            = $("input[name=login_link_hover]").val();
    var btn_background_colour       = $("input[name=btn_background_colour]").val();  

    if ((primary_color != '') && (secondary_color != ''))
    {
        if (overall_theme)
        {
            $(".btn-success").css("cssText", "background-color: "+primary_color+" !important; border-color : "+primary_color+" !important; width: 114px; height: 40px;");
            $(".main-header li.user-header").css("cssText", "background-color: "+primary_color+" !important;");

            if (loggedin_header_backround == '')
            {
                $(".navbar.navbar-static-top").css("cssText", "background-color: "+primary_color+" !important;");
                $('.main-header').before("<style>.main-header .navbar-custom-menu:before {border-right-color: "+primary_color+" !important}</style>");
            }

            if (loggedin_sidebar_bg == '')
            {
                $(".main-sidebar").css("cssText", "background-color: "+primary_color+" !important;");
                $(".menu-item").css("cssText", "background-color: "+primary_color+" !important;");
            }

            if (loggedin_sidebar_hover == '')
            {
                $(".main-sidebar li a").hover(function(){
                    $(this).css("cssText", "background-color : "+secondary_color+" !important");
                    }, function(){
                    $(this).css("cssText", "background-color : "+primary_color+" !important");
                });
            }

            if (loggedin_sidebar_hover_svg == '')
            {
                var sidebar_svg = "#FFFFFF";
                $(".main-sidebar li a").hover(function(){
                    $(this).children('svg').attr('style', 'color: '+ primary_color + ' !important');
                }, function(){
                    $(this).children('svg').attr('style', 'color: '+ sidebar_svg + ' !important');
                });
            }

            if (btn_background_colour == '')
            {
                $("#whitelabel_config_save_btn").css("cssText", "background-color: "+secondary_color+" !important;");
            } 

            $(".main-header .navbar-custom-menu #user-profile-header svg").css("cssText", "color: "+secondary_color+" !important;");
            $(".title-background-wrap .title-background").css("cssText", "background-color: "+secondary_color+" !important;");

            if (loggedin_header_link_hover == '')
            {
                $(".main-header a").hover(function(){
                    $(this).attr('style', 'color: '+ secondary_color +' !important');
                }, function(){
                    $(this).attr('style', 'color: #FFFFFF !important');
                });
            }
        }
        else
        {
            $(".main-header li.user-header").css("cssText", "background-color: "+secondary_color+" !important;");

            if (loggedin_header_backround == '')
            {
                $(".navbar.navbar-static-top").css("cssText", "background-color: #54565A !important;");
                $('.main-header').before("<style>.main-header .navbar-custom-menu:before {border-right-color: #54565A !important}</style>");
            }

            if (loggedin_sidebar_bg == '')
            {
                $(".main-sidebar").css("cssText", "background-color: #B1B1B1 !important;");
                $(".menu-item").css("cssText", "background-color: #B1B1B1 !important;");
            }

            if (loggedin_sidebar_hover == '')
            {
                $(".main-sidebar li a").hover(function(){
                    $(this).css("cssText", "background-color : "+primary_color+" !important");
                    }, function(){
                    $(this).css("cssText", "background-color : #B1B1B1 !important");
                });
            }

            if (loggedin_sidebar_hover_svg == '')
            {
                var sidebar_svg = "#FFFFFF";
                $(".main-sidebar li a").hover(function(){
                    $(this).children('svg').attr('style', 'color: '+ secondary_color + ' !important');
                }, function(){
                    $(this).children('svg').attr('style', 'color: '+ sidebar_svg + ' !important');
                });
            }

            if (btn_background_colour == '')
            {
                $("#whitelabel_config_save_btn").css("cssText", "background-color: "+primary_color+" !important;");
            } 

            $(".main-header .navbar-custom-menu #user-profile-header svg").css("cssText", "color: "+primary_color+" !important;");
            $(".title-background-wrap .title-background").css("cssText", "background-color: "+primary_color+" !important;");

            if (loggedin_header_link_hover == '')
            {
                $(".main-header a").hover(function(){
                    $(this).attr('style', 'color: #FFFFFF !important');
                }, function(){
                    $(this).attr('style', 'color: #FFFFFF !important');
                });
            }
        }
    }
});

function readTermsTextByTermsId(termsId, language, element)
{
    if (termsId != '')
    {
        cmsLoadingStatus = true;
        loadOverlay();
    
        var action  = "read_terms_text_by_language";
        var ptToken = $("input[name=token]").val(); 

        var formData = new FormData();
        formData.append('action', action);
        formData.append('ptToken', ptToken);
        formData.append('terms_id', termsId);
        formData.append('language', language);

        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            data: formData,
            contentType: false,
            cache: false,
            processData:false,
            success: function(data)
            {
                cmsLoadingStatus = false;
            
                $('#'+element).val(data['0']);
                $('#'+element).summernote('destroy');

                var summnerNoteFullOptions = {
                    minHeight: 200,
                    maxHeight: 300,
                    dialogsInBody: true,
                    codemirror: {
                        theme: 'monokai'
                    },
                    toolbar: [
                        ['style', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
                        ['insert', ['link', 'unlink']],
                        ['color', ['color']],
                        ['para', ['ul', 'ol', 'paragraph']],
                        ['code', ['codeview']]
                    ],
                    callbacks: {
                      onPaste: function (e) {
                        var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                        e.preventDefault();
                        setTimeout( function(){
                          document.execCommand( 'insertText', false, bufferText );
                        }, 10 );
                      }
                    }
                };
                $('#'+element).summernote(summnerNoteFullOptions);
            }
        });
    }
    else 
    {
        $('#'+element).val("");
    }
}

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(function(registration) {
        registration.unregister();
      })
      .catch(function(error) {
        console.error(error.message);
      });
  }
}

function reloginUser()
{    
    var email = $("#email").val();
    var password = $("#password").val();
    var academy_id = getParameterByName('academy');
    $("#relogin-modal-error").hide();
    $("#relogin-modal-success").hide();

    $.ajax({
        url: '/relogin_user.php',
        type: "post",
        dataType: "json",
        data: {
           email: email,
           password: password,
           academy_id: academy_id
        },            
        success : function(result) 
        {        
            if (result.token != null)
            {
                $("#relogin-modal-error").slideUp();
                $("#relogin-modal-success").slideDown();

                setTimeout(function(){
                    $("#feedback-form .btn-submit-feedback").html("Submit");
                    $("input[name='ptToken']").val(result.token);                
                    $("#global-modal .close").click(); 
                    $("#feedback-form .btn-submit-feedback").trigger('click');
                }, 1000);
            } 
            else
            {
                $("#relogin-modal-error").slideDown();
                $("#relogin-modal-success").slideUp();
            }        
        },
        error : function(result, error) 
        {
            console.log(result);                
        }
    });
}

$(document).ready(function () {

    setTimeout(() => {
        $('body').removeClass('pt-loading');
        $('.sb-container').removeClass('pt-loading');
        $('.sb-container').addClass('active');
    }, 500);

    $('body').removeClass('loading');


    if ($('body').hasClass('is_login_page')) {
        $('#language').select2({
            minimumResultsForSearch: Infinity,
            theme: "bootstrap-5",
        });

    } else {
         $('#language').select2({
            minimumResultsForSearch: Infinity,
            // theme: "bootstrap-5",
        });
    }

    if ($('.deliverer-role-table-content').length) initDelivererRolesDatatable();

    if ($("#sub_academy_ids").length)
    {
        $("#sub_academy_ids").select2({
            placeholder: "-- Sub-Academy --"
        });
    }

    if ($(".number_positive").length)
    {
        $(".number_positive").keypress(function (evt) {
            evt.preventDefault();
        });
    }

    if ($("#tbl_audience_types").length)
    {
        $("#tbl_audience_types").DataTable({
            "pageLength": 10,
            "initComplete" : function(){
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }         
        });
    }

    if ($("#tbl_authenticated_domains").length)
    {
        $("#tbl_authenticated_domains").DataTable({
            "pageLength": 10,
            "initComplete" : function(){
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }         
        });
    }

    if (($("#tbl_certificate_template").length) && (urlPageVal == 'academy') && (tabId == 7))
    {
        var data_url = "../cms/ajax_cms.php?action=read_certification_table&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
        $("#tbl_certificate_template").dataTable({
            "ajax": data_url,
            "deferRender" : true,
            "pageLength": 10,
            responsive: true,
            "initComplete" : function() {
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }
        }); 
    }

    if (($("#tbl_academy_administrators").length) && (urlPageVal == 'academy') && (tabId == 9))
    {
        var data_url = "../cms/ajax_cms.php?action=read_academy_administrators_table&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
        $("#tbl_academy_administrators").dataTable({
            "ajax": data_url,
            "deferRender" : true,
            "pageLength": 10,
            responsive: true,
            "initComplete" : function() {
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }
        }); 
    }

    if (($("#tbl_registration_domains").length) && (urlPageVal == 'academy') && (tabId == 10))
    {
        var data_url = "../cms/ajax_cms.php?action=read_academy_registration_domains&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
        $("#tbl_registration_domains").dataTable({
            "ajax": data_url,
            "deferRender" : true,
            "pageLength": 10,
            responsive: true,
            "initComplete" : function() {
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }
        });
    }

    if (($("#tbl_registration_emails").length) && (urlPageVal == 'academy') && (tabId == 11))
    {
        var data_url = "../cms/ajax_cms.php?action=read_academy_registration_emails&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
        $("#tbl_registration_emails").dataTable({
            "ajax": data_url,
            "deferRender" : true,
            "pageLength": 10,
            responsive: true,
            "initComplete" : function() {
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }
        }); 
    }

    if (($("#tbl_sub_academies").length) && (urlPageVal == 'academy') && (tabId == 8))
    {
        var data_url = "../cms/ajax_cms.php?action=read_sub_academies&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
        $("#tbl_sub_academies").dataTable({
            "ajax": data_url,
            "deferRender" : true,
            "pageLength": 10,
            responsive: true,
            "initComplete" : function() {
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }
        }); 
    }


    if (($("#tbl_accreditation_types").length) && (urlPageVal == 'academy') && (tabId == 12))
    {
        var data_url = "../cms/ajax_cms.php?action=read_academy_activity_types&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
        $("#tbl_accreditation_types").dataTable({
            "ajax": data_url,
            "deferRender" : true,
            "pageLength": 10,
            responsive: true,
            "initComplete" : function() {
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }
        }); 
    }

    $(function() {
        // if you're in academy 8 and within GEP
        if (urlAcademy == 8 || urlAcademy == 103)
        {
            if (urlViewVal == "gep" || urlViewVal == "ebook")
            {
                return;
            }
        }
        // else unregister the service worker
       unregister();
    });

    // check if IE
    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    if((isIE === true))
    {
        var showPopUp = showPopUpIe();

        if ((isUserLoggedIn === true) && (showPopUp !== true))
        {
            $.ajax({
                url: '../cms/ajax_cms.php',
                dataType: "json",
                data: {
                    action      : 'show_pop_up_ie',
                    ptToken     : 'show_pop_token'
                },
                success: function (data)
                {
                    if (data.output === true)
                    {
                        launchModal();
                    }                   
                },
                error: function ()
                {
                    alert("Something went wrong.");
                }
            });
        }
    }

    if ($(".filter_course_audience_types").length)
    {
        var entry   = readEntry();
        $(".filter_course_audience_types").select2({
            placeholder: entry[3263],
            theme: "bootstrap-5"
        });
    }

    if ((urlViewVal == 'cms') && (urlPageVal == 'academy_theme'))
    {
        // white labelling sub academy drop down select function
        $(function() {

            $(".dropdown-menu li a").click(function(){
                $("#dLabel:first-child").text($(this).text());
                $("#dLabel:first-child").val($(this).text());

                cmsLoadingStatus = true;
                loadOverlay();
            });

            // set id var from url with fallback of 0
            var id      = (urlSubAcademy) ? urlSubAcademy : 0;
            // get the item with match data-id
            var ele     = $('#sub-academy-drop a[data-id="' + id + '"]');
            // get the text value from the element
            var text    = ele.text();
            // populate the button in the dropdown with the value
            $('#academy-name').html(text);
        });

        $('#primary_color').css("cssText", "border-color: "+ $('input[name="primary_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#secondary_color').css("cssText", "border-color: "+ $('input[name="secondary_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#heading_color').css("cssText", "border-color: "+ $('input[name="heading_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#header_background_color').css("cssText", "border-color: "+ $('input[name="header_background_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#header_nav_color').css("cssText", "border-color: "+ $('input[name="header_nav_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#body_font_color').css("cssText", "border-color: "+ $('input[name="body_font_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#body_font_color').css("cssText", "border-color: "+ $('input[name="body_font_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#banner_caption_heading_color').css("cssText", "border-color: "+ $('input[name="banner_caption_heading_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#banner_caption_color').css("cssText", "border-color: "+ $('input[name="banner_caption_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#section_title_background_color').css("cssText", "border-color: "+ $('input[name="section_title_background_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#section_title_color').css("cssText", "border-color: "+ $('input[name="section_title_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#login_background').css("cssText", "border-color: "+ $('input[name="login_background"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#login_link_colour').css("cssText", "border-color: "+ $('input[name="login_link_colour"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#login_link_hover').css("cssText", "border-color: "+ $('input[name="login_link_hover"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#btn_background_colour').css("cssText", "border-color: "+ $('input[name="btn_background_colour"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#btn_colour').css("cssText", "border-color: "+ $('input[name="btn_colour"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#btn_background_hover').css("cssText", "border-color: "+ $('input[name="btn_background_hover"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#btn_hover_colour').css("cssText", "border-color: "+ $('input[name="btn_hover_colour"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#loggedin_header_backround').css("cssText", "border-color: "+ $('input[name="loggedin_header_backround"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#loggedin_header_link_colour').css("cssText", "border-color: "+ $('input[name="loggedin_header_link_colour"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#loggedin_header_link_hover').css("cssText", "border-color: "+ $('input[name="loggedin_header_link_hover"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#loggedin_sidebar_bg').css("cssText", "border-color: "+ $('input[name="loggedin_sidebar_bg"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#loggedin_sidebar_colour').css("cssText", "border-color: "+ $('input[name="loggedin_sidebar_colour"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#loggedin_sidebar_svg').css("cssText", "border-color: "+ $('input[name="loggedin_sidebar_svg"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#loggedin_sidebar_hover').css("cssText", "border-color: "+ $('input[name="loggedin_sidebar_hover"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#loggedin_sidebar_hover_svg').css("cssText", "border-color: "+ $('input[name="loggedin_sidebar_hover_svg"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");
        $('#banner_caption_bg_color').css("cssText", "border-color: "+ $('input[name="banner_caption_bg_color"]').val() +" !important; border-right-width: 35px !important; border-right-style: solid !important;");

        if ($("#custom_cofig_tab").length)
        {
            $('#custom_cofig_tab').click(function(evt){
                $("#whitelabel_config_save_btn").show();
            });
        }
        if ($("#advanced_cofig_tab").length)
        {
            $('#advanced_cofig_tab').click(function(evt){
                $("#whitelabel_config_save_btn").show();
            });
        }
        if ($("#terminology_cofig_tab").length)
        {
            $('#terminology_cofig_tab').click(function(evt){
                $("#whitelabel_config_save_btn").hide();
            });
        }

        if (("#theme_config_tabs").length)
        {
            $('#theme_config_tabs').click(function(evt){
                $("#whitelabel_config_save_btn").show();
            });
        }

        if ($("#banner_config_tabs").length)
        {
            $('#banner_config_tabs').click(function(evt){
                $("#whitelabel_config_save_btn").show();
            });
        }

        if ($("#courses_config_tabs").length)
        {
            $('#courses_config_tabs').click(function(evt){
                $("#whitelabel_config_save_btn").hide();
            });
        }

        if ($("#slider_config_tabs").length)
        {
            $('#slider_config_tabs').click(function(evt){
                $("#whitelabel_config_save_btn").hide();
            });
        }


        if ((urlSubAcademy == null) || (urlSubAcademy == ''))
        {
            $("#terminology_cofig_tbl").dataTable({
                "ajax": "../cms/ajax_cms.php?action=read_custom_generic_text&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
                "deferRender" : true,
                "order": [],
                "pageLength": 10,
                "initComplete" : function(){
                    $('[data-toggle="tooltip"]').tooltip({
                        trigger: 'hover'
                    });
                }
            });
        }

        $("#lang_options_terms").change(function () {
            var language    = this.value;
            var terms_id    = $("input[name=terms_id]").val();
            readTermsTextByTermsId(terms_id, language, 'terms_text');
        });

        $("#lang_options_privacy_terms").change(function () {
            var language         = this.value;
            var privacy_terms_id = $("input[name=privacy_terms_id]").val();
            readTermsTextByTermsId(privacy_terms_id, language, 'privacy_terms_text');
        });

        $("#lang_options_course_terms").change(function () {
            var language         = this.value;
            var course_terms_id  = $("input[name=course_terms_id]").val();
            readTermsTextByTermsId(course_terms_id, language, 'course_terms_text');
        });
    }

    if ((urlViewVal == 'cms') && (urlPageVal == 'user_details'))
    {
        if ($("#registration_tbl").is(":visible"))
        {
            var academyId    = $("input[name=academy]").val();
            cmsLoadingStatus = true;
            loadOverlay();

            if (academyId == 103)
            {
                $("#registration_tbl").dataTable({
                    "ajax": "../content/ajax_itf_common.php?action=read_user_registered&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
                    "deferRender" : true,
                    "pageLength": 10,
                    responsive: true,              
                    dom: 'lBfrtip',
                     buttons: [
                            { extend: 'excel', className: 'btn-dataTable' },
                            { 
                            extend: 'pdfHtml5', 
                            className: 'btn-dataTable', 
                            orientation: 'landscape',   
                            pageSize: 'LEGAL',
                            exportOptions: 
                            {
                                columns: [ 0, 1, 2, 3, 4, 5, 6 ]
                            }
                        }                 
                    ],
                    "columnDefs": [
                        { "width": "9%", "targets": 7 },
                        { "width": "10%", "targets": 6 }
                    ],
                    "initComplete" : function(){
                        cmsLoadingStatus = false;
                        $('[data-toggle="tooltip"]').tooltip({
                            trigger: 'hover'
                        });
                    }
                });
            }
            else if (academyId == 107)
            {
                $("#registration_tbl").dataTable({
                    "ajax": "../content/ajax_itf_common.php?action=read_user_registered&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
                    "deferRender" : true,
                    "pageLength": 10,
                    responsive: true,              
                    dom: 'lBfrtip',
                    buttons: [
                        { extend: 'excel', className: 'btn-dataTable' },
                        { 
                        extend: 'pdfHtml5', 
                        className: 'btn-dataTable', 
                        orientation: 'landscape',   
                        pageSize: 'LEGAL',
                        exportOptions: 
                        {
                            columns: [ 0, 1, 2, 3, 4, 5, 6 ]
                        }
                    }               
                    ],
                    "columnDefs": [
                        { "width": "10%", "targets": 6 },
                        { "width": "9%", "targets": 5 }
                    ],
                    "initComplete" : function(){
                        cmsLoadingStatus = false;
                        $('[data-toggle="tooltip"]').tooltip({
                            trigger: 'hover'
                        });
                    }
                });
            }
            else if (academyId == 109)
            {
                $("#registration_tbl").dataTable({
                    "ajax": "../content/ajax_itf_common.php?action=read_user_registered&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
                    "deferRender" : true,
                    "pageLength": 10,
                    responsive: true,              
                    dom: 'lBfrtip',
                    buttons: [
                        { extend: 'excel', className: 'btn-dataTable' },
                        { 
                        extend: 'pdfHtml5', 
                        className: 'btn-dataTable', 
                        orientation: 'landscape',   
                        pageSize: 'LEGAL',
                        exportOptions: 
                        {
                            columns: [ 0, 1, 2, 3, 4, 5, 6, 7 ]
                        }
                    }               
                    ],
                    "columnDefs": [
                        { "width": "10%", "targets": 6 },
                        { "width": "9%", "targets": 5 }
                    ],
                    "initComplete" : function(){
                        cmsLoadingStatus = false;
                        $('[data-toggle="tooltip"]').tooltip({
                            trigger: 'hover'
                        });
                    }
                });
            }
            else
            {
                $("#registration_tbl").dataTable({
                    "ajax": "../content/ajax_itf_common.php?action=read_user_registered&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
                    "deferRender" : true,
                    "pageLength": 10,
                    responsive: true,              
                    dom: 'lBfrtip',
                    buttons: [
                            { extend: 'excel', className: 'btn-dataTable' },
                            { 
                                extend: 'pdfHtml5', 
                                className: 'btn-dataTable', 
                                orientation: 'landscape',   
                                pageSize: 'LEGAL',
                                exportOptions: 
                                {
                                    columns: [ 0, 1, 2, 3, 4, 5, 6 ]
                                }
                            }                 
                    ],
                    "columnDefs": [
                        { "width": "9%", "targets": 6 },
                        { "width": "10%", "targets": 5 }
                    ],
                    "initComplete" : function(){
                        cmsLoadingStatus = false;
                        $('[data-toggle="tooltip"]').tooltip({
                            trigger: 'hover'
                        });
                    }
                });
            }            
        }

        $('#exTab1').on("click", "li", function (event) {    

            var activeTab = $(this).find('a').attr('href');            

            if (activeTab == '#subscriptions')
            {
                cmsLoadingStatus = true;
                loadOverlay();

                $("#icoach_subscription_tbl").dataTable({
                    destroy: true,
                    "ajax": "../content/ajax_itf_common.php?action=read_itf_subscriptions&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
                    "deferRender" : true,
                    "pageLength": 10,
                     dom: 'lBfrtip',
                     buttons: [
                        { extend: 'excel', className: 'btn-dataTable' },
                        { extend: 'pdf', className: 'btn-dataTable' },
                        {
                            extend: 'print',
                            text: 'Print all',
                            className: 'btn-dataTable',
                            exportOptions: {
                                modifier: {
                                    selected: null
                                }
                            }
                        },
                        {
                            extend: 'print',
                            text: 'Print selected',
                            className: 'btn-dataTable'
                        }
                    ],
                    select: true,
                    "initComplete" : function(){
                        cmsLoadingStatus = false;
                    }
                });
            }
            else if (activeTab =='#staff_registrations')
            {
                cmsLoadingStatus = true;
                loadOverlay();

                $("#registration_itf_tbl").dataTable({
                    destroy: true,
                    "ajax": "../content/ajax_itf_common.php?action=read_user_itf&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
                    "deferRender" : true,
                    "pageLength": 10,
                    dom: 'lBfrtip',
                    buttons: [
                        { extend: 'excel', className: 'btn-dataTable' },
                        { extend: 'pdf', className: 'btn-dataTable' },
                        {
                            extend: 'print',
                            text: 'Print all',
                            className: 'btn-dataTable',
                            exportOptions: {
                                modifier: {
                                    selected: null
                                }
                            }
                        },
                        {
                            extend: 'print',
                            text: 'Print selected',
                            className: 'btn-dataTable'
                        }
                    ],
                    select: true,
                    "initComplete" : function(){
                        cmsLoadingStatus = false;
                    }
                });
            }
            else if (activeTab == '#voucher_batches')
            {
                cmsLoadingStatus = true;
                loadOverlay();

                $("#icoach_voucher_tbl").dataTable({
                    destroy: true,
                    "ajax": "../content/ajax_itf_common.php?action=read_itf_voucher_users&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
                    "deferRender" : true,
                    "pageLength": 10,
                    dom: 'lBfrtip',
                    buttons: [
                        { extend: 'excel', className: 'btn-dataTable' },
                        { 
                            extend: 'pdfHtml5', 
                            className: 'btn-dataTable', 
                            orientation: 'landscape',   
                            pageSize: 'LEGAL'
                        
                        },  
                        {
                            extend: 'print',
                            text: 'Print all',
                            exportOptions: {
                                modifier: {
                                    selected: null
                                }
                            },
                            className: 'btn-dataTable'
                        },
                        {
                            extend: 'print',
                            text: 'Print selected',
                            className: 'btn-dataTable'
                        }
                    ],
                    select: true,
                    "initComplete" : function(){
                        cmsLoadingStatus = false;
                    } 
                });
            }
            else if (activeTab == '#course_admin')
            {
                cmsLoadingStatus = true;
                loadOverlay();

                $("#course_admin_tbl").dataTable({
                    destroy: true,
                    "ajax": "../content/ajax_itf_common.php?action=read_course_admin&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
                    "deferRender" : true,
                    "pageLength": 10,
                    dom: 'lBfrtip',
                    buttons: [
                        { extend: 'excel', className: 'btn-dataTable' },
                        { 
                            extend: 'pdfHtml5', 
                            className: 'btn-dataTable', 
                            orientation: 'landscape',   
                            pageSize: 'LEGAL',
                            exportOptions: 
                            {
                                columns: [ 0, 1, 2, 3, 4, 5]
                            }
                        }    
                    ],
                    "initComplete" : function(){
                        cmsLoadingStatus = false;
                        $('[data-toggle="tooltip"]').tooltip({
                            trigger: 'hover'
                        });
                    }
                });
            }
        });
    }

    if ((urlViewVal == 'cms') && (urlPageVal == 'course_admin'))
    {
        if ($("#course_admin_tbl").is(":visible"))
        {
                cmsLoadingStatus = true;
                loadOverlay();

                $("#course_admin_tbl").dataTable({
                    destroy: true,
                    "ajax": "../content/ajax_itf_common.php?action=read_course_admin&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
                    "deferRender" : true,
                    "pageLength": 10,
                    dom: 'lBfrtip',
                    buttons: [
                        { extend: 'excel', className: 'btn-dataTable' },
                        { 
                            extend: 'pdfHtml5', 
                            className: 'btn-dataTable', 
                            orientation: 'landscape',   
                            pageSize: 'LEGAL',
                            exportOptions: 
                            {
                                columns: [ 0, 1, 2, 3, 4, 5]
                            }
                        }    
                    ],
                    "initComplete" : function(){
                        cmsLoadingStatus = false;
                        $('[data-toggle="tooltip"]').tooltip({
                            trigger: 'hover'
                        });
                    }
                });
        }
    }    

    if ((urlViewVal == 'cms') && (urlPageVal == 'quarterly_reports'))
    {
        if ($("#qr-active-users-table").is(":visible"))
        {
            loadQuarterlyReportsActiveUsersTable();              
        }     
    }

    $(document).on('click', '#search-quarterly-reports-btn', function(e){  
        
        if ($("#qr-active-users-table").is(":visible"))
        {
            loadQuarterlyReportsActiveUsersTable();            
        }
        else if ($("#qr-assessment-courses-table").is(":visible"))
        {
            loadQuarterlyReportsAssessmentsTable();            
        }
        else if ($("#qr-ecommerce-transactions-table").is(":visible"))
        {
            loadQuarterlyReportsEcommTable();            
        }
        else if ($("#qr-ebooks-transactions-table").is(":visible"))
        {
            loadQuarterlyReportsEbooksEcommTable();            
        }
    });    

    $('#duplicate_activity').click(function(evt){

        var token          = $('input[name="token"]').val();
        var interventionId = $('input[name="intervention_id"]').val();
        var geId           = $("#games_edition_list").val();
        var lpId           = $("#lp_list").val();

        $('#copy-activity-alert').removeClass("alert-danger");

        if (interventionId == '')
        {
            showErrorMessage("Error : Activity not found!");
        }
        else if ((geId == "0") || (geId == ""))
        {
            showErrorMessage("Error : Games edition not found!");            
        }
        else if ((lpId == "0") || (lpId == ""))
        {
            showErrorMessage("Error : Learning pathway not found!");
        }
        else
        {
            var url     = window.location.href;
            var urlPart = url.split("games_edition_id=");
            var newUrl  = urlPart[0]+"games_edition_id="+geId+"&pathway_id="+lpId+ 
            "&tab=3&intervention_id="+interventionId+"&sub_tab=1&action=duplicate_intervention&token="+token;
            window.location.replace(newUrl);
        }
        
    });

    if ($("#games_edition_list").length)
    {
        $("#games_edition_list").change(function(){

            var functionType = "read_pathways_by_games_editions";
            var ge_id        = $("#games_edition_list").val();
            var token        = $('input[name="token"]').val();

            if ((ge_id == "0") || (ge_id == ""))
            {
                $("#lp_list").prop("disabled", true);
            }
            else
            {
                cmsLoadingStatus = true;
                loadOverlay();

                $.ajax({
                    url : '../course_admin/ajax_publish_intervention_as_course.php',
                    dataType: "json",
                    data: {
                        function: functionType,
                        ptToken : token,
                        ge_id   : ge_id
                    },
                    success: function (data)
                    {
                        $("#lp_list").html(data.output);
                        $("#lp_list").prop("disabled", false);
                        cmsLoadingStatus = false;
                    }
                });
            }
        });
    }

    if ($("#lead_functional_area_id").length)
    {
        $("#lead_functional_area_id").change(function(){
            var functionType    = "read_streams";
            var functional_id   = $("#lead_functional_area_id").val();
            var token           = $('input[name="token"]').val();
            var intervention_id = $('input[name="intervention_id"]').val();
            cmsLoadingStatus = true;
            loadOverlay();

            $.ajax({
                url : '../course_admin/ajax_publish_intervention_as_course.php',
                dataType: "json",
                data: {
                    function: functionType,
                    functional_id: functional_id,
                    ptToken : token,
                    intervention_id : intervention_id
                },
                success: function (data)
                {
                    $("#div_fa_streams").show();
                    $("#fa_streams_div").empty();
                    $("#fa_streams_div").html(data.output);
                    cmsLoadingStatus = false;
                }
            });
        });
    }

    if ($("#fa_streams-1").length)
    {
        $('input:radio[name=fa_streams]').change(function() {
            if (this.value == '1')
            {
                $("#functional_area_streams").show();
            }
            else
            {
                $("#functional_area_streams").hide();
            }
        });
    }

    if ($("#worldpay_online_courses_btn").length)
    {
        $('#worldpay_online_courses_btn').on('click', function() 
        {  
            var action = "worldpay_online_courses";
            var token  = $('input[name="token"]').val();
            var course = $('input[name="course"]').val();

            cmsLoadingStatus = true;
            loadOverlay();

            $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {             
                    token     : token,
                    action    : action,
                    course_id : course
                },          
                success: function(data)
                {
                    try
                    {
                        if (data.output != "")
                        {
                            location.href = data.output;                        
                        }
                    }
                    catch (e)
                    {
                        cmsLoadingStatus = false;
                        alert("Something went wrong.");
                    }
                }
            });        
        });
    }

    if ($(".staff_types").length)
    {
        $("#staff_types").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5',
            dropdownParent: $('#create-staff-model .modal-body')
        });
    }

    if ($(".prereq_courses").length)
    {
        $(".prereq_courses").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });
    }

    if ($("#academy-list-feedback_forms").length)
    {
        $("#academy-list-feedback_forms").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });
    }

    if ($(".feedback_academy_list").length)
    {        
        $(".feedback_academy_list").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });
    }

    if ($("#courseform").length)
    {
        $(".course_audience_types").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });
        
        $(".programme_deliveres").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });

        $(".prereq_courses").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });

        $(".deliverer_type").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });

        $(".course_outcome").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });

        $(".currency_code").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });

        $("#course_type").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });

        $("#country").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });

        $("#region").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });

        $("#territory").select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5'
        });

        $(".select2-search__field").addClass("light-color");
    }

    if ($("#create-staff-model").length)
    {
        $("#create-staff-model").on("hidden.bs.modal", function() {
            var tags = readCreateStaff();
            $("#modal-body-main").html(tags);

            $("#search-users-txt").keyup(function (e) {

                if (e.which == 13) return false;


                if ($(this).val().trim() != "")
                {
                    $("#search-users-admin .search-btn").prop("disabled", false);
                }
                else
                {
                    $("#search-users-admin .search-btn").prop("disabled", true);
                }
            });

            if ($("#staff_types").length)
            {
                $("#staff_types").select2({
                    placeholder: 'Please select...'
                });
            }

            $("#search-users-admin .search-btn").on("click", function () {
                var searchString = $("#search-users-txt").val().trim();
                var action       = "search_users";
                var ptToken      = $("input[name=token]").val();

                $(".search-box.lds-ring").css('display', 'inline-block');

                $.ajax({
                    url: '../api/v1/people_admin.php',
                    dataType: "json",
                    type: "POST",
                    data: {
                        action: action,
                        searchString: searchString,
                        ptToken : ptToken
                    },
                    success: function (data)
                    {
                        try
                        {
                            var arrLength = data.output.length;
                            $("#waos_account").empty();
                            for( var i = 0; i < arrLength; i++)
                            {
                                var user_id   = data.output[i]['user_id'];
                                var name      = data.output[i]['name']+" - "+data.output[i]['email'];
                                var academy   = data.output[i]['academy'];
                                if (academy !== '' && academy !== null)
                                {
                                    $("#waos_account").append("<option value='"+user_id+"'>"+name+", Registered Academy - "+academy+"</option>");
                                }
                                else
                                {
                                    $("#waos_account").append("<option value='"+user_id+"'>"+name+"</option>");
                                }                       
                            }
                            if (arrLength > 0)
                            {
                                $('#waos_account').css('display', 'block');
                            }
                            else
                            {
                                $('#waos_account').css('display', 'none');
                            }                  
                        }
                        catch (e)
                        {
                            alert("Something went wrong.");
                        }
                        finally {
                            $(".search-box.lds-ring").hide();
                        }
                    }
                });
            });
        });
    }    

    if($('[data-toggle="tooltip"]').length) $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
    });

    if ($("#intervention_timeframe_div").length)
    {
        $("#intervention_timeframe_div").datepicker( {
            format: "MM yyyy",
            viewMode: "months", 
            minViewMode: "months"
        });

        $('#intervention_timeframe_div').datepicker().on('changeDate', function (ev) {
            var timeframe = $('#intervention_timeframe').val();
            $('#shared_actual_timeframe').val(timeframe); 
            console.log(timeframe);              
        });
    }

    if ($("#games_timeframe_date_div").length)
    {  
        $("#games_timeframe_date_div").datepicker( {
            format: "MM yyyy",
            viewMode: "months", 
            minViewMode: "months"
        });

        $('#games_timeframe_date_div').datepicker().on('changeDate', function (ev) {

            var geEndDate       = $('#games_timeframe_end_date').val();

            if (geEndDate === '' || geEndDate === null)
            {
                if ($('#games_edition_id').length)
                {
                    geEndDate = $('#games_edition_id').find(':selected').attr('data-date');
                }                
            }

            var geTimeframe     = $('#games_timeframe_date').val();
            var startDate       = new Date(geEndDate);
            var endDate         = new Date(geTimeframe);
            var diff            = dateDiff(startDate, endDate);
            var totalMonthsDiff = (diff.years * 12) + diff.months;

            if (startDate < endDate)
            {
                totalMonthsDiff = totalMonthsDiff + 1;
            }

            $('#games_timeframe_txt').val("G"+totalMonthsDiff); 

            if ($('#games_timeframe').length)
            {
                $('#games_timeframe').val(totalMonthsDiff);   
            }      

            var gamePhase       = getPhaseByGamesTimeframe(totalMonthsDiff);

            if (totalMonthsDiff < -84)
            {
                var phase = document.getElementById("phase");
                var gamePhaseValue = "G"+gamePhase;

                var exists = 0 != $('#phase option[value='+gamePhaseValue+']').length;
                if (!exists)
                {
                    var option = document.createElement("option");
                    option.text  = gamePhaseValue;
                    option.value = gamePhaseValue;
                    phase.add(option);
                } 
                $('#phase_hidden').val(gamePhaseValue);   
                $('#phase option[value="'+gamePhaseValue+'"]').prop("selected", true); 
            }
            else
            {
                $('#phase_hidden').val(gamePhase);   
                $('#phase option[value="'+gamePhase+'"]').prop("selected", true); 
            }
        });
    }       

    if ($("#interventionNameAssignProgramme").length)
    {
        var interventionName = $("#interventionNameAssignProgramme").val();
        var programmeName    = $("#programme_id option:selected").text();
        checkInterventionName(interventionName, programmeName);

        $("#programme_id").change(function(){
            programmeName  = $("#programme_id option:selected").text();
            checkInterventionName(interventionName, programmeName)
        });
    }    
    
    // publishAcademyResourceItems();    
    // updateAvailabilityAacademyResources();
    publishAcademyResourceSubheadings();  
    publishStaffRecords();
    publishAnnouncementRecords();
    archiveAnnouncementRecords();
    archiveIstudyAnnouncementRecords();
    publishProjects();
    publishWebsiteCMS();
    updateFeedbackLiveStatus();
    displayFeedbackForms();
    publishAFECSchool();
    publishStudentProfile();
    publishAFECAssessor();
    publishFacultyProfile();
    update2faUsers();
    publishSubAcademy();

    tbl_projects = $("#tbl_projects").DataTable({
        "ajax": "../api/v1/people_admin.php?action=read_projects&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
        "pageLength": 10,
        "rowReorder": true,
        "columnDefs": [
            { className: "reorder", "targets": [ 0 ] },            
            { targets: 1, visible: false },
            { 'targets': [0,1,2,3,4], 'orderable': false }
        ],
        "initComplete" : function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }       
    });

    tbl_projects.on( 'row-reorder', function ( e, diff, edit ) {
        var elementOrder = [];
        for (var i = 0, ien = diff.length; i<ien ; i++) 
        {
            var rowData = tbl_projects.row( diff[i].node ).data();
            var element = {"key" : rowData[1], "order" : diff[i].newData};
            elementOrder.push(element);
        }

        var token    = $('input[name=token]').val();
        var academy  = $("input[name=academy]").val();

        $.ajax({
            url: '../api/v1/people_admin.php',
            type: "post",
            dataType: "json",
            async: false,
            data: {
                action   : 'update_project_order',
                ptToken  : token,
                academy  : academy,
                elements : elementOrder
            },
            success: function(data)
            {                
                $(function () {
                  $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                  });
                });

            }
        });
    });

    tbl_afec_schools = $("#tbl_afec_schools").DataTable({
        "ajax": "../api/v1/people_admin.php?action=read_afec_centres&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
        "pageLength": 10,
        "rowReorder": true,
        "columnDefs": [
            { className: "reorder", "targets": [ 0 ] },            
            { targets: 1, visible: false },
            { "width": "20%", "targets": 5 },
            { "width": "10%", "targets": 6 },
            { 'targets': [0,1,2,3,4,5,6], 'orderable': false }
        ],
        "initComplete" : function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }       
    });

    tbl_afec_schools.on( 'row-reorder', function ( e, diff, edit ) {
        var elementOrder = [];
        for (var i = 0, ien = diff.length; i<ien ; i++) 
        {
            var rowData = tbl_afec_schools.row( diff[i].node ).data();
            var element = {"key" : rowData[1], "order" : diff[i].newData};
            elementOrder.push(element);
        }

        var token    = $('input[name=token]').val();
        var academy  = $("input[name=academy]").val();

        $.ajax({
            url: '../api/v1/people_admin.php',
            type: "post",
            dataType: "json",
            async: false,
            data: {
                action   : 'update_afec_school_order',
                ptToken  : token,
                academy  : academy,
                elements : elementOrder
            },
            success: function(data)
            {                
                $(function () {
                  $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                  });
                });

            }
        });
    });

    tbl_student_profiles = $("#tbl_student_profiles").DataTable({
        "ajax": "../api/v1/people_admin.php?action=read_student_profiles&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
        "pageLength": 10,
        "rowReorder": true,
        "scrollX": true,
        "columnDefs": [
            { className: "reorder", "targets": [ 0 ] },            
            { targets: 1, visible: false },
            { "width": "20%", "targets": 5 },
            { "width": "10%", "targets": 6 },
            { 'targets': [0,1,2,3,4,5,6,7,8,9], 'orderable': false }
        ],
        "initComplete" : function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }       
    });

    tbl_student_profiles.on( 'row-reorder', function ( e, diff, edit ) {
        var elementOrder = [];
        for (var i = 0, ien = diff.length; i<ien ; i++) 
        {
            var rowData = tbl_student_profiles.row( diff[i].node ).data();
            var element = {"key" : rowData[1], "order" : diff[i].newData};
            elementOrder.push(element);
        }

        var token    = $('input[name=token]').val();
        var academy  = $("input[name=academy]").val();

        $.ajax({
            url: '../api/v1/people_admin.php',
            type: "post",
            dataType: "json",
            async: false,
            data: {
                action   : 'update_student_profile_order',
                ptToken  : token,
                academy  : academy,
                elements : elementOrder
            },
            success: function(data)
            {                
                $(function () {
                  $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                  });
                });

            }
        });
    });

    tbl_afec_assessors = $("#tbl_afec_assessors").DataTable({
        "ajax": "../api/v1/people_admin.php?action=read_afec_assessors&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
        "pageLength": 10,
        "rowReorder": true,
        "columnDefs": [
            { className: "reorder", "targets": [ 0 ] },            
            { targets: 1, visible: false },
            { "width": "20%", "targets": 5 },
            { "width": "10%", "targets": 6 },
            { 'targets': [0,1,2,3,4,5,6], 'orderable': false }
        ],
        "initComplete" : function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }       
    });

    tbl_afec_assessors.on( 'row-reorder', function ( e, diff, edit ) {
        var elementOrder = [];
        for (var i = 0, ien = diff.length; i<ien ; i++) 
        {
            var rowData = tbl_afec_assessors.row( diff[i].node ).data();
            var element = {"key" : rowData[1], "order" : diff[i].newData};
            elementOrder.push(element);
        }

        var token    = $('input[name=token]').val();
        var academy  = $("input[name=academy]").val();

        $.ajax({
            url: '../api/v1/people_admin.php',
            type: "post",
            dataType: "json",
            async: false,
            data: {
                action   : 'update_afec_assessor_order',
                ptToken  : token,
                academy  : academy,
                elements : elementOrder
            },
            success: function(data)
            {                
                $(function () {
                  $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                  });
                });

            }
        });
    });

    tbl_faculty_profiles = $("#tbl_faculty_profiles").DataTable({
        "ajax": "../api/v1/people_admin.php?action=read_faculty_profiles&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
        "pageLength": 10,
        "rowReorder": true,
        "columnDefs": [
            { className: "reorder", "targets": [ 0 ] },            
            { targets: 1, visible: false },
            { "width": "20%", "targets": 5 },
            { "width": "10%", "targets": 6 },
            { 'targets': [0,1,2,3,4,5,6,7], 'orderable': false }
        ],
        "initComplete" : function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }       
    });

    tbl_faculty_profiles.on( 'row-reorder', function ( e, diff, edit ) {
        var elementOrder = [];
        for (var i = 0, ien = diff.length; i<ien ; i++) 
        {
            var rowData = tbl_faculty_profiles.row( diff[i].node ).data();
            var element = {"key" : rowData[1], "order" : diff[i].newData};
            elementOrder.push(element);
        }

        var token    = $('input[name=token]').val();
        var academy  = $("input[name=academy]").val();

        $.ajax({
            url: '../api/v1/people_admin.php',
            type: "post",
            dataType: "json",
            async: false,
            data: {
                action   : 'update_faculty_profile_order',
                ptToken  : token,
                academy  : academy,
                elements : elementOrder
            },
            success: function(data)
            {                
                $(function () {
                  $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                  });
                });

            }
        });
    });

    tbl_staff = $("#tbl_staff").DataTable({
        "ajax": "../api/v1/people_admin.php?action=read_staff&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val()+"&category="+$("input[name=staff_category]").val(),
        "pageLength": 10,
        "rowReorder": true,
        "columnDefs": [
            { className: "reorder", "targets": [ 0 ] },      
            { targets: 0, visible: false },      
            { targets: 1, visible: false },
            { 'targets': [0,1,2,3,4,5,6], 'orderable': false }
        ],
        "responsive": true,
        "initComplete" : function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }       
    }); 

    tbl_staff.on( 'row-reorder', function ( e, diff, edit ) {
        var elementOrder = [];
        for (var i = 0, ien = diff.length; i<ien ; i++) 
        {
            var rowData = tbl_staff.row( diff[i].node ).data();
            var element = {"key" : rowData[1], "order" : diff[i].newData};
            elementOrder.push(element);
        }

        var token    = $('input[name=token]').val();
        var academy  = $("input[name=academy]").val();
        var category = $("input[name=staff_category]").val();

        $.ajax({
            url: '../api/v1/people_admin.php',
            type: "post",
            dataType: "json",
            async: false,
            data: {
                action   : 'update_staff_order',
                ptToken  : token,
                academy  : academy,
                category : category,
                elements : elementOrder
            },
            success: function(data)
            {                
                $(function () {
                  $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                  });
                });

            }
        });
    });

    tbl_announcements = $("#tbl_announcements").DataTable({
        "ajax": "../api/v1/people_admin.php?action=read_announcements&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
        "pageLength": 10,
        "initComplete" : function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }       
    });

        // if (($("#tbl_sub_academies").length) && (urlPageVal == 'academy') && (tabId == 8))

    if (($("#tbl_resources").length) && (urlPageVal == 'academy') && (tabId == 4)) {
        tbl_resources = $("#tbl_resources").DataTable({
            "ajax": "../cms/ajax_cms.php?action=read_resources&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
            "pageLength": 50,
            "rowReorder": true,
            "columnDefs": [
                { className: "reorder", "targets": [ 0 ] },            
                { targets: 1, visible: false },
                { 'targets': [0,1,2,3,4,5,6,7,8], 'orderable': false }
            ],
            "initComplete" : function(){
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }      
        });
 
        tbl_resources.on( 'click', 'tr', function () {
            tbl_resources_data_row = tbl_resources.row( this ).data();
        });
     
        tbl_resources.on( 'row-reorder', function ( e, diff, edit ) {
            var elementOrder = [];
            for ( var i=0, ien=diff.length ; i<ien ; i++ ) 
            {
                var rowData = tbl_resources.row( diff[i].node ).data();
                var element = {"key" : rowData[1], "order" : diff[i].newData};
                elementOrder.push(element);
            }

            var token = $('input[name="token"]').val();
            $.ajax({
                url: '../cms/ajax_cms.php',
                type: "post",
                dataType: "json",
                async: false,
                data: {
                    ptToken  : $('input[name="token"]').val(),
                    action   : 'update_resource_order',
                    academy  : $("input[name=academy]").val(),
                    elements : elementOrder
                },
                success: function(data)
                {                
                    $(function () {
                      $('[data-toggle="tooltip"]').tooltip({
                        trigger: 'hover'
                      });
                    });

                }
            });
        });
    }

    if (($("#tbl_resources").length) && (urlPageVal == 'academy') && (tabId == 5)) {

        var tbl_subheadings = $("#tbl_subheadings").DataTable({
            "ajax": "../cms/ajax_cms.php?action=read_resource_subheadings&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
            "pageLength": 10,
            "rowReorder": true,
            "columnDefs": [
                { className: "reorder", "targets": [ 0 ] },            
                { targets: 1, visible: false },
                { 'targets': [0,1,2,3,4], 'orderable': false }
            ],
            "initComplete" : function(){
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }        
        });

        tbl_subheadings.on( 'click', 'tr', function () {
            tbl_subheadings_data_row = tbl_subheadings.row( this ).data();
        });

        tbl_subheadings.on( 'row-reorder', function ( e, diff, edit ) {
            var elementOrder = [];
            for ( var i=0, ien=diff.length ; i<ien ; i++ ) 
            {
                var rowData = tbl_subheadings.row( diff[i].node ).data();
                var element = {"key" : rowData[1], "order" : diff[i].newData};
                elementOrder.push(element);
            }

            var token = $('input[name="token"]').val();
            $.ajax({
                url: '../cms/ajax_cms.php',
                type: "post",
                dataType: "json",
                async: false,
                data: {
                    ptToken  : $('input[name="token"]').val(),
                    action   : 'update_subheadings_order',
                    academy  : $("input[name=academy]").val(),
                    elements : elementOrder
                },
                success: function(data)
                {                
                    $(function () {
                      $('[data-toggle="tooltip"]').tooltip({
                        trigger: 'hover'
                      });
                    });
                }
            });
        });
    }

    if (($("#ogkm-report-level").length) && (!$("#change_history_report").length))
    {
        $("#ogkm-report-level").val("lp-area");        
        OnReportLevel();
    }   

    $('body').on('click', '.user-manage-academy', function() {
        var academy_id   = $(this).attr('data-index');
        var item         = 'user-manage-academy_' + academy_id;
        var operation    = $("#"+item+"").prop("checked");
        var user_id      = $('input[name="user_id"]').val();
        var academy      = 'label-user-manage-academy_' + academy_id;
        var academy_name = $("#"+academy+"").text();
        manageAcademyAccess(academy_id, operation, user_id, academy_name);
    });

    $('body').on('click', '.user-manage-roles', function() {
        var role_id      = $(this).attr('data-index');
        var item         = 'user-manage-roles_' + role_id;
        var operation    = $("#"+item+"").prop("checked");
        var user_id      = $('input[name="user_id"]').val();
        manageUserRoles(role_id, operation, user_id);
    });

    /*Enable Server side processing/ Also add debounce to make search efficient */
    if ($("#tbl_user_management").is(":visible"))
    {
        cmsLoadingStatus = true;
        loadOverlay();

        setTimeout(function ()
        {
            var table = $("#tbl_user_management").DataTable({
                "processing": true,
                "serverSide": true,
                "ajax": {
                    "url": "../admin/ajax_get_user_management_users.php",
                    "type": "POST",
                    "data": function (d)
                    {
                        d.ptToken = $("input[name=token]").val();
                        d.academy_id = $('#academy-list-user-management').val();
                    }
                },
                "pageLength": 10,
                "deferRender": true,
                "responsive": true,
                "language": {
                    "infoFiltered": ""
                },
                "initComplete": function ()
                {
                    cmsLoadingStatus = false;
                    $('[data-toggle="tooltip"]').tooltip({
                        trigger: 'hover'
                    });
                }
            });

            // DEBOUNCE the default search input
            var searchDelayTimer;
            $('#tbl_user_management_filter input')
                .off() // remove the default keyup handler
                .on('keyup', function (e)
                {
                    var query = this.value;

                    clearTimeout(searchDelayTimer);

                    searchDelayTimer = setTimeout(function ()
                    {
                        table.search(query).draw();
                    }, 300); // <-- 300ms debounce
                });
        }, 1000);
    }


    if ($("#tbl_regulations").is(":visible"))
    {
        cmsLoadingStatus = true;
        loadOverlay();
        tbl_regulations = 
        $("#tbl_regulations").DataTable({
            "ajax": "../cms/ajax_cms.php?action=read_regulations_tbl&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
            "pageLength": 10, 
            "responsive": true,
            "rowReorder": true,
            "columnDefs": [
                { className: "reorder", "targets": [ 0 ] },            
                { targets: 0, visible: false },
                { targets: 1, visible: false },
                { "width": "110px", "targets": 5 , 'orderable': false },
                { 'targets': [2,3,4,5,6], 'orderable': false }   
            ],
            "initComplete" : function(){
                cmsLoadingStatus = false;
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }  
        });

        tbl_regulations.on( 'row-reorder', function ( e, diff, edit ) {

            cmsLoadingStatus = true;
            loadOverlay();

            var elementOrder = [];
            for (var i = 0, ien = diff.length; i<ien ; i++) 
            {
                var rowData = tbl_regulations.row( diff[i].node ).data();
                var element = {"key" : rowData[1], "order" : diff[i].newData};
                elementOrder.push(element);
            }

            var token    = $('input[name=token]').val();
            var academy  = $("input[name=academy]").val();

            $.ajax({
                url: '../cms/ajax_cms.php',
                type: "post",
                dataType: "json",
                async: false,
                data: {
                    action   : 'reorder_regulations',
                    ptToken  : token,
                    academy  : academy,
                    elements : elementOrder
                },
                success: function(data)
                {                
                    cmsLoadingStatus = false;
                }
            });
        });
    }

    if ($("#tbl_knowledge_tests").is(":visible"))
    {
        cmsLoadingStatus = true;
        loadOverlay();
        tbl_knowledge_tests = 
        $("#tbl_knowledge_tests").DataTable({
            "ajax": "../cms/ajax_cms.php?action=read_knowledge_tests_tbl&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
            "pageLength": 10, 
            "responsive": true,
            "columnDefs": [                        
                { targets: 0, visible: false },
                { targets: 1, visible: false }               
            ],
            "initComplete" : function(){
                cmsLoadingStatus = false;
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }  
        });       
    }

    if ($("#tbl_certifications").is(":visible"))
    {
        cmsLoadingStatus = true;
        loadOverlay();
        tbl_certifications = 
        $("#tbl_certifications").DataTable({
            "ajax": "../cms/ajax_cms.php?action=read_certifications_tbl&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
            "pageLength": 10, 
            "responsive": true,
            "rowReorder": true,
            "columnDefs": [
                { className: "reorder", "targets": [ 0 ] },            
                { targets: 0, visible: false },
                { targets: 1, visible: false },
                { "width": "110px", "targets": 6 , 'orderable': false },
                { 'targets': [2,3,4,5], 'orderable': false }   
            ],
            "initComplete" : function(){
                cmsLoadingStatus = false;
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }  
        });

        tbl_certifications.on( 'row-reorder', function ( e, diff, edit ) {

            cmsLoadingStatus = true;
            loadOverlay();

            var elementOrder = [];
            for (var i = 0, ien = diff.length; i<ien ; i++) 
            {
                var rowData = tbl_certifications.row( diff[i].node ).data();
                var element = {"key" : rowData[1], "order" : diff[i].newData};
                elementOrder.push(element);
            }

            var token    = $('input[name=token]').val();
            var academy  = $("input[name=academy]").val();

            $.ajax({
                url: '../cms/ajax_cms.php',
                type: "post",
                dataType: "json",
                async: false,
                data: {
                    action   : 'reorder_certifications',
                    ptToken  : token,
                    academy  : academy,
                    elements : elementOrder
                },
                success: function(data)
                {                
                    cmsLoadingStatus = false;
                }
            });
        });
    }

    if ($("#activity_types_tbl").is(":visible"))
    {
        $("#activity_types_tbl").dataTable();
    }

    if ($("#session_types_tbl").is(":visible"))
    {
        $("#session_types_tbl").dataTable();
    }

    if ($("#transport_types_tbl").is(":visible"))
    {
        $("#transport_types_tbl").dataTable();
    }

    if ($("#session_streams_tbl").is(":visible"))
    {
        $("#session_streams_tbl").dataTable();
    }

       
    if ($("#activity_venues_tbl").is(":visible"))
    {
        $("#activity_venues_tbl").dataTable();
    } 

    if ($("#que_and_ans_tbl").is(":visible"))
    {
        $("#que_and_ans_tbl").dataTable();
    } 

    if ($("#gep_workbook_tbl").is(":visible"))
    {
        $("#gep_workbook_tbl").dataTable();
    } 

    if ($('#organiser_role_tbl').is(":visible"))
    {
         $("#organiser_role_tbl").dataTable();
    }

    if ($('#gep_references_tbl').is(":visible"))
    {
         $("#gep_references_tbl").dataTable();
    }

    if ($('#exp_references_tbl').is(":visible"))
    {
         $("#exp_references_tbl").dataTable();
    }

    if ($('#ge_exp_references_tbl').is(":visible"))
    {
         $("#ge_exp_references_tbl").dataTable();
    }

     if ($('#organisation_tbl').is(":visible"))
    {
         $("#organisation_tbl").dataTable();
    }
    
    
    if ($('#gep_groups_tbl').is(":visible"))
    {
        
         $("#gep_groups_tbl").dataTable({
            "initComplete": function() {
                
                $('.gep_group_members_s2').select2({
                    theme: "classic"
                });
            },
            "fnDrawCallback": function( oSettings ) {
                $('.gep_group_members_s2').select2({
                    theme: "classic"
                });
            }
        });
    }

    if ($("#gep_workbook_section_tbl").is(":visible"))
    {
        $("#gep_workbook_section_tbl").dataTable({
            "initComplete": function() {
                
                $('.gep_content_editors').select2({
                    theme: "classic"
                });

            },
            "fnDrawCallback": function( oSettings ) {
                 $('.gep_content_editors').select2({
                    theme: "classic"
                });
            }
        });
    } 

    if ((urlViewVal == 'cms') && ((urlPageVal == 'people_admin') || (urlPageVal == 'programme')))
    {
        var summnerNoteFullOptions = {
            minHeight: 200,
            maxHeight: 300,
            dialogsInBody: true,
            codemirror: {
                theme: 'monokai'
            },
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
                ['insert', ['link', 'unlink']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['code', ['codeview']]
            ],
            callbacks: {
              onPaste: function (e) {
                var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                e.preventDefault();
                setTimeout( function(){
                  document.execCommand( 'insertText', false, bufferText );
                }, 10 );
              }
            }
        };
        $('.summernote').summernote(summnerNoteFullOptions);
    }

    if ((urlViewVal == 'cms') && (urlPageVal == 'academy_theme'))
    {
        console.log("I am here")
        var summnerNoteFullOptions = {
            minHeight: 200,
            maxHeight: 300,
            dialogsInBody: true,
            codemirror: {
                theme: 'monokai'
            },
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
                ['insert'],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['code', ['codeview']]
            ],
            callbacks: {
              onPaste: function (e) {
                var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                e.preventDefault();
                setTimeout( function(){
                  document.execCommand( 'insertText', false, bufferText );
                }, 10 );
              }
            }
        };
        $('.summernote').summernote(summnerNoteFullOptions);
    }

    var summnerNoteOptions = {
            minHeight: 300,
            dialogsInBody: true,
            //,airMode: true
            codemirror: { // codemirror options
                theme: 'monokai'
            },
            toolbar: [
                // [groupName, [list of button]]
                ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
                ['insert', ['link', 'unlink']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                
            ],
            callbacks: {
              onPaste: function (e) {
                var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                e.preventDefault();
                setTimeout( function(){
                  document.execCommand( 'insertText', false, bufferText );
                }, 10 );
              }
            }
    };

    if ($('#what_to_observe_where').length)
    {        
        $('#overview').summernote(summnerNoteOptions);
        $('#main_challenges').summernote(summnerNoteOptions);
        $('#key_observation_experience_question').summernote(summnerNoteOptions);
        $('#what_to_observe_where').summernote(summnerNoteOptions); 
        $('#key_services_provided').summernote(summnerNoteOptions);
    }

    $('#gep_reference_document_type').on('change', function(){

        if ($(this).val() == 'link')
        {
            $("#link").attr('type', 'text'); 
            $("#link").attr('class', 'form-control'); 
        }
        else 
        {
             $("#link").attr('type', 'file'); 
             $("#link").attr('class', 'upload-file-btn'); 
        }
       
    });

    if ($('#info').length)
    {        
        $('#info').summernote(summnerNoteOptions);
        
    }

    

    $("#tbl_assign_role").dataTable({
        "ajax": "../content/ajax_user_management.php?action=read_assign_role_tbl&ptToken="+$("input[name=token]").val()+"&user_id="+$('input[name="user_id"]').val(),
        "deferRender" : true,
        "pageLength": 10,
        "initComplete": function(settings, json) {
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
          }
    });

    $("#tbl_online_course_management").dataTable({
        "ajax": "../content/ajax_user_management.php?action=read_user_access_online_course_tbl&ptToken="+$("input[name=token]").val()+"&games_edition="+$("#ge_List_online_courses").val()+"&user_id="+$('input[name="user_id"]').val(),
        "deferRender" : true,
        "pageLength": 10,
        "initComplete": function(settings, json) {
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
          }
    });

    if($("#lp_target").length)
    {
        loadLearningPathwaysForUserRoles();
    }

    if($("#geList").length)
    {
        $("#geList").change(function() {
            loadLearningPathwaysForUserRoles();        
        });  
    }

    if($("#is_live").length)
    {        
        $("#is_live").click(function(){
            manageLearningPathway("is_live", $("#is_live").prop("checked"));
        });
    }

    if($("#is_ocog_learning_solution_intervention_on").length)
    {        
        $("#is_ocog_learning_solution_intervention_on").click(function(){
            manageLearningPathway("is_ocog_learning_solution_intervention_on", $("#is_ocog_learning_solution_intervention_on").prop("checked"));
        });
    }

    if($("#is_ioc_tailored_intervention_on").length)
    {        
        $("#is_ioc_tailored_intervention_on").click(function(){
            manageLearningPathway("is_ioc_tailored_intervention_on", $("#is_ioc_tailored_intervention_on").prop("checked"));
        });
    }

    if($("#is_ioc_master_intervention_on").length)
    {        
        $("#is_ioc_master_intervention_on").click(function(){
            manageLearningPathway("is_ioc_master_intervention_on", $("#is_ioc_master_intervention_on").prop("checked"));
        });
    }

    if($("#games_editions").length)
    {
        $("#duplicate_fas").prop("disabled", true);
        $("#games_editions").change(function() {
            var games_edition = $("#games_editions").val();
            if(games_edition != 0) {
                $("#duplicate_fas").prop("disabled", false);
            } else {
                $("#duplicate_fas").prop("disabled", true);
            }
        });
    }

    var map;
    var geocoder;
    var marker;
    var allMarkers = [];
    var is_china = $('input[name="is_china"]').val();
    var markers;
    var map; 
    var tiles; 
    var line;

    function geocodeLatLng(geocoder, map, infowindow,lat,long) 
    {        
        var latlng = {lat: parseFloat(lat), lng: parseFloat(long)};        
        geocoder.geocode({'location': latlng}, function(results, status) 
        {
          if (status === 'OK') 
          {
            if (results[0]) 
            {
              map.setZoom(16);
              marker = new google.maps.Marker({
                position: latlng,
                map: map
              });

                for(var i = 0; i < allMarkers.length; i++)
                {                   
                    allMarkers[i].setMap(null);
                }

              allMarkers.push(marker);

              infowindow.setContent(results[0].formatted_address);
              infowindow.open(map, marker);

              $('input[name="location_address"]').val(results[0].formatted_address);
            } 
            else 
            {
              window.alert('No results found');
            }
          } 
          else 
          {
            window.alert('Geocoder failed due to: ' + status);
          }
        });
    }

   

    function InitializeMap(edit) {

        var latlng = new google.maps.LatLng(-37.816, 144.958);
        if (edit)
        {
            var myOptions =
            {
                zoom:16,
                center: latlng,
                mapTypeId: google.maps.MapTypeId.HYBRID,
                disableDefaultUI: true
            };
        }
        else
        {
            var myOptions =
            {
                zoom:12,
                center: latlng,
                mapTypeId: google.maps.MapTypeId.HYBRID,
                disableDefaultUI: true
            };
        }
        

        if($('#maps_edit').length)
        {
             map = new google.maps.Map(document.getElementById("maps_edit"), myOptions);
        }
        else
        {
             map = new google.maps.Map(document.getElementById("maps"), myOptions);
        }               

        // marker refers to a global variable
        marker = new google.maps.Marker({
            position: latlng,
            map: map
        });

        allMarkers.push(marker);

        google.maps.event.addListener(map, "click", function (event) {
            // get lat/lon of click
            // if (marker != null) {
            //      google.maps.clear();
            // }
            var geocoder = new google.maps.Geocoder;
            var infowindow = new google.maps.InfoWindow;
            
            var clickLat = event.latLng.lat();
            var clickLon = event.latLng.lng();
            $('input[name="lat"]').val("");
            $('input[name="long"]').val("");
          
            $('input[name="lat"]').val(clickLat.toFixed(5));
            $('input[name="long"]').val(clickLon.toFixed(5));

            //  marker = new google.maps.Marker({
            //     position: new google.maps.LatLng(clickLat, clickLon),
            //     map: map
            // });
            geocodeLatLng(geocoder, map, infowindow,clickLat,clickLon);
        });
    }

    function FindLocation(edit) {
        geocoder = new google.maps.Geocoder();
        InitializeMap(edit);

        if ($('input[name="location_address"]').length)
        {
            var address = $('input[name="location_address"]').val();
        }
        
        geocoder.geocode({'address': address}, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                map.setCenter(results[0].geometry.location);
                var latitude = results[0].geometry.location.lat();
                var longitude = results[0].geometry.location.lng();

                $('input[name="lat"]').val(latitude.toFixed(5));
                $('input[name="long"]').val(longitude.toFixed(5));
                var marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location
                });
                for(var i = 0; i < allMarkers.length; i++)
                {                   
                    allMarkers[i].setMap(null);
                }
                allMarkers.push(marker);
            }
            else 
            {
                alert("Geocode was not successful for the following reason: " + status);
            }
        });

    }



    function InitilizeMapbox()
    {
        L.mapbox.accessToken = 'pk.eyJ1Ijoid2Fvcy1kZXZlbG9wbWVudCIsImEiOiJjazQzOXpybmcwNXJ6M2psbmoycmxvNGt2In0.cs0B3XScUPbNs8zryWLxag';
        map = L.mapbox.map('maps')
            .setView([-37.816, 145.50], 10)
            .addLayer(L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v11'));

         
         // setup a marker group       
        var marker =  L.marker([-37.816, 144.958]);

        var markers = L.layerGroup([marker]).addTo(map);


        map.scrollWheelZoom.disable();

        map.on('click', function(e) 
        {    
            map.eachLayer(function (layer) {
                 map.removeLayer(layer);
            });
            map.addLayer(L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v11'));
            $('input[name="lat"]').val( e.latlng.lat.toFixed(5));
            $('input[name="long"]').val(e.latlng.lng.toFixed(5));  
           // markers.clearLayers();
        

            var marker =  L.marker([e.latlng.lat.toFixed(5), e.latlng.lng.toFixed(5)]);
            var markers = L.layerGroup([marker]).addTo(map);
        });

           
    }

    function FindMapboxLocation()
    {
        var lat = $('input[name="lat"]').val();
        var long = $('input[name="long"]').val();
        L.mapbox.accessToken = 'pk.eyJ1Ijoid2Fvcy1kZXZlbG9wbWVudCIsImEiOiJjazQzOXpybmcwNXJ6M2psbmoycmxvNGt2In0.cs0B3XScUPbNs8zryWLxag';
        map = L.mapbox.map('maps_edit')
            .setView([lat, long], 10)
            .addLayer(L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v11'));
          
        // setup a marker group       
        var marker =  L.marker([lat, long]);

        var markers = L.layerGroup([marker]).addTo(map);        

        map.scrollWheelZoom.disable();

        map.on('click', function(e) 
        {    
            map.eachLayer(function (layer) {
                 map.removeLayer(layer);
            });
            map.addLayer(L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v11'));
            $('input[name="lat"]').val( e.latlng.lat.toFixed(5));
            $('input[name="long"]').val(e.latlng.lng.toFixed(5));  
           // markers.clearLayers();
        

            var marker =  L.marker([e.latlng.lat.toFixed(5), e.latlng.lng.toFixed(5)]);
            var markers = L.layerGroup([marker]).addTo(map);
        });



    }

    if ($('input[name="location_address"]').length)
    {
        if (is_china === '0')
        {
            InitializeMap(false);
        }
        else
        {
            if (!$('#maps_edit').length)
            {
                InitilizeMapbox();
            }
        }
       
    }

    $('input[name="location_address"]').on('change', function()
    {
         if (is_china === '0')
        {
            FindLocation(false);
        }
    });

    if ($('#maps_edit').length)
    {
        if (is_china === '0')
        {
            FindLocation(true);
        }
        else
        {
            FindMapboxLocation(true);
        }

    }

    if($("#organisation").length)
    {
        loadFunctionalAreas();   
        $("#organisation").change(function() {
            loadFunctionalAreas();        
        });      
    }

    

    $(".dash-loader").css('display', 'none');

    if($('.ogkm_search_filters').length)
    {
        // adds select2 plugin to learning pathway filters
        $('.ogkm_search_filters').select2({
            minimumResultsForSearch: Infinity
        });
    }    

   
    if($('.gep-experience-interventions').length)
    {
        $(".gep-experience-interventions").select2();
    } 

    if(($("#intervention_type").length) && ($("#intervention_type_filter").length))
    {
        $("#intervention_type").change(function() {
            searchGridViewElements();
        });

        $("#intervention_type_filter").change(function() {
            searchGridViewElements();
        });
    }

    if($("#specific_intervention").length)
    {
        $("#specific_intervention" ).change(function() {
            var control = $(this);  
            var iconValue = control.find(':selected').data('icon');
            var image = document.getElementById('image_logo_div');

            if(iconValue != '' && typeof iconValue !== 'undefined')
            {
                image.style.display = "block";                
                var preview = image.getElementsByTagName('img')[0];
                preview.src = "https://d22u7g0jugykn9.cloudfront.net/images/intervention_type_icons/"+iconValue;
            }
            else
            {
                image.style.display = "none";
            }                        
        });
    }

    if($("#issue_certificate_datepicker").length)
    {
        $("#issue_certificate_datepicker").datepicker({
            orientation: "bottom"
        });
    }

    $("#ogkm-report-type-dropdown").on("change", function(){

        $("#ogkm-dash-report-body").hide();

    });

    if ($("#entity_id").length)
    {
        $('.related_voucher_academies').select2();
       
        storeRolesEntitiesOptions();
        toggleEntityValueRolesSection();
    }

    if ( $('.related-activities-programmes').length)
    {
        $('.related-activities-programmes').select2();
    }

    if ( $('.related-activities-delegations').length)
    {
        $('.related-activities-delegations').select2();
    }

    if ($('#workbook-functional-areas-select2-box').length)
    {
        $('.workbook_functional_areas').select2();
    }

    if ( $('.related-activities-central').length)
    {
        $('.related-activities-central').select2();
    }

    $("#entity_id").on('change', function(){

        toggleEntityValueRolesSection();
    });

    if ($("#admin_user_report").length)
    {
        $('#start_date_itf_reports_div').datepicker().on('changeDate', function (ev) {
            var startDate = $("#start_date_itf_reports").val();
            var parts     = startDate.split('-');
            startDate     = parts[2]+"-"+parts[1]+"-"+parts[0];
            startDate     = new Date(startDate);

            var endDate   = $("#end_date_itf_reports").val();
            parts         = endDate.split('-');
            endDate       = parts[2]+"-"+parts[1]+"-"+parts[0];
            endDate       = new Date(endDate);

            var dateDiff  = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
            if (dateDiff > 183)
            {
                var setEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 6, startDate.getDate());
                $("#end_date_itf_reports").val(setEndDate);
                $("#end_date_itf_reports_div").datepicker("setDate", setEndDate);
            }
        });

        $('#end_date_itf_reports_div').datepicker().on('changeDate', function (ev) {
            var startDate = $("#start_date_itf_reports").val();
            var parts     = startDate.split('-');
            startDate     = parts[2]+"-"+parts[1]+"-"+parts[0];
            startDate     = new Date(startDate);

            var endDate   = $("#end_date_itf_reports").val();
            parts         = endDate.split('-');
            endDate       = parts[2]+"-"+parts[1]+"-"+parts[0];
            endDate       = new Date(endDate);

            var dateDiff  = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
            if (dateDiff > 183)
            {
                var setEndDate = new Date(endDate.getFullYear(), endDate.getMonth() - 6, endDate.getDate());
                $("#start_date_itf_reports").val(setEndDate);
                $("#start_date_itf_reports_div").datepicker("setDate", setEndDate);
            }
        });
    }

    if ($("#full_change_history_section").length)
    {
        var d = new Date();
        var currMonth = d.getMonth();
        var currYear = d.getFullYear();
        var currDate = d.getDate();
        var startDate = new Date(currYear, currMonth-1, currDate);

        if($("#academy").val() == 8)
        {
            $("#change_history-start-date").datepicker("setDate", startDate);
        }
        else
        {
            $(".datepicker").datepicker({dateFormat: "dd-mm-yy"});
            $("#start-date").datepicker("setDate", startDate);
        }
    }

    if ($('#change_history-start-date').length)
    {
        $('#change_history-start-date').datepicker().on('changeDate', function (ev) {
            var startDate = $("#start-date").val();
            var parts     = startDate.split('-');
            startDate     = parts[2]+"-"+parts[1]+"-"+parts[0];
            startDate     = new Date(startDate);

            var endDate   = $("#end-date").val();
            parts         = endDate.split('-');
            endDate       = parts[2]+"-"+parts[1]+"-"+parts[0];
            endDate       = new Date(endDate);

            var dateDiff  = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
            if (dateDiff > 31)
            {
                var setEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, startDate.getDate());
                $("#change_history-datepicker").datepicker("setDate", setEndDate);
            }
        });
    }

    if ($('#change_history-datepicker').length)
    {
        $('#change_history-datepicker').datepicker().on('changeDate', function (ev) {
            var startDate = $("#start-date").val();
            var parts     = startDate.split('-');
            startDate     = parts[2]+"-"+parts[1]+"-"+parts[0];
            startDate     = new Date(startDate);

            var endDate   = $("#end-date").val();
            var parts     = endDate.split('-');
            endDate       = parts[2]+"-"+parts[1]+"-"+parts[0];
            endDate       = new Date(endDate);

            var dateDiff  = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
            if (dateDiff > 31)
            {
                var setStartDate = new Date(endDate.getFullYear(), endDate.getMonth() - 1, endDate.getDate());
                $("#change_history-start-date").datepicker("setDate", setStartDate);
            }
        });
    }    

    $("#change_history_submit_btn").on("click", function(){
        var startDate    = $("#start-date").val();
        var endDate      = $("#end-date").val();
        var gamesEdition = $("#ge-list-dropdown").val();
        var pathwayId    = $("#lp-list-dropdown").val();
        var functionType = "load_lp_change_history";

        if (pathwayId == '' || pathwayId ==null)
        {
            pathwayId = 'all';
        }
        var btn          = $(this);
        var token        = $("input[name=token]").val();
        var user_timezone_offset_minutes = get_user_timezone_offset_minutes();

        btn.html("Loading...");
        $(".change-history-loader").show();
        $("#full_change_history_section").hide();

        $.ajax({
            url: '../content/ajax_load_change_history.php',
            dataType: "json",
            data: {
                async       : true,
                function    : functionType,
                start_date  : startDate,
                end_date    : endDate,
                gamesEdition: gamesEdition,
                pathwayId   : pathwayId,
                ptToken     : token,
                user_timezone_offset_minutes : user_timezone_offset_minutes
            },
            success: function (data)
            {
                try
                {
                    if (data.output != "")
                    {
                        $("#full_change_history_section").html(data.output);
                    }
                    else
                    {
                        alert("Something went wrong");
                    }
                }
                catch (e)
                {
                    alert("Something went wrong. : " + e);
                }
                finally
                {
                    setTimeout(function(){
                        $("#full_change_history_section").fadeIn();
                        btn.html("Submit");
                        $(".change-history-loader").hide();
                    }, 500);
                }
            },
            error: function ()
            {
                alert("Something went wrong.");
            }
        });
    });

    $("#change_history_lp_submit_btn").on("click", function(){
        var startDate    = $("#start-date").val();
        var endDate      = $("#end-date").val();
        var gamesEdition = $("#games_edition_id").val();
        var pathwayId    = $("#pathway_id").val();   
        var functionType = "load_lp_change_history";
        var btn          = $(this);
        var token        = $("input[name=token]").val();
        var user_timezone_offset_minutes = get_user_timezone_offset_minutes();

        btn.html("Loading...");
        $(".change-history-loader").show();
        $("#full_change_history_section").hide();

        $.ajax({
            url: '../content/ajax_load_change_history.php',
            dataType: "json",
            data: {
                async       : true,
                function    : functionType,
                start_date  : startDate,
                end_date    : endDate,
                gamesEdition: gamesEdition,
                pathwayId   : pathwayId,
                ptToken     : token,
                user_timezone_offset_minutes : user_timezone_offset_minutes
            },
            success: function (data)
            {
                try
                {
                    if (data.output != "")
                    {
                        $("#full_change_history_section").html(data.output);
                    }
                    else
                    {
                        alert("Something went wrong");
                    }
                }
                catch (e)
                {
                    alert("Something went wrong. : " + e);
                }
                finally
                {
                    setTimeout(function(){
                        $("#full_change_history_section").fadeIn();
                        btn.html("Submit");
                        $(".change-history-loader").hide();
                    }, 500);
                }
            },
            error: function ()
            {
                alert("Something went wrong.");
            }
        });
    });

    $("#add-intervention-links-btn").on('click', function(){
        var remove_icon     = $(this).prev();
        var url_field       = $(this).prev().prev();
        var name_field      = url_field.prev();

        url_field.next().after(remove_icon.clone());
        url_field.next().after(url_field.clone().val(""));
        url_field.next().after(name_field.clone().val(""));
    });

    $("#add-streams-links-btn").on('click', function(){
        var remove_icon     = $(this).prev();
        var stream_field    = $(this).prev().prev();

        stream_field.next().after(remove_icon.clone());
        stream_field.next().after(stream_field.clone().val(""));
    });

    //Create a span for password validation error messages.
    if (($("#registrationForm").length) || ($("#newpwform").length))
    {
        var pw_validation_span = '<span class="pw-validate-error-area">'
                                + '<ul>'
                                + '<li class="pw-err-msg" id="ten_char_limit">'+tenCharLimit+'</li>'
                                + '<li class="pw-err-msg" id="one_special_char_limit">'+oneSpecialCharLimit+'</li>'
                                + '<li class="pw-err-msg" id="one_num_limit">'+oneNumLimit+'</li>'
                                + '</ul>'
                                + '</span>';
    }

    //Registration Form & Password Reset Form
    if ($("#registrationForm").length)
    {
        $("#registrationForm input[type=password]").after(pw_validation_span);
    }
    else if ($("#newpwform").length)
    {
        $("#newpwform input[type=password]").after(pw_validation_span);
    }

    $("#registrationForm input[type=password], #newpwform input[type=password]").on('keyup', function(){
        validatePassword($(this));
    });

    //If pathway type is strategic, hide LeadFA dropdown
    function hideLeadFADropdown(type)
    {       
        if (($("#pathway_category").val() == "strategic") || ($("#pathway_category").val() == "cross_functional"))
        {            
            if (type == "slide")
            {
                $("#lead_functional_area_id").parent().parent().slideUp();
            }
            else
            {
                $("#lead_functional_area_id").parent().parent().hide();
            }

            if ($("#pathway_category").val() == "cross_functional" || $("#pathway_category").val() == "strategic")
            {
                $("#programme_category").parent().parent().hide();
            }
            else
            {
                $("#programme_category").parent().parent().show();
            }
        }
        else
        {
            if (type == "slide")
            {
                $("#lead_functional_area_id").parent().parent().slideDown();
            }
            else
            {
                $("#lead_functional_area_id").parent().parent().show();
            }

            if ($("#pathway_category").val() != "cross_functional")
            {
                $("#programme_category").parent().parent().show();
            }            
        }
    }

    //Check for LeadFA on change of pathway type dropdown.
    $("#pathway_category").on("change", function(){
        hideLeadFADropdown("slide");
    });

    //Validate registration form & password reset form
    function validatePassword(thisObj)
    {
        var errorSpan = thisObj.next();
        var formatSpecialChar = /[!@$%^&*()_{}]+/;
        var formatNum = /[0-9]+/;
        var errCount = 0;

        if (thisObj.val().length >= 10)
        {
            errorSpan.find('#ten_char_limit').hide();
        }
        else
        {
            errorSpan.find('#ten_char_limit').show();
            errCount++;
        }

        if (formatSpecialChar.test(thisObj.val()))
        {
            errorSpan.find('#one_special_char_limit').hide();
        }
        else
        {
            errorSpan.find('#one_special_char_limit').show();
            errCount++;
        }

        if (formatNum.test(thisObj.val()))
        {
            errorSpan.find('#one_num_limit').hide();
        }
        else
        {
            errorSpan.find('#one_num_limit').show();
            errCount++;
        }

        if (errCount > 0)
        {
            if ($("#register").length)
            {
                $("#register").prop('disabled', true);
            }
            else if ($(".submit_button").length)
            {
                $(".submit_button").hide();
            }
        }
        else
        {
            if ($("#register").length)
            {
                $("#register").prop('disabled', false);
            }
            else if ($(".submit_button").length)
            {
                $(".submit_button").show();
            }
        }
    }

    if ($('#emails-message').length) {

        setRestrictionMessages();
    }

    selectPathwayCategory();

    $('#pathway-category-select').on("change", function(){
        selectPathwayCategory();
    });

    if ($('.cms-wrapper').length) {
        $("textarea").each(function () {

            setTextareaHeight($(this));

        });
    }

    //Toggle show/hide 'is required' field for the feedback_form_field_type select element
    $("select[name='feedback_form_field_type']").on('change', function(){

        var val = $(this).val();
        var headingList = ['1','2','3','4','5','6','7','8','9','10','11','32','33', '46']; //Heading Types

        if (jQuery.inArray(val, headingList) !== -1) //Exists
        {
            $(".field-label").each(function(){
                if ($(this).text() == "Is Required")
                {
                    $(this).parent().hide();
                }
            });
        }
        else
        {
            $(".field-label").each(function(){
                if ($(this).text() == "Is Required")
                {
                    $(this).parent().show();
                }
            });
        }
    });

    //Trigger change event when doc loads for feedback form
    $("select[name='feedback_form_field_type']").trigger('change');

    //Delete button confirmation
    $('.delete-btn').click(function(evt){
        evt.stopImmediatePropagation();
        return confirm('Are you sure you want to delete this?');
    });

    //Duplicate learning pathway button confirmation
    $('.duplicate-lp-btn').click(function(evt){
        evt.stopImmediatePropagation();
        return confirm('Are you sure you want to duplicate this learning pathway?');
    });

    //Show/Hide Games Edition Dropdown
    $(".games-default-dropdown").on("click", function () {

        if (!($(".games-editions-dropdown").is(":visible")))
        {
            $(this).addClass('active');
            $(".games-editions-dropdown").fadeIn(200);
            var currentDataIndex = $(".games-logo").attr("data-index");
        }
    });
    $('.games-editions-dropdown').on('click', function(e) {
      $('.games-default-dropdown').removeClass('active');
      e.stopPropagation();
    });
    $('.key-wrap').on('click', function() {

      if($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });

    // hide show icon key
    $('.icon-key-container').on('click', function() {
        if($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });
    //Hide Games Edition Dropdown
    $(document).mouseup(function (e)
    {
        var geDropdown = $(".games-editions-dropdown");
        var keySection = $(".key-wrap");
        var keyIconSection = $(".icon-key-container");

        if (!geDropdown.is(e.target) && geDropdown.has(e.target).length === 0)
        {
            geDropdown.fadeOut(100);
            geDropdown.parents('.games-default-dropdown').removeClass('active');
        }

        if (!keySection.is(e.target) && keySection.has(e.target).length === 0)
        {
            keySection.removeClass('active');
        }

        if (!keyIconSection.is(e.target) && keyIconSection.has(e.target).length === 0)
        {
            keyIconSection.removeClass('active');
        }
    });

    //Logic to handle Games edition selection
    $(".ge-option").on("click", function () {
        readPathwayCategories($(this));
    });

    function readPathwayCategories(thisObj)
    {
        $(".games-logo").attr("src", thisObj.find("img").attr("src"));
        $(".games-logo").attr("data-index", thisObj.attr("data-index"));
        $(".games-editions-dropdown").hide();
        $(".pre-reading-box").hide();

        functionType = "load_pathway_categories";
        gamesEditionId = thisObj.attr("data-index");
        var token = $('input[name="token"]').val();

        $(".games-editions-dropdown").hide();
        $(".pre-reading-box").hide();

        $.ajax({
            url: '../content/ajax_load_interventions.php',
            dataType: "json",
            data: {
                function: functionType,
                gamesEditionId: gamesEditionId,
                ptToken: token
            },
            success: function (data)
            {
                try
                {
                    if (data.output != "")
                    {
                        $(".lp-category-select").html(data.output);
                        $(".lp-category-select").parent().show();
                        onGamesEditionSelected(thisObj);
                    }
                    else
                    {
                        if (gamesEditionId == 2)
                        {
                            $("#lp-description").empty();
                            $("#lp-description").html("<p>Learning Pathways aim to formalise and organise in an ideal sequence all the learning activities required for an OCOG to successfully plan and deliver the Games.</p>"+
                            "<p>Learning Pathways promote synergies across different stakeholders and enable OCOGs to become learning organisations supported by a clear roadmap of learning activities throughout their lifecycle. The mapping of learning activities facilitates the use of identified learning tools and reference documents that are relevant to each activity and audience.</p>");
                        }

                        $(".lp-category-select").parent().hide();
                        $(".lp-select-header").parent().hide();
                        $("#interventions-list").hide();
                        $("#interventions-grid-list-section").hide();
                        $(".grid-view-btn-wrapper").hide();
                        $('.key-wrap, .icon-key-container').hide();

                        $("#interventions-message").show();
                        $("#interventions-message").html("<p>No pathways found.</p>");
                    }
                }
                catch (e)
                {
                    alert("Something went wrong. : " + e);
                }
            },
            error: function ()
            {
                alert("Something went wrong.");
            }
        });
    }

    //Search users in the Assign Role CMS
    $("#search-users").keyup(function () {
        if ($(this).val().trim() != "")
        {
            $("#search-users-section .search-btn").prop("disabled", false);
        }
        else
        {
            $("#search-users-section .search-btn").prop("disabled", true);
        }
    });

    $("#search-users-txt").keyup(function (e) {

        if (e.which == 13) return false;


        if ($(this).val().trim() != "")
        {
            $("#search-users-admin .search-btn").prop("disabled", false);
        }
        else
        {
            $("#search-users-admin .search-btn").prop("disabled", true);
        }
    });

    function selectPathwayCategory()
    {
        var gamesLogoIndex = $(".games-logo").attr("data-index");
        $(".ge-option").each(function(){
            if ($(this).attr("data-index") == gamesLogoIndex)
            {
                onGamesEditionSelected($(this));
            }
        });
    }

    function onGamesEditionSelected(thisObj)
    {
        $(".games-logo").attr("src", thisObj.find("img").attr("src"));
        $(".games-logo").attr("data-index", thisObj.attr("data-index"));
        $(".games-editions-dropdown").hide();
        $(".pre-reading-box").hide();
        
        functionType = "load_pathways";
        gamesEditionId = thisObj.attr("data-index");
        var pathwayCategory  = $("#pathway-category-select option:selected").val();
        var token = $('input[name="token"]').val();
        var pathwayId = $('input[name="pathway_id"]').val();

        $("#lp-description").empty();

        if (pathwayCategory == 'strategic') // Executive
        {
            $("#lp-description").html("The Executive Learning Pathway (ELP) comprises a series of bespoke, structured and codesigned learning activities based on the needs of executives and delivery partners, addressing critical areas of focus for the OCOG. The ELP is designed to equip senior OCOG leadership and delivery partners with appropriate planning guidance, governance comprehension and decision-making skills to adequately prepare the OCOG throughout each phase of the Games.");
        }
        else if (pathwayCategory == 'cross_functional') // Thematic
        {
            $("#lp-description").html("Thematic Learning Pathways are integrated learning roadmaps. They are designed to capture the learning activities of several OCOG FAs, or a specific learning programme where several OCOG FAs are contributing to the learning activities. They describe the various learning activities (e.g. workshops, meetings, observation opportunities) that the OCOG FAs should undertake during their lifespan.");
        }
        else if (pathwayCategory == 'functional') // Functional
        {
            $("#lp-description").html('Functional Learning Pathways outline the learning roadmap for each OCOG functional area (FA). A Functional Learning Pathway describes the various learning activities (e.g. workshops, meetings, observation opportunities) that an OCOG FA should undertake during its lifespan.');
        }
        else
        {
            $("#lp-description").html("<p>Learning Pathways aim to formalise and organise in an ideal sequence all the learning activities required for an OCOG to successfully plan and deliver the Games.</p>"+
                                        "<p>Learning Pathways promote synergies across different stakeholders and enable OCOGs to become learning organisations supported by a clear roadmap of learning activities throughout their lifecycle. The mapping of learning activities facilitates the use of identified learning tools and reference documents that are relevant to each activity and audience.</p>");
        }

        $.ajax({
            url: '../content/ajax_load_interventions.php',
            dataType: "json",
            data: {
                function: functionType,
                gamesEditionId: gamesEditionId,
                pathway_category: pathwayCategory,
                ptToken: token,
                pathway_id: pathwayId
            },
            success: function (data)
            {
                try
                {
                    if (data.output != "")
                    {
                        if (data.hasPathways)
                        {
                            $(".lp-select-header").html(data.output);
                            $(".lp-select-header").parent().show();
                            $('.key-wrap').show();
                            onPathwaySelected();

                        }
                        else
                        {
                            $(".lp-select-header").parent().hide();
                            $("#interventions-list").hide();
                            $("#interventions-grid-list-section").hide();
                            $(".grid-view-btn-wrapper").hide();
                            $('.key-wrap, .icon-key-container').hide();

                            $("#interventions-message").show();
                            $("#interventions-message").html(data.output);
                        }
                    }
                    else
                    {
                        alert("Something went wrong");
                    }
                }
                catch (e)
                {
                    alert("Something went wrong. : " + e);
                }
            },
            error: function ()
            {
                alert("Something went wrong.");
            }
        });
    }

    function onAssignClicked(e)
    {
        var currentObj = $(e.target);
        var roleId = "";
        var userId = "";
        var functionType = "addUserRole";
        var tickElem = currentObj.siblings('.green-tick-wrap');
        var assignLink = currentObj;
        var loader = currentObj.prev();
        var token = $("input[name=token]").val();

        loader.css('display', 'inline-block');

        roleId = $("#current-role-id").val();
        userId = currentObj.prev().prev().attr("data-index");

        if ((roleId != "") && (userId != ""))
        {
            $.ajax({
                url: '../admin/ajax_add_user_role.php',
                dataType: "json",
                type: "POST",
                data: {
                    function: functionType,
                    role_id: roleId,
                    user_id: userId,
                    ptToken: token
                },
                success: function (data)
                {
                    try
                    {
                        if (data.success != null)
                        {
                            setTimeout(function () {
                                loader.fadeOut(200);
                                assignLink.hide();
                                setTimeout(function () {
                                    tickElem.fadeIn(200);
                                });
                            }, 500);


                        }
                        else if (data.error != null)
                        {
                            loader.hide();
                            alert(data.error);
                        }
                    }
                    catch (e)
                    {
                        loader.hide();
                        alert("Something went wrong.");
                    }
                }
            });
        }
        else
        {
            loader.hide();
            alert("Something went wrong.");
        }
    }

    $("#search-users-section .search-btn").on("click", function () {
        var searchString = "";
        var functionType = "";
        var token = $("input[name=token]").val();

        searchString = $("#search-users").val().trim();
        functionType = "searchUsers";
        roleId = $("#current-role-id").val();

        $(".search-box.lds-ring").css('display', 'inline-block');

        $.ajax({
            url: '../admin/ajax_add_user_role.php',
            dataType: "json",
            type: "POST",
            data: {
                function: functionType,
                searchString: searchString,
                roleId: roleId,
                ptToken : token
            },
            success: function (data)
            {
                try
                {
                    if (data.success != null)
                    {
                        $(".all-users-section").html(data.success);
                        $(".user-role-assign-btn").on("click", function (e) {
                            onAssignClicked(e);
                        });
                    }
                    else if (data.error != null)
                    {
                        $(".all-users-section").html(data.error);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
                finally {
                    $(".search-box.lds-ring").hide();
                }
            }
        });
    });

    $("#search-users-admin .search-btn").on("click", function () {
        var searchString = $("#search-users-txt").val().trim();
        var action       = "search_users";
        var ptToken      = $("input[name=token]").val();
        var type         = "";
        $(".search-box.lds-ring").css('display', 'inline-block');
        $("#search-users-admin .search-btn").attr('disabled', true);

        if ($("#add-user-deliverer").length)
        {   
            $("#search-users-admin-loader .role-loaders").show();
            $("#waos_account").hide();
            $("#add-user-deliverer").hide();
            $(".role_territory_inp_wrapper").remove();
            $(".programmes_for_academy_wrapper").remove();
            type = "academy";
        }       

        $.ajax({
            url: '../api/v1/people_admin.php',
            dataType: "json",
            type: "POST",
            data: {
                action: action,
                searchString: searchString,
                type: type,
                ptToken : ptToken
            },
            success: function (data)
            {
                try
                {
                    var arrLength = data.output.length;
                    $("#waos_account").empty();
                    for( var i = 0; i < arrLength; i++)
                    {
                        var user_id   = data.output[i]['user_id'];
                        var name      = data.output[i]['name']+" - "+data.output[i]['email'];
                        var academy   = data.output[i]['academy'];
                        if (academy !== '' && academy !== null)
                        {
                            $("#waos_account").append("<option value='"+user_id+"'>"+name+", Registered Academy - "+academy+"</option>");
                        }
                        else
                        {
                            $("#waos_account").append("<option value='"+user_id+"'>"+name+"</option>");
                        }                       
                    }
                    if (arrLength > 0)
                    {
                        setTimeout(function(){
                            if ($("#add-user-deliverer").length)
                            {   
                                var academy_id = getParameterByName('academy');
                                var is_first_stone = getParameterByName('is_first_stone');
                                var territories = ['National', 'Regional', 'International'];
                                $("#waos_account").after("<div class='row mt-4 role_territory_inp_wrapper'><div class='col-md-12'><div>"+                                                                
                                                                "<select class='form-control' id='role_territory_inp'>");

                                                                        if ((academy_id == 107) || (is_first_stone == 1) || (academy_id == 14))
                                                                        {
                                                                            if (academy_id == 14)
                                                                            {
                                                                                var territories = {'International' : 'international', 'National' : 'national', 'Resort' : 'facility'};
                                                                                var entries = Object.entries(territories);

                                                                                for (var [key, value] of entries) {
                                                                                    $("#role_territory_inp").append("<option value="+value+">"+key+"</option>");
                                                                                }
                                                                            }
                                                                            else
                                                                            {
                                                                                var territories = ['International', 'National', 'Facility'];
                                                                                for (var i = 0; i < territories.length; i++) {
                                                                                    $("#role_territory_inp").append("<option value="+territories[i].toLowerCase()+">"+territories[i]+"</option>");
                                                                                }
                                                                            }                                                                            
                                                                        }
                                                                        else
                                                                        {
                                                                            for (var i = 0; i < territories.length; i++) {
                                                                                $("#role_territory_inp").append("<option value="+territories[i].toLowerCase()+">"+territories[i]+"</option>");
                                                                            }
                                                                        }
                                                                        
                                                                   
                                                                $("#role_territory_inp").after("</select>"+   
                                                        "</div></div></div>");  
                                $("#role_territory_inp").show();                       
                                $("#waos_account").show();
                                $("#add-user-deliverer").show();
                                $("#add-user-deliverer").attr('disabled', false);  
                                $(".role_territory_inp_wrapper").after("<div class='row mt-4 programmes_for_academy_wrapper'><div class='col-md-12'><div class='user_role_programmes_for_academy'>"+
                                    "</div></div></div>");  
                                
                                $(".user_role_programmes_for_academy").after("<div><span>Note: For eLearning courses, Territory isn't applicable</span></div>");

                                if ((academy_id == 107) || (is_first_stone == 1) || (academy_id == 14))
                                {
                                    loadProgrammesByAcademyDropdown();

                                    $("#role_territory_inp").on('change', function(){ 
                                        var facilityType = $("#role_territory_inp option:selected").val();
                                        if (facilityType == 'facility')
                                        {
                                            loadFacilitiesByTypeDropdown();
                                        }
                                        else
                                        {
                                            loadProgrammesByAcademyDropdown();
                                        }
                                    });
                                } 
                                else
                                {                         
                                    loadProgrammesByAcademyDropdown();  
                                }

                            }
                            else
                            {
                                $('#waos_account').css('display', 'block');
                            }
                        }, 500);
                        
                    }
                    else
                    {
                        setTimeout(function(){
                            $('#waos_account').css('display', 'none');
                            if ($("#add-user-deliverer").length)
                            {   
                                $(".add-user-to-role-msg-area .msg-content").html("No users matched the search!");
                                $(".add-user-to-role-msg-area .msg-content").addClass('alert-danger');
                                $(".add-user-to-role-msg-area .msg-wrapper").slideDown();
                                $("#search-users-txt").val("");
                                $("#search-users-admin .search-btn").attr('disabled', true);
                            }
                        }, 500);
                    }                  
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
                finally {
                    setTimeout(function(){
                        $(".search-box.lds-ring").hide();
                        $("#search-users-admin-loader .role-loaders").hide();
                    }, 500);

                    if ($("#add-user-deliverer").length)
                    {   
                        setTimeout(function(){
                            $(".add-user-to-role-msg-area .msg-wrapper").slideUp();                            
                            setTimeout(function(){
                                $(".add-user-to-role-msg-area .msg-content").removeClass('alert-danger');
                                $(".add-user-to-role-msg-area .msg-content").removeClass('alert-success'); 
                            }, 500);                   
                        }, 2500);
                    }
                }
            }
        });
    });

    if ($('.cms-rows.sortable').length) {

        $(".cms-rows.sortable").sortable({
            update: function (event, ui) {

                var token = $('input[name="token"]').val();
                var data = {
                    rows: []
                };

                var row;

                $(".cms-rows").children().each(function () {
                    row = {entity: $(this).attr("entity"), id: $(this).attr("id")};
                    data.rows.push(row);
                });

                $.ajax({
                    type: 'POST',
                    url: 'course_admin/ajax_sort_rows.php',
                    data: {json: JSON.stringify(data), ptToken : token},
                    dataType: 'json',
                    success: function (data){
                        if(data.message == 'Invalid Token'){
                            alert("Somthing went wrong!");
                        }
                    }
                });
            }
        });

        $(".cms-rows.sortable").disableSelection();

    }

    if ($('.flex-table.sortable').length) {

        $(".flex-table.sortable").sortable({
            update: function (event, ui) {

                var token = $('input[name="token"]').val();
                var data = {
                    rows: []
                };

                var row;

                $(".flex-table").children().each(function () {
                    row = {entity: $(this).attr("entity"), id: $(this).attr("id")};
                    data.rows.push(row);
                });

                $.ajax({
                    type: 'POST',
                    url: 'course_admin/ajax_sort_rows.php',
                    data: {json: JSON.stringify(data), ptToken : token},
                    dataType: 'json',
                    success: function (data){
                        if(data.message == 'Invalid Token'){
                            alert("Somthing went wrong!");
                        }
                    }
                });
            }
        });

        $(".flex-table.sortable").disableSelection();

    }

    updateArgumentLabel();

    $(".request-edit-form").find("select[name='class']").on("change", function () {
        updateArgumentLabel();
    });

    function updateArgumentLabel()
    {
        var editClass = $(".request-edit-form").find("select[name='class'] option:selected");

        if (editClass.val() != "")
        {
            $(".request-edit-form").find("label").each(function () {

                if (($(this).text().toLowerCase() == "argument1") || ($(this).text().toLowerCase() == "argument 1"))
                {
                    if (editClass.val() == "youtube")
                    {
                        $(this).text("Youtube ID");
                    }
                }
                else if ($(this).text().toLowerCase() == "youtube id")
                {
                    $(this).text("Argument 1");
                }
            });
        }
    }

    if ($("input[name='toggle_assign_prog']").length)
    {
        var radio = $("input[name=toggle_assign_prog]:checked");

        if (radio.val() == "create_new_prog")
        {
            $("select[name='programme_id']").hide();
            $("input[name='submit']").val("Create");
            $("select[name='programme_id']").parent().prev().hide();
            $("select[name='programme_id']").prop('selectedIndex', 0);
        }
        else if (radio.val() == "assign_prog")
        {
            $("input[name='submit']").val("Save");
            $("select[name='programme_id']").show();
            $("select[name='programme_id']").parent().prev().show();
        }
    }

    $("input[name='toggle_assign_prog']").on('click', function () {
        if ($(this).val() == "create_new_prog")
        {
            $("input[name='submit']").attr("disabled", false);
            $("select[name='programme_id']").hide();
            $("input[name='submit']").val("Create");
            $("select[name='programme_id']").parent().prev().hide();
            $("select[name='programme_id']").prop('selectedIndex', 0);
            $("#assignExisitingProgrammeRadioBtn").prop("checked", false);
            $("#assign-program-error").hide();
        }
        else if ($(this).val() == "assign_prog")
        {        
            $("input[name='submit']").val("Save");
            $("select[name='programme_id']").show();
            $("select[name='programme_id']").parent().prev().show();
            $("#createProgrammeRadioBtn").prop("checked", false);
            var interventionName = $("#interventionNameAssignProgramme").val();
            var programmeName    = $("#programme_id option:selected").text();
            checkInterventionName(interventionName, programmeName);
        }
    });

    $("#unassign-programme").on('click', function(){
        var intervention_id = $(this).attr('data-index');
        var functionType = "unassign_programme";
        var token = $('input[name="token"]').val();

        $(".unassign-prog .error").hide();

        $.ajax({
            url : '../course_admin/ajax_publish_intervention_as_course.php',
            dataType: "json",
            data: {
                function: functionType,
                intervention_id: intervention_id,
                ptToken : token
            },
            success: function (data)
            {
                if (data.errorMessage != null)
                {
                    $(".unassign-prog").html(data.errorMessage).show();
                }
                else if (data.output != null)
                {
                    alert("Programme successfully un-assigned");
                    var url = window.location.href;
                    var url_part = url.split("sub_tab=");
                    window.location.replace(url_part[0] + "sub_tab=5" ); //Redirect to Assign Programme
                }
            }
        });
    });

    $("#publish-intervention-course").on('click', function () {

        $("#intervention-publish-msg").hide(); //Hide in case user coming from the 'Approve' flow
        $("#publish-intervention-form .dash-loader").css('display', 'flex');
        var form = $("#publish-intervention-form").find("form");

        var postData = [];
        var functionType = "publish_intervention_course";
        var formAction = "";
        var academyId = "";
        var token = $('input[name="token"]').val();
        var gamesEditionId = $('input[name="games_edition_id"]').val();

        formAction = form.attr("action");
        var academyParts = formAction.split("&academy=");
        academyId = academyParts[1].split("&")[0];

        form.find("input, select").each(function () {
            postData.push({name: $(this).attr('name'), value: $(this).val()});
        });

        $.ajax({
            url: '../course_admin/ajax_publish_intervention_as_course.php',
            dataType: "json",
            data: {
                function: functionType,
                academy_id: academyId,
                postData: postData,
                ptToken : token,
                gamesEditionId : gamesEditionId
            },
            success: function (data)
            {
                try
                {
                    if (data.output != null)
                    {
                        // setTimeout(function () {
                        //     $("#publish-intervention-form .dash-loader").hide();
                        //     $("#publish-intervention-form").prev().text("View Session");
                        //     $("#intervention-publish-msg").before(data.output);

                        //     $(".intervention-tabs .tab").each(function(){
                        //         if ($(this).text() == "Unassign Programme")
                        //         {
                        //             $(this).hide();
                        //         }
                        //         else if ($(this).text() == "Publish as Session")
                        //         {
                        //             $(this).text("View Session");
                        //         }
                        //     });

                        //     setTimeout(function(){
                        //         $("#intervention-publish-msg").html("<p class='waos_green'>Session successfully activated.</p>").slideDown(500);
                        //     }, 200);

                        //     $("#publish-intervention-course").remove();
                        //     $(".intervention-lock-icon").removeClass('unlocked');

                        //     if ((data.tick_icon != null) && (data.intervention_id != null))
                        //     {
                        //         $("#" + data.intervention_id).find(".name").append(data.tick_icon);
                        //     }

                        // }, 500);

                        var url = window.location.href;
                        var url_part = url.split("sub_tab=");
                        window.location.replace(url_part[0] + "sub_tab=6" );

                    }
                    else if (data.error != null)
                    {

                        $("#publish-intervention-form .dash-loader").hide();
                        $("#intervention-publish-msg").html("<p class='error'>Course could not be activated.</p><p class='error'>" + data.error + "</p>");
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });

    $("#approve-intervention").on('click', function () {
        $("#publish-intervention-form .dash-loader").css('display', 'flex');
        var form = $("#publish-intervention-form").find("form");
        var token = $('input[name="token"]').val();
        var gamesEditionId = $('input[name="games_edition_id"]').val();
        var postData = [];
        var functionType = "approve_intervention";
        var formAction = "";
        var academyId = "";

        formAction = form.attr("action");
        var academyParts = formAction.split("&academy=");
        academyId = academyParts[1].split("&")[0];

        form.find("input, select").each(function () {
            postData.push({name: $(this).attr('name'), value: $(this).val()});
        });

        $.ajax({
            url: '../course_admin/ajax_publish_intervention_as_course.php',
            dataType: "json",
            data: {
                function: functionType,
                academy_id: academyId,
                postData: postData,
                ptToken: token,
                gamesEditionId: gamesEditionId
            },
            success: function (data)
            {
                try
                {
                    if (data.output != null)
                    {
                        setTimeout(function () {
                            $("#publish-intervention-form .dash-loader").hide();

                            if ($(".hidden-publish-btn").length) //Only there in DOM when user has both approve and publish access
                            {
                                $("#approve-msg").hide();
                                $(".hidden-publish-btn").fadeIn(300);
                                $("#approve-intervention").remove();
                            }
                            else
                            {
                                $("#approve-msg").html("You do not have access to publish this session.");
                                $("#approve-intervention").remove();
                            }

                            $("#intervention-publish-msg").html("<p class='waos_green'>Activity successfully approved and can now be activated.</p>");
                        }, 500);
                    }
                    else if (data.error != null)
                    {
                        $("#publish-intervention-form .dash-loader").hide();
                        $("#intervention-publish-msg").html("<p class='error'>Activity could not be activated.</p><p class='error'>" + data.error + "</p>");
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });

    $(".publish-all-courses-btn").on('click', function () {
        var functionType = "publish_all_courses";
        var pathwayId = "";
        var token = $('input[name="token"]').val();
        var gamesEditionId = $('input[name="games_edition_id"]').val();
        pathwayId = $(this).attr("data-index");

        $.ajax({
            url: '../course_admin/ajax_publish_intervention_as_course.php',
            dataType: "json",
            data: {
                function: functionType,
                pathway_id: pathwayId,
                ptToken: token,
                gamesEditionId: gamesEditionId
            },
            success: function (data)
            {
                try
                {
                    var published_ids = data.published_ids;
                    var unpublished_ids = data.unpublished_ids;
                    var summary_html = "";

                    //Published
                    if (published_ids.length > 0)
                    {
                        summary_html += "<h2>Published Courses (" + published_ids.length + ") </h2>";
                        for (var i = published_ids.length - 1; i >= 0; i--)
                        {
                            summary_html += "<p class='courses_published'><strong>Name : </strong>" + published_ids[i].name + "</p>";
                        }
                    }

                    //Unpublished
                    if (unpublished_ids.length > 0)
                    {
                        summary_html += "<h2>Courses not published (" + unpublished_ids.length + ") </h2>";
                        for (var i = unpublished_ids.length - 1; i >= 0; i--)
                        {
                            summary_html += "<p class='courses_not_published'><strong>Name : </strong>" + unpublished_ids[i].name + " </br/><strong> Error : </strong> " + unpublished_ids[i].error + "</p>";
                        }
                    }

                    //Populate div
                    $(".published-courses-summary").html(summary_html);

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });

    //Deactivate session
    $("#deactivate-session").on('click', function(){

        var confirmation = confirm("Are you sure you want to deactivate this session?");

        if (confirmation == true)
        {
            var intervention_id = $(this).attr('data-index');
            var functionType = "deactivate_session";
            var token = $('input[name="token"]').val();
            var gamesEditionId = $('input[name="games_edition_id"]').val();

            $.ajax({
                url : '../course_admin/ajax_publish_intervention_as_course.php',
                dataType: "json",
                data: {
                    function: functionType,
                    intervention_id: intervention_id,
                    ptToken : token,
                    gamesEditionId: gamesEditionId
                },
                success: function (data)
                {
                    if (data.errorMessage != null)
                    {
                        $(".deactivate-sess").html(data.errorMessage).show();
                    }
                    else if (data.output != null)
                    {
                        alert("Session successfully deactivated!");
                        var url = window.location.href;
                        var url_part = url.split("sub_tab=");
                        window.location.replace(url_part[0] + "sub_tab=6" ); //Redirect to Activate as Session
                    }
                }
            });
        }        
    });


    $("#feedback-form-section .acp_workshop_organiser").on("change", function () {
        var selectedOption = $("#feedback-form-section .acp_workshop_organiser option:selected").val();

        if (selectedOption == "other")
        {
            $("#feedback-form-section .acp_workshop_organiser_other_text").show();
        }
        else
        {
            $("#feedback-form-section .acp_workshop_organiser_other_text").hide();
            $("#feedback-form-section .acp_workshop_organiser_other_field").val("");
        }

    });

    $("#feedback-form-section .acp_workshop_duration").on("change", function () {
        var selectedOption = $("#feedback-form-section .acp_workshop_duration option:selected").val();

        if (selectedOption == "other")
        {
            $("#feedback-form-section .acp_workshop_duration_other_text").show();
        }
        else
        {
            $("#feedback-form-section .acp_workshop_duration_other_text").hide();
            $("#feedback-form-section .acp_workshop_duration_other_field").val("");
        }

    });

    $("#feedback-form .btn-submit-feedback").click(function (e) {

        e.preventDefault();

        var fieldValues = [];
        var fieldValue;
        var fieldType = "";
        var fieldName = "";
        var fieldsCompleted = true;
        var lang = "";
        var from_online_course = "";
        var formData = new FormData();        
        
        lang = getParameterByName('lang');
        from_online_course = getParameterByName('from_online_course');

        if ($("#feedback-form .btn-submit-feedback").html() == "Sending")
        {
            return false;
        }

        $("#feedback-form .btn-submit-feedback").html("Sending");

        $("#feedback-form input, #feedback-form textarea,  #feedback-form select, .rangeslider").each(function () {

        // console.log('name: ' + fieldName, $(this).prop("name"));

        var is_required = false;
        fieldType       = this.type;
        var fieldId     = "";

        if (($(this).hasClass("rangeslider")) && ($(window).width() < 768)) 
        {
            fieldValue = $(this).val();

            fieldName = $(this).prop("name");

            if ($(this).parents('.field-wrapper').find(".field-label").find(".field-required").text() == '*')
            {
                is_required = true;
            }

            if ((fieldValue == null || fieldValue < 1) && (is_required))
            {
                $(this).parents('.field-wrapper').css("color", "red");
                fieldsCompleted = false;
            } else {
                $(this).parents('.field-wrapper').css("color", "#54565a");               

            }
            fieldType = 'radio';
            fieldValues.push({name: fieldName, type: fieldType, value: fieldValue});
        }
        
        // only process each input once in the case of radio buttons
        if ((fieldName != $(this).prop("name")) && (this.type != "checkbox"))
        {
            fieldId    = $(this).prop("id");
            if ((this.type == "textarea") || (this.type == "text") || (this.type == "date"))
            {               
                if ($(this).parents('.field-wrapper').find(".field-label").find(".field-required").text() == '*')
                {
                    is_required = true;                    
                }
                fieldValue = $(this).val();
                if (fieldValue == '' && is_required)
                {      
                    $(this).parents('.field-wrapper').css("color", "red");
                    fieldsCompleted = false;
                }
                else
                {
                    $(this).parents('.field-wrapper').css("color", "black");
                    
                }

                if (this.type == "date")
                {                    
                    fieldName = $(this).prop("name");
                    fieldValue = formatDate($(this).val());
                    fieldValues.push({name: fieldName, type: fieldType, value: fieldValue});
                }
                else
                {                    
                    fieldName = $(this).prop("name");
                    fieldValue = $(this).val();
                    fieldValues.push({name: fieldName, type: fieldType, value: fieldValue});
                }
               
            }
            else if (this.type == "file")
            {
                fieldName = $(this).prop("name");
                fieldValue = $(this).val();;

                var file = document.querySelector('input[name="'+fieldName+'"]').files[0]; 
                formData.append(fieldName, file);

                fieldValue = fieldValue.replace(/.*[\/\\]/, '');
                fieldValues.push({name: fieldName, type: fieldType, value: fieldValue});
            }
            else if ((this.type == "radio") && ($(window).width() > 768)) 
            {
                fieldName = $(this).prop("name");
                fieldValue = $("input[name='" + fieldName + "']:checked").val();

                if ($(this).parents('.field-wrapper').find(".field-label").find(".field-required").text() == '*')
                {
                    is_required = true;
                }

                console.log(fieldName);
                console.log(fieldValue);

                if ((fieldValue == null || fieldValue == undefined) && (is_required))
                {
                    if (fieldName == "would_you_like_to_see_changes_flag")
                    {
                   
                        $(this).parents('.field-wrapper').css("color", "red");
                    }
                    else
                    {
                     
                        $(this).parents('.field-wrapper').css("color", "red");
                    }

                    fieldsCompleted = false;
                }
                else
                {
                    if (fieldName == "would_you_like_to_see_changes_flag")
                    {
                        $(this).parents('.field-wrapper').css("color", "black");
                    }
                    else
                    {
                        $(this).parents('.field-wrapper').css("color", "black");
                    }                    
                }
                fieldValues.push({name: fieldName, type: fieldType, value: fieldValue});
            }
            else if (this.type == "number")
            {
                fieldName = $(this).prop("name");
                fieldValue = $(this).val();

                if ($(this).parent().find(".field-label").find(".field-required").text() == '*')
                {
                    is_required = true;
                }

                if ((fieldValue == "") && (is_required))
                {                    
                    $(this).parent().css("color", "red");
                    fieldsCompleted = false;
                }
                else if ((fieldName == "sessions_selector") && (fieldValue == "") && (is_required))
                {                    
                    $(this).parent().css("color", "red");
                    fieldsCompleted = false;
                }
                else
                {
                    $(this).parents('.field-wrapper').css("color", "black");
                }
                fieldValues.push({name: fieldName, type: fieldType, value: fieldValue});

            }
            else if (this.type == "select-one")
            {
                fieldName = $(this).prop("name");
                fieldValue = $(this).val(); 

                if (this.type == "select-one")
                {
                    fieldType = "select";
                }

                if ($(this).parent().parent().find(".field-label").find(".field-required").text() == '*')
                {
                    is_required = true;
                }

                if ((fieldValue == null || fieldValue == "") && (is_required))
                {    
                    $(this).parent().parent().css("color", "red");
                    fieldsCompleted = false;                   
                }
                else
                {                   
                    $(this).parent().parent().css("color", "black");
                    if (fieldId == "level_of_english")
                    {
                        $('#level_of_english_field_label').removeAttr("style");
                        $("#level_of_english_field_label").css("color", "black");
                    }
                    
                }
                fieldValues.push({name: fieldName, type: fieldType, value: fieldValue});
            }
            else
            {
                fieldValue = this.value;                
            }

            if (fieldValue == null)
            {
                fieldValue = "";
            }

            if (this.type == "hidden") {
                fieldName = $(this).prop("name");
                fieldValue = $(this).val();
                fieldValues.push({name: fieldName, type: fieldType, value: fieldValue});
            }   
        }
        else
        {
            fieldName = $(this).prop("name");
            fieldType = this.type;


            if (this.type == "checkbox")
            {
                if ($(this).parents('.field-wrapper').find(".field-label").find(".field-required").text() == '*')
                {
                    is_required = true;
                }               

                if ((!$(this).is(":checked")) && (is_required))
                {                   
                    $(this).parent().parent().css("color", "red");                    
                }
                else
                {
                    $(this).parent().parent().css("color", "black");
                }

                var selectedValues = [];
                const checkboxes = document.querySelectorAll('input[name="'+fieldName+'"]:checked');
                checkboxes.forEach((checkbox) => {
                    selectedValues.push(checkbox.value);
                });

                if (!selectedValues.length && is_required) 
                {
                    fieldsCompleted = false;
                }

                if (fieldType != "button") {
                    var found = fieldValues.some(el => el.name === fieldName);
                    if (!found) {
                        fieldValues.push({name: fieldName, type: fieldType, value: selectedValues});
                    }
                }

                // if ($(this).is(":checked"))
                // {
                //     fieldValue = "Yes";
                //     if (fieldType != "button") {
                //         fieldValues.push({name: fieldName, type: fieldType, value: fieldValue});
                //     }
                // }
                // else
                // {
                //     fieldValue = "No";
                //     if (fieldType != "button") {
                //         fieldValues.push({name: fieldName, type: fieldType, value: fieldValue});
                //     }
                // }
            }
        }
    });

        if (('#level_of_english_field_label').length)
        {
            var value = $('#level_of_english').val();    
            if (value !== '') 
            {                
                $('#level_of_english_field_label').css('color', 'black');
            }
        }

        console.log(fieldsCompleted);

        if (!fieldsCompleted)
        {
            $("#feedback-form .btn-submit-feedback").html("Submit");
            $("#feedback-error").show();
            $("#feedback-error").html('All required fields must be completed.');
            return false;
        }
        var all_form_elements = submit_first_before_submissions();
        var ptToken = $('input[name="ptToken"]').val();

        formData.append('fields', JSON.stringify(fieldValues));
        formData.append('allValues', JSON.stringify(all_form_elements));
        formData.append('language', lang);
        formData.append('from_online_course', from_online_course);
        formData.append('ptToken', ptToken);

        $.ajax({
            url : '/course_admin/ajax_add_feedback.php',
            type : 'POST',
            data : formData,
            processData: false,
            contentType: false,
            success : function(result) {                
                if (result == "session_expired")
                {  
                    revalidate_session(formData);
                }
                else
                { 
                    if ($('.form-wrapper').length) {
                        $('.form-wrapper').html(result);
                    } else if ($('.content-wrapper .content').length) {
                        $('.content-wrapper .content').html(result);
                    }
                }
                
            },
            error : function(result, error) {
                console.log("there");
                if ($('.form-wrapper').length) {
                    $('.form-wrapper').html(result.responseText);
                } else if ($('.content-wrapper .content').length) {
                    $('.content-wrapper .content').html(result.responseText);
                }
            }
        });
    });
    
    function revalidate_session()
    {   
        var newModal = Object.create(renderModalPrototype);        
        newModal.title = '<i class="fa fa-exclamation-triangle"></i> Session Expired';
        newModal.body = '<p>Your Session has expired. Re-authenticate to submit this form.</p>';
        newModal.body += '  <div class="row pb-1">'+
                                '<div class="col-sm-12">'+
                                    '<span>Email</span>'+
                                '</div>'+
                            '</div>'+
                            '<div class="row pb-3">'+
                                '<div class="col-sm-12">'+
                                    '<input placeholder="Email" class="form-control" id="email" name="email" type="email"/>'+
                                '</div>'+
                            '</div>'+
                            
                            '<div class="row pb-1">'+
                                '<div class="col-sm-12">'+
                                    '<span>Password</span>'+
                                '</div>'+
                            '</div>'+
                            '<div class="row pb-4">'+
                                '<div class="col-sm-12">'+
                                    '<input placeholder="Password" class="form-control" id="password" name="password" type="password"/>'+
                                '</div>'+
                            '</div>'+

                            '<div class="row pb-3">'+
                                '<div class="col-sm-12">'+
                                    '<div class="submit_button">'+
                                    '<a class="btn btn-primary" href="javascript:void(0);" name="submitbutton" onClick="reloginUser();">Submit</a></div>'+
                                    '</div>'+
                            '</div>'+
                            
                            '<div class="row pb-1">'+
                                '<div class="col-sm-12">'+
                                    '<p id="relogin-modal-error" style="display:none;" class="alert alert-warning">Authentication failed. Please retry</p>'+
                                '</div>'+
                            '</div>'+

                            '<div class="row pb-1">'+
                                '<div class="col-sm-12">'+
                                    '<p id="relogin-modal-success" style="display:none;" class="alert alert-success">Successfully authenticated</p>'+
                                '</div>'+
                            '</div>';

        newModal.renderModal();
    }    

    function validatFormFieldsBeforeSessions()
    {
        var fieldValue = "";
        var fieldName = "";
        var fieldsCompleted = true;
        var id = "";

        console.log('is it coming ing');

        $("#feedback-form input, #feedback-form textarea, #feedback-form select").each(function () {

            if ($(this).is(':visible'))
            {
                // only process each input once in the case of radio buttons
                if (fieldName != $(this).prop("name"))
                {
                    fieldName = $(this).prop("name");
                    id = $(this).prop("id");
                    console.log(id);

                    if (this.type == "textarea")
                    {
                        fieldValue = $(this).val();
                    }
                    else if (this.type == "radio")
                    {
                        fieldValue = $("input[name='" + fieldName + "']:checked").val();

                        if (fieldValue == null)
                        {
                            if (fieldName == "would_you_like_to_see_changes_flag")
                            {
                                $(this).parent().parent().css("color", "red");
                            }
                            else
                            {
                                $(this).parent().parent().parent().parent().css("color", "red");
                            }

                            fieldsCompleted = false;
                        }
                        else
                        {
                            if (fieldName == "would_you_like_to_see_changes_flag")
                            {
                                $(this).parent().parent().css("color", "black");
                            }
                            else
                            {
                                $(this).parent().parent().parent().parent().css("color", "black");
                            }
                        }
                    }
                    else if (this.type == "number")
                    {
                        fieldValue = $(this).val();

                        if (fieldValue == null)
                        {
                            $(this).parent().css("color", "red");
                            fieldsCompleted = false;
                        }
                        else if ((fieldName == "sessions_selector") && (fieldValue <= 0))
                        {
                            $(this).parent().css("color", "red");
                            fieldsCompleted = false;
                        }

                    }
                    else if (this.type == "select-one")
                    {
                        fieldValue = $(this).val();

                        if (fieldValue == null || fieldValue == "")
                        {
                            $(this).parent().parent().css("color", "red");
                            fieldsCompleted = false;
                        }
                        else
                        {
                            $(this).parent().parent().css("color", "black");
                        }
                    }


                    if (fieldValue == null)
                    {
                        fieldValue = "";
                    }
                }
            }
        });

        if (!fieldsCompleted)
        {
            $("#feedback-error").show();
            $("#feedback-error").html('All required fields must be completed.');
            return false;
        }
        else
        {
            $("#feedback-error").html('');
            return true;
        }
    }

    function validateSessionFormFields(sectionId)
    {
        var fieldValue = "";
        var fieldName = "";
        var fieldsCompleted = true;

        console.log('comeinsg');

        $("#" + sectionId + " input, #" + sectionId + " textarea, #" + sectionId + " select").each(function () {

            // only process each input once in the case of radio buttons
            if (fieldName != $(this).prop("name"))
            {
                fieldName = $(this).prop("name");

                if (this.type == "textarea")
                {
                    fieldValue = $(this).val();
                }
                else if (this.type == "radio")
                {
                    fieldValue = $("input[name='" + fieldName + "']:checked").val();

                    if (fieldValue == null)
                    {
                        if (fieldName == "would_you_like_to_see_changes_flag")
                        {
                            $(this).parent().parent().css("color", "red");
                        }
                        else
                        {
                            $(this).parent().parent().parent().parent().css("color", "red");
                        }

                        fieldsCompleted = false;
                    }
                    else
                    {
                        if (fieldName == "would_you_like_to_see_changes_flag")
                        {
                            $(this).parent().parent().css("color", "black");
                        }
                        else
                        {
                            $(this).parent().parent().parent().parent().css("color", "black");
                        }
                    }
                }
                else if (this.type == "number")
                {
                    fieldValue = $(this).val();

                    if (fieldValue == null)
                    {
                        $(this).parent().css("color", "red");
                        fieldsCompleted = false;
                    }
                    else if ((fieldName == "sessions_selector") && (fieldValue <= 0))
                    {
                        $(this).parent().css("color", "red");
                        fieldsCompleted = false;
                    }

                }
                else if (this.type == "select-one")
                {
                    fieldValue = $(this).val();

                    if (fieldValue == null || fieldValue == "")
                    {
                        $(this).parent().parent().css("color", "red");
                        fieldsCompleted = false;
                    }
                }


                if (fieldValue == null)
                {
                    fieldValue = "";
                }
            }
        });

        if (!fieldsCompleted)
        {
            $("#feedback-error").show();
            $("#feedback-error").html('All required fields must be completed.');
            return false;
        }
        else
        {
            $("#feedback-error").html('');
            return true;
        }
    }

    $(".arrow-left").click(function () {
        changePathwayColour('left');
    });

    $(".arrow-right").click(function () {
        changePathwayColour('right');
    });

    if($(".arrow-right").length)
    {
        $('html').keydown(function(e){
            if(e.which == '39')
            {
                changePathwayColour('right');
            }            
        });
    }

    if($(".arrow-left").length)
    {
        $('html').keydown(function(e){
            if(e.which == '37')
            {
                changePathwayColour('left');
            }            
        });
    }

    $("body").on('click', '.current-intervention .btn, .green-link, #main-link', function (e) {
        e.preventDefault();
        var currentElem = $(e.target);
        if (!$("#interventions-list").hasClass("restricted"))
        {
            showInterventionDetailPage($(this), '');
        }
    });

    function onInterventionDetailBackClicked(viewActive)
    {
        $("#intervention-details-section").remove();
        $("#intervention-section").remove();
        $("#interventions-grid-list-section").hide();
        $("#interventions-list").hide();

        if (viewActive == "timeline")
        {
            $("#interventions-list").fadeIn(500);
            $("#interventions-grid-list-section").hide();
        }
        else if (viewActive == "grid")
        {
            $("#interventions-grid-list-section").fadeIn(500);
            $("#interventions-list").hide();
        }

        $(".pathway").show();
        $(".dash-loader").hide();
        $("#pathway-filter").show();
        $("#online-courses-header").show();
        $(".online-courses").show();

        $('html, body').animate({
            scrollTop: $("#pathway-filter").offset().top
        }, 100);

    }

    $("#grid-view-nav-btn").on('click', function(){
        onGridViewNavBtnClicked();
        $('.learning-pathways-section').removeClass('timeline-active').addClass('gridview-active');
        $('#search_area').css('display', 'flex');
        $('.icon-key-container').css('display', 'block');

        var selectedValue       = $("#intervention_type").val();
        var selectedValueFilter = $("#intervention_type_filter").val();
        if(selectedValue != 'view_all')
        {
            $('#intervention_type').val('view_all').change();
        }
        // if(selectedValueFilter != 0)
        // {
        //     $('#intervention_type_filter').val('0').change();
        // }

        $('#intervention_type_filter').val('1').change();

        var pageURL     = window.location.href;
        var requestList = pageURL.split("&");
        var newURL      = "";
      
        requestList.forEach(function(entry) {
            if (!entry.includes("intervention_id"))
            {
                newURL += entry +"&";
            }
        });

        newURL += "layout=grid";

        requestList.forEach(function(entry) {
            if (entry.includes("intervention_id"))
            {
                newURL += "&" + entry ;
            }
        });
        
        if (!pageURL.includes("&layout=grid"))
        {
            window.history.pushState("", "", newURL);
        }
        newURL = "";          
    });

    function onGridViewNavBtnClicked() {
        var pathwayVersionId = $(".lp-select-header option:selected").val();
        var functionVal = "loadInterventionsGrid";
        var pathwayCategory  = $("#pathway-category-select option:selected").val();
        var gamesEditionId = $(".games-logo").attr("data-index");            

        //$(".pre-reading-box").show();
        var token = $("input[name=token]").val();

        $(".dash-loader").css('display', 'flex');

        $.post("/course_admin/ajax_load_intervention_detail.php", {functionVal: functionVal, pathwayVersionId: pathwayVersionId, pathway_category: pathwayCategory, gamesEditionId: gamesEditionId, ptToken: token}, function (result) {
            $("#interventions-list").hide();
            $(".pathway-fade").hide();
            $(".dash-loader").hide();
            $("#interventions-grid-list-section").html(result).fadeIn(200);

            $(".current-intervention-grid > a:first-child").click(function (e) {
                e.preventDefault();
                showInterventionDetailPage($(this), '');
            });
        });

        $("#timeline-view-nav-btn").on('click', function () {

            var pageURL     = window.location.href;
            var requestList = pageURL.split("&");
            var newURL      = requestList[0] +"&"+ requestList[1] +"&"+ requestList[2] +"&"+ requestList[3] +"&"+ requestList[4] +"&"+ requestList[5];
            window.history.pushState("", "", newURL);
            newURL = '';   

            $('#search_area').css('display', 'none');     
            $('.icon-key-container').css('display', 'none');       
            $(".dash-loader").css('display', 'flex');
            $("#interventions-grid-list-section").hide();
            $("#interventions-list").fadeIn(200);
            $('.learning-pathways-section').removeClass('gridview-active').addClass('timeline-active');
            $(".pathway-fade").fadeIn(200);
            $(".dash-loader").hide();
            $("#interventions-list").show();
            onPathwaySelected();
        });
    }


    var sessions_selected = "";

    function updateSessions(functionVal) {

        var token   = getParameterByName('token');
        var lang    = $("#language").val();
        var ptToken = $('input[name="token"]').val();

        sessions = [];

        $('.session-selector-instance').each(function (i, obj) {
            sessions.push($(this).val());
        });

        sessions_selected = sessions;

        $.post("/course_admin/ajax_get_sessions.php", {function: functionVal, token: token, language: lang, number_sessions: $("input[name='sessions_selector']").val(), sessions: sessions, ptToken : ptToken}, function (result) {

            if (functionVal == "show_session_fields")
            {
                $("#session-dynamic-fields").remove();

                //Hide other fields
                $("#feedback-form-section div, #feedback-form-section h2, #feedback-form-section h1, #feedback-form-section p").each(function () {
                    if (($(this).attr('class') == "after-sessions-selector"))
                    {
                        return false;
                    }
                    else
                    {
                        $(this).hide();
                    }
                });

                //Add session fields to body
                $("#session-dynamic-dropdowns").after("<div id='session-dynamic-fields' style='display:none;'>" + result + "</div>");
                $(window).scrollTop(0);
                $("#session-dynamic-fields").fadeIn(500);

                //Hide Individual session fields
                $(".individual-session-assessment-section").each(function () {

                    if (this.id != "session_assessment_" + sessions_selected[0])
                    {
                        $(this).hide();
                    }

                });

                $(".next-session-btn").on('click', function () {
                    $(window).scrollTop(0);


                    var currentSessionId = "";
                    currentSessionId = $(this).parent().parent().attr("id").split("_")[2];
                    var currentSectionId = "session_assessment_" + currentSessionId;

                    var next_session_num = "";
                    next_session_num = this.id.split("_")[2];

                    if (this.id == "final_next_btn")
                    {
                        if (validateSessionFormFields(currentSectionId))
                        {
                            $(".after-sessions-selector").each(function () {
                                $(this).fadeIn(500);
                            });
                        }

                    }

                    if (validateSessionFormFields(currentSectionId))
                    {
                        $(".individual-session-assessment-section").each(function () {

                            if (this.id != "session_assessment_" + next_session_num)
                            {
                                $(this).hide();
                            }
                            else
                            {
                                $(this).fadeIn(500);
                            }

                        });

                    }

                });


                $(".previous-session-btn").on('click', function () {
                    $(window).scrollTop(0);
                    if (this.id == "back_to_main")
                    {
                        $("#feedback-form-section div, #feedback-form-section h2, #feedback-form-section h1, #feedback-form-section p").each(function () {
                            if (($(this).classname != "after-sessions-selector"))
                            {
                                $(this).show();
                            }
                        });

                        $(".after-sessions-selector").each(function () {
                            $(this).hide();
                        });

                        $(".individual-session-assessment-section").each(function () {
                            $(this).hide();
                        });

                    }
                    else
                    {
                        var previous_session_num = "";
                        previous_session_num = this.id.split("_")[2];

                        $(".individual-session-assessment-section").each(function () {

                            if (this.id != "session_assessment_" + previous_session_num)
                            {
                                $(this).hide();
                            }
                            else
                            {
                                $(this).fadeIn(200);
                            }

                        });
                    }


                });


            }
            else if (functionVal == "show_session_dropdowns")
            {
                $("#session-dynamic-fields").remove();
                $("#session-dynamic-dropdowns").remove();

                $("input[name='sessions_selector']").parent().after("<div id='session-dynamic-dropdowns'>" + result + "</div>");

                //Set disabled for already selected options
                setSessionDropdownDefaults();


                $("#session-selector-submit-btn").on('click', function () {
                    var session_not_set = false;
                    $('.session-selector-instance').each(function (i, obj) {
                        if ($(this).val() == "none")
                        {
                            session_not_set = true;
                        }
                    });

                    if (session_not_set)
                    {
                        alert("Select a valid Session.");
                    }
                    else
                    {
                        if (validatFormFieldsBeforeSessions())
                        {
                            var request = "show_session_fields";
                            updateSessions(request);
                        }

                    }
                });
            }

            $(".session-selector-instance").change(function () {
                $("#session-dynamic-fields").remove();
                $(".after-sessions-selector").hide();
                setSessionDropdownDefaults();
            });

            return true;

        });

    }

    $("input[name='sessions_selector']").bind('keyup mouseup', function () {
        if ($(this).val() > 0)
        {
            if (($(this).val()) > ($(this).attr("max")))
            {
                alert("This course has a maximum of " + $(this).attr("max") + " sessions");
                $("#session-dynamic-dropdowns").remove();
                return false;
            }
            else
            {
                var request = "show_session_dropdowns";
                $(".after-sessions-selector").hide();
                updateSessions(request);
            }
        }
        else
        {
            $("#session-dynamic-dropdowns").remove();
            return false;
        }

    });

    function renderCaseStudy(functionVal)
    {
        var token   = getParameterByName('token');
        var lang    = $("#language").val();
        var ptToken = $('input[name="token"]').val();
        var functionVal = functionVal;
        var lang    = $("#language").val();

        cases_ids = [];

        $('#case_selections_vals').each(function (i, obj) {
            cases_ids.push($(this).val());
        });
        case_selected = cases_ids;
        if (functionVal == "get_cases_fields")
        {
            $.ajax({
                url: '/course_admin/ajax_get_case_studies.php',
                dataType: "json",
                data: {
                   function : functionVal,
                   ptToken : ptToken,
                   token : token,
                   language : lang
                },
                success: function(data)
                {
                    try
                    {
                        $("#feedback-form-section span").each(function () {
                            var id = $(this).attr('id');
                            if (id == "btn-case-study-selector")
                            {
                                $(this).hide();
                            }
                        });
                        //Hide other fields
                        $("#feedback-form-section div, #feedback-form-section h2, #feedback-form-section h1, #feedback-form-section p,#feedback-form-section span").each(function () {
                            if (($(this).attr('class') == "after-sessions-selector"))
                            {
                                return false;
                            }
                            else
                            {
                                $(this).hide();
                            }
                            
                        });

                             //Add session fields to body
                            $("#btn-case-study-selector").after("<div id='session-dynamic-fields' style='display:none;'>" + data.form + "</div>");
                            $(window).scrollTop(0);
                            $("#session-dynamic-fields").fadeIn(500);

                            //Hide Individual session fields
                            $(".individual-case-assessment-section").each(function () {

                                if (this.id != "case_assessment_" + case_selected[0])
                                {
                                    $(this).hide();
                                }

                            });


                          $(".next-case-study-btn").on('click', function () {
                                $(window).scrollTop(0);
                                var currentSessionId = "";
                                currentSessionId = $(this).parent().parent().attr("id").split("_")[2];
                                var currentSectionId = "case_assessment_" + currentSessionId;

                                var next_session_num = "";
                                next_session_num = this.id.split("_")[2];

                                if (this.id == "final_next_btn")
                                {
                                    if (validateSessionFormFields(currentSectionId))
                                    {
                                        $(".after-sessions-selector").each(function () {
                                            $(this).fadeIn(500);
                                        });
                                    }

                                }

                                if (validateSessionFormFields(currentSectionId))
                                {
                                    $(".individual-case-assessment-section").each(function () {

                                        if (this.id != "case_assessment_" + next_session_num)
                                        {
                                            $(this).hide();
                                        }
                                        else
                                        {
                                            $(this).fadeIn(500);
                                        }

                                    });

                                }

                            });

                           $(".previous-case-study-btn").on('click', function () {
                                $(window).scrollTop(0);
                                if (this.id == "back_to_main")
                                {
                                    $("#feedback-form-section div, #feedback-form-section h2, #feedback-form-section h1, #feedback-form-section p,#feedback-form-section span").each(function () {
                                        if (($(this).classname != "after-sessions-selector"))
                                        {
                                            $(this).show();
                                        }
                                    });

                                    $(".after-sessions-selector").each(function () {
                                        $(this).hide();
                                    });

                                    $(".after-sessions-selectors").each(function () {
                                        $(this).hide();
                                    });

                                    $(".individual-case-assessment-section").each(function () {
                                        $(this).hide();
                                    });

                                }
                                else
                                {
                                    var previous_session_num = "";
                                    previous_session_num = this.id.split("_")[2];

                                    $(".individual-case-assessment-section").each(function () {

                                        if (this.id != "case_assessment_" + previous_session_num)
                                        {
                                            $(this).hide();
                                        }
                                        else
                                        {
                                            $(this).fadeIn(200);
                                        }

                                    });
                                }
                        });
                        
                       
                    }
                    catch (e)
                    {

                       
                    }
                },
                complete : function()
                {
                   
                }
            });
        }
    }

    $('body').on('click', '#btn-case-study-selector', function(e)
    {
        e.preventDefault();
        var request = "get_cases_fields";       
        renderCaseStudy(request);
    });

    $('body').on('change', '#feedback_case_study_btn', function() 
    {
        var case_id = $(this).val();
        if (case_id !== '0')
        {
            var request = "show_case_info";
            $(".after-sessions-selector").hide();
            renderCaseStudy(request);
        }
        else if (case_id === '0')
        {
             $(".after-sessions-selector").hide();
        }  
    });

    $('body').on('click', '#poc-added-filter-btn',function(){
            var feedback_form_id    = $("#rpt-feedback-frm").val();
            var academy_form_id     = $("#rpt-academy-frm").val();
            var programe_form_id    = $("#rpt-programme-frm").val();
            var course_form_id      = $("#rpt-course-frm").val();
            var start_date          = $("#rpt-start-date").val();
            var end_date            = $("#rpt-end-date").val();
            var report_type         = $("#report-type").val();
            var no_courses          = "false";
            var listofcourses       = "";
            var token               = $('input[name="token"]').val();
            var workshop_id         = $("#rpt-visits-frm").val();
            var ocog                = $('#ge-list-dropdown').val();
            var startDateAllActivities           = $("#ogkm-report-search-area #month-picker-start").val();
            var endDateAllActivities             = $("#ogkm-report-search-area #month-picker-end").val();
            var reportLevel         = $("#ogkm-report-level option:selected").val();
            var productArea = $("#rpt-report-areas-frm option:selected").val();
            var audienceType = $("#rpt-audience-frm").val();

            $cmsLoadingStatus       = true;
            report_area_default     = document.getElementById("report-area");
            
            if (!report_area_default)
            {      
                $('#ogkm-dash-report-body').hide();         
                $(".reports-loader").show(); 
            }
            
            DisableApplyFilterBtn();
            if (course_form_id == "all")
            {
                //build all the forms id
                count = 0;
                $("#rpt-course-frm option").each( function()
                {
                    var length_of_courses = $("#rpt-course-frm option").length - 1;
                    if (length_of_courses > 0)
                    {
                        if ($(this).val() !== "all")
                        {
                            if (count == length_of_courses)
                            {
                               listofcourses += $(this).val();
                            }
                            else
                            {
                                listofcourses += $(this).val() + ",";
                            }
                        }
                    }
                    else
                    {
                        no_courses = "true";
                    }

                    count++;

                });
            }
            else
            {
                listofcourses = course_form_id;
            }

            var functionType    = "applyFilter";
            if (no_courses == "false")
            {
                $.ajax({
                    url: '../course_admin/ajax_generate_feedback_charts.php',
                    dataType: "json",
                    data: {
                        applyFilter     : functionType,
                        feedback        : feedback_form_id,
                        academy         : academy_form_id,
                        prog            : programe_form_id,
                        course          : listofcourses,
                        startdate       : start_date,
                        enddate         : end_date,
                        report_type     : report_type,
                        ptToken         : token,
                        workshop_id     : workshop_id,
                        ocog            : ocog,
                        start_date_activities      : startDateAllActivities,
                        end_date_activities        : endDateAllActivities,
                        report_level : reportLevel,
                        product_area: productArea,
                        audience_type: audienceType
                    },
                    success: function(data)
                    {
                        try
                        {
                            if (data.output != null)
                            {
                                report_area_default = document.getElementById("report-area");
                                if (report_area_default)
                                {
                                    $('#report-area').html(data.output);
                                }
                                else
                                {
                                    $('#ogkm-dash-report-body').html(data.output);
                                    $('#ogkm-dash-report-body').show();
                                    $(".reports-loader").hide();
                                }
                                
                                $cmsLoadingStatus   = false;
                                
                                EnableApplyFilterBtn();
                            }
                            else if (data.error != null)
                            {
                                alert(data.error);
                                $cmsLoadingStatus   = false;
                                $(".reports-loader").hide();
                                EnableApplyFilterBtn();
                            }
                        }
                        catch (e)
                        {

                             $('#loading-dialog').hide();
                             
                             EnableApplyFilterBtn();
                        }
                    },
                    complete : function()
                    {
                        //$("h2").html("Custom Report Filters");                        
                        $('#loading-dialog').hide();
                       
                        EnableApplyFilterBtn();
                    }
                });
            }
            else
            {
                alert("There are no courses found associated with the selected Feedback Forms");
                $('#loading-dialog').hide();
                EnableApplyFilterBtn();
            }

    });

    $('body').on('click', "#show-filters-date", function(){
            var toggle = $(this).attr("toggle");
            if (toggle == "off")
            {
                $("#custom-filters-date").show();
                $(this).attr("toggle","on");
                $("#select-date-range").html("Clear Date Range Filters");
            }
            else if (toggle == "on")
            {
                $("#rpt-start-date").val("");
                $("#rpt-end-date").val("");
                $("#custom-filters-date").hide();
                $(this).attr("toggle","off");
                $("#select-date-range").html("Select Date Range Filters");

            }

    });

    if ($(".cookie-policy-wrapper-v2").length)
    {
        $(".cookie-policy-wrapper-v2").fadeIn();

        $("#cookie-accept-btn").on('click', function(){
            var policyType = $(this).attr('policy-type');
            $.ajax({
                url:'../admin/ajax_accept_cookie_policy.php',
                dataType:'json',
                type:'post',
                data: {action: "accept", policyType: policyType, hasAcceptedCookies: 1},
                success: function(data) {
                    if (data.success != null)
                    {
                       $(".cookie-policy-wrapper-v2").fadeOut(200); 
                    }
                    else if (data.error != null)
                    {
                        alert(data.error);
                    }
                },
                error: function(data) {
                    alert('Something went wrong');
                }
            });
        });

        $("#cookie-reject-btn").on('click', function(){
            var policyType = $(this).attr('policy-type');
            $.ajax({
                url:'../admin/ajax_accept_cookie_policy.php',
                dataType:'json',
                type:'post',
                data: {action: "accept", policyType: policyType, hasAcceptedCookies: 0},
                success: function(data) {
                    if (data.success != null)
                    {
                       $(".cookie-policy-wrapper-v2").fadeOut(200); 
                    }
                    else if (data.error != null)
                    {
                        alert(data.error);
                    }
                },
                error: function(data) {
                    alert('Something went wrong');
                }
            });
        });

    }

    if ($(".cookie-policy-wrapper").length)
    {       
        $(".cookie-policy-wrapper").fadeIn();

        $(".cookie-close-icon").on('click', function(){
            $(".cookie-policy-wrapper").fadeOut(200);

            $.ajax({
                url:'../admin/ajax_accept_cookie_policy.php',
                dataType:'json',
                type:'post',
                data: {action:"close"},
                success: function(data) {
                    if (data.success != null)
                    {
                       $(".cookie-policy-wrapper").fadeOut(200); 
                    }
                    else if (data.error != null)
                    {
                        alert(data.error);
                    }
                },
                error: function(data) {
                    alert('Something went wrong');
                }
            });
        });

        $("#cookie-policy-link").on("click", function(){
            $(".cookie-policy-detail").fadeIn();
        })

        $("#cookie-accept-btn").on('click', function(){
            var policyType = $(this).attr('policy-type');
            $.ajax({
                url:'../admin/ajax_accept_cookie_policy.php',
                dataType:'json',
                type:'post',
                data: {action: "accept", policyType: policyType},
                success: function(data) {
                    if (data.success != null)
                    {
                       $(".cookie-policy-wrapper").fadeOut(200); 
                    }
                    else if (data.error != null)
                    {
                        alert(data.error);
                    }
                },
                error: function(data) {
                    alert('Something went wrong');
                }
            });
        });
    }

    $('#input-opted-in-btn').on('click', function() {
        var userId = $(this).attr('data-user');
        var policy = $(this).attr('data-policy');
        var action = "reject_opt_in";
        var token = $('input[name="token"]').val();
        $.ajax({
                url:'../content/ajax_itf_common.php',
                dataType:'json',
                type:'post',
                data: { 
                    action: action, 
                    user_id: userId,
                    policy: policy,
                    token: token
                },
                success: function(data) {
                    if (data.success != null)
                    {
                       $('.modal').hide();
                    }
                    else if (data.error != null)
                    {
                        alert(data.error);
                    }
                },
                error: function(data) {
                    alert('Something went wrong');
                }
            });
    });

    $('#btn-opted-out').on('click', function() {
        var userId = $(this).attr('data-user');
        var policy = $(this).attr('data-policy');
        var action = "reject_opt_in";
        var token = $('input[name="token"]').val();
        $.ajax({
                url:'../content/ajax_itf_common.php',
                dataType:'json',
                type:'post',
                data: { 
                    action: action, 
                    user_id: userId,
                    policy: policy,
                    token: token
                },
                success: function(data) {
                    if (data.success != null)
                    {
                       $('.modal').hide();
                    }
                    else if (data.error != null)
                    {
                        alert(data.error);
                    }
                },
                error: function(data) {
                    alert('Something went wrong');
                }
            });
    });

    $('#btn-opted-in').on('click', function() {
        var userId = $(this).attr('data-user');
        var policy = $(this).attr('data-policy');
        var action = "accept_opt_in";
        var token = $('input[name="token"]').val();
        $.ajax({
                url:'../content/ajax_itf_common.php',
                dataType:'json',
                type:'post',
                data: { 
                    action: action, 
                    user_id: userId,
                    policy: policy,
                    token: token
                },
                success: function(data) {
                    $('.modal').hide();
                },
                error: function(data) {
                    alert('Something went wrong');
                }
            });
    });

    $(".cms-forms").submit(function(e){

        var formData = $('form').serializeArray();
        var token = $('input[name="token"]').val();
        var target = this;
        $(target).find('#error-message').html("");
        
        $.ajax({
            url: '../cms/ajax_xss_validation.php',
            type: "post",
            dataType: "json",
            async: false,
            data: {
                data    :   formData,
                ptToken :   token
            },
            success: function(data)
            {          

                if (data.error == "Invalid request!")
                {                                       
                    $(target).find('#error-message').text('Invalid data. Please try again!');
                    e.preventDefault();

                    var loadingDialog = document.getElementById("loading-dialog");
                    if(loadingDialog)
                    {
                         $('#loading-dialog').hide();
                    }

                    var itfSuccessMessage = document.getElementById("itf-success-message");
                    if(itfSuccessMessage)
                    {
                         $('#itf-success-message').hide();
                    }
                }
                else if(data.error == 'Invalid token!')
                {
                    $(target).find('#error-message').text('Invalid token!');
                    e.preventDefault();

                    var loadingDialog = document.getElementById("loading-dialog");
                    if(loadingDialog)
                    {
                         $('#loading-dialog').hide();
                    }

                    var itfSuccessMessage = document.getElementById("itf-success-message");
                    if(itfSuccessMessage)
                    {
                         $('#itf-success-message').hide();
                    }
                }                
                else
                {
                    isDirty = false;
                    textChangeArrayCMS = {};
                    return true;
                }
            }
        });
    });

    if($('[data-toggle="tooltip"]').length)
    {       
        $(function () {
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            })
        });
    }

    $('.insert_new_domain input[type="button"]').on('click', function ()
    {
        $('#games_edition_active_tbl').append('<tr><td><input type="text" id="domain-name-valid-ge" /></td><td><input class="btns btns-primary save-games-edition-domain-btn" type="button" value="Save" /></td></tr>');
        $('#input-new-ge-domain-btn').attr('disabled','true');
    });

    $('body').on('click', '.save-games-edition-domain-btn', function() {
        var domain_name     = $('#domain-name-valid-ge').val();
        var token           = $('input[name="token"]').val();
        var action          = "saveValidDomains";
        var gamesEditionId  = $('input[name="ge_id"]').val();
        var thisbutton       = $(this);

        //TO-DO -- Have to validate the domain name
        if (domain_name == "")
        {
             alert("Empty domains are not allowed");
             return;
        }

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                domain          : domain_name,
                token           : token,
                action          : action,
                gamesEditionId  : gamesEditionId
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {
                       $('#input-new-ge-domain-btn').prop('disabled',false);
                       $('#domain-name-valid-ge').prop('disabled',true);
                       thisbutton.removeClass('btns-primary');
                       thisbutton.addClass('btns-danger');
                       thisbutton.addClass('remove-ogkm-domain-btn');
                       thisbutton.removeClass('save-games-edition-domain-btn');
                       id =data.output;
                       thisbutton.attr('attr-id', id);
                       thisbutton.val("Remove");
                       alert("Domain successfully added for this Games Editions");
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

    });


    $('body').on('click', '.assign_ogkm_domain', function() {
        var token               = $('input[name="token"]').val();
        var action              = "assignValidDomains";
        var academyDomainId     = $(this).attr('attr-id');
        var gamesEditionId      = $('input[name="ge_id"]').val();
        var thisbutton          = $(this);

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                mapping         : academyDomainId,
                token           : token,
                action          : action,
                geid            : gamesEditionId
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {

                       thisbutton.closest('tr').remove();
                       alert("Domain successfully assign  to this Games Editions");
                       location.reload();
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

     });

    $('body').on('click', '.remove-ogkm-domain-btn', function() {
        var token               = $('input[name="token"]').val();
        var action              = "removeValidDomains";
        var mapping_id          = $(this).attr('attr-id');
        var thisbutton          = $(this);

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                mapping         : mapping_id,
                token           : token,
                action          : action

            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {
                       thisbutton.closest('tr').remove();
                       alert("Domain successfully removed from this Games Editions");
                    }
                    else if(data.error)
                    {
                       alert("There was an error in adding valid domains. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

    });

    $('body').on('click', '.remove-online-ge-courses-btn', function() {
        var token               = $('input[name="token"]').val();
        var action              = "removeGeOnlineCourses";
        var mapping_id          = $(this).attr('attr-id');
        var thisbutton          = $(this);

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                mapping         : mapping_id,
                token           : token,
                action          : action
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {
                       thisbutton.closest('tr').remove();
                       alert("Online course successfully removed from this Games Editions");
                       location.reload();
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

    });

     $('body').on('click', '.assign_online_course_ge', function() {
        var token               = $('input[name="token"]').val();
        var action              = "assignValidOnlineCourseGe";
        var course_id           = $(this).attr('attr-id');
        var gamesEditionId      = $('input[name="ge_id"]').val();
        var thisbutton          = $(this);

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                mapping         : course_id,
                token           : token,
                action          : action,
                geid            : gamesEditionId
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {

                       thisbutton.closest('tr').remove();
                       alert("Online course successfully assigned to this games editions.");
                       location.reload();
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator.");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

     });

     if ($('#games_edition_all_tbl').length)
     {
        $('#games_edition_all_tbl').dataTable();
     }

     if ($('#games_edition_online_courses_all_tbl').length)
     {
        $('#games_edition_online_courses_all_tbl').dataTable();
     }

     if ($('#games_edition_all_emails_tbl').length)
     {
        $('#games_edition_all_emails_tbl').dataTable();
     }

     if ($('#user_management_tbl').length)
     {
        $('#user_management_tbl').dataTable();
     }

    if ($('#interventions_prod_areas_tbl').length)
     {
        $('#interventions_prod_areas_tbl').dataTable();
     }

    $('.insert_new_email input[type="button"]').on('click', function ()
    {
        $('#games_edition_active_emails_tbl').append('<tr><td><input type="text" id="email-name-valid-ge" size="50"/></td><td><input class="btns btns-primary save-games-edition-email-btn" type="button" value="Save" /></td></tr>');
        $('#input-new-ge-email-btn').prop('disabled',true);
    });

    $('body').on('click', '.save-games-edition-email-btn', function() {
        var email               = $('#email-name-valid-ge').val();
        var token               = $('input[name="token"]').val();
        var action              = "saveValidEmails";
        var gamesEditionId      = $('input[name="ge_id"]').val();
        var thisbutton          = $(this);
        var thisTextbox         = $('#email-name-valid-ge');


        if (!isValidEmailAddress(email))
        {
             alert("Email address is not allowed.");
             return;
        }


        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                email           : email,
                token           : token,
                action          : action,
                gamesEditionId  : gamesEditionId
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {
                       $('#input-new-ge-email-btn').prop('disabled',false);

                       thisTextbox.prop('disabled',true);
                       thisTextbox.removeAttr('id');


                       thisbutton.removeClass('btns-primary');
                       thisbutton.addClass('btns-danger');
                       thisbutton.addClass('remove-ocog-email-btn');
                       thisbutton.removeClass('save-games-edition-email-btn');
                       id =data.output;
                       thisbutton.attr('attr-id', id);
                       thisbutton.val("Remove");

                       textboxid    = "email-name-valid-ge-" + id;
                       thisTextbox.attr('id', textboxid);


                       alert("Email successfully added for this Games Editions");
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

    });


    $('body').on('click', '.remove-ocog-email-btn', function() {
        var token               = $('input[name="token"]').val();
        var action              = "removeGeEmails";
        var mapping_id          = $(this).attr('attr-id');
        var thisbutton          = $(this);

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                mapping         : mapping_id,
                token           : token,
                action          : action
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {
                       thisbutton.closest('tr').remove();
                       alert("Email address successfully removed from this Games Editions");
                       //location.reload();
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

    });

     $('body').on('click', '.assign_ogkm_emails', function() {
        var token               = $('input[name="token"]').val();
        var action              = "assignValidEmailToGe";
        var email_id            = $(this).attr('attr-id');
        var gamesEditionId      = $('input[name="ge_id"]').val();
        var thisbutton          = $(this);

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                mapping         : email_id,
                token           : token,
                action          : action,
                geid            : gamesEditionId
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {

                       thisbutton.closest('tr').remove();
                       alert("Email Address successfully assigned to this games editions.");
                       location.reload();
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

     });


    $('body').on('click', '.assign_interventions_prod_areas', function() {
        var token               = $('input[name="token"]').val();
        var action              = "assignInterToProdArea";
        var intervention_id     = $(this).attr('attr-id');
        var prodAreaId          = $('input[name="prod_id"]').val();
        var thisbutton          = $(this);

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                mapping         : intervention_id,
                token           : token,
                action          : action,
                geid            : prodAreaId
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {

                       thisbutton.closest('tr').remove();
                       alert("Programme successfully assigned to this product area.");
                       location.reload();
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

     });

    $('body').on('click', '.remove-intervention-prod-areas-btn', function() {
        var token               = $('input[name="token"]').val();
        var action              = "removeInterProdAreas";
        var mapping_id          = $(this).attr('attr-id');
        var thisbutton          = $(this);

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                mapping         : mapping_id,
                token           : token,
                action          : action
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {
                       thisbutton.closest('tr').remove();
                       alert("Programme successfully removed from this Product Area");
                       location.reload();
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

    });

    $('body').on('click', '.remove-intakes-case-areas-btn', function() {
        var token               = $('input[name="token"]').val();
        var action              = "removeIntakeCase";
        var mapping_id          = $(this).attr('attr-id');
        var thisbutton          = $(this);

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                mapping         : mapping_id,
                token           : token,
                action          : action
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {
                       thisbutton.closest('tr').remove();
                       alert("Course successfully removed from this Case Study");
                       //location.reload();
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

    });

    $('body').on('click', '.assign_intakes_case_areas', function() {
        var token               = $('input[name="token"]').val();
        var action              = "assignIntakeToCase";
        var intervention_id     = $(this).attr('attr-id');
        var prodAreaId          = $('input[name="prod_id"]').val();
        var thisbutton          = $(this);

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                mapping         : intervention_id,
                token           : token,
                action          : action,
                geid            : prodAreaId
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {

                       thisbutton.closest('tr').remove();
                       alert("Course successfully assigned to this Case study.");
                       location.reload();
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });

     });

    $('#type').on('change', function() 
    {
        var val = $(this).val();

        if (val == "workshop")
        {
            $('#is_case_study-1').parent().parent().show();
        }
        else
        {
            $('#is_case_study-1').parent().parent().hide();
        }

    });


    $('body').on('click', '.case_study_info', function() {
         var type = $(this).attr('attr-type');

         if (type === "workshop")
         {
            $('#case-studies').show();
         }
         else
         {
            $('#case-studies').hide();
         }
    });



    check_default_value_for_case();

    function check_default_value_for_case()
    {
        if ($('#type').length)
        {
            var val = $('#type').val();
            if (val == "workshop")
            {
                 $('#is_case_study-1').parent().parent().show();
            }
        }
    }



    $('body').on('click', '.presenter_info', function() 
    {
        var presenter_id    = $(this).attr('pre');
        var name            = $(this).attr('data-cell');
        var token           = $('input[name="token"]').val();
        var action          = "presenterInfo";

        name               += " Analysis";

        $('#presenter-name').text(name);
        $('#loading-dialog').show();

        //Ajax call to get infomation

        $.ajax({
            url: '../content/ajax_ogkm_controller.php',
            dataType: "json",
            data: {
                mapping         : presenter_id,
                token           : token,
                action          : action               
            },
            success: function(data)
            {
                try
                {
                    if (data.output)
                    {

                        generate_individual_presenter(data.output);
                        $('#loading-dialog').hide();
                        $('#container').show();
                      
                    }
                    else if(data.error)
                    {
                       alert("There was an error encountered. Please contact system administrator");
                    }

                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }

        });
       

        
    });

    $('body').on('click', '#close-btn-presenter', function()
    {
        $('#container').hide();
    });

   $('body').on('click', '.btn-for-view-users', function(){
        var userId      = $(this).attr('attr-date');
        var name        = $(this).attr('nameuser');
        renderModalUserAnalytics(userId, name);  
    });

    $('body').on('click', '#close-btn-table', function()
    {
        $('#table-report-data').hide();
           if ($('#user_info_itf_dt').find('tr:first-child').find('td').length > 1) 
           {
                $("#user_info_itf_dt").dataTable().fnDestroy();
                $('#user-itf-table-info').html('');
                var default_str = "<tr><td>This user have not view a content.</td></tr>";
                $('#user-itf-table-info').html(default_str);
           }
           else
           {
                $('#user-itf-table-info').html('');
                var default_str = "<tr><td>This user have not view a content.</td></tr>";
                $('#user-itf-table-info').html(default_str);
           }
       
    })


    $('body').on('change', '#academies_regions', function()
    {
        var academy_id = $(this).val(); 
        var token    = $('input[name="token"]').val();   
        var action   = "getRegionsbyCountries";
        if (academy_id !== "")
        {   
                $.ajax({
                        url: '../content/ajax_ogkm_controller.php',
                        dataType: "json",
                        data: {
                            mapping         : academy_id,
                            token           : token,
                            action          : action               
                        },
                        success: function(data)
                        {
                            try
                            {
                               
                                if (data.output)
                                {   
                                     $('#country_regions').html(data.output);                            
                                }
                                else
                                {
                                     $('#loading-dialog').hide();                                     
                                }

                                if(data.error)
                                {
                                   alert("There was an error encountered. Please contact system administrator");
                                }

                            }
                            catch (e)
                            {
                                alert("Something went wrong.");
                            }
                },
                complete: function()
                {

                }

            });
        }
        else
        {
            $('#country_regions').html('');
        }
    })


    $('body').on('click', '#download-dashboard-btn-not-used', function() 
    {  
       var reportArray  = [];
       var token        = $('input[name="token"]').val();   
       var action       = "downloadReportDashboard";  
       var courseTitle  = $('#rpt-course-frm').text();  
       var courseId     =  $('#rpt-course-frm').val()
        $('#loading-dialog').show();
        var generalInfo = $('.description-block').html();
        tempArr = {"info":generalInfo};
        reportArray.push(tempArr); 

       $('.gauges-container').each( function() 
       {
           var childElementId = $(this).children("div").attr('id');  
           var title           = $(this).find('.highcharts-title').text();
           if (title != "" && title != null)
           {
                var childSvg     = $("#"+childElementId).highcharts().getSVG();
                if (childSvg !== "")
               {
                 tempArr = {"gauges":childSvg};
                 reportArray.push(tempArr);
               }
           }         
           
       })

       $('.general-attendance').each( function()
       {
            var htmlAttendanceTable = $(this).html();
            if (htmlAttendanceTable !== "")
            {
                tempArr = {"html":htmlAttendanceTable};
                reportArray.push(tempArr);
            }
       })

       $('.charts-section').each(function(){
            var childElementId = $(this).children("div").attr('id');   
            var title           = $(this).find('.highcharts-title').text();
            if (title != "" && title != null)
            {        
                var childSvg     = $("#"+childElementId).highcharts().getSVG();
                if (childSvg !== "")
                {
                    tempArr = {"svg":childSvg};
                    reportArray.push(tempArr);
                }
            }
       });

        var htmlComments = $('.comments-well').html();
        tempArr = {"comments":htmlComments};
        reportArray.push(tempArr); 

        var pdfUrl = ""; 

        $.ajax({
                url: '../content/ajax_ogkm_controller.php',
                dataType: "json",
                type:"post",  
                async: true,             
                data: {
                    mapping         : reportArray,
                    title           : courseTitle,
                    token           : token,
                    course          : courseId,
                    action          : action               
                },
                success: function(data)
                {
                    try
                    {
                       
                        if (data.output)
                        {   
                           
                            $('#loading-dialog').hide();
                            pdfUrl = data.output; 
                            window.location.href = pdfUrl; 
                           
                           
                        }
                       
                        if(data.error)
                        {
                           alert("There was an error encountered. Please contact system administrator");
                           $('#loading-dialog').hide();
                        }

                    }
                    catch (e)
                    {
                        alert("Something went wrong.");
                        $('#loading-dialog').hide();
                    }
                }

            });    

    });

    var reportArray      = [];
    $('body').on('click', '#download-dashboard-btn', function() 
    {  
      
       var token            = $('input[name="token"]').val();   
       var action           = "downloadReportDashboardExcel";  
       var courseTitle      = $('#rpt-course-frm').text();  
       var courseId         = $('#rpt-course-frm').val();
       var feedbackFormId   = $('#rpt-feedback-frm').val();
       var programmeId      = $('#rpt-programme-frm').val();
       var userType         = $('#report-type').val();
       var responseRate, overallAssess, NPS;
       reportArray          = [];

        $('#loading-dialog').show();
      
       $('.gauges-container').each( function() 
       {
            var childElementId  = $(this).children("div").attr('id');
            var title           = $(this).find('.highcharts-title').text(); 
            if (title != "" && title != null)
            {
                var childSvg        = $("#"+childElementId).highcharts().getSVG();
            
                if (title === "Response Rate")
                {
                    responseRate = $(this).find('h5').text(); 
                }
                else if (title === "Overall Assessment Score")
                {
                    overallAssess = $(this).find('h5').text(); 
                }
                else if (title === "Net Promoter Score")
                {
                    NPS = $(this).find('h5').text(); 
                }
                var canvas          = document.createElement( "canvas" );
               
                canvas.width = 475;
                canvas.height = 450;
                var ctx = canvas.getContext( "2d" );           

                var img = document.createElement( "img" );
                img.setAttribute( "src", "data:image/svg+xml;base64," + btoa( unescape(encodeURIComponent(childSvg))));
                
                var dataPngUrl = "";
                img.onload = function() {
                    ctx.drawImage( img, 0, 0 );   
                    var dataPngUrl = canvas.toDataURL( "image/png" );
                    preloadUrlExcel(dataPngUrl,reportArray, 'gauges','');
                }; 
            }   
       })

       // console.log(responseRate);
       //  console.log(overallAssess);
       //  console.log(NPS);       

       $('.general-attendance').each( function()
       {
            var htmlAttendanceTable = $(this).html();
            if (htmlAttendanceTable !== "")
            {
                tempArr = {"html":htmlAttendanceTable};
                reportArray.push(tempArr);
            }
       })

       $('.charts-section').each(function(){
            var childElementId = $(this).children("div").attr('id');    
            var title = $("#"+childElementId).highcharts().title.textStr;
            if (title != null && title != "")
            {
                var childSvg     = $("#"+childElementId).highcharts().getSVG();
                var canvas = document.createElement( "canvas" );           
                canvas.width = 500;
                canvas.height = 450;
                var ctx = canvas.getContext( "2d" );           

                var img = document.createElement( "img" );
                img.setAttribute( "src", "data:image/svg+xml;base64," + btoa( unescape(encodeURIComponent(childSvg))));
                

                var dataPngUrl = "";
                img.onload = function() {
                    ctx.drawImage( img, 0, 0 );   
                    var dataPngUrl = canvas.toDataURL( "image/png" );
                    preloadUrlExcel(dataPngUrl,reportArray, 'svg', title);
                };
            }       
                
       });

       
        var pdfUrl = ""; 
        var htmlComments = $('.comments-well').html();
        
       

        // console.log(reportArray);
        setTimeout(function(){            
        $.ajax({
                url: '../content/ajax_ogkm_controller.php',
                dataType: "json",
                type:"post",                       
                data: {
                    mapping         : reportArray,
                    title           : courseTitle,
                    token           : token,
                    course          : courseId,
                    action          : action,
                    programme_id    : programmeId,
                    feedback_form_id : feedbackFormId,
                    response_rate : responseRate,
                    overall_assess : overallAssess,
                    nps : NPS,
                    comments :   htmlComments,
                    user_type : userType              
                },
                success: function(data)
                {
                    try
                    {
                        if (data.output)
                        {
                            $('#loading-dialog').hide();
                            pdfUrl = data.output; 
                            window.location.href = pdfUrl;
                        }
                       
                        if(data.error)
                        {
                           alert("There was an error encountered. Please contact system administrator");
                           $('#loading-dialog').hide();
                        }

                    }
                    catch (e)
                    {
                        alert("Something went wrong.");
                        $('#loading-dialog').hide();
                    }
                }

            });  
        }, 3000);      
         

    });

    $(document).on('select2:select', '.gep_content_editors', function (e) {    
        var data            = e.params.data;
        var sectionId      = $(this).attr('data-parent');
        var userId         = data.id;
        var token            = $('input[name="token"]').val();   
        var action           = "addSectionEditors";  
       
        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: {                   
                    token           : token,                   
                    action          : action,
                    user_id         : userId,
                    section_id      : sectionId
                    
                }

            });  
        
       
    });
    
    $(document).on('select2:unselect', '.gep_content_editors', function (e) {
        var data            = e.params.data;  
        var sectionId       = $(this).attr('data-parent');
        var userId          = data.id;
        var token            = $('input[name="token"]').val();   
        var action           = "removeSectionEditors";  

        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: {                   
                    token           : token,                   
                    action          : action,
                    user_id         : userId,
                    section_id      : sectionId
                    
                }
            });  

    });


    $('.gep_group_members_s2').on('select2:unselect', function (e) {
        var data            = e.params.data;  
        var groupId       = $(this).attr('data-parent');
        var userId          = data.id;
        var token            = $('input[name="token"]').val();   
        var action           = "remove_group_member";  

        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: {                   
                    token           : token,                   
                    action          : action,
                    user_id         : userId,
                    group_id        : groupId
                    
                }
            });  

    });

    $('.gep_group_members_s2').on('select2:select', function (e) {    
        var data            = e.params.data;
        var groupId      = $(this).attr('data-parent');
        var userId         = data.id;
        var token            = $('input[name="token"]').val();   
        var action           = "add_group_member";  
        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: {                   
                    token           : token,                   
                    action          : action,
                    user_id         : userId,
                    group_id        : groupId
                    
                }

            });  
        
       
    });

    $('.related-activities-programmes').on('select2:select', function (e) {    
        var data                = e.params.data;
        var userRoleId          = $(this).attr('user_role_id');
        var roleId              = $(this).attr('role_id');
        var userId              = $(this).attr('user_id');
        var interventionId      = data.id;
        var token               = $('input[name="token"]').val();   
        var action              = "add_role_ocog";
        cmsLoadingStatus = true;
        loadOverlay(); 
        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: {                   
                    token           : token,                   
                    action          : action,
                    user_id         : userId,
                    intervention_id : interventionId,
                    user_role_id    : userRoleId,
                    role_id         : roleId
                    
                },
                success: function(data)
                {
                    cmsLoadingStatus = false;
                }

            });  
        
       
    });
    
    $('.related-activities-programmes').on('select2:unselect', function (e) {
         var data                = e.params.data;
        var userRoleId          = $(this).attr('user_role_id');
        var roleId              = $(this).attr('role_id');
        var userId              = $(this).attr('user_id');
        var interventionId      = data.id;
        var token               = $('input[name="token"]').val();   
        var action              = "remove_role_ocog"; 
        cmsLoadingStatus = true;
        loadOverlay();
        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: {                   
                    token           : token,                   
                    action          : action,
                    user_id         : userId,
                    intervention_id : interventionId,
                    user_role_id    : userRoleId,
                    role_id         : roleId
                    
                },
                success: function(data)
                {
                    cmsLoadingStatus = false;
                }

            });  
        
    });

    $('.related-activities-delegations').on('select2:select', function (e) {    
        var data                = e.params.data;
        var userRoleId          = $(this).attr('user_role_id');
        var roleId              = $(this).attr('role_id');
        var userId              = $(this).attr('user_id');
        var delegationId        = data.id;
        var token               = $('input[name="token"]').val();    
        var action              = "add_role_delegation"; 
        cmsLoadingStatus = true;
        loadOverlay();
        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: {                   
                    token           : token,                   
                    action          : action,
                    user_id         : userId,
                    delegation_id   : delegationId,
                    user_role_id    : userRoleId,
                    role_id         : roleId
                    
                },
                success: function(data)
                {
                    cmsLoadingStatus = false;
                }
            });          
       
    });
    
    $('.related-activities-delegations').on('select2:unselect', function (e) {
        var data                = e.params.data;
        var userRoleId          = $(this).attr('user_role_id');
        var roleId              = $(this).attr('role_id');
        var userId              = $(this).attr('user_id');
        var delegationId        = data.id;
        var token               = $('input[name="token"]').val();   
        var action              = "remove_role_delegation"; 
        cmsLoadingStatus = true;
        loadOverlay();
        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: {                   
                    token           : token,                   
                    action          : action,
                    user_id         : userId,
                    delegation_id : delegationId,
                    user_role_id    : userRoleId,
                    role_id         : roleId
                    
                },
                success: function(data)
                {
                    cmsLoadingStatus = false;
                }

            });  
        
    });

    $('#btn-set-organisation').on('click', function()
    {
        $('#update-organisation-div').removeClass("alert-danger");
        $('#update-organisation-div').removeClass("alert-success");

        var currentOrganisation = $('#gep-user-ocog').val();
        if (currentOrganisation != 0)
        {
            var token   = $('input[name="token"]').val();   
            var userId  = $('input[name="user_id"]').val();
            var action  = "update_user_organisation"; 
            $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: 
                {                   
                    token           : token,                   
                    action          : action,
                    ocog            : currentOrganisation,
                    user_id         : userId
                },
                success: function(data)
                {
                    try
                    {
                        if (data.output)
                        {
                            $('#update-organisation-div').addClass("alert-success");
                            $('#update-organisation-div').html("Organisation is successfully updated!");
                            $("#update-organisation-div").fadeIn(300).delay(1500).fadeOut(400);
                        }
                    }
                    catch (e)
                    {
                        alert("Something went wrong.");
                    }
                }   
            });         
        }
        else
        {
            $('#update-organisation-div').addClass("alert-danger");
            $('#update-organisation-div').html("Select a correct organisation!");
            $("#update-organisation-div").fadeIn(300).delay(1500).fadeOut(400);
        }
    });

    //Call on document ready
    hideLeadFADropdown();

    $('.duplicate_gep_resource').on('click', function()
    {
        var token = $('input[name="token"]').val();
        var action = "duplicate_gep_resources";
        $('#loading-dialog').show();
        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: 
                {                   
                    token           : token,                   
                    action          : action
                },
                success: function(data)
                {
                    try
                    {
                        if (data.output)
                        {                
                            $('#loading-dialog').hide();
                            window.location.reload();
                        }
                    }
                    catch (e)
                    {
                        alert("Something went wrong.");
                        $('#loading-dialog').hide();
                    }
                 }   

            });

        });


    if ($("#type").length && $("#country_id").length && $("#region_id").length && $("#state_id").length)
    {
        if ($("#country_id").length)
        {
            $("#country_id").select2({
                placeholder: '--select--'
            });
        }

        if ($("#state_id").length)
        {
            $("#state_id").select2({
                placeholder: '--select--'
            });
        }

        if ($("#region_id").length)
        {
            $("#region_id").select2({
                placeholder: '--select--'
            });
        }

        // Remove 'Type' as an option for facilities
        // $("#type").on('change', function(){

        //     if ($("#type option:selected").val() == "regional")
        //     {
        //         $("#region_id").parent().parent().show();
        //         $("#country_id").parent().parent().hide();
        //         $("#state_id").parent().parent().hide();    
        //     }
        //     else if ($("#type option:selected").val() == "country")
        //     {
        //         $("#region_id").parent().parent().hide();
        //         $("#state_id").parent().parent().hide();
        //         $("#country_id").parent().parent().show();                
        //     }
        //     else if ($("#type option:selected").val() == "state")
        //     {
        //         loadStateByCountry();
        //         $("#region_id").parent().parent().hide();
        //         $("#state_id").parent().parent().show();
        //         $("#country_id").parent().parent().show();
        //     }
        // });        

        // $('#type').val($("#type option:selected").val()).change();

        $("#country_id").on('change', function(){
            // if ($("#type option:selected").val() == "state")
            // {
                loadStateByCountry();
            // }            
        });
    }

    $("#country_code").on('change', function(){
        loadStateByCountryCode();
    });

    $("#home_resort_id").on('change', function(){
        var home_resort_id = this.value;
        if (home_resort_id == 6) {
            $("#div_please_specify").css("display", "block");
        } else {
            $("#div_please_specify").css("display", "none");
        }        
    });

    $('#btn-cms-send-push').on('click', function() {

        var message         = $("#message-push-notify").val();
        var token           = $("input[name=token]").val();
        var action          = "bulk_push_notifications";  
        var interventionId  = $("#intervention_id").val();

        console.log('sending');

        cmsLoadingStatus = true;
        loadOverlay();
        
        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: {                   
                    token           : token,                   
                    action          : action,
                    content         : message,
                    intervention_id : interventionId
                },
                success: function (data)
                {
                    console.log('Message Sent');
                    $("#message-push-notify").val('');
                }

            }).fail(function(jqXHR, textStatus, errorThrown) {
                console.log(textStatus + ': ' + errorThrown);
                
            }).always( function() {
                console.log('finished');
                cmsLoadingStatus = false;
            });  
    });

    var headerAlertCount = 0;
    var academyId = getParameterByName('academy');

    if (academyId != 8)
    {        
        var token   = $("input[name=token]").val();
        var action  = "get_user_transcript_notification";  
        $.ajax({
                url:      '../api/v1/transcript.php',
                dataType: "json",
                type:     "post",                       
                data: {                   
                    ptToken         : token,                   
                    action          : action
                   
                },
                success: function (data)
                {
                    var val = 0;
                    //console.log(data);
                    if(data.output > 0) 
                    {
                        val = data.output;
                    } 
                    $('#btn-transcript-global .badge').text(val);

                    headerAlertCount += parseInt(val);
                }

            });  
        
    }

    if (academyId != 8)
    {
        var token   = $("input[name=token]").val();
        var action  = "get_user_messages_notification"; 

        // if (navigator.online == true)
        // {
             $.ajax({
                url:      '../api/v1/course.php',
                dataType: "json",
                type:     "post",                       
                data: {                   
                    ptToken         : token,                   
                    action          : action
                   
                },
                success: function (data)
                {
                    let val = 0;
                    //console.log(data);
                    if(data.output > 0) 
                    {
                        val = data.output;
                    } 
                    $('#btn-message-global .badge').text(val);

                    headerAlertCount += parseInt(val);

                    renderAddHeaderAlertCount(headerAlertCount);
                }

            }); 
        // }
    }

    var token   = $("input[name=token]").val();
    var action  = "create_user_page_view_row"; 
    var queryString = window.location.search;
    queryString = queryString.substring(1);
    var viewParam = getParameterByName('view');
    var pageParam = getParameterByName('page');

    if ((viewParam != "cms") && (viewParam != "user_management") && (viewParam != "administration") && (viewParam != "courses"))
    {
        $.ajax({
            url : '../api/v1/user.php',
            dataType: "json",
            type    :"post",  
            data: {
                action  : action,            
                ptToken : token,
                query_string: queryString
            },
            success: function (data) 
            {
                //Do Something  
            },
            error: function ()
            {
                //console.log("Error while logging page view");
            }
        });
    }

    function renderAddHeaderAlertCount(headerAlertCount) {
        if (headerAlertCount === 0) return;

        $('#profile-alert-count').text(headerAlertCount);

    }   

    $('body').on('click', '.remove-soft-delete-user', function(){
        var confirmation = confirm("Are you sure you want to archive this user from ITF Academy?");
        if(confirmation == true)
        {
            cmsLoadingStatus = true;
            loadOverlay();

            var userId = $(this).attr('user-id');
            var token  = $("input[name=token]").val();
            var action = "remove_soft_delete_user";   

            $.ajax({
                    url     : '../content/ajax_itf_common.php',
                    dataType: "json",
                    type    :"post",                       
                    data: {                   
                        token           : token,                   
                        action          : action,
                        user_id         : userId
                    },
                    success: function (data)
                    {
                        cmsLoadingStatus = false;
                        reload_registered_users_table()
                    }
            }); 
        }
    }); 

    if ((urlViewVal == 'cms') && (urlPageVal == 'user_analytics'))
    {
        if ($("#registration_tbl").is(":visible"))
        {
            cmsLoadingStatus = true;
            loadOverlay();
            $("#registration_tbl").dataTable({
                "ajax": "../content/ajax_itf_common.php?action=read_user_registered&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
                "deferRender" : true,
                "pageLength": 10,
                responsive: true,              
                 dom: 'Bfrtip',
                 buttons: [
                    { extend: 'excel', className: 'btn-primary' },
                    { 
                        extend: 'pdfHtml5', 
                        className: 'btn-dataTable', 
                        orientation: 'landscape',   
                        pageSize: 'LEGAL',
                        exportOptions: 
                        {
                            columns: [ 0, 1, 2, 3, 4, 5, 6 ]
                        }
                    }            
                ],
                "initComplete" : function(){
                    cmsLoadingStatus = false;
                    $('[data-toggle="tooltip"]').tooltip({
                        trigger: 'hover'
                    });
                }
            });
        }
    }

    $( ".workbook_section_image_remove").on("click", function() {
        var docid = $(this).attr("docId");
        var docRowId = "#text_doc_" + docid;
        var token = $('input[name="token"]').val();
        var decision =  confirm('Are you sure you want to delete this?');
        if (decision)
        {
            //Sent an ajax to remove from table
            var action = "remove_section_image";
            $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type    :"post",         
                data: {
                    docId              : docid,
                    token              : token,                    
                    action             : action
                },                
                success: function(data)
                {
                    try
                    {
                        if (data.output != "")
                        {
                            $(docRowId).remove();
                        }
                    }
                    catch (e)
                    {
                        alert("Something went wrong.");
                    }
                }
            });
        }
    });

    $('#btn-generate-report-lrs').on('click', function(){
        var reportType = $("#inputLrsReport").val();
        var token = $('input[name="token"]').val();
        var action = "generate_report";
        $.ajax({
            url: '../content/ajax_lrs_common.php',
            dataType: "json",
            type    :"post",         
            data: {
                reportType         : reportType,
                token              : token,                    
                action             : action
            },                
            success: function(data)
            {
               // console.log(data.output);
                $('#lrs_report_view').html(data.output); 
                if (reportType == "statement_report")
                {
                    $('#statement_rpt_tbl').DataTable();
                }
                else if (reportType == "search_report")
                {
                    $('#search_rpt_tbl').DataTable();
                    $('#search_course_rpt_tbl').DataTable();
                }
            }
        });
   
    });

    $('#btn-select-change-gep').on('click', function()
    {
        var interventionId = $('#gep-programme').val();
        var token       = $('input[name="token"]').val();
        var action      = "create_user_intervention";
        var academy     = $('input[name="academy"]').val();
        $.ajax({
            url: '../content/ajax_gep_common.php',
            dataType: "json",
            type    :"post",         
            data: {
                action              : action,
                token               : token,                    
                interventionId       : interventionId
            },                
            success: function(data)
            {                
               location.href = '?view=cms&render=gep&academy='+academy+'&page=activity_venues&intervention_id='+interventionId;
            }
        });

    });

    $('.related-activities-central').on('select2:select', function (e) {    
        var data                = e.params.data;
        var userRoleId          = $(this).attr('user_role_id');
        var roleId              = $(this).attr('role_id');
        var userId              = $(this).attr('user_id');
        var interventionId        = data.id;
        var token               = $('input[name="token"]').val();    
        var action              = "add_role_central_admin"; 
        cmsLoadingStatus = true;
        loadOverlay();
        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: {                   
                    token           : token,                   
                    action          : action,
                    user_id         : userId,
                    intervention_id   : interventionId,
                    user_role_id    : userRoleId,
                    role_id         : roleId
                    
                },
                success: function(data)
                {                     
                   cmsLoadingStatus = false;
                }

            });          
       
    });
    
    $('.related-activities-central').on('select2:unselect', function (e) {
        var data                = e.params.data;
        var userRoleId          = $(this).attr('user_role_id');
        var roleId              = $(this).attr('role_id');
        var userId              = $(this).attr('user_id');
        var interventionId        = data.id;
        var token               = $('input[name="token"]').val();   
        var action              = "remove_role_central_admin"; 
        cmsLoadingStatus = true;
        loadOverlay();
        $.ajax({
                url: '../content/ajax_gep_common.php',
                dataType: "json",
                type:"post",                       
                data: {                   
                    token           : token,                   
                    action          : action,
                    user_id         : userId,
                    intervention_id : interventionId,
                    user_role_id    : userRoleId,
                    role_id         : roleId
                    
                },
                success: function(data)
                {                     
                   cmsLoadingStatus = false;
                }

            });  
        
    });

    if (("#themes_tbl_cms").length)
    {
        $("#themes_tbl_cms").DataTable({
            "pageLength": 10
        });
    }

    if (("#sub_themes_tbl_cms").length)
    {
        $("#sub_themes_tbl_cms").DataTable({
            "pageLength": 10
        });
    }

    if (("#player_level_tbl_cms").length)
    {
        $("#player_level_tbl_cms").DataTable({
            "pageLength": 10
        });
    }

    if (("#player_questions_cms").length)
    {
        $("#player_questions_cms").DataTable({
            "pageLength": 10
        });
    }

    $('#btn-add-theme-row-cb').on('click', function(e){
        e.preventDefault();
    })
    
    $("#comm_form").submit(function(){     
        var amount = $("#amount").val();
        var toFixed = parseFloat(amount).toFixed(2);      
        $("#amount").attr("value" ,toFixed );
    });

    var ccExpir = {
        month: '',
        year: ''
    }

    $('#exp-month').on('change', function() {

        var val = $(this).val();

        ccExpir.month = val;

        $('input[name="exp"]').val(ccExpir.month + ccExpir.year);

    });


    $('#exp-year').on('keyup', function() {

        var val = $(this).val();

        ccExpir.year = val;

        $('input[name="exp"]').val(ccExpir.month + ccExpir.year);
    });
    
    if ($("#comm_form").length)
    {
        $('.cc-parsley-validate').parsley({
            successClass: "has-success has-feedback",
            errorClass: "has-error has-feedback",
            classHandler: function(el) {

              var type = el.$element.attr('type');
              var className = (type == 'radio') ? ".radio-group" : '.form-group';

              return el.$element.closest(className);

            },
            errorsWrapper: "<span class='form-feedback'></span>",
            errorTemplate: "<span></span>"
        });
    }


    $('body').on('click', '.view_profile_button', function() {
        var userId      = $(this).attr('data-id');
        var action      = "read_my_info";
        var newModal    = Object.create(renderModalPrototype);
        console.log('Clicked ' + userId);
        $.ajax({
                url:      '../api/v1/user.php',
                dataType: "json",
                type:     "post",                       
                data: {                   
                    ptToken         : token,                   
                    action          : action,
                    userId          : userId
                   
                },
                success: function (data)
                {
                    
                    if (data.output) 
                    {
                        newModal.title = "User Profile";
                        newModal.body  = data.output;
                        newModal.renderModal();
                    } 
                    else 
                    {
                        $('#btn-message-global span').html('');
                    }   
                }

     }); 

    });


    if ($('#academy_plans_table').length)
    {
       read_academy_subscriptions_table();
    }


    $('body').on('click', '.view_presenter_button', function() {
        var userId      = $(this).attr('data-id');
        var action      = "read_presenter_info";
        var newModal    = Object.create(renderModalPrototype);
        console.log('Clicked ' + userId);
        $.ajax({
                url:      '../api/v1/user.php',
                dataType: "json",
                type:     "post",                       
                data: {                   
                    ptToken         : token,                   
                    action          : action,
                    userId          : userId
                   
                },
                success: function (data)
                {
                    
                    if (data.output) 
                    {
                        newModal.title = "User Profile";
                        newModal.body  = data.output;
                        newModal.renderModal();
                    } 
                    else 
                    {
                        $('#btn-message-global span').html('');
                    }   
                }

     }); 

    });

    $("#login-itf-user-btn").on('click', function(){
        var email = $("#itf-login-email").val().trim().toLowerCase();
        var token = $("input[name=token]").val();

        var url = new URL(window.location.href);
        var registerValue = url.searchParams.get("register"); //Needed to check new NA survey flow

        $.ajax({
            url:      '/validate_itf_fast_track_user.php',
            dataType: "json",
            type:     "post",                       
            data: {                   
                ptToken         : token, 
                email           : email,
                registerValue: registerValue                   
            },
            success: function (data)
            {                    
                if (data.redirect_url) 
                {
                    if (data.redirect_url == "self")
                    {
                        if (!$("#itf-pass-wrapper").is(":visible"))
                        {
                            $("#itf-login-err").hide();
                            $("#itf-forgot-pwd-link").slideDown();
                            $("#itf-pass-wrapper").slideDown();
                        }
                        else if ($("#itf-pass").val().trim() != "")
                        {                                
                            $("#myform").submit();
                        }
                    }
                    else
                    {
                        window.location.href = data.redirect_url;
                    }
                } 
                else
                {
                    alert(data.error);
                }                       
            }

        });        
    });

    /*ITF FAQ Page*/
    $(".faq-menu-item").on('click', function(){
        var dataValue = $(this).attr('data-value');

        $(".faq-item-body-wrapper").each(function(){
            if ($(this).attr('data-value') == dataValue)
            {
                $(this).slideToggle(500);
            }
        })
    });

    if ($('#sub_academy_member_table').length)
    {
        $('#sub_academy_member_table').DataTable();
    }
    
    if ($('[data-toggle="popover"]').length)
    {
        $('[data-toggle="popover"]').popover();

        $('[data-toggle="popover"]').on('click', function (e) {
            $('[data-toggle="popover"]').not(this).popover('hide');
        });
    }

    $('#comm_form').submit(function(){
        cmsLoadingStatus = true;
        loadOverlay();
    });

    if ($('#academy-elearning-dashboard').length) {       
        if ($(window).width() < 1444) { 
            calculateMobileHeightF2F();
        } else {
            calculateHeightF2F();
        }
    }

    if ($("#registrationForm").length) {
        if ($(window).width() <= 768) { 
            adjustFooterCss();
        }
    }

    /*Na survey functions and listeners*/
    $('.survey-distribution-main-wrapper #na-admin-approval-modal').on('show.bs.modal', function (event) {
        var span = $(event.relatedTarget) // span that triggered the modal
        var surveyCountryId = span.attr('data-survey-country-id'); // Extract info from data-* attributes
        var countryName = span.attr('data-country-name'); // Extract info from data-* attributes
        var userEmailId = span.attr('data-email-id'); // Extract info from data-* attributes
        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
        var modal = $(this);
        modal.find('.user-email-id').text(userEmailId);
        modal.find('.country-name').text(countryName);
        var userId = span.attr('data-user-id');
        var action  = "approve_na_roles_for_country";
        var token   = $("input[name=token]").val();
        $("#approve-na-admin-btn").on('click', function(){

            $.ajax({
                    url: '../content/ajax_itf_common.php',
                    dataType: "json",
                    data: {
                        action  : action,
                        token   : token,
                        country_id : surveyCountryId,
                        user_id: userId
                    },
                    success: function(data)
                    {            
                        setTimeout(function(){
                            cmsLoadingStatus = false;
                            $('#na-admin-approval-modal').modal('hide');
                        }, 2000);

                       location.reload();
                    }
                });
            
        });
    });

    $('.na-survey-main-wrapper #start_resume_survey').on('click', function(){
        $(".pre-survey-questions-wrapper").slideToggle();
    });

    $("#pre-survey-save-confirm-btn").on('click', function(){
        var surveyId = $("#submit_pre_survey").data('survey-id');
        $('#pre-survey-save-modal').modal('hide');
        savePreSurveyQuestionnaireResponse(surveyId);
    });

    $("#go-to-survey").on('click', function(){
        $("#presurvey-container").hide();
        $("#main-survey-container").slideDown();
    });

    $("#view-presurvey-area").on('click', function(){
        $("#presurvey-container").slideDown(300);
        $("#main-survey-container").hide();
    });

    $(".expand-definition-btn").on("click", function(){        
        var elemClass = ".definition-guidance-" + $(this).data("survey-section-question-id"); 
        console.log(elemClass);
        $(elemClass).slideToggle(300);
    });

    $(".survey-expand-btn").on('click', function(){
        var targetdivId = "#" + $(this).data("target");
        $(targetdivId).slideToggle(300);
        $(this).hide();
        $(this).next().show();

        var playersQuestionInputIdWithReasonTierTwo = "1*_*Tier_2*_*Gender breakdown*_*Female";
        if ($('[id="' + playersQuestionInputIdWithReasonTierTwo + '"]').is(":visible"))
        {
            $('[id="' + playersQuestionInputIdWithReasonTierTwo + '"]').trigger('keyup');           
        }

        var coachesQuestionInputIdWithReasonTierTwo = "8*_*Tier_2*_*Gender breakdown*_*Female";
        if ($('[id="' + coachesQuestionInputIdWithReasonTierTwo + '"]').is(":visible"))
        {
            $('[id="' + coachesQuestionInputIdWithReasonTierTwo + '"]').trigger('keyup');           
        }

    });

    $(".survey-collapse-btn").on('click', function(){
        var targetdivId = "#" + $(this).data("target");
        $(targetdivId).slideToggle(300);
        $(this).hide();
        $(this).prev().show();
    });

    var formModified = false;   

    $(".question-expand-btn").on('click', function(){       
        var targetdivId = "#" + $(this).data("target");
       
        //Is expanded but trying to collapse
        if ($(targetdivId).is(":visible"))
        {
            if (formModified)
            {
                var confirmation = confirm('You have unsaved changes. Are you sure you want to close this question?', 'Yes', 'Cancel');
                if (confirmation) {
                    //Do nothing, it will automatically call toggleSurveyQuestionVisibility below.
                    formModified = false;
                }
                else
                {
                    return;
                }
            }
        }
        else
        {
        //Is collapsed but trying to expand  
            if (!formModified)
            {         
                $(targetdivId + ' form input,' + targetdivId + ' form select,'+ targetdivId + ' textarea').on('input', function() {                          
                    formModified = true;
                });
            }
        }        

        toggleSurveyQuestionVisibility(targetdivId); 
        triggerKeyUpEventForQuestionsWithReasons();
        triggerChangeEventForSpecificItems();

    });   

    /*Check for unsaved changes*/
    $(window).on('beforeunload', function() {  
        if (formModified) {                     
            return 'You have unsaved changes. Are you sure you want to leave?';
        }
    });

    $(".breakdown-checkbox").on('change', function(){  
        var targetId = "#" + $(this).data("target");        

        if ($(this).is(":checked"))
        {
            $(targetId).addClass("disabled");
            $(targetId + " input").each(function(){                
                $(this).attr('disabled', 'disabled');
                $(this).removeAttr('required');
            });

            $(targetId + " select").each(function(){
                $(this).attr('disabled', 'disabled');
                $(this).removeAttr('required');                          
            });
        }
        else
        { 
            $(targetId).removeClass("disabled");
            $(targetId + " input").each(function(){
                if ((!$(this).hasClass('sub-total')) && (!$(this).hasClass('other-specify-input-box')))
                {
                    $(this).removeAttr('disabled');

                    if ($(this).attr('type') === "checkbox")
                    {
                        //Do Nothing
                    }
                    else
                    {
                        $(this).attr('required', 'required');
                    }
                }
            }); 

            $(targetId + " select").each(function(){
                $(this).removeAttr('disabled');
                $(this).attr('required', 'required');
            });
        }        
    });

    $(".remove-evidence-document").on('click', function(){
        var docId = $(this).attr('id').split("-")[3];
        var targetId = "#" + "evidence-document-" + docId;
        $(targetId).remove();
    });

    function createUploadSurveyEvidence(surveySectionQuestionId, surveyId, fileInput, fileNameDisplay, linkUrl) {
        return function uploadSurveyEvidence() {
            var token = $("input[name=token]").val();  
            cmsLoadingStatus = true;
            loadOverlay();

            var countryId = getParameterByName('country_id'); //Will be present if admin is viewing it  
            var formData = new FormData();   
            formData.append('token', token);  
            formData.append('surveySectionQuestionId', surveySectionQuestionId);
            formData.append('surveyId', surveyId);
            formData.append('action', "upload_survey_question_data_source_evidence");
            formData.append('countryId', countryId);  

            if ($(".link-type").is(":visible"))
            {
                //Link Type                
                formData.append('linkUrl', linkUrl.value);
            }
            else
            {
                //Upload type
                for (var i = 0; i < fileInput.files.length; i++) 
                {                
                    formData.append('files[]', fileInput.files[i]);                
                }
            }

            $.ajax({
                url: '../content/ajax_itf_common.php',
                type: "POST",
                data: formData,
                contentType: false,
                cache: false,
                processData: false,  
                success: function(data) {
                    cmsLoadingStatus = false;

                    if (data.errorMessage) 
                    {                    
                        //console.log('Error: ', data.errorMessage);
                    } 
                    else 
                    { 
                        for (var i = 0; i < data.output.length; i++) 
                        {
                            $("#evidence-uploaded-files-" + surveySectionQuestionId).append("<div class='border-bottom border-light d-inline-block' data-upload-type='"+data.output[i].upload_type+"' id='evidence-document-"+data.output[i].document_id+"'><p class='mr-1 mt-2 d-inline-block evidence-para'>"+data.output[i].filename_original+"</p><span id='remove-evidence-document-"+data.output[i].document_id+"' class='remove-evidence-document p-2 mr-4'><i class='fa fa-times'></i></span></div>");
                        }

                        $(".remove-evidence-document").on('click', function(){
                            var docId = $(this).attr('id').split("-")[3];
                            var targetId = "#" + "evidence-document-" + docId;
                            $(targetId).remove();
                        });

                        $('#data-source-evidence-modal').modal('hide');
                        
                        fileInput.value = '';
                        fileNameDisplay.value = '';
                        linkUrl.value = ''
                    }
                },
                error: function(xhr, status, error) 
                {
                    cmsLoadingStatus = false;                 
                    console.log('AJAX error:', error);
                }
            });
        };
    }

    $('#data-source-evidence-modal').on('show.bs.modal', function (event) {
        var btn = $(event.relatedTarget)
        var surveySectionQuestionId = btn.attr('data-survey-section-question-id');
        var dataQuestionNum = btn.attr('data-question-num');
        var surveyId = btn.attr('data-survey-id');

        var fileInput = document.getElementById('cms-file-evidence');
        var fileNameDisplay = document.getElementById('file-name-display');
        var linkUrl = document.getElementById("docs-url");       
       
        var modal = $(this);
        modal.find('.ques-num').text("Question " + dataQuestionNum);

        function handleChange(file) 
        {
            var files = fileInput.files;
            var fileNames = [];
            for (var i = 0; i < files.length; i++) {
            fileNames.push(files[i].name);
            }
            fileNameDisplay.value = fileNames.join(', ');
        }

        fileInput.removeEventListener('change', handleChange);
        fileInput.addEventListener('change', handleChange);
        
        $(document).on('change', 'input[name="evidence-upload"]', function() {

            var evidenceType = $(this).val();
            var evidenceAddonUI;            

            if (evidenceType == 'link') 
            {
                fileInput.value = '';
                fileNameDisplay.value = '';
                $(".evidence-wrapper .upload-type").hide();
                $(".evidence-wrapper .link-type").show();
            } 
            else 
            {
                linkUrl.value = '';
                $(".evidence-wrapper .upload-type").show();
                $(".evidence-wrapper .link-type").hide();
            }
        }); 

        var evidenceConfirmBtn = document.getElementById('evidence-confirm-btn');
        evidenceConfirmBtn.removeEventListener('click', evidenceConfirmBtn.uploadSurveyEvidence);

        // Create a new instance of uploadSurveyEvidence with the current data and bind it to the button
        evidenceConfirmBtn.uploadSurveyEvidence = createUploadSurveyEvidence(surveySectionQuestionId, surveyId, fileInput, fileNameDisplay, linkUrl);

        // Add the new event listener
        evidenceConfirmBtn.addEventListener('click', evidenceConfirmBtn.uploadSurveyEvidence);

    });

    $(".remove-section-sub-admin").on('click', function(){
        var sectionUserId = $(this).attr('id').split("-")[3];
        var surveyId = $(this).data('survey-id');
        var surveySectionId = $(this).data('survey-section-id');
        var targetId = "#" + "section-admin-row-" + sectionUserId;                                                              
        removeSectionSubAdmin(sectionUserId, targetId, surveyId, surveySectionId);
    });

    /*Custom checkboxes and radios*/ 
    function handleCustomRadioChange(radioName, checkboxId, dataSourceId=null) 
    {
        $('[name="' + radioName + '"]').change(function () {
            if ($(this).val() == "No") 
            {
                if (checkboxId != null)
                {
                    $('[id="' + checkboxId + '"]').prop("checked", true).trigger("change").hide();
                    var labelElement = $('label[for="' + checkboxId + '"]'); 
                    labelElement.addClass('disabled-label');  
                }
                
                if (dataSourceId != null)
                {
                    $("#"+dataSourceId+" #survey-data-source").addClass('disabled');
                    $("#"+dataSourceId+" input").each(function(){
                        $(this).attr('disabled', 'disabled');
                        $(this).removeAttr('required');
                    });  
                }
            } 
            else 
            {
                if (checkboxId != null)
                {
                    $('[id="' + checkboxId + '"]').prop("checked", false).trigger("change").show();
                    var labelElement = $('label[for="' + checkboxId + '"]'); 
                    labelElement.removeClass('disabled-label');  
                }

                if (dataSourceId != null)
                {
                    $("#"+dataSourceId+" #survey-data-source").removeClass('disabled');
                    $("#"+dataSourceId+" input").each(function(){
                        $(this).attr('disabled', false);
                        $(this).attr('required', true);
                    });
                }
            }
        });
    }
    
    handleCustomRadioChange("7*_*Tier_1*_*a) Response", "7*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("14*_*Tier_1*_*a) Response", "14*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("17*_*Tier_1*_*a) Response", "17*_*i_do_not_have_this_breakdown_information_Tier_2", 'survey-data-source-wrapper-9');
    handleCustomRadioChange("29*_*Tier_1*_*a) Response", "29*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("30*_*Tier_1*_*a) Response", null, "survey-data-source-wrapper-4");
    handleCustomRadioChange("31*_*Tier_1*_*a) Response", null, "survey-data-source-wrapper-5");
    handleCustomRadioChange("45*_*Tier_1*_*a) Response", "45*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("49*_*Tier_1*_*a) Response", "49*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("50*_*Tier_1*_*a) Response", "50*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("57*_*Tier_1*_*a) Response", "57*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("60*_*Tier_1*_*a) Response", "60*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("61*_*Tier_1*_*a) Response", "61*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("62*_*Tier_1*_*a) Response", "62*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("63*_*Tier_1*_*a) Response", "63*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("75*_*Tier_1*_*a) Response", "75*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("76*_*Tier_1*_*a) Response", "76*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("79*_*Tier_1*_*a) Response", "79*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("80*_*Tier_1*_*a) Response", "80*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("84*_*Tier_1*_*a) Response", "84*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("85*_*Tier_1*_*a) Response", "85*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("91*_*Tier_1*_*a) Response", "91*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("92*_*Tier_1*_*a) Response", "92*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("98*_*Tier_1*_*a) Response", "98*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("100*_*Tier_1*_*a) Response", "100*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("102*_*Tier_1*_*a) Response", "102*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("113*_*Tier_1*_*a) Response", "113*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("114*_*Tier_1*_*a) Response", "114*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("115*_*Tier_1*_*a) Response", "115*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("116*_*Tier_1*_*a) Response", "116*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("117*_*Tier_1*_*a) Response", "117*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("118*_*Tier_1*_*a) Response", "118*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("119*_*Tier_1*_*a) Response", "119*_*i_do_not_have_this_breakdown_information_Tier_2");
    handleCustomRadioChange("120*_*Tier_1*_*a) Response", "120*_*i_do_not_have_this_breakdown_information_Tier_2");


    $('[id="1*_*i_do_not_have_this_breakdown_information_Tier_2"]').change(function(){
        if ($(this).is(":checked"))
        {
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-info"]').find(':input').prop('disabled', true);;            
        }
        else
        {
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-info"]').find(':input').prop('disabled', false);;  
        }
    });

    $('[id="8*_*i_do_not_have_this_breakdown_information_Tier_2"]').change(function(){
        if ($(this).is(":checked"))
        {
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-info"]').find(':input').prop('disabled', true);;            
        }
        else
        {
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-info"]').find(':input').prop('disabled', false);;  
        }
    });

    $('[id="53*_*i_do_not_have_this_breakdown_information_Tier_2"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="53*_*i_do_not_have_this_breakdown_information_Tier_3"]').attr("checked", true);
            $('[id="53*_*i_do_not_have_this_breakdown_information_Tier_3"]').hide();
            $('[id="53*_*i_do_not_have_this_breakdown_information_Tier_3"]').trigger("change");
            var labelElement = $('label[for="53*_*i_do_not_have_this_breakdown_information_Tier_3"]'); 
            labelElement.addClass('disabled-label');
        }
        else
        {
            $('[id="53*_*i_do_not_have_this_breakdown_information_Tier_3"]').attr("checked", false);
            $('[id="53*_*i_do_not_have_this_breakdown_information_Tier_3"]').trigger("change");
            $('[id="53*_*i_do_not_have_this_breakdown_information_Tier_3"]').show();
            var labelElement = $('label[for="53*_*i_do_not_have_this_breakdown_information_Tier_3"]'); 
            labelElement.removeClass('disabled-label');
        }
    });


    /*6-FIN-GEN-3*/
    $('[name="40*_*Tier_1*_*a) Response"]').change(function () {
        var labelElement1 = $('label[for="40*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        var labelElement2 = $('label[for="40*_*i_do_not_have_this_breakdown_information_Tier_3"]');

        if ($(this).val() == "Do not wish to disclose") 
        {
            $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_2"]').prop("checked", true).trigger("change").hide();
            $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_3"]').prop("checked", true).trigger("change").hide();             
            labelElement1.addClass('disabled-label');
            labelElement2.addClass('disabled-label');
        } 
        else if ($(this).val() == "Annual revenue total range (USD only)")
        {
            $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_2"]').prop("checked", true).trigger("change").hide();
            $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_3"]').prop("checked", false).trigger("change").show();
            labelElement1.addClass('disabled-label');
            labelElement2.removeClass('disabled-label');
        }
        else if ($(this).val() == "Annual revenue total")
        {
            $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_2"]').prop("checked", false).trigger("change").show();
            $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_3"]').prop("checked", true).trigger("change").hide();            
            labelElement1.removeClass('disabled-label');
            labelElement2.addClass('disabled-label');
        }
        else
        {
            $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_2"]').prop("checked", false).trigger("change").show();
            $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_3"]').prop("checked", false).trigger("change").show();
            labelElement1.removeClass('disabled-label');
            labelElement2.removeClass('disabled-label');
        }
    });

    /*3-DEL-OTH-12*/
    var survey3_DEL_OTH_12_CustomCheckboxId = "19*_*Tier_1*_*a) None*_* ";
    $('[id="' + survey3_DEL_OTH_12_CustomCheckboxId + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="19*_*Tier_1*_*b) Parents or Guardians*_* "]').prop('disabled', true).prop('checked', false);
            $('[id="19*_*Tier_1*_*c) Managers and / or Administrators *_* "]').prop('disabled', true).prop('checked', false);
            $('[id="19*_*Tier_1*_*d) Volunteers*_* "]').prop('disabled', true).prop('checked', false);
            $('[id="19*_*Tier_1*_*e) Players*_* "]').prop('disabled', true).prop('checked', false);
            $('[id="19*_*Tier_1*_*f) Other (please state)*_* "]').prop('disabled', true).prop('checked', false);
            $('[id="19*_*Tier_1*_*f) Other (please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
            $('[id="19*_*Tier_1*_*f) Other (please state)*_*other-specify-text_other_please_state_text"]').hide(); 
        }
        else
        {
            $('[id="19*_*Tier_1*_*b) Parents or Guardians*_* "]').prop('disabled', false);
            $('[id="19*_*Tier_1*_*c) Managers and / or Administrators *_* "]').prop('disabled', false);
            $('[id="19*_*Tier_1*_*d) Volunteers*_* "]').prop('disabled', false);
            $('[id="19*_*Tier_1*_*e) Players*_* "]').prop('disabled', false);
            $('[id="19*_*Tier_1*_*f) Other (please state)*_* "]').prop('disabled', false);

            if ($('[id="19*_*Tier_1*_*f) Other (please state)*_* "]').is(':checked'))
            {
                $('[id="19*_*Tier_1*_*f) Other (please state)*_*other-specify-text_other_please_state_text"]').show(); 
                $('[id="19*_*Tier_1*_*f) Other (please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);
            }
        }
    }); 

    var survey6_FIN_GEN_6_CustomCheckboxId = "43*_*Tier_1*_*g) No membership categories in place*_* ";
    $('[id="' + survey6_FIN_GEN_6_CustomCheckboxId + '"]').change(function() {
        var labelElement1 = $('label[for="43*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        var labelElement2 = $('label[for="43*_*i_do_not_have_this_breakdown_information_Tier_3"]');

        if ($(this).is(":checked"))
        {
            $('[id="43*_*i_do_not_have_this_breakdown_information_Tier_2"]').prop("checked", true).trigger("change").hide();
            $('[id="43*_*i_do_not_have_this_breakdown_information_Tier_3"]').prop("checked", true).trigger("change").hide();
            labelElement1.addClass('disabled-label');
            labelElement2.addClass('disabled-label');
        }
        else
        {
            $('[id="43*_*i_do_not_have_this_breakdown_information_Tier_2"]').prop("checked", false).trigger("change").show();
            $('[id="43*_*i_do_not_have_this_breakdown_information_Tier_3"]').prop("checked", false).trigger("change").show();
            labelElement1.removeClass('disabled-label');
            labelElement2.removeClass('disabled-label');
        }
    });  

    /*Handle Other text box*/
    $('[id="19*_*Tier_1*_*f) Other (please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="19*_*Tier_1*_*f) Other (please state)*_*other-specify-text_other_please_state_text"]').show();   
            $('[id="19*_*Tier_1*_*f) Other (please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
            $('[id="19*_*Tier_1*_*f) Other (please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="19*_*Tier_1*_*f) Other (please state)*_*other-specify-text_other_please_state_text"]').hide(); 
            $('[id="19*_*Tier_1*_*f) Other (please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
            $('[id="19*_*Tier_1*_*f) Other (please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
        }
    }); 

    $('[id="41*_*Tier_1*_*e) Other area (Please state)*_*% of Total Income"]').on('change', function(){
        if ($(this).val() != "0%")
        {
            $('[id="41*_*Tier_1*_*e) Other area (Please state)*_*% of Total Income_other_please_state_text"]').show();   
            $('[id="41*_*Tier_1*_*e) Other area (Please state)*_*% of Total Income_other_please_state_text"]').prop('required', true); 
            $('[id="41*_*Tier_1*_*e) Other area (Please state)*_*% of Total Income_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="41*_*Tier_1*_*e) Other area (Please state)*_*% of Total Income_other_please_state_text"]').hide(); 
            $('[id="41*_*Tier_1*_*e) Other area (Please state)*_*% of Total Income_other_please_state_text"]').prop('required', false);
            $('[id="41*_*Tier_1*_*e) Other area (Please state)*_*% of Total Income_other_please_state_text"]').prop('disabled', true);
        }
    }); 

    $('[id="42*_*Tier_1*_*h) Other area (please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="42*_*Tier_1*_*h) Other area (please state)*_*other-specify-text_other_please_state_text"]').show();   
            $('[id="42*_*Tier_1*_*h) Other area (please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
            $('[id="42*_*Tier_1*_*h) Other area (please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="42*_*Tier_1*_*h) Other area (please state)*_*other-specify-text_other_please_state_text"]').hide(); 
            $('[id="42*_*Tier_1*_*h) Other area (please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
            $('[id="42*_*Tier_1*_*h) Other area (please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
        }
    });

    $('[id="43*_*Tier_1*_*e) Other #1 (Please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="43*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').show();   
            $('[id="43*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
            $('[id="43*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="43*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
            $('[id="43*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
            $('[id="43*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
        }
    });   

    $('[id="43*_*Tier_1*_*f) Other #2 (Please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="43*_*Tier_1*_*f) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').show();   
            $('[id="43*_*Tier_1*_*f) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
            $('[id="43*_*Tier_1*_*f) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="43*_*Tier_1*_*f) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
            $('[id="43*_*Tier_1*_*f) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
            $('[id="43*_*Tier_1*_*f) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
        }
    }); 

    $('[id="45*_*Tier_2*_*h) Other (Please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="45*_*Tier_2*_*h) Other (Please state)*_* _other_please_state_text"]').show();   
            $('[id="45*_*Tier_2*_*h) Other (Please state)*_* _other_please_state_text"]').prop('required', true); 
            $('[id="45*_*Tier_2*_*h) Other (Please state)*_* _other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="45*_*Tier_2*_*h) Other (Please state)*_* _other_please_state_text"]').hide(); 
            $('[id="45*_*Tier_2*_*h) Other (Please state)*_* _other_please_state_text"]').prop('required', false);
            $('[id="45*_*Tier_2*_*h) Other (Please state)*_* _other_please_state_text"]').prop('disabled', true);
        }
    });

    $('[id="67*_*Tier_1*_*d) Other (Please state)*_*ITF Website"]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*ITF Website_other_please_state_text"]').show();   
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*ITF Website_other_please_state_text"]').prop('required', true); 
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*ITF Website_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*ITF Website_other_please_state_text"]').hide(); 
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*ITF Website_other_please_state_text"]').prop('required', false);
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*ITF Website_other_please_state_text"]').prop('disabled', true);
        }
    });

    $('[id="67*_*Tier_1*_*d) Other (Please state)*_*Social Media (ie, Facebook, X (formerly Twitter), Instagram, YouTube, LinkedIn, TikTok)"]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*social_media_other_please_state_text"]').show();   
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*social_media_other_please_state_text"]').prop('required', true); 
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*social_media_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*social_media_other_please_state_text"]').hide(); 
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*social_media_other_please_state_text"]').prop('required', false);
            $('[id="67*_*Tier_1*_*d) Other (Please state)*_*social_media_other_please_state_text"]').prop('disabled', true);
        }
    }); 

    $('[id="68*_*Tier_1*_*i) Other (Please state)*_* "]').on('change', function(){
        if (($(this).val() != "") && ($(this).val() != "Not applicable"))
        {
            $('[id="68*_*Tier_1*_*i) Other (Please state)*_* _other_please_state_text"]').show();   
            $('[id="68*_*Tier_1*_*i) Other (Please state)*_* _other_please_state_text"]').prop('required', true); 
            $('[id="68*_*Tier_1*_*i) Other (Please state)*_* _other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="68*_*Tier_1*_*i) Other (Please state)*_* _other_please_state_text"]').hide(); 
            $('[id="68*_*Tier_1*_*i) Other (Please state)*_* _other_please_state_text"]').prop('required', false);
            $('[id="68*_*Tier_1*_*i) Other (Please state)*_* _other_please_state_text"]').prop('disabled', true);
        }
    }); 

    $('[id="94*_*Tier_1*_*v) Other #1 (Please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="94*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').show();   
            $('[id="94*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
            $('[id="94*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="94*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
            $('[id="94*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
            $('[id="94*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
        }
    });

    $('[id="94*_*Tier_1*_*w) Other #2 (Please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="94*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').show();   
            $('[id="94*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
            $('[id="94*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="94*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
            $('[id="94*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
            $('[id="94*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
        }
    }); 

    $('[id="95*_*Tier_1*_*e) Other #1 (Please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="95*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').show();   
            $('[id="95*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
            $('[id="95*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="95*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
            $('[id="95*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
            $('[id="95*_*Tier_1*_*e) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
        }
    }); 

    $('[id="97*_*Tier_1*_*v) Other #1 (Please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="97*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').show();   
            $('[id="97*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
            $('[id="97*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="97*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
            $('[id="97*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
            $('[id="97*_*Tier_1*_*v) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
        }
    });

    $('[id="97*_*Tier_1*_*w) Other #2 (Please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="97*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').show();   
            $('[id="97*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
            $('[id="97*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="97*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
            $('[id="97*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
            $('[id="97*_*Tier_1*_*w) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
        }
    });     

    $('[id="102*_*Tier_2*_*d) Other #1 (Please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="102*_*Tier_2*_*d) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').show();   
            $('[id="102*_*Tier_2*_*d) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
            $('[id="102*_*Tier_2*_*d) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="102*_*Tier_2*_*d) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
            $('[id="102*_*Tier_2*_*d) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
            $('[id="102*_*Tier_2*_*d) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
        }
    }); 

     $('[id="104*_*Tier_1*_*d) Other (Please state)*_* "]').on('change', function(){
        if ($(this).is(":checked"))
        {
            $('[id="104*_*Tier_1*_*d) Other (Please state)*_*other-specify-text_other_please_state_text"]').show();   
            $('[id="104*_*Tier_1*_*d) Other (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
            $('[id="104*_*Tier_1*_*d) Other (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
        }
        else
        {
            $('[id="104*_*Tier_1*_*d) Other (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
            $('[id="104*_*Tier_1*_*d) Other (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
            $('[id="104*_*Tier_1*_*d) Other (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
        }
    });

    var surveyBeachTennisCustomCheckboxId = "88*_*Tier_1*_* No Beach Tennis clubs*_* ";
    var surveyBeachTennisCustomCheckboxTargetId = "88*_*Tier_1*_*Total clubs*_* ";

    $('[id="' + surveyBeachTennisCustomCheckboxId + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="' + surveyBeachTennisCustomCheckboxTargetId + '"]').val("0");
            $('[id="' + surveyBeachTennisCustomCheckboxTargetId + '"]').attr("disabled", true);
        }
        else
        {
            $('[id="' + surveyBeachTennisCustomCheckboxTargetId + '"]').attr("disabled", false);
        }
    });

    var surveyPLY_2_CustomCheckboxId = "2*_*Tier_1*_* No register or database*_* ";
    var surveyPLY_2_CustomCheckboxTargetId = "2*_*Tier_1*_*Total players*_* ";

    $('[id="' + surveyPLY_2_CustomCheckboxId + '"]').change(function() {
        var labelElement1 = $('label[for="2*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        var labelElement2 = $('label[for="2*_*i_do_not_have_this_breakdown_information_Tier_3"]'); 

        if ($(this).is(":checked"))
        {
            $('[id="' + surveyPLY_2_CustomCheckboxTargetId + '"]').val("0");
            $('[id="' + surveyPLY_2_CustomCheckboxTargetId + '"]').attr("disabled", true);
            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
            labelElement1.addClass('disabled-label');


            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_3"]').attr("checked", true);
            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_3"]').hide();
            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_3"]').trigger("change");
            labelElement2.addClass('disabled-label');

            $("#survey-data-source-wrapper-1 #survey-data-source").addClass('disabled');
            $("#survey-data-source-wrapper-1 input").each(function(){
                $(this).attr('disabled', 'disabled');
                $(this).removeAttr('required');
            });            
        }
        else
        {
            $('[id="' + surveyPLY_2_CustomCheckboxTargetId + '"]').attr("disabled", false);
            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", false);
            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_2"]').show();
            labelElement1.removeClass('disabled-label');

            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_3"]').attr("checked", false);
            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_3"]').trigger("change");
            $('[id="2*_*i_do_not_have_this_breakdown_information_Tier_3"]').show();
            labelElement2.removeClass('disabled-label');

            $("#survey-data-source-wrapper-1 #survey-data-source").removeClass('disabled');
            $("#survey-data-source-wrapper-1 input").each(function(){
                $(this).attr('disabled', false);
                $(this).prop('required', true);
            }); 
        }
    });

    var surveyPLY_3_CustomCheckboxId = "3*_*Tier_1*_* No register or database*_* ";
    var surveyPLY_3_CustomCheckboxTargetId = "3*_*Tier_1*_*Total non-players*_* ";

    $('[id="' + surveyPLY_3_CustomCheckboxId + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="' + surveyPLY_3_CustomCheckboxTargetId + '"]').val("0");
            $('[id="' + surveyPLY_3_CustomCheckboxTargetId + '"]').attr("disabled", true);
        }
        else
        {
            $('[id="' + surveyPLY_3_CustomCheckboxTargetId + '"]').attr("disabled", false);
        }
    });

    /*Custom logic for interaction*/
    var gov_gen_6_name = "31*_*Tier_1*_*a) Response";
    $('[name="' + gov_gen_6_name + '"]').change(function() {
        if ($(this).val() == "No")
        {            
            $("#survey-data-source-wrapper-5 #survey-data-source").addClass('disabled');
            $("#survey-data-source-wrapper-5 input").each(function(){
                $(this).attr('disabled', 'disabled');
                $(this).removeAttr('required');
            });
        }
        else
        {            
            $("#survey-data-source-wrapper-5 #survey-data-source").removeClass("disabled");
            $("#survey-data-source-wrapper-5 input").each(function(){
                $(this).removeAttr('disabled');
                $(this).attr('required', 'required');
            }); 
        }
    });

    if ($('[name="' + gov_gen_6_name + '"]').length)
    {
        $('[name="' + gov_gen_6_name + '"]').trigger('change');
    }


    /*Na survey functions and listeners*/
    $('.survey-distribution-main-wrapper #na-admin-approval-section-modal').on('show.bs.modal', function (event) {
        var span = $(event.relatedTarget) // span that triggered the modal
        var surveySectionId = span.attr('data-section-id'); // Extract info from data-* attributes
        var countryId       = span.attr('data-country-id'); // Extract info from data-* attributes
        //var userEmailId = span.attr('data-email-id'); // Extract info from data-* attributes
        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
        var modal = $(this);
        modal.find('#not-approval-reason').css('height', '150px');
        modal.find('#not-approval-reason').prop('disabled', true);
        
       // modal.find('.country-name').text(countryName);
        var userId  = span.attr('data-user-id');
        var action  = "approve_survey_section";
        var token   = $("input[name=token]").val();

        $("#approve-na-admin-section-btn").on('click', function(){

            $.ajax({
                    url: '../content/ajax_itf_common.php',
                    dataType: "json",
                    data: {
                        action          : action,
                        token           : token,
                        surveySectionId : surveySectionId,
                        countryId         : countryId
                    },
                    success: function(data)
                    {            
                        setTimeout(function(){
                            cmsLoadingStatus = false;
                            $('#na-admin-approval-section-modal').modal('hide');
                        }, 2000);

                        
                       location.reload();
                    }
            });
            
        });
    });


    $("#survey-progress-region-select").on('change', function(){
        cmsLoadingStatus = true;
        loadOverlay();

        var selectedRegion = $(this).val().toLowerCase();
        var baseUrl = window.location.origin;            
        var newUrl = `${baseUrl}/?academy=103&page=na_survey_progress&view=itf&survey_id=1&region=${selectedRegion}`;           
        window.location.href = newUrl;
    });

    $("#survey-insights-region-select").on('change', function(){
        cmsLoadingStatus = true;
        loadOverlay();

        var selectedRegion = $(this).val().toLowerCase();
        var baseUrl = window.location.origin;            
        var newUrl = `${baseUrl}/?academy=103&page=na_survey_insights&view=itf&survey_id=1&region=${selectedRegion}`;           
        window.location.href = newUrl;
    });

    if ($("#btn-survey-final-submission").length) {

        var countryId   = $("#btn-survey-final-submission").attr("data-country-id");
        var action      = "check_approved_sections_by_country";
        var token       = $("input[name=token]").val();
        $.ajax({
                    url: '../content/ajax_itf_common.php',
                    dataType: "json",
                    data: {
                        action          : action,
                        token           : token,
                        countryId         : countryId
                    },
                    success: function(data)
                    {            
                       if (data.output == true)
                       {
                        $("#btn-survey-final-submission").removeClass("disabled");
                        $("#btn-survey-final-submission").removeAttr('disabled');
                       }                      
                    }
        });
    }

    /*Na survey functions and listeners*/
    $('.survey-distribution-main-wrapper #na-admin-approval-survey-modal').on('show.bs.modal', function (event) {
        var span = $(event.relatedTarget) // span that triggered the modal
        var surveyId        = span.attr('data-survey-id'); // Extract info from data-* attributes
        var countryId       = span.attr('data-country-id'); // Extract info from data-* attributes        
        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.        
        var action  = "sent_for_final_approve_survey_for_country";
        var token   = $("input[name=token]").val();

        $("#approve-na-admin-survey-btn").on('click', function(){
            cmsLoadingStatus = true;
            loadOverlay();
            $.ajax({
                        url: '../content/ajax_itf_common.php',
                        dataType: "json",
                        data: {
                            action          : action,
                            token           : token,
                            countryId       : countryId,
                            surveyId        : surveyId
                        },
                        success: function(data)
                        {            
                            $("#btn-survey-final-submission").text("Sent For Approval");  
                            $("#btn-survey-final-submission").addClass("disabled"); 
                            $("#btn-survey-final-submission").prop("disabled", true);  
                            $('#na-admin-approval-survey-modal').modal('hide'); 

                            /*Reload the page so that buttons have their listeners reconnected*/
                            setTimeout(function(){      
                                location.reload();  
                            }, 1000);                        
                        }
            });
            
        });
    });

    /*Na survey functions and listeners*/
    $('.survey-distribution-main-wrapper #itf-admin-approval-survey-modal').on('show.bs.modal', function (event) {
        var span = $(event.relatedTarget) // span that triggered the modal
        var surveyId        = span.attr('data-survey-id'); // Extract info from data-* attributes
        var countryId       = span.attr('data-country-id'); // Extract info from data-* attributes
        //var userEmailId = span.attr('data-email-id'); // Extract info from data-* attributes
        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
        var modal = $(this);
        modal.find('#not-approval-submission-reason').css('height', '150px');

       // modal.find('.country-name').text(countryName);
        var userId  = span.attr('data-user-id');
        var action  = "approve_final_survey_itf_admin";
        var token   = $("input[name=token]").val();

        $("#approve-itf-admin-survey-btn").on('click', function(){

            $.ajax({
                    url: '../content/ajax_itf_common.php',
                    dataType: "json",
                    data: {
                        action            : action,
                        token             : token,
                        surveyId          : surveyId,
                        countryId         : countryId,
                        approvalStatus    : "approved"
                    },
                    success: function(data)
                    {            
                        setTimeout(function(){
                            cmsLoadingStatus = false;
                            $('#itf-admin-approval-survey-modal').modal('hide');
                        }, 1000);

                        
                       location.reload();
                    }
            });
            
        });

        $('#not-approve-na-admin-section-btn').on('click', function() {
            $.ajax({
                    url: '../content/ajax_itf_common.php',
                    dataType: "json",
                    data: {
                        action            : action,
                        token             : token,
                        surveyId          : surveyId,
                        countryId         : countryId,
                        approvalStatus    : "un-approved"
                    },
                    success: function(data)
                    {            
                        setTimeout(function(){
                            cmsLoadingStatus = false;
                            $('#itf-admin-approval-survey-modal').modal('hide');
                        }, 1000);

                        
                       location.reload();
                    }
            });
        })
    });

    /*Reload survey progress page for ITF Admin with selected region*/
    $("#survey-progress-all-region-select").on('change', function(){
        cmsLoadingStatus = true;
        loadOverlay();

        var selectedRegion = $(this).val().toLowerCase();
        var baseUrl =  window.location.origin;            
        var newUrl  = `${baseUrl}/?academy=103&page=na_approval&view=itf&survey_id=1&region=${selectedRegion}`;           
        window.location.href = newUrl;
    });

    /*Handle max three checkboxes for data validation reason options*/
    $(".increase-option, .decrease-option, .no-change-option").on('change', function() {         
        var clickedClass =  $(this).hasClass('increase-option') ? 'increase-option' :
                            $(this).hasClass('decrease-option') ? 'decrease-option' :
                            $(this).hasClass('no-change-option') ? 'no-change-option' :
                            'unknown-option'; 
        var data_tier = $(this).attr('data_tier');
        var data_reason_dropdown_id = $(this).attr('data_reason_dropdown_id');
        var maxChecked = 3;        
        var checkedCount = $("." + clickedClass + "[data_reason_dropdown_id='" + data_reason_dropdown_id + "']" + "[data_tier='" + data_tier + "']:checked").length;
  
        if (checkedCount > maxChecked) {
            $(this).attr("checked", false);
            alert("Select maximum of three reasons");
            return false;
        }
    });

    var clubsOtherReasonDecreaseIdStr = "4*_*Tier_1*_*Total clubs*_* -reason-dropdown*_*significant-decrease-reason*_*Other, please state";
    var clubsOtherReasonIncreaseIdStr = "4*_*Tier_1*_*Total clubs*_* -reason-dropdown*_*significant-increase-reason*_*Other, please state";
    var clubsOtherReasonNoChangeIdStr = "4*_*Tier_1*_*Total clubs*_* -reason-dropdown*_*no-change-reason*_*Other, please state";
 
    $('[id="' + clubsOtherReasonDecreaseIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $(".reason-other-text").show();
            $(".reason-other-text").prop('required', true);
            $(".reason-other-text").prop('disabled', false);
        }  
        else
        {
            $(".reason-other-text").hide();
            $(".reason-other-text").prop('required', false);
            $(".reason-other-text").prop('disabled', true);
        }      
    });

    $('[id="' + clubsOtherReasonIncreaseIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $(".reason-other-text").show();
            $(".reason-other-text").prop('required', true);
            $(".reason-other-text").prop('disabled', false);
        }  
        else
        {
            $(".reason-other-text").hide();
            $(".reason-other-text").prop('required', false);
            $(".reason-other-text").prop('disabled', true);
        }      
    });

    $('[id="' + clubsOtherReasonNoChangeIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $(".reason-other-text").show();
            $(".reason-other-text").prop('required', true);
            $(".reason-other-text").prop('disabled', false);
        }  
        else
        {
            $(".reason-other-text").hide();
            $(".reason-other-text").prop('required', false);
            $(".reason-other-text").prop('disabled', true);
        }      
    });

    if ($('[id="' + clubsOtherReasonDecreaseIdStr + '"]').is(":checked"))
    {
        $(".reason-other-text").show();
        $(".reason-other-text").prop('required', true);
        $(".reason-other-text").prop('disabled', false);
    }

    if ($('[id="' + clubsOtherReasonIncreaseIdStr + '"]').is(":checked"))
    {
        $(".reason-other-text").show();
        $(".reason-other-text").prop('required', true);
        $(".reason-other-text").prop('disabled', false);
    }

    if ($('[id="' + clubsOtherReasonNoChangeIdStr + '"]').is(":checked"))
    {
        $(".reason-other-text").show();
        $(".reason-other-text").prop('required', true);
        $(".reason-other-text").prop('disabled', false);
    }

    var playersOtherReasonDecreaseIdStr = "1*_*Tier_1*_*Total players*_* -reason-dropdown*_*significant-decrease-reason*_*Other, please state";
    var playersOtherReasonIncreaseIdStr = "1*_*Tier_1*_*Total players*_* -reason-dropdown*_*significant-increase-reason*_*Other, please state";
    var playersOtherReasonNoChangeIdStr = "1*_*Tier_1*_*Total players*_* -reason-dropdown*_*no-change-reason*_*Other, please state";
 
    $('[id="' + playersOtherReasonDecreaseIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').show();
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('required', true);
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').hide();
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('required', false);
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('disabled', true);
        }      
    });

    $('[id="' + playersOtherReasonIncreaseIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').show();
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('required', true);
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').hide();
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('required', false);
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('disabled', true);
        }      
    });

    $('[id="' + playersOtherReasonNoChangeIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').show();
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('required', true);
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').hide();
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('required', false);
            $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('disabled', true);
        }      
    });

    if ($('[id="' + playersOtherReasonDecreaseIdStr + '"]').is(":checked"))
    {
        $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').show();
        $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('required', true);
        $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('disabled', false);
    }

    if ($('[id="' + playersOtherReasonIncreaseIdStr + '"]').is(":checked"))
    {
        $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').show();
        $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('required', true);
        $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('disabled', false);
    }

    if ($('[id="' + playersOtherReasonNoChangeIdStr + '"]').is(":checked"))
    {
        $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').show();
        $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('required', true);
        $('[id="1*_*Tier_1*_*Total players*_* -reason-other-text"]').prop('disabled', false);
    }

    var playersOtherReasonDecreaseIdStrTier2 = "1*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*significant-decrease-reason*_*Other, please state";
    var playersOtherReasonIncreaseIdStrTier2 = "1*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*significant-increase-reason*_*Other, please state";
    var playersOtherReasonNoChangeIdStrTier2 = "1*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*no-change-reason*_*Other, please state";
 
    $('[id="' + playersOtherReasonDecreaseIdStrTier2 + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').hide();
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', false);
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', true);
        }      
    });

    $('[id="' + playersOtherReasonIncreaseIdStrTier2 + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').hide();
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', false);
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', true);
        }      
    });

    $('[id="' + playersOtherReasonNoChangeIdStrTier2 + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').hide();
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', false);
            $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', true);
        }      
    });

    if ($('[id="' + playersOtherReasonDecreaseIdStrTier2 + '"]').is(":checked"))
    {
        $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
        $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
        $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
    }

    if ($('[id="' + playersOtherReasonIncreaseIdStrTier2 + '"]').is(":checked"))
    {
        $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
        $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
        $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
    }

    if ($('[id="' + playersOtherReasonNoChangeIdStrTier2 + '"]').is(":checked"))
    {
        $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
        $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
        $('[id="1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
    }

    var coachesOtherReasonDecreaseIdStr = "8*_*Tier_1*_*Total coaches*_* -reason-dropdown*_*significant-decrease-reason*_*Other, please state";
    var coachesOtherReasonIncreaseIdStr = "8*_*Tier_1*_*Total coaches*_* -reason-dropdown*_*significant-increase-reason*_*Other, please state";
    var coachesOtherReasonNoChangeIdStr = "8*_*Tier_1*_*Total coaches*_* -reason-dropdown*_*no-change-reason*_*Other, please state";
 
    $('[id="' + coachesOtherReasonDecreaseIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').show();
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('required', true);
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').hide();
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('required', false);
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('disabled', true);
        }      
    });

    $('[id="' + coachesOtherReasonIncreaseIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').show();
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('required', true);
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').hide();
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('required', false);
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('disabled', true);
        }      
    });

    $('[id="' + coachesOtherReasonNoChangeIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').show();
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('required', true);
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').hide();
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('required', false);
            $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('disabled', true);
        }      
    });

    if ($('[id="' + coachesOtherReasonDecreaseIdStr + '"]').is(":checked"))
    {
        $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').show();
        $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('required', true);
        $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('disabled', false);
    }

    if ($('[id="' + coachesOtherReasonIncreaseIdStr + '"]').is(":checked"))
    {
        $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').show();
        $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('required', true);
        $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('disabled', false);
    }

    if ($('[id="' + coachesOtherReasonNoChangeIdStr + '"]').is(":checked"))
    {
        $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').show();
        $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('required', true);
        $('[id="8*_*Tier_1*_*Total coaches*_* -reason-other-text"]').prop('disabled', false);
    }

    var coachesOtherReasonDecreaseIdStrTier2 = "8*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*significant-decrease-reason*_*Other, please state";
    var coachesOtherReasonIncreaseIdStrTier2 = "8*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*significant-increase-reason*_*Other, please state";
    var coachesOtherReasonNoChangeIdStrTier2 = "8*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*no-change-reason*_*Other, please state";
 
    $('[id="' + coachesOtherReasonDecreaseIdStrTier2 + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').hide();
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', false);
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', true);
        }      
    });

    $('[id="' + coachesOtherReasonIncreaseIdStrTier2 + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').hide();
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', false);
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', true);
        }      
    });

    $('[id="' + coachesOtherReasonNoChangeIdStrTier2 + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').hide();
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', false);
            $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', true);
        }      
    });

    if ($('[id="' + coachesOtherReasonDecreaseIdStrTier2 + '"]').is(":checked"))
    {
        $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
        $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
        $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
    }

    if ($('[id="' + coachesOtherReasonIncreaseIdStrTier2 + '"]').is(":checked"))
    {
        $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
        $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
        $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
    }

    if ($('[id="' + coachesOtherReasonNoChangeIdStrTier2 + '"]').is(":checked"))
    {
        $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').show();
        $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('required', true);
        $('[id="8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text"]').prop('disabled', false);
    }

    var courtsOtherReasonDecreaseIdStr = "5*_*Tier_1*_*Total courts*_* -reason-dropdown*_*significant-decrease-reason*_*Other, please state";
    var courtsOtherReasonIncreaseIdStr = "5*_*Tier_1*_*Total courts*_* -reason-dropdown*_*significant-increase-reason*_*Other, please state";
    var courtsOtherReasonNoChangeIdStr = "5*_*Tier_1*_*Total courts*_* -reason-dropdown*_*no-change-reason*_*Other, please state";
 
    $('[id="' + courtsOtherReasonDecreaseIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').show();
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('required', true);
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').hide();
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('required', false);
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('disabled', true);
        }      
    });

    $('[id="' + courtsOtherReasonIncreaseIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').show();
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('required', true);
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').hide();
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('required', false);
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('disabled', true);
        }      
    });

    $('[id="' + courtsOtherReasonNoChangeIdStr + '"]').change(function() {
        if ($(this).is(":checked"))
        {
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').show();
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('required', true);
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('disabled', false);
        }  
        else
        {
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').hide();
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('required', false);
            $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('disabled', true);
        }      
    });

    if ($('[id="' + courtsOtherReasonDecreaseIdStr + '"]').is(":checked"))
    {
        $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').show();
        $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('required', true);
        $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('disabled', false);
    }

    if ($('[id="' + courtsOtherReasonIncreaseIdStr + '"]').is(":checked"))
    {
        $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').show();
        $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('required', true);
        $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('disabled', false);
    }

    if ($('[id="' + courtsOtherReasonNoChangeIdStr + '"]').is(":checked"))
    {
        $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').show();
        $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('required', true);
        $('[id="5*_*Tier_1*_*Total courts*_* -reason-other-text"]').prop('disabled', false);
    }


    //Survey insights
    $("#survey-insights-country-select, #survey-insights-year-select").on('change', function(){
        var country = $("#survey-insights-country-select").val();
        var year = $("#survey-insights-year-select").val();

        var action   = "load_survey_insight_report";
        var token    = $("input[name=token]").val();
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action  : action,
                    token   : token,
                    country : country,
                    year: year
                },
                success: function(data)
                {     
                    setTimeout(function(){
                        cmsLoadingStatus = false;   
                        $("#survey-insight-report-main-wrapper").html(data.output);
                    }, 1000);       
                    
                   
                }
            });
    });


    if ($("#itf_admin_messages_overall").length) {

        var messageTable = $("#itf_admin_messages_overall").DataTable({
              "pageLength": 5,
              "columnDefs": [
                    { "width": "40px", "targets": 1 },
                    { "width": "30px", "targets": 2 } // Set width to 100 pixels for the first column (index 0)
                ]
        });

        $('.select-all-message-checkbox').on('change', function() {
            var isChecked = $(this).prop('checked');           
            messageTable.rows().nodes().to$().find('.row-select').prop('checked', isChecked);
        });

       var userIds = [];

        $(document).on("change", ".row-select", function() {
            console.log("changing");
            if ($(this).prop('checked')) {               
                var userId = $(this).attr('data-user-id');
                console.log(userId);
                userIds.push(userId);
            } 
        });

        $('#btn-send-message-itf-admin').on('click', function() {

            var messageSubject = $("#messageSubject").val();
            var messageText    = $("#messageText").val();
            var token          = $("input[name=token]").val();
            var isChecked      = $(".select-all-message-checkbox").prop("checked");
            var recepient      = "";
            var action         = "create_message_threads";

            if (isChecked) {
                recepient  = "all";
            }
            
            if (messageSubject == "") {
                alert("Message subjects cannot be empty");
                return;
            }

            if (messageText == "") {
                alert("Messages cannot be empty");
                return;
            }

            if (userIds == "" && recepient == "") {
                alert("Recepients is empty");
                return;
            }

            if (recepient == "") {
                recepient = userIds;
            }

            cmsLoadingStatus = true;
            loadOverlay();

            $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action  : action,
                    token   : token,
                    messageText : messageText,
                    messageSubject: messageSubject,
                    recepient : recepient
                },
                success: function(data) {    
                    location.href = "/?page=na_survey_messages&view=itf&academy=103&survey_id=1";
                }
            });



        });

    }

    if ($("#itf-admin-all-messages").length) {

         var messageTable = $("#itf-admin-all-messages").DataTable({
                "order": [2, 'desc'],
                "oLanguage": {
                    "sEmptyTable": "No messages"
                },
                lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
                "pageLength": 5
        });
                    

        // global object
        var waos = {      
            recipientData: [],
            msgRecipients: [],
            latestReplies: [],
            newMessage: '',
            activeThreadData: [],
            activeThread: [],
            activeThreadId: '',
            messageSender: '',
            messageRecipients: '',
            threadData: [],
            timeStampGroup: ''
        }

            // global variables
        var firstInitial = '';
        var secondInitial = '';
        var firstName = '';
        var secondName = '';
        var threadLatest = '';
        var lastUpdate;
        var addedId;
        var countRequest = 0;
        var userId = $("input[name=user_id]").val();

        var ajaxUrl = '../content/ajax_gep_common.php';


        // Generic function to make an AJAX call
        var fetchData = (query, type, dataURL) => {
          lockSave = false;
          // fire loading state
          loading = true;
          loadOverlay();
          return $.ajax({
              url: dataURL,
              dataType: 'json',
              type: type,
              data: query,
          }).done((data) => {      
              try {
                if (data.errorMessage) {
                  //alert(data.errorMessage);
                  
                  if ((data.errorMessage === 'Invalid Token') || (data.errorMessage === 'User not logged in')) {
                    alert(data.errorMessage);
                    loading = false;
                   // window.location = '/?academy=8&ogkm_logout=1';
                  }
                  else
                  {
                    alert(data.errorMessage);
                  }
                } else if ((data.output != '') || (data.length > 0)) {
                  // console.log("Success!");

                } else {
                  console.log("Data has length of 0");
                }
              }
              catch (e) {
                console.log("Something went wrong. : " + e);
              }
          }).fail((jqXHR, textStatus, errorThrown) => {
              console.log(textStatus + ': ' + errorThrown);
          }).always(() => {
            loading = false;
            
          });
        }

        // Generic function to make an AJAX call
        var fetchMsgData = (query, type, dataURL) => {

          return $.ajax({
              url: dataURL,
              dataType: 'json',
              type: type,
              data: query,
          }).done((data) => {
              // console.log(data);
             
              try {
                if (data.errorMessage) {

                 // 

                 if ((data.errorMessage === 'Invalid Token') || (data.errorMessage === 'User not logged in')) {
                  
                    alert(data.errorMessage);
                    loading = false;
                 //   window.location = '/?academy=8&ogkm_logout=1';
                  }
                  else
                  {
                    alert(data.errorMessage);
                    loading = false;
                  }

                } else if ((data.output != '') || (data.length > 0)) {
                    // console.log("Success!");
                } else {
                  console.log("Data has length of 0");
                }
              }
              catch (e) {
                console.log("Something went wrong. : " + e);
              }
          }).fail((jqXHR, textStatus, errorThrown) => {
             waosGlobal.offline = true;
              console.log(textStatus + ': ' + errorThrown);
               console.log(waosGlobal.offline);
          }).always(() => {
            loading = false;
          });
        }

        function sortAscending(a, b) {
            var nameA = new Date(a.creation_date); // ignore upper and lowercase
            var nameB = new Date(a.creation_date); // ignore upper and lowercase

            console.log(nameA);

            let comparison = 0;
            if (nameA > nameB) {
                comparison = -1;
            } else if (nameA < nameB) {
                comparison = 1;
            }
            return comparison;
        }

         // Timeout checks for replies every 500 miliseconds
        function getLatestRepliesSurveys() {

            function checkForReplies() {

                console.log(waos.activeThreadId);
                
                // query the API to see if there new messages
                const ajaxGetMsgLastUpdate = fetchMsgData(
                {
                    action: 'get_latest_reply',
                    token: token,
                    thread_id: waos.activeThreadId,
                    last_update_date: lastUpdate,

                }, 'POST', ajaxUrl);

                $.when(ajaxGetMsgLastUpdate).then((data) => {

                    countRequest += 1;
                    console.log("Coming in again");
                    console.log(data.output);
                
                    // check if the Ajax has returned any data
                    if (data.output != undefined) {
                        // set the data to the waos object
                        waos.latestReplies = data.output;

                        console.log(waos.latestReplies);

                        lastUpdate = data.output.map(function(e) { return e.comment_id; }).sort().reverse()[0];
                        console.log("lastUpdate");
                        console.log(lastUpdate);

                        let arr1 = waos.latestReplies.reverse();//latest reply
                        let arr2 = waos.activeThread;//is the existing
                        console.log(arr1);
                        console.log(arr2);

                        let addReply = arraysEqual(arr1, arr2);

                        // get the key of last item
                        let lastCommentThread = waos.activeThread.length -1;
                        // get the comment id of the last item in thread
                        let lastele = waos.activeThread[lastCommentThread].comment_id;
                        // get key of latest reply
                        let lastCommentReply = waos.latestReplies.length -1;
                        console.log(waos.activeThread[lastCommentThread]);
                        // get latest reply id
                        let latestRep = waos.latestReplies[lastCommentReply].comment_id;
                        // get time of last comment
                        let lastCommentTime = waos.activeThread[lastCommentThread].time_sent;
                        // get time of most recent reply
                        let latestCommentTime = waos.latestReplies[lastCommentReply].time_sent;
                        // fire the function if the 2 id's and time stamps don't match (stops duplicates)
                        console.log('lastEle:' + lastele);
                        console.log('latestRep:' + latestRep);
                        // console.log('addedId:' + addedId);

                        if((lastele !== latestRep) && (addedId !== latestRep)) {
                            if(addReply == false) {
                                renderLatestReplies(lastele);
                            }
                        }

                        waos.activeThread = data.output;
                    }
                    // reload page when requests get to 1000
                    if (countRequest == 1000) window.location.reload(); 
                    
                });


                // set time out to check for replies every "" seconds
               
                setTimeout( checkForReplies, 5000 );
               

            }
            //checkForReplies();
        }


        // render the latest replies
        function renderLatestReplies(lastele) {
            let flexClass;
            
            let latestReplies = waos.latestReplies;
            // let activeThread = waos.activeThread;
            let renderMessageLatest;

            for (var i = 0; i < latestReplies.length; i++) {
                let r = latestReplies[i];


                firstName = r.first_name;
                secondName = r.last_name;
                console.log(firstName);
                console.log(r);
                // set initals
                var initials = setMsgInitials(firstName, secondName);

                if(r.from == userId) {
                    flexClass = ` flex-right`;
                } else {
                    flexClass = ` flex-left`;
                }

                let timeSent = r.time_sent;


                if((lastele != r.comment_id) && (waos.activeThreadId == r.message_id)) {

                    renderMessageLatest = `
                        <div data-id="` + r.comment_id + `" class="ca-msg-row` + flexClass + `">
                            <div class="ca-user-cell">
                                <div class="ca-user" title="` + firstName + ` ` + secondName + `">` + initials + `</div>
                            </div>
                            <div class="ca-msg-cell">
                                <div class="ca-msg">` + r.message + `</div>
                                <div class="time">` + timeSent + `</div>
                            </div>
                        </div>
                    `;

                    $('#ca-msg-body-survey').append(renderMessageLatest);
                }
            }
        

            // scroll div to bottom after render
            scrollDivSurveyBottom('ca-msg-body-survey');
        }

        // get formatted time
        function getFormattedTime() {
            const date = new Date();
            const currentHour = date.getHours();
            const currentMinute = date.getMinutes();
            const currentSecond = date.getSeconds();

            const str = ("0" + currentHour).slice(-2) + ":" + ("0" + currentMinute).slice(-2) + ":" + ("0" + currentSecond).slice(-2);
            console.log(str);
            return str;
        }


        getAllMessageData();
    
        function getAllMessageData(activeThreadId) {
            var action = 'read_my_messages';
            // get all participants for messaging
            const ajaxGetMessageData = fetchData(
            {
                action: action,
                token: token,
                survey_id: 1
                
            }, 'POST', ajaxUrl);

            // get initial participants via ajax
            $.when(ajaxGetMessageData).then((data) => {

                $('#ca-msg-body-survey').html('');

                if (data.output != null && data.output !== "Empty Messages") {

                    if (!$(".msg-body-main").is(":visible"))
                    {
                        $(".msg-body-main").show();
                    }
                    // check url for carrent thread var

                    console.log(data.output);

                    waos.threadData = data.output;


                    // let activeThreadId = $.urlParam('current_thread_id');
                    let thread;
                    // if not present load the first item 
                    if (activeThreadId == null) {
                        // set the active thread to the first row

                            
                        // let dataToSort = data.output;

                        waos.threadData.sort(sortAscending);
                        

                        console.log(waos.threadData);

                        
                        waos.activeThreadId = waos.threadData[0].message_id;
                        thread = waos.threadData[0].threads;
                        waos.activeThread = waos.threadData[0].threads;
                        waos.activeThreadData = waos.threadData[0];

                    } else {
                        // else load the active thread
                        waos.activeThreadId = activeThreadId;

                        let activeThread = waos.threadData.filter(function (el) {
                            return el.message_id == activeThreadId;
                        });

                        //console.log(activeThread);

                        thread = activeThread[0].threads;

                        waos.activeThreadData = activeThread;
                        
                        waos.activeThread = activeThread[0].threads;
                    }

                    // initial render, add parcipant rows to the DOM
                    //renderMsgParticipantRows(waos.threadData, activeThreadId);

                    // initial render, add msg rows to the DOM
                    renderMessageRowsSurvey(waos.threadData, thread);

                    // the recipientData variable to contain the JSON
                    waos.recipientData = waos.threadData;
                    console.log(waos.recipientData);

                    threadLatest = waos.recipientData[0].threads;

                    lastUpdate = threadLatest[threadLatest.length-1].mc_id;

                    // scrollDivBottom('ca-msg-body');

                    // check for replies
                    getLatestRepliesSurveys();

                    scrollDivSurveyBottom('ca-msg-body-survey');


                    loading = false;
                    $('#ca-input-msg').attr('disabled',false);
                    $('#ca-btn-send').attr('disabled',false);
                } else {
                    $('#ca-input-msg').attr('disabled',true);
                    $('#ca-btn-send').attr('disabled',true);
                    $('#ca-msg-participant-rows').html('<div style="padding: 20px;">You have no new messages...</div>');
                    loading = false;
                }
            });
        }


       
        // scroll element to bottom
        function scrollDivSurveyBottom(div) {
          var objDiv = document.getElementById(div);
          objDiv.scrollTop = objDiv.scrollHeight;
        }

        // set initials for messages
        function setMsgInitials(firstName, secondName) {
            
            let firstInitial,secondInitial;

          if (firstName != null) {
            firstInitial = firstName.charAt(0);
          } else {
            firstInitial = ``;
          }
          if (secondName != null) {
            secondInitial = secondName.charAt(0);
          } else {
            secondInitial = ``;
          }
          return firstInitial + secondInitial;
        }

        // check if 2 arrays are equal
        function arraysEqual(arr1, arr2) {
            for(var i = arr1.length; i--;) {
                if(arr2[i] === undefined)
                    return false;
                if(arr1[i].comment_id !== arr2[i].comment_id)
                    return false;
            }
        }

        function stripHtmlCode(code) {
          let toUpperCase = code.toUpperCase();

          if ((toUpperCase.includes('<HTML')) ||
              (toUpperCase.includes('<SCRIPT')) ||
              (toUpperCase.includes('<BODY')) ||
              (toUpperCase.includes('<DIV')) ||
              (toUpperCase.includes('<?')) ||
              (toUpperCase.includes('<P'))) {

            return true;
          } else {
            return false;
          }
        }

        // generate new message and append it to DOM
        function renderNewSurveyMessage(msg) {

            let renderNewMessage;
            let flexClass = ` flex-right`;
            console.log(waos.recipientData, waos.activeThreadId);
            let currentThread = waos.recipientData.filter(p => p.message_id == waos.activeThreadId);

            

            let isMsgCreator = false;
            if (userId == waos.recipientData[0].user_id) { isMsgCreator = true; }

            console.log(isMsgCreator);
            // true = message creator
            // false = message recipient
            if(isMsgCreator == false) { 

                // filter the JSON to return the logged in user only
                var userData = waos.recipientData[0].recepients.filter(function (el) {
                    return el.to_user_id == userId;
                });

            } else {
                
                // filter the JSON to return the logged in user only
                var userData = waos.recipientData.filter(function (el) {
                    return el.message_id == waos.activeThreadId;
                });

            }

            console.log(userData, waos.activeThreadData, userId);
            // format time
            let newDate = getFormattedTime();

            // for (var i = 0; i < userData.length; i++) {
                // var n = userData[i]

                firstName = userData[0].first_name;
                secondName = userData[0].last_name;
                // set initals
                var initials = setMsgInitials(firstName, secondName);

                renderNewMessage = `
                    <div class="ca-msg-row` + flexClass + `">
                        <div class="ca-user-cell">
                            <div class="ca-user" title="` + firstName + ` ` + secondName + `">` + initials + `</div>
                        </div>
                        <div class="ca-msg-cell">
                            <div class="ca-msg">` + msg + `</div>
                            <div class="time">` + newDate + `</div>
                        </div>
                    </div>
                `;
            // }
            // check for a value before appending to DOM
            if($('#ca-input-msg').val() != '') {
                // append the new msg to the DOM
                $('#ca-msg-body-survey').append(renderNewMessage);
            }

            // clear the input after msg sent
            $('#ca-input-msg').val('');
            //addedId = '';
        }

       function createReplyMsgSurvey() {
            let msg = waos.newMessage;
            let trimMsg = $.trim(msg);
            $('#ca-input-msg').prop('disabled', true);
            $('#createReplyMsgSurvey').prop('disabled', true);
            // Check msg for code snippets
            let codeInject = stripHtmlCode(trimMsg);
            console.log(msg);
            if (trimMsg != '') {   
                if (codeInject == true) {
                  alert('Error: Messaging service only accepts plain text');
                } else {
                  
                    //$('.ca-input-msg-cell').append('<i class="fa fa-spinner fa-pulse fa-spin"></i>');
                    const ajaxCreateMsgReply = fetchData(
                    {
                        action: 'create_reply_for_messages',
                        token: token,
                        thread_id: waos.activeThreadId,
                        message_reply: waos.newMessage

                    }, 'POST', ajaxUrl);

                    $.when(ajaxCreateMsgReply).then((data) => {

                        // update the last update variable with the latest time stamp
                        lastUpdate = data.output;
                        //console.log(lastUpdate);
                        addedId = data.output;

                        renderNewSurveyMessage(msg);

                        scrollDivSurveyBottom('ca-msg-body-survey');

                        setTimeout(function() {

                            $('#ca-input-msg').prop('disabled', false).focus();
                            $('#createReplyMsgSurvey').prop('disabled', false);
                           // $('.ca-input-msg-cell').find('.fa-spinner').remove();
                        }, 500);
                    });
                }
            } else {
                   alert("Messages cannot be empty");
            }
        }



        // toggle message window based on thread
        function renderMessageSurveyRowsToggle(data, threadId) {
            let flexClass;
            $('#ca-msg-body-survey').html('');

            let renderMessageToggle;

            for (var i = 0; i < data.output.length; i++) {
                var t = data.output[i]

                firstName = t.first_name;
                secondName = t.last_name;
                // set initals
                var initials = setMsgInitials(firstName, secondName);

                if (t.from == userId) {
                    flexClass = ` flex-right`;
                } else {
                    flexClass = ` flex-left`;
                }

                let timeSent = t.time_sent;

                renderMessageToggle = `
                    <div data-id="` + t.comment_id + `" class="ca-msg-row` + flexClass + `">
                        <div class="ca-user-cell">
                            <div class="ca-user" title="` + firstName + ` ` + secondName + `">` + initials + `</div>
                        </div>
                        <div class="ca-msg-cell">
                            <div class="ca-msg">` + t.message + `</div>
                            <div class="time">` + timeSent + `</div>
                        </div>
                    </div>
                `;

                $('#ca-msg-body-survey').append(renderMessageToggle);
            }

            // add recipients name to thread title
            $('#ca-msg-thread-title').html(waos.messageSender + ' > ' + waos.messageRecipients);

           
            getLatestRepliesSurveys();
            
        }

        // render all messages for Document ready function
        function renderMessageRowsSurvey(data, thread) {
            
            let renderMsgRows;
            let flexClass;

            // console.log(data);

            
            // loop through the data
            for (var i = 0; i < thread.length; i++) {
                var m = thread[i];

                firstName = m.first_name;
                secondName = m.last_name;
                // set intials
                var initials = setMsgInitials(firstName, secondName);


                if(m.from == userId) {
                    flexClass = ` flex-right`;
                } else {
                    flexClass = ` flex-left`;
                }
                console.log(waos.activeThreadId);
                console.log(m.message_id);
                let timeStamp = m.time_sent.split(' ');
                let timeSent = timeStamp[1];
                let date = timeStamp[0];
                let dateFormated = formatDate(date);
                let dateGroup;
                if(waos.activeThreadId == m.message_id) {
                    
                    if ((waos.timeStampGroup == '') || (waos.timeStampGroup != date)) {

                        //dateGroup = `<div class="timestamp">${dateFormated}</div>`;
                         dateGroup = ``;

                    } else {

                        dateGroup = ``;

                    }

                    renderMsgRows = `
                        ${dateGroup}
                        <div class="ca-msg-row` + flexClass + `">
                            <div class="ca-user-cell">
                                <div class="ca-user" title="` + firstName + ` ` + secondName + `">` + initials + `</div>
                            </div>
                            <div class="ca-msg-cell">
                                <div class="ca-msg">` + m.message + `</div>
                                <div class="time">` + m.time_sent + `</div>
                            </div>
                        </div>
                    `;

                    $('#ca-msg-body-survey').append(renderMsgRows);
                }

                waos.timeStampGroup = date;

            }
            // add recipients name to thread title
         //   $('#ca-msg-thread-title').html(waos.messageSender + ' > ' + waos.messageRecipients);


        }


        // toggle message threads
        $(document).on('click', '.thread-row-survey', function(e) {
            var typeNotification = $(this).attr("type");
            var questionId       = $(this).attr("data-question-id");
            var countryId       = $(this).attr("data-country-id");

            if (!$("#ca-msg-body-survey-text").is(":visible"))
            {
                $("#ca-msg-body-survey-text").show();
            }

            console.log(questionId);
            if (questionId === null || questionId == "") {

                if ($("#question-go-to-btn").is(":visible")) {

                    $("#question-go-to-btn").hide();

                }
            } else {

                $("#question-go-to-btn").show();
                var secQuestion = questionId.split('_');
                var sectionId   = secQuestion[0];
                var queId       = secQuestion[1];

                var link = "/?page=na_survey_section&view=itf&academy=103&survey_id=1&survey_section_id=" + sectionId + "&country_id=" + countryId;
                $("#question-go-to-btn").attr("href", link);
            }

            if (typeNotification == "message") {

                $('#ca-msg-body-survey').html("");
                $("#ca-input-msg").prop("disabled", false);
                $('#ca-btn-send-message').prop("disabled", false);
            } else {

                $('#ca-msg-body-survey').html("");
                $("#ca-input-msg").prop("disabled", true);
                $('#ca-btn-send-message').prop("disabled", true);
            }
            $(this).addClass('active')
            .siblings().removeClass('active');

            $(this).find('.thread-count').remove();

            waos.messageSender = $(this).find('.message-creator').text();
            waos.messageRecipients = $(this).find('.message-recipients').text();

            let threadId = $(this).data('thread-id');
            let action;
            let url;
            waos.activeThreadId = threadId;
            // get the message rows
            const ajaxGetMsgThread = fetchData(
            {
                action: 'get_replies',
                ptToken: token,
                message_id: threadId,
                

            }, 'POST', '../api/v1/message.php');

            $.when(ajaxGetMsgThread).then((data) => {

                console.log(data);

                renderMessageSurveyRowsToggle(data, threadId);

               //  // check for replies
               getLatestRepliesSurveys();

                waos.activeThread = data.output;

               //  console.log(data.output);


                scrollDivSurveyBottom('ca-msg-body-survey');

               //  getUserMessageNotifications();
            });
           

       
        
        });

         // send the message data on click
        $(document).on('click', '#ca-btn-send-message', function() {
            console.log("sending");
            // if (loading) return;
                
            createReplyMsgSurvey();

            waos.newMessage = '';

        });

        // send the message data on keyup
        window.addEventListener('keyup', function (e) {

            if (loading) return;

            if (e.keyCode === 13) {

                createReplyMsgSurvey();

                waos.newMessage = '';
            }

        }, false);


        // get the message value from the input
        $(document).on('keyup', '#ca-input-msg', function() {

           // if (loading) return;

            let msgValue = $(this).val();

            console.log(msgValue);

            waos.newMessage = msgValue;

        });

        /*Trigger a click to the first thread*/
        if ($(".ind-thread-view").length)
        {
            $(".thread-row-survey.ind-thread-view:first").click();
        }

    }

    $('#btn-send-message-na-admin').on('click', function() {
        var messageSubject = $("#messageSubject").val();
        var messageText    = $("#messageText").val();
        var token          = $("input[name=token]").val();
        var recepient      = "itf-admin";
        var action         = "create_message_threads";
            
        if (messageSubject == "") {
            alert("Message subjects cannot be empty");
            return;
        }

        if (messageText == "") {
            alert("Messages cannot be empty");
            return;
        }         

        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action  : action,
                token   : token,
                messageText : messageText,
                messageSubject: messageSubject,
                recepient : recepient
            },
            success: function(data) {    
               location.href = "/?page=na_survey_messages&view=itf&academy=103&survey_id=1";
            }
        });
    });

    $('.message-btn-icon').on("click", function(e) {
        var messageQuestionId = $(this).attr("id");
       
        $("#message-box-" + messageQuestionId).slideToggle(10, function() {
            $('.question-message-btn').css("position", "absolute");
            $('.question-message-btn').css("left", "71%");
            $("#question-message-btn-"+messageQuestionId).css("z-index", "8");
            $("#question-message-btn-"+messageQuestionId).addClass("col-md-5");
            $("#messageText-"+messageQuestionId).css("height", "197px");
            $('.message-btn-icon').hide();
            $('.survey-question-container').each(function() {

                $(this).addClass("inline-question-container");
           
            });           
        });
      
    });

     $('.close-message-box').on("click", function() {       
        var messageQuestionId = $(this).attr("id");       
        surveyQuestionsReload(messageQuestionId);
    });

    $('.btn-send-message-na-admin-question').on("click", function() {
        var questionId     = $(this).attr("data-question-id");
        var sectionId      = $(this).attr("data-section-id");
        var countryId      = $(this).attr("data-country-id");
        var messageSubject = $("#messageSubject-" + questionId).val();
        var messageText    = $(".message-text-" + questionId).val();
        var token          = $("input[name=token]").val();
        var recepient      = "itf-admin";
        var action         = "create_message_threads_questions";
            
        if (messageSubject == "") {
            alert("Message subjects cannot be empty");
            return;
        }

        if (messageText == "") {
            alert("Messages cannot be empty");
            return;
        }        

        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action  : action,
                token   : token,
                messageText : messageText,
                messageSubject: messageSubject,
                recepient : recepient,
                questionId : questionId,
                sectionId  : sectionId,
                countryId : countryId
            },
            success: function(data) {    
                cmsLoadingStatus = false; 
                $("#messageSubject-" + questionId).val("");
                $(".message-text-" + questionId).val("");
                surveyQuestionsReload(questionId);
            }
        });
    });

    function surveyQuestionsReload(messageQuestionId) {
        $('.survey-question-container').each(function() {
                $(this).removeClass("inline-question-container");
        });
        $("#message-box-" + messageQuestionId).hide();
        $('.question-message-btn').css("position", "revert");
        $("#question-message-btn-"+messageQuestionId).css("z-index", "auto");
        $("#question-message-btn-"+messageQuestionId).removeClass("col-md-5");
        //$('.question-message-btn').css("left", "71%");
        $("#messageText-"+messageQuestionId).css("height", "197px");
        $('.message-btn-icon').show();
    }   

    $(document).on('click', '#not-accept-terms-survey', function() {

        cmsLoadingStatus = true;
        loadOverlay();
        var action = "not_accept_terms_survey";
        var token  = $("input[name=token]").val();
        $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action  : action,
                token   : token               
            },
            success: function(data) {    
                cmsLoadingStatus = false;   
                $('#itf-admin-approval-modal').modal('hide');                    
            }
        });

    });

    $(document).on('click', '#accept-terms-conditions-survey', function() {
        cmsLoadingStatus = true;
        loadOverlay();
        var action = "accept_terms_survey";
        var token  = $("input[name=token]").val();

        $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action  : action,
                token   : token,              
            },
            success: function(data) {    
                cmsLoadingStatus = false; 
                $('#itf-admin-approval-modal').modal('hide');  
                location.reload();
                
            }
        });

    });

    if ($('#approve-all-section-btn').length)
    {
        var countryId   = $("#approve-all-section-btn").attr("data-country-id");
        var action      = "check_approved_sections_by_country";
        var token       = $("input[name=token]").val();
        $.ajax({
                    url: '../content/ajax_itf_common.php',
                    dataType: "json",
                    data: {
                        action          : action,
                        token           : token,
                        countryId         : countryId
                    },
                    success: function(data)
                    {            
                       if (data.output == true)
                       {
                        $("#approve-all-section-btn").removeClass("disabled");
                       }                      
                    }
        });
    }

     /*Na survey functions and listeners*/
    $('.survey-distribution-main-wrapper #na-admin-approval-all-section-modal').on('show.bs.modal', function (event) {
        var span = $(event.relatedTarget) // span that triggered the modal
        var surveyId        = span.attr('data-survey-id'); // Extract info from data-* attributes
        var countryId       = span.attr('data-country-id'); // Extract info from data-* attributes        
        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.        
        var action  = "approve_all_survey_section";
        var token   = $("input[name=token]").val();

        var modal = $(this);
        modal.find('#not-approval-reason').css('height', '150px');
        modal.find('#not-approval-reason').prop('disabled', true);

        $("#approve-na-all-admin-section-btn").on('click', function(){
            cmsLoadingStatus = true;
            loadOverlay();
            $.ajax({
                        url: '../content/ajax_itf_common.php',
                        dataType: "json",
                        data: {
                            action          : action,
                            token           : token,
                            countryId       : countryId,
                            surveyId        : surveyId
                        },
                        success: function(data)
                        {            
                            cmsLoadingStatus = false;  
                            $("#approve-all-section-btn").addClass("disabled");  
                                setTimeout(function(){
                                    $('#na-admin-approval-section-modal').modal('hide');
                                }, 2000);

                            $("#approve-all-section-btn").text("Approved");  
                            $("#approve-all-section-btn").addClass("disabled"); 
                            $("#approve-all-section-btn").prop("disabled", true);  
                            
                            location.reload();                             
                        }
            });
            
        });
    });

    $('.un-approved-btn').hover(
        function(){
          $(this).text('Unapprove'); 
          $(this).removeClass('btn-na-survey-secondary-approved');
          $(this).addClass('btn-na-survey-secondary-un-approved');
        },
        function(){
          var tickIcon =  '<span class="section-check-icon"><i class="fas fa-check"></i></span>Approved';
          $(this).html(tickIcon); 
          $(this).removeClass('btn-na-survey-secondary-un-approved');
          $(this).addClass('btn-na-survey-secondary-approved');
        }
    );

    $(document).on('click', '.btn-na-survey-secondary-un-approved', function(){
        $(this).text('Unapprove'); 
        $(this).removeClass('btn-na-survey-secondary-approved');
        $(this).addClass('btn-na-survey-secondary-un-approved');
    });

    /*Na survey functions and listeners*/
    $('.survey-distribution-main-wrapper #na-admin-un-approve-section-modal').on('show.bs.modal', function (event) {
        var span = $(event.relatedTarget) // span that triggered the modal
        var sectionId        = span.attr('data-section-id'); // Extract info from data-* attributes
        var countryId       = span.attr('data-country-id'); // Extract info from data-* attributes        
        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.        
        var action  = "un_approve_survey_section";
        var token   = $("input[name=token]").val();

        $("#un-approve-na-all-admin-section-btn").on('click', function(){
            cmsLoadingStatus = true;
            loadOverlay();
            $.ajax({
                        url: '../content/ajax_itf_common.php',
                        dataType: "json",
                        data: {
                            action          : action,
                            token           : token,
                            countryId       : countryId,
                            sectionId       : sectionId
                        },
                        success: function(data)
                        {            
                            cmsLoadingStatus = false;  
                            location.reload();                             
                        }
            });
            
        });
    });


     /*Merge users modals and listners*/
    $('#merge-user-modal').on('show.bs.modal', function (event) {
        var span        = $(event.relatedTarget) // span that triggered the modal
        var email        = span.attr('data-email-id'); // Extract info from data-* attributes
        var userId       = span.attr('data-user-id'); // Extract info from data-* attributes        
        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.        
        var action  = "sent_for_final_approval_merge";
        var token   = $("input[name=token]").val();
        var modal   = $(this);
        modal.find('#user-email-merge').text(email);
        var searchUrl = '../api/v1/course_wizard.php';

        $("#input-merge-user").select2({
            theme: 'bootstrap-5',
            minimumInputLength: 0,
            dropdownParent: $("#merge-user-modal"),
            ajax: { 
            url: searchUrl+"/?action=get_all_users_by_search_term&ptToken="+token,
            type: "post",
            dataType: 'json',
            delay: 250,
            data: function (params) {
                return {
                    searchTerm: params.term,
                    userId: userId
                };
            },
            processResults: function (response) {
                return {
                    results: response
                };
            },
            cache: true
            }
        });  

        $("#merge-request-button").on('click', function(){
            cmsLoadingStatus = true;
            var userMergeInto = $('#input-merge-user').val();
            loadOverlay();
            $.ajax({
                        url: '../content/ajax_itf_common.php',
                        dataType: "json",
                        data: {
                            action                  : action,
                            token                   : token,
                            user_merged             : userId,
                            user_merge_into         : userMergeInto
                        },
                        success: function(data)
                        {           
                            cmsLoadingStatus = false;                             
                            $('#merge-user-modal').modal('hide'); 
                        }
            });
            
        });
    });

    /*Remove listener when modal closes*/
    $('#merge-user-modal').on("hidden.bs.modal", function() {
       $(".merge-request-button-cls").off("click");
    });

    
    $('#itf-admin-approval-merge-modal').on('show.bs.modal', function (event) {
        var span                = $(event.relatedTarget) // span that triggered the modal
        var mergedUser          = span.attr('data-merged-user'); // Extract info from data-* attributes
        var mergeToUser         = span.attr('data-merge-to-user'); // Extract info from data-* attributes  
        var mergedUserId        = span.attr('data-merged-user-id'); // Extract info from data-* attributes
        var mergeToUserId       = span.attr('data-merge-to-user-id'); // Extract info from data-* attributes            
        var mergeFromEmail      = span.attr('data-merge-from-email');
        var mergeToEmail        = span.attr('data-merge-to-email');
        var approvalId          = span.attr('data-approval-id');

        var action              = "read_all_merged_courses_for_user";
        var token               = $("input[name=token]").val();
        var modal               = $(this);

        modal.find('#merged-user').text(mergedUser);
        modal.find('#merged-to-user').text(mergeToUser);
        modal.find('#user-archived').text(mergedUser);

        $('.archiveUserToggle').bootstrapToggle('destroy');
        $('.archiveUserToggle').bootstrapToggle("on");

         $('.archiveUserToggle').hover(function() {
            $(this).closest('.toggle').find('.toggle-handle').show();
        }, function() {
            $(this).closest('.toggle').find('.toggle-handle').hide();
        });

        $('.toggle-group').click(function() {
            var checkbox = $(this).prev('input[type="checkbox"]');
            checkbox.bootstrapToggle('toggle');
        });

        $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action                  : action,
                    token                   : token,
                    merged_user_id          : mergedUserId,
                   
                },
                success: function(data)
                {                           
                    modal.find('#list-of-merged-courses').html(data.output);
                }
        });

        $("#accept-merge-for-user").on('click', function(){
            cmsLoadingStatus = true;
            var archived     = "no";   
            if ($('.archiveUserToggle').is(':checked')) {
                 archived     = "yes";     
            }     
            var allCourses   = $("input[name=input_courses]").val();
            loadOverlay();
            $.ajax({
                        url: '../content/ajax_itf_common.php',
                        dataType: "json",
                        data: {
                            action                  : "accept_and_apply_merge",
                            token                   : token,
                            user_merge_from         : mergedUserId,
                            user_merge_to           : mergeToUserId,
                            merge_from_email        : mergeFromEmail,
                            merge_to_email          : mergeToEmail,
                            approval_id             : approvalId,
                            archived                : archived,
                            input_courses           : allCourses
                        },
                        success: function(data)
                        {           
                            //cmsLoadingStatus = false;      
                            $('#itf-admin-approval-merge-modal').modal('hide'); 
                            location.reload();
                               
                        }
            });
            
        });

        $("#reject-merge-for-user").on('click', function(){
            var allCourses   = $("input[name=input_courses]").val();
            cmsLoadingStatus = true;                
            loadOverlay();
            $.ajax({
                        url: '../content/ajax_itf_common.php',
                        dataType: "json",
                        data: {
                            action                  : "reject_merge",
                            token                   : token,
                            user_merge_from         : mergedUserId,
                            user_merge_to           : mergeToUserId,                           
                            approval_id             : approvalId,
                            input_courses           : allCourses                            
                        },
                        success: function(data)
                        {           
                            //cmsLoadingStatus = false;      
                            $('#itf-admin-approval-merge-modal').modal('hide'); 
                            location.reload();
                               
                        }
            });
            
        });

   
    });


    $('.un-merge-btn').hover(
        function() {
          console.log("hover");
          $(this).text('Reverse'); 
          $(this).removeClass('btn-na-survey-secondary-approved');
          $(this).addClass('btn-unmerge-btn');
        },
        function() {
          var tickIcon =  '<span class="section-check-icon"><i class="fas fa-check"></i></span>Approved';
          $(this).html(tickIcon); 
          $(this).removeClass('btn-unmerge-btn');
          $(this).addClass('btn-na-survey-secondary-approved');
        }
    );


    $(document).on("click", ".btn-unmerge-btn", function() {
        $(this).text('Reverse'); 
        $(this).removeClass('btn-na-survey-secondary-approved');
        $(this).addClass('btn-unmerge-btn');
        
    }); 

    /*Na survey functions and listeners*/
    $('#admin-reverse-merge-modal').on('show.bs.modal', function (event) {
        var span = $(event.relatedTarget) // span that triggered the modal
        var approvalId      = span.attr('data-approval-id'); // Extract info from data-* attributes
        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.        
        var action  = "un_merge_user";
        var token   = $("input[name=token]").val();

        $("#un-merge-user-btn").on('click', function(){
            cmsLoadingStatus = true;
            loadOverlay();
            $.ajax({
                        url: '../content/ajax_itf_common.php',
                        dataType: "json",
                        data: {
                            action          : action,
                            token           : token,
                            approval_id      : approvalId
                           
                        },
                        success: function(data)
                        {            
                            //cmsLoadingStatus = false;  
                            location.reload();                             
                        }
            });
            
        });
    });

    /*Na survey functions and listeners*/
    $('#view-version-merge-modal').on('show.bs.modal', function (event) {
        var span = $(event.relatedTarget) // span that triggered the modal
        var mergedUser          = span.attr('data-merged-user'); // Extract info from data-* attributes
        var mergeToUser         = span.attr('data-merge-to-user'); // Extract info from data-* attributes  
        var mergedUserId        = span.attr('data-merged-user-id'); // Extract info from data-* attributes
        var mergeToUserId       = span.attr('data-merge-to-user-id'); // Extract info from data-* attributes            
        var mergeFromEmail      = span.attr('data-merge-from-email');
        var mergeToEmail        = span.attr('data-merge-to-email');
        var approvalId          = span.attr('data-approval-id');

        var modal               = $(this);
    
        var action  = "read_course_transfered";
        var token   = $("input[name=token]").val();
        $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action          : action,
                    token           : token,
                    approval_id      : approvalId
                   
                },
                success: function(data)
                {            
                    cmsLoadingStatus = false;  
                    modal.find('#list-of-merged-courses').html(data.output);                             
                }
        });
    });


    $('#btn-serene-create-banner').on('click', function() {
        var input   = $("#banner_image")[0];
        var token   = $("input[name=token]").val();
        if (input.files && input.files[0]) {
            var file = input.files[0];
           
        }
        
        var formData = new FormData();
        formData.append('image', file);
        formData.append('token', token);
        formData.append('action', "create_isa_banner");

        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            type: "POST",
            data: formData,
            contentType: false,
            cache: false,
            processData:false,      
            success: function(data)
            {
                if (data.errorMessage != null)
                {
                    $('#loading-dialog').hide();
                    console.log(data.errorMessage);
                }
                else
                {
                    location.reload();  
                }
            }
        });
    
    });

    $(document).on('click', '#delete-banner-btn', function() {
        var action  = "remove_banner_serene";
        var token   = $("input[name=token]").val();
        var bannerId = $(this).attr("data-id");
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action          : action,
                    token           : token,
                    banner_id       : bannerId
                   
                },
                success: function(data)
                {                                
                    location.reload();                        
                }
        });
    });

    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        var target = $(e.target).attr("href"); // Get the active tab
        
        // Hide the button if the active tab is #banner_config_tabs
        if (target === '#banner_tabs') {
            if ($('#serene-banner-create').length) {
                $('#whitelabel_config_save_btn').hide();
            }
        } else if (target === '#qualification_builder') {
            
            if ($.fn.DataTable.isDataTable('#tbl_qualifications')) {
                 $('#tbl_qualifications').DataTable().destroy();
            }

        
            if ($("#tbl_qualifications").is(":visible"))
            {
                    cmsLoadingStatus = true;
                    loadOverlay();
                    tbl_certifications = 
                    $("#tbl_qualifications").DataTable({
                        "ajax": "../cms/ajax_cms.php?action=read_qualifications_tbl&ptToken="+$("input[name=token]").val(),
                        "pageLength": 10, 
                        "responsive": true,
                        "initComplete" : function(){
                            cmsLoadingStatus = false;
                            $('[data-toggle="tooltip"]').tooltip({
                                trigger: 'hover'
                            });
                        }  
                    });       
            }
        } else if (target === '#qualifications') {
             if ($.fn.DataTable.isDataTable('#all_qualifications_tbl')) {
                 $('#all_qualifications_tbl').DataTable().destroy();
            }
        
            if ($("#all_qualifications_tbl").is(":visible")) {
            
                $("#all_qualifications_tbl").DataTable();            
            }
        } else if (target === '#regulation_document') {
           
            if ($("#pending_document_ils_tbl").is(":visible")) {
            
                $("#pending_document_ils_tbl").DataTable();           
            }

            if ($("#approved_ils_documents_tbl").is(":visible")) {
            
                $("#approved_ils_documents_tbl").DataTable();           
            }

            if ($("#rejected_qualifications_tbl").is(":visible")) {
            
                $("#rejected_qualifications_tbl").DataTable();           
            }
            
        } else if (target === '#coaching_education') {
           
            if ($("#national_coaching_tbl").is(":visible")) {
            
                $("#national_coaching_tbl").DataTable();           
            }

          
        } else if (target === '#national_training') {
           
            if ($("#national_training_tbl").is(":visible")) {
            
                $("#national_training_tbl").DataTable();           
            }
        }
    });

    $(document).on("click", "#btn-serene-create-courses", function(){
        var action          = "add_home_page_courses";
        var token           = $("input[name=token]").val();
        var online_courses  = $('.online_courses_select').val();
        var f2f_courses     = $('.f2f_theme_courses').val();
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action          : action,
                    token           : token,
                    online_courses  : online_courses,
                    f2f_courses     : f2f_courses
                   
                },
                success: function(data)
                {                                
                    location.reload();                        
                }
        });
    });


    $(document).on('keyup', '#qualification-name-txt', function(event) {

        if ($(this).val().trim() != "") {

            $("#add-qualification-btn").prop('disabled', false);
        } else {

            $("#add-qualification-btn").prop('disabled', true);
            $(document).off("keydown");
        }
    
    });

  
    function toggleAddQualificationButton()
    {
        console.log("is_coming_soon");
        if ($("#qualification-name-txt").val().trim() != "")
        {
            $("#add-qualification-btn").prop('disabled', false);
        }
        else
        {
            $("#add-qualification-btn").prop('disabled', true);
            $(document).off("keydown");
        }
    }

    $(document).on('click', '.edit-qualification', function() 
    {
        var qualificationId = $(this).attr("data-content-id");
        console.log('Clicked');
        editQualificationModal(qualificationId);    
    });

    function editQualificationModal(qualificationId)
    {
    $('#edit-regulation-modal').remove();
    var output = 
    '<div id="edit-qualification-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-lg" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">Edit Qualification</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="name">Qualification Name</label>'+
                                '<input type="text" class="form-control" id="name-qualification"/>'+
                            '</div>'+
                        '</div>'+
                         '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="qualificationType">Qualification Type</label>'+
                                 ' <select class="form-control" id="qualification_type">'+
                                    '<option value="coaching">Coaching</option>'+
                                    '<option value="judging">Judging</option>'+
                                    '<option value="adaptive">Adaptive</option>'+
                                    '<option value="others">Others</option>'+
                                  '</select>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="qualification-requirement">'+                       

                    '</div>'+
                    '<div class="qualification-add">'+                       
                        '<button id="add-qualification-req-btn" type="button" class="btn btn-primary btn-md"><i class="fa fa-plus-square fa-sm"></i></button>'+
                    '</div>'+                 
                    '<div id="advanced-req-select"></div>'+
                    '<div class="row">'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="description">Validity Period</label>'+
                                 ' <select class="form-control" id="validity_period">'+
                                               '<option value="1">1 Month</option>'+
                                                '<option value="2">2 Months</option>'+
                                                '<option value="3">3 Months</option>'+
                                                '<option value="4">4 Months</option>'+
                                                '<option value="5">5 Months</option>'+
                                                '<option value="6">6 Months</option>'+
                                                '<option value="7">8 Months</option>'+
                                                '<option value="9">9 Months</option>'+
                                                '<option value="10">10 Months</option>'+
                                                '<option value="11">11 Months</option>'+
                                                '<option value="12">12 Months</option>'+
                                                '<option value="24">24 Months</option>'+
                                                '<option value="36">36 Months</option>'+
                                 '</select>'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="description">From the first day of the next:</label>'+
                                ' <select class="form-control" id="expiry_period">'+
                                               '<option value="year">Month</option>'+
                                                '<option value="quarter">Quarter</option>'+
                                 '</select>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div style="display:none;" class="row">'+
                        '<div class="col-sm-12">'+                           
                        '</div>'+
                    '</div>'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<input type="hidden" id="qualification-id" value="'+qualificationId+'">'+
                            '<button id="update-qualification-btn" type="button" class="btn btn-primary">Save</button>'+
                        '</div>'+                       
                    '</div>'+

                    '<div class="alert alert-qualification" role="alert" id="alert-course-qualification"></div>'+

                    '<hr>'+

                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<h5>Assigned to this Qualification</h5>'+
                            '<div class="assigned-to-this-qualification">'+
                            '</div>'+                 
                        '</div>'+
                    '</div>'+

                '</div>'+
                '<div class="modal-footer">'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#edit-qualification-modal').modal('show');

    loadQualificationFormData(qualificationId);
    }

    function reload_qualifications_table()
    {
        var data_url = "../cms/ajax_cms.php?action=read_qualifications_tbl&ptToken="+$("input[name=token]").val();
        tbl_qualifications = 
        $("#tbl_qualifications").DataTable({
            destroy: true,
            "ajax": data_url,
            "stateSave": true,
            "pageLength": 10, 
            "responsive": true,
            "rowReorder": true,
            "columnDefs": [
                    { className: "reorder", "targets": [ 0 ] },            
                    { targets: 0, visible: false },
                    { targets: 1, visible: false }             
                    
            ],    
            "initComplete" : function(){
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }
        });

        $.ajax({
            url: data_url,
            dataType: "JSON", 
            success: function(data) {

                console.log(data.data);
            }
        });
        
    }

    function loadQualificationFormData(qualificationId)
    {
        cmsLoadingStatus = true;
        loadOverlay();
        var action   = "read_qualification_info";
        var token    = $("input[name=token]").val();
        var academy  = $("input[name=academy]").val();

        $.ajax({
            url: '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action  : action,
                ptToken : token,
                academy : academy,
                id      : qualificationId
            },
            success: function(data)
            {

                console.log(data);
                $("#qualification-id").val(qualificationId); 

                var qualification = data.qualification[0];
                $("#name-qualification").val(qualification[0].name);
                $("#description-qualification").val(qualification[0].description);
                $("#validity_period").val(qualification[0].validity_period_months);
                $("#expiry_period").val(qualification[0].first_day_of_next);
                $("#qualification_type").val(qualification[0].qualification_type);

                var online_courses    = data.online_courses_form[0];
                var f2f_courses       = data.f2f_courses_form[0];            

                $("#online_courses_list").html(online_courses);
                $("#f2f_courses_list").html(f2f_courses);
              

                $("#online_courses_list").select2({
                    placeholder: "Please select",
                    theme: 'bootstrap-5',
                    dropdownParent: $('.modal-body')

                });

                $("#f2f_courses_list").select2({
                    placeholder: "Please select",
                    theme: 'bootstrap-5',
                    dropdownParent: $('.modal-body')
                });

                $(".assigned-to-this-qualification").html(data.qualification_req[0]);

                // tbl_qualification_courses = 
                // $('#existing_users_table_' + qualificationId).DataTable({                               
                //     responsive: true,
                //     rowReorder: true
                                                 
                // });
               

                var isRegulationPublished = qualification[0].is_published;
                if (isRegulationPublished == 1)
                {
                    $("#is_published").prop("checked", true);
                }
                else
                {
                    $("#is_published").prop("checked", false);
                }

                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
                var hasReq = data.has_requirements;   
                var showAnd = "display:none";
                if (hasReq)
                {
                    showAnd = "";
                }      

                var reqHtml = `<div class="row">
                                    <div class='col-md-8'></div>
                                     <div class="col-md-4" style="`+showAnd+`">
                                        <div class="form-group">
                                             <label for="relation">And / Or</label>
                                            <select class="form-control select2-course-qualification" name="relation" id="relation_001" >
                                              <option value="and">And</option>
                                              <option value="or">Or</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class='col-md-4'>
                                        <div class="form-group">
                                            <label for="selectOption">Qualification Requirement</label>
                                                <select class="form-control" id="qualificationType_001">
                                                   <option value="0">Please select</option>
                                                    <option value="pathway">Pathway</option>
                                                    <option value="elearning">eLearning</option>
                                                    <option value="attendance">Attendance Course</option>
                                                    <option value="assessed">Assessed Course</option>
                                                    <option value="cpd">CPD</option>
                                                </select>
                                        </div>
                                     </div>
                                     <div class='col-md-8'>
                                        <div class="form-group">
                                            <label id="labelCpd_001" for="selectOption">Course</label>
                                            <input type="number" id="qualificationCpd_001" class="form-control" style="display:none" />
                                            <select style="width:100%"  class="form-control select2-course-regulation" name="qualification_type[]" multiple="multiple" id="qualificationCourses_001" >
                                           
                                            </select>
                                        </div>
                                     </div>
                                </div>
                                `;

                       
                $(".qualification-requirement").html('');
                    
                //Does not have any requirements
                $(".qualification-requirement").append(reqHtml);

                cmsLoadingStatus = false;
            }
        });
    }

    $(document).on("change", "[id^='qualificationType']", function() {
        var token  = $('input[name=token]').val();
        var type   = $(this).val();
        var number = $(this).attr("id").match(/\d+$/)[0];
        var elemId = number;
        console.log(elemId);
        changeCpdAndCoursesText(elemId, type);
        var elementSelect2 = $("[id^='qualificationCourses_" + number + "']");

        //Only call to change the requiement type is not cpd
        if (type !== "cpd") {
                $.ajax({
                    url: '../cms/ajax_cms.php',
                    type: "post",
                    dataType: "json",
                    async: true,
                    data: {
                        action: 'read_value_from_type_requirements',
                        ptToken: token,
                        type: type
                    },
                    success: function(data) {
                        cmsLoadingStatus = false;

                        // Ensure old Select2 instances are destroyed before initializing
                        if ($('#qualificationCourses_' + number).hasClass("select2-hidden-accessible")) {
                            $('#qualificationCourses_' + number).select2('destroy');
                        }

                        // Set new HTML content for Select2
                        $("#qualificationCourses_" + number).html(data.courses);

                        // Initialize Select2 after setting the HTML
                        $('#qualificationCourses_' + number).select2({
                            placeholder: 'Please select...',
                            theme: 'bootstrap-5'
                            
                        });
                    }
                });
        }

     
    });

   

    $(document).on('click', '#add-qualification-req-btn', function() {
        var count   = $("[id^='qualificationType']").length;
        var nextid  = count + 1;

        var reqHtml = `
                    <div class="row">
                         <div class='col-md-8'></div>
                         <div class="col-md-4">
                            <div class="form-group">
                                 <label for="relation">And / Or</label>
                                <select class="form-control select2-course-qualification" name="relation_" id="relation_00`+nextid+`" >
                                  <option value="and">And</option>
                                  <option value="or">Or</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class='col-md-4'>
                                    <div class="form-group">
                                        <label for="selectOption">Qualification Requirement</label>
                                            <select class="form-control" id="qualificationType_00`+nextid+`">
                                                <option value="0">Please select</option>
                                                <option value="pathway">Pathway</option>
                                                <option value="elearning">eLearning</option>
                                                <option value="attendance">Attendance Course</option>
                                                <option value="assessed">Assessed Course</option>
                                                <option value="cpd">CPD</option>
                                            </select>
                                    </div>
                                 </div>
                                 <div class='col-md-8'>
                                    <div class="form-group">
                                        <label id="labelCpd_00`+nextid+`" for="selectOption">Course</label>
                                        <input type="number" id="qualificationCpd_00`+nextid+`" class="form-control" style="display:none" />
                                        <select class="form-control select2-course-qualification" name="qualification_type[]" multiple="multiple" id="qualificationCourses_00`+nextid+`" >
                                          
                                        </select>
                                    </div>
                                 </div>
                               </div>  `;
        $(".qualification-requirement").append(reqHtml);
       
    });


    $(document).on('click', '#update-qualification-btn', function() 
    {
        var qualificationid     = $("#qualification-id").val();
        var name                = $("#name-qualification").val();
        var action              = "edit_qualification_info";
        var token               = $("input[name=token]").val();
        var validityPeriod      = $("#validity_period").val();  
        var expiryPeriod        = $("#expiry_period").val();  
        var coachingType        = $("#qualification_type").val(); 
        console.log(validityPeriod);

        
        $('#alert-course-qualification').removeClass("alert-danger");
        $('#alert-course-qualification').removeClass("alert-success");

        if ((name == '') || (name == null))
        {
            $('#alert-course-qualification').addClass("alert-danger");
            $('#alert-course-qualification').html("Error : Qualification name not found!");
            $("#alert-course-qualification").fadeIn(300).delay(1500).fadeOut(400);
        }
        else if ((validityPeriod == "") || (validityPeriod == null))
        {
            $('#alert-course-qualification').addClass("alert-danger");
            $('#alert-course-qualification').html("Error : ValidityPeriod is required!");
            $("#alert-course-qualification").fadeIn(300).delay(1500).fadeOut(400);
        }
        else
        {        
            var allQualifications = [];

            $("[id^='qualificationType_']").each(function() {
                var id                  = $(this).attr('id'); 
                var nextid              = id.split('_')[1]; 
                var qualificationType   = $(this).val();
                var qualificationCourses = $('#qualificationCourses_' + nextid).val();
                var qualificationCpd     = $('#qualificationCpd_' + nextid).val();
                var isRequired          = $('#relation_' + nextid).val();

                var validTypes = ['pathway','elearning','attendance','assessed','cpd'];

                console.log(qualificationType);

                if (validTypes.includes(qualificationType)) {
                    // Combine the data for this specific pair
                    allQualifications.push({
                        "type": qualificationType,
                        "courses": qualificationCourses,
                        "id": nextid,
                        "cpd": qualificationCpd,
                        "isRequired":isRequired
                    });
                }
            });
            console.log(allQualifications);
            cmsLoadingStatus = true;
            loadOverlay();

            var formData = new FormData();
            formData.append('action', action);
            formData.append('ptToken', token);
            formData.append('id', qualificationid);
            formData.append('name', name);
            formData.append('qualification', JSON.stringify(allQualifications));        
            //formData.append('description', description);
            formData.append('validity', validityPeriod);
            formData.append('expiryfirstday', expiryPeriod);
            formData.append('coachingType', coachingType);

            $.ajax({
                url: '../cms/ajax_cms.php',
                type: "post",
                dataType: "json",
                contentType: false,
                cache: false,
                processData: false,
                data: formData,
                success: function(data)
                {

                    if (data.output)
                    {
                        cmsLoadingStatus = false;
                        loadQualificationFormData(qualificationid);
                        $('#alert-course-qualification').addClass("alert-success");
                        $('#alert-course-qualification').html("Qualification successfully updated");
                        $("#alert-course-qualification").fadeIn(300).delay(1500).fadeOut(400);
                    }
                    else
                    {
                        cmsLoadingStatus = false;
                        loadQualificationFormData(qualificationid);
                        reload_qualifications_table();
                        $('#alert-course-qualification').addClass("alert-danger");
                        $('#alert-course-qualification').html("Qualification could not be updated");
                        $("#alert-course-qualification").fadeIn(300).delay(1500).fadeOut(400);
                    }
                  
                }
            });
        }
    });

    function changeCpdAndCoursesText(id, elemtype) {
       
        if (elemtype == "cpd") {

            $('#qualificationCpd_' + id).show();
            $('#qualificationCourses_' + id).hide();
            $("#qualificationCourses_"+ id).next(".select2-container").hide();
            $("#labelCpd_"+ id).text("Credits");
        } else {

            $('#qualificationCpd_' + id).hide();
            $('#qualificationCourses_' + id).show();
            $("#qualificationCourses_"+ id).next(".select2-container").show();
            $("#labelCpd_"+ id).text("Course");
        }
    }

    

    function reload_qualifications_upload_table()
    {
        var data_url = "../cms/ajax_cms.php?action=reload_qualifications_upload_table&ptToken="+$("input[name=token]").val();
        tbl_qualifications = 
        $("#all_qualifications_tbl").DataTable({
            destroy: true,
            "ajax": data_url,
            "stateSave": true,
            "pageLength": 10, 
            "responsive": true,
        });

        $.ajax({
            url: data_url,
            dataType: "JSON", 
            success: function(data) {

                console.log(data.data);
            }
        });
        
    }

    if ($("#pending_qualifications_tbl").is(":visible"))
    {
        $("#pending_qualifications_tbl").DataTable();
    }

    if ($("#all_qualifications_tbl").is(":visible"))
    {
        $("#all_qualifications_tbl").DataTable();
    }

    if ($("#approved_qualifications_tbl").is(":visible"))
    {
        $("#approved_qualifications_tbl").DataTable();
    }
    
    if ($("#rejected_qualifications_tbl").is(":visible"))
    {
        $("#rejected_qualifications_tbl").DataTable();
    }

    if ($("#pending_document_ils_tbl").is(":visible"))
    {
        $("#pending_document_ils_tbl").DataTable();
    }

    if ($("#approved_document_ils_tbl").is(":visible"))
    {
        $("#approved_document_ils_tbl").DataTable();
    }

    if ($("#rejected_document_ils_tbl").is(":visible"))
    {
        $("#rejected_document_ils_tbl").DataTable();
    }

    if ($(".accreditation-table").is(":visible"))
    {
        $('.accreditation-table').each(function () {
            $(this).DataTable();
        });
    }

    if ($("#national_training_tbl").is(":visible"))
    {
        $("#national_training_tbl").DataTable();
    }

    $('#regulation-upload-approve-modal').on('show.bs.modal', function (event) {
        var span                = $(event.relatedTarget) 
        var requestId           = span.attr('data-request-id');
        var name                = span.attr('data-name');
        var qualificationId     = span.attr('data-qualification-id');
        var fee                 = span.attr('data-fee');
        var regulation          = span.attr('data-regulation');
        var regType             = span.attr('data-type');      
        var action              = "read_renewal_request_open_for_edit_by_id";
        var token               = $("input[name=token]").val();
        var qualType            = span.attr('data-qualification-type');

        var modal               = $(this);
        if (regType == "payment")
        {
           $(".upload-regulation").hide();
           $(".payment-regulation").show();
           $('#btn-submit-regulation-cpd').hide();
           $('.coaching-data').hide();
           $('.cpd_credit_upload').hide();

        }
        else if (regType == "coaching_data")
        {
            $(".upload-regulation").hide();
            $(".payment-regulation").hide();
            $('#btn-submit-regulation-cpd').show();
            $('.coaching-data').show();
            $('.cpd_credit_upload').hide();
            $('#coachingData').html('');

            if (qualType == "judging")
            {
                $('#coachingData').html("Judging Data");
            }
            else
            {
                $('#coachingData').html("Coaching Data");
            }

            $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action             : "read_questions_for_regulation",
                    token              : token,
                    qualType           : qualType
                },
                success: function(data)
                {                           
                    modal.find('#coaching-data-questions').html(data.output);
                }
            });
        }
        else if (regType == "cpd_credit")
        {
            $(".upload-regulation").hide();
            $(".payment-regulation").hide();
            $('#btn-submit-regulation-cpd').hide();
            $('.coaching-data').hide();
            $('.cpd_credit_upload').show();
        }
        else
        {
            $(".upload-regulation").show();
            $(".payment-regulation").hide();
            $('#btn-submit-regulation-cpd').show();
            $('.coaching-data').hide();
            $('.cpd_credit_upload').hide();
        }
        modal.find('#payment-regulation-btns').attr('data-fee', fee);
        modal.find('#payment-regulation-btns').attr('data-regulation', regulation);
        modal.find('#qualification_name').html(name);

        modal.find('#fee-for-regulation').html(fee);
        modal.find('#btn-add-voucher-renewal').attr('data-regulation', regulation);
        modal.find('#qualification_id').val(qualificationId);
        console.log($('#qualification_id').val());
            
     });

    $(document).on('click', '#payment-regulation-btns', function() {
        var action              = "payment_regulation_stripe";
        var token               = $("input[name=token]").val();
        var payment_fee         = $(this).attr("data-fee");
        var regulation_id       = $(this).attr("data-regulation");

        $.ajax({
                    url: '../content/ajax_itf_common.php',
                    dataType: "json",
                    data: {
                        action             : action,
                        token              : token,
                        payment_fee          : payment_fee,
                        regulation_id   : regulation_id,
                    },
                    success: function(data)
                    {                           
                        location.href = '?view=stripe&academy=112&course_id='+regulation_id;
                    }
        });
         
    });

    $(document).on("click", "#btn-submit-regulation-cpd", function(){
        var action          = "create_cpd_submission_request";
        var token           = $("input[name=token]").val();
        var regulation      = $('#regulation_name').val();
        var activityType    = $('#activity_type').val();
        var hoursAttained   = $('#hours_attained').val();
        var description     = $('#description_of_cpd').val();
        var regulation_id   = $("#payment-regulation-btns").attr("data-regulation");
        var question_1      = $("#question_1").text();
        var question_2      = $("#question_2").text();
        var question_3      = $("#question_3").text();
        var answer_1        = $("#answer_1").val();
        var answer_2        = $("#answer_2").val();
        var answer_3        = $("#answer_3").val(); 
        var dateAchievedILS = $('#date_achieved_ils').val();

        cmsLoadingStatus = true;
        loadOverlay();
        var formData        = new FormData();
        var files           = $('#file_attach')[0].files;
       
        if (files.length > 0) {
            for (var i = 0; i < files.length; i++) {
                formData.append('file_attach[]', files[i]);
            }
        }
        // Create FormData object
        formData.append('action', action);
        formData.append('token', token);
        formData.append('regulation_id', regulation_id);
        formData.append('question_1', question_1);
        formData.append('question_2', question_2);
        formData.append('question_3', question_3);
        formData.append('answer_1', answer_1);
        formData.append('answer_2', answer_2);
        formData.append('answer_3', answer_3);
        formData.append('date_achieved_ils', dateAchievedILS);
        $.ajax({
            url: '../content/ajax_itf_common.php',
            type: 'POST', 
            data: formData,
            contentType: false, 
            processData: false, 
            dataType: "json",
            success: function(data) {    
                if (data.error != null) {
                
                    alert(data.error);   
                    cmsLoadingStatus = false;               
                } 
                else {

                    location.reload();  
                }                           
                                     
            }
        });

    });

    $(document).on('change', '#qualification_name', function() {
        var action              = "check_qualification_type";
        var token               = $("input[name=token]").val();
        var qualificationid     = $(this).val();
       
        $.ajax({
                    url: '../content/ajax_itf_common.php',
                    dataType: "json",
                    data: {
                        action             : action,
                        token              : token,
                        qualificationid    : qualificationid
                    },
                    success: function(data)
                    {                           
                        var hasMet      = data.output["has_met_other"];
                        var allOther    = data.output["all_other_requirements"];
                        var qual        = data.output["qualification"];
                        var qualType    = qual[0].qualification_type;

                        $('.btn-qualification-request').attr("data-type", qualType);

                        if (qualType == "judging")
                        {
                            $("#activity_cpd_row").show();
                            $(".qualification-add").show();
                            $("#activity_qualification_row").hide();
                        }
                        else
                        {
                            $("#activity_cpd_row").hide();
                            $(".qualification-add").hide();
                            $("#activity_qualification_row").show();
                        }
                      
                    }
        });
         
    });

    $('#view-rejection-modal').on('show.bs.modal', function (event) {
        var span                = $(event.relatedTarget);
        console.log("sneaking open");
        var name                = span.attr('data-qualification-notes');
        var modal               = $(this);
        modal.find('#rejectMessage').html(name);
    });

    /*When switching tabs in course listing page to available courses, trigger search so that the list is correctly filtered*/
    $('.course_type_nav li').on('click', function() {        
        if ($("#available_courses_wrap").is(":visible"))
        {
            $("#available_courses_wrap").hide(); 
            if ($("#search_course_btn").length)
            {
                setTimeout(function(){
                    $("#available_courses_wrap").html(''); 
                    $("#available_courses_wrap").show(); 
                    $("#search_course_btn").trigger("click");
                }, 10);                
            }
            else
            {
                $("#available_courses_wrap").show(); 
            }
        }        
    });

    $(document).on('click', '#dismiss-modal-box', function() {
        $('.qualification-warning-wrapper').hide();

    });

    if ($('.renewal-tooltip-class').length) {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover'
        });
    }

    $(".card-header").on('click', function(){
         
        $(this).find('.panel-expand').toggle();
        $(this).find('.panel-collapse').toggle(); 
        var panelId = $(this).attr("data-attr");
         console.log($(this));
        if ($('#' + panelId).is(":hidden")) {

            $('#' + panelId).slideDown('fast','linear');    
        } else {                   
            
            $('#' + panelId).slideUp('fast','linear');                       
        }
        
    });

    /*Handle test submission with knowledge test reponses*/
    $(".knowledge-test-form-wrapper").on("submit", function(e) 
    {
        e.preventDefault(); // Prevent normal form submission
        $(".test-submit-error").addClass("d-none")

        let isAuto = $("#auto_submit_triggered").val() === "1";

        // If not auto-submitting, ask confirmation
        if (!isAuto) 
        {
            let confirmSubmission = confirm("Are you sure you want to submit the test? Once submitted, you cannot change your answers.");
            if (!confirmSubmission) return;
        }

        if (!isAuto)
        {
            if (!validateKnowledgeTestOnSubmit()) 
            {
                alert("Some questions are incomplete or invalid. Please check and correct them before submitting.");
                return;
            }
        }       
    
        var action   = "submit_user_test_response";
        var token    = $("input[name=token]").val();
        var joinId   = $("input[name=join_id]").val();
        var cktId    = $("input[name=ckt_id]").val();
        var formData = $(this).serializeArray();

        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url: "../cms/ajax_cms.php",
            dataType: "json",
            type: "POST",
            data: {
                action   : action,
                ptToken  : token,
                user_id  : userId,
                join_id  : joinId,
                ckt_id   : cktId,
                is_auto  : isAuto,
                responses: formData
            },
            success: function(response) 
            {
                if (response.status === "success") 
                {
                    alert("Test submitted successfully!");
                    location.reload(); // Redirect
                } 
                else 
                {
                    $(".test-submit-error").removeClass("d-none").html(response.errorMessage);
                }
            },
            error: function(xhr, status, error) 
            {
                console.error("Submission Error:", error);
                alert("Failed to submit test. Please try again.");
            }
        });
    });

    /*Auto-save knowledge test reponses*/
    $(".knowledge-test-form-wrapper input").on("change keyup", function() 
    { 
        autosaveUserTestResponse();
    });

    let autosaveTimeout;

    $(".knowledge-test-form-wrapper textarea").on("keyup change", function() 
    {
        clearTimeout(autosaveTimeout); // Cancel the previous autosave call
        autosaveTimeout = setTimeout(function() 
        {
            autosaveUserTestResponse(); // Call autosave after the delay
        }, 1000); // Adjust debounce time (1000ms = 1 second)
    });


}); //End of doc ready

function validateKnowledgeTestOnSubmit() {
    let isValid = true;

    // Validate all MCQs (radio and checkbox)
    $(".knowledge-test-form-wrapper ul").each(function () {
        const $ul = $(this);
        const $inputs = $ul.find("input");
        const questionId = $ul.data("question-id");

        const selected = $inputs.filter(":checked").length;
        const selectionError = $ul.next(".selection-error-message");
        const checkboxError = $ul.nextAll(".checkbox-error-message");

        const isCheckbox = $inputs.first().attr("type") === "checkbox";
        const expectedCount = parseInt($ul.attr("data-correct-count")) || 1;

        if (selected === 0) {
            selectionError.removeClass("d-none").text("Select at least one option for submission.");
            isValid = false;
        } else {
            selectionError.addClass("d-none");
        }

        if (isCheckbox && selected !== expectedCount) {
            checkboxError.removeClass("d-none").text("Select exactly " + expectedCount + " option(s) for submission.");
            isValid = false;
        } else {
            checkboxError.addClass("d-none");
        }
    });

    // Validate all longform questions
    $(".knowledge-test-form-wrapper textarea").each(function () {
        const $textarea = $(this);
        const wordMin = parseInt($textarea.attr("data-word-min")) || 0;
        const wordMax = parseInt($textarea.attr("data-word-limit")) || Infinity;
        const text = $textarea.val().trim();
        const wordCount = text.length ? text.split(/\s+/).length : 0;
        const errorMessage = $textarea.siblings(".error-message");

        if (wordCount < wordMin || wordCount > wordMax) {
            errorMessage.removeClass("d-none").text(`Word count: ${wordCount} (Min: ${wordMin}, Max: ${wordMax})`);
            isValid = false;
        } else {
            errorMessage.addClass("d-none");
        }
    });

    return isValid;
}


function autosaveUserTestResponse() 
{
    var action   = "autosave_user_test_response";
    var token    = $("input[name=token]").val();
    var joinId   = $("input[name=join_id]").val();
    var cktId    = $("input[name=ckt_id]").val();
    var userId   = $("input[name=user_id]").val();

    var formData = $(".knowledge-test-form-wrapper").serializeArray();

    // Add flagged questions to the form data
    $(".question-flag").each(function() 
    {
        let questionId = $(this).data("question-id");
        let isFlagged = $(this).hasClass("text-danger") ? "1" : "0";

        formData.push({ name: "flags[" + questionId + "]", value: isFlagged });
    });

    // Exclude unwanted fields (join_id, ckt_id, token, user_id)
    formData = formData.filter(function(item) {
        return !["join_id", "ckt_id", "token", "user_id"].includes(item.name);
    });

    // Disable submit button during autosave
    $(".knowledge-test-form-wrapper button[type=submit]").prop("disabled", true).text("Saving...");

    $.ajax({
        url: "../cms/ajax_cms.php",
        dataType: "json",
        type: "POST",
        data: {
            action  : action,
            ptToken : token,
            join_id : joinId,
            ckt_id  : cktId,
            user_id : userId,
            responses: formData
        },
        success: function(response) 
        {
            if (response.status === "success") 
            {
                console.log("Autosave successful.");
            } 
            else 
            {
                console.error("Autosave failed:", response.message);
            }                
        },
        error: function(xhr, status, error) 
        {
            console.error("Autosave AJAX Error:", error);                
        },
        complete: function() 
        {
            // Re-enable submit button after autosave is done
            $(".knowledge-test-form-wrapper button[type=submit]").prop("disabled", false).html("<i class='fas fa-paper-plane mr-1'></i> Submit Answers");
        }
    });
}


function toggleFlag(element) 
{
    let questionId = $(element).data("question-id");
    let isFlagged = $(element).hasClass("text-danger") ? 0 : 1;

    // Toggle the flag color
    $(element).toggleClass("text-danger text-secondary");

    // Trigger autosave
    autosaveUserTestResponse();

    // Update flagged count
    let flaggedCount = $(".question-flag.text-danger").length;
    if (flaggedCount > 0) {
        $("#flagged-question-count").text("Flagged Questions: " + flaggedCount);
        $("#flagged-counter").removeClass("d-none");
    } else {
        $("#flagged-counter").addClass("d-none");
    }
}


function updateSubTotal(e)
{
    var elem = e.target;   
    var elemId = $(elem).parent().parent().attr("id");
    var colDataAttr = $(elem).parent().attr("data-col-attr");
    var tableId = $(elem).parent().parent().parent().parent().attr("id");
    var subtotalId = elemId + "-subtotal";
    var grandTotalId = tableId + "-grand-total";
    var colTotalId = colDataAttr;

    var container = document.getElementById(elemId);
    var inputElements = container.querySelectorAll("input");
    var subtotal = 0;
    inputElements.forEach(function(input) {
        var val = input.value;
        if (val.trim() == "")
        {
            val = 0;
        }

        subtotal += parseInt(val);            
    });

    $('[id="' + subtotalId + '"]').html(subtotal);

    /*Update column subtotal*/
    var inputElements = document.getElementsByClassName(colDataAttr);
    var colTotal = 0;

    for (let i = 0; i < inputElements.length; i++) {
        var inputs = inputElements[i].getElementsByTagName("input");

        for (let j = 0; j < inputs.length; j++) {
            var val = inputs[j].value;
            if (val.trim() == "") {
                val = 0;
            }

            colTotal += parseInt(val);
        }
    }

    $('[id="' + colTotalId + '"]').html(colTotal);

    /*Also update grand total*/
    if ($('[id="' + grandTotalId + '"]').length)
    {
        var containerTable = document.getElementById(tableId);
        var inputElements = containerTable.querySelectorAll("input");
        var grandTotal = 0;
        inputElements.forEach(function(input) {
            var val = input.value;
            if (val.trim() == "")
            {
                val = 0;
            }

            grandTotal += parseInt(val);            
        });

        $('[id="' + grandTotalId + '"]').html("<label>Total: " + grandTotal + "</label>");
    }
}

function validateThresholdVals(e, qId, tier)
{
    var elem = e.target;
    var elemId = $(elem).attr("id");
    var minThresholdVal  = $('[id="' + elemId + '"]').data('threshold-min-value');
    var maxThresholdVal  = $('[id="' + elemId + '"]').data('threshold-max-value');
    
    var otherTextboxId = "";
    var tier_str = "Tier_1";

    if (qId == 1)
    { 
        otherTextboxId = "1*_*Tier_1*_*Total players*_* -reason-other-text";       

        var otherReasonDecreaseIdStr = "1*_*Tier_1*_*Total players*_* -reason-dropdown*_*significant-decrease-reason*_*Other, please state";
        var otherReasonIncreaseIdStr = "1*_*Tier_1*_*Total players*_* -reason-dropdown*_*significant-increase-reason*_*Other, please state";
        var otherReasonNoChangeIdStr = "1*_*Tier_1*_*Total players*_* -reason-dropdown*_*no-change-reason*_*Other, please state";

        if (tier == "tier-2")
        {
            otherTextboxId = "1*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text";            

            var otherReasonDecreaseIdStr = "1*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*significant-decrease-reason*_*Other, please state";
            var otherReasonIncreaseIdStr = "1*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*significant-increase-reason*_*Other, please state";
            var otherReasonNoChangeIdStr = "1*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*no-change-reason*_*Other, please state";
        }
    }
    else if (qId == 4)
    {        
        otherTextboxId = "4*_*Tier_1*_*Total clubs*_* -reason-other-text";

        var otherReasonDecreaseIdStr = qId + "*_*Tier_1*_*Total clubs*_* -reason-dropdown*_*significant-decrease-reason*_*Other, please state";
        var otherReasonIncreaseIdStr = qId + "*_*Tier_1*_*Total clubs*_* -reason-dropdown*_*significant-increase-reason*_*Other, please state";
        var otherReasonNoChangeIdStr = qId + "*_*Tier_1*_*Total clubs*_* -reason-dropdown*_*no-change-reason*_*Other, please state";
    } 
    else if (qId == 8)
    {        
        otherTextboxId = "8*_*Tier_1*_*Total coaches*_* -reason-other-text";

        var otherReasonDecreaseIdStr = qId + "*_*Tier_1*_*Total coaches*_* -reason-dropdown*_*significant-decrease-reason*_*Other, please state";
        var otherReasonIncreaseIdStr = qId + "*_*Tier_1*_*Total coaches*_* -reason-dropdown*_*significant-increase-reason*_*Other, please state";
        var otherReasonNoChangeIdStr = qId + "*_*Tier_1*_*Total coaches*_* -reason-dropdown*_*no-change-reason*_*Other, please state";

        if (tier == "tier-2")
        {
            otherTextboxId = "8*_*Tier_2*_*Gender breakdown*_*Female-reason-other-text";            

            var otherReasonDecreaseIdStr = "8*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*significant-decrease-reason*_*Other, please state";
            var otherReasonIncreaseIdStr = "8*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*significant-increase-reason*_*Other, please state";
            var otherReasonNoChangeIdStr = "8*_*Tier_2*_*Gender breakdown*_*Female-reason-dropdown*_*no-change-reason*_*Other, please state";
        }
    } 
    else if (qId == 5)
    {        
        otherTextboxId = "5*_*Tier_1*_*Total courts*_* -reason-other-text";

        var otherReasonDecreaseIdStr = qId + "*_*Tier_1*_*Total courts*_* -reason-dropdown*_*significant-decrease-reason*_*Other, please state";
        var otherReasonIncreaseIdStr = qId + "*_*Tier_1*_*Total courts*_* -reason-dropdown*_*significant-increase-reason*_*Other, please state";
        var otherReasonNoChangeIdStr = qId + "*_*Tier_1*_*Total courts*_* -reason-dropdown*_*no-change-reason*_*Other, please state";
    }    

    $('[id="' + elemId + '-reason-info"]').find(".threshold-msg").each(function(){
        $(this).hide();
    });

    $('[id="' + elemId + '-reason-info"]').find(".threshold-dropdown").each(function(){
        $(this).hide();
    });
    
    if ($('[id="' + elemId + '"]').val() == "")
    {
        return;
    }

    if (($('[id="' + elemId + '"]').val() <= minThresholdVal))
    {       
        $('[id="' + elemId + '-reason-info"]').find("#threshold-msg-decrease").show();
        $('[id="' + elemId + '-reason-info"]').find(".threshold-reason-decrease-dropdown").show();

        if ($('[id="' + otherReasonDecreaseIdStr + '"]').is(":checked"))
        {
            $('[id="'+otherTextboxId+'"]').show();
            $('[id="'+otherTextboxId+'"]').prop('required', true);
            $('[id="'+otherTextboxId+'"]').prop('disabled', false);
        }
        else
        {
            $('[id="'+otherTextboxId+'"]').hide();
            $('[id="'+otherTextboxId+'"]').prop('required', false);
            $('[id="'+otherTextboxId+'"]').prop('disabled', true);
        }
    }
    else if (($('[id="' + elemId + '"]').val() >= maxThresholdVal))
    {
        $('[id="' + elemId + '-reason-info"]').find("#threshold-msg-increase").show();
        $('[id="' + elemId + '-reason-info"]').find(".threshold-reason-increase-dropdown").show();

        if ($('[id="' + otherReasonIncreaseIdStr + '"]').is(":checked"))
        {
            $('[id="'+otherTextboxId+'"]').show();
            $('[id="'+otherTextboxId+'"]').prop('required', true);
            $('[id="'+otherTextboxId+'"]').prop('disabled', false);
        }
        else
        {
            $('[id="'+otherTextboxId+'"]').hide();
            $('[id="'+otherTextboxId+'"]').prop('required', false);
            $('[id="'+otherTextboxId+'"]').prop('disabled', true);
        }
    }
    else
    {
        $('[id="' + elemId + '-reason-info"]').find("#threshold-msg-no-change").show();
        $('[id="' + elemId + '-reason-info"]').find(".threshold-reason-no-change-dropdown").show();

        if ($('[id="' + otherReasonNoChangeIdStr + '"]').is(":checked"))
        {
            $('[id="' + otherTextboxId + '"]').show();
            $('[id="' + otherTextboxId + '"]').prop('required', true);
            $('[id="' + otherTextboxId + '"]').prop('disabled', false);
        }
        else
        {
            $('[id="' + otherTextboxId + '"]').hide();
            $('[id="' + otherTextboxId + '"]').prop('required', false);
            $('[id="' + otherTextboxId + '"]').prop('disabled', true);
        }
    }
}

function removeSectionSubAdmin(sectionUserId, targetId, surveyId, surveySectionId)
{
    var action   = "remove_na_survey_section_admin";
    var token    = $("input[name=token]").val();

    cmsLoadingStatus = true;
    loadOverlay();
    $(".invalid-feedback").hide();

    $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            type: "post",
            data: {
                action  : action,
                token   : token,
                surveyId: surveyId,
                sectionUserId   : sectionUserId
            },
            success: function(data)
            {            
                setTimeout(function(){ 
                    if (typeof data.output != "undefined")
                    {   
                        setTimeout(function(){
                            cmsLoadingStatus = false;  
                            $(targetId).remove();
                        }, 100);
                    }
                    else if (data.errorMessage != null)
                    {
                        $("#sub-admin-error-msg-" + surveySectionId).show();
                        $("#sub-admin-error-msg-" + surveySectionId).text(data.errorMessage);
                        cmsLoadingStatus = false;                         
                    }
                    else
                    {
                        cmsLoadingStatus = false;   
                    }              
                }, 500);
            }

        });
}

function saveItfUserPositionForSurvey(position, area)
{
    var action   = "save_user_position";
    var token    = $("input[name=token]").val();
    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action  : action,
                token   : token,
                position : position,
                area: area
            },
            success: function(data)
            {     
                setTimeout(function(){
                    cmsLoadingStatus = false; 
                    $('#position-success-message').show();

                    setTimeout(function(){                                       
                        $('#position-selection-modal').modal('hide');
                    }, 1000);

                }, 1000);       
                
               
            }
        });
}

function addSectionSubAdmin(e)
{
    e.preventDefault();    
    var elem = e.target;
    var surveySectionId = $(elem).attr("id").split("-")[3];
    var surveyId = $(elem).data("survey-id");
    var targetId = "#subadmin-input-" +  surveySectionId;

    var email = $(targetId).val();
    var action   = "add_na_survey_section_admin";
    var token    = $("input[name=token]").val();
    $(".invalid-feedback").hide();

    cmsLoadingStatus = true;
    loadOverlay();

    try{
        $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            type: "post",
            data: {
                action  : action,
                token   : token,
                targetEmail   : email,
                surveyId: surveyId,
                surveySectionId: surveySectionId
            },
            success: function(data)
            {            
                setTimeout(function(){ 
                    if (typeof data.output != "undefined")
                    {   
                        cmsLoadingStatus = false;  

                        if (typeof data.output.survey_section_user_id != "undefined")
                        {
                            $(targetId).val("");                            
                            $("#no-section-admin-added-" + surveySectionId).hide();
                            var usersArea = "#section-admins-list-"+surveySectionId;
                            $(usersArea).append('<div class="row" id="section-admin-row-'+ data.output.survey_section_user_id +'"><div class="col-8 border-bottom border-light"><p>' + email + '</p></div><div class="col-4 text-right"><span id="remove-section-admin-`+ data.output.survey_section_user_id +`" class="remove-evidence-document p-2"><i class="fa fa-times"></i></span></div></div>');  
                        
                            $(".remove-section-sub-admin").on('click', function(){
                                var sectionUserId = $(this).attr('id').split("-")[3];
                                var surveyId = $(this).data('survey-id');
                                var targetId = "#" + "section-admin-row-" + sectionUserId;    
                                var surveySectionId = $(this).data('survey-section-id');                                                          
                                removeSectionSubAdmin(sectionUserId, targetId, surveyId, surveySectionId);
                            });
                        } 
                    }
                    else if (data.errorMessage != null)
                    {
                        $("#sub-admin-error-msg-" + surveySectionId).show();
                        $("#sub-admin-error-msg-" + surveySectionId).text(data.errorMessage);
                        cmsLoadingStatus = false; 
                        $(targetId).val(""); 
                    }
                    else
                    {
                        cmsLoadingStatus = false;                         
                        $(targetId).val("");
                    }              
                }, 500);
            }

        });
    }
    catch(e) 
    {
        console.log(e)
        cmsLoadingStatus = false;  
        $(targetId).val("");
    }
    finally
    {
        
    }

}

function validateCustomNASurveyLogic(errId, questionCode, formId, questionId)
{
    /*Percentage type questions. Check if they add upto 100%*/
    var percentageTypeQuestions = ['2-ACC-VEN-3','6-FIN-GEN-2','6-FIN-GEN-4'];
    if (percentageTypeQuestions.includes(questionCode))
    {
        var percentageSum = 0;

        $(formId).find('select').each(function() {
            var isDisabled = $(this).attr('disabled');
            if (!isDisabled)
            {
                percentageSum += parseInt($(this).val().split("%")[0]);                
            }
        });

        if (percentageSum != 100)
        {        
            $(errId).html("Total percentage must be equal to 100%").show();
            return false;
        }
    }    

    /*Custom Logic for 5-GOV-GEN-1*/
    if (questionCode == "5-GOV-GEN-1")
    {
        var dropdown1ID = questionId + "*_*Tier_1*_*a) Response*_*Start Year";
        var dropdown2ID = questionId + "*_*Tier_1*_*a) Response*_*End Year";
        var isDisabled = $('[id="' + dropdown1ID + '"]').attr('disabled');

        if (!isDisabled)
        {
            var dropdown1Val = parseInt($('[id="' + dropdown1ID + '"]').val());
            var dropdown2Val = parseInt($('[id="' + dropdown2ID + '"]').val());

            if ((dropdown1Val >= dropdown2Val))
            {
                $(errId).html("Start Year cannot be greater than or equal to End Year").show();
                return false;
            }
        }
    }

    /*Custom Logic for 4-MKT-GEN-1*/
    if (questionCode == "4-MKT-GEN-1") 
    {
        var selectedOptions = [];
        var dupeFound = false;
        $('#survey-main-response-tier-1-0 select').each(function () {
            var selectedOption = $(this).val();

            // Check for duplicates
            if (selectedOptions.includes(selectedOption)) 
            {
                $(errId).html("Select unique sport for each row").show();
                dupeFound = true;
                return false;
            } 
            else 
            {
                selectedOptions.push(selectedOption);
            }
        });

        if (dupeFound)
        {
            return false;
        }
    }

    /*Custom Logic for 4-MKT-GEN-3*/
    if (questionCode == "4-MKT-GEN-3") 
    {
        var selectedOptions = [];
        var dupeFound = false;
        $('#survey-main-response-tier-1-2 select').each(function () {
            var selectedOption = $(this).val();

            // Check for duplicates
            if (selectedOptions.includes(selectedOption)) 
            {
                $(errId).html("Select unique sport for each row").show();
                dupeFound = true;
                return false;
            } 
            else 
            {
                selectedOptions.push(selectedOption);
            }
        });

        if (dupeFound)
        {
            return false;
        }
    }

    if (questionCode == "6-FIN-GEN-7")
    {
        var selectedOptions = [];
        var dupeFound = false;
        $('#survey-main-response-tier-1-6 select').each(function () {
            var selectedOption = $(this).val();

            // Check for duplicates
            if (selectedOptions.includes(selectedOption)) 
            {
                $(errId).html("Select unique area for each row").show();
                dupeFound = true;
                return false;
            } 
            else 
            {
                selectedOptions.push(selectedOption);
            }
        });

        if (dupeFound)
        {
            return false;
        }
    }

    if (questionCode == "10-STR-GEN-1")
    {
        var selectedOptions = [];
        var dupeFound = false;
        $('#survey-main-response-tier-1-0 select').each(function () {
            var selectedOption = $(this).val();

            // Check for duplicates
            if (selectedOptions.includes(selectedOption)) 
            {
                $(errId).html("Select unique pillar for each row").show();
                dupeFound = true;
                return false;
            } 
            else 
            {
                selectedOptions.push(selectedOption);
            }
        });

        if (dupeFound)
        {
            return false;
        }
    }

    if (questionCode == "10-STR-GEN-2")
    {
        var selectedRadioCount = 0;
        $('#survey-main-response-tier-1-1 .form-check-input').each(function () {
            if ($(this).is(':checked')) {
                selectedRadioCount++;
            }
        });

        if (selectedRadioCount > 3)
        {
            $(errId).html("Select maximum of three pillars").show();
            return false;
        }

    } 

    if (questionCode == "5-GOV-GEN-9")
    {
        var selectedOptions = [];
        var dupeFound = false;
        $('#survey-main-response-tier-1-8 select').each(function () {
            if (!$(this).prop('disabled'))
            {
                var selectedOption = $(this).val();

                // Check for duplicates
                if (selectedOptions.includes(selectedOption)) 
                {
                    $(errId).html("Select unique rank for each objective").show();
                    dupeFound = true;
                    return false;
                } 
                else 
                {
                    selectedOptions.push(selectedOption);
                }
            }
        });

        if (dupeFound)
        {
            return false;
        }

        if (selectedOptions.length != 3)
        {
            $(errId).html("Select three objectives").show();
            return false;
        }
    }  

    return true;    
}

function resetReasonCheckboxes(questionId)
{
    var tiers = ['tier-1', 'tier-2'];
    for (var k = 0; k < tiers.length; k++) 
    {
        var checkboxes = document.querySelectorAll('input[type="checkbox"]');
        var isNoChangeSelected = false;
        var isDecreaseSelected = false;
        var isIncreaseSelected = false;

        for (var i = 0; i < checkboxes.length; i++) {
            var checkbox = checkboxes[i];

            if (checkbox.id.includes('*_*significant-decrease-reason*_*') && checkbox.id.includes(questionId) && checkbox.offsetParent !== null && checkbox.getAttribute("data_tier") == tiers[k]) {
                isDecreaseSelected = checkbox.checked;
                if (isDecreaseSelected)
                {
                    break; 
                }
            }
        }

        for (var i = 0; i < checkboxes.length; i++) {
            var checkbox = checkboxes[i];

            if (checkbox.id.includes('*_*significant-increase-reason*_*') && checkbox.id.includes(questionId) && checkbox.offsetParent !== null && checkbox.getAttribute("data_tier") == tiers[k]) {
                isIncreaseSelected = checkbox.checked;
                if (isIncreaseSelected)
                {
                    break; 
                }
            }
        }

        for (var i = 0; i < checkboxes.length; i++) {
            var checkbox = checkboxes[i];

            if (checkbox.id.includes('*_*no-change-reason*_*') && checkbox.id.includes(questionId) && checkbox.offsetParent !== null && checkbox.getAttribute("data_tier") == tiers[k]) {
                isNoChangeSelected = checkbox.checked;
                if (isNoChangeSelected)
                {
                    break; 
                }
            }
        }
        
        if (isNoChangeSelected)
        {       
            checkboxes.forEach(function(checkbox) {       
            if (checkbox.id.includes('*_*significant-decrease-reason*_*') && checkbox.id.includes(questionId) && checkbox.getAttribute("data_tier") == tiers[k]) {            
                checkbox.checked = false;
            }
            });

            checkboxes.forEach(function(checkbox) {       
                if (checkbox.id.includes('*_*significant-increase-reason*_*') && checkbox.id.includes(questionId) && checkbox.getAttribute("data_tier") == tiers[k]) {            
                    checkbox.checked = false;
                }
            });
        }

        if (isDecreaseSelected)
        {
            checkboxes.forEach(function(checkbox) {       
            if (checkbox.id.includes('*_*no-change-reason*_*') && checkbox.id.includes(questionId) && checkbox.getAttribute("data_tier") == tiers[k]) {            
                checkbox.checked = false;
            }
            });

            checkboxes.forEach(function(checkbox) {       
                if (checkbox.id.includes('*_*significant-increase-reason*_*') && checkbox.id.includes(questionId) && checkbox.getAttribute("data_tier") == tiers[k]) {            
                    checkbox.checked = false;
                }
            });
        }

        if (isIncreaseSelected)
        {        
            checkboxes.forEach(function(checkbox) {       
            if (checkbox.id.includes('*_*significant-decrease-reason*_*') && checkbox.id.includes(questionId) && checkbox.getAttribute("data_tier") == tiers[k]) {            
                checkbox.checked = false;
            }
            });

            checkboxes.forEach(function(checkbox) {       
                if (checkbox.id.includes('*_*no-change-reason*_*') && checkbox.id.includes(questionId) && checkbox.getAttribute("data_tier") == tiers[k]) {            
                    checkbox.checked = false;
                }
            });
        }
    }
}

function validateReasonCheckboxes(errId, questionId, questionCode)
{   
    var validQuesCodes = ["2-ACC-VEN-1","1-PLY-GEN-1","3-DEL-CED-1","2-ACC-VEN-2"];    
    var isValid = true;
    var tiers = ['tier-1', 'tier-2'];   
    var tiers_id = ['Tier_1', 'Tier_2'];    
    
    if (!validQuesCodes.includes(questionCode))
    {
        return true;
    }
    
    for (var k = 0; k < tiers.length; k++) 
    {
        $(".threshold-reason-increase-dropdown").each(function(){
            if (($(this).parent().attr('id').includes(tiers_id[k])))
            {
                if ($(this).css('display') == "block")
                {
                    var isIncreaseSelected = false;
                    var hasIncreaseCheckboxes = false;
                    var checkboxes = document.querySelectorAll('input[type="checkbox"]');
                    for (var i = 0; i < checkboxes.length; i++) 
                    {
                        var checkbox = checkboxes[i];

                        if (!checkbox.disabled && checkbox.id.includes('*_*significant-increase-reason*_*') && checkbox.id.includes(questionId) && checkbox.offsetParent !== null && checkbox.getAttribute("data_tier") == tiers[k]) {
                            isIncreaseSelected = checkbox.checked;
                            hasIncreaseCheckboxes = true;
                            if (isIncreaseSelected)
                            {
                                break; 
                            }
                        }
                    }

                    if (hasIncreaseCheckboxes && !isIncreaseSelected)
                    {
                        $(errId).html("Select at least one valid reason for the increase for " + questionCode + "." + (k+1)).show();
                        isValid = false;
                        return false;
                    }
                }
            }
        });
    }

    if (isValid)
    {
        for (var k = 0; k < tiers.length; k++) 
        {
            $(".threshold-reason-decrease-dropdown").each(function(){
                if (($(this).parent().attr('id').includes(tiers_id[k])))
                {
                    if ($(this).css('display') == "block")
                    {
                        var isDecreaseSelected = false;
                        var hasDecreaseCheckboxes = false;
                        var checkboxes = document.querySelectorAll('input[type="checkbox"]');
                        for (var i = 0; i < checkboxes.length; i++) 
                        {
                            var checkbox = checkboxes[i];

                            if (!checkbox.disabled && checkbox.id.includes('*_*significant-decrease-reason*_*') && checkbox.id.includes(questionId) && checkbox.offsetParent !== null && checkbox.getAttribute("data_tier") == tiers[k]) {
                                isDecreaseSelected = checkbox.checked;
                                hasDecreaseCheckboxes = true;
                                if (isDecreaseSelected)
                                {
                                    break; 
                                }
                            }
                        }

                        if (hasDecreaseCheckboxes && !isDecreaseSelected)
                        {
                            $(errId).html("Select at least one valid reason for the decrease for " + questionCode + "." + (k+1)).show();
                            isValid = false;
                            return false;
                        }
                    }
                }
            });
        }
    }

    if (isValid)
    {
        for (var k = 0; k < tiers.length; k++) 
        {
            $(".threshold-reason-no-change-dropdown").each(function(){
                if (($(this).parent().attr('id').includes(tiers_id[k])))
                {
                    if ($(this).css('display') == "block")
                    {
                        var isNoChangeSelected = false;
                        var hasNoChangeCheckboxes = false;
                        var checkboxes = document.querySelectorAll('input[type="checkbox"]');
                        for (var i = 0; i < checkboxes.length; i++) 
                        {
                            var checkbox = checkboxes[i];

                            if (!checkbox.disabled && checkbox.id.includes('*_*no-change-reason*_*') && checkbox.id.includes(questionId) && checkbox.offsetParent !== null && checkbox.getAttribute("data_tier") == tiers[k]) {
                                isNoChangeSelected = checkbox.checked;
                                hasNoChangeCheckboxes = true;
                                if (isNoChangeSelected)
                                {
                                    break; 
                                }
                            }
                        }

                        if (hasNoChangeCheckboxes && !isNoChangeSelected)
                        {
                            $(errId).html("Select at least one valid reason for no change for  " + questionCode + "." + (k+1)).show();
                            isValid = false;
                            return false;
                        }
                    }
                }
            });
        }
    }
    
    if (isValid)
    {
        return true;
    }

    return false;
}

function surveyQuestionSubmit(e)
{
    e.preventDefault();    
    var elem                    = e.target;
    var questionId              = $(elem).attr("id").split("_")[1];
    var saveBtnId               = "#" + questionId + "-save-question-btn";    
    var targetdivId             = "#" + $(saveBtnId).data("target");
    var surveySectionQuestionId = $(saveBtnId).data("survey-section-question-id");
    var surveyId                = $(saveBtnId).data("survey-id");
    var sectionCode             = $(saveBtnId).data("section-code");
    var questionCode            = $(saveBtnId).data("question-code");
    var formId                  = "#form_" + surveySectionQuestionId;
    var formData                = {};
    var errId = "#" + surveySectionQuestionId + "-save-error-msg";

    $(errId).hide();
    var isValid = validateCustomNASurveyLogic(errId, questionCode, formId, questionId); 
    if (!isValid) 
    {
        return false;
    }

    var isValid = validateReasonCheckboxes(errId, questionId, questionCode); 
    if (!isValid) 
    {
        return false;
    } 

    resetReasonCheckboxes(surveySectionQuestionId);

    $(formId).find('input, select, textarea').each(function() {

        var type = $(this).attr('type');
        var isDisabled = $(this).attr('disabled');
        if (!isDisabled)
        {
            if (type === 'radio') 
            {
                if ($(this).is(':checked')) 
                {
                    formData[this.name] = $(this).val();
                }
            } 
            else if (type !== 'checkbox' || $(this).is(':checked')) 
            {              
                formData[this.name] = $(this).val();
            }
        }
    });

    formData['evidence'] = [];

    $("#evidence-uploaded-files-" + surveySectionQuestionId + " div").each(function() {

        if ($(this).data('upload-type') == "document")
        {
            var documentId = $(this).attr("id").split("-")[2];
            formData['evidence'].push({"document_id" : documentId});
        }

        if ($(this).data('upload-type') == "link")
        {
            var elId = "#" + $(this).attr("id");
            var linkUrl = $(elId + " .evidence-para").text();
            formData['evidence'].push({"linkUrl" : linkUrl});
        }
    });   

    $(saveBtnId).text("Saving...");

    cmsLoadingStatus = true;
    loadOverlay();

    var action   = "save_na_survey_individual_question_response";
    var token    = $("input[name=token]").val();
    var countryId = getParameterByName('country_id'); //Will be present if admin is viewing it
    
    try{
        $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action  : action,
                token   : token,
                surveyId: surveyId,
                surveySectionQuestionId: surveySectionQuestionId,
                sectionCode: sectionCode,
                countryId: countryId,
                formData : formData
            },
            success: function(data)
            {            
                setTimeout(function(){  

                    formModified = false;
                    $(window).off('beforeunload');

                    if ((sectionCode == "WHC") && ((questionCode == "11-WHC-GEN-1") || (questionCode == "11-WHC-GEN-2")))
                    {
                        location.reload();
                    }
                    else if ((sectionCode == "BEA") && ((questionCode == "12-BEA-GEN-2") || (questionCode == "12-BEA-GEN-1") || (questionCode == "12-BEA-ACC-5")))
                    {
                        location.reload();
                    }
                    else if ((sectionCode == "VAR") && ((questionCode == "16-VAR-CUS-1")))
                    {
                        location.reload();
                    }
                    else if ((sectionCode == "DIG") && ((questionCode == "13-DIG-GEN-1") || (questionCode == "13-DIG-GEN-7")))
                    {
                        location.reload();
                    }  
                    else if ((sectionCode == "MKT") && ((questionCode == "4-MKT-GEN-1")))
                    {
                        location.reload();
                    } 
                    else if ((sectionCode == "FIN") && ((questionCode == "6-FIN-GEN-4")))
                    {
                        location.reload();
                    }                  
                    else
                    {
                        cmsLoadingStatus = false;  
                    }
                    
                    $(saveBtnId).text("Saved");

                    setTimeout(function(){
                        $(saveBtnId).text("Save");
                        $("#chevron-wrapper-" + surveySectionQuestionId).addClass("complete");
                        $("#chevron-info-" + surveySectionQuestionId).addClass("complete");
                        toggleSurveyQuestionVisibility(targetdivId);
                    }, 1000);                    
                }, 500);
            }

        });
    }
    catch(e) 
    {
        $(saveBtnId).text("Save");
    }
}  


function triggerChangeEventForSpecificItems()
{
    /*Not required*/
    /*var surveyPLY_2_CustomCheckboxId = "2*_*Tier_1*_* No register or database*_* ";
    if ($('[id="' + surveyPLY_2_CustomCheckboxId + '"]').is(":visible"))
    {
        $('[id="' + surveyPLY_2_CustomCheckboxId + '"]').trigger('change');
    }*/

    var surveyPLY_3_CustomCheckboxId = "3*_*Tier_1*_* No register or database*_* ";
    if ($('[id="' + surveyPLY_3_CustomCheckboxId + '"]').is(":visible"))
    {
        $('[id="' + surveyPLY_3_CustomCheckboxId + '"]').trigger('change');
    }

    var survey3_DEL_OTH_12_CustomCheckboxId = "19*_*Tier_1*_*a) None*_* ";
    if ($('[id="' + survey3_DEL_OTH_12_CustomCheckboxId + '"]').is(":visible"))
    {
        $('[id="' + survey3_DEL_OTH_12_CustomCheckboxId + '"]').trigger('change');
    }

    var venue_4_custom_radio_no = "7*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + venue_4_custom_radio_no + '"]').is(":visible") && $('[id="' + venue_4_custom_radio_no + '"]').is(":checked"))
    {        
        $('[id="7*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="7*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="7*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="7*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var del_7_custom_radio_no = "14*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + del_7_custom_radio_no + '"]').is(":visible") && $('[id="' + del_7_custom_radio_no + '"]').is(":checked"))
    {        
        $('[id="14*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="14*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="14*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="14*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var del_10_custom_radio_no = "17*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + del_10_custom_radio_no + '"]').is(":visible") && $('[id="' + del_10_custom_radio_no + '"]').is(":checked"))
    {        
        $('[id="17*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="17*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="17*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="17*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');

        $("#survey-data-source-wrapper-9 #survey-data-source").addClass('disabled');
        $("#survey-data-source-wrapper-9 input").each(function(){
            $(this).attr('disabled', 'disabled');
            $(this).removeAttr('required');
        });
    }

    var gov_5_custom_radio_no = "29*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + gov_5_custom_radio_no + '"]').is(":visible") && $('[id="' + gov_5_custom_radio_no + '"]').is(":checked"))
    {        
        $('[id="29*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="29*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="29*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="29*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }  

    /*6-FIN-GEN-3*/
    if ($('[id="40*_*Tier_1*_*a) Response*_*Do not wish to disclose"]').is(":visible") && $('[id="40*_*Tier_1*_*a) Response*_*Do not wish to disclose"]').is(":checked")) 
    {
        $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_2"]').prop("checked", true).trigger("change").hide();
        $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_3"]').prop("checked", true).trigger("change").hide();
        var labelElement1 = $('label[for="40*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        var labelElement2 = $('label[for="40*_*i_do_not_have_this_breakdown_information_Tier_3"]'); 
        labelElement1.addClass('disabled-label');
        labelElement2.addClass('disabled-label');
    } 
    else if ($('[id="40*_*Tier_1*_*a) Response*_*Annual revenue total range (USD only)"]').is(":visible") && $('[id="40*_*Tier_1*_*a) Response*_*Annual revenue total range (USD only)"]').is(":checked")) 
    {
        $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_2"]').prop("checked", true).trigger("change").hide();
        $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_3"]').prop("checked", false).trigger("change").show();

        var labelElement1 = $('label[for="40*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        var labelElement2 = $('label[for="40*_*i_do_not_have_this_breakdown_information_Tier_3"]'); 
        labelElement1.addClass('disabled-label');
        labelElement2.removeClass('disabled-label');
    }
    else if ($('[id="40*_*Tier_1*_*a) Response*_*Annual revenue total"]').is(":visible") && $('[id="40*_*Tier_1*_*a) Response*_*Annual revenue total"]').is(":checked")) 
    {
        $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_3"]').prop("checked", true).trigger("change").hide();
        $('[id="40*_*i_do_not_have_this_breakdown_information_Tier_2"]').prop("checked", false).trigger("change").show();

        var labelElement1 = $('label[for="40*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        var labelElement2 = $('label[for="40*_*i_do_not_have_this_breakdown_information_Tier_3"]'); 
        labelElement1.removeClass('disabled-label');
        labelElement2.addClass('disabled-label');
    }  

    var survey6_FIN_GEN_4_CustomSelectId = "41*_*Tier_1*_*e) Other area (Please state)*_*% of Total Income";
    if ($('[id="' + survey6_FIN_GEN_4_CustomSelectId + '"]').is(":visible"))
    {
        $('[id="' + survey6_FIN_GEN_4_CustomSelectId + '"]').trigger('change');
    } 

    var survey6_FIN_GEN_5_CustomId = "42*_*Tier_1*_*h) Other area (please state)*_* ";
    if ($('[id="' + survey6_FIN_GEN_5_CustomId + '"]').is(":visible"))
    {
        $('[id="' + survey6_FIN_GEN_5_CustomId + '"]').trigger('change');
    } 

    var survey6_FIN_GEN_6_CustomId1 = "43*_*Tier_1*_*e) Other #1 (Please state)*_* ";
    if ($('[id="' + survey6_FIN_GEN_6_CustomId1 + '"]').is(":visible"))
    {
        $('[id="' + survey6_FIN_GEN_6_CustomId1 + '"]').trigger('change');
    }

    var survey6_FIN_GEN_6_CustomId2 = "43*_*Tier_1*_*f) Other #2 (Please state)*_* ";
    if ($('[id="' + survey6_FIN_GEN_6_CustomId2 + '"]').is(":visible"))
    {
        $('[id="' + survey6_FIN_GEN_6_CustomId2 + '"]').trigger('change');
    }   

    /*var survey6_FIN_GEN_6_CustomCheckboxId = "43*_*Tier_1*_*g) No membership categories in place*_* ";
    if ($('[id="' + survey6_FIN_GEN_6_CustomCheckboxId + '"]').is(":visible"))
    {
        $('[id="' + survey6_FIN_GEN_6_CustomCheckboxId + '"]').trigger('change');
    }*/

    var par_1_custom_radio_no = "45*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + par_1_custom_radio_no + '"]').is(":visible") && $('[id="' + par_1_custom_radio_no + '"]').is(":checked"))
    {        
        $('[id="45*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="45*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="45*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="45*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }  

    var survey7_PAR_1_CustomCheckboxId = "45*_*Tier_2*_*h) Other (Please state)*_* ";
    if ($('[id="' + survey7_PAR_1_CustomCheckboxId + '"]').length)
    {
        $('[id="' + survey7_PAR_1_CustomCheckboxId + '"]').trigger('change');
    }

    var par_7_5_customRadio = "49*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + par_7_5_customRadio + '"]').is(":visible") && $('[id="' + par_7_5_customRadio + '"]').is(":checked"))
    {        
        $('[id="49*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="49*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="49*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="49*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    } 

    var par_7_6_customRadio = "50*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + par_7_6_customRadio + '"]').is(":visible") && $('[id="' + par_7_6_customRadio + '"]').is(":checked"))
    {        
        $('[id="50*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="50*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="50*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="50*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    } 

    var eve_9_1_customRadio = "57*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + eve_9_1_customRadio + '"]').is(":visible") && $('[id="' + eve_9_1_customRadio + '"]').is(":checked"))
    {        
        $('[id="57*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="57*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="57*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="57*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var eve_9_4_customRadio = "60*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + eve_9_4_customRadio + '"]').is(":visible") && $('[id="' + eve_9_4_customRadio + '"]').is(":checked"))
    {        
        $('[id="60*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="60*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="60*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="60*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var eve_9_5_customRadio = "61*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + eve_9_5_customRadio + '"]').is(":visible") && $('[id="' + eve_9_5_customRadio + '"]').is(":checked"))
    {        
        $('[id="61*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="61*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="61*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="61*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var eve_9_6_customRadio = "62*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + eve_9_6_customRadio + '"]').is(":visible") && $('[id="' + eve_9_6_customRadio + '"]').is(":checked"))
    {        
        $('[id="62*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="62*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="62*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="62*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var eve_9_7_customRadio = "63*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + eve_9_7_customRadio + '"]').is(":visible") && $('[id="' + eve_9_7_customRadio + '"]').is(":checked"))
    {        
        $('[id="63*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="63*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="63*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="63*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var survey10_str_4_CustomCheckboxId1 = "67*_*Tier_1*_*d) Other (Please state)*_*ITF Website";
    if ($('[id="' + survey10_str_4_CustomCheckboxId1 + '"]').length)
    {
        $('[id="' + survey10_str_4_CustomCheckboxId1 + '"]').trigger('change');
    }

    var survey10_str_4_CustomCheckboxId2 = "67*_*Tier_1*_*d) Other (Please state)*_*Social Media (ie, Facebook, X (formerly Twitter), Instagram, YouTube, LinkedIn, TikTok)";
    if ($('[id="' + survey10_str_4_CustomCheckboxId2 + '"]').length)
    {
        $('[id="' + survey10_str_4_CustomCheckboxId2 + '"]').trigger('change');
    }

    var survey10_str_par_5_CustomSelectId = "68*_*Tier_1*_*i) Other (Please state)*_* ";
    if ($('[id="' + survey10_str_par_5_CustomSelectId + '"]').is(":visible"))
    {
        $('[id="' + survey10_str_par_5_CustomSelectId + '"]').trigger('change');
    }

    var whc_11_1_customRadio = "75*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + whc_11_1_customRadio + '"]').is(":visible") && $('[id="' + whc_11_1_customRadio + '"]').is(":checked"))
    {        
        $('[id="75*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="75*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="75*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="75*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var whc_11_2_customRadio = "76*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + whc_11_2_customRadio + '"]').is(":visible") && $('[id="' + whc_11_2_customRadio + '"]').is(":checked"))
    {        
        $('[id="76*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="76*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="76*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="76*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var whc_11_5_customRadio = "79*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + whc_11_5_customRadio + '"]').is(":visible") && $('[id="' + whc_11_5_customRadio + '"]').is(":checked"))
    {        
        $('[id="79*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="79*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="79*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="79*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var whc_11_6_customRadio = "80*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + whc_11_6_customRadio + '"]').is(":visible") && $('[id="' + whc_11_6_customRadio + '"]').is(":checked"))
    {        
        $('[id="80*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="80*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="80*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="80*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var bea_12_1_customRadio = "84*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + bea_12_1_customRadio + '"]').is(":visible") && $('[id="' + bea_12_1_customRadio + '"]').is(":checked"))
    {        
        $('[id="84*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="84*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="84*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="84*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var bea_12_2_customRadio = "85*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + bea_12_2_customRadio + '"]').is(":visible") && $('[id="' + bea_12_2_customRadio + '"]').is(":checked"))
    {        
        $('[id="85*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="85*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="85*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="852*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var bea_12_8_customRadio = "91*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + bea_12_8_customRadio + '"]').is(":visible") && $('[id="' + bea_12_8_customRadio + '"]').is(":checked"))
    {        
        $('[id="91*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="91*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="91*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="91*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var bea_12_9_customRadio = "92*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + bea_12_9_customRadio + '"]').is(":visible") && $('[id="' + bea_12_9_customRadio + '"]').is(":checked"))
    {        
        $('[id="92*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="92*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="92*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="92*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var dig13_gen_2_customId1 = "94*_*Tier_1*_*v) Other #1 (Please state)*_* ";
    if ($('[id="' + dig13_gen_2_customId1 + '"]').is(":visible"))
    {
        $('[id="' + dig13_gen_2_customId1 + '"]').trigger('change');
    }

    var dig13_gen_2_customId2 = "94*_*Tier_1*_*w) Other #2 (Please state)*_* ";
    if ($('[id="' + dig13_gen_2_customId2 + '"]').is(":visible"))
    {
        $('[id="' + dig13_gen_2_customId2 + '"]').trigger('change');
    }

    var dig13_gen_3_customId = "95*_*Tier_1*_*e) Other #1 (Please state)*_* ";
    if ($('[id="' + dig13_gen_3_customId + '"]').is(":visible"))
    {
        $('[id="' + dig13_gen_3_customId + '"]').trigger('change');
    }

    var dig13_gen_5_customId1 = "97*_*Tier_1*_*v) Other #1 (Please state)*_* ";
    if ($('[id="' + dig13_gen_5_customId1 + '"]').is(":visible"))
    {
        $('[id="' + dig13_gen_5_customId1 + '"]').trigger('change');
    }

    var dig13_gen_5_customId2 = "97*_*Tier_1*_*w) Other #2 (Please state)*_* ";
    if ($('[id="' + dig13_gen_5_customId2 + '"]').is(":visible"))
    {
        $('[id="' + dig13_gen_5_customId2 + '"]').trigger('change');
    }

    var dig13_gen_6_customId = "98*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + dig13_gen_6_customId + '"]').is(":visible") && $('[id="' + dig13_gen_6_customId + '"]').is(":checked"))
    {        
        $('[id="98*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="98*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="98*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="98*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var dig13_gen_8_customId = "100*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + dig13_gen_8_customId + '"]').is(":visible") && $('[id="' + dig13_gen_8_customId + '"]').is(":checked"))
    {        
        $('[id="100*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="100*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="100*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="100*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var dis15_1_customId = "102*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + dis15_1_customId + '"]').is(":visible") && $('[id="' + dis15_1_customId + '"]').is(":checked"))
    {        
        $('[id="102*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="102*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="102*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="102*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var dis15_1_custom_checkboxid = "102*_*Tier_2*_*d) Other #1 (Please state)*_* ";
    if ($('[id="' + dis15_1_custom_checkboxid + '"]').length)
    {
        $('[id="' + dis15_1_custom_checkboxid + '"]').trigger('change');
    }

    var var_oth_4 = "113*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + var_oth_4 + '"]').is(":visible") && $('[id="' + var_oth_4 + '"]').is(":checked"))
    {        
        $('[id="113*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="113*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="113*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="113*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var var_pad_4 = "114*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + var_pad_4 + '"]').is(":visible") && $('[id="' + var_pad_4 + '"]').is(":checked"))
    {        
        $('[id="114*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="114*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="114*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="114*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var var_pic_4 = "115*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + var_pic_4 + '"]').is(":visible") && $('[id="' + var_pic_4 + '"]').is(":checked"))
    {        
        $('[id="115*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="115*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="115*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="115*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var var_pop_4 = "116*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + var_pop_4 + '"]').is(":visible") && $('[id="' + var_pop_4 + '"]').is(":checked"))
    {        
        $('[id="116*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="116*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="116*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="116*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var var_oth_5 = "117*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + var_oth_5 + '"]').is(":visible") && $('[id="' + var_oth_5 + '"]').is(":checked"))
    {        
        $('[id="117*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="117*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="117*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="117*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var var_pad_5 = "118*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + var_pad_5 + '"]').is(":visible") && $('[id="' + var_pad_5 + '"]').is(":checked"))
    {        
        $('[id="118*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="118*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="118*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="118*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var var_pic_5 = "119*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + var_pic_5 + '"]').is(":visible") && $('[id="' + var_pic_5 + '"]').is(":checked"))
    {        
        $('[id="119*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="119*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="119*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="119*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    var var_pop_5 = "120*_*Tier_1*_*a) Response*_*No";
    if ($('[id="' + var_pop_5 + '"]').is(":visible") && $('[id="' + var_pop_5 + '"]').is(":checked"))
    {        
        $('[id="120*_*i_do_not_have_this_breakdown_information_Tier_2"]').attr("checked", true);
        $('[id="120*_*i_do_not_have_this_breakdown_information_Tier_2"]').trigger("change");
        $('[id="120*_*i_do_not_have_this_breakdown_information_Tier_2"]').hide();
        var labelElement1 = $('label[for="120*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        labelElement1.addClass('disabled-label');
    }

    if ($("#table_Tier_1_34").is(":visible"))
    {
        checkMaxCheckboxSelection();
    }

    var gov5_9_custom_checkboxid1 = "34*_*Tier_1*_*t) Other #1 (Please state)*_* ";
    if ($('[id="' + gov5_9_custom_checkboxid1 + '"]').is(":visible"))
    {
        $('[id="' + gov5_9_custom_checkboxid1 + '"]').trigger('change');
    }

    var gov5_9_custom_checkboxid2 = "34*_*Tier_1*_*u) Other #2 (Please state)*_* ";
    if ($('[id="' + gov5_9_custom_checkboxid2 + '"]').is(":visible"))
    {
        $('[id="' + gov5_9_custom_checkboxid2 + '"]').trigger('change');
    }

    var gov5_9_custom_checkboxid3 = "34*_*Tier_1*_*v) Other #3 (Please state)*_* ";
    if ($('[id="' + gov5_9_custom_checkboxid3 + '"]').is(":visible"))
    {
        $('[id="' + gov5_9_custom_checkboxid3 + '"]').trigger('change');
    }

    if ($("#table_Tier_1_74").is(":visible"))
    {
        toggleExtraTextForCheckbox('#table_Tier_1_74');
        $('#table_Tier_1_74 input[type="checkbox"]').change();
    }

    $('#table_Tier_1_104').on('change', 'input[type="checkbox"]', function() {
        if ($(this).attr('id') !== '104*_*Tier_1*_*e) None*_* ') 
        {
            // If any checkbox other than "e) None" is checked, uncheck "e) None"
            if ($(this).prop('checked')) 
            {
                $('[id="104*_*Tier_1*_*e) None*_* "]').prop('checked', false);
            }
        } 
        else 
        {
            // If "e) None" is checked, uncheck all other checkboxes
            if ($(this).prop('checked')) 
            {
                $(this).closest('table').find('input[type="checkbox"]').not(this).prop('checked', false);
            }

            $('[id="104*_*Tier_1*_*d) Other (Please state)*_* "]').trigger('change');             
        }
    });

    var var16_1_custom_checkboxid = "104*_*Tier_1*_*d) Other (Please state)*_* ";
    if ($('[id="' + var16_1_custom_checkboxid + '"]').length)
    {
        $('[id="' + var16_1_custom_checkboxid + '"]').trigger('change');
    }

    if ($("#table_Tier_1_101").is(":visible"))
    {
        toggleExtraTextForCheckbox('#table_Tier_1_101');
        $('#table_Tier_1_101 input[type="checkbox"]').change();
    }

    var breakdownCheckbox8_npp_gen_3 = "53*_*i_do_not_have_this_breakdown_information_Tier_2";    
    if ($('[id="' + breakdownCheckbox8_npp_gen_3 + '"]').length)
    {
        $('[id="' + breakdownCheckbox8_npp_gen_3 + '"]').trigger('change');
    }

    $('#table_Tier_1_43').on('change', 'input[type="checkbox"]', function() {
        var labelElement1 = $('label[for="43*_*i_do_not_have_this_breakdown_information_Tier_2"]'); 
        var labelElement2 = $('label[for="43*_*i_do_not_have_this_breakdown_information_Tier_3"]');

        if ($(this).attr('id') !== '43*_*Tier_1*_*g) No membership categories in place*_* ') 
        {
            // If any checkbox other than "g) No membership categories in place" is checked, uncheck "g) No membership categories in place"
            if ($(this).prop('checked')) 
            {
                $('[id="43*_*Tier_1*_*g) No membership categories in place*_* "]').prop('checked', false);
            }
        } 
        else 
        {
            // If "g) No membership categories in place" is checked, uncheck all other checkboxes
            if ($(this).prop('checked')) 
            {
                $(this).closest('table').find('input[type="checkbox"]').not(this).prop('checked', false);
            }

            $('[id="43*_*Tier_1*_*e) Other #1 (Please state)*_* "]').trigger('change');
            $('[id="43*_*Tier_1*_*f) Other #2 (Please state)*_* "]').trigger('change');             
        }

        if ($('[id="43*_*Tier_1*_*g) No membership categories in place*_* "]').is(":checked"))
        {
            $('[id="43*_*i_do_not_have_this_breakdown_information_Tier_2"]').prop("checked", true).trigger("change").hide();
            $('[id="43*_*i_do_not_have_this_breakdown_information_Tier_3"]').prop("checked", true).trigger("change").hide();
            labelElement1.addClass('disabled-label');
            labelElement2.addClass('disabled-label');
        }
        else
        {
            $('[id="43*_*i_do_not_have_this_breakdown_information_Tier_2"]').prop("checked", false).trigger("change").show();
            $('[id="43*_*i_do_not_have_this_breakdown_information_Tier_3"]').prop("checked", false).trigger("change").show();
            labelElement1.removeClass('disabled-label');
            labelElement2.removeClass('disabled-label');
        }     
    });
}

function toggleExtraTextForCheckbox(tableId)
{
    $(tableId + ' input[type="checkbox"]').change(function () {        
        var checkboxIndex = $(this).closest('tr').index();       
        var inputTextBox = $(tableId + ' input[type="text"]').eq(checkboxIndex);
        
        if ($(this).prop('checked')) 
        {
            inputTextBox.prop('disabled', false);
            inputTextBox.prop('required', true);
            inputTextBox.show();
        } 
        else 
        {
            inputTextBox.prop('disabled', true);
            inputTextBox.prop('required', false);
            inputTextBox.hide();
        }
    });
}

function checkMaxCheckboxSelection()
{
    var checkboxes = $('#table_Tier_1_34 input[type="checkbox"]');
    var maxCheckboxes = 3;

    checkboxes.change(function() {
        var checkedCheckboxes = checkboxes.filter(':checked');

        if (checkedCheckboxes.length > maxCheckboxes) 
        {
            $(this).prop('checked', false);
            alert("Only three objectives can be selected");            
        }
        else
        {
            $('[id="34*_*Tier_1*_*t) Other #1 (Please state)*_* "]').on('change', function(){
            if ($(this).is(":checked"))
            {
                $('[id="34*_*Tier_1*_*t) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').show();   
                $('[id="34*_*Tier_1*_*t) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
                $('[id="34*_*Tier_1*_*t) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
            }
            else
            {
                $('[id="34*_*Tier_1*_*t) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
                $('[id="34*_*Tier_1*_*t) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
                $('[id="34*_*Tier_1*_*t) Other #1 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
            }
        }); 

        $('[id="34*_*Tier_1*_*u) Other #2 (Please state)*_* "]').on('change', function(){
            if ($(this).is(":checked"))
            {
                $('[id="34*_*Tier_1*_*u) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').show();   
                $('[id="34*_*Tier_1*_*u) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
                $('[id="34*_*Tier_1*_*u) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
            }
            else
            {
                $('[id="34*_*Tier_1*_*u) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
                $('[id="34*_*Tier_1*_*u) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
                $('[id="34*_*Tier_1*_*u) Other #2 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
            }
        });

        $('[id="34*_*Tier_1*_*v) Other #3 (Please state)*_* "]').on('change', function(){
            if ($(this).is(":checked"))
            {
                $('[id="34*_*Tier_1*_*v) Other #3 (Please state)*_*other-specify-text_other_please_state_text"]').show();   
                $('[id="34*_*Tier_1*_*v) Other #3 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', true); 
                $('[id="34*_*Tier_1*_*v) Other #3 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', false);           
            }
            else
            {
                $('[id="34*_*Tier_1*_*v) Other #3 (Please state)*_*other-specify-text_other_please_state_text"]').hide(); 
                $('[id="34*_*Tier_1*_*v) Other #3 (Please state)*_*other-specify-text_other_please_state_text"]').prop('required', false);
                $('[id="34*_*Tier_1*_*v) Other #3 (Please state)*_*other-specify-text_other_please_state_text"]').prop('disabled', true);
            }
        });


        var checkboxIndex = checkboxes.index(this);
        var selectBox = $('#table_Tier_1_34 select').eq(checkboxIndex);

        // Enable or disable the select box based on checkbox state
        if ($(this).prop('checked')) 
        {
            selectBox.prop('disabled', false);
            selectBox.prop('required', true);
        } 
        else 
        {
            selectBox.val('');
            selectBox.prop('disabled', true);
            selectBox.prop('required', false);
        }            
        }
    });
}

function triggerKeyUpEventForQuestionsWithReasons()
{
    var venueQuestionInputIdWithReason = "4*_*Tier_1*_*Total clubs*_* ";
    if ($('[id="' + venueQuestionInputIdWithReason + '"]').is(":visible"))
    {
        $('[id="' + venueQuestionInputIdWithReason + '"]').trigger('keyup');           
    }

    var playersQuestionInputIdWithReason = "1*_*Tier_1*_*Total players*_* ";
    if ($('[id="' + playersQuestionInputIdWithReason + '"]').is(":visible"))
    {
        $('[id="' + playersQuestionInputIdWithReason + '"]').trigger('keyup');           
    }

    var playersQuestionInputIdWithReasonTierTwo = "1*_*Tier_2*_*Gender breakdown*_*Female";
    if ($('[id="' + playersQuestionInputIdWithReasonTierTwo + '"]').is(":visible"))
    {
        $('[id="' + playersQuestionInputIdWithReasonTierTwo + '"]').trigger('keyup');           
    }

    var coachesQuestionInputIdWithReason = "8*_*Tier_1*_*Total coaches*_* ";
    if ($('[id="' + coachesQuestionInputIdWithReason + '"]').is(":visible"))
    {
        $('[id="' + coachesQuestionInputIdWithReason + '"]').trigger('keyup');           
    }

    var coachesQuestionInputIdWithReasonTierTwo = "8*_*Tier_2*_*Gender breakdown*_*Female";
    if ($('[id="' + coachesQuestionInputIdWithReasonTierTwo + '"]').is(":visible"))
    {
        $('[id="' + coachesQuestionInputIdWithReasonTierTwo + '"]').trigger('keyup');           
    }

    var courtsQuestionInputIdWithReason = "5*_*Tier_1*_*Total courts*_* ";
    if ($('[id="' + courtsQuestionInputIdWithReason + '"]').is(":visible"))
    {
        $('[id="' + courtsQuestionInputIdWithReason + '"]').trigger('keyup');           
    }
}


function toggleSurveyQuestionVisibility(targetdivId)
{
    $(targetdivId).slideToggle(300, function(){
        $(".survey-question-container").addClass("disabled");
    
        if ($(targetdivId).is(":visible"))
        {               
            $(this).parent().parent().parent().removeClass('disabled');            
        }
        else
        {               
            $(".survey-question-container").removeClass("disabled");
        }
    });
}

function savePreSurveyQuestionnaireResponse(surveyId)
{
    cmsLoadingStatus = true;
    loadOverlay();
    var preSurveyData = [];

    $(".pre-survey-radio").each(function() {        
        if ($(this).is(":checked")) {            
            var value = $(this).val();            
            var questionId = $(this).data("question-id");

            var questionAnswer = {
              questionId: questionId,
              answer: value
            };
            
            // Push the object to the data array
            preSurveyData.push(questionAnswer);
        }
    });

    var action   = "save_presurvey_questionnaire_response";
    var token    = $("input[name=token]").val();
    
    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action  : action,
            token   : token,
            preSurveyData : preSurveyData,
            surveyId: surveyId
        },
        success: function(data)
        {            
            setTimeout(function(){                
                location.reload();
            }, 2000);
        }
    });
}

function uploadContentItemS3(elemId)
{
    var ptToken     = $("input[name=token]").val();
    var contentVideo   = document.getElementById(elemId).files[0];

    var formData = new FormData();
    formData.append('file', contentVideo);
    formData.append('ptToken', ptToken);
    $('#loading-dialog').show();

    $.ajax({
        url: '../content/upload_content_item_video.php',
        dataType: "json",
        type: "POST",
        data: formData,
        contentType: false,
        cache: false,
        processData:false,      
        success: function(data)
        {
            if (data.errorMessage != null)
            {
                $('#loading-dialog').hide();
                console.log(data.errorMessage);
            }
            else
            {
                $('#loading-dialog').hide();               
                $(".video_preview_"+elemId+ " video").attr('src', data.output);
                $(".video_preview_"+elemId).show();
                var inputElement = document.querySelector("input[type='hidden'][name='" + elemId + "']");
                inputElement.value = data.output;
            }
        }
    });
}

function loadStateByCountryCode()
{
    cmsLoadingStatus = true;
    loadOverlay();

    $(".status-message").remove();
    $("#state_input_div").append('<i class="status-message">Loading ...</i>');

    $("#state_id").slideUp();
    var country_code = $("#country_code option:selected").val();
    var token = $("input[name=token]").val();
    $.ajax({
        url: '/course_admin/ajax_get_region.php',
        dataType: "json",
        type: "POST",
        data: {            
            ptToken : token,
            function: 'loadStates',
            country_code: country_code
        },
        success: function (data)
        {
            if ((data.output == "") || (data.output == null))
            {
                $("#state_id").hide();
                $("#state_id").attr('required', false); 
                $(".status-message").remove();
                $("#state_input_div").append('<i class="status-message">State(s) not available!</i>');
            }
            else
            {
                $(".status-message").remove();
                $("#state_id").attr('required', true);
                $("#state_id").show();                
                $("#state_id").html(data.output);
                $("#state_id").slideDown();
            }
            cmsLoadingStatus = false;
        }
    });
}

function loadStateByCountry()
{
    cmsLoadingStatus = true;
    loadOverlay();

    $(".status-message").remove();
    $("#select-wrapper-state_id").append('<i class="status-message">Loading ...</i>');

    $("#state_id").slideUp();
    var country_id = $("#country_id option:selected").val();
    var token = $("input[name=token]").val();
    $.ajax({
        url: '/course_admin/ajax_get_region.php',
        dataType: "json",
        type: "POST",
        data: {            
            ptToken : token,
            function: 'loadStates',
            country_id: country_id
        },
        success: function (data)
        {
            if ((data.output == "") || (data.output == null))
            {
                $("#state_id").hide();
                $("#state_id").next(".select2-container").hide();
                $(".status-message").remove();
                $("#select-wrapper-state_id").append('<i class="status-message">State(s) not available!</i>');
            }
            else
            {
                $(".status-message").remove();
                $("#state_id").show();    
                $("#state_id").next(".select2-container").show();            
                $("#state_id").html(data.output);
                $("#state_id").slideDown();
            }
            cmsLoadingStatus = false;
        }
    });
}

function initTooltipForDelivererRolesTable()
{    
    if ($("#existing_deliverer_roles_table_paginate .paginate_button").length)
    {
        $("#existing_deliverer_roles_table_paginate .paginate_button").on('click', function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            }); 
        });
    }
}

function initTooltipForRoleUsersTable()
{    
    if ($(".paginate_button").length)
    {
        $(".paginate_button").on('click', function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            }); 
        });
    }
}

function toggleAddRoleButton()
{    
    if ($("#role_name_inp").val().trim() != "")
    {
        $(".add-role-btn").prop('disabled', false);

        $(document).keydown(function(e) {
            if(e.which == 13) {

                if ($(".add-role-btn").text() != "Update")
                {
                    addDelivererRole(); 
                }
            }
        });
    }
    else
    {
        $(".add-role-btn").prop('disabled', true);
        $(document).off("keydown");
    }
}

function toggleAddCertificationButton()
{
    if ($("#certification-name-txt").val().trim() != "")
    {
        $("#add-certification-btn").prop('disabled', false);
    }
    else
    {
        $("#add-certification-btn").prop('disabled', true);
        $(document).off("keydown");
    }
}

function toggleAddRegulationButton()
{
    if ($("#regulation-name-txt").val().trim() != "")
    {
        $("#add-regulation-btn").prop('disabled', false);
    }
    else
    {
        $("#add-cregulation-btn").prop('disabled', true);
        $(document).off("keydown");
    }
}

function preloadUrlExcel(url, reportArray, type, title)
{   
    if (type === "gauges")
    {
        var new_arr = {gauges: url}; 
        reportArray.push(new_arr);  
    }
    else
    {
        var new_arr = {svg: url, title: title}; 
        reportArray.push(new_arr);  
    }
    
   
}


function merge_svg()
{
     var svgArr = [],
                    top = 0,
                    width = 0;

    for (var i=1; i <= 3; i++)
    {
        if (i == 1)
        {
            var svg = $('#respondents-gauge-chart').highcharts().getSVG();
        }
        else if (i == 2)
        {
             var svg = $('#net-promoter-gauge-chart').highcharts().getSVG();
        }
        else
        {
            var svg = $('#overall-assess-gauge-chart').highcharts().getSVG(); 
        }
        
            // Get width/height of SVG for export
          var  svgWidth = +svg.match(
                /^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/
            )[1],
            svgHeight = +svg.match(
                /^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/
            )[1];

        svg = svg.replace(
            '<svg',
            '<g transform="translate(0,' + top + ')" '
        );
        svg = svg.replace('</svg>', '</g>');

        top += svgHeight;
        width = Math.max(width, svgWidth);

        svgArr.push(svg);
    }

    return '<svg height="' + top + '" width="' + width +
        '" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
        svgArr.join('') + '</svg>';

}

function loadFunctionalAreas()
{
    var gamesEdition = $("#organisation").val();
    var token = $("input[name=token]").val();
    if(gamesEdition != '')
    {
        $.ajax({
            url: '../content/ajax_load_functional_areas.php',
            dataType: "json",
            data: {
                gamesEdition: gamesEdition,
                ptToken : token
            },
            success: function (response)
            {
                if(response == 'error_1')
                {
                    $("#groupOptions").empty();
                    var output = "<div style='margin-top:10px;color:gray;font-size:1.1em;'>No functional areas found!</div>";
                    $("#groupOptions").html(output);
                }
                else
                {
                    var length = response.length;
                    $("#groupOptions").empty();
                    var output = '';
                    for(var i = 0; i < length; i++)
                    {
                        var id      = response[i]['id'];
                        var name    = response[i]['name'];
                        var checked = response[i]['checked'];
                        output  += "<div style='clear:both;'><input class='required' style='margin-right: 5px;background:transparent; border:0px;' type='radio' name='functional_area' value='"+name+"' ";
                        if(checked === 1)
                        {
                            output  += "checked='yes'";
                        }
                        output  += "/>"+name+"</div>";
                    }
                    $("#groupOptions").html(output);
                }
            }
        });
    }
    else
    {
        $("#groupOptions").empty();
        var output = "<div style='margin-top:10px;color:gray;font-size:1.1em;'>Please select an organization to load functional areas!</div>";
        $("#groupOptions").html(output);
    }
}

function searchGridViewElements()
{
    var selectdValue       = $("#intervention_type").val();
    var selectdValueFilter = $("#intervention_type_filter").val();
    var pathwayVersionId= $(".lp-select-header option:selected").val();
    var functionVal     = "filterInterventionsGrid";
    var pathwayCategory = $("#pathway-category-select option:selected").val();
    var gamesEditionId  = $(".games-logo").attr("data-index");            
    var token           = $("input[name=token]").val();

    $(".dash-loader").css('display', 'flex');

    $.post("/course_admin/ajax_load_intervention_detail.php", {functionVal: functionVal, pathwayVersionId: pathwayVersionId, pathway_category: pathwayCategory, gamesEditionId: gamesEditionId, ptToken: token, searchKey: selectdValue, searchKeyFilter: selectdValueFilter}, function (result) {
        $("#interventions-list").hide();
        $(".pathway-fade").hide();
        $(".dash-loader").hide();
        $("#interventions-grid-list-section").html(result).fadeIn(200);

        $(".current-intervention-grid > a:first-child").click(function (e) {
            e.preventDefault();
            showInterventionDetailPage($(this), '');
        });
    });
}

function setSessionDropdownDefaults()
{
    $(".session-selector-instance option").each(function () {
        $(this).prop("disabled", false);
    });

    $(".session-selector-instance").each(function () {
        var selectedId = $(this).val();
        var selectedName = $(this).prop("name");

        $('.session-selector-instance').each(function (i, obj) {
            if ($(this).prop("name") != selectedName)
            {
                $("option[value='" + selectedId + "']", $(this)).prop("disabled", true);
            }
        });
    });
}

var historyState = [];

function onSessionFilterSelected()
{
    var w_id = $("#select-visit-dropdown option:selected").val();
    var ocog = $("#select-ocog-dropdown option:selected").val();
    var token = $('input[name="token"]').val();

    var functionType    = "session_charts";
    $.ajax({
            url: '../course_admin/ajax_generate_feedback_charts.php',
            dataType: "json",
            data: {
                function        : functionType,
                workshop_id     : w_id,
                ocog            : ocog,
                ptToken         : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != null)
                    {
                        $('#reports-summary-area').html(data.output);
                    }
                    else if (data.error != null)
                    {
                        alert("Error");
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
}


function renderReport(course_id, reportType, is_attendance_report)
{
    var functionType = reportType;
    var token        = $('input[name="token"]').val();
    var isSuperUser  = $('input[name="isSuperUser"]').val();

    $(".reports-loader").show();

    $.ajax({
        url: '../course_admin/ajax_generate_feedback_charts.php',
        dataType: "json",
        data: {
            function                : functionType,
            course_id               : course_id,
            is_attendance_report    : is_attendance_report,
            ptToken                 : token
        },
        success: function(data)
        {
            try
            {
                if (data.output != null)
                {
                    $(".reports-loader").hide();
                    $('#reports-summary-area').html(data.output);

                    if (isSuperUser == 1)
                    {
                        loadFiltersInStages('all');
                    }
                    else
                    {
                        loadFiltersInStages('other');
                    }                    
                }
                else if (data.error != null)
                {
                    alert("Error");
                }
            }
            catch(e)
            {
               alert("Something went wrong." + e);
            }
        }
    });
}

function onChartTypeSelected(course)
{
    var temp = historyState[historyState.length - 1];
    var chart_type = $("#chart-type-dropdown option:selected").val();
    var ocog = $("#select-ocog-dropdown option:selected").val();
    var token = $("input[name=token]").val();

    var functionType = chart_type;
    $(".reports-loader").show();

    $("#dates-range-selection").hide();
    $("#visit-selection").hide();

    if (chart_type == "per_session_summary")
    {
        $("#visit-selection").show();
        var w_id = $("#select-visit-dropdown option:selected").val();

        if ((temp == undefined) || ((temp.chart_type != "per_session_summary") || (temp.ocog != ocog) || (temp.w_id != w_id)))
        {
            historyState[historyState.length] = {chart_type: "per_session_summary", ocog: ocog, w_id: w_id};
        }

        onSessionFilterSelected();
    }
    else
    {
        if (chart_type == "daily_summary")
        {
            if ((temp == undefined) || ((temp.chart_type != chart_type) || (temp.ocog != ocog) || (temp.course != course)))
            {
                historyState[historyState.length] = {chart_type: chart_type, ocog: ocog, course: course};
            }
        }

        if (chart_type == "visit_type_summary")
        {
            $("#dates-range-selection").show();
            var startDate = $("#start-date").val();
            var endDate = $("#end-date").val();

            if ((temp == undefined) || ((temp.chart_type != chart_type) || (temp.ocog != ocog) || (temp.course != course) || (temp.startDate != startDate) || (temp.endDate != endDate)))
            {
                historyState[historyState.length] = {chart_type: chart_type, ocog: ocog, course: course, startDate: startDate, endDate: endDate};
            }
        }

        $.ajax({
            url: '../course_admin/ajax_generate_feedback_charts.php',
            dataType: "json",
            data: {
                function: functionType,
                course_id: course,
                range_start_date: startDate,
                range_end_date: endDate,
                ocog: ocog,
                ptToken : token
            },
            success: function (data)
            {
                try
                {
                    if (data.output != null)
                    {
                        $(".reports-loader").hide();
                        $('#reports-summary-area').html(data.output);
                        $(".datepicker").datepicker({dateFormat: "dd-mm-yy"});
                    }
                    else if (data.error != null)
                    {
                        alert("Error");
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    }
}

function onDailySummaryChartClick(dateSelected, courseId, ocog)
{
    $("#daily-session-expanded-report").hide();
    $(".reports-loader").fadeIn();
    var token = $("input[name=token]").val();

    if (dateSelected == "")
    {
        alert("Something went wrong.");
    }
    else
    {
        var functionType = "daily_expanded_chart";
        $.ajax({
            url: '../course_admin/ajax_generate_feedback_charts.php',
            dataType: "json",
            data: {
                function: functionType,
                date_selected: dateSelected,
                course_id: courseId,
                ocog: ocog,
                ptToken : token
            },
            success: function (data)
            {
                try
                {
                    setTimeout(function () {
                        if (data.output != null)
                        {
                            $(".reports-loader").hide();
                            $("#daily-session-expanded-report").fadeIn(300);
                            $("#daily-session-expanded-report").html(data.output);
                        }
                        else if (data.error != null)
                        {
                            alert("Error");
                        }
                    }, 300);
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    }

}

function onBackButtonClicked()
{
    historyState.pop();
    var arrlength = historyState.length;

    if (arrlength == 0)
    {
        window.history.back();
    }
    else
    {
        var temp = historyState[historyState.length - 1];

        if (temp.chart_type == "per_session_summary")
        {
            $("#chart-type-dropdown").val("per_session_summary");
            $("#select-ocog-dropdown").val(temp.ocog);
            $("#select-visit-dropdown").val(temp.w_id);
            onChartTypeSelected(null);
        }
        else if (temp.chart_type == "daily_summary")
        {
            $("#chart-type-dropdown").val("daily_summary");
            $("#select-ocog-dropdown").val(temp.ocog);
            onChartTypeSelected(temp.course);
        }
        else if (temp.chart_type == "visit_type_summary")
        {
            $("#chart-type-dropdown").val("visit_type_summary");
            $("#select-ocog-dropdown").val(temp.ocog);
            $("#start-date").val(temp.startDate);
            $("#start-date").val(temp.endDate);
            onChartTypeSelected(temp.course);
        }
    }
}

function onPathwaySelected()
{
    var pathwayVersionId = $(".lp-select-header option:selected").val();
    var functionType = "load_interventions";
    var pathwayCategory  = $("#pathway-category-select option:selected").val();
    var token = $('input[name="token"]').val();
    var viewActive = "timeline";
    var gamesEditionId = $(".games-logo").attr("data-index");

    var pageURL     = window.location.href;
    if (pageURL.includes("&layout=grid"))
    {
        viewActive = "grid";
    }

    if ($("#interventions-grid-list-section").is(":visible"))
    {
        viewActive = "grid";
    }

    $("#interventions-list").hide();
    $("#interventions-grid-list-section").hide();
    $("#interventions-message").hide();
    $(".dash-loader").css('display', 'flex');
    $('.pre-reading-box').hide();

    $.ajax({
        url: '../content/ajax_load_interventions.php',
        dataType: "json",
        data: {
            function: functionType,
            pathway_v_id: pathwayVersionId,
            pathway_category: pathwayCategory,
            gamesEditionId: gamesEditionId,
            ptToken: token
        },
        success: function (data)
        {
            try
            {
                setTimeout(function () {
                    if (data.output != null)
                    {
                        $(".dash-loader").hide();

                        //Bind JS after AJAX
                        if (viewActive == "timeline")
                        {
                            $("#interventions-grid-list-section").hide();
                            $("#interventions-list").show();
                            $(".grid-view-btn-wrapper").show();

                            interventions = data.output;
                            currentInterventionIndex = getTimeLineStartPoint();
                            configurePreRead();
                            changePathwayColour('left');
                        }
                        else if (viewActive == "grid")
                        {
                            $("#grid-view-nav-btn").click();
                        }
                    }
                    else if (data.error != null)
                    {
                        $("#interventions-grid-list-section").hide();
                        $("#interventions-list").hide();
                        $(".grid-view-btn-wrapper").show();
                        $(".dash-loader").hide();
                        $("#interventions-message").show();
                        $("#interventions-message").html(data.error);
                    }
                }, 300);

                var pageURL        = window.location.href;
                var requestList    = pageURL.split("&");
                var interventionId = '';
                interventionId     = pageURL.split("&intervention_id=")[1];

                var newURL      = requestList[0] +"&"+ requestList[1] +"&"+ requestList[2];
                if (gamesEditionId != '')
                {
                    newURL += "&games_edition=" + gamesEditionId;
                }
                if (pathwayCategory != '')
                {
                    newURL += "&pathway_category=" + pathwayCategory;
                }
                if (pathwayVersionId != '')
                {
                    newURL += "&pathway_id=" + pathwayVersionId;
                }
                if (typeof interventionId !== typeof undefined && interventionId !== false) 
                {
                    newURL += "&intervention_id=" + interventionId;
                }

                window.history.pushState("", "", newURL);
                newURL = '';          
            }
            catch (e)
            {
                $("#interventions-list").show();
                $(".dash-loader").hide();
                alert("Something went wrong. : " + e);
            }
        },
        error: function ()
        {
            $(".dash-loader").hide();
            alert("Something went wrong.");
        }
    });

    if (pageURL.includes("&intervention_id"))
    {
        var intervention_id = pageURL.split("&intervention_id=")[1];
        showInterventionDetailPage('', intervention_id);
    }
}

function getTimeLineStartPoint()
{
    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    var currentDate = new Date(y, m, 1);
    var timeLineStartPoint = 1;
    for (var i = 0; i < interventions.length; i++) 
    {
        //var actualTimeframe = new Date(interventions[i]['actual_timeframe']); 
        var actualTimeframeToSplit =  interventions[i]['actual_timeframe'].split(' ');

        var actualTimeframe = new Date(actualTimeframeToSplit[0]  + '1, ' + actualTimeframeToSplit[1]); 

        if((interventions[i]['games_timeframe'] != -100) && (actualTimeframe < currentDate) && (interventions.length > 1))
        {
            timeLineStartPoint++;
        }                               
    }

    if (interventions.length < timeLineStartPoint)
    {
        timeLineStartPoint--;
    }
    return timeLineStartPoint;
}

function createProgrammeSharedIntervention()
{
    var functionType         = 'create_programme_for_shared_intervention';
    var token                = $("input[name=token]").val();
    var sharedInterventionId = $("input[name=shared_intervention_id]").val(); 
    $.ajax({
        url: '../course_admin/ajax_publish_intervention_as_course.php',
        dataType: "json",
        data: {
            function: functionType,
            ptToken : token,
            shared_intervention_id : sharedInterventionId
        },
        success: function (data)
        {
            var url = window.location.href;
            var url_part = url.split("sub_tab=");
            window.location.replace(url_part[0] + "sub_tab=8" );
        }
    });
}

function unassignProgrammeSharedIntervention()
{
    var confirmation = confirm("Are you sure you want to unassign this programme?");
    if(confirmation == true)
    {
        var functionType         = 'unassign_programme_shared_intervention';
        var token                = $("input[name=token]").val();
        var sharedInterventionId = $("input[name=shared_intervention_id]").val(); 
        $.ajax({
            url: '../course_admin/ajax_publish_intervention_as_course.php',
            dataType: "json",
            data: {
                function: functionType,
                ptToken : token,
                shared_intervention_id : sharedInterventionId
            },
            success: function (data)
            {
                var url = window.location.href;
                var url_part = url.split("sub_tab=");
                window.location.replace(url_part[0] + "sub_tab=8" );
            }
        });
    }    
}

function deactivateSharedIntervention()
{
    var confirmation = confirm("Are you sure you want to deactivate this session?");
    if(confirmation == true)
    {
        var functionType         = 'deactivateSharedIntervention';
        var token                = $("input[name=token]").val();
        var sharedInterventionId = $("input[name=shared_intervention_id]").val(); 
        $.ajax({
            url: '../course_admin/ajax_publish_intervention_as_course.php',
            dataType: "json",
            data: {
                function: functionType,
                ptToken : token,
                shared_intervention_id : sharedInterventionId
            },
            success: function (data)
            {
                var url = window.location.href;
                var url_part = url.split("sub_tab=");
                window.location.replace(url_part[0] + "sub_tab=9" );
            }
        });
    }
}

function approveSharedIntervention()
{
    var functionType         = 'approve_shared_intervention';
    var token                = $("input[name=token]").val();
    var sharedInterventionId = $("input[name=shared_intervention_id]").val(); 
    $.ajax({
        url: '../course_admin/ajax_publish_intervention_as_course.php',
        dataType: "json",
        data: {
            function: functionType,
            ptToken : token,
            shared_intervention_id : sharedInterventionId
        },
        success: function (data)
        {
            var url = window.location.href;
            var url_part = url.split("sub_tab=");
            window.location.replace(url_part[0] + "sub_tab=9" );
        }
    });
}

function activateSharedIntervention()
{
    var functionType         = 'activate_shared_intervention';
    var token                = $("input[name=token]").val();
    var sharedInterventionId = $("input[name=shared_intervention_id]").val(); 
    $.ajax({
        url: '../course_admin/ajax_publish_intervention_as_course.php',
        dataType: "json",
        data: {
            function: functionType,
            ptToken : token,
            shared_intervention_id : sharedInterventionId
        },
        success: function (data)
        {
            var url = window.location.href;
            var url_part = url.split("sub_tab=");
            window.location.replace(url_part[0] + "sub_tab=9" );
        }
    });
}

function onOGKMSearchClicked()
{
    var lpvId        = $("#ogkm-report-search-area #lp-list-dropdown").val();
    var startDate    = $("#ogkm-report-search-area #month-picker-start").val();
    var endDate      = $("#ogkm-report-search-area #month-picker-end").val();
    var reportId     = $("#ogkm-report-type-dropdown").val();
    var functionType = "load_ogkm_report";
    var token        = $("input[name=token]").val();
    var lp_type      = $('#ogkm-lp-type').val();
    var reportLevel  = $('#ogkm-report-level').val();
    var ocogId         = $('#ge-list-dropdown option:selected').val();

    $("#ogkm-dash-report-body").hide();

    $(".reports-loader").show();
    $.ajax({
        url: '../course_admin/ajax_load_ogkm_dashboard_report.php',
        dataType: "json",
        data: {
            function         : functionType,
            report_level     : reportLevel,
            lpv_id           : lpvId,
            start_date       : startDate,
            end_date         : endDate,
            report_id        : reportId,
            lp_type          : lp_type,
            ptToken          : token,
            ocog_id          : ocogId
        },
        success: function(data)
        {
            try
            {                
                setTimeout(function(){
                    $("#ogkm-dash-report-body").show();
                    if (data.output != null)
                    {
                        $("#ogkm-dash-report-body").delay(100).slideDown(500);
                        $("#ogkm-dash-report-body").html(data.output);

                        if (reportLevel == 'executive-level-area')
                        {
                            //Convert to a datatable
                            var table1 = $('.presenter-table').DataTable({                               
                                "order": [1, 'desc']                                      
                            });

                            var table2 = $('.interventions-table').DataTable({                               
                                "order": [2, 'desc']                                      
                            });                             

                            var table = $('.online-courses-table').DataTable({                               
                                                              
                                order: [1, 'asc'],                             
                                lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
                                columnDefs: [
                                { "width": "50%", "targets": 0 }
                              ]
                            });
                           
                            /* Add event listeners to handle highcharts fullscreen enter/exit events on exec reports*/
                            document.addEventListener('fullscreenchange', exitHighchartFullScreenHandler, false);
                            document.addEventListener('mozfullscreenchange', exitHighchartFullScreenHandler, false);
                            document.addEventListener('MSFullscreenChange', exitHighchartFullScreenHandler, false);
                            document.addEventListener('webkitfullscreenchange', exitHighchartFullScreenHandler, false);                            
                             
                        }
                      
                        $('#ogkm-report-level').prop("disabled", false); 
                    }
                    else if (data.error != null)
                    {
                        alert("Error");
                    }
                }, 200);
            }
            catch(e)
            {
                alert("Something went wrong.");
            }
            finally
            {
                setTimeout(function(){
                    $(".reports-loader").hide();
                }, 200);
            }
        }
    });

}



function initDelivererRolesDatatable()
{
    var table = $('#existing_deliverer_roles_table').DataTable({                               
        order: [1, 'asc'],
        // responsive: true,
        scrollY: '400px',
        scrollX: true,
        scrollCollapse: true,
        paging: false,
        // fixedColumns: true,
        fixedColumns:   {
            leftColumns: 1,
            rightColumns: 1
        },
        "columnDefs": [
            { targets: 0, width: '185px' },
            { targets: 20, width: '185px' }
        ]

    });

    $('[data-toggle="tooltip"]').tooltip({
        placement: 'left',
        trigger: 'hover'
    }); 
    initTooltipForDelivererRolesTable();

}

function initExisitingUsersForRolesDatatable(roleId)
{
    $('#existing_users_table_' + roleId).DataTable({                               
        order: [0, 'asc'],
        responsive: true                                      
    });

    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
    }); 
    initTooltipForRoleUsersTable();
}

function initExisitingUserProgrammesDatatable(delivererUserRoleId)
{
    $('#existing_user_role_programmes_table_' + delivererUserRoleId).DataTable({                               
        order: [1, 'asc'],
        responsive: true                                      
    });    
}

var currentHighchartId = '';

/* Handle fullscreen event of highcharts in exec report area */
function exitHighchartFullScreenHandler()
{
    if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) 
    { 
        if (currentHighchartId != '')
        {  
            var chart = $("#"+currentHighchartId).first().highcharts();
            var parentWidth = 440;

            if ($("#"+currentHighchartId).parent().hasClass("pa-nps-content"))
            {
                parentWidth = $("#"+currentHighchartId).parent().width();      
            }
            else
            {
                parentWidth = $("#"+currentHighchartId).parent().parent().parent().width();      
            }             
           
            chart.setSize(parentWidth - 40, 400, false);   
        }   
    }
    else if (document.fullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement)
    {
        currentHighchartId = document.fullscreenElement.id;
        var chart = $("#"+currentHighchartId).first().highcharts();
        chart.setSize(screen.width, screen.height - 40, false);
    }
}

function OnFeedbacksChangeFilters()
{
    var feedback_form_id = $("#rpt-feedback-frm").val();
    var function_type = "change_feedback_filters";
    var token = $('input[name="token"]').val();

    DisableApplyFilterBtn();
     $.ajax({
            url: '../course_admin/ajax_generate_feedback_charts.php',
            dataType: "json",
            data: {
                function        : function_type,
                feedback        : feedback_form_id,
                ptToken         : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != null)
                    {
                        $('#rpt-academy-frm').html(data.output['academy']);
                        $("#rpt-course-frm").html(data.output['course']);
                        $("#rpt-programme-frm").html(data.output['programme']);
                        EnableApplyFilterBtn();
                    }
                    else if (data.error != null)
                    {
                        alert("Something went wrong!");
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
}

function onAllActivitiesSelected() 
{
    if ((($("#rpt-report-areas-frm").val() == 1) || ($("#rpt-report-areas-frm").val() == 12) || ($("#rpt-report-areas-frm").val() == 4)) && ($("#rpt-programme-frm").val() == "all-activities")) //Show extra options for Obs & Exp & LP
    {                           
        $("#rpt-audience-frm-wrapper").show();

        if ($("#rpt-report-areas-frm").val() == 12)
        {                                
            $('#rpt-audience-frm option[value=participants]').hide();
        }
        else
        {
             $('#rpt-audience-frm option[value=participants]').show();
        }
    }
    else
    {
        $("#rpt-audience-frm-wrapper").hide();
    }

    $("#rpt-course-frm").parent().hide()
    $("#rpt-feedback-frm").val('all'); // Reset to default
    $("#rpt-feedback-frm").parent().hide();
    $("#date-selectors-ogkm-reports").parent().show();
    EnableApplyFilterBtn();
} 

function onAllIntakesSelected() 
{
    if ((($("#rpt-report-areas-frm").val() == 1) || ($("#rpt-report-areas-frm").val() == 12) || ($("#rpt-report-areas-frm").val() == 4)) && ($("#rpt-programme-frm").val() == "all-activities")) //Show extra options for Obs & Exp & LP
    {                           
        $("#rpt-audience-frm-wrapper").show();

        if ($("#rpt-report-areas-frm").val() == 12)
        {                                
            $('#rpt-audience-frm option[value=participants]').hide();
        }
        else
        {
             $('#rpt-audience-frm option[value=participants]').show();
        }
    }
    else
    {
        $("#rpt-audience-frm-wrapper").hide();
    }

    $("#rpt-course-frm").parent().show()
    $("#rpt-feedback-frm").val('all'); // Reset to default
    $("#rpt-feedback-frm").parent().hide();
    $("#date-selectors-ogkm-reports").parent().show();
    EnableApplyFilterBtn();
}

var prevProgrammeIndex = "";
function OnProgrammeChangeFilters()
{    
    var programme_id = $("#rpt-programme-frm").val();
    if (programme_id == 'all-activities')
    {
        onAllActivitiesSelected();
        return false;
    }
    else if ($("#rpt-report-areas-frm").val() == "case_studies")
    {
        onAllActivitiesSelected();
        return false;
    }
    
    var logic_status = false;
    var currIndex = document.getElementById("rpt-programme-frm").selectedIndex;
    if( currIndex >= 0 )
    {
        if( prevProgrammeIndex != currIndex )
        {
            prevProgrammeIndex = currIndex;
            logic_status = true;
        }
        else
        {
            logic_status = false;
        }
    }
    
    if (logic_status)
    {
        var programme_id = $("#rpt-programme-frm").val();
        var feedback     = $("#rpt-feedback-frm").val();
        var function_type = "change_programme_filters";
        var academy_id = $("#rpt-academy-frm").val();
        var token = $('input[name="token"]').val();

        DisableApplyFilterBtn();
        report_area_default = document.getElementById("ogkm-dash-report-body");

        listofacademies = "";
        if (academy_id == "all")
        {
            //build all the forms id
            $count = 0;
            $("#rpt-academy-frm option").each( function()
            {
                var last_element = $("#rpt-academy-frm option").length - 1;

                if ($(this).val() !== "all")
                {
                    if ($count == last_element)
                    {
                       listofacademies += $(this).val();
                    }
                    else
                    {
                        listofacademies += $(this).val() + ",";
                    }
                }
                $count++;

            });
        }
        else
        {
            listofacademies = academy_id;
        }

        $('#date-selectors-ogkm-reports').parent().hide();  

        if (report_area_default)
        {
            $(".reports-loader").show(); 
        }

          $.ajax({
            url: '../course_admin/ajax_generate_feedback_charts.php',
            dataType: "json",
            data: {
                function         : function_type,
                programme        : programme_id,
                feedback         : feedback,
                academyid        : listofacademies,
                ptToken          : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != null)
                    {
                        course = data.output['course'];
                        feedback = data.output['feedback'];
                        cases = data.output['cases'];

                        if ((($("#rpt-report-areas-frm").val() == 1) || ($("#rpt-report-areas-frm").val() == 12) || ($("#rpt-report-areas-frm").val() == 4)) && ($("#rpt-programme-frm").val() == "all-activities") && ($("#rpt-programme-frm").val() != 178)) //Show extra options for Obs & Exp
                        {                           
                            $("#rpt-audience-frm-wrapper").show();

                            if ($("#rpt-report-areas-frm").val() == 12)
                            {                                
                                $('#rpt-audience-frm option[value=participants]').hide();
                            }
                            else
                            {
                                 $('#rpt-audience-frm option[value=participants]').show();
                            }
                        }
                        else
                        {
                            $("#rpt-audience-frm-wrapper").hide();
                        }

                        if (course == 0 || feedback == 0)
                        {                         
                             $("#rpt-course-frm").parent().hide();
                             $("#rpt-feedback-frm").parent().hide();
                             $("#rpt-case-study-frm").parent().hide();
                             $('#activity_visits').hide();
                             DisableApplyFilterBtn();
                        }
                        else
                        {
                            $("#rpt-course-frm").parent().show();
                            $("#rpt-feedback-frm").parent().show();
                            
                            $("#rpt-course-frm").html(data.output['course']);
                            $("#rpt-feedback-frm").html(data.output['feedback']);
                            $("#rpt-case-study-frm").html(data.output['cases']);
                            $("#rpt-feedback-frm").trigger('change');

                            if (cases == 0)
                            {
                                $("#rpt-case-study-frm").parent().hide();
                            }
                            else
                            {
                                $("#rpt-case-study-frm").parent().show();
                                loadFiltersInStages("#rpt-case-study-frm");                            
                            }

                            loadFiltersInStages("#rpt-course-frm");
                           // EnableApplyFilterBtn();
                        }
                    }
                    else if (data.error != null)
                    {
                        alert("Something went wrong!");
                    }
                    $(".reports-loader").hide();
                }
                catch (e)
                {
                    alert("Something went wrong.");
                   // $(".reports-loader").hide();
                }
            }
        });
    }
}

function selectFeedbackForm()
{
    loadFiltersInStages("#rpt-feedback-frm");
    loadFiltersInStages("#rpt-case-study-frm-white");
}

function OnChangeFeedbackForms()
{
    
    var optLength = $('#rpt-feedback-frm > option').length;    
    if (optLength > 1)
    {
        $('[data-toggle="tooltip"]').tooltip('enable');
        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover'
        });
    }
    else
    {
       $('[data-toggle="tooltip"]').tooltip('disable');
    }
}

function loadFiltersInStages(element)
{
    if (element === 'all')
    {
        $("#rpt-academy-frm").css("border-color","#077d20");       
        $("#rpt-report-areas-frm").prop("disabled", true);
        $("#rpt-programme-frm").prop("disabled", true);
        $("#rpt-course-frm").prop("disabled", true);
        $("#rpt-feedback-frm").prop("disabled", true);
        $("#rpt-case-study-frm").prop("disabled", true);
        $("#report-type").prop("disabled", true);
        //$('#rpt-visits-frm').hide();
    }
    else if (element === 'other')
    {
        $("#rpt-programme-frm").css("border-color","#077d20");
        $("#rpt-course-frm").prop("disabled", true);
        $("#rpt-feedback-frm").prop("disabled", true);
        $("#rpt-case-study-frm").prop("disabled", true);
        $("#report-type").prop("disabled", true);
    }
    else if (element === '#rpt-report-areas-frm')
    {
        $("#rpt-academy-frm").css("border-color","#d2d6de");
        $("#rpt-report-areas-frm").css("border-color","#077d20");
        $("#rpt-programme-frm").css("border-color","#d2d6de");
        $("#rpt-report-areas-frm").prop("disabled", false);
        $("#rpt-programme-frm").prop("disabled", true);
        $("#rpt-course-frm").prop("disabled", true);
        $("#rpt-feedback-frm").prop("disabled", true);
        $("#rpt-case-study-frm").prop("disabled", true);
        //$('#rpt-visits-frm').hide();
    }
    else if (element === '#rpt-programme-frm')
    {
        $("#rpt-academy-frm").css("border-color","#d2d6de");
        $("#rpt-report-areas-frm").css("border-color","#d2d6de");
        $("#rpt-programme-frm").css("border-color","#077d20");
        $("#rpt-programme-frm").prop("disabled", false);
        $("#rpt-course-frm").prop("disabled", true);
        $("#rpt-feedback-frm").prop("disabled", true);
        $("#rpt-case-study-frm").prop("disabled", true);

    }
    else if (element === '#rpt-course-frm')
    {
        $("#rpt-academy-frm").css("border-color","#d2d6de");
        $("#rpt-report-areas-frm").css("border-color","#d2d6de");
        $("#rpt-programme-frm").css("border-color","#d2d6de");
        $("#rpt-course-frm").css("border-color","#077d20");
        $("#rpt-course-frm").prop("disabled", false); 
        $("#rpt-feedback-frm").prop("disabled", true);
        $("#rpt-case-study-frm").prop("disabled", true);       
    }
    else if (element === '#rpt-feedback-frm')
    {
        $("#rpt-academy-frm").css("border-color","#d2d6de");
        $("#rpt-report-areas-frm").css("border-color","#d2d6de");
        $("#rpt-programme-frm").css("border-color","#d2d6de");
        $("#rpt-course-frm").css("border-color","#d2d6de");

        $("#rpt-feedback-frm").prop("disabled", false);
        $("#rpt-case-study-frm").prop("disabled", true);
    }
    else if (element === "#rpt-case-study-frm")
    {
        $("#rpt-case-study-frm").prop("disabled", true);
    }
    else if (element === "#rpt-case-study-frm-white")
    {
        $("#rpt-case-study-frm").prop("disabled", false);
    } 

    if (($("#rpt-report-areas-frm") == 1) && ($("#rpt-programme-frm").val() == "all-activities")) //Show extra options for Obs & Exp
    {                           
        $("#rpt-audience-frm-wrapper").show();
    }
    else
    {
        $("#rpt-audience-frm-wrapper").hide();
    }     
}

var prevAcademyIndex = "";
function OnAcademiesChangeFilters()
{
    var logic_status = false;
    var currIndex = document.getElementById("rpt-academy-frm").selectedIndex;
    if( currIndex >= 0 )
    {
        if( prevAcademyIndex != currIndex )
        {
            prevAcademyIndex = currIndex;
            logic_status = true;
        }
        else
        {
            logic_status = false;
        }
    }
     DisableApplyFilterBtn();
    if (logic_status)
    {
        var academy_id = $("#rpt-academy-frm").val();
        var feedback     = $("#rpt-feedback-frm").val();
        var function_type = "change_academy_filters";
        var token = $('input[name="token"]').val();

        if (academy_id == 8)
        {
            if (!($("#product-rpt-areas").is(":visible")))       
            {
                $('#product-rpt-areas').show();
                $('#lbl-intervention-rpt').text('Intervention Name');
            }
        }
        else
        {
            if ($("#product-rpt-areas").is(":visible"))       
            {
                $('#product-rpt-areas').hide();
                $('#lbl-intervention-rpt').text('Programme Name');
            }
        }

        DisableApplyFilterBtn();
        CheckForIntakesFeedbackForms();
        listofacademies = "";
        if (academy_id == "all")
        {
            $count = 0;
            $("#rpt-academy-frm option").each( function()
            {
                var last_element = $("#rpt-academy-frm option").length - 1;

                if ($(this).val() !== "all")
                {
                    if ($count == last_element)
                    {
                       listofacademies += $(this).val();
                    }
                    else
                    {
                        listofacademies += $(this).val() + ",";
                    }
                }
                $count++;

            });
        }
        else
        {
            listofacademies = academy_id;
        }

          $.ajax({
            url: '../course_admin/ajax_generate_feedback_charts.php',
            dataType: "json",
            data: {
                function         : function_type,
                academy          : listofacademies,
                feedback         : feedback,
                ptToken          : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != null)
                    {
                        course = data.output['courses'];
                        feedback = data.output['feedback'];
                        cases = data.output['case'];

                        if (course == 0 || feedback == 0)
                        { 
                            $("#rpt-programme-frm").html(data.output['programmes']);                        
                            $("#rpt-course-frm").parent().hide();
                            $("#rpt-feedback-frm").parent().hide();
                            $("#rpt-case-study-frm").parent().hide();

                            loadFiltersInStages("#rpt-programme-frm");
                            DisableApplyFilterBtn();
                        }
                        else
                        {
                            $("#rpt-course-frm").html(data.output['courses']);
                            $("#rpt-programme-frm").html(data.output['programmes']);
                            $("#rpt-feedback-frm").html(data.output['feedback']);
                            $("#rpt-feedback-frm").trigger('change');
                            if (cases == 0)
                            {
                                $("#rpt-case-study-frm").parent().hide();
                            }
                            else
                            {
                                $("#rpt-case-study-frm").html(data.output['case']);
                            }

                            if (listofacademies === '8')
                            {
                                loadFiltersInStages("#rpt-report-areas-frm");
                            }
                            else
                            {
                                loadFiltersInStages("#rpt-programme-frm");
                            }                        
                            
                           // EnableApplyFilterBtn();
                        }                  
                    }
                    else if (data.error != null)
                    {
                        alert("Something went wrong!");
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    }
}

var prevCourseIndex = '';
function OnIntakeChangeFilters()
{
    var intake_id       = $("#rpt-course-frm").val();  
    if (intake_id == 'all-intakes')
    {
        onAllIntakesSelected();
        return false;
    }
    else
    {
        $('#date-selectors-ogkm-reports').parent().hide();  
        $("#rpt-feedback-frm").show();
        $("#rpt-feedback-frm").parent().show();
        loadFiltersInStages("#rpt-feedback-frm");
        EnableApplyFilterBtn();
    }

    var logic_status = false;
    var currIndex = document.getElementById("rpt-course-frm").selectedIndex;
    if( currIndex >= 0 )
    {
        if( prevCourseIndex !== currIndex )
        {
            prevCourseIndex = currIndex;
            logic_status = true;
        }
        else
        {
            logic_status = false;
        }
    }

    if (logic_status)
    {
        var intake_id       = $("#rpt-course-frm").val();  
        var function_type   = "change_intake_filters";    
        var token           = $('input[name="token"]').val();

        DisableApplyFilterBtn();       
        listofintake_id = "";
        if (intake_id == "all")
        {
            //build all the forms id
            $count = 0;
            $("#rpt-course-frm option").each( function()
            {
                var last_element = $("#rpt-course-frm option").length - 1;

                if ($(this).val() !== "all")
                {
                    if ($count == last_element)
                    {
                       listofintake_id += $(this).val();
                    }
                    else
                    {
                        listofintake_id += $(this).val() + ",";
                    }
                }
                $count++;

            });
        }
        else
        {
            listofintake_id = intake_id;
        }

        $.ajax({
            url: '../course_admin/ajax_generate_feedback_charts.php',
            dataType: "json",
            data: {
                function         : function_type,
                intake           : listofintake_id,           
                ptToken          : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != null)
                    {                   
                        cases = data.output['cases'];
                        workshops = data.output['workshops'];
                       

                        if (cases == 0)
                        {
                            $('#rpt-case-study-frm').parent().hide();       
                        }
                        else
                        {
                            $("#rpt-case-study-frm").html(cases);
                            $('#rpt-case-study-frm').parent().show();  
                        }

                        if (workshops !== "")
                        {
                            $('#activity_visits').show();
                            $('#rpt-visits-frm').html(workshops);
                        }
                        else
                        {
                             $('#activity_visits').hide();
                        }

                        loadFiltersInStages("#rpt-feedback-frm");
                        $("#rpt-feedback-frm").html(data.output['feedback']);
                        $("#rpt-feedback-frm").trigger('change');
                        EnableApplyFilterBtn();
                    }
                    else if (data.error != null)
                    {
                        alert("Something went wrong!");
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    }
}

function DisableApplyFilterBtn()
{
    $("#poc-added-filter-btn").attr("disabled",true);
    $("#poc-added-filter-btn").css("background-color","#B1B1B1");

    $('#download-dashboard-btn').attr("disabled",true);
    $("#download-dashboard-btn").css("background-color","#B1B1B1");
}

function EnableApplyFilterBtn()
{
    $('#report-type').prop("disabled", false);

    $('#poc-added-filter-btn').prop("disabled", false);
    $("#poc-added-filter-btn").css("background-color","#008f70");

    $('#download-dashboard-btn').prop("disabled", false);
    $("#download-dashboard-btn").css("background-color","#008f70");
}

function  storeRolesEntitiesOptions()
{
    $('#feature_id option').each(function()
    {
        var val = $(this).val();
        var text = $(this).text();
        originalFeaturesOptions += '<option value = "'+val+'">'+text+'</option>';
    })

}

function previewProfileImage()
{
    var image = document.getElementById('image_logo_div');
    var preview = image.getElementsByTagName('img')[0];
    var file = document.querySelector('input[name="input-file-logo"]').files[0];
    var reader  = new FileReader();
    var saveButton = document.getElementById('saveProfileImage');

    reader.onloadend = function () {
        preview.src = reader.result;
    }

    if (file) {
        reader.readAsDataURL(file);
        saveButton.style.display = "block";
    } else {
        preview.src = "";
    }
}

function previewStaffImage()
{
    var image = document.getElementById('image_logo_div');
    var preview = image.getElementsByTagName('img')[0];
    var file = document.querySelector('input[name="input-file-logo"]').files[0];
    var reader  = new FileReader();

    reader.onloadend = function () {
        preview.src = reader.result;
    }

    if (file) {
        reader.readAsDataURL(file);
    } else {
        preview.src = "";
    }
}

function previewStaffImageEdit(staff_id)
{
    var image = document.getElementById('image_logo_div-'+staff_id);
    var preview = image.getElementsByTagName('img')[0];
    var file = document.querySelector('input[name="input-file-logo-'+staff_id+'"]').files[0];
    var reader  = new FileReader();

    reader.onloadend = function () {
        preview.src = reader.result;
    }

    if (file) {
        reader.readAsDataURL(file);
    } else {
        preview.src = "";
    }
}

function previewInterventionIcon()
{
    var image = document.getElementById('image_logo_div');
    var preview = image.getElementsByTagName('img')[0];
    preview.style.display = "inline-block";
    var file = document.querySelector('input[name="icon"]').files[0];
    var reader  = new FileReader();

    reader.onloadend = function () {
        preview.src = reader.result;
    }

    if (file) 
    {
        reader.readAsDataURL(file);
    } else 
    {
        preview.src = "";
    }
}

function previewCourseImage()
{
    var image = document.getElementById('image_logo_div');
    var preview = image.getElementsByTagName('img')[0];
    preview.style.display = "inline-block";
    var file = document.querySelector('input[name="lead_image1"]').files[0];
    var reader  = new FileReader();

    reader.onloadend = function () {
        preview.src = reader.result;
    }

    if (file) 
    {
        reader.readAsDataURL(file);
    } 
    else 
    {
        preview.src = "";
    }
}

function previewResourceCoverImage()
{
    var image = document.getElementById('image_logo_div');
    var preview = image.getElementsByTagName('img')[0];
    preview.style.display = "inline-block";
    var file = document.querySelector('input[name="cover_image_url"]').files[0];
    var reader  = new FileReader();

    reader.onloadend = function () {
        preview.src = reader.result;
    }

    if (file) 
    {
        reader.readAsDataURL(file);
    } 
    else 
    {
        preview.src = "";
    }
}

function previewBannerImage()
{
    var image = document.getElementById('image_logo_div');
    var preview = image.getElementsByTagName('img')[0];
    preview.style.display = "inline-block";
    var file = document.querySelector('input[name="image"]').files[0];
    var reader  = new FileReader();

    reader.onloadend = function () {
        preview.src = reader.result;
    }

    if (file) 
    {
        reader.readAsDataURL(file);
    } 
    else 
    {
        preview.src = "";
    }
}

function previewAnnouncementImage()
{
    var image = document.getElementById('image_logo_div');
    var preview = image.getElementsByTagName('img')[0];
    preview.style.display = "inline-block";
    var file = document.querySelector('input[name="press_release_image"]').files[0];
    var reader  = new FileReader();

    reader.onloadend = function () {
        preview.src = reader.result;
    }

    if (file) 
    {
        reader.readAsDataURL(file);
    } 
    else 
    {
        preview.src = "";
    }
}

function previewCMSImage(field_name)
{
    var image = document.getElementById('image_'+field_name+'_div');
    console.log('image_'+field_name+'_div');
    var preview = image.getElementsByTagName('img')[0];
    preview.style.display = "inline-block";
    var file = document.querySelector('input[name="'+field_name+'"]').files[0];
    var reader  = new FileReader();

    reader.onloadend = function () {
        preview.src = reader.result;
    }

    if (file) 
    {
        reader.readAsDataURL(file);
    } 
    else 
    {
        preview.src = "";
    }
}

function previewGamesImage()
{
    var image = document.getElementById('image_logo_div');
    var preview = image.getElementsByTagName('img')[0];
    preview.style.display = "inline-block";
    var file = document.querySelector('input[name="project_lead_image_url"]').files[0];
    var reader  = new FileReader();

    reader.onloadend = function () {
        preview.src = reader.result;
    }

    if (file) 
    {
        reader.readAsDataURL(file);
    } 
    else 
    {
        preview.src = "";
    }
}

function loadOverlay() {

    if(cmsLoadingStatus === true) 
    {
        $('body').append('<div id="cms-loading-overlay" class="cms-loading"><i class="fa fa-spinner fa-pulse fa-spin"></i></div>');
    }

    function checkLoadingState() 
    {
        if(cmsLoadingStatus === false) 
        {
            $('#cms-loading-overlay').remove();
            return;
        }
        setTimeout( checkLoadingState, 500 );
    }
    checkLoadingState();
}

function createStaffMember()
{
    var ptToken      = $("input[name=token]").val();
    var category     = $("input[name=staff_category]").val();
    var name         = $("#name").val();
    var title        = $("#title").val();
    var bio          = $("#bio").val();
    var url          = $("#url").val();
    var linkedin     = $("#linkedin").val();
    var waos_account = $("#waos_account").val();
    var logoImage    = document.querySelector('input[name="input-file-logo"]').files[0];
    var action       = 'create_staff_member';
    var academy      = $("input[name=academy]").val();
    var error_msg    = '';
    var staff_types  = $('#staff_types').val();

    if ((waos_account === '') || (waos_account === null) || (waos_account === undefined))
    {
        waos_account = '';
    }
    if ((title === '') || (title === null) || (title === undefined))
    {
        title = '';
    }
    if ((url === '') || (url === null) || (url === undefined))
    {
        url = '';
    }
    if ((linkedin === '') || (linkedin === null) || (linkedin === undefined))
    {
        linkedin = '';
    }
    if ((staff_types === '') || (staff_types === null) || (staff_types === undefined))
    {
        staff_types = [];
    }

    if ((name === '') || (name === null) || (name === undefined))
    {
        error_msg = 'Please enter name!';
    }
    else
    {
        var formData = new FormData();
        formData.append('action', action);
        formData.append('file', logoImage);
        formData.append('ptToken', ptToken);
        formData.append('name', name);
        formData.append('title', title);
        formData.append('bio', bio);
        formData.append('url', url);
        formData.append('linkedin', linkedin);
        formData.append('waos_account', waos_account);
        formData.append('academy', academy);
        formData.append('category', category);
        formData.append('staff_types', staff_types);

        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url: '../api/v1/people_admin.php',
            type: "post",
            dataType: "json",
            data: formData,
            contentType: false,
            cache: false,
            processData:false,
            success: function(data)
            {
                cmsLoadingStatus = false;

                if (data.output.length > 0)
                {
                    var newId     = data.output[0];
                    var image_url = data.output[1];
                    var user_text = data.output[2];
                    var titles    = data.output[3];

                    $("#modal-body-main").html("");
                    $('#create-staff-model').modal('toggle');

                    if (image_url === '')
                    {
                        image_url = "https://d22u7g0jugykn9.cloudfront.net/user_uploads/default-user-v1.png";
                    }

                    var name_label_text = 'Name';
                    var bio_lable_text  = 'Bio';
                    var hide_elements   = false;

                    if (category == 'partners')
                    {                        
                        name_label_text = 'Partner Name';
                        bio_lable_text  = 'Description';
                        hide_elements   = true;    
                    }

                    var item_list = $("#edit_staff_model_div").html();
                    var newItem = 
                    '<div class="modal fade" id="edit-staff-model-'+newId+'" role="dialog">'+
                        '<div class="modal-dialog modal-lg">'+
                            '<div class="modal-content">'+
                                '<div class="modal-header">'+
                                    '<button type="button" class="close" data-dismiss="modal">&times;</button>'+
                                    '<h4 class="modal-title">Edit member</h4>'+
                                '</div>'+
                                '<div class="modal-body">'+

                                    '<div class="row">'+
                                        '<div class="col-sm-6">'+
                                            '<div class="form-group">'+
                                                '<label for="name">'+name_label_text+':</label>'+
                                                '<input type="text" class="form-control" id="name-'+newId+'" value="'+name+'">'+
                                            '</div>';

                    if ((!hide_elements) && (category != 'visiting_fellows'))
                    {    
                        newItem +=  '<div class="form-group">'+
                                        '<label for="title">Title:</label>'+
                                        '<input type="text" class="form-control" id="title-'+newId+'" value="'+title+'">'+
                                    '</div>';
                    }
                    else if (category == 'visiting_fellows')
                    {
                        newItem +=  '<div class="form-group">'+
                                        '<label for="title">Title:</label>'+
                                        '<select class="form-control staff_types" name="staff_types-'+newId+'[]" id="staff_types-'+newId+'" multiple="multiple" style="width:100%">';
                        for (var i = 0;i < titles.length; i++)
                        {
                            newItem += '<option value="'+titles[i].id+'"';
                            if (staff_types.includes(titles[i].id))
                            {
                                newItem += 'selected="selected"';
                            }
                            newItem += '>'+titles[i].title+'</option>';
                        }
                        newItem +=      '</select>'+
                                    '</div>';
                    }
                    else
                    {
                        newItem += '<div class="form-group">'+
                                        '<label for="name">URL:</label>'+
                                        '<input type="url" class="form-control" id="url-'+newId+'" value="'+url+'">'+
                                    '</div>';
                    }

                        newItem +=  '</div>'+
                                        '<div class="col-sm-6">'+
                                            '<div id="image_logo_div-'+newId+'">'+
                                                '<img src="'+image_url+'" style="height: 100px;">'+
                                            '</div>'+
                                            '<div class="file-loading">'+
                                                '<input type="file" onchange="previewStaffImageEdit('+newId+')" id="input-file-logo-'+title+'" name="input-file-logo-'+newId+'">'+
                                            '</div>'+
                                        '</div>'+
                                    '</div>'+

                                    '<div class="row">'+
                                        '<div class="col-sm-6">'+
                                            '<div class="form-group">'+
                                                '<label for="name">'+bio_lable_text+':</label>'+
                                                '<textarea class="form-control" id="bio-'+newId+'" rows="8">'+bio+'</textarea>'+
                                            '</div>'+
                                        '</div>'+
                                        '<div class="col-sm-6">';

                    if (!hide_elements)
                    {
                        newItem +=          '<div class="form-group" style="display:none">'+
                                                '<label for="name">URL:</label>'+
                                                '<input type="url" class="form-control" id="url-'+newId+'" value="'+url+'">'+
                                            '</div>'+
                                            '<div class="form-group">'+
                                                '<label for="linkedin">LinkedIn:</label>'+
                                                '<input type="url" class="form-control" id="linkedin-'+newId+'" value="'+linkedin+'">'+
                                            '</div>'+

                                            '<label for="waos_account">Email (registered on WAoS platform):</label>'+
                                            '<div id="search-users-admin" class="row">'+
                                                '<div class="col-sm-8">'+
                                                    '<input type="text" id="search-users-txt-'+newId+'" class="form-control" placeholder="Type to search">'+
                                                '</div>'+

                                                '<div class="col-sm-3">'+
                                                    '<input type="submit" name="submit" value="Search" class="btn btn-primary" onClick="search_user('+newId+')">'+
                                                '</div>'+
                                            '</div>'+

                                            '<div class="row">'+
                                                '<div class="col-sm-12">'+
                                                    '<div class="search-box lds-ring"><div></div><div></div><div></div><div></div></div>'+
                                                '</div>'+
                                            '</div>'+   

                                            '<div class="row" style="margin-top: 3px">'+
                                                '<div class="col-sm-12">'+
                                                    '<select id="waos_account-'+newId+'" class="form-control">'+
                                                        '<option value="'+waos_account+'">'+user_text+'</option>'+
                                                    '</select>'+
                                                '</div>'+
                                            '</div>';
                    }
                    newItem +=  '</div>'+
                                    '</div>'+

                                '</div>'+
                                '<div class="modal-footer">'+
                                    '<button type="button" class="btn btn-success" onClick="editStaffMember('+newId+')">Save</button>'+
                                    '<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>'+
                                '</div>'+
                            '</div>'+
                        '</div>'+
                    '</div>';
                    item_list = item_list + newItem;
                    $("#edit_staff_model_div").html("");
                    $("#edit_staff_model_div").html(item_list);

                    if ($(".staff_types").length)
                    {
                        $("#staff_types-"+newId).select2({
                            placeholder: 'Please select...',
                            theme: 'bootstrap-5',
                            dropdownParent: $('#edit-staff-model-'+staff_id+' .modal-body')
                        });
                    }                    

                    reload_staff_table();
                }
                else
                {
                    error_msg = "Something went wrong!";
                }          
            }
        });
    }    

    if (error_msg !== '')
    {
        alert(error_msg);
    }
}

function search_user(id)
{
    var searchString = $("#search-users-txt-"+id).val().trim();
    var action       = "search_users";
    var ptToken      = $("input[name=token]").val();

    $(".search-box.lds-ring").css('display', 'inline-block');

    $.ajax({
        url: '../api/v1/people_admin.php',
        dataType: "json",
        type: "POST",
        data: {
            action: action,
            searchString: searchString,
            ptToken : ptToken
        },
        success: function (data)
        {
            try
            {
                var arrLength = data.output.length;
                $("#waos_account-"+id).empty();
                for( var i = 0; i < arrLength; i++)
                {
                    var user_id   = data.output[i]['user_id'];
                    var name      = data.output[i]['name']+" - "+data.output[i]['email'];
                    var academy   = data.output[i]['academy'];
                    if (academy !== '' && academy !== null)
                    {
                        $("#waos_account-"+id).append("<option value='"+user_id+"'>"+name+", Registered Academy - "+academy+"</option>");
                    }
                    else
                    {
                        $("#waos_account-"+id).append("<option value='"+user_id+"'>"+name+"</option>");
                    }                       
                }
                if (arrLength > 0)
                {
                    $('#waos_account-'+id).css('display', 'block');
                }
                else
                {
                    $('#waos_account-'+id).css('display', 'none');
                }                  
            }
            catch (e)
            {
                alert("Something went wrong.");
            }
            finally {
                $(".search-box.lds-ring").hide();
            }
        }
    });
}

function editStaffMember(id)
{
    var action       = 'edit_staff_member';
    var ptToken      = $("input[name=token]").val();
    var name         = $("#name-"+id).val();
    var title        = $("#title-"+id).val();
    var bio          = $("#bio-"+id).val();
    var url          = $("#url-"+id).val();
    var linkedin     = $("#linkedin-"+id).val();
    var waos_account = $("#waos_account-"+id).val();
    var logoImage    = document.querySelector('input[name="input-file-logo-'+id+'"]').files[0];
    var staff_types  = $('#staff_types-'+id).val();

    var error_msg    = '';

    if ((waos_account === '') || (waos_account === null) || (waos_account === undefined))
    {
        waos_account = '';
    }
    if ((title === '') || (title === null) || (title === undefined))
    {
        title = '';
    }
    if ((url === '') || (url === null) || (url === undefined))
    {
        url = '';
    }
    if ((linkedin === '' || linkedin === null || linkedin === undefined))
    {
        linkedin = '';
    }
    if ((staff_types === '') || (staff_types === null) || (staff_types === undefined))
    {
        staff_types = [];
    }


    if ((name === '') || (name === null) || (name === undefined))
    {
        error_msg = 'Please enter name!';
    }
    else
    {
        var formData = new FormData();
        formData.append('action', action);
        formData.append('file', logoImage);
        formData.append('ptToken', ptToken);
        formData.append('name', name);
        formData.append('title', title);
        formData.append('bio', bio);
        formData.append('url', url);
        formData.append('linkedin', linkedin);
        formData.append('waos_account', waos_account);
        formData.append('staff_id', id);
        formData.append('staff_types', staff_types);

        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url: '../api/v1/people_admin.php',
            type: "post",
            dataType: "json",
            data: formData,
            contentType: false,
            cache: false,
            processData:false,
            success: function(data)
            {
                cmsLoadingStatus = false;
                if (data.output > 0)
                {
                    $('#edit-staff-model-'+id).modal('toggle');
                    reload_staff_table();
                }
                else
                {
                    error_msg = "Something went wrong!";
                }          
            }
        });
    }    

    if (error_msg !== '')
    {
        alert(error_msg);
    }
}

function deleteStaffMember(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_staff_member';

    var confirmation = confirm("Are you sure you want to delete this staff record?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                action: action,
                ptToken: ptToken,
                staff_id: id
            },
            success: function (data)
            {
                reload_staff_table();
                cmsLoadingStatus = false;
            }
        });
    }
}

function deleteAnnouncement(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_announcement';

    var confirmation = confirm("Are you sure you want to delete this news?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                action: action,
                ptToken: ptToken,
                announcement_id: id
            },
            success: function (data)
            {
                reload_announcements_table();
                cmsLoadingStatus = false;
            }
        });
    }
}

function deleteProject(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_project';

    var confirmation = confirm("Are you sure you want to delete this project?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                action: action,
                ptToken: ptToken,
                project_id: id
            },
            success: function (data)
            {
                reload_projects_table();
                cmsLoadingStatus = false;
            }
        });
    }
}

function deleteAFECSchool(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_afec_school';

    var confirmation = confirm("Are you sure you want to delete this AFEC school?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                action    : action,
                ptToken   : ptToken,
                centre_id : id
            },
            success: function (data)
            {
                reload_afac_school_table();
                cmsLoadingStatus = false;
            }
        });
    }
}

function deleteStudentProfile(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_student_profile';

    var confirmation = confirm("Are you sure you want to delete this Student Profile?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                action    : action,
                ptToken   : ptToken,
                student_profile_id : id
            },
            success: function (data)
            {
                reload_student_profiles_table();
                cmsLoadingStatus = false;
            }
        });
    }
}

function deleteAFECAssessor(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_afec_assessor';

    var confirmation = confirm("Are you sure you want to delete this AFEC Assessor?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                action    : action,
                ptToken   : ptToken,
                afec_assessor_id : id
            },
            success: function (data)
            {
                reload_afec_assessors_table();
                cmsLoadingStatus = false;
            }
        });
    }
}

function deleteFacultyProfile(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_faculty_profile';

    var confirmation = confirm("Are you sure you want to delete this Faculty Profile?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../api/v1/people_admin.php',
            dataType: "json",
            data: {
                action    : action,
                ptToken   : ptToken,
                faculty_profile_id : id
            },
            success: function (data)
            {
                reload_faculty_profiles_table();
                cmsLoadingStatus = false;
            }
        });
    }
}

function reload_staff_table()
{ 
    var data_url = "../api/v1/people_admin.php?action=read_staff&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val()+"&category="+$("input[name=staff_category]").val();
    $('#tbl_staff').DataTable().ajax.url(data_url).load();
}

function reload_announcements_table()
{
    var data_url = "../api/v1/people_admin.php?action=read_announcements&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $('#tbl_announcements').DataTable().ajax.url(data_url).load();
}

function reload_projects_table()
{
    var data_url = "../api/v1/people_admin.php?action=read_projects&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $('#tbl_projects').DataTable().ajax.url(data_url).load();
}

function reload_afac_school_table()
{
    var data_url = "../api/v1/people_admin.php?action=read_afec_centres&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $('#tbl_afec_schools').DataTable().ajax.url(data_url).load(); 
}

function reload_student_profiles_table()
{
    var data_url = "../api/v1/people_admin.php?action=read_student_profiles&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $('#tbl_student_profiles').DataTable().ajax.url(data_url).load(); 
}

function reload_afec_assessors_table()
{
    var data_url = "../api/v1/people_admin.php?action=read_afec_assessors&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $('#tbl_afec_assessors').DataTable().ajax.url(data_url).load(); 
}

function reload_faculty_profiles_table()
{
    var data_url = "../api/v1/people_admin.php?action=read_faculty_profiles&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $('#tbl_faculty_profiles').DataTable().ajax.url(data_url).load(); 
}

function uploadProfileImage()
{
    $("#registrationForm").submit(function(e){

        e.preventDefault();
        var ptToken     = $("input[name=token]").val();
        var logoImage   = document.querySelector('input[name="input-file-logo"]').files[0];
        var saveButton  = document.getElementById('saveProfileImage');

        var messageLabel = document.getElementById('messageLabel');
        messageLabel.style.display = "block";

        var formData = new FormData();
        formData.append('file', logoImage);
        formData.append('ptToken', ptToken);

        $.ajax({
            url: '../content/upload_profile_image.php',
            type: "post",
            dataType: "json",
            data: formData,
            contentType: false,
            cache: false,
            processData:false,

            success: function(data)
            {
                saveButton.style.display = "none";

                if (data.errorMessage != null)
                {
                    messageLabel.innerHTML = data.errorMessage;
                }
                else
                {
                    messageLabel.innerHTML = "Image successfully uploaded!";
                }
            }
        });
    });
}

function configurePreRead()
{    
    var prereadhtml = "";
    for(var i=0; i < interventions.length; i++)
    {
        if (typeof interventions[i]['type'] !== 'undefined')
        {
            if (interventions[i]['type'] == "Pre-read")
            {
                $('.pre-reading-box').show();
                new_link = "/?academy=8&page=ogkm_learning_pathways&view=ogkm";
                intervention_name = interventions[i]['name'];
                
                if(interventions[i]['link_url'] != '' && interventions[i]['link_url'] != null && interventions[i]['links'] == 'assigned')
                {
                    intervention_link = interventions[i]['link_url'];
                    prereadhtml += "<a class='btn' target='_blank' href='"+intervention_link+"'>"+intervention_name+"</a>";
                }
                else
                {
                    intervention_link = "/?academy=8&view=intervention&intervention=" +interventions[i]['id'];
                    prereadhtml += "<a class='btn green-link' href='"+intervention_link+"'>"+intervention_name+"</a>";
                }       
                interventions.splice(i, 1);
                i--;
            }
        }
    }
    $('.pre-reading-buttons').html(prereadhtml);
}

function isValidEmailAddress(email)
{
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function readOnlineCourses()
{
    var token = $('input[name="token"]').val();
    $.ajax({
        url     : '../course_admin/ajax_get_online_courses.php',
        type    : "POST",
        dataType: "json",
        data    :
        {
            ptToken          : token
        },
        success: function(response)
        {
            var length = response.length;
            $("#online_courses").empty();
            for( var i = 0; i < length; i++)
            {
                var id = response[i]['id'];
                var name = response[i]['name'];
                $("#online_courses").append("<option value='"+id+"'>"+name+"</option>");
            }
        }
    });
}

function CheckForIntakesFeedbackForms()
{
    if ($('#rpt-course-frm').is(":hidden"))
    {
        $('#rpt-course-frm').parent().show();
        $('#rpt-feedback-frm').parent().show();
       
    }

    if ($('#rpt-case-study-frm').is(":hidden"))
    {
        $('#rpt-case-study-frm').parent().show();       
    }
}

var prevProductIndex = '';
function OnProductAreaChangeFilters()
{
   
    var logic_status    = false;
    var currIndex       = document.getElementById("rpt-report-areas-frm").selectedIndex;
    var currentVal      = $("#rpt-report-areas-frm").val();
    var gamesEdition    = $('#ge-list-dropdown').val();

    $("#rpt-programme-frm").prev().html('Activity Name');

    if( currIndex >= 0 )
    {
        if(prevProductIndex !== currIndex)
        {
            prevProductIndex = currIndex;
            logic_status = true;
        }
        else if (currentVal === "all")
        {
             logic_status = true;
        }
        else
        {
            logic_status = false;
        }

    }
    DisableApplyFilterBtn(); 
    
    if (logic_status)
    {
       
        var product_area_id = $("#rpt-report-areas-frm").val();    
        var function_type = "change_productarea_filters";   
        var token = $('input[name="token"]').val();

        DisableApplyFilterBtn();  
        
        report_area_default = document.getElementById("ogkm-dash-report-body");
        if (report_area_default)
        {
            $(".reports-loader").show(); 
        }
        
        $("#date-selectors-ogkm-reports").parent().hide();

        $.ajax({
            url: '../course_admin/ajax_generate_feedback_charts.php',
            dataType: "json",
            data: {
                function         : function_type,
                product          : product_area_id,           
                ptToken          : token,
                ocog_id          : gamesEdition
            },
            success: function(data)
            {
                try
                {
                    if (data.output != null)
                    {
                        course = data.output['courses'];
                        feedback = data.output['feedback'];
                        cases = data.output['case'];
                        programmes = data.output['programmes']

                        if (product_area_id == 'case_studies') //Special case where activites won;t be shown and case studies will be shown
                        {                           
                            programmes = data.output['case'];
                            $("#rpt-programme-frm").prev().html('Case Study Name');
                        }                                               

                        if (course == 0 || feedback == 0)
                        { 
                            $("#rpt-programme-frm").html(data.output['programmes']);                        
                            $("#rpt-course-frm").parent().hide();
                            $("#rpt-feedback-frm").parent().hide();
                            $("#rpt-case-study-frm").parent().hide();
                            $('#activity_visits').hide();
                            DisableApplyFilterBtn();
                        }
                        else
                        {
                            $("#rpt-course-frm").html(course);
                            $("#rpt-programme-frm").html(programmes);
                            $("#rpt-feedback-frm").html(data.output['feedback']);                   
                            $("#rpt-case-study-frm").html(data.output['case']);

                            $("#rpt-feedback-frm").trigger('change');

                            $("#rpt-course-frm").parent().show();
                            $("#rpt-feedback-frm").parent().show();
                            if (cases == 0)
                            {
                                $("#rpt-case-study-frm").parent().hide();
                            }
                            else
                            {
                                loadFiltersInStages("#rpt-case-study-frm");
                                $("#rpt-case-study-frm").parent().show();
                            }

                            if (product_area_id == 'case_studies')
                            {
                                $("#rpt-course-frm").parent().hide()
                                $("#rpt-feedback-frm").val('all'); // Reset to default
                                $("#rpt-feedback-frm").parent().hide();
                                $("#date-selectors-ogkm-reports").parent().show();
                                EnableApplyFilterBtn();
                            }
                            
                            loadFiltersInStages("#rpt-programme-frm");                    
                            //EnableApplyFilterBtn();
                        }                        
                        
                        $(".reports-loader").hide();
                    } 
                    else if (data.error != null)
                    {
                        alert("Something went wrong!");
                         $(".reports-loader").hide();
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                     $(".reports-loader").hide();
                }
            }
        });
    }
}

function OnGamesEditionsChangeFilters()
{
    var games_edition_id = $('#ge-list-dropdown').val();
    var function_type = "ge_lp_filter";   
    var token = $('input[name="token"]').val();
    var level = $('#ogkm-report-level').val();

    $.ajax({
        url: '../course_admin/ajax_generate_feedback_charts.php',
        dataType: "json",
        data: {
            function         : function_type,
            product          : games_edition_id,           
            ptToken          : token,
            level            : level
    },
    success: function(data)
    {
        try
        {
            if (data.output != null)
            {
                if (level == "lp-area")
                {
                    $('#lp-list-dropdown').html(data.output);
                }
                else if (level == "product-area")
                {
                    $('#rpt-programme-frm').html(data.output);
                    $('#activity_visits').hide();
                    //loadFiltersInStages("#rpt-report-areas-frm");
                    OnProductAreaChangeFilters();
                   
                }
            } 
            else if (data.error != null)
            {
                alert("Something went wrong!");
            }
        }
        catch (e)
        {
            alert("Something went wrong.");
        }
    }
    });    
}

function OnLPTypeChangeFilters()
{
    var lp_type             = $('#ogkm-lp-type').val();
    var games_edition_id    = $('#ge-list-dropdown').val();
    var function_type       = "lp_type_filter";   
    var token               = $('input[name="token"]').val();

    $.ajax({
        url: '../course_admin/ajax_generate_feedback_charts.php',
        dataType: "json",
        data: {
            function         : function_type,
            geid             : games_edition_id,
            product          : lp_type,           
            ptToken          : token
    },
    success: function(data)
    {
        try
        {
            if (data.output != null)
            {
                $('#lp-list-dropdown').html(data.output);
               
            } 
            else if (data.error != null)
            {
                alert("Something went wrong!");
            }
        }
        catch (e)
        {
            alert("Something went wrong.");
        }
    }
    });    
}

function generate_individual_presenter(session)
{
    Highcharts.chart('chart-area', {
              chart: {
                type: 'column'
              },
              title: {
                text: null
              },
                 credits: {
                            enabled: false
                        },
                        exporting: {
                            enabled: true
                        },
                        xAxis: {
                                categories: session['xaxis']
                            },
                            yAxis: {
                                min: 1,
                                max: 7,
                                tickInterval: 1,
                                title: {
                                    text: "Score",
                                    align: "high"
                                }
                            },
                        startOnTick : true,
                        tooltip: {

                        },
                        plotOptions: {
                            column: {
                                dataLabels: {
                                    enabled: true,
                                    crop: false,
                                    overflow: 'none'
                                }
                            }
                        },
                        series: [{
                                    name: "Scale average is out of 7",
                                    data: session['series'],

                                }]
            });
        
}

function copyLink(e)
{   
    var link = $(e.target).attr('data-index');    
    var alertMsg = '';
    var temp = document.createElement('textarea');

    if (typeof link == "undefined")
    {
        var err = $(e.target).attr('data-err');
        if (err == 'null_source_academy')
        {
            alertMsg = 'Source academy is not set. Please set source academy for this user and retry.';
        }
        else
        {
            alertMsg = 'Error: Link not found';
        } 
        
        /*Clear previous copy*/
        temp.value = "-";         
    }
    else
    {  
        temp.value = link;  
        alertMsg = 'Link copied';     
    }

    document.body.appendChild(temp);    
    temp.select();
    document.execCommand('copy');
    document.body.removeChild(temp);
    
    alert(alertMsg);
    
}

function copyQRLink()
{   
    var elText = document.getElementById("inputQRcode");
    var link   = elText.value;

    var temp = document.createElement('textarea');
    temp.value = link;
    document.body.appendChild(temp);    
    temp.select();
    document.execCommand('copy');
    document.body.removeChild(temp);    
}

$(document).on('click', '#btn-toggle-bg', function() {
    var button = $(this);
    var body = $('body');
    button.toggleClass('active');
    body.toggleClass('overflow-hidden');

    $('body').append('<div class="snapshot-overlay"></div>');
});


// User Profile Save / Update
$(document).on('click', '#save-user-profile-updates', function() {

    cmsLoadingStatus = true;
    loadOverlay();

    var action       = 'edit_user_profile';
    var token        = $('input[name="token"]').val();
    var user_id      = $('input[name="user_id"]').val();
    var academy      = $('input[name="academy"]').val();

    var first_name   = $('#first_name').val();
    var last_name    = $('#last_name').val();
    var country_code = $('#country_code').val();
    var state_id     = $('#state_id').val();
    var age_range    = $('#age_range').val();
    var gender       = $('#gender').val();
    var email        = $('#email').val();
    var mobile       = $('#mobile_number').val();
    var wechat_id    = $('#wechat_id').val();
    var snow_id      = $('#snow_id').val();
    var sub_academy  = $('#sub_academy').val();
    var profileImage = document.querySelector('input[name="profile-image"]').files[0];
    var user_bio      = $('#user_bio').val();
    var linkedin_profile    = $('#linkedin_profile').val();
    var facebook            = $('#facebook_profile').val();
    var instagram           = $('#instagram_profile').val();

    var formData = new FormData();
    formData.append('action', action);
    formData.append('ptToken', token);
    formData.append('user_id', user_id);
    formData.append('first_name', first_name);
    formData.append('last_name', last_name);
    formData.append('country_code', country_code);
    formData.append('state_id', state_id);
    formData.append('age_range', age_range);
    formData.append('gender', gender);
    formData.append('file', profileImage);
    formData.append('email', email);
    formData.append('mobile', mobile);
    formData.append('wechat_id', wechat_id);
    formData.append('snow_id', snow_id);
    formData.append('sub_academy', sub_academy);
    formData.append('user_bio', user_bio);
    formData.append('linkedin_profile', linkedin_profile);
    formData.append('facebook_profile', facebook);
    formData.append('instagram_profile', instagram);

    $('#update-source-academy-div').removeClass("alert-danger");
    $('#update-source-academy-div').removeClass("alert-success");

    if ((first_name == '') || (first_name == null))
    {
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Error : First name not found!");
        cmsLoadingStatus = false;
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((last_name == '') || (last_name == null))
    {
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Error : Last name not found!");
        cmsLoadingStatus = false;
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((country_code == '') || (country_code == null))
    {
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Error : Country not found!");
        cmsLoadingStatus = false;
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if (($('#state_id').is(':visible')) && ((state_id == '') || (state_id == null)))
    {       
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Error : State / Province not found!");
        cmsLoadingStatus = false;
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
       
    }
    else if (($('#age_range').length) && ((age_range == '') || (age_range == null)))
    {
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Age range not found!");
        cmsLoadingStatus = false;
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if (($('#gender').length) && ((gender == '') || (gender == null)))
    {
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Gender not found!");
        cmsLoadingStatus = false;
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((email == '') || (email == null))
    {
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Email not found!");
        cmsLoadingStatus = false;
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if (((snow_id == '') || (snow_id == null)) && (academy == 109))
    {
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Snow ID not found!");
        cmsLoadingStatus = false;
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        $.ajax({
            url: "../cms/ajax_cms.php",
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData,
            success: function(data) {
                try
                {
                   
                    if (data.output == true)
                    {
                        $('#user-profile-name').html(first_name + " " + last_name);
                        $('#update-source-academy-div').addClass("alert-success");
                        $('#update-source-academy-div').html("User profile successfully updated!");
                        location.reload();
                    } 
                    else if (data.output == 'incorrect_mobile_number_format')
                    {
                         cmsLoadingStatus = false;
                        $('#update-source-academy-div').addClass("alert-danger");
                        $('#update-source-academy-div').html("Error : Incorrect mobile number format!");
                    }
                    else if (data.output == 'email_exists')
                    {
                         cmsLoadingStatus = false;
                        $('#update-source-academy-div').addClass("alert-danger");
                        $('#update-source-academy-div').html("Error : Email address already in use. Enter a different Email address!");
                    }
                    else if (data.output == "user_access_issue")
                    {
                         cmsLoadingStatus = false;
                        $('#update-source-academy-div').addClass("alert-danger");
                        $('#update-source-academy-div').html("Error : User doesn't have acccess to change email!");
                    }
                    else if (data.output == "send_email")
                    {
                        $('#update-source-academy-div').addClass("alert-success");
                        $('#update-source-academy-div').html("User profile successfully updated!!");

                        var url = window.location.href;
                        var url_part = url.split("&page=");
                        window.location.replace(url_part[0]+"&logout=1&page=email_verification" );
                    }
                    else
                    {
                        $('#update-source-academy-div').addClass("alert-danger");
                        $('#update-source-academy-div').html("Error : User profile is not updated!");
                    }               
                    $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
                }   
                catch (e)
                {
                    $('#update-source-academy-div').addClass("alert-danger");
                    $('#update-source-academy-div').html("Error : User profile is not updated!");
                    $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
                }
            }
        });
    }
});

// attach the `fileselect` event to all file inputs on the page
$(document).on('change', '.generic-file-input', function() {
    var input = $(this),
        numFiles = input.get(0).files ? input.get(0).files.length : 1,
        label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
    input.trigger('fileselect', [numFiles, label]);
});

 $(document).on('change', '.generic-file-input', function(e){
        
    let fileFileName = e.target.files[0];
    var fileType = fileFileName['type'];
    var validFileTypes = ['image/gif', 'image/jpeg', 'image/png', 'application/pdf'];

    // console.log(e.target.files[0]);

    if (validFileTypes.includes(fileType)) {

        var reader = new FileReader();

        reader.onload = function(e) {
            
           let fileTempFile = e.target.result;

           $('.profile-thumb').attr('src', fileTempFile);
           $('.profile-thumb').css('display', 'block');
           $('.btn-profile').find('.fa-user').css('display', 'none');
           $('.user-header').find('img').attr('src', fileTempFile);
        }

        reader.readAsDataURL(fileFileName);
    } else {
        alert('! Acceptable file types are: .gif, .jpeg, .png'); // Acceptable audio types are .mp4, .mp3
    }
});



function renderModal(type, title, body, footer, styles) {
    $('#dynamic-modal').remove();

    var closeBtn = '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';

    var modalHtml = '<div class="modal fade" id="dynamic-modal">'+
          '<div class="modal-dialog ' + type + '" style="' + styles + '">'+
              '<div class="modal-content">'+
                  '<div class="modal-header">'+
                      '<h4 class="modal-title">' + title + '</h4>'+
                      closeBtn +
                  '</div>'+
                      body +
                  '<div class="modal-footer">'+
                      footer +
                  '</div>'+
              '</div>'+
          '</div>'+
      '</div>';
  $('body').append(modalHtml);
  var modal = $('#dynamic-modal');
  modal.modal('show');
}


$.urlParam = function (name) {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
};

generic = {
  isolatedCategory: []
};
var urlAcademy = $.urlParam('academy');
var urlViewVal = $.urlParam("view");
var urlPageVal = $.urlParam("page");
var urlRenderVal = $.urlParam("render");
var urlSubAcademy = $.urlParam('sub_academy_id');
var tabId = $.urlParam('tab');

Object.size = function(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

function addValuesToTextChangeArrayCMS(key)
{
    if (!(key in textChangeArrayCMS))
    {
        textChangeArrayCMS[key] = oldValueCMS;
    }
}

function checkTextChangeCMS(key, value)
{
    isDirty = true;

    if (key in textChangeArrayCMS)
    {

        if (value == textChangeArrayCMS[key])
        {
            delete textChangeArrayCMS[key];

            var sizeTextChangeArrayCMS = Object.size(textChangeArrayCMS);

            if (sizeTextChangeArrayCMS >= 1)
            {
                isDirty = true;
            }
            else
            {
                isDirty = false;        
            }                       
        }
        else
        {
            isDirty = true;
        }
    }

    window.onbeforeunload = function (evt) 
    {
        if (isDirty)
        {
            return 'If you continue your changes will not be saved.';
        }
    }
}

$(function () {

    if ((urlViewVal == 'cms') && (urlPageVal != 'academy')) 
    {
        $('#cms-form input, #cms-form select, #cms-form radio, #cms-form checkbox, #cms-form textarea').on('change', function() {
            var key   = $(this).attr("name");
            var value = $(this).val();

            addValuesToTextChangeArrayCMS(key);
            checkTextChangeCMS(key, value);
        });

        $('#cms-form input, #cms-form select, #cms-form radio, #cms-form checkbox, #cms-form textarea').on('click', function() {
            oldValueCMS = $(this).val();
        });

        $("#cms-form").submit(function(e){
            isDirty = false;
            textChangeArrayCMS = {};
        });
    }

    // check if user has made any changes to form fields 
    if (urlPageVal == 'certification_admin') {
        // listen to all .form-control fields for "change"
        $(document).on('change', '#edit-certification-modal .form-control', function() {
            var key   = $(this).attr("name");
            var value = $(this).val();

            addValuesToTextChangeArrayCMS(key);
            checkTextChangeCMS(key, value);
        });

        // listen to delete btns 
        $(document).on('click', '.btn-delete-expertise', function() {
            isDirty = true;
        });

        // fire confirm alert if user tries to close modal without saving
        $(document).on('hide.bs.modal', '#edit-certification-modal', function() {
            if (isDirty) {
                if (!confirm('If you continue your changes will not be saved')) {
                    return false;
                } else {
                    isDirty = false;
                    console.log(isDirty);
                }
            }
        });

        // reset variables if user clicks save 
        $(document).on('click', '#update-certification-btn', function(e){
            isDirty = false;
            textChangeArrayCMS = {};
        });
    }

  // feedback forms range slider
  if (urlViewVal === 'feedback' || urlPageVal === 'feedback_form') {
    var mobileResize = function mobileResize() {
      var custom_values;
      var range = $(".range_8_3, .range_8_2, .range_8_4, .range_8_1");
      var range7 = $(".range_7_4, .range_7_3, .range_7_2, .range_7_1");
      custom_values = [0, 1, 2, 3, 4, 5, 6, 7, 'N/A'];
      custom_values7 = [0, 1, 2, 3, 4, 5, 6, 7];

      if ($(window).width() < 768) {
        range.ionRangeSlider({
          type: "single",
          grid: true,
          min: 1,
          values: custom_values,
          skin: "round"
        });
        range7.ionRangeSlider({
          type: "single",
          grid: true,
          min: 1,
          values: custom_values7,
          skin: "round"
        });
        $('.range_10').ionRangeSlider({
          type: "single",
          grid: true,
          min: 1,
          values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          skin: "round"
        });
        $('.range_9').ionRangeSlider({
          type: "single",
          grid: true,
          min: 1,
          values: [0, 1, 2, 3, 4, 5, 6, 7, 'N/A', 'N/A'],
          skin: "round"
        });
      }
    };

    (function ($, functionName) {
      'use strict'; // debouncing function from John Hann
      // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/

      var debounce = function debounce(cb, threshold, execAsap) {
        var timeout;
        return function debounced() {
          var obj = this,
              args = arguments;

          function delayed() {
            if (!execAsap) {
              cb.apply(obj, args);
            }

            timeout = null;
          }

          if (timeout) {
            clearTimeout(timeout);
          } else if (execAsap) {
            cb.apply(obj, args);
          }

          timeout = setTimeout(delayed, threshold || 10);
        };
      }; // smartresize


      jQuery.fn[functionName] = function (callback) {
        return callback ? this.bind('resize', debounce(callback)) : this.trigger(functionName);
      };
    })(jQuery, 'smartresize');

    mobileResize();
    $(window).smartresize(function () {
      mobileResize();
    });
  } // video resources for curling


  if (urlViewVal == 'resources') {
    var academy = getResourseAcademy();
    var entry   = readEntry();

    var renderVideoResourcesCats = function renderVideoResourcesCats() {
      // lang = getLang();
      // language = getLanguage();
      $('#ca-resource-videos').html('');
      console.log(list_of_resources);
      var ele;

      for (var i = 0; i < list_of_resources.length; i++) {
        var r = list_of_resources[i];
        var imagePlaceHolder = r.lead_image_url != null ? '' : '<i class="fa fa-image"></i>';
        ele = "\n                <div class=\"col-lg-3 col-md-6\">\n                    <div class=\"card mb_5\">\n                        <div class=\"card-header-img\" style=\"background-image: url('".concat(r.lead_image_url, "')\">").concat(imagePlaceHolder, "</div>\n                        <div class=\"card-footer\">\n                            <a data-id=\"").concat(r.subheading_id, "\" href=\"?academy="+academy+"&view=libraries&page=content_items").concat(r.subheading_id, "\" class=\"btn btn-primary btn-block\">\n                                ").concat(r.subheading, "\n                                <i class=\"fa fa-angle-right\"></i>\n                            </a>\n                        </div>\n                    </div>\n                    ");
        $('#ca-resource-videos').append(ele);
      }
    };

    var renderVideoResources = function renderVideoResources(dataId, reorder) {
      generic.isolatedCategory = list_of_resources.filter(function (p) {
        return p.subheading_id == dataId;
      });
      var videos = generic.isolatedCategory[0].resources; // sort by name

      videos.sort(function (a, b) {
        if (a.title !== null) {
          var nameA = a.title.toUpperCase(); // ignore upper and lowercase

          var nameB = b.title.toUpperCase(); // ignore upper and lowercase

          if (reorder == 'title-ascending') {
            if (nameA < nameB) {
              return -1;
            }

            if (nameA > nameB) {
              return 1;
            }
          } else if (reorder == 'title-descending') {
            if (nameA > nameB) {
              return -1;
            }

            if (nameA < nameB) {
              return 1;
            }
          } // names must be equal

        }

        return 0;
      });
      console.log(videos);
      var container = "\n                <div class=\"col-md-12\">\n                    <div class=\"row mb_5\">\n                        <div class=\" col-6 col-md-3\">\n                            <select name=\"selectCategory\" id=\"inputSelectCategory\" class=\"form-control\" required=\"required\">\n                                <option value=\"\">-- "+entry[3129]+" --</option>\n                            </select>\n                        </div>\n                        <div class=\"col-6 col-md-3 col-md-offset-6\">\n                            <select name=\"filter\" id=\"inputFilter\" class=\"form-control\" required=\"required\">\n                                <option value=\"\">-- "+entry[3130]+" --</option>\n                                <option value=\"title-ascending\">"+entry[3121]+"</option>\n                                <option value=\"title-descending\">"+entry[3122]+"</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"row\" id=\"video-mount-point\"></div>\n                </div>\n            ";
      $('#ca-resource-videos').html(container);
      var optionCat, selectCat;

      for (var i = 0; i < list_of_resources.length; i++) {
        var r = list_of_resources[i];
        selectCat = r.subheading_id == dataId ? ' selected' : '';
        optionCat = "<option".concat(selectCat, " value=\"").concat(r.subheading_id, "\">").concat(r.subheading, "</option>");
        $('#inputSelectCategory').append(optionCat);
      }

      var video, button;

      for (var i = 0; i < videos.length; i++) {
        var v = videos[i];

        if (userId != '' || v["public"] != 1) {
          button = "<button data-id=\"".concat(v.resource_id, "\" class=\"btn-play-video btn btn-primary\"><i class=\"fa fa-play\"></i> "+entry[3120]+"</button>");
        } else {
          button = "<a href=\"/?view=login&academy="+academy+"\" class=\"btn btn-primary\"><i class=\"fa fa-lock\"></i> Login to Play</a>";
        }

        video = "\n                    <div class=\"col-md-6\">\n                        <div class=\"video-item-container mb_3\">\n                            <div class=\"video-title mb_3\"><b>".concat(v.title, "</b></div>\n                            <div class=\"row\">\n                                <div class=\"col-md-5\">\n                                    <div class=\"video-thumb\" style=\"background-image: url('").concat(v.cover_image_url, "')\"></div>\n                                </div>\n                                <div class=\"col-md-7\">\n                                    <p class=\"mb_2\" style=\"height: 160px; overflow: auto\">").concat(v.description, "</p>\n                                    ").concat(button, "\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                ");
        $('#video-mount-point').append(video);
      }
    };

    var renderVideoModal = function renderVideoModal(dataId) {
      var isolatedVideo = generic.isolatedCategory[0].resources.filter(function (p) {
        return p.resource_id == dataId;
      });
      var modalTitle = isolatedVideo[0].title;
      var forms = "\n                <div class=\"embed-responsive embed-responsive-16by9 mb_3\">\n                    <video class=\"embed-responsive-item\" controls=\"\" controlsList=\"nodownload\">\n                      <source src=\"".concat(isolatedVideo[0].resource_path, "\" type=\"video/mp4\">\n                    </video>\n                </div>\n                <div class=\"modal-body\">\n                    <p>").concat(isolatedVideo[0].description, "</p>\n                </div>\n            ");
      var footerText = "<button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Close</button>";
      var type = 'modal-lg',
          title = modalTitle,
          body = forms,
          footer = footerText; // fire the modal

      renderModal(type, title, body, footer);
    };

    var list_of_resources = read_all_active_resources();
    var userId = loggedInStatus();
    var urlCategoryVal = $.urlParam("category");
    console.log(urlCategoryVal);
    $(document).on('click', '.btn-resource-category', function () {
      var dataId = $(this).data('id');
      renderVideoResources(dataId);
    });
    $(document).on('change', '#inputSelectCategory', function () {
      var dataId = $(this).val();
      renderVideoResources(dataId);
    });
    $(document).on('change', '#inputFilter', function () {
      var reorder = $(this).val();
      dataId = generic.isolatedCategory[0].subheading_id;
      renderVideoResources(dataId, reorder);
    });
    $(document).on('click', '.btn-play-video', function () {
      var dataId = $(this).data('id');
      renderVideoModal(dataId);
    });
    $(document).ready(function () {
      if (urlCategoryVal != null) {
        renderVideoResources(urlCategoryVal);
      } else {
        renderVideoResourcesCats();
      }
    });
  }
});

$(document).on('click', '.snapshot-overlay', function() {
    var button = $('#btn-toggle-bg');
    var body = $('body');
    var overlay = $(this);
    button.toggleClass('active');
    body.toggleClass('overflow-hidden');
    overlay.remove();
});

var isAddingDelivererRole = false;

function addDelivererRole() {

    if (isAddingDelivererRole)
    {
        return false;
    }

    isAddingDelivererRole = true;
    $(".create_deliverer_wrapper .msg-content").html("");
    $(".create_deliverer_wrapper .msg-wrapper").hide();
    $(".create_deliverer_wrapper .msg-content").removeClass('alert-danger');
    $(".create_deliverer_wrapper .msg-content").removeClass('alert-success');

    var roleName        = $("#role_name_inp").val().trim();    

    var assessCourses                        = $("#assess_courses_dropdown option:selected").val();
    var setupCourses                         = $("#setup_courses_dropdown option:selected").val();
    var elearningBuilder                     = $("#elearning_builder_dropdown option:selected").val();
    var courseAdminReports                   = $("#course_admin_reports_dropdown option:selected").val();
    var registerParticipants                 = $("#register_participants_dropdown option:selected").val();
    var sendFeedbackForms                    = $("#send_feedback_forms_dropdown option:selected").val();
    var createCertificates                   = $("#create_certificates_dropdown option:selected").val();
    var createVouchers                       = $("#create_vouchers_dropdown option:selected").val();
    var deleteCourses                        = $("#delete_courses_dropdown option:selected").val();
    var viewWorkbooks                        = $("#view_workbooks_dropdown option:selected").val();

    var viewAnalyticsTotalUsers              = $("#view_analytics_total_users_checkbox").prop("checked") == true ? 1:6;
    var viewAnalyticsUsersByDate             = $("#view_analytics_users_by_date_checkbox").prop("checked") == true ? 1:6;
    var viewAnalyticsUsersByCountry          = $("#view_analytics_users_by_country_checkbox").prop("checked") == true ? 1:6;
    var viewAnalyticsUsersByRegion           = $("#view_analytics_users_by_region_checkbox").prop("checked") == true ? 1:6;
    var viewAnalyticsUsersByCourses          = $("#view_analytics_users_by_courses_checkbox").prop("checked") == true ? 1:6;
    var viewAnalyticsMostPopularContentItems = $("#view_analytics_most_popular_content_items_checkbox").prop("checked") == true ? 1:6;
    var viewUserDetails                      = $("#view_user_details_checkbox").prop("checked") == true ? 1:6;
    var courseBuilder                        = $("#course_builder_checkbox").prop("checked") == true ? 1:6;
    var facilitiesCheckbox                   = $("#facilities_checkbox").prop("checked") == true ? 1:6;
    var viewAllF2FCoursesCheckbox            = $("#view_all_face_to_face_courses_checkbox").prop("checked") == true ? 1:6;
    var guidedLearningCheckbox               = $("#guided_learning_checkbox").prop("checked") == true ? 1:6;
    var displayUserDetailsWithinAnalytics    = $("#display_user_details_within_analytics_checkbox").prop("checked") == true ? 1:6;

    var functionType    = "add_deliverer_role";
    var token           = $('input[name="token"]').val();

    if (roleName == "")
    {
        $(".create_deliverer_wrapper .msg-content").html("Fields can't be blank.");
        $(".create_deliverer_wrapper .msg-content").addClass('alert-danger');
        $(".create_deliverer_wrapper .msg-wrapper").slideDown();

        setTimeout(function(){
            $(".create_deliverer_wrapper .msg-wrapper").slideUp();
        }, 2500);

        isAddingDelivererRole = false;
        return false;
    }

    $("#add-role-loaders").show();
    $(".add-role-btn").hide();

    var data = {name: roleName, 
                assess_courses: assessCourses, 
                setup_courses: setupCourses, 
                elearning_builder: elearningBuilder,
                course_admin_reports: courseAdminReports,
                register_participants: registerParticipants,
                send_feedback_forms: sendFeedbackForms, 
                create_certificates: createCertificates, 
                create_vouchers: createVouchers,
                view_analytics_total_users: viewAnalyticsTotalUsers,
                view_analytics_users_by_date: viewAnalyticsUsersByDate, 
                view_analytics_users_by_country: viewAnalyticsUsersByCountry, 
                view_analytics_users_by_region: viewAnalyticsUsersByRegion,
                view_analytics_users_by_courses: viewAnalyticsUsersByCourses,
                view_analytics_most_popular_content_items: viewAnalyticsMostPopularContentItems,
                view_user_details: viewUserDetails,
                course_builder: courseBuilder,
                delete_courses: deleteCourses,
                view_workbooks: viewWorkbooks,
                facilities : facilitiesCheckbox,
                view_all_face_to_face_courses : viewAllF2FCoursesCheckbox,
                guided_learning : guidedLearningCheckbox,
                display_user_details_within_analytics : displayUserDetailsWithinAnalytics
                };
    
    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            data: {
                function         : functionType,
                data             : data,           
                ptToken          : token
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {
                    $(".deliverer-role-table-content").html(data.output);
                    initDelivererRolesDatatable(); 
                    $(".create_deliverer_wrapper .msg-content").html('Deliverer Role added');
                    $(".create_deliverer_wrapper .msg-content").addClass('alert-success');
                    $(".create_deliverer_wrapper .msg-wrapper").slideDown();         
                } 
                else if (data.errorMessage != null)
                {
                    $(".create_deliverer_wrapper .msg-content").html(data.errorMessage);
                    $(".create_deliverer_wrapper .msg-content").addClass('alert-danger');
                    $(".create_deliverer_wrapper .msg-wrapper").slideDown();
                }
            }
            catch (e)
            {
                alert("Something went wrong.");
            }
            finally
            {
                $("#add-role-loaders").hide();
                $(".add-role-btn").show();
                $(".add-role-btn").attr('disabled', true);

                setTimeout(function(){ 
                    $(".create_deliverer_wrapper .msg-wrapper").slideUp(); 
                    $("#role_name_inp").val("");                  
                    $("#assess_courses_dropdown").val(6);
                    $("#setup_courses_dropdown").val(6);
                    $("#elearning_builder_dropdown").val(6);
                    $("#course_admin_reports_dropdown").val(6);
                    $("#register_participants_dropdown").val(6);
                    $("#send_feedback_forms_dropdown").val(6);
                    $("#create_certificates_dropdown").val(6);
                    $("#create_vouchers_dropdown").val(6);
                    $("#delete_courses_dropdown").val(6);
                    $("#view_workbooks_dropdown").val(6);
                    $("#view_user_details_checkbox").prop("checked", false);
                    $("#view_analytics_total_users_checkbox").prop("checked", false);
                    $("#view_analytics_users_by_date_checkbox").prop("checked", false);
                    $("#view_analytics_users_by_country_checkbox").prop("checked", false);
                    $("#view_analytics_users_by_region_checkbox").prop("checked", false);
                    $("#view_analytics_users_by_courses_checkbox").prop("checked", false);
                    $("#view_analytics_most_popular_content_items_checkbox").prop("checked", false);
                    $("#course_builder_checkbox").prop("checked", false);
                    $("#facilities_checkbox").prop("checked", false);
                    $("#view_all_face_to_face_courses_checkbox").prop("checked", false);
                    $("#guided_learning_checkbox").prop("checked", false);
                    $("#display_user_details_within_analytics_checkbox").prop("checked", false);

                    toggleAddRoleButton();
                    isAddingDelivererRole = false;                    
                }, 2500);
            }
        }
    });
}

var isUpdatingRole = false;
function updateDelivererRole(roleId)
{
    if (isUpdatingRole)
    {
        return false;
    }

    isUpdatingRole = true;
    $(".create_deliverer_wrapper .msg-content").html("");
    $(".create_deliverer_wrapper .msg-wrapper").hide();
    $(".create_deliverer_wrapper .msg-content").removeClass('alert-danger');
    $(".create_deliverer_wrapper .msg-content").removeClass('alert-success');
    $(".create_deliverer_wrapper .msg-content").removeClass('alert-warning');

    var roleName                             = $("#role_name_inp").val().trim();    
    var assessCourses                        = $("#assess_courses_dropdown option:selected").val();
    var setupCourses                         = $("#setup_courses_dropdown option:selected").val();
    var elearningBuilder                     = $("#elearning_builder_dropdown option:selected").val();
    var courseAdminReports                   = $("#course_admin_reports_dropdown option:selected").val();
    var registerParticipants                 = $("#register_participants_dropdown option:selected").val();
    var sendFeedbackForms                    = $("#send_feedback_forms_dropdown option:selected").val();
    var createCertificates                   = $("#create_certificates_dropdown option:selected").val();
    var createVouchers                       = $("#create_vouchers_dropdown option:selected").val();
    var deleteCourses                        = $("#delete_courses_dropdown option:selected").val();
    var viewWorkbooks                        = $("#view_workbooks_dropdown option:selected").val();

    var viewAnalyticsTotalUsers              = $("#view_analytics_total_users_checkbox").prop("checked") == true ? 1:6;
    var viewAnalyticsUsersByDate             = $("#view_analytics_users_by_date_checkbox").prop("checked") == true ? 1:6;
    var viewAnalyticsUsersByCountry          = $("#view_analytics_users_by_country_checkbox").prop("checked") == true ? 1:6;
    var viewAnalyticsUsersByRegion           = $("#view_analytics_users_by_region_checkbox").prop("checked") == true ? 1:6;
    var viewAnalyticsUsersByCourses          = $("#view_analytics_users_by_courses_checkbox").prop("checked") == true ? 1:6;
    var viewAnalyticsMostPopularContentItems = $("#view_analytics_most_popular_content_items_checkbox").prop("checked") == true ? 1:6;
    var viewUserDetails                      = $("#view_user_details_checkbox").prop("checked") == true ? 1:6;
    var courseBuilder                        = $("#course_builder_checkbox").prop("checked") == true ? 1:6;
    var facilities                           = $("#facilities_checkbox").prop("checked") == true ? 1:6;
    var viewAllF2FCourses                    = $("#view_all_face_to_face_courses_checkbox").prop("checked") == true ? 1:6;
    var guidedLearning                       = $("#guided_learning_checkbox").prop("checked") == true ? 1:6;
    var displayUserDetailsWithinAnalytics    = $("#display_user_details_within_analytics_checkbox").prop("checked") == true ? 1:6;

    

    var functionType    = "update_deliverer_role";
    var token           = $('input[name="token"]').val();

    if (roleName == "")
    {
        $(".create_deliverer_wrapper .msg-content").html("Fields can't be blank.");
        $(".create_deliverer_wrapper .msg-content").addClass('alert-danger');
        $(".create_deliverer_wrapper .msg-wrapper").slideDown();

        setTimeout(function(){
            $(".create_deliverer_wrapper .msg-wrapper").slideUp();
            toggleAddRoleButton();
        }, 2500);

        isUpdatingRole = false;
        return false;
    }

    $("#add-role-loaders").show();
    $(".add-role-btn").hide();
    $(".cancel-btn").attr("disabled", true);

    var data = {id: roleId, 
                name: roleName, 
                assess_courses: assessCourses, 
                setup_courses: setupCourses,
                elearning_builder: elearningBuilder, 
                course_admin_reports: courseAdminReports,
                register_participants: registerParticipants,
                send_feedback_forms: sendFeedbackForms, 
                create_certificates: createCertificates, 
                create_vouchers: createVouchers,
                view_analytics_total_users: viewAnalyticsTotalUsers,
                view_analytics_users_by_date: viewAnalyticsUsersByDate, 
                view_analytics_users_by_country: viewAnalyticsUsersByCountry,
                view_analytics_users_by_region: viewAnalyticsUsersByRegion,
                view_analytics_users_by_courses: viewAnalyticsUsersByCourses,
                view_analytics_most_popular_content_items: viewAnalyticsMostPopularContentItems,
                view_user_details: viewUserDetails,
                course_builder: courseBuilder,
                facilities: facilities,
                view_all_face_to_face_courses: viewAllF2FCourses,
                guided_learning : guidedLearning,
                delete_courses: deleteCourses,
                view_workbooks: viewWorkbooks,
                display_user_details_within_analytics : displayUserDetailsWithinAnalytics
            };
    
    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            data: {
                function         : functionType,
                data             : data,           
                ptToken          : token
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {
                    cancelUpdateRole();
                    $(".deliverer-role-table-content").html(data.output);
                    initDelivererRolesDatatable(); 
                    $(".create_deliverer_wrapper .msg-content").html('Deliverer Role: ' + roleName + ' has been updated');
                    $(".create_deliverer_wrapper .msg-content").addClass('alert-success');
                    $(".create_deliverer_wrapper .msg-wrapper").slideDown();         
                } 
                else if (data.errorMessage != null)
                {
                    cancelUpdateRole();
                    $(".create_deliverer_wrapper .msg-content").html(data.errorMessage);
                    $(".create_deliverer_wrapper .msg-content").addClass('alert-danger');
                    $(".create_deliverer_wrapper .msg-wrapper").slideDown();
                }
                else if (data.warning != null)
                {
                    cancelUpdateRole();
                    $(".create_deliverer_wrapper .msg-content").html(data.warning);
                    $(".create_deliverer_wrapper .msg-content").addClass('alert-warning');
                    $(".create_deliverer_wrapper .msg-wrapper").slideDown();
                }
            }
            catch (e)
            {
                cancelUpdateRole();
                alert("Something went wrong.");
            }
            finally
            {                
                $("#add-role-loaders").hide();
                $(".add-role-btn").show();
                $(".add-role-btn").attr('disabled', true);

                setTimeout(function(){ 
                    $(".create_deliverer_wrapper .msg-wrapper").slideUp();                    
                    $("#role_name_inp").val("");                    
                    $("#assess_courses_dropdown").val(6);
                    $("#setup_courses_dropdown").val(6);
                    $("#elearning_builder_dropdown").val(6);
                    $("#course_admin_reports_dropdown").val(6);
                    $("#register_participants_dropdown").val(6);
                    $("#send_feedback_forms_dropdown").val(6);
                    $("#create_certificates_dropdown").val(6);
                    $("#create_vouchers_dropdown").val(6);
                    $("#delete_courses_dropdown").val(6);
                    $("#view_workbooks_dropdown").val(6);
                    $("#view_analytics_total_users_checkbox").prop("checked", false);
                    $("#view_analytics_users_by_date_checkbox").prop("checked", false);
                    $("#view_analytics_users_by_country_checkbox").prop("checked", false);
                    $("#view_analytics_users_by_region_checkbox").prop("checked", false);
                    $("#view_analytics_users_by_courses_checkbox").prop("checked", false);
                    $("#view_analytics_most_popular_content_items_checkbox").prop("checked", false);
                    $("#view_user_details_checkbox").prop("checked", false);
                    $("#course_builder_checkbox").prop("checked", false);
                    $("#facilities_checkbox").prop("checked", false);
                    $("#view_all_face_to_face_courses_checkbox").prop("checked", false);
                    toggleAddRoleButton();
                    isUpdatingRole = false; 
                    setTimeout(function(){
                        $(".create_deliverer_wrapper .msg-content").removeClass('alert-danger');
                        $(".create_deliverer_wrapper .msg-content").removeClass('alert-success');
                        $(".create_deliverer_wrapper .msg-content").removeClass('alert-warning');  
                    }, 500);
                    
                }, 2500);
            }
        }
    });
}

function updateDelivererRoleInputs(roleId) {
    var roleName        = $("#main-role-row-"+roleId+" .role-name").text().trim();  

    var assessCourses                        = $("#main-role-row-"+roleId+" .assess_courses").attr('data-index');
    var setupCourses                         = $("#main-role-row-"+roleId+" .setup_courses").attr('data-index');
    var elearningBuilder                     = $("#main-role-row-"+roleId+" .elearning_builder").attr('data-index');
    var courseAdminReports                   = $("#main-role-row-"+roleId+" .course_admin_reports").attr('data-index');
    var registerParticipants                 = $("#main-role-row-"+roleId+" .register_participants").attr('data-index');
    var sendFeedbackForms                    = $("#main-role-row-"+roleId+" .send_feedback_forms").attr('data-index');
    var createCertificates                   = $("#main-role-row-"+roleId+" .create_certificates").attr('data-index');
    var createVouchers                       = $("#main-role-row-"+roleId+" .create_vouchers").attr('data-index');
    var deleteCourses                        = $("#main-role-row-"+roleId+" .delete_courses").attr('data-index');
    var viewWorkbooks                        = $("#main-role-row-"+roleId+" .view_workbooks").attr('data-index');

    var viewAnalyticsTotalUsers              = $("#main-role-row-"+roleId+" .view_analytics_total_users").attr('data-index') == 1 ? true : false;
    var viewAnalyticsUsersByDate             = $("#main-role-row-"+roleId+" .view_analytics_users_by_date").attr('data-index') == 1 ? true : false;
    var viewAnalyticsUsersByCountry          = $("#main-role-row-"+roleId+" .view_analytics_users_by_country").attr('data-index') == 1 ? true : false;
    var viewAnalyticsUsersByRegion           = $("#main-role-row-"+roleId+" .view_analytics_users_by_region").attr('data-index') == 1 ? true : false;
    var viewAnalyticsUsersByCourses          = $("#main-role-row-"+roleId+" .view_analytics_users_by_courses").attr('data-index') == 1 ? true : false;
    var viewAnalyticsMostPopularContentItems = $("#main-role-row-"+roleId+" .view_analytics_most_popular_content_items").attr('data-index') == 1 ? true : false;
    var viewUserDetails                      = $("#main-role-row-"+roleId+" .view_user_details").attr('data-index') == 1 ? true : false;
    var courseBuilder                        = $("#main-role-row-"+roleId+" .course_builder").attr('data-index') == 1 ? true : false;
    var facilities                           = $("#main-role-row-"+roleId+" .facilities").attr('data-index') == 1 ? true : false;
    var viewAllF2FCourses                    = $("#main-role-row-"+roleId+" .view_all_face_to_face_courses").attr('data-index') == 1 ? true : false;
    var guidedLearning                       = $("#main-role-row-"+roleId+" .guided_learning").attr('data-index') == 1 ? true : false;
    var displayUserDetailsWithinAnalytics    = $("#main-role-row-"+roleId+" .display_user_details_within_analytics").attr('data-index') == 1 ? true : false;

    var functionType    = "update_deliverer_role";

    $("#role_name_inp").val(roleName);    
    
    $("#assess_courses_dropdown").val(assessCourses);
    $("#setup_courses_dropdown").val(setupCourses);
    $("#elearning_builder_dropdown").val(elearningBuilder);
    $("#course_admin_reports_dropdown").val(courseAdminReports);
    $("#register_participants_dropdown").val(registerParticipants);
    $("#send_feedback_forms_dropdown").val(sendFeedbackForms);
    $("#create_certificates_dropdown").val(createCertificates);
    $("#create_vouchers_dropdown").val(createVouchers);
    $("#delete_courses_dropdown").val(deleteCourses);
    $("#view_workbooks_dropdown").val(viewWorkbooks);

    $("#view_analytics_total_users_checkbox").prop('checked', viewAnalyticsTotalUsers);
    $("#view_analytics_users_by_date_checkbox").prop('checked', viewAnalyticsUsersByDate);
    $("#view_analytics_users_by_country_checkbox").prop('checked', viewAnalyticsUsersByCountry);
    $("#view_analytics_users_by_region_checkbox").prop('checked', viewAnalyticsUsersByRegion);
    $("#view_analytics_users_by_courses_checkbox").prop('checked', viewAnalyticsUsersByCourses);
    $("#view_analytics_most_popular_content_items_checkbox").prop('checked', viewAnalyticsMostPopularContentItems);
    $("#view_user_details_checkbox").prop('checked', viewUserDetails);
    $("#course_builder_checkbox").prop('checked', courseBuilder);
    $("#facilities_checkbox").prop('checked', facilities);
    $("#view_all_face_to_face_courses_checkbox").prop('checked', viewAllF2FCourses);
    $("#guided_learning_checkbox").prop('checked', guidedLearning);
    $("#display_user_details_within_analytics_checkbox").prop('checked', displayUserDetailsWithinAnalytics);

    $(".add-role-btn").html("Update");
    $(".add-role-btn").addClass("save-btn");
    $(".add-role-btn").tooltip('hide')
          .attr('data-original-title', 'Update Role')
          .tooltip('_fixTitle');

    $(".existing_roles_wrapper").slideUp();
    $(".add-role-btn").attr('onclick', "updateDelivererRole("+roleId+");");
    $(".add-role-btn").after('<button type="button" data-toggle="tooltip" title="Cancel" onclick="cancelUpdateRole();" class="btn btn-danger cancel-btn">Cancel</button>');
    $(".cancel-btn").tooltip('hide')
          .attr('data-original-title', 'Cancel')
          .tooltip('_fixTitle');
    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
    }); 
    $("#add-role-heading").html("Update Deliverer Role");
    toggleAddRoleButton();  
}

function cancelUpdateRole()
{
    $("#role_name_inp").val("");    
    
    $("#assess_courses_dropdown").val(6);
    $("#setup_courses_dropdown").val(6);
    $("#elearning_builder_dropdown").val(6);
    $("#course_admin_reports_dropdown").val(6);
    $("#register_participants_dropdown").val(6);
    $("#send_feedback_forms_dropdown").val(6);
    $("#create_certificates_dropdown").val(6);
    $("#create_vouchers_dropdown").val(6);
    $("#delete_courses_dropdown").val(6);

    $("#view_workbooks_dropdown").val(6);
    console.log("here")

    $("#view_analytics_total_users_checkbox").prop('checked', false);
    $("#view_analytics_users_by_date_checkbox").prop('checked', false);
    $("#view_analytics_users_by_country_checkbox").prop('checked', false);
    $("#view_analytics_users_by_region_checkbox").prop('checked', false);
    $("#view_analytics_users_by_courses_checkbox").prop('checked', false);
    $("#view_analytics_most_popular_content_items_checkbox").prop('checked', false);
    $("#view_user_details_checkbox").prop('checked', false);
    $("#course_builder_checkbox").prop('checked', false);
    $("#facilities_checkbox").prop('checked', false);
    $("#view_all_face_to_face_courses_checkbox").prop('checked', false);
    $("#guided_learning_checkbox").prop('checked', false);   
    $("#display_user_details_within_analytics_checkbox").prop('checked', false);    

    $(".add-role-btn").html("+");
    $(".add-role-btn").removeClass("save-btn");
    $(".add-role-btn").tooltip('hide')
          .attr('data-original-title', 'Create Role')
          .tooltip('_fixTitle');
    $(".add-role-btn").attr('onclick', "addDelivererRole();");
    $(".existing_roles_wrapper").slideDown();    
    $(".cancel-btn").tooltip('hide');
    $(".cancel-btn").remove();
    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
    });  
    $("#add-role-heading").html("Create Deliverer Role");
    toggleAddRoleButton();
}

function deleteDelivererRole(event, roleIndex) {
    var confirmation = confirm("Are you sure you want to delete this role?");

    if (!confirmation)
    {
        return false;
    }

    $(".existing_roles_wrapper .msg-content").html("");
    $(".existing_roles_wrapper .msg-wrapper").hide();
    $(".existing_roles_wrapper .msg-content").removeClass('alert-danger');
    $(".existing_roles_wrapper .msg-content").removeClass('alert-success');

    var elem          = event.target;   
    var functionType  = "delete_deliverer_role";
    var token         = $('input[name="token"]').val();
    
    if (roleIndex == "")
    {
        $(".existing_roles_wrapper .msg-content").html("Invalid Role Id. Can't delete Role");
        $(".existing_roles_wrapper .msg-content").addClass('alert-danger');
        $(".existing_roles_wrapper .msg-wrapper").slideDown();
        return false;
    }

    $("#role-row-"+roleIndex).find(".action-btns").hide();
    $("#role-row-"+roleIndex).find(".role-loaders").fadeIn();
   
    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            data: {
                function         : functionType,
                role_index       : roleIndex,           
                ptToken          : token
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {
                    setTimeout(function(){
                        $(".deliverer-role-table-content").html(data.output);
                        initDelivererRolesDatatable(); 
                        $(".existing_roles_wrapper .msg-content").html('Deliverer Role deleted');
                        $(".existing_roles_wrapper .msg-content").addClass('alert-success');
                        $(".existing_roles_wrapper .msg-wrapper").slideDown(); 

                        $('html, body').animate({
                            scrollTop: $(".existing_roles_wrapper .msg-wrapper").offset().top
                        }, 500); 
                    }, 500);
                } 
                else if (data.errorMessage != null)
                {
                    setTimeout(function(){
                        $(".existing_roles_wrapper .msg-content").html(data.errorMessage);
                        $(".existing_roles_wrapper .msg-content").addClass('alert-danger');
                        $(".existing_roles_wrapper .msg-wrapper").slideDown();
                        $("#role-row-"+roleIndex).find(".role-loaders").hide();     
                        $("#role-row-"+roleIndex).find(".action-btns").show();
                    }, 500);
                }
            }
            catch (e)
            {
                alert("Something went wrong.");
            }
            finally
            {
                setTimeout(function(){ 
                    $(".existing_roles_wrapper .msg-wrapper").slideUp();  
                }, 2500);
            }
        }
    });
}

function showUserProgrammesDialog(delivererRoleUserId, territory, academyid) {
    var token = $('input[name="token"]').val();
    var functionType = "read_role_user_programmes";
    var isFirstStone = getParameterByName('is_first_stone');
    $(".deliverer-role-user-programmes-wrapper").html("Loading...");

    $('#view-users-programmes-modal').on('shown.bs.modal', function () {
        if (territory == 'facility') {
            if (academyid == 14) {
                $('#myModalLabel2').html('View assigned resorts for this user');
            } else {
                $('#myModalLabel2').html('View assigned facilities for this user');
            }            
        } else {
            $('#myModalLabel2').html('View assigned programmes for this user');
        }        
    });

    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            data: {
                function                : functionType,
                deliverer_role_user_id  : delivererRoleUserId,           
                ptToken                 : token,
                is_first_stone          : isFirstStone,
                territory               : territory
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {                    
                    setTimeout(function(){ 
                        $(".deliverer-role-user-programmes-wrapper").html(data.output);
                        initExisitingUserProgrammesDatatable(delivererRoleUserId); 
                    }, 500);
                }                 
            }
            catch (e)
            {
                alert("Something went wrong.");
            }            
        }
    });
}

function showAddUsersToRoleDialog(roleId) {
    
    /*While editing role user if modal is closed and & reopened, set the props back */
    $(".exisiting-users-list-wrapper").show();
    $(".search-btn").show();
    $("#add-user-deliverer").text('Add User');
    $("#search-users-txt").parent().removeClass('col-md-12').addClass('col-md-9');
    $("#search-users-txt").prop('disabled', false);
    $("#cancel-user-deliverer").remove();
    $("#update-user-deliverer").remove();

    /*When reopening the dialog, set the props back */
    $(".role_territory_inp_wrapper").remove(); 
    $(".programmes_for_academy_wrapper").remove();  
    $("#selected-role-id").html("");
    var roleName = $("#main-role-row-"+roleId).find(".role-name").html();
    var title = "Assign users to : " + roleName;
    $("#add-users-modal .modal-title").html(title);
    $("#selected-role-id").html(roleId);
    $("#waos_account").val("");
    $("#search-users-txt").val("");
    $(".search-btn").attr('disabled', true);
    $("#waos_account").hide();
    $("#add-user-deliverer").hide();
   
    var token = $('input[name="token"]').val();
    var functionType = "read_role_users";
    var isFirstStone = getParameterByName('is_first_stone');
    $(".role-users-wrapper").show(); 
    $(".role-users-wrapper").html("Loading..."); 

    $("#search-users-admin #search-users-txt").on('keypress', function(e) {
        if(e.which == 13) {
            if (!$("#search-users-admin .search-btn").is(":disabled"))
            {
                $("#search-users-admin .search-btn").trigger('click');
            }
        }
    });

    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            data: {
                function   : functionType,
                role_id    : roleId,           
                ptToken    : token,
                is_first_stone : isFirstStone
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {                    
                    setTimeout(function(){ 
                        $(".role-users-wrapper").hide(); 
                        $(".role-users-wrapper").html(data.output);
                        $(".role-users-wrapper").fadeIn(); 
                        initExisitingUsersForRolesDatatable(roleId); 
                    }, 500);
                }                 
            }
            catch (e)
            {
                alert("Something went wrong.");
            }            
        }
    });
}

var addingUserDeliverer = false;
function addUserDeliverer()
{
    $(".add-user-to-role-msg-area .msg-content").html("");
    $(".add-user-to-role-msg-area .msg-content").removeClass('alert-danger');
    $(".add-user-to-role-msg-area .msg-content").removeClass('alert-success');
    $(".add-user-to-role-msg-area .msg-content").removeClass('alert-warning');

    if (addingUserDeliverer)
    {
        return false;
    }

    addingUserDeliverer = true;

    var userId = $("#waos_account option:selected").val();
    var roleId = $("#selected-role-id").html();
    var territory = $("#add-users-modal #role_territory_inp option:selected").val();
    var programmes = $("#add-users-modal #programmes_for_academy").val();

    var functionType = "add_user_to_role";
    var isFirstStone = getParameterByName('is_first_stone');

    
    $("#add-user-loader .role-loaders").show();  

    if (userId == "" || roleId == "" || territory == "")
    {
        $(".add-user-to-role-msg-area .msg-content").html("No user or role or territory selected.");
        $(".add-user-to-role-msg-area .msg-content").addClass('alert-danger');
        $(".add-user-to-role-msg-area .msg-wrapper").slideDown();
    }

    var data  = {user_id: userId, territory:territory, role_id: roleId, programmes: programmes};
    var token = $('input[name="token"]').val();

    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            data: {
                function   : functionType,
                data       : data,           
                ptToken    : token,
                is_first_stone : isFirstStone
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {
                    setTimeout(function(){
                        $("#add-user-loader .role-loaders").hide();
                        $(".role-users-wrapper").html(data.output);     
                        $(".add-user-to-role-msg-area .msg-content").addClass('alert-success');                  
                        $(".add-user-to-role-msg-area .msg-content").html('User added to Role');
                        $(".add-user-to-role-msg-area .msg-wrapper").slideDown();
                        initExisitingUsersForRolesDatatable(roleId);                        
                    }, 500);
                } 
                else if (data.warning != null)
                {
                    setTimeout(function(){
                        $("#add-user-loader .role-loaders").hide();
                        $(".add-user-to-role-msg-area .msg-content").html(data.warning);
                        $(".add-user-to-role-msg-area .msg-content").addClass('alert-warning');
                        $(".add-user-to-role-msg-area .msg-wrapper").slideDown();  
                    }, 500); 
                }
                else if (data.errorMessage != null)
                {
                    setTimeout(function(){
                        $("#add-user-loader .role-loaders").hide();
                        $(".add-user-to-role-msg-area .msg-content").html(data.errorMessage);
                        $(".add-user-to-role-msg-area .msg-content").addClass('alert-danger');
                        $(".add-user-to-role-msg-area .msg-wrapper").slideDown();  
                    }, 500); 
                }
            }
            catch (e)
            {
                alert("Something went wrong.");
            }
            finally
            {
                setTimeout(function(){ 
                    $(".add-user-to-role-msg-area .msg-wrapper").slideUp(); 
                    setTimeout(function(){                        
                        $("#add-user-deliverer").hide();
                        $("#waos_account").hide();
                        $("#waos_account").val("");
                        $("#search-users-txt").val("");
                        $(".search-btn").attr('disabled', true);
                        $(".role_territory_inp_wrapper").remove();
                        $(".programmes_for_academy_wrapper").remove();
                    }, 500); 
                }, 2500);

                addingUserDeliverer = false;
            }
        }
    });
}

function cancelEditRoleUser()
{
    if (updatingUserDeliverer)
    {        
        return false;
    }

    /*When editing role user and then closing & reopening the dialog, set the props back */
    $(".exisiting-users-list-wrapper").slideDown();
    $(".search-btn").show();   
    $("#search-users-txt").parent().removeClass('col-md-12').addClass('col-md-9');
    $("#search-users-txt").val('').prop('disabled', false);
    $("#cancel-user-deliverer").remove();
    $("#update-user-deliverer").remove();

    /*When reopening the dialog, set the props back */
    $(".role_territory_inp_wrapper").remove(); 
    $(".programmes_for_academy_wrapper").remove();
    $("#add-user-deliverer").hide();
    $(".search-btn").attr('disabled', true);   
}

var updatingUserDeliverer = false;
function updateRoleUser(roleUserId, roleId)
{
    $(".add-user-to-role-msg-area .msg-content").html("");
    $(".add-user-to-role-msg-area .msg-content").removeClass('alert-danger');
    $(".add-user-to-role-msg-area .msg-content").removeClass('alert-success');
    $(".add-user-to-role-msg-area .msg-content").removeClass('alert-warning');

    if (updatingUserDeliverer)
    {
        return false;
    }    

    updatingUserDeliverer = true;
   
    var territory = $("#add-users-modal #role_territory_inp option:selected").val();
    var programmes = $("#add-users-modal #programmes_for_academy").val();

    var functionType = "update_user_role";
    var isFirstStone = getParameterByName('is_first_stone');
    
    $("#add-user-loader .role-loaders").addClass('update-user-role-loader').show();  
 
    if (territory == "" || roleUserId == "")
    {
        $(".add-user-to-role-msg-area .msg-content").html("No user or role or territory selected.");
        $(".add-user-to-role-msg-area .msg-content").addClass('alert-danger');
        $(".add-user-to-role-msg-area .msg-wrapper").slideDown();
    }

    var data  = {territory:territory, role_user_id: roleUserId, programmes: programmes, role_id: roleId};
    var token = $('input[name="token"]').val();

    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            data: {
                function   : functionType,
                data       : data,           
                ptToken    : token,
                is_first_stone: isFirstStone
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {
                    setTimeout(function(){
                        cancelEditRoleUser();
                        $("#add-user-loader .role-loaders").hide().removeClass('update-user-role-loader');                        
                        $(".role-users-wrapper").html(data.output);     
                        $(".add-user-to-role-msg-area .msg-content").addClass('alert-success');                  
                        $(".add-user-to-role-msg-area .msg-content").html('User role updated');
                        $(".add-user-to-role-msg-area .msg-wrapper").slideDown();
                        initExisitingUsersForRolesDatatable(roleId);                        
                    }, 500);
                }
                else if (data.errorMessage != null)
                {
                    setTimeout(function(){
                        cancelEditRoleUser();
                        $("#add-user-loader .role-loaders").hide().removeClass('update-user-role-loader');
                        $(".add-user-to-role-msg-area .msg-content").html(data.errorMessage);
                        $(".add-user-to-role-msg-area .msg-content").addClass('alert-danger');
                        $(".add-user-to-role-msg-area .msg-wrapper").slideDown();  
                    }, 500); 
                }
            }
            catch (e)
            {
                alert("Something went wrong.");
            }
            finally
            {
                setTimeout(function(){ 
                    $(".add-user-to-role-msg-area .msg-wrapper").slideUp();  
                }, 2500);

                updatingUserDeliverer = false;
            }
        }
    });
}

function editRoleUserShowDialog(roleUserId, userId, roleId, userName, territory)
{
    if (roleUserId == "" || userId == "" || roleId == "" || userName == "" || territory == "")
    {
        return false;
    }

    if ($("#add-user-deliverer").is(":visible"))
    {
        alert('Cannot edit user while adding a user');
        return false;
    }
    

    var territories = ['National', 'Regional', 'International'];
    var academy_id = getParameterByName('academy');
    var is_first_stone = getParameterByName('is_first_stone');
    $(".exisiting-users-list-wrapper").slideUp();
    $(".search-btn").hide();
    $("#search-users-txt").parent().removeClass('col-md-9').addClass('col-md-12');
    $("#search-users-txt").val(userName).prop('disabled', true);
    $("#search-users-txt").after("<div class='row mt-4 role_territory_inp_wrapper'><div class='col-md-12'><div>"+                                                                
                                                                "<select class='form-control' id='role_territory_inp'>");
                                                                        
                                                                        if ((academy_id == 107) || (is_first_stone == 1) || (academy_id == 14))
                                                                        {
                                                                            if (academy_id == 14)
                                                                            {
                                                                                var territories = {'International' : 'international', 'National' : 'national', 'Resort' : 'facility'};
                                                                                var entries = Object.entries(territories);

                                                                                for (var [key, value] of entries) {
                                                                                    $("#role_territory_inp").append("<option value="+value+">"+key+"</option>");
                                                                                }
                                                                            }
                                                                            else
                                                                            {
                                                                                var territories = ['International', 'National', 'Facility'];
                                                                                for (var i = 0; i < territories.length; i++) {
                                                                                    $("#role_territory_inp").append("<option value="+territories[i].toLowerCase()+">"+territories[i]+"</option>");
                                                                                }
                                                                            }                                                                            
                                                                        }
                                                                        else
                                                                        {
                                                                            for (var i = 0; i < territories.length; i++) {
                                                                                $("#role_territory_inp").append("<option value="+territories[i].toLowerCase()+">"+territories[i]+"</option>");
                                                                            }
                                                                        }
                                                                   
                                                                $("#role_territory_inp").after("</select>"+   
                                                        "</div></div></div>");
    $("#role_territory_inp").val(territory);
    
    
    //Add Save & Cancel btn
    var e1 = $("#add-user-deliverer");
    var e2 = e1.clone();
    var e3 = e1.clone();
    e1.after(e2);
    e2.after(e3);
   
    e2.attr({'id':'update-user-deliverer', 'onClick':'updateRoleUser('+roleUserId+', '+roleId+')', 'disabled':false}); 
    e2.text('Save');   
    e3.attr({'id':'cancel-user-deliverer', 'onClick':'cancelEditRoleUser()', 'disabled':false});
    e3.addClass('btn-danger').removeClass('btn-primary');
    e3.text('Cancel');

    e2.show();
    e3.show();

    //Add territory and load default programme list
    $("#add-user-deliverer").attr('disabled', false);
    $(".role_territory_inp_wrapper").after("<div class='row mt-4 programmes_for_academy_wrapper'><div class='col-md-12'><div class='user_role_programmes_for_academy'>"+
            "</div></div></div>"); 

    $(".user_role_programmes_for_academy").after("<div class='mt-3 alert alert-info'><span>Note: Territory is not applicable for eLearning courses</span></div>");

    if ((academy_id == 107) || (is_first_stone == 1) || (academy_id == 14))
    {
        if (territory == 'facility')
        {
            loadFacilitiesByTypeDropdown();
        }       
        else
        {
            loadProgrammesByAcademyDropdown();
        }

        $("#role_territory_inp").on('change', function(){

            var facilityType = $("#role_territory_inp option:selected").val();
            if (facilityType == 'facility')
            {
                loadFacilitiesByTypeDropdown();
            }
            else
            {
                loadProgrammesByAcademyDropdown();
            }
        });
    }
    else
    {
        loadProgrammesByAcademyDropdown(); 
    }

    $(".user_role_programmes_for_academy").hide();

    var token = $('input[name="token"]').val();
    var functionType = "read_role_user_programmes_ids";   

    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            data: {
                function                : functionType,
                deliverer_role_user_id  : roleUserId,           
                ptToken                 : token,
                is_first_stone          : is_first_stone,
                territory               : territory 
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {   
                    if ((!is_first_stone) && (territory != 'facility'))
                    {
                        var prog_ids = [];              
                   
                        for (var i=0; i < data.output.length; i++)
                        {
                            prog_ids.push(data.output[i].programme_id);
                        }

                        $('#programmes_for_academy').val(prog_ids);
                    }
                    else
                    {
                        var facility_ids = [];              
                   
                        for (var i=0; i < data.output.length; i++)
                        {
                            facility_ids.push(data.output[i].facility_id);
                        }

                        console.log(facility_ids);

                        $('#programmes_for_academy').val(facility_ids);
                    }   
                    
                    $('#programmes_for_academy').trigger('change');
                    $(".user_role_programmes_for_academy").slideDown();
                }                 
            }
            catch (e)
            {
                alert("Something went wrong.");
            }            
        }
    });
}

function deleteUserFromRole(roleUserId, userId, roleId)
{
    if (roleUserId == "" || userId == "" || roleId == "")
    {
        return false;
    }

    var confirmation = confirm("Are you sure you want to delete this user from this role?");
    if (confirmation == false)
    {
        return false;
    }

    var token = $('input[name="token"]').val();
    var functionType = "delete_role_user";

    $(".role-user-cell-"+roleUserId+" .role-loaders").show();
    $(".role-user-cell-"+roleUserId+" .delete").hide();
    $(".role-user-cell-"+roleUserId+" .view").hide();
    $(".role-user-cell-"+roleUserId+" .edit").hide();

    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            data: {
                function        : functionType,
                role_id         : roleId,
                role_user_id    : roleUserId,
                user_id         : userId,          
                ptToken         : token
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {
                    setTimeout(function(){
                        $(".role-users-wrapper").html(data.output);     
                        $(".exisiting-users-list-wrapper .msg-content").addClass('alert-success');                  
                        $(".exisiting-users-list-wrapper .msg-content").html('User deleted from role');
                        $(".exisiting-users-list-wrapper .msg-wrapper").slideDown();
                        initExisitingUsersForRolesDatatable(roleId);                        
                    }, 500);
                } 
                else if (data.warning != null)
                {
                    setTimeout(function(){
                        $(".exisiting-users-list-wrapper .msg-content").html(data.warning);
                        $(".exisiting-users-list-wrapper .msg-content").addClass('alert-warning');
                        $(".exisiting-users-list-wrapper .msg-wrapper").slideDown();
                        $(".role-user-cell-"+roleUserId+" .role-loaders").hide();
                        $(".role-user-cell-"+roleUserId+" .delete").show(); 
                        $(".role-user-cell-"+roleUserId+" .view").show();  
                        $(".role-user-cell-"+roleUserId+" .edit").show(); 
                    }, 500); 
                }
                else if (data.errorMessage != null)
                {
                    setTimeout(function(){
                        $(".exisiting-users-list-wrapper .msg-content").html(data.errorMessage);
                        $(".exisiting-users-list-wrapper .msg-content").addClass('alert-danger');
                        $(".exisiting-users-list-wrapper .msg-wrapper").slideDown(); 
                        $(".role-user-cell-"+roleUserId+" .role-loaders").hide();
                        $(".role-user-cell-"+roleUserId+" .delete").show(); 
                        $(".role-user-cell-"+roleUserId+" .view").show(); 
                        $(".role-user-cell-"+roleUserId+" .edit").show(); 
                    }, 500); 
                }                
            }
            catch (e)
            {
                alert("Something went wrong.");
            } 
            finally
            {
                setTimeout(function(){ 
                    $(".exisiting-users-list-wrapper .msg-wrapper").slideUp(); 
                }, 2500);
            }           
        }
    });
}

function loadProgrammesByAcademyDropdown()
{
    var programmesDropdown = '';
    var functionType = 'read_programmes_list';
    var ptToken = $('input[name="token"]').val();
    var academyId = getParameterByName('academy');

    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            async: false,
            data: {
                function        : functionType,  
                academy_id      : academyId,                    
                ptToken         : ptToken
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {
                    $(".user_role_programmes_for_academy").html(data.output);   
                    $("#programmes_for_academy").select2({
                        placeholder: 'Select courses for this user...',
                        theme: 'bootstrap-5',
                        dropdownParent: $('#add-users-modal .modal-body')
                    });
                }                               
            }
            catch (e)
            {
                alert("Something went wrong.");
            }                        
        }
    });
}

function loadFacilitiesByTypeDropdown()
{
    var programmesDropdown = '';
    var functionType = 'read_facilities_list';
    var ptToken = $('input[name="token"]').val();
    var academyId = getParameterByName('academy');
    var facilityType = $("#role_territory_inp option:selected").val();

    if (facilityType == 'state')
    {
        facilityType == 'country';
    }

    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            async: false,
            data: {
                function        : functionType,  
                academy_id      : academyId,
                facility_type   : facilityType,                
                ptToken         : ptToken
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {
                    $(".user_role_programmes_for_academy").html(data.output); 

                    if (academyId == 14)
                    {
                        $("#programmes_for_academy").select2({
                            placeholder: 'Select resorts for this user...'
                        });
                    }  
                    else
                    {
                        $("#programmes_for_academy").select2({
                            placeholder: 'Select facilities for this user...'
                        });
                    }                    
                }                               
            }
            catch (e)
            {
                alert("Something went wrong.");
            }                        
        }
    });
}

function loadFacilitiesByTypeAdmin()
{
    var programmesDropdown = '';
    var functionType = 'read_facilities_list_admin';
    var ptToken      = $('input[name="token"]').val();    
    var facilityType = $("#territory option:selected").val();

    $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            type: "POST",
            async: false,
            data: {
                function        : functionType,               
                facility_type   : facilityType,  
                course_id       : course_id,              
                ptToken         : ptToken
        },
        success: function(data) {
            try
            {
                if (data.output != null)
                {
                    $("#facility_div").html(data.output);
                    $("#facility_div").show();   
                    $("#facility_id").select2({
                        placeholder: 'Select facility'
                    });   
                }                               
            }
            catch (e)
            {
                alert("Something went wrong.");
            }                        
        }
    });
}

function readAddressByMapBoxRestrictByCountry(countrycode, country)
{
    mapboxgl.accessToken = 'pk.eyJ1Ijoid2Fvcy1kZXZlbG9wbWVudCIsImEiOiJjazQzOXpybmcwNXJ6M2psbmoycmxvNGt2In0.cs0B3XScUPbNs8zryWLxag';
    var map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [-2.237680, 53.475021],
        zoom: 4
    });

    $.ajax({
        url: "https://api.mapbox.com/geocoding/v5/mapbox.places/"+country+".json?country="+countrycode+"&access_token="+mapboxgl.accessToken,
        success: function(res) {
            var bbox1 = res.features[0].bbox;
            map.fitBounds([
              [bbox1[0], bbox1[1]],
              [bbox1[2], bbox1[3]]
            ]);
        }
    });
     
    var geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        countries: countrycode,
        mapboxgl: mapboxgl
    });
     
    document.getElementById('geocoder').appendChild(geocoder.onAdd(map));
}

function readAddressByMapBoxRestrictByLocation(location)
{
    mapboxgl.accessToken = 'pk.eyJ1Ijoid2Fvcy1kZXZlbG9wbWVudCIsImEiOiJjazQzOXpybmcwNXJ6M2psbmoycmxvNGt2In0.cs0B3XScUPbNs8zryWLxag';
    var map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [-2.237680, 53.475021],
        zoom: 4
    });
     
    var geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        countries: location,
        mapboxgl: mapboxgl
    });
     
    document.getElementById('geocoder').appendChild(geocoder.onAdd(map));
}

function readAddressByMapBox()
{
    mapboxgl.accessToken = 'pk.eyJ1Ijoid2Fvcy1kZXZlbG9wbWVudCIsImEiOiJjazQzOXpybmcwNXJ6M2psbmoycmxvNGt2In0.cs0B3XScUPbNs8zryWLxag';
    var map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [-2.237680, 53.475021],
        zoom: 4
    });
     
    var geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl
    });
     
    document.getElementById('geocoder').appendChild(geocoder.onAdd(map));
}

function setMarkerByAddress(address)
{
    if ((address != null) && (address != ''))
    {   
        // cmsLoadingStatus = true;
        // loadOverlay();
        
        $('.mapboxgl-ctrl-geocoder--input').val(address);
        mapboxgl.accessToken = 'pk.eyJ1Ijoid2Fvcy1kZXZlbG9wbWVudCIsImEiOiJjazQzOXpybmcwNXJ6M2psbmoycmxvNGt2In0.cs0B3XScUPbNs8zryWLxag';
        var mapboxClient = mapboxSdk({ accessToken: mapboxgl.accessToken });
        mapboxClient.geocoding
        .forwardGeocode({
            query: address,
            autocomplete: false,
            limit: 1
        })
        .send()
        .then(function(response) {
            if (
            response &&
            response.body &&
            response.body.features &&
            response.body.features.length
            ) 
            {
                var feature = response.body.features[0];
                var map = new mapboxgl.Map({
                  container: 'map',
                  style: 'mapbox://styles/mapbox/streets-v11',
                  center: feature.center,
                  zoom: 13
                });
                new mapboxgl.Marker().setLngLat(feature.center).addTo(map);

                // map.on('load', function () {
                //     cmsLoadingStatus = false;
                // });
            }
        });
    }
}

function fillFacilityFormbyAddress(address)
{
    mapboxgl.accessToken = 'pk.eyJ1Ijoid2Fvcy1kZXZlbG9wbWVudCIsImEiOiJjazQzOXpybmcwNXJ6M2psbmoycmxvNGt2In0.cs0B3XScUPbNs8zryWLxag';
    var client   = new MapboxClient(mapboxgl.accessToken);
    client.geocodeForward(address, function(err, data, res)
    {
        var postcode       = '';
        var place_name     = '';
        var place_name_arr = '';
        var city           = '';
        var state          = '';
        var country        = '';

        if (country == '')
        {
            var addressArr = address.split(",");
            country = addressArr[addressArr.length -1];
        }

        for (var i = 0; i < data.features.length; i++) 
        {
            var feature = data.features[i];
            if (feature.place_type[0] == "postcode")
            {
                postcode       = feature.text;
                place_name     = feature.place_name;
                place_name_arr = place_name.split(",");
                city           = place_name_arr[(place_name_arr.length - 3)];
                state          = place_name_arr[(place_name_arr.length - 2)];
                break;                
            }
        }
        
        if (state == '')
        {
            for (var i = 0; i < data.features.length; i++) 
            {
                var feature = data.features[i];
                if (feature.place_type[0] == "address")
                {
                    place_name     = feature.place_name;
                    place_name_arr = place_name.split(",");
                    city           = place_name_arr[(place_name_arr.length - 4)];
                    state          = place_name_arr[(place_name_arr.length - 3)];
                    postcode       = place_name_arr[(place_name_arr.length - 2)];
                    break;                
                }
            }
        }

        readCountryInfoByCountry(country, state);
        $("input[name='city']").val(city);
        $("input[name='postcode']").val(postcode);

        if (postcode == '')
        {
            $("input[name='postcode']").val('');
        }

        if (city == '')
        {
            $("input[name='city']").val('');
        }

        if (country == '')
        {
            $("input[name='country_id']").val('');
            $("#country_id").select2({
                placeholder: '--select--'
            });

            $("input[name='region_id']").val('');
            $("#region_id").select2({
                placeholder: '--select--'
            });
        }

        if (state == '')
        {
            $("input[name='state_id']").val('');
            $("#state_id").select2({
                placeholder: '--select--'
            });
        }

    });
}

function readCountryInfoByCountry(country, state)
{
    var functionType = 'readCountryInfoByCountry';
    var token        = $("input[name=token]").val();

    $.ajax({
        url: '/course_admin/ajax_get_region.php',
        dataType: "json",
        type: "POST",
        data: {            
            ptToken : token,
            function: functionType,
            country : country,
            state   : state
        },
        success: function (data)
        {
            $("#country_id").html(data.output);
            $("#state_id").html(data.output_states);
            $("#region_id").html(data.output_region);
        }
    });
}

$(document).on('click', '#add-certification-btn', function() {
    addCertifications();
});

$(document).on('click', '#add-regulation-btn', function() {
    addRegulation();
});

$(document).on('click', '#add-qualification-btn', function() {
    addQualifications();
});

function addQualifications()
{
    var action   = "create_qualification";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    var name     = $("#qualification-name-txt").val();

    $('#update-source-academy-div').removeClass("alert-danger");
    $('#update-source-academy-div').removeClass("alert-success");

    if ((name == '') || (name == null))
    {
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Error : Qualification name not found!");
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url: '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action  : action,
                academy : academy,
                ptToken : token,
                name    : name
            },
            success: function(data)
            {
                cmsLoadingStatus = false;
                if (data.output > 0)
                {
                    $('#update-source-academy-div').addClass("alert-success");
                    $('#update-source-academy-div').html("Qualification successfully added.");

                    $("#qualification-name-txt").val("");
                    // reload_qualifications_table();
                   location.reload(); 
                }
                else if (data.output == "user_access_issue")
                {
                    $('#update-source-academy-div').addClass("alert-danger");
                    $('#update-source-academy-div').html("You do not have access to create new Qualification. Please contact your academy administrator to request access.");
                }   
                else
                {
                    $('#update-source-academy-div').addClass("alert-danger");
                    $('#update-source-academy-div').html("Error : Qualification could not be added.");
                }               
                $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
            }
        });
    }
}

function addRegulation()
{
    var action   = "create_regulation";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    var name     = $("#regulation-name-txt").val();

    $('#update-source-academy-div').removeClass("alert-danger");
    $('#update-source-academy-div').removeClass("alert-success");

    if ((name == '') || (name == null))
    {
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Error : Regulation name not found!");
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url: '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action  : action,
                academy : academy,
                ptToken : token,
                name    : name
            },
            success: function(data)
            {
                cmsLoadingStatus = false;
                if (data.output > 0)
                {
                    $('#update-source-academy-div').addClass("alert-success");
                    $('#update-source-academy-div').html("Regulation successfully added.");

                    $("#regulation-name-txt").val("");
                    reload_regulations_table();
                }
                else if (data.output == "user_access_issue")
                {
                    $('#update-source-academy-div').addClass("alert-danger");
                    $('#update-source-academy-div').html("You do not have access to create new regulation. Please contact your academy administrator to request access.");
                }   
                else
                {
                    $('#update-source-academy-div').addClass("alert-danger");
                    $('#update-source-academy-div').html("Error : Regulation could not be added.");
                }               
                $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
            }
        });
    }
}

function reload_regulations_table()
{
    var data_url = "../cms/ajax_cms.php?action=read_regulations_tbl&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    tbl_certifications = 
    $("#tbl_regulations").DataTable({
        destroy: true,
        "ajax": data_url,
        "stateSave": true,
        "pageLength": 10, 
        "responsive": true,
        "rowReorder": true,
        "columnDefs": [
            { className: "reorder", "targets": [ 0 ] },            
            { targets: 0, visible: false },
            { targets: 1, visible: false },
            { "width": "110px", "targets": 4 , 'orderable': false },
            { 'targets': [2,3], 'orderable': false }            
        ],
        "initComplete" : function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }
    });

    $.ajax({
        url: data_url,
        dataType: "JSON", 
        success: function(data) {

            console.log(data.data);
        }
    });
}

function reload_knowledge_tests_table()
{
    var data_url = "../cms/ajax_cms.php?action=read_knowledge_tests_tbl&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    tbl_knowledge_tests = 
    $("#tbl_knowledge_tests").DataTable({
        destroy: true,
        "ajax": data_url,
        "stateSave": true,
        "pageLength": 10, 
        "responsive": true,
        "rowReorder": true,
        "columnDefs": [               
            { targets: 0, visible: false },
            { targets: 1, visible: false }           
        ],
        "initComplete" : function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
            cmsLoadingStatus = false;
        }
    });

    $.ajax({
        url: data_url,
        dataType: "JSON", 
        success: function(data) {

            //console.log(data.data);
        }
    });

    setTimeout(function(){
        $('#edit-knowledge-test-modal').modal('hide');
    }, 1500);
    
}

function reload_assessment_question_bank_table()
{
    var data_url = "../cms/ajax_cms.php?action=read_assessment_question_bank_tbl&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    tbl_assessment_question_bank = 
    $("#tbl_ab_question_bank").DataTable({
        "destroy": true,
        "ajax": data_url,
        "pageLength": 10, 
        "responsive": true,
        "order": [[0, 'desc']],
        /*"columnDefs": [                        
            { targets: 0, visible: false },
            { targets: 1, visible: false }               
        ],*/
        "initComplete" : function(){
            cmsLoadingStatus = false;
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }  
    });
}

function addCertifications()
{
    var action   = "create_certification";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    var name     = $("#certification-name-txt").val();

    $('#update-source-academy-div').removeClass("alert-danger");
    $('#update-source-academy-div').removeClass("alert-success");

    if ((name == '') || (name == null))
    {
        $('#update-source-academy-div').addClass("alert-danger");
        $('#update-source-academy-div').html("Error : Certificate name not found!");
        $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url: '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action  : action,
                academy : academy,
                ptToken : token,
                name    : name
            },
            success: function(data)
            {
                cmsLoadingStatus = false;
                if (data.output > 0)
                {
                    $('#update-source-academy-div').addClass("alert-success");
                    $('#update-source-academy-div').html("Certificate successfully added.");

                    $("#certification-name-txt").val("");
                    reload_Certifications_table();
                }
                else if (data.output == "user_access_issue")
                {
                    $('#update-source-academy-div').addClass("alert-danger");
                    $('#update-source-academy-div').html("You do not have access to create new pathways. Please contact your academy administrator to request access.");
                }   
                else
                {
                    $('#update-source-academy-div').addClass("alert-danger");
                    $('#update-source-academy-div').html("Error : Certificate is not added.");
                }               
                $("#update-source-academy-div").fadeIn(300).delay(1500).fadeOut(400);
            }
        });
    }
}
var certificationList = [];
function reload_Certifications_table()
{
    var data_url = "../cms/ajax_cms.php?action=read_certifications_tbl&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    tbl_certifications = 
    $("#tbl_certifications").DataTable({
        destroy: true,
        "ajax": data_url,
        "stateSave": true,
        "pageLength": 10, 
        "responsive": true,
        "rowReorder": true,
        "columnDefs": [
            { className: "reorder", "targets": [ 0 ] },            
            { targets: 0, visible: false },
            { targets: 1, visible: false },
            { "width": "110px", "targets": 6 , 'orderable': false },
            { 'targets': [2,3,4,5], 'orderable': false }            
        ],
        "initComplete" : function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }
    });

    $.ajax({
        url: data_url,
        dataType: "JSON", 
        success: function(data) {

            console.log(data.data);
        }
    });
}

$(document).on('click', '.edit-certification', function() 
{
    var certificationId = $(this).attr("data-content-id");
    editCertificationModal(certificationId);    
});

$(document).on('click', '.edit-regulation', function() 
{
    var regulationId = $(this).attr("data-content-id");
    editRegulationModal(regulationId);    
});

function editRegulationModal(regulationId)
{
    $('#edit-regulation-modal').remove();
    var academy = $('input[name="academy"]').val();

    if (academy == 112) {
    
       var output = 
            '<div id="edit-regulation-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">'+
             '<div class="modal-dialog modal-lg" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">Regulation Settings</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="name">Name</label>'+
                                '<input type="text" class="form-control" id="name-regulation"/>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="row">'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="onlineCourses">Associated Qualification</label>'+
                                '<select style="width:100%" class="form-control select2-course-regulation" name="qualification" id="qualification"></select>'+
                            '</div>'+
                        '</div>'+

                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="f2fCourses">Renewal Prequisite</label>'+
                                '<select style="width:100%" class="form-control select2-course-regulation" name="prerequisite" id="prerequisite"></select>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div id="advanced-req-select"></div>'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="description">Description</label>'+
                                '<textarea type="text" class="form-control" rows="3" id="description-regulation"></textarea>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                     '<div style="display:none;" class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="image">Regulation Image <em>[Ideal Dimension - width:810px;height:400px] (Can use tinypng.com for compression)</em></label>'+
                                '<img class="itf-logo-images" style="width:50%" id="regulation_image_url" src=""/>' +
                                '<input type="file" style="display:inline-block;vertical-align:middle" class="upload-file-btn" name="regulation_image" id="regulation_image">'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                     '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="description">Renewal Requirements</label>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                     '<div class="row">'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="onlineCourses">Online Courses</label>'+
                                '<select style="width:100%" class="form-control select2-course-regulation" name="online_courses_list[]" id="online_courses_list" multiple="multiple"></select>'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="documentType">Type</label>'+
                                '<select style="width:100%" class="form-control select2-course-regulation" name="document_upload" id="type_upload">'+
                                       '<option value="0">Please select type</option>'+
                                      '<option value="upload_document">Document Upload</option>'+
                                '</select>'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="name">Name</label>'+
                                '<input type="text" class="form-control" id="name_document_upload"/>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="row">'+
                        '<div class="col-sm-2">'+
                            '<div class="form-group mt-4">'+
                                '<label class="switch is-fee-required pt-2"><input type="checkbox" id="is_fee_required"><div class="slider round"></div></label>'+
                            '</div>'+
                        '</div>'+
                         '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="fee-required">Fee Required</label>'+
                                '<input type="number" id="fee_required" class="form-control" name="fee-required" disabled>'+
                              '</div>'+
                        '</div>'+
                        '<div class="col-sm-2">'+
                            '<div class="form-group mt-4">'+
                                '<label class="switch is-cpd-required pt-2"><input type="checkbox" id="is_cpd_required"><div class="slider round"></div></label>'+
                            '</div>'+
                        '</div>'+
                         '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="fee-required">CPD Credits Required</label>'+
                                '<input type="number" id="cpd_required" class="form-control" name="cpd-required" disabled>'+
                              '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="row">'+
                        '<div class="col-sm-10">'+
                            '<div class="form-group">'+
                                '<label class="switch is-cpd-upload mt-3"><input type="checkbox" id="is_cpd_upload"><div class="slider round"></div></label>'+
                                '<label for="cpd-upload-required">Allow CPD Credits through upload of evidence.</label>'+
                            '</div>'+   
                        '</div>'+                      
                    '</div>'+  
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="description">Description for end user</label>'+
                                '<textarea type="text" class="form-control" rows="3" id="description_end_user_cpd" disabled></textarea>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="alert alert-regulation" role="alert" id="alert-course-regulation"></div>'+
                    '<hr>'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                               '<h5>Renewal Status Rules</h5>'+
                        '</div>'+
                    '</div>'+
                      '<div class="row">'+
                        '<div class="col-sm-12">'+
                                '<h5>Not Current Status Rules</h5>'+
                        '</div>'+
                        '<div class="col-md-6">'+
                                '<label for="not-current">If the user is current - renewal commences on</label>'+
                                 '<select style="width:100%" class="form-control select2-course-regulation" name="renewal-commences" id="notcurrent_renewal_start">'+
                                      '<option value="date_of_certificate">On date of Certificate</option>'+
                                      '<option value="expiry_date">On date of Certificate Expiry</option>'+
                                      '<option value="1_year_after">One year after Certificate Expiry</option>'+
                                      '<option value="2_years_after">Two years after Certificate Expiry</option>'+
                                      '<option value="3_years_after">Three years after Certificate Expiry</option>'+
                                      '<option value="4_years_after">Four years after Certificate Expiry</option>'+
                                      '<option value="5_years_after">Five years after Certificate Expiry</option>'+
                                      '<option value="6_years_after">Six years after Certificate Expiry</option>'+
                                '</select></div>'+
                                 '<div class="col-md-6">'+
                                '<label for="not-current">Renewal Period Finishes</label>'+
                                 '<select style="width:100%" class="form-control select2-course-regulation" name="finish-commences" id="notcurrent_renewal_finish">'+
                                      '<option value="date_of_certificate">On date of Certificate</option>'+
                                      '<option value="expiry_date">On date of Certificate Expiry</option>'+
                                      '<option value="1_year_after">One year after Certificate Expiry</option>'+
                                      '<option value="2_years_after">Two years after Certificate Expiry</option>'+
                                      '<option value="3_years_after">Three years after Certificate Expiry</option>'+
                                      '<option value="4_years_after">Four years after Certificate Expiry</option>'+
                                      '<option value="5_years_after">Five years after Certificate Expiry</option>'+
                                      '<option value="6_years_after">Six years after Certificate Expiry</option>'+
                                '</select></div>'+
                                '<div class="col-md-6">'+
                                '<label for="not-current">If the user is not current for more than </label>'+
                                 '<select style="width:100%" class="form-control select2-course-regulation" name="renewal-commences" id="notcurrent_period_not_current">'+
                                       '<option value="6">6 Months</option>'+
                                      '<option value="12">12 Months</option>'+
                                      '<option value="24">24 Months</option>'+
                                '</select></div>'+
                                 '<div class="col-md-6">'+
                                '<label for="not-current">Additional Percentage Fee will be charged</label>'+
                                '<input type="number" id="notcurrent_fee_charged" class="form-control"/>'+
                    '</div>'+
                        '<div class="col-sm-12 mt-4">'+
                                '<h5>Expired Status Rules</h5>'+
                        '</div>'+
                        '<div class="col-md-6">'+
                                '<label for="not-current">If the user is not current for</label>'+
                                 '<select style="width:100%" class="form-control select2-course-regulation" name="renewal-commences" id="expired_period_not_current">'+
                                      '<option value="0">Please Select</option>'+
                                       '<option value="36">36 Months</option>'+
                                       '<option value="24">24 Months</option>'+
                                      '<option value="12">12 Months</option>'+
                        '</select></div>'+
                    '</div>'+
                    '<div class="row">'+
                        '<div class="col-sm-4">'+
                            '<label for="is-published">Publish Regulation</label>'+
                            '<label class="switch is-published mt-3"><input type="checkbox" id="is_published"><div class="slider round"></div></label>'+
                    '</div></div>'+ 
                '</div>'+
                '<div class="modal-footer">'+
                        '<div class="col-sm-12">'+
                            '<button type="button" class="btn btn-secondary mr-3" data-dismiss="modal">Close</button>'+
                            '<input type="hidden" id="regulation-id" value="'+regulationId+'">'+
                            '<button id="update-regulation-btn" type="button" class="btn btn-primary">Save</button>'+
                        '</div>'+                       
                    '</div>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';
    }
    else {

         var output = 
    '<div id="edit-regulation-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-lg" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">Edit Regulation</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="name">Name</label>'+
                                '<input type="text" class="form-control" id="name-regulation"/>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="row">'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="onlineCourses">Online Courses</label>'+
                                '<select style="width:100%" class="form-control select2-course-regulation" name="online_courses_list[]" id="online_courses_list" multiple="multiple"></select>'+
                            '</div>'+
                        '</div>'+

                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="f2fCourses">Face to Face Courses</label>'+
                                '<select style="width:100%" class="form-control select2-course-regulation" name="f2f_courses_list[]" id="f2f_courses_list" multiple="multiple"></select>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                        '<div class="col-sm-3">'+
                            '<label for="is-published">Publish Regulation</label>'+
                            '<label class="switch is-published"><input type="checkbox" id="is_published"><div class="slider round"></div></label>'+
                        '</div>'+                        
                    '</div>'+  
                    '<div id="advanced-req-select"></div>'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="description">Description</label>'+
                                '<textarea type="text" class="form-control" rows="5" id="description-regulation"></textarea>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div style="display:none;" class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="image">Regulation Image <em>[Ideal Dimension - width:810px;height:400px] (Can use tinypng.com for compression)</em></label>'+
                                '<img class="itf-logo-images" style="width:50%" id="regulation_image_url" src=""/>' +
                                '<input type="file" style="display:inline-block;vertical-align:middle" class="upload-file-btn" name="regulation_image" id="regulation_image">'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<input type="hidden" id="regulation-id" value="'+regulationId+'">'+
                            '<button id="update-regulation-btn" type="button" class="btn btn-primary">Save</button>'+
                        '</div>'+                       
                    '</div>'+

                    '<div class="alert alert-regulation" role="alert" id="alert-course-regulation"></div>'+

                    '<hr>'+

                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<h5>Courses assigned to this Regulation</h5>'+
                            '<div class="role-users-wrapper">'+
                            '</div>'+                 
                        '</div>'+
                    '</div>'+

                '</div>'+
                '<div class="modal-footer">'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    }
   

    $('body').append(output);
    $('#edit-regulation-modal').modal('show');

    loadRegulationFormData(regulationId);
}

$(document).on("click", ".duplicate-knowledge-test", function () {
    const testId = $(this).data("content-id");

    if (!confirm("Are you sure you want to duplicate this test? Note: Questions from the original test that are active and have not been archived will be assigned to this test")) {
        return;
    }

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: "../cms/ajax_course_builder.php",
        method: "POST",
        data: {
            action: "duplicate_knowledge_test",
            test_id: testId,
            ptToken: $("input[name=token]").val()
        },
        success: function (response) {
            cmsLoadingStatus = false;
            let data = JSON.parse(response);
            if (data.output) {
                alert("Test duplicated successfully");
            }
            else if (data.errorMessage)
            {
                alert(data.errorMessage);
            }    

            reload_knowledge_tests_table();       
        },
        error: function () {
            cmsLoadingStatus = false;
            alert("Error duplicating test");
        }
    });
});

$(document).on("click", ".preview-knowledge-test", function () {
    const testId = $(this).data("content-id");

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: "../cms/ajax_course_builder.php",
        method: "POST",
        data: {
            action: "get_knowledge_test_preview",
            test_id: testId,
            ptToken: $("input[name=token]").val()
        },
        success: function (response) {
            cmsLoadingStatus = false;

            try {
                let data = JSON.parse(response);
                if (data.errorMessage) {
                    alert(data.errorMessage);
                    return;
                }

                showKnowledgeTestPreviewModal(data.instructions_html, data.questions_html, data.default_instructions_html, data.title, data.duration);
            } catch (e) {
                alert("Error parsing preview content");
            }
        },
        error: function () {
            cmsLoadingStatus = false;
            alert("Error fetching test preview.");
        }
    });
});

function showKnowledgeTestPreviewModal(instructionsHtml, questionsHtml, defaultInstructionsHtml, title, duration) {
    // Remove any existing modal
    $("#preview-knowledge-test-modal").remove();

    const modalHtml = `
    <div id="preview-knowledge-test-modal" class="knowledge-test-container modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">${title}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!-- Instructions Block (same layout as actual test) -->
                    <div class="card bg-light border-info mb-4 p-3">
                        <div class="card-body">
                            <h5 class="card-title text-info">Test Instructions</h5>
                            <div class="card-text">${instructionsHtml}</div>

                            <h5 class="card-title text-info mt-3">General Instructions</h5>
                            <div class="card-text">Please read the instructions for each question carefully as they require either:</div>
                            <div class="card-text">${defaultInstructionsHtml}</div>

                            <h5 class="card-title text-info mt-3">Duration</h5>
                            <div class="card-text">                                
                                <p class="fw-bold">This test has a time limit of <u>${duration} minutes</u>.</p>
                                <p> The timing will commence when you click the <b>Start Test</b> button. Once the test commences, you will be presented with a countdown timer. </p>
                            </div>
                        </div>
                    </div>


                    <!-- Questions Block -->
                    <h5 class="text-dark">Questions</h5>
                    <div>${questionsHtml}</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        <i class="fas fa-times"></i> Close Preview
                    </button>
                </div>
            </div>
        </div>
    </div>`;

    $("body").append(modalHtml);
    $("#preview-knowledge-test-modal").modal("show");
}



$(document).on('click', '.edit-knowledge-test', function() 
{
    var knowledgeTestId = $(this).attr("data-content-id");
    editKnowledgeTestModal(knowledgeTestId);   
});

$(document).on('click', '.edit-knowledge-test-questions', function() 
{
    var knowledgeTestId = $(this).attr("data-content-id");
    editAssessmentsQuestionModal(null, knowledgeTestId);   
});

function editKnowledgeTestModal(knowledgeTestId)
{
    var rolesMultiSelect = '';
    var academyId = "";
    academyId = getParameterByName('academy');

    if (academyId == 103)
    {                     
        rolesMultiSelect = '<div class="col-sm-6">'+
                                '<div class="form-group" id="knowledge-test-roles">'+
                                    '<label for="test_themes">Roles</label>'+
                                    '<select style="width:100%" class="roles_select" name="roles-knowledge-test-input[]" id="roles-knowledge-test-input" multiple="multiple"></select>'+
                                '</div>'+
                            '</div>';
    }

    $('#edit-knowledge-test-modal').remove();
    var output = 
    '<div id="edit-knowledge-test-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-lg" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">Edit Test</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="name">Name</label>'+
                                '<input type="text" class="form-control" placeholder="Enter Test Name" id="name-knowledge-test"/>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="description">Instructions</label>'+
                                '<textarea type="text" class="form-control" rows="3" placeholder="Enter Test Instructions" id="description-knowledge-test"></textarea>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group" id="knowledge-test-tags">'+
                                '<label for="test_tags">Tags</label><br/>'+
                                '<span class="pl-2" data-toggle="tooltip" data-placement="top" title="Type and press Enter key to add new tags or select existing tags from the dropdown">' +
                                    '<i class="fas fa-info-circle"></i>' +
                                '</span>' +
                                '<select name="tags-knowledge-test-input[]" id="tags-knowledge-test-input" class="tags_select" multiple="multiple">'+
                                '</select>'+
                            '</div>'+
                        '</div>'+

                        rolesMultiSelect +


                    '</div>'+

                    '<div class="row">'+  

                        '<div class="col-sm-2">'+
                            '<label for="is-published">Question Limit</label>'+                           
                            '<input type="number" class="form-control" value="20" min="1" id="question-limit-knowledge-test"/>'+
                        '</div>'+ 

                    '</div>'+                  

                    '<div class="row mt-4">'+

                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="name">Pass Mark %</label>'+
                                '<input type="number" class="form-control" value="80" min="1" max="100" id="pass-mark-percentage"/>'+
                            '</div>'+
                        '</div>'+ 

                        '<div class="col-sm-4">'+
                            '<label for="test-time-limit">Test Time Limit (Minutes)</label>'+
                            '<input type="number" class="form-control" value="60" min="1" id="test-time-limit"/>'+
                        '</div>'+ 

                        '<div class="col-sm-4">' +
                            '<label for="is-anonymous">Anonymous Grading</label>' +
                            '<span class="pl-2">' +
                                '<i class="fas fa-info-circle" data-toggle="tooltip" title="When enabled, participant names will be hidden during grading and shown as User 001, User 002, etc."></i>' +
                            '</span><br/>' +
                            '<label class="switch is-published">' +
                                '<input type="checkbox" id="is-anonymous">' +
                                '<div class="slider round"></div>' +
                            '</label>' +
                        '</div>' +


                    '</div>'+                                   
                    
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<input type="hidden" id="knowledge-test-id" value="'+knowledgeTestId+'">'+     
                                              
                        '</div>'+                       
                    '</div>'+

                    '<div class="alert alert-knowledge-test mt-3 mb-3" role="alert" id="alert-knowledge-test"></div>'+

                '</div>'+
                '<div class="modal-footer">'+                    
                    '<button id="update-knowledge-test-btn" type="button" class="btn btn-primary mr-3 pl-3 pr-3 btn-success">Save</button>'+     
                    '<button type="button" class="btn btn-secondary mr-3" data-dismiss="modal">Close</button>'+
                    
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#edit-knowledge-test-modal').modal('show');

    loadKnowledgeTestFormData(knowledgeTestId);

    $(".tags_select").select2({ theme: 'bootstrap-5', placeholder: '-- Please Select --'}); 
    $(".roles_select").select2({ theme: 'bootstrap-5', placeholder: '-- Please Select --'}); 
}


$(document).on('click', '.edit-assessment-question', function() 
{
    var questionId = $(this).attr("data-content-id");
    editAssessmentsQuestionModal(questionId, false);   
});

function editAssessmentsQuestionModal(questionId, knowledgeTestId=false) {
    $('#save-assessment-question-btn').off();
    $('#edit-assessment-question-modal').remove();
    $('#video-modal').remove();

    var academyId = "";
    academyId = getParameterByName('academy');
    var themesDiv = '';

    if (academyId == 103)
    {
        themesDiv = '<div class="col-sm-4">' +
                            '<label for="question-themes">Themes</label>' +
                            '<select id="question-themes" class="form-control">' +
                                '<option value="coach">Coach</option>' +
                                '<option value="teacher">Teacher</option>' +
                            '</select>' +
                        '</div>' +
                        '<div class="col-sm-4" id="question-sub-themes-wrapper">' +
                            '<label for="question-sub-themes">Sub-Themes</label>' +
                            '<select style="width:100%" class="form-control select2-sub-themes" name="question-sub-themes[]" id="question-sub-themes" multiple></select>'+
                        '</div>';
    }            
    var title = "Create Question";

    if (knowledgeTestId)
    {
        title = "Select Questions";
    }

    var output = 
    '<div id="edit-assessment-question-modal" class="modal fade bd-example-modal-xl" data-backdrop="static" tabindex="-1" role="dialog">' +
        '<div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">' +
            '<div class="modal-content">' +
                '<div class="modal-header">' +
                    '<h5 class="modal-title">'+ title +'</h5>' +
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                      '<span aria-hidden="true">&times;</span>' +
                    '</button>' +
                '</div>' +
                '<div class="modal-body">';

                    if (knowledgeTestId)
                    {
                        output +=
                        // Add tabs
                        '<ul class="nav nav-tabs" id="questionTabs" role="tablist">' +
                            '<li class="nav-item">' +
                                '<a class="nav-link active" id="create-question-tab" data-toggle="tab" href="#create-question" role="tab" aria-controls="create-question" aria-selected="true">Create Question</a>' +
                            '</li>' +
                            '<li class="nav-item">' +
                                '<a class="nav-link" id="question-bank-tab" data-toggle="tab" href="#question-bank" role="tab" aria-controls="question-bank" aria-selected="false">Select from Question Bank</a>' +
                            '</li>' +
                        '</ul>' +

                        // Tab content
                        '<div class="tab-content" id="questionTabContent">' +
                        
                        // Create Question Tab
                        '<div class="tab-pane fade show active" id="create-question" role="tabpanel" aria-labelledby="create-question-tab">';
                    }

                    output +=
                    
                        '<div class="row mt-3">' +
                            '<div class="col-sm-6">' +
                                '<label for="question-type">Type</label>' +
                                '<select id="question-type" class="form-control">' +
                                    '<option value="multi-choice">Multi-Choice</option>' +
                                    '<option value="long-answer">Long Answer</option>' +
                                '</select>' +
                            '</div>' +
                            '<div class="col-sm-6">' +
                                '<label for="question-language">Language</label>' +
                                '<select onchange="loadAssessmentQuestionFormData('+questionId+');" id="question-language" class="form-control">' +
                                    '<option value="en">English</option>' +
                                    '<option value="es">Spanish</option>' +
                                    '<option value="fr">French</option>' +
                                '</select>' +
                            '</div>' +
                        '</div>' +

                        '<div class="row mt-3">' +
                            '<div class="col-sm-12">' +
                                '<label for="question-name">Question Text</label>' +
                                '<div class="d-flex align-items-center w-100">' +
                                    '<div class="flex-grow-1 mr-2">' +
                                        '<input type="text" id="question-txt" class="form-control summernote w-100" placeholder="Enter question here" />' +
                                    '</div>' +                               
                                    '<button class="btn btn-outline-secondary ms-2 mr-2" onclick="document.getElementById(\'image_question\').click();">' +
                                        '<i class="fas fa-image"></i>' +
                                    '</button>' +
                                    '<input type="file" class="upload-file-btn" name="image_question" id="image_question" style="display: none;" />' +
                                    '<button class="btn btn-outline-secondary ms-1" data-toggle="modal" data-target="#video-modal">' +
                                        '<i class="fas fa-video"></i>' +
                                    '</button>' +
                                '</div>' + 

                                '<div id="question-image-wrapper" style="width:50%;" class="mr-1 d-block">' +      
                                    '<div id="question-image">' +                                   
                                    '</div>' +                             
                                '</div>' +


                            '</div>' +
                        '</div>' + 
                       
                       '<div class="row mt-3">' +
                            '<div class="col-sm-12">' +
                                '<label for="question-instruction">Question Instruction</label>' +
                                '<span class="pl-2">' +
                                    '<i class="fas fa-info-circle" data-toggle="tooltip" title="This instruction is a subtext that appears below the main question."></i>' +
                                '</span>' +
                                '<input type="text" id="question-instruction" class="form-control summernote" placeholder="Enter instructions" />' +
                            '</div>' +
                        '</div>' +


                        '<div id="long-answer-options-wrapper">' +
                            '<div class="row mt-3 mb-3">' +

                                '<div class="col-sm-4">' +
                                    '<label for="long-answer-word-min">Word Minimum</label>' +
                                    '<input type="number" id="long-answer-word-min" class="form-control" placeholder="10" />' +
                                '</div>' +

                                '<div class="col-sm-4">' +
                                    '<label for="long-answer-word-limit">Word Limit</label>' +
                                    '<input type="number" id="long-answer-word-limit" class="form-control" placeholder="700" />' +
                                '</div>' +  
                            '</div>' +  

                            '<div id="model-answer-toggle-wrapper" class="row mt-4">' +
                                '<div class="col-sm-6 d-flex align-items-center">' +
                                    '<label for="model-answer-toggle" class="mr-2">Include Model Answer</label>' +
                                    '<label class="switch is-published d-flex align-items-center"><input type="checkbox" id="model-answer-toggle"><div class="slider round"></div></label>' +
                                '</div>' +
                            '</div>' +

                            '<div id="longform-model-answer-wrapper" class="row mt-3 d-none">' +
                                '<div class="col-sm-12">' +
                                    '<label for="longform-model-answer">Model Answer</label>' +
                                    '<textarea id="longform-model-answer" class="form-control" rows="3" placeholder="Model Answer"></textarea>' +
                                '</div>' +                       
                            '</div>' +

                        '</div>' +

                        '<div id="multi-choice-options-wrapper">' +

                            '<div class="row mt-3">' +

                                '<div class="col-sm-4">' +
                                    '<label for="has-no-correct-answers">Has no correct answers?</label><br/>' +
                                    '<label class="switch has-no-correct-answers"><input type="checkbox" id="has-no-correct-answers"><div class="slider round"></div></label>' +
                                '</div>' +

                                '<div class="col-sm-12">' +
                                    '<label id="select-correct-label">Select at least one correct answer</label>' +
                                    '<div id="answers-container">' +
                                        '<div class="d-flex align-items-center answer-wrapper mb-2">' + 
                                            '<div class="input-group-text mr-2"><input type="checkbox" name="correct-answer"></div>' + 
                                            '<div class="flex-grow-1 mr-2">' + 
                                                '<input type="text" id="answer-txt-a" class="form-control summernote" placeholder="Type an answer" />' + 
                                            '</div>' + 
                                            '<div class="d-flex align-items-center">' + 
                                                /*'<button class="btn btn-outline-secondary mr-1">' + 
                                                    '<i class="fas fa-image"></i>' + 
                                                '</button>' + */
                                                '<button class="btn btn-outline-secondary remove-answer">' + 
                                                    '<i class="fas fa-trash"></i>' + 
                                                '</button>' + 
                                            '</div>' + 
                                        '</div>' + 

                                        '<div class="d-flex align-items-center answer-wrapper mb-2">' + 
                                            '<div class="input-group-text mr-2"><input type="checkbox" name="correct-answer"></div>' + 
                                            '<div class="flex-grow-1 mr-2">' + 
                                                '<input type="text" id="answer-txt-b" class="form-control summernote" placeholder="Type an answer" />' + 
                                            '</div>' + 
                                            '<div class="d-flex align-items-center">' + 
                                               /* '<button class="btn btn-outline-secondary mr-1">' + 
                                                    '<i class="fas fa-image"></i>' + 
                                                '</button>' + */
                                                '<button class="btn btn-outline-secondary remove-answer">' + 
                                                    '<i class="fas fa-trash"></i>' + 
                                                '</button>' + 
                                            '</div>' + 
                                        '</div>' + 


                                    '</div>' +
                                    '<button id="add-answer" class="btn btn-primary btn-sm">+ Answer</button>' +
                                '</div>' +
                            '</div>' +

                            '<div class="row mt-3">' +
                                '<div class="col-sm-12 d-flex align-items-center">' +
                                    '<label for="feedback-toggle" class="mr-2">Show Question Feedback to Participants</label>' +
                                    '<label class="switch is-published d-flex align-items-center"><input type="checkbox" id="feedback-toggle"><div class="slider round"></div></label>' +
                                '</div>' +
                            '</div>' +

                            '<div id="feedback-section" class="row mt-3 d-none">' +
                                '<div class="col-sm-6">' +
                                    '<label for="correct-answer-comments">Correct Answer Comments</label>' +
                                    '<textarea id="correct-answer-comments" class="form-control" rows="2" placeholder="Comments for correct answers"></textarea>' +
                                '</div>' +
                                '<div class="col-sm-6">' +
                                    '<label for="incorrect-answer-comments">Incorrect Answer Comments</label>' +
                                    '<textarea id="incorrect-answer-comments" class="form-control" rows="2" placeholder="Comments for incorrect answers"></textarea>' +
                                '</div>' +
                            '</div>' +

                        '</div>' + 

                        '<div class="row mt-3">' +
                            '<div class="col-sm-4" id="question-tags-wrapper">' +
                                '<label for="tags-question-input">Tags</label>' +
                                '<span class="pl-2" data-toggle="tooltip" data-placement="top" title="Type and press Enter key to add new tags or select existing tags from the dropdown">' +
                                    '<i class="fas fa-info-circle"></i>' +
                                '</span>' +
                                '<select style="width:100%;" name="tags-question-input[]" id="tags-question-input" class="tags-question-input" multiple="multiple">' +
                                '</select>' +
                            '</div>' +
                            themesDiv +
                        '</div>' +



                        '<div class="row mt-3">' +
                            '<div class="col-sm-4 d-none">' +
                                '<label for="pin-question">Pin Question (Always on Test)</label><br/>' +
                                '<label class="switch is-published"><input type="checkbox" id="pin-question"><div class="slider round"></div></label>' +
                            '</div>' +

                            '<div class="col-sm-4">' +
                                '<label for="question-marks">Marks</label>' +
                                '<input type="number" id="question-marks" class="form-control" value="1" min="1" step="1" />' +
                            '</div>' +
                            '<div class="col-sm-4">' +
                                '<label for="question-difficulty">Difficulty</label>' +
                                '<select id="question-difficulty" class="form-control">' +
                                    '<option value="1">1 (Easy)</option>' +
                                    '<option value="2">2</option>' +
                                    '<option value="3">3</option>' +
                                    '<option value="4">4</option>' +
                                    '<option value="5">5 (Hard)</option>' +
                                '</select>' +
                            '</div>' +
                        '</div>' +

                        '<div class="alert alert-success d-none"><span id="save-question-success-msg"></span></div>' + 
                        '<div class="alert alert-danger d-none"><span id="save-question-error-msg"></span></div>';

                    if (knowledgeTestId)
                    {   
                        let hideThemesFilterStr = ' d-none ';
                        if (academyId == 103)
                        {
                            hideThemesFilterStr = '';
                        }

                        loadKnowledgeTestFormData(knowledgeTestId, false);
                        
                        output += 
                        '</div>' +

                        // Select from Question Bank Tab
                        '<div class="tab-pane fade" id="question-bank" role="tabpanel" aria-labelledby="question-bank-tab">' +
                            '<div class="mt-3">' +

                                '<div class="row mt-3 mb-3">';

                                    output += `
                                        <div class="col-sm-12 mb-1">
                                            <label class="mt-2"><b>Question Selection Mode</b></label>
                                            <div class="row">
                                                <!-- Specific Questions Option -->
                                                <div class="col-md-6">
                                                    <div class="border rounded p-3 bg-light h-100">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="radio" name="question-selection-mode" id="select-specific-questions"
                                                                onchange="handleQuestionSelectionChange()" value="specific" checked>
                                                            <label class="form-check-label font-weight-bold" for="select-specific-questions">
                                                                Select Specific Questions
                                                            </label>
                                                        </div>
                                                        <small class="text-muted d-block mt-2">
                                                            Select this mode if you want this test to have specific selected questions only.
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- Randomised Questions Option -->
                                                <div class="col-md-6 mt-3 mt-md-0">
                                                    <div class="border rounded p-3 bg-light h-100">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="radio" name="question-selection-mode" id="randomise-all-questions"
                                                                onchange="handleQuestionSelectionChange()" value="random">
                                                            <label class="form-check-label font-weight-bold" for="randomise-all-questions">
                                                                Select Randomised Questions
                                                            </label>
                                                        </div>
                                                        <small class="text-muted d-block mt-2">
                                                            Select this mode if you want to automatically generate this test based on set rules. You can choose to pin specific questions to always appear on the test too.
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Question Bank Note -->
                                            <div class="border rounded p-3 bg-light h-20 mt-2">
                                                <strong>Note</strong>: To create new questions, go to the Question Bank tab in the previous screen or click 
                                                <a href="#ab-question-bank-wrapper" onClick="navigateToQuestionBank();"><u>here</u></a>.
                                            </div>
                                        </div>`;


                                    output +=  '<hr/><div class="col-sm-12 mt-4 border-top question-filter-item">' +
                                                    '<label class="mt-2"><b>Filter Questions</b></label>'+
                                                '</div>'+
                                                '<div class="' + hideThemesFilterStr + ' col-sm-4 question-filter-item">' +
                                                    '<label for="question-themes-qb">Themes</label>' +
                                                    '<select id="question-themes-qb" class="form-control">' +
                                                        '<option value="coach">Coach</option>' +
                                                        '<option value="teacher">Teacher</option>' +
                                                    '</select>' +
                                                '</div>' +
                                                '<div class="' + hideThemesFilterStr + ' col-sm-4 question-filter-item" id="question-sub-themes-wrapper-qb">' +
                                                    '<label for="question-sub-themes-qb">Sub-Themes</label>' +
                                                    '<select style="width:100%" class="form-control select2-sub-themes" name="question-sub-themes-qb[]" id="question-sub-themes-qb" multiple></select>'+
                                                '</div>';

                                    output += '<div class="col-sm-4 question-filter-item">' +
                                                  '<label for="question-tags-qb">Tags</label>' +
                                                  '<select id="question-tags-qb" class="form-control select2-tags-qb" multiple>' +
                                                  '</select>' +
                                              '</div>';                                     

                                    output +=  
                                                '<div class="col-12 mt-3 question-filter-item">' +
                                                    '<button id="filter-question-bank-btn" type="button" onClick="filterQuestionBank();" class="btn btn-success">Filter</button>' + 
                                                '</div>' + 
                                '</div>' +
                                

                                '<hr/>';


                               output += '<div id="question-rules-wrapper" class="d-none">';
                                
                               output += '<div class="col-12 mt-2 alert alert-info">' + 
                                            '<div class="row align-items-center">' +
                                                '<div class="col-auto px-2">' +
                                                    '<i class="fas fa-info-circle"></i>' +
                                                '</div>' +
                                                '<div class="col">' +
                                                    '<span>To generate a test using the Randomisation tool, set Mandatory & Additional Rules. You can also pin questions that will always appear on the test.</span>' +
                                                '</div>' +
                                            '</div>' +
                                          '</div>';


                                output += ' <div class="mandatory-rules-main-wrapper border border-secondary rounded p-2 mt-2">'+
                                                '<div class="col-sm-12 mt-2">' +
                                                    '<h5>Step 1: Mandatory Rules</h5>' +
                                                    '<p class="text-muted">Test must follow these mandatory rules:</p>' +
                                                '</div>' +

                                                '<div id="mandatory-rules-container">' + 
                                                      generateMandatoryRuleRow().prop('outerHTML') + // Generate initial mandatory rule
                                                '</div>' +

                                                '<div class="col-sm-12 mt-3">' +
                                                      '<button class="btn btn-light border" onclick="addMandatoryRuleRow()">' +
                                                          '<i class="fas fa-plus"></i> Add Mandatory Rule' +
                                                      '</button>' +
                                                '</div>' +
                                            '</div>' +

                                            ' <div class="optional-rules-main-wrapper border border-secondary rounded p-2 mt-2">'+
                                                '<div class="col-sm-12 mt-4">' +
                                                      '<h5>Step 2: Additional Rules</h5>' +
                                                      '<p class="text-muted">Additional rules help refine question selection:</p>' +
                                                '</div>' +

                                                '<div id="optional-rules-container">' + 
                                                      generateOptionalRuleRow().prop('outerHTML') + // Generate initial optional rule
                                                '</div>' +

                                                '<div class="col-sm-12 mt-3">' +
                                                      '<button class="btn btn-light border" onclick="addOptionalRuleRow()">' +
                                                          '<i class="fas fa-plus"></i> Add Additional Rule' +
                                                      '</button>' +
                                                '</div>' +
                                            '</div>';    

                                output +=   '<div class="col-sm-12 mt-3 mb-3 text-right">' +                                                  
                                                  '<button id="save-rules-btn" onClick="saveRules();" class="btn btn-primary mx-2">Save Rules</button>' + 
                                            '</div>';                                                                       
                              
                                output += ' <div class="pin-rules-main-wrapper border border-secondary rounded p-2 mt-2">'+
                                                '<div class="col-12 mt-4">' +
                                                      '<h5>Step 3: Pin Questions (Optional)</h5>' +
                                                      '<p class="text-muted">Pinned questions will always appear on the test, irrespective of the above rules</p>' +
                                                '</div>' +
                                                '<div class="col-12 p-2">' +
                                                    '<table id="tbl_ab_question_bank_filtered_randomisation" class="table table-bordered">' + 
                                                        '<thead>' +
                                                            '<th class="span2">Id</th>' +
                                                            '<th class="span2">Question</th> ' +
                                                            '<th class="span2">Marks</th>' +
                                                            '<th class="span2">Difficulty</th>' +      
                                                            '<th class="span2">Tags</th>' +                                                
                                                            '<th class="span2">Type</th>' + 
                                                            '<th class="span2">Pinned Question</th>' +                                                            
                                                            '<th class="span2">Actions</th> ' +             
                                                        '</thead>' +
                                                    '</table>' + 
                                                '</div>'+                                   
                                            '</div>';

                                output +=   '<div class="col-sm-12 mt-4 px-0">' +
                                                  '<div id="rule-message" class="alert d-none"></div>' +
                                            '</div>';

                                output +=   '<div class="col-sm-12 mt-3 text-right">' +                                                   
                                                    '<button id="generate-random-test-btn" onClick="generateSampleTestWithRules();" class="btn btn-primary mx-2">Generate Test</button>' +
                                                    '<button type="button" class="d-none btn btn-danger" id="unpublish-test">Un-publish Test</button>' + 
                                            '</div>';


                                output += '</div>'; //End of question-rules-wrapper



                                output += 

                                '<div class="row mt-4 mb-3 mt-4" id="assign-questions-wrapper">'+
                                    '<div class="col-sm-12 assign-items">' +
                                        '<label class="mt-2"><b>Assign Questions</b></label>'+
                                    '</div>'+
                                    '<div class="col-12 assign-items">' +
                                            '<div class="alert alert-info d-flex justify-content-between align-items-center">'+
                                                '<span>Total questions assigned to this test: <b><span id="selected-q">0</span>/<span id="total-q">20</span></span></b>' +
                                                '<button id="publish-assessment-test-btn" type="button" onClick="publishAssessmentTestFromSpecificQuestionsArea();" class="btn btn-success">Publish Test</button>' +
                                                '<button id="unpublish-assessment-test-btn" type="button" onClick="unPublishAssessmentTest();" class="btn btn-danger d-none">Un-Publish Test</button>' + 
                                            '</div>'+                                                                                        
                                    '</div>' +

                                    '<!-- <div class="col-6 d-none assign-items" id="pinned-q-wrapper">' + 
                                        '<div class="alert alert-info d-flex justify-content-between align-items-center">'+
                                            '<span>Total pinned questions: <b><span id="pinned-q">0</span></b></span>' + 
                                            '<a data-toggle="tooltip" title="Since you have assigned more questions than the test question limit, you can pin some questions to this test that will always appear on the test and randomise the remaining questions.">' + 
                                                '<i class="fas fa-info-circle"></i>'+
                                            '</a>' +
                                        '</div>' +  
                                    '</div> -->' +                                     

                                '</div>' +

                                '<div class="row mt-3 mb-3">'+
                                    '<div class="col-12">' +
                                        '<table id="tbl_ab_question_bank_filtered" class="table table-bordered">' + 
                                            '<thead>' +
                                                '<th class="span2">Id</th>' +
                                                '<th class="span2">Question</th> ' +
                                                '<th class="span2">Marks</th>' +
                                                '<th class="span2">Difficulty</th>' +   
                                                '<th class="span2">Tags</th>' +                                                
                                                '<th class="span2">Type</th>' +                                                
                                                '<th class="span2">Actions</th> ' +             
                                            '</thead>' +
                                        '</table>' + 
                                    '</div>'+                                   
                                '</div>'+

                            '</div>' +
                        '</div>';
                    }

                output +=
                '</div>' +
                '<div class="modal-footer">';

                if (questionId)
                {
                    output += '<input type="hidden" id="current-question-id" value="'+ questionId+'" />';
                }

                if (knowledgeTestId)
                {
                    output += '<input type="hidden" id="current-kt-id" value="'+ knowledgeTestId +'" />';
                    output += '<button id="save-assessment-question-btn" type="button" onClick="saveAssessmentQuestion();" class="btn btn-success">Create and Add to Test</button>';
                }
                else
                {
                    output += '<button id="save-assessment-question-btn" type="button" onClick="saveAssessmentQuestion();" class="btn btn-success">Save</button>';
                }
                
                output +=
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>' + 


    '<div id="video-modal" class="modal fade" tabindex="-1" data-backdrop="static" role="dialog">' +
        '<div class="modal-dialog modal-md" role="document">' +
            '<div class="modal-content">' +
                '<div class="modal-header">' +
                    '<h4 class="modal-title">Add Video to Question</h4>' +
                    '<button type="button" class="close" data-dismiss="modal" onclick="refocusMainModal()">&times;</button>' +
                '</div>' +
                '<div id="modal-body-main-video" class="modal-body">' +
                    '<div class="row pb-4">' +
                        '<div class="col-md-4">' +
                            '<label>Video Type</label>' +
                            '<select name="media_type" id="select-video-type" class="form-control" required>' +
                                '<option value="youtube">YouTube</option>' +
                                '<option value="vimeo">Vimeo</option>' +
                            '</select>' +
                        '</div>' +
                    '</div>' +
                    '<label>Paste Your Embed Code Below</label>' +
                    '<textarea class="form-control" id="video-url-question" name="video-url-question" rows="5"></textarea>' +
                    '<div class="alert alert-danger" role="alert" id="error-label" style="display:none"></div>' +
                '</div>' +
                '<div class="modal-footer">' +
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal" onclick="refocusMainModal()">Close</button>' +
                    '<button type="button" class="btn btn-primary" data-dismiss="modal" id="create-question-video-btn">Save</button>' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>';

    $('body').append(output);

    if (knowledgeTestId) {
        // Hide the first tab and activate the second tab
        $('#create-question-tab').closest('li').hide(); // Hide the tab header
        $('#create-question').remove(); // Remove the tab content
        $('#question-bank-tab').tab('show'); // Activate second tab

        // Manually trigger associated logic
        $("#save-assessment-question-btn").hide();
        loadAcademyThemesDropdownQb(questionId);
    }



    $('#edit-assessment-question-modal').modal('show');

    setTimeout(function() {
        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover'
        });
    }, 200);

    $(".tags-question-input").select2({ theme: 'bootstrap-5', placeholder: '-- Please Select --'}); 

    if (knowledgeTestId)
    {
        $("#question-tags-qb").select2({ theme: 'bootstrap-5', placeholder: '-- Select Tags --' });
        loadAcademyTagsForRandomisation("question-tags-qb");
    }    

    loadAcademyThemesDropdown(questionId);

    if (questionId)
    {
        loadAssessmentQuestionFormData(questionId);
    }
    else
    {
        loadAcademyTagsForQuestion("tags-question-input");
    }

    function refocusMainModal() {
        setTimeout(function() {
            $('body').addClass('modal-open');  // Ensure modal-open class is reapplied
            $('#edit-assessment-question-modal').focus();  // Refocus on main modal
        }, 300);
    }

    // Initial Counter for Unique IDs
    let answerCounter = 3;
    const maxAnswers = 7;
    const minAnswers = 2;

    // Function to Generate Unique ID (a, b, c...)
    function generateUniqueId() {
        return 'answer-txt-' + String.fromCharCode(96 + answerCounter);
    }

    // Add Answer on Button Click
    $('#add-answer').on('click', function() {
        if ($('.answer-wrapper').length >= maxAnswers) {
            alert('You cannot add more than 7 answers.');
            return;
        }

        var propDisabled = "";
        if ($('#has-no-correct-answers').is(':checked')) {
            propDisabled = " disabled ";
        }

        let uniqueId = generateUniqueId();
        
        $('#answers-container').append(
            '<div class="d-flex align-items-center answer-wrapper mb-2">' + 
                '<div class="input-group-text mr-2">' +
                    '<input type="checkbox" ' + propDisabled + ' name="correct-answer">' + 
                '</div>' + 
                '<div class="flex-grow-1 mr-2">' + 
                    '<input type="text" id="' + uniqueId + '" class="form-control summernote" placeholder="Type an answer" />' + 
                '</div>' + 
                '<div class="d-flex align-items-center">' + 
                    /*'<button class="btn btn-outline-secondary mr-1">' + 
                        '<i class="fas fa-image"></i>' + 
                    '</button>' +*/ 
                    '<button class="btn btn-outline-secondary remove-answer">' + 
                        '<i class="fas fa-trash"></i>' + 
                    '</button>' + 
                '</div>' + 
            '</div>'
        );

        $("#" + uniqueId).summernote(summnerNoteQuestionBuilderOptions);
        
        answerCounter++;
    });

    // Remove Answer on Trash Click
    $(document).on('click', '.remove-answer', function() {
        if ($('.answer-wrapper').length <= minAnswers) {
            alert('At least two answers are required.');
            return;
        }
        $(this).closest('.answer-wrapper').remove();
    });

    $('#feedback-toggle').on('change', function() {
        if ($(this).is(':checked')) {
            $('#feedback-section').slideUp().removeClass('d-none');
        } else {
            $('#feedback-section').slideDown().addClass('d-none');
        }
    });

    $('#model-answer-toggle').on('change', function() {
        if ($(this).is(':checked')) {
            $('#longform-model-answer-wrapper').slideUp().removeClass('d-none');
        } else {
            $('#longform-model-answer-wrapper').slideDown().addClass('d-none');
        }
    });

    $('#has-no-correct-answers').on('change', function() {
        if ($(this).is(':checked')) {
            $('#select-correct-label').addClass('d-none');
            $('input[name=correct-answer]').each(function(){
                $(this).prop('disabled', true);
                $(this).prop('checked', false);
            });
        } else {
            $('#select-correct-label').removeClass('d-none');
            $('input[name=correct-answer]').each(function(){
                $(this).prop('disabled', false);
                $(this).prop('checked', false);
            })
        }
    });

    $("#question-type").on('change', function(){
        var type = $("#question-type option:selected").val();
        if (type == "long-answer")
        {
            $("#multi-choice-options-wrapper").hide();
            $("#long-answer-options-wrapper").show();
        }
        else
        {
            $("#multi-choice-options-wrapper").show();
            $("#long-answer-options-wrapper").hide();
        }
    });

    var summnerNoteQuestionBuilderOptions = {
        dialogsInBody: true,
        //,airMode: true
        codemirror: { // codemirror options
            theme: 'monokai'
        },
        toolbar: [
            // [groupName, [list of button]]
            ['style', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
            ['insert', ['link', 'unlink']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['code', ['codeview']]
        ],
        callbacks: {
          // Clear all formatting of the pasted text
          onPaste: function (e) {
            var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
            e.preventDefault();
            setTimeout( function(){
              document.execCommand( 'insertText', false, bufferText );
            }, 10 );
          }
        }
    }

    $('.summernote').each(function(){
        $(this).summernote(summnerNoteQuestionBuilderOptions);
    }); 

    // Image Selection Logic
    $('#image_question').on('change', function (event) {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = function (e) {
                // Replace the content inside #question-image div
                $('#question-image-wrapper').html(
                    `<img id="question-image" src="${e.target.result}" 
                          style="max-height: 200px; display: block; margin-top: 10px;" />`
                );
            };
            reader.readAsDataURL(file);

            // Clear video-related inputs
            $("#select-video-type").val("");
            $("#video-url-question").val("");
        }
    });

    // Video Embed Code Logic
    $('#create-question-video-btn').on('click', function () {
        const videoEmbedCode = $('#video-url-question').val().trim();
        if (videoEmbedCode) {
                        
            $('#question-image-wrapper').html(videoEmbedCode);
            $('#video-modal').modal('hide');
            $('#image_question').val("");
        }
    });

    if (!questionId)
    {
        $("#question-type").trigger('change');
    }

    $('#questionTabs a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
        // Get the current tab's ID
        const targetTabId = $(e.target).attr("id");
        if (targetTabId == "question-bank-tab")
        {
            $("#save-assessment-question-btn").hide();
            loadAcademyThemesDropdownQb(questionId);
        }
        else
        {
            $("#save-assessment-question-btn").show();
        }
    });

    $('#question-marks').on('blur', function () {
        let val = parseFloat($(this).val());
        if (!Number.isInteger(val)) {
            alert('Only whole numbers are allowed.');
            $(this).val(1); // or reset to previous valid value
        }
    });
}

function navigateToQuestionBank()
{
    $('#edit-assessment-question-modal').modal('hide'); // Close the modal

    setTimeout(function () {
        $('.nav-tabs .nav-link:eq(1)').trigger('click'); // Trigger 2nd tab (0-indexed)
    }, 500);
}

var totalMandatoryRules = 1;
function generateMandatoryRuleRow(selectedTheme = null, selectedSubTheme = null, selectedTags = null) {
    let id       = "rule-theme-" + totalMandatoryRules;
    let subId    = "rule-subtheme-" + totalMandatoryRules;
    let tagsId   = "rule-tags-" + totalMandatoryRules;
    let academyId = $('input[name="academy"]').val();

    // Default: only percentage label
    let rowHtml = '<div class="col-sm-12 d-flex align-items-center mb-2 rule-row">' +
                    '<span>Test must have</span>' +
                    '<input type="number" class="form-control d-inline-block rule-percentage mx-2" style="width: 70px;" value="100" min="1" max="100">%';

    // Add Theme/Subtheme/Tags only for academy 103
    if (academyId === "103") {
        let subthemeDropdown = 
            '<span>& Subtheme&nbsp;</span>' +
            '<select id="' + subId + '" class="form-control d-inline-block rule-subtheme" style="width: 150px;">' +
                generateOptions('Subtheme') +
            '</select>';

        rowHtml += '<span class="font-weight-bold mx-2">Theme</span>' +
                    '<select id="' + id + '" class="form-control d-inline-block rule-value rule-theme mx-2" style="width: 150px;">' +
                        generateOptions('Theme') +
                    '</select>' +

                    '<div class="subtheme-container d-inline-block mx-2">' + subthemeDropdown + '</div>';

        rowHtml +=      '<span class="mx-2">& Tags</span>' +
                        '<select id="' + tagsId + '" class="form-control d-inline-block rule-tags mx-2" style="width: 160px;" multiple>' +
                            generateOptions("Tags") +
                        '</select>';

    }
    else
    {
        rowHtml +=  '<span class="mx-2">from Tags</span>' +
                    '<select id="' + tagsId + '" class="form-control d-inline-block rule-tags mx-2" style="width: 160px;" multiple>' +
                        generateOptions("Tags") +
                    '</select>';
    }   

    rowHtml += '<button class="btn btn-light text-danger border remove-rule-btn mx-2">' +
               '<i class="fas fa-trash"></i>' +
               '</button>' +
               '</div>';

    let row = $(rowHtml);

    // Load dropdown data only if academyId is 103
    if (academyId === "103") {
        loadAcademyThemesForRandomisation(id, subId, selectedTheme, selectedSubTheme);        
    }

    loadAcademyTagsForRandomisation(tagsId, selectedTags);

    totalMandatoryRules++;
    return row;
}

function generateOptionalRuleRow() {
    let row = $('<div class="col-sm-12 d-flex align-items-center mb-2 optional-rule-row">' +
                    '<span>Test must have at least</span>' +
                    '<input type="number" class="form-control d-inline-block rule-percentage mx-2" style="width: 70px;" value="10" min="1" max="100">% from ' +

                    '<select class="form-control d-inline-block rule-optional-category mx-2" style="width: 150px;" onchange="updateOptionalRuleOptions(this)">' +
                        '<option value="Difficulty">Difficulty</option>' +
                        '<option value="Type">Question Type</option>' +
                    '</select>' +

                    '<select class="form-control d-inline-block rule-optional-value mx-2" style="width: 150px;">' +
                        generateOptions('Difficulty') + 
                    '</select>' +

                    '<button class="btn btn-light text-danger border remove-optional-rule-btn mx-2">' +
                        '<i class="fas fa-trash"></i>' +
                    '</button>' +
                '</div>');

    return row;
}



function addMandatoryRuleRow() {
    let newRow = generateMandatoryRuleRow();
    $("#mandatory-rules-container").append(newRow);

    let tagsDropdown = newRow.find(".rule-tags");
    tagsDropdown.select2({
        placeholder: "Please select...",
        theme: "bootstrap-5",
    });
}

function addOptionalRuleRow() {
    let newRow = generateOptionalRuleRow();
    $("#optional-rules-container").append(newRow);
}

$(document).on("click", ".remove-rule-btn", function() {
    $(this).closest(".rule-row").remove();
    totalMandatoryRules--;
});

$(document).on("click", ".remove-optional-rule-btn", function() {
    $(this).closest(".optional-rule-row").remove();
});

function updateOptionalRuleOptions(selectElement) {
    let selectedCategory = $(selectElement).val();
    let ruleRow = $(selectElement).closest(".optional-rule-row");
    let valueDropdown = ruleRow.find(".rule-optional-value");

    valueDropdown.html(generateOptions(selectedCategory));
}

function generateOptions(category) {
    let options = {
        "Theme": [
            
        ],
        "Subtheme": [
           
        ],
        "Tags": [
           
        ],
        "Difficulty": [
            { value: '1', text: '1 (Easy)' },
            { value: '2', text: '2' },
            { value: '3', text: '3' },
            { value: '4', text: '4' },
            { value: '5', text: '5 (Hard)' }
        ],
        "Type": [
            { value: 'multichoice', text: 'Multi-Choice' },
            { value: 'longform', text: 'Long Answer' }
        ]
    };

    return options[category].map(option => `<option value="${option.value}">${option.text}</option>`).join('');
}


function handleQuestionSelectionChange() {
    let selectedValue = document.querySelector('input[name="question-selection-mode"]:checked').value;
    
    if (selectedValue == 'random')
    {
        $(".question-filter-item").each(function(){
            $(this).slideUp();
        });  

        $("#tbl_ab_question_bank_filtered_wrapper").hide(); 
        $("#tbl_ab_question_bank_filtered_randomisation_wrapper").show();
        $("#question-rules-wrapper").removeClass('d-none'); 
        $("#assign-questions-wrapper").hide();   

        $("#mandatory-rules-container .rule-tags").select2({
            placeholder: "Please select...",
            theme: "bootstrap-5",
        });
        
        filterQuestionBankRandomisation();
        readAndPopulateRandomisationRules();
    }
    else
    {
        $(".question-filter-item").each(function(){
            $(this).slideDown();
        });

        $("#tbl_ab_question_bank_filtered_wrapper").show(); 
        $("#tbl_ab_question_bank_filtered_randomisation_wrapper").hide();
        $("#question-rules-wrapper").addClass('d-none');
        $("#assign-questions-wrapper").show();  

        filterQuestionBank();
    }
}

function saveRules() {
    $("#rule-message").addClass('d-none');

    let formData = new FormData();
    let mandatoryTotal = 0;

    let testId = $("#current-kt-id").val(); 
    formData.append("action", "save_knowledge_test_question_rules");
    formData.append("ktId", testId);
    var ptToken       = $("input[name=token]").val();
    formData.append('ptToken', ptToken);
    var themeSubthemeErr = false;
    let academyId = $('input[name="academy"]').val();

    // **Read Mandatory Rules**
    $(".rule-row").each(function(index) {
        let percentage = parseInt($(this).find(".rule-percentage").val(), 10);
        let theme = $(this).find(".rule-value").val();
        let subtheme = $(this).find(".rule-subtheme").val();
        let tags = $(this).find(".rule-tags").val() || [];

        if (academyId == 103)
        {
            if (theme == null || subtheme == null) {
                themeSubthemeErr = true;
                return;
            }
        }

        mandatoryTotal += percentage;

        formData.append(`mandatory[${index}][percentage]`, percentage);
        formData.append(`mandatory[${index}][theme]`, theme);
        formData.append(`mandatory[${index}][subtheme]`, subtheme);
        formData.append(`mandatory[${index}][tags]`, tags.join(", ")); // Convert array to comma-separated string
    });

    
    if (academyId == 103)
    {
        if (themeSubthemeErr) {
            displayRulesMessage("danger", "Error: Theme/Subtheme are required fields.");
            return;
        }  
    }  

    // **Check if Mandatory Rules Sum to 100%**
    if (mandatoryTotal !== 100) {
        displayRulesMessage("danger", "Error: Mandatory rule percentages must add up to 100%.");
        return;
    }

    // **Read Optional Rules**
    $(".optional-rule-row").each(function(index) {
        let percentage = parseInt($(this).find(".rule-percentage").val(), 10);
        let category = $(this).find(".rule-optional-category").val();
        let value = $(this).find(".rule-optional-value").val();

        formData.append(`optional[${index}][percentage]`, percentage);
        formData.append(`optional[${index}][category]`, category);
        formData.append(`optional[${index}][value]`, value);
    });

    console.log("Saving Rules:", formData);

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,  // Important for FormData
        cache: false,
        processData: false,  // Prevent jQuery from processing data
        data: formData,
        success: function(response) { 
            if (response.errorMessage)
            {
                displayRulesMessage("danger", response.errorMessage);
            }
            else
            {
                displayRulesMessage("success", "Rules saved successfully!");
            }
        },
        error: function(xhr, status, error) {
            displayRulesMessage("danger", "Error saving rules: " + error);
        }
    });
}


function displayRulesMessage(type, message) { 
    let ruleMessage = $("#rule-message");

    ruleMessage.removeClass('alert-danger alert-info alert-success d-none');
    ruleMessage.addClass("alert-" + type);
    ruleMessage.html(message);

    let modalBody = ruleMessage.closest('.modal-body');

    if (modalBody.length) {
        modalBody.animate({
            scrollTop: ruleMessage.offset().top - modalBody.offset().top + modalBody.scrollTop()
        }, 600);
    } 

    if (type == 'success')
    {
        setTimeout(() => {
            ruleMessage.addClass('d-none');
        }, 5000);
    }    
}

function readAndPopulateRandomisationRules() {
    let testId = $("#current-kt-id").val();  
    let ptToken = $("input[name=token]").val();  
    let formData = new FormData();
    
    formData.append("action", "read_knowledge_test_question_rules");
    formData.append("ktId", testId);
    formData.append("ptToken", ptToken);

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(response) {
            if (response.success && response.rules) {
                populateRulesUI(response.rules);
            } else {
                console.log("No rules found or error fetching rules.");
            }
        },
        error: function(xhr, status, error) {
            console.log("Error fetching rules: " + error);
        }
    });
}

function generateSampleTestWithRules() {
    $("#rule-message").addClass('d-none');
    let testId = $("#current-kt-id").val();
    let ptToken = $("input[name=token]").val();
    let formData = new FormData();

    formData.append("action", "generate_test_with_rules");
    formData.append("ktId", testId);
    formData.append("ptToken", ptToken);

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data) {
            if (data.success && data.testQuestions) {
                displayGeneratedTest(data.testQuestions, testId);
            } else if (data.errorMessage) {
                displayRulesMessage("danger", data.errorMessage);
            }

            cmsLoadingStatus = false;
        },
        error: function(xhr, status, error) {
            console.log("Error fetching test: " + error);
            cmsLoadingStatus = false;
        }
    });
}

function displayGeneratedTest(questions, testId) { 
    let testContent = '';

    questions.forEach((question, index) => {
        let mediaContent = '';

        if (question.image_url) {
            mediaContent = `<img src="${question.image_url}" class="img-fluid mb-3" alt="Question Image">`;
        } else if (question.video_type === "youtube" || question.video_type === "vimeo") {
            mediaContent = `<div class="embed-responsive embed-responsive-16by9 mb-3">
                                ${question.video_src}
                            </div>`;
        }

        let metadata = `
            <div class="d-flex flex-wrap gap-2 mb-2">
                <small class="alert alert-info p-1 px-2 mx-1">Difficulty: ${question.difficulty}</small>
                <small class="alert alert-info p-1 px-2 mx-1">Marks: ${question.marks}</small>`;
                if (question.theme_desc != "")
                {
                    metadata += `<small class="alert alert-info p-1 px-2 mx-1">Theme: ${question.theme_desc}</small>`;
                }

                if (question.subtheme_desc != "")
                {
                    metadata += `<small class="alert alert-info p-1 px-2 mx-1">Subtheme: ${question.subtheme_desc}</small>`;
                }                
                
                 metadata += `
                <small class="alert alert-info p-1 px-2 mx-1">Tags: ${question.tag_desc}</small>
                <small class="alert alert-info p-1 px-2 mx-1">Pinned: ${question.is_pinned == 1 ? 'Yes' : 'No'}</small>
            </div>`;

        let answerContent = '';
        if (question.class === 'longform') {
            answerContent = `<div class="mt-3">
                                <label><strong>Answer:</strong></label>
                                <textarea class="form-control"></textarea>
                            </div>`;
        } else {
            answerContent = `<ul class="list-group mt-3">
                ${Object.keys(question.answers).map(answerId => {
                    let answerText = question.answers[answerId];
                    if (!answerText) return '';
                    let inputType = question.correct_answers.length > 1 ? 'checkbox' : 'radio';
                    return `
                    <li class="list-group-item d-flex align-items-center gap-2">
                        <input type="${inputType}" name="answer-${index}" value="${answerId}">
                        <label class="mb-0 ml-2">${answerText}</label>
                    </li>`;
                }).join('')}
            </ul>`;
        }

        testContent += `
        <div class="test-question mb-4 border border-secondary p-4 rounded">
            ${mediaContent}
            <h5 class="mt-2 mb-2 d-flex"><span>${index + 1}.&nbsp; </span> ${question.question}</h5>
            ${metadata}
            ${answerContent}
        </div>`;
    });

    let modalHtml = `
    <div class="modal fade" id="test-modal" tabindex="-1" aria-labelledby="testModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="testModalLabel">Generated Test Preview</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body">
                    ${testContent}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" id="publish-test" data-test-id="${testId}">Publish Test</button>
                    <button type="button" class="btn btn-secondary" id="close-test-modal">Close</button>
                </div>
            </div>
        </div>
    </div>`;

    $('body').append(modalHtml);
    $('#test-modal').modal('show');

    $(document).on('click', '#close-test-modal', function () {
        $('#test-modal').modal('hide');
    });

    $('#test-modal').on('hidden.bs.modal', function () {
        $(this).remove();
    });

    // Publish test button click event
    $(document).off('click', '#publish-test').on('click', '#publish-test', function () {
        let testId = $(this).data('test-id');
        let action = 'publish_assessment_test';
        let questionIds = questions.map(q => q.id); // Extract question IDs
        let ptToken       = $("input[name=token]").val();

        if (!confirm("Are you sure you want to publish this test? This will make the test available to be added to courses/intakes. You can keep editing the test until it has submissions.")) {
            return;
        }

        let formData = new FormData();
        formData.append('action', action);
        formData.append('test_id', testId);        
        formData.append('ptToken', ptToken);

        questionIds.forEach((id, index) => {
            formData.append(`question_ids[]`, id); 
        });

        $.ajax({
            url: '../cms/ajax_course_builder.php',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                response = JSON.parse(response);
                if (response.errorMessage)
                {
                    alert(response.errorMessage);
                    return false;
                }
                else
                {
                    alert("Test published successfully!");
                    $('#test-modal').modal('hide');
                    reload_knowledge_tests_table();
                    $('#edit-assessment-question-modal').modal('hide');    
                }
                
            },
            error: function (xhr, status, error) {
                alert("Failed to publish test. Please try again.");
            }
        });
    });

    $(document).off('click', '#unpublish-test').on('click', '#unpublish-test', function () {
        unPublishAssessmentTest();
    });
}

function publishAssessmentTestFromSpecificQuestionsArea() {
    let testId  = $("#current-kt-id").val();
    let action  = 'publish_assessment_test';    
    let ptToken = $("input[name=token]").val();

    if (!confirm("Are you sure you want to publish this test? This will make the test available to be added to courses/intakes. You can keep editing the test until it has submissions.")) 
    {
        return;
    }

    let formData = new FormData();
    formData.append('action', action);
    formData.append('test_id', testId);        
    formData.append('ptToken', ptToken);

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
            response = JSON.parse(response);

            if (response.errorMessage)
            {
                alert(response.errorMessage);
                return false;
            }

            alert("Test published successfully!");  
            reload_knowledge_tests_table();   
            $('#edit-assessment-question-modal').modal('hide');          
        },
        error: function (xhr, status, error) {
            alert("Failed to publish test. Please try again.");
        }
    });
}

function unPublishAssessmentTest() {
    let testId  = $("#current-kt-id").val();
    let action  = 'unpublish_assessment_test';    
    let ptToken = $("input[name=token]").val();

    if (!confirm("Are you sure you want to un-publish this test? This will make the test un-available to be added to courses/intakes.")) 
    {
        return;
    }

    let formData = new FormData();
    formData.append('action', action);
    formData.append('test_id', testId);        
    formData.append('ptToken', ptToken);

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
            response = JSON.parse(response);                
            if (response.errorMessage)
            {
                alert(response.errorMessage);
                return;
            }
            else
            {

                alert("Test un-published successfully!");  
                reload_knowledge_tests_table();  
                $('#edit-assessment-question-modal').modal('hide');       
            }
        },
        error: function (xhr, status, error) {
            alert("Failed to un-publish test. Please try again.");
        }
    });
}


function populateRulesUI(rules) {
    cmsLoadingStatus = true;
    loadOverlay();

    $("#mandatory-rules-container").empty();
    $("#optional-rules-container").empty();
    
    let mandatoryRuleCount = 0;
    
    rules.forEach((rule) => {
        if (rule.rule_type === "mandatory") {
            var thisTags = rule.tags ? rule.tags.split(", ") : null;
            let row = generateMandatoryRuleRow(rule.theme, rule.subtheme, thisTags);
            row.find(".rule-percentage").val(rule.percentage);
            row.find(".rule-theme").val(rule.theme);
            row.find(".rule-subtheme").val(rule.subtheme);
            
            if (rule.tags) {
                row.find(".rule-tags").val(thisTags).trigger("change");  
            }

            $("#mandatory-rules-container").append(row);
            mandatoryRuleCount++;
        } else if (rule.rule_type === "optional") {
            let row = generateOptionalRuleRow();
            row.find(".rule-percentage").val(rule.percentage);
            row.find(".rule-optional-category").val(rule.category).trigger("change");

            let valueDropdown = row.find(".rule-optional-value");
            valueDropdown.html(generateOptions(rule.category));
            valueDropdown.val(rule.value);

            $("#optional-rules-container").append(row);
        }
    });

    totalMandatoryRules = mandatoryRuleCount;    
    setTimeout(function(){
       cmsLoadingStatus = false; 
    }, 2000)
}

function filterQuestionBank()
{
    var selectedTags = $('#question-tags-qb').val(); // Gets selected tags as array
    var tagsParam = selectedTags ? selectedTags.join(',') : ''; // Convert to comma-separated string

    var ajaxUrl = "../cms/ajax_course_builder.php?action=filter_question_bank_questions" +
                  "&ktid=" + $("#current-kt-id").val() +
                  "&ptToken=" + $("input[name=token]").val() +
                  "&academy=" + $("input[name=academy]").val() +
                  "&theme=" + $('#question-themes-qb').val() +
                  "&sub_theme=" + $('#question-sub-themes-qb').val() +
                  "&tags=" + encodeURIComponent(tagsParam);

    cmsLoadingStatus = true;
    loadOverlay();
    
    tbl_assessment_question_bank_filtered = $("#tbl_ab_question_bank_filtered").DataTable({
        "destroy": true,
        "ajax": ajaxUrl,
        "pageLength": 50,
        "responsive": true,
        "order": [[0, 'desc']],
        "initComplete" : function(){
            cmsLoadingStatus = false;
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }
    });
}


function filterQuestionBankRandomisation()
{
    var formData = new FormData();
    let action = "filter_question_bank_questions";

    cmsLoadingStatus = true;
    loadOverlay();
    tbl_assessment_question_bank_filtered_randomisation = 
    $("#tbl_ab_question_bank_filtered_randomisation").DataTable({
        "destroy": true,
        "ajax": "../cms/ajax_course_builder.php?action=filter_question_bank_questions&random=1&ktid="+$("#current-kt-id").val()+"&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val()+"&theme="+$('#question-themes-qb').val()+"&sub_theme="+$('#question-sub-themes-qb').val(),
        "pageLength": 5, 
        "responsive": true,
        "order": [[0, 'desc']],
        /*"columnDefs": [                        
            { targets: 0, visible: false },
            { targets: 1, visible: false }               
        ],*/
        "initComplete" : function(){
            cmsLoadingStatus = false;
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }  
    });
}

function deleteAssessmentQuestion(questionId)
{
    var action = "delete_question_by_question_id";
    var token = $("input[name=token]").val();
    var academy = $("input[name=academy]").val();

    var confirmation = confirm("Are you sure you want to delete this question?");
    if (!confirmation)
    {
        return false;
    }

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        dataType: "json",
        data: {
            action      : action,
            ptToken     : token,
            academy     : academy,
            questionId  : questionId,
        },
        success: function(data) {
            console.log(data)
            if (data.errorMessage)
            {

            }
            else
            {
                alert("Question successfully deleted");
                reload_assessment_question_bank_table();
            }            
        }
    });
}

function archiveAssessmentQuestion(questionId)
{
    var action = "archive_question_by_question_id";
    var token = $("input[name=token]").val();
    var academy = $("input[name=academy]").val();

    var confirmation = confirm("Are you sure you want to archive this question?");
    if (!confirmation)
    {
        return false;
    }

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        dataType: "json",
        data: {
            action      : action,
            ptToken     : token,
            academy     : academy,
            questionId  : questionId,
        },
        success: function(data) {
            console.log(data)
            if (data.errorMessage)
            {

            }
            else
            {
                alert("Question successfully archived");
                reload_assessment_question_bank_table();
            }            
        }
    });
}

function saveAssessmentQuestion()
{
    var errorContainer = $("#save-question-error-msg").parent();
    errorContainer.addClass('d-none'); 

    var formData = new FormData();
    let isValid = true;
    let errorMessage = "";
    let action = "create_assessment_question";

    // Collect Form Inputs
    if ($("#current-question-id").length)
    {
        let questionId = $("#current-question-id").val();
        action = 'edit_assessment_question'; 
        formData.append('questionId', questionId);           
    }

    if ($("#current-kt-id").length)
    {
       let testId = $("#current-kt-id").val();       
       formData.append('testId', testId);          
    }

    formData.append('action', action);
    formData.append('question_type', $('#question-type').val());
    formData.append('question_txt', $('#question-txt').summernote("code"));
    formData.append('question_instruction', $('#question-instruction').summernote("code"));
    formData.append('language', $('#question-language').val());
    formData.append('marks', $('#question-marks').val());
    formData.append('difficulty', $('#question-difficulty').val());
    formData.append('pin_question', $('#pin-question').is(':checked'));
    formData.append('tags', $('#tags-question-input').val());
    formData.append('theme', $('#question-themes').val());
    formData.append('sub_theme', $('#question-sub-themes').val());
    formData.append('video_type', $('#select-video-type').val());
    formData.append('video_url', $('#video-url-question').val());
    formData.append('alt_text', $('#image_alt_text').val());
    formData.append('feedback_enabled', $('#feedback-toggle').is(':checked'));
    formData.append('has_no_correct_answers', $('#has-no-correct-answers').is(':checked'));
    var ptToken       = $("input[name=token]").val();
    formData.append('ptToken', ptToken);

    // Handle Image Upload
    var files = $('#image_question')[0].files;
    if (files.length > 0) {
        formData.append('image', files[0]);
    }

    if ($('#question-type').val() == "multi-choice")
    {
        // Collect Feedback Comments
        if ($('#feedback-toggle').is(':checked')) {
            let correctFeedback = $('#correct-answer-comments').val();
            let incorrectFeedback = $('#incorrect-answer-comments').val();

            if (!correctFeedback || !incorrectFeedback) {
                errorMessage += "Feedback for both correct and incorrect answers is required.\n";
                isValid = false;
            }
            formData.append('correct_feedback', correctFeedback);
            formData.append('incorrect_feedback', incorrectFeedback);
        }

        // Collect Dynamic Answers
        let answers = [];
        $('.answer-wrapper input[type="text"]').each(function() {
            let thisId = "#" + $(this).attr('id');
            let val = $(thisId).summernote("code");
            if (val) {
                answers.push(val);
            }
        });

        // Append Answers to FormData
        answers.forEach((answer, index) => {
            formData.append('answer_' + (index + 1), answer);
        });

        // Collect Correct Answer IDs
        let correctAnswers = [];
        $("input[name='correct-answer']:checked").each(function () {
            let id = $(this).closest('.answer-wrapper').find('input[type="text"]').attr('id');
            correctAnswers.push(id.split('-').pop());
        });
        formData.append('correct_answers', correctAnswers);    

        if (answers.length < 2) {
            errorMessage += "At least two answers are required.\n";
            isValid = false;
        }

        if (!correctAnswers.length && !$('#has-no-correct-answers').is(':checked')) {
            errorMessage += "Select at least one correct answer.\n";
            isValid = false;
        }
    }
    else
    {        
        if ($('#model-answer-toggle').is(':checked')) {
            let modelAnswer = $('#longform-model-answer').val();

            if (!modelAnswer) {
                errorMessage += "Model answer is required.\n";
                isValid = false;
            }

            formData.append('model_answer', modelAnswer);
        }

        let wordLimit = parseInt($("#long-answer-word-limit").val());
        let wordMin = parseInt($("#long-answer-word-min").val());

        if (wordLimit == 0) {
            errorMessage += "Word Limit is invalid.\n";
            isValid = false;
        }
       
        if (wordMin > wordLimit) {
            errorMessage += "Minimum Words cannot be greater than Word Limit.\n";
            isValid = false;
        }

        formData.append('word_limit', wordLimit);
        formData.append('word_min', wordMin);
    }

    // Validations
    if (!$('#question-txt').summernote('code')) {
        errorMessage += "Question text is required.\n";
        isValid = false;
    }

    if (!$('#tags-question-input').val()) {
        errorMessage += "Please select at least one tag.\n";
        isValid = false;
    }

    /*if (!$('#question-themes').val()) {
        errorMessage += "Please select a theme.\n";
        isValid = false;
    }

    if (!$('#question-sub-themes').val()) {
        errorMessage += "Please select a sub-theme.\n";
        isValid = false;
    }*/

    // Video is optional, so no validation for video_url unless video_type is selected
    /*if ($('#select-video-type').val() && !$('#video-url-question').val()) {
        errorMessage += "Please paste a valid video embed code.\n";
        isValid = false;
    }*/

    // Display Errors or Submit
    if (!isValid) {
        var errorContainer = $("#save-question-error-msg").parent();
        var modalBody = $('.modal-dialog-scrollable .modal-body');

        $("#save-question-error-msg").html(errorMessage);
        errorContainer.removeClass('d-none');       
        modalBody.animate({
            scrollTop: errorContainer.offset().top - modalBody.offset().top + modalBody.scrollTop()
        }, 500);      

        return;
    }

    // Disable the button to prevent multiple submissions
    $('#save-assessment-question-btn').prop('disabled', true);
    
    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function(response) {
            alert('Question saved successfully!');
            $('#save-assessment-question-btn').prop('disabled', false);
            $('#edit-assessment-question-modal').modal('hide');
            reload_assessment_question_bank_table();
            
        },
        error: function() {
            alert('Error saving question.');
            $('#save-assessment-question-btn').prop('disabled', false);
        }
    });
}

function loadAcademyThemesDropdown(questionId)
{
    var action   = "read_assessment_question_theme";
    var token    = $("input[name=token]").val();  
    var formData = new FormData();

    formData.append('action', action);
    formData.append('ptToken', token);
    formData.append('questionId', questionId);

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {            
            if (data.output)
            {
                var themeOptions = data.output.theme_options;
                $("#question-themes").html(themeOptions);

                $("#question-themes").on('change', function(){
                    loadAcademySubThemesDropdown(questionId);
                })
            }
            else
            {
                //Do nothing
            }
        }
    });
}

function loadAcademyTagsForQuestion(elemClass)
{
    var action   = "read_academy_tags";
    var token    = $("input[name=token]").val();  
    var formData = new FormData();

    formData.append('action', action);
    formData.append('ptToken', token);    

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {            
            if (data.output)
            {                
                var tagsHtml = data.output;  
                $("." + elemClass).html(tagsHtml);
                $("." + elemClass).select2({ theme: 'bootstrap-5', placeholder: '-- Please Select --' });              
            }
            else
            {
                //Do nothing
            }
        }
    });
}

function loadAcademyTagsForRandomisation(elemId, selectedTags=null)
{
    var action   = "read_question_rules_academy_tags";
    var token    = $("input[name=token]").val();  
    var formData = new FormData();

    formData.append('action', action);
    formData.append('ptToken', token);    

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {            
            if (data.output)
            {                
                var tagsHtml = data.output;  
                $("#" + elemId).empty().html(tagsHtml);
                $("#" + elemId).select2({ theme: 'bootstrap-5', placeholder: '-- Please Select --' });

                if (selectedTags && selectedTags.length > 0) 
                {
                    $("#" + elemId).val(selectedTags).trigger("change");
                }
            }
            else
            {
                //Do nothing
            }
        }
    });
}

function loadAcademyThemesForRandomisation(elemId, elemSubId, selectedTheme=null, selectedSubTheme=null)
{
    var action   = "read_assessment_question_theme";
    var token    = $("input[name=token]").val();  
    var formData = new FormData();

    formData.append('action', action);
    formData.append('ptToken', token);    

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {            
            if (data.output)
            {
                var themeOptions = data.theme_options_arr;
                var themeOptionsHtml = data.output.theme_options;  
                $("#" + elemId).html(themeOptionsHtml);

                if (selectedTheme)
                {
                    $("#" + elemId).val(selectedTheme);
                    loadAcademySubThemesForRandomisation(elemId, elemSubId, selectedSubTheme);
                }

                $("#" + elemId).on('change', function(){
                    loadAcademySubThemesForRandomisation(elemId, elemSubId);
                });
            }
            else
            {
                //Do nothing
            }
        }
    });
}

function loadAcademySubThemesForRandomisation(elemId, elemSubId, selectedSubTheme=null)
{
    var action   = "read_assessment_question_sub_theme";
    var token    = $("input[name=token]").val();  
    var selectedTheme =  $("#"+elemId+" option:selected").val();
    var formData = new FormData();

    formData.append('action', action);
    formData.append('ptToken', token);
    formData.append('theme_id', selectedTheme);

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {            
            if (data.output)
            {
                var subThemeOptions = data.output.subThemes;
                var subThemes = $('#' + elemSubId);
                subThemes.html(subThemeOptions);

                if (selectedSubTheme)
                {
                    $('#' + elemSubId).val(selectedSubTheme);
                }
            }
            else
            {
                //Do nothing
            }
        }
    });
}

function loadAcademyThemesDropdownQb(questionId)
{
    var action   = "read_assessment_question_theme";
    var token    = $("input[name=token]").val();  
    var formData = new FormData();

    formData.append('action', action);
    formData.append('ptToken', token);
    formData.append('questionId', questionId);

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {            
            if (data.output)
            {
                var themeOptions = data.output.theme_options;
                $("#question-themes-qb").html(themeOptions);                

                $("#question-themes-qb").on('change', function(){
                    loadAcademySubThemesDropdownQb(questionId);
                });

                $("#question-themes-qb").trigger('change');

                filterQuestionBank();
            }
            else
            {
                //Do nothing
            }
        }
    });
}

function loadAcademySubThemesDropdown(questionId)
{console.log("loadAcademySubThemesDropdown")
    var action   = "read_assessment_question_sub_theme";
    var token    = $("input[name=token]").val();  
    var selectedTheme =  $("#question-themes option:selected").val();
    var formData = new FormData();

    formData.append('action', action);
    formData.append('ptToken', token);
    formData.append('questionId', questionId);
    formData.append('theme_id', selectedTheme);

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {            
            if (data.output)
            {
                var subThemeOptions = data.output.subThemes;
                var subThemes = $('#question-sub-themes');
                subThemes.html(subThemeOptions);
                subThemes.select2({
                    placeholder: 'Please select...',
                    theme: 'bootstrap-5',
                });
            }
            else
            {
                //Do nothing
            }
        }
    });
}

function loadAcademySubThemesDropdownQb(questionId)
{
    var action   = "read_assessment_question_sub_theme";
    var token    = $("input[name=token]").val();  
    var selectedTheme =  $("#question-themes-qb option:selected").val();
    var formData = new FormData();

    formData.append('action', action);
    formData.append('ptToken', token);
    formData.append('questionId', questionId);
    formData.append('theme_id', selectedTheme);

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {            
            if (data.output)
            {
                var subThemeOptions = data.output.subThemes;
                var subThemes = $('#question-sub-themes-qb');
                subThemes.html(subThemeOptions);
                subThemes.select2({
                    placeholder: 'Please select...',
                    theme: 'bootstrap-5',
                });
            }
            else
            {
                //Do nothing
            }
        }
    });
}

$(document).on('click', '.assign-assessment-question', function(){
    var questionId      = $(this).attr('data-content-id');
    var ktId            = $("#current-kt-id").val();
    var ptToken         = $("input[name=token]").val();    

    $("#spinner-" +  questionId).removeClass('d-none');

    var action   = "assign_assessment_question";  
    var formData = new FormData();
    formData.append('questionId', questionId);
    formData.append('ktId', ktId);
    formData.append('ptToken', ptToken);
    formData.append('action', action);

    assignAssessmentQuestion(formData, questionId);
});

function assignAssessmentQuestion(formData, questionId)
{
    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {  
            $("#spinner-" +  questionId).addClass('d-none');

            if (data.output)
            {
                $("#selected-q").html(data.assigned_questions_num);

                if ($("#question-bank-tab").hasClass("active"))
                {
                    filterQuestionBank();
                }
            }
            else if (data.errorMessage != "")
            {  
                alert(data.errorMessage);
            }
            else
            {
                cmsLoadingStatus = false;   
                if ($("#question-bank-tab").hasClass("active"))
                {
                    filterQuestionBank();
                }                   
                
            }

            /*if (data.assigned_questions_num >= data.max_questions)
            {
                if (data.assigned_questions_num > data.max_questions)
                {
                    $("#pinned-q-wrapper").removeClass("d-none");
                    $("#pinned-q").html(data.pinned_questions_num);
                }

                $("#publish-assessment-test-btn").removeClass("d-none");
            } 
            else
            {
                $("#pinned-q-wrapper").addClass("d-none");
                $("#publish-assessment-test-btn").addClass("d-none");
            }    */         
        }
    });
}

function updatePinStatusForAssessmentQuestion(questionId, ktId, ptToken, pinStatus)
{
    $("#spinner-" +  questionId).removeClass('d-none');

    let selectedValue = document.querySelector('input[name="question-selection-mode"]:checked').value;
    var action   = "pin_assessment_question";  
    var formData = new FormData();
    formData.append('questionId', questionId);
    formData.append('ktId', ktId);
    formData.append('ptToken', ptToken);
    formData.append('pinStatus', pinStatus);
    formData.append('action', action);

    if (selectedValue == 'random')
    {       
        formData.append('random', 1);
    }

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {  
            $("#spinner-" +  formData.questionId).addClass('d-none');

            if (data.output)
            {
                $("#selected-q").html(data.assigned_questions_num);                
                if ($("#question-bank-tab").hasClass("active"))
                {
                    if (selectedValue == 'random')
                    {
                        filterQuestionBankRandomisation();
                    }
                    else
                    {
                        filterQuestionBank();
                    }
                }
            }
            else
            {
                if ($("#question-bank-tab").hasClass("active"))
                {
                    if (selectedValue == 'random')
                    {
                        filterQuestionBankRandomisation();
                    }
                    else
                    {
                        filterQuestionBank();
                    }
                }
            } 

            if (data.assigned_questions_num > data.max_questions)
            {
                $("#pinned-q-wrapper").removeClass("d-none");
                $("#pinned-q").html(data.pinned_questions_num);
            }  
            else
            {
                $("#pinned-q-wrapper").addClass("d-none");
            }              
        }
    });
}

$(document).on('click', '.pin-test-assessment-question', function(){
    var questionId      = $(this).attr('data-content-id');
    var ktId            = $("#current-kt-id").val();
    var ptToken         = $("input[name=token]").val();    
    var pinStatus       = true;
    updatePinStatusForAssessmentQuestion(questionId, ktId, ptToken, pinStatus);
});

$(document).on('click', '.unpin-test-assessment-question', function(){
    var questionId      = $(this).attr('data-content-id');
    var ktId            = $("#current-kt-id").val();
    var ptToken         = $("input[name=token]").val();    
    var pinStatus       = false;
    updatePinStatusForAssessmentQuestion(questionId, ktId, ptToken, pinStatus);
});

$(document).on('click', '.preview-assessment-question', function(){
    var questionId = $(this).attr('data-content-id');
    var action = "read_assessment_question_info";
    var language = "en";
    var token = $("input[name=token]").val();
    var academy = $("input[name=academy]").val();

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        dataType: "json",
        data: {
            action  : action,
            ptToken : token,
            academy : academy,
            id      : questionId,
            language: language
        },
        success: function(data) {
            var question = data.output.question;
            if (question && typeof question.question !== 'undefined') {
                var questionType = data.output.type;
                var answers = question.answers;
                var correctAnswers = question.correct_answers;
                var displayAsRadio = question.display_answers_as_radio === "1";
                var mediaContent = '';
                
                // Check for image or video and add it above the question
                if (question.image_url) {
                    mediaContent = `<img src="${question.image_url}" class="img-fluid mb-3" alt="Question Image">`;
                } else if (question.video_type === "youtube" || question.video_type === "vimeo") {
                    mediaContent = `<div class="embed-responsive embed-responsive-16by9 mb-3">
                                        `+ question.video_src +`
                                    </div>`;
                }

                // Generate answer section
                var answerContent = '';
                if (questionType === 'long-answer' && question.correct_text) {
                    answerContent = `<div class="mt-3">
                                        <label><strong>Model Answer:</strong></label>
                                        <textarea class="form-control" disabled>${question.correct_text}</textarea>
                                    </div>`;
                } else {
                    answerContent = `<ul class="list-group mt-3">
                        ${Object.keys(answers).map(answerId => {
                            var answerText = answers[answerId];
                            if (!answerText) return '';
                            var isCorrect = correctAnswers.includes(answerId) ? 'list-group-item-success' : '';
                            var inputType = correctAnswers.length > 1 ? 'checkbox' : 'radio';
                            var checked = correctAnswers.includes(answerId) ? 'checked' : '';
                            return `
                            <li class="list-group-item d-flex align-items-center gap-2 ${isCorrect}">
                                <input type="${inputType}" name="answer-choice" value="${answerId}" ${checked}> 
                                <label class="mb-0 ml-2">${answerText}</label>
                            </li>`;
                        }).join('')}
                    </ul>`;
                }
                
                // Create Modal Structure
                var modalHtml = `
                <div class="modal fade" id="question-modal" tabindex="-1" aria-labelledby="questionModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="questionModalLabel">Question Preview</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            </div>
                            <div class="modal-body">
                                ${mediaContent}
                                <h5 class="mt-2 mb-2">${question.question}</h5>
                                ${answerContent}
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" id="close-question-modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>`;
                
                // Append modal to body and show it
                $('body').append(modalHtml);
                $('#question-modal').modal('show');
                
                // Ensure Close button works properly by targeting the specific modal
                $(document).on('click', '#close-question-modal', function () {
                    $('#question-modal').modal('hide');
                });
                
                $('#question-modal').on('hidden.bs.modal', function () {
                    $(this).remove();
                });
            }
        }
    });
});

$(document).on('click', '.remove-test-assessment-question', function(){
    var questionId      = $(this).attr('data-content-id');
    var ktId            = $("#current-kt-id").val();
    var ptToken         = $("input[name=token]").val();    

    $("#spinner-" +  questionId).removeClass('d-none');

    var action   = "remove_test_assessment_question";  
    var formData = new FormData();
    formData.append('questionId', questionId);
    formData.append('ktId', ktId);
    formData.append('ptToken', ptToken);
    formData.append('action', action);

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {  
            $("#spinner-" +  questionId).addClass('d-none');

            if (data.output)
            {
                $("#selected-q").html(data.assigned_questions_num);
                cmsLoadingStatus = false; 
                if ($("#question-bank-tab").hasClass("active"))
                {
                    filterQuestionBank();
                }
            }
            else if (data.errorMessage)
            {  
                alert(data.errorMessage);
            }
            else
            {
                cmsLoadingStatus = false;   
                if ($("#question-bank-tab").hasClass("active"))
                {
                    filterQuestionBank();
                }                   
                
            } 

            /*if (data.assigned_questions_num >= data.max_questions)
            {
                if (data.assigned_questions_num > data.max_questions)
                {
                    $("#pinned-q-wrapper").removeClass("d-none");
                    $("#pinned-q").html(data.pinned_questions_num);
                }
                
                $("#publish-assessment-test-btn").removeClass("d-none");
            }  
            else
            {
                $("#pinned-q-wrapper").addClass("d-none");
                $("#publish-assessment-test-btn").addClass("d-none");
            }*/              
        }
    });
});

$(document).on('click', '#update-knowledge-test-btn', function() 
{
    var name          = $("#name-knowledge-test").val();
    var timeLimit     = $("#test-time-limit").val();
    var testId        = $("#knowledge-test-id").val();
    var description   = $("#description-knowledge-test").val();
    var quesLimit     = $("#question-limit-knowledge-test").val();
    var passMark      = $("#pass-mark-percentage").val();
    var isAnonymous   = $("#is-anonymous").prop("checked") == true ? 1:0;
    var tags          = $("#tags-knowledge-test-input").val();
    var roles         = $("#roles-knowledge-test-input").val();
    var ptToken       = $("input[name=token]").val();
    
    if (testId.trim() != "")
    {
        var action    = "edit_knowledge_test_info";  
    }
    else
    {
        var action    = "add_knowledge_test";  
    }

    $('#alert-knowledge-test').removeClass("alert-danger");
    $('#alert-knowledge-test').removeClass("alert-success");

    if ((name == '') || (name == null))
    {
        $('#alert-knowledge-test').addClass("alert-danger");
        $('#alert-knowledge-test').html("Error : Test name not found!");
        $("#alert-knowledge-test").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        var formData = new FormData();
        formData.append('name', name);
        formData.append('timeLimit', timeLimit);
        formData.append('testId', testId);
        formData.append('description', description);
        formData.append('quesLimit', quesLimit);
        formData.append('passMark', passMark);       
        formData.append('isAnonymous', isAnonymous);
        formData.append('tags', tags);
        formData.append('roles', roles);
        formData.append('ptToken', ptToken);
        formData.append('action', action);

        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData,
            success: function(data)
            {
                if (data.output)
                {
                    cmsLoadingStatus = false;
                    
                    if (testId != "undefined")
                    {
                        loadKnowledgeTestFormData(testId);
                    }

                    reload_knowledge_tests_table();

                    $('#alert-knowledge-test').addClass("alert-success");
                    $('#alert-knowledge-test').html("Test successfully saved");
                    $("#alert-knowledge-test").fadeIn(300).delay(1500).fadeOut(400);
                }
                else
                {
                    cmsLoadingStatus = false;
                    
                    if (testId != "undefined")
                    {
                        loadKnowledgeTestFormData(testId);
                    }

                    reload_knowledge_tests_table();
                    $('#alert-knowledge-test').addClass("alert-danger");
                    $('#alert-knowledge-test').html("Test could not be saved");
                    $("#alert-knowledge-test").fadeIn(300).delay(1500).fadeOut(400);
                }
              
            }
        });
    }
});

function loadKnowledgeTestFormData(testId, updateTestFormDisplay=true)
{
    cmsLoadingStatus = true;
    loadOverlay();

    var action   = "read_knowledge_test_info";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();

    $.ajax({
        url: '../cms/ajax_cms.php',
        dataType: "json",
        data: {
            action  : action,
            ptToken : token,
            academy : academy,
            id      : testId
        },
        success: function(data)
        {
            $("#knowledge-test-id").val(testId);             
            var test = data.test;               

            if (updateTestFormDisplay)
            {
                if (typeof testId != 'undefined')
                {
                    $("#name-knowledge-test").val(test.name);
                    $("#test-time-limit").val(test.time_limit_minutes);
                    $("#knowledge-test-id").val(test.id);
                    $("#description-knowledge-test").val(test.instructions);
                    $("#question-limit-knowledge-test").val(test.max_question_limit);
                    $("#pass-mark-percentage").val(test.pass_mark_percentage);

                    var isAnonymous = test.is_anonymous_grading;
                    
                    if (isAnonymous == 1)
                    {
                        $("#is-anonymous").prop("checked", true);
                    }
                    else
                    {
                        $("#is-anonymous").prop("checked", false);
                    }
                }

                if (data.tags != 'undefined')
                {
                    $("#knowledge-test-tags").html(data.tags);
                    $(".tags_select").select2({ theme: 'bootstrap-5', placeholder: '-- Please Select --'}); 
                }

                if (data.roles != 'undefined')
                {
                    $("#knowledge-test-roles").html(data.roles);
                    $(".roles_select").select2({ theme: 'bootstrap-5', placeholder: '-- Please Select --'}); 
                }

                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }
            else
            {
                $("#selected-q").html(test.assigned_questions_num);
                $("#total-q").html(test.max_question_limit);

                if (test.is_published == "1")
                {
                    $("#unpublish-assessment-test-btn").removeClass("d-none");
                    $("#unpublish-test").removeClass("d-none");
                    $("#publish-assessment-test-btn").addClass("d-none");   
                }
                else
                {
                    $("#publish-assessment-test-btn").removeClass("d-none");   
                    $("#unpublish-test").addClass("d-none");      
                    $("#unpublish-assessment-test-btn").addClass("d-none");                
                }
            }

            cmsLoadingStatus = false;
        }
    });
}

function loadAssessmentQuestionFormData(questionId)
{
    cmsLoadingStatus = true;
    loadOverlay();

    var action   = "read_assessment_question_info";
    var language = $('#question-language').val()
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();

    $.ajax({
        url: '../cms/ajax_course_builder.php',
        dataType: "json",
        data: {
            action  : action,
            ptToken : token,
            academy : academy,
            id      : questionId,
            language: language
        },
        success: function(data)
        {         
            var question = data.output.question;               

            if ((question) && (typeof question.question !== 'undefined'))
            {
                $("#question-type").val(data.output.type);
                $("#question-txt").val(question.question);
                $('#question-txt').summernote('code', question.question);

                $("#question-instruction").val(question.instruction);
                $('#question-instruction').summernote('code', question.instruction);

                $("#question-marks").val(question.marks);
                $("#question-difficulty").val(question.difficulty);
                
                if (question.has_no_correct_answers == 1)
                {
                    $("#has-no-correct-answers").prop("checked", true);
                }
                else
                {
                    $("#has-no-correct-answers").prop("checked", false);
                }

                if (question.is_pinned == 1)
                {
                    $("#pin-question").prop("checked", true);
                }
                else
                {
                    $("#pin-question").prop("checked", false);
                }

                if ((data.output.type == 'long-answer') && (question.correct_text != null))
                {
                    $("#model-answer-toggle").prop("checked", true);
                    $("#longform-model-answer").val(question.correct_text); 
                    $("#longform-model-answer-wrapper").removeClass('d-none');
                } 

                if ((data.output.type == 'long-answer') && (question.word_limit != null))
                {
                    $("#long-answer-word-limit").val(question.word_limit);
                }

                if ((data.output.type == 'long-answer') && (question.word_min != null))
                {
                    $("#long-answer-word-min").val(question.word_min);
                }  

                if ((question.video_type == "youtube") || (question.video_type == "vimeo"))
                {
                    $('#question-image-wrapper').html(question.video_src);
                }  

                if ((question.image_url != "") && (question.image_url != null))
                {
                    $('#question-image-wrapper').html(
                        `<img id="question-image" src="` + question.image_url + `" 
                          style="max-height: 200px; display: block; margin-top: 10px;" />`
                    );
                }           
                
                var answers = question.answers;
                Object.keys(answers).forEach(function(answerId) {
                    if (answers[answerId]) { 
                        if (!$("#answer-txt-" + answerId).length) {
                            $("#add-answer").trigger('click');                        
                        }
                        
                        $("#answer-txt-" + answerId).val(answers[answerId]);  
                        $('#answer-txt-' + answerId).summernote('code', answers[answerId]);
                    }
                });

                let correctAnswers = question.correct_answers;                
                $("input[name='correct-answer']").prop('checked', false);                
                correctAnswers.forEach(function(answerId) {
                    $("input[name='correct-answer']").each(function() {
                        let id = $(this).closest('.answer-wrapper').find('input[type=\"text\"]').attr('id');
                        
                        if (id && id.endsWith(answerId)) {
                            $(this).prop('checked', true);
                        }
                    });
                });

                if ((question.correct_text != null) || (question.incorrect_text != null))
                {
                    if (data.output.type != 'long-answer')
                    {
                        $("#feedback-toggle").prop("checked", true);
                        $("#feedback-toggle").trigger('change');
                        $("#correct-answer-comments").val(question.correct_text); 
                        $("#incorrect-answer-comments").val(question.incorrect_text); 
                    }                    
                }

                if (data.output.tags_html != 'undefined')
                {
                    $("#question-tags-wrapper").html(data.output.tags_html);
                    $("#question-tags-wrapper .tags-question-input").select2({ theme: 'bootstrap-5', placeholder: '-- Please Select --'}); 
                }

                if (data.output.theme != null)
                {
                    $("#question-themes").val(data.output.theme);

                    if (data.output.sub_themes != 'undefined')
                    {
                        var subThemeOptions = data.output.sub_themes;
                        var subThemes = $('#question-sub-themes');
                        subThemes.html(subThemeOptions);
                        subThemes.select2({
                            placeholder: 'Please select...',
                            theme: 'bootstrap-5',
                        });
                    }
                }

            }
            else
            {
                /*Defaults/Blanks*/
                $("#question-txt").val("");
                $('#question-txt').summernote('code', "");

                $("#question-instruction").val("");
                $('#question-instruction').summernote('code', "");

                $(".answer-wrapper input[type='text']").each(function() {
                    $(this).val("");
                    $(this).summernote("code", "");
                });
               
                $("#correct-answer-comments").val(""); 
                $("#incorrect-answer-comments").val(""); 

                $("#longform-model-answer").val(""); 
            }            

            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            }); 

            $("#question-type").trigger("change");         

            cmsLoadingStatus = false;
        }
    });
}

function loadRegulationFormData(regulationId)
{
    cmsLoadingStatus = true;
    loadOverlay();

    var action   = "read_regulation_info";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();

    $.ajax({
        url: '../cms/ajax_cms.php',
        dataType: "json",
        data: {
            action  : action,
            ptToken : token,
            academy : academy,
            id      : regulationId
        },
        success: function(data)
        {

            console.log(data);
            $("#regulation-id").val(regulationId); 

            var regulation = data.regulation[0];
            $("#name-regulation").val(regulation[0].name);
            $("#description-regulation").val(regulation[0].description);

            var online_courses    = data.online_courses_form[0];
            var f2f_courses       = data.f2f_courses_form[0];    
            var qualificationhtml = data.qualification[0];    
            var prereqHtml    = data.regulation_html[0];     

            $("#online_courses_list").html(online_courses);
            $("#f2f_courses_list").html(f2f_courses);
            $("#qualification").html(qualificationhtml);
            $("#prerequisite").html(prereqHtml);
          

            $("#online_courses_list").select2({
                placeholder: "Please select",
                theme: 'bootstrap-5'
            });
            

            $("#f2f_courses_list").select2({
                placeholder: "Please select",
                theme: 'bootstrap-5'
            });

            $(".role-users-wrapper").html(data.regulation_courses[0]);

            tbl_regulation_courses = 
            $('#existing_users_table_' + regulationId).DataTable({                               
                responsive: true,
                rowReorder: true,
                columnDefs: [
                    { className: "reorder", "targets": [ 0 ] },            
                    { targets: 0, visible: false },
                    { targets: 1, visible: false },
                    { "width": "80px", "targets": 6, 'orderable': false },
                    { 'targets': [2,3,4,5], 'orderable': false }
                ]                                     
            });

            tbl_regulation_courses.on( 'row-reorder', function ( e, diff, edit ) {

                cmsLoadingStatus = true;
                loadOverlay();

                var elementOrder = [];
                for (var i = 0, ien = diff.length; i<ien ; i++) 
                {
                    var rowData = tbl_regulation_courses.row( diff[i].node ).data();
                    var element = {"key" : rowData[1], "order" : diff[i].newData};
                    elementOrder.push(element);
                }

                var token = $('input[name=token]').val();

                $.ajax({
                    url: '../cms/ajax_cms.php',
                    type: "post",
                    dataType: "json",
                    async: false,
                    data: {
                        action   : 'reorder_regulation_courses',
                        ptToken  : token,
                        elements : elementOrder
                    },
                    success: function(data)
                    {
                        cmsLoadingStatus = false;
                        reload_regulations_table();
                    }
                });
            });

            var isRegulationPublished = regulation[0].is_published;
            if (isRegulationPublished == 1)
            {
                $("#is_published").prop("checked", true);
            }
            else
            {
                $("#is_published").prop("checked", false);
            }

            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });

            var imageUrl = regulation[0].image_url;
            $('#regulation_image_url').attr('src', imageUrl);

            //check for the requirements
            if (academy == 112) {

                var requirements_renewal = data.regulation_requirements[0];
                var not_current_status   = data.render_not_current[0];
                var expired_status       = data.render_expired[0];

                var document_upload   = requirements_renewal.document_upload;
                var document_desc     = requirements_renewal.document_name;

                var fee_required     = requirements_renewal.fee_required;
                var fee_value     = requirements_renewal.fee_value;

                var cpd_required     = requirements_renewal.cpd_credit;
                var cpd_fee_value     = requirements_renewal.cpd_credit_value;

                var cpd_credit_upload     = requirements_renewal.cpd_credit_upload;
                var cpd_credit_description     = requirements_renewal.cpd_credit_description;

                var not_current_fee = not_current_status.fee_charged;
                var not_current_start = not_current_status.renewal_start;
                var not_current_finish = not_current_status.renewal_finish;
                var not_current_period        = not_current_status.period_not_current;

                var expired_period = expired_status.period_not_current;


                if (document_upload == "on")
                {
                    $("#type_upload").val("upload_document");
                    $("#name_document_upload").val(document_desc);
                }

                if (fee_required == "on")
                {
                    $("#is_fee_required").prop("checked", true);
                    $('#fee_required').val(fee_value);
                    $('#fee_required').removeAttr('disabled');
                }

                if (cpd_required == "on")
                {
                    $("#is_cpd_required").prop("checked", true);
                    $('#cpd_required').val(cpd_fee_value);
                    $('#cpd_required').removeAttr('disabled');
                }

                if (cpd_credit_upload == "on")
                {
                    $("#is_cpd_upload").prop("checked", true);
                    $('#description_end_user_cpd').val(cpd_credit_description);
                    $('#description_end_user_cpd').removeAttr('disabled');
                }

                if (not_current_fee != "")
                {
                    $('#notcurrent_fee_charged').val(not_current_fee);
                }

                if (not_current_start != "")
                {
                    $('#notcurrent_renewal_start').val(not_current_start);
                }

                if (not_current_finish != "")
                {
                    $('#notcurrent_renewal_finish').val(not_current_finish);
                }

                if (not_current_period != "")
                {
                    $('#notcurrent_period_not_current').val(not_current_period);
                }

                if (expired_period != "")
                {
                    $('#expired_period_not_current').val(expired_period);
                }

                var summnerNoteOptions = {
                        minHeight: 300,
                        dialogsInBody: true,
                        //,airMode: true
                        codemirror: { // codemirror options
                            theme: 'monokai'
                        },
                        toolbar: [
                            // [groupName, [list of button]]
                            ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
                            ['insert', ['link', 'unlink']],
                            ['color', ['color']],
                            ['para', ['ul', 'ol', 'paragraph']],
                            
                        ],
                        callbacks: {
                          onPaste: function (e) {
                            var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                            e.preventDefault();
                            setTimeout( function(){
                              document.execCommand( 'insertText', false, bufferText );
                            }, 10 );
                          }
                        }
                };

                if ($('#description-regulation').length)
                {        
                    $('#description-regulation').summernote(summnerNoteOptions);
                }

               

            }

            cmsLoadingStatus = false;
        }
    });
}

$(document).on('change', '#is_fee_required', function() {

    if ($(this).is(':checked')) {
       
       $('#fee_required').removeAttr('disabled');

    } else {
        $('#fee_required').attr('disabled', 'disabled');
        $('#fee_required').val('0');
    }

});

$(document).on('change', '#is_cpd_required', function() {

    if ($(this).is(':checked')) {
       
       $('#cpd_required').removeAttr('disabled');

    } else {
        $('#cpd_required').attr('disabled', 'disabled');
        $('#cpd_required').val('0');
    }

});

$(document).on('change', '#is_cpd_upload', function() {

    if ($(this).is(':checked')) {
       
       $('#description_end_user_cpd').removeAttr('disabled');

    } else {
        $('#description_end_user_cpd').attr('disabled', 'disabled');
        
    }

});

function editCertificationModal(certificationId)
{
    $('#edit-certification-modal').remove();
    var output = 
    '<div id="edit-certification-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-lg" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">Edit Pathway</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="name">Name</label>'+
                                '<input type="text" class="form-control" id="name-certification"/>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="onlineCourses">Online Programmes</label>'+
                                '<select style="width:100%" class="form-control select2-course-certification" name="online_courses_list[]" id="online_courses_list" multiple="multiple"></select>'+
                            '</div>'+
                        '</div>'+

                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="f2fCourses">Face to Face Programmes</label>'+
                                '<select style="width:100%" class="form-control select2-course-certification" name="f2f_courses_list[]" id="f2f_courses_list" multiple="multiple"></select>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="onlineCourses">Pathway Certificate</label>'+
                                '<select style="width:100%" class="form-control select2-course-certification" name="pathway_certificate" id="pathway_certificate"></select>'+
                            '</div>'+
                        '</div>'+

                        '<div class="col-sm-2">'+
                            '<label for="isCertification">Publish Pathway</label>'+
                            '<label class="switch is-certification"><input type="checkbox" id="is_certification"><div class="slider round"></div></label>'+
                        '</div>'+
                        '<div class="col-sm-2">'+
                            '<label for="isHomePage">Show On Home Page</label>'+
                            '<label class="switch is-show-home"><input type="checkbox" id="is_show_home"><div class="slider round"></div></label>'+
                        '</div>'+
                        '<div class="col-sm-2">'+
                            '<label for="restrict">Restrict Display to F2F/Webinar Participants</label>'+
                            '<label class="switch is-show-restrict"><input type="checkbox" id="is_restrict"><div class="slider round"></div></label>'+
                        '</div>'+
                    '</div>'+  
                    '<div id="advanced-req-select"></div>'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="description">Description</label>'+
                                '<textarea type="text" class="form-control" rows="5" id="description-certification"></textarea>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="image">Pathway Image [Ideal Dimension - width:810px;height:400px] (Can use tinypng.com for compression) </label>'+
                                '<img class="itf-logo-images" style="width:50%" id="pathway_image_url" src=""/>' +
                                '<input type="file" style="display:inline-block;vertical-align:middle" class="upload-file-btn" name="pathway_image" id="pathway_image">'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<input type="hidden" id="certification-id" value="'+certificationId+'">'+
                            '<button id="update-certification-btn" type="button" class="btn btn-primary">Save</button>'+
                        '</div>'+                       
                    '</div>'+

                    '<div class="alert alert-certifications" role="alert" id="alert-course-certification"></div>'+

                    '<hr>'+

                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<h5>Programmes assigned to this pathway</h5>'+
                            '<div class="role-users-wrapper">'+
                            '</div>'+                 
                        '</div>'+
                    '</div>'+

                '</div>'+
                '<div class="modal-footer">'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#edit-certification-modal').modal('show');

    loadCertificationFormData(certificationId);
}



var certLevelForm, expertise;
function loadCertificationFormData(certificationId)
{
    cmsLoadingStatus = true;
    loadOverlay();

    var action   = "read_certification_info";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    var advancedData;

    $.ajax({
        url: '../cms/ajax_cms.php',
        dataType: "json",
        data: {
            action  : action,
            ptToken : token,
            academy : academy,
            id      : certificationId
        },
        success: function(data)
        {

            console.log(data);

            advancedData = data.all_certification[0];
            // carryForwardData = data.cfwd_rules_form_form[0];

            $("#certification-id").val(certificationId); 

            var certification = data.certification[0];
            $("#name-certification").val(certification[0].name);
            $("#description-certification").val(certification[0].description);

            var online_courses    = data.online_courses_form[0];
            var f2f_courses       = data.f2f_courses_form[0];
            var certificates      = data.certificates_form[0];

            $("#online_courses_list").html(online_courses);
            $("#f2f_courses_list").html(f2f_courses);
            $("#pathway_certificate").html(certificates);

            $("#online_courses_list").select2({
                placeholder: "Please select",
                theme: 'bootstrap-5',
                dropdownParent: $('.modal-body')

            });

            $("#f2f_courses_list").select2({
                placeholder: "Please select",
                theme: 'bootstrap-5',
                dropdownParent: $('.modal-body')
            });

        

            $(".role-users-wrapper").html(data.certification_courses[0]);

            tbl_certification_courses = 
            $('#existing_users_table_' + certificationId).DataTable({                               
                responsive: true,
                rowReorder: true,
                columnDefs: [
                    { className: "reorder", "targets": [ 0 ] },            
                    { targets: 0, visible: false },
                    { targets: 1, visible: false },
                    { "width": "80px", "targets": 7, 'orderable': false },
                    { 'targets': [2,3,4,5,6], 'orderable': false }
                ]                                     
            });

            tbl_certification_courses.on( 'row-reorder', function ( e, diff, edit ) {

                cmsLoadingStatus = true;
                loadOverlay();

                var elementOrder = [];
                for (var i = 0, ien = diff.length; i<ien ; i++) 
                {
                    var rowData = tbl_certification_courses.row( diff[i].node ).data();
                    var element = {"key" : rowData[1], "order" : diff[i].newData};
                    elementOrder.push(element);
                }

                var token = $('input[name=token]').val();

                $.ajax({
                    url: '../cms/ajax_cms.php',
                    type: "post",
                    dataType: "json",
                    async: false,
                    data: {
                        action   : 'reorder_certification_courses',
                        ptToken  : token,
                        elements : elementOrder
                    },
                    success: function(data)
                    {
                        cmsLoadingStatus = false;
                        reload_Certifications_table();
                    }
                });
            });

            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });

            var filePath = certification[0].certificate_path;
            if ((filePath != '') && (filePath != null))
            {
                var fileArr  = filePath.split("/");
                var fileName = fileArr[(fileArr.length-1)];
                $('#uploaded_pdf_file').html('<i class="fas fa-check"></i><a class="uploaded-pdf-path-cc" href="'+filePath+'" target="_blank">'+fileName+'</a>');
            }
            else
            {
                $('#uploaded_pdf_file').empty();
            }

            $('#input-pdf-upload').val("");
            $('#input-pdf-upload').parents('.input-group').find('.form-control').val("");

            

            var isCertificationStatus = certification[0].is_certification;
            if (isCertificationStatus == 1)
            {
                $("#is_certification").prop("checked", true);
            }
            else
            {
                $("#is_certification").prop("checked", false);
            }   

            var showHomePathway = certification[0].is_show_home;
            if (showHomePathway == 1)
            {
                $("#is_show_home").prop("checked", true);
            }
            else
            {
                $("#is_show_home").prop("checked", false);
            }   

            var restrictPathway = certification[0].is_restrict;
            if (restrictPathway == 1)
            {
                $("#is_restrict").prop("checked", true);
            }
            else
            {
                $("#is_restrict").prop("checked", false);
            }   

            console.log(certification[0]);

            certLevelForm = data.cert_level_form[0];
            expertise = data.cpd_expertise;
            

            let academyId = $('input[name="academy"]').val();
            if (academyId == 103)
            {
                addAdvancedSelect(certLevelForm, expertise);
            }
            var imageUrl = certification[0].image_url;
            $('#pathway_image_url').attr('src', imageUrl);

            cmsLoadingStatus = false;
        }
    });
}
var advancedLevel = [];
function addAdvancedSelect(certLevelForm, expertise) 
{
    var certLevel = `<div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="">Pathway Level:</label>
                                <select class="form-control" name="cert_level" id="cert_level">
                                    <option value="">-- Please Select --</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label for="">Advanced Expertise:</label>
                            <input type="text" class="form-control mb_2" id="expertise_name" placeholder="Expertise Name">
                            <div class="row mb_3">
                                <div class="col-md-8">
                                    <select class="form-control" name="advanced_level_drop" id="advanced_level_drop">
                                        <option value="">-- Expertise Level --</option>
                                        <option value="1">Level 1</option>
                                        <option value="2">Level 2</option>
                                        <option value="3">Level 3</option>
                                        <option value="4">Level 4</option>
                                    </select>     
                                </div>
                                <div class="col-md-4 text-right">
                                    <button class="btn btn-success btn-block" id="btn-add-expertise">Add <i class="fa fa-plus"></i></button>
                                </div>
                            </div>
                            <ul class="list-group" id="expertise-mount"></ul>                            
                        </div>
                    </div>`;
    $('#advanced-req-select').html(certLevel);
    $("#cert_level").html(certLevelForm); // clear the array
    advancedLevel = [];
    var liItem;
    for (var i = 0; i < expertise[0].length; i++) {
        var c = expertise[0][i];
        liItem = renderExpertiseItem(c.id, c.name, c.level);
        $('#expertise-mount').append(liItem); // add previously assigned values to the array
        advancedLevel.push({
          'id': c.id,
          'advanced_level': c.level,
          'name': c.name
        });
    }
}

function renderExpertiseItem(id, name, level) 
{
    var liItem = "<li class=\"list-group-item\" \n        data-id=\"".concat(id, "\"\n        data-level=\"").concat(level, "\" \n        data-name=\"").concat(name, "\">\n            <b>Level: ").concat(level, "</b> \n            ").concat(name, " \n            <button class=\"btn btn-danger btn-sm btn-delete-expertise pull-right\"><i class=\"fa fa-times\"></i></button>\n        </li>");
    return liItem;
}

$(document).on('click', '.btn-delete-expertise', function() {

    var parent = $(this).parent('.list-group-item');
    var dataId = parent.data('level');

    var item = advancedLevel.find(function(p) {

        return p.advanced_level == dataId;
    });

    item.delete = 1;

    $(this).remove();

    parent.append('<span class="badge badge-danger">DELETED</span>');

    console.log(dataId, advancedLevel);

    // parent.remove();

});

$(document).on('click', '#btn-add-expertise', function () {
    var dataId = $(this).parent('.list-group-item').data('id');
    var name = $('#expertise_name').val();
    var level = $('#advanced_level_drop').val();
    var liItem; // check if level or name exists in array

    if (advancedLevel.some(function (p) {
        return p.advanced_level == level;
    })) {
        alert('Cannot add an existing level');
        return;
    } else if (advancedLevel.some(function (p) {
        return p.name == name;
    })) {
        alert('Cannot add an existing name');
        return;
    } //check if either field is empty
    if (name == '' || level == '') {
        alert('Please fill in both Expertise Name and Select Level');
        return;
    } else {
        // add item to DOM
        liItem = renderExpertiseItem('', name, level);
        $('#expertise-mount').append(liItem); // add values to array
        advancedLevel.push({
          'id': dataId,
          'advanced_level': level,
          'name': name
        });
    }
});

$(document).on('click', '#update-certification-btn', function() 
{
    var certificationId   = $("#certification-id").val();
    var name              = $("#name-certification").val();
    var onlineCoursesList = $("#online_courses_list").val();
    var f2fCoursesList    = $("#f2f_courses_list").val();
    var certificate       = $("#pathway_certificate").val();
    var isCertification   = $("#is_certification").prop("checked") == true ? 1:0;
    var isAdvanced        = $("#is_advanced").prop("checked") == true ? 1:0;
    var advancedReq       = $("#expertise_requirements").val();
    var certLevel         = $("#cert_level").val();
    var action            = "edit_certification_info";
    var token             = $("input[name=token]").val();
    var description       = $("#description-certification").val();
    var isShowHome        = $("#is_show_home").prop("checked") == true ? 1:0;
    var isRestrict        = $("#is_restrict").prop("checked") == true ? 1:0;

    $('#alert-course-certification').removeClass("alert-danger");
    $('#alert-course-certification').removeClass("alert-success");

    if ((name == '') || (name == null))
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Certificate name not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        var formData = new FormData();
        formData.append('action', action);
        formData.append('ptToken', token);
        formData.append('id', certificationId);
        formData.append('name', name);
        formData.append('online_courses_list', onlineCoursesList);
        formData.append('f2f_courses_list', f2fCoursesList);
        formData.append('certificate', certificate);
        formData.append('is_certification', isCertification);
        formData.append('cert_level', certLevel);
        formData.append('cpd_expertise', JSON.stringify(advancedLevel));
        formData.append('is_advanced', isAdvanced);
        formData.append('parent_id', advancedReq);
        formData.append('description', description);
        formData.append('is_show_home', isShowHome);
        formData.append('is_restrict', isRestrict);

        var files = $('#pathway_image')[0].files;
        if(files.length > 0 )
        {
           formData.append('file',files[0]);
       }
       var currentUrl = $("#pathway_image_url").attr('src');
       formData.append('currentImage', currentUrl);
        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData,
            success: function(data)
            {

                if (data.output)
                {
                    cmsLoadingStatus = false;
                    loadCertificationFormData(certificationId);
                    reload_Certifications_table();

                    $('#alert-course-certification').addClass("alert-success");
                    $('#alert-course-certification').html("Pathway successfully updated.");
                    $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
                }
                else
                {
                    cmsLoadingStatus = false;
                    loadCertificationFormData(certificationId);
                    reload_Certifications_table();
                    $('#alert-course-certification').addClass("alert-danger");
                    $('#alert-course-certification').html("Face to face courses is required!");
                    $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
                }
              
            }
        });
    }
});

$(document).on('click', '#update-regulation-btn', function() 
{
    var regulationId        = $("#regulation-id").val();
    var name                = $("#name-regulation").val();
    var onlineCoursesList   = $("#online_courses_list").val();
    var f2fCoursesList      = $("#f2f_courses_list").val();
    var isPublished         = $("#is_published").prop("checked") == true ? 1:0;   
    var action              = "edit_regulation_info";
    var token               = $("input[name=token]").val();
    var description         = $("#description-regulation").val(); 
    var academy             = $('input[name="academy"]').val();

    $('#alert-course-regulation').removeClass("alert-danger");
    $('#alert-course-regulation').removeClass("alert-success");

    if ((name == '') || (name == null))
    {
        $('#alert-course-regulation').addClass("alert-danger");
        $('#alert-course-regulation').html("Error : Regulation name not found!");
        $("#alert-course-regulation").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        var formData = new FormData();
        formData.append('action', action);
        formData.append('ptToken', token);
        formData.append('id', regulationId);
        formData.append('name', name);
        formData.append('online_courses_list', onlineCoursesList);
        formData.append('f2f_courses_list', f2fCoursesList);       
        formData.append('is_published', isPublished);
        formData.append('description', description);


        if (academy == 112) {

            var qualification       = $("#qualification").val();
            var prereq              = $("#prerequisite").val();
            var typeUpload          = $("#type_upload").val();
            var nameDocUpload       = $("#name_document_upload").val();
            var isFeeRequired       = $("#is_fee_required").prop("checked") == true ? 1:0;
            var feeRequired         = $("#fee_required").val();
            var isCpdRequired       = $("#is_cpd_required").prop("checked") == true ? 1:0;
            var cpdRequired         = $("#cpd_required").val();
            var isCpdUploadRequired = $("#is_cpd_upload").prop("checked") == true ? 1:0;
            var descOfUpload         = $("#description_end_user_cpd").val();
            var notcurrent_start   = $('#notcurrent_renewal_start').val();
            var notcurrent_finish  = $('#notcurrent_renewal_finish').val();
            var notcurrent_period  = $('#notcurrent_period_not_current').val();
            var notcurrent_fee     = $('#notcurrent_fee_charged').val();
            var expired_period     = $('#expired_period_not_current').val();


            formData.append('qualification', qualification);
            formData.append('prereq', prereq);
            formData.append('typeUpload', typeUpload);
            formData.append('nameDocUpload', nameDocUpload);
            formData.append('isFeeRequired', isFeeRequired);
            formData.append('feeRequired', feeRequired);
            formData.append('isCpdRequired', isCpdRequired);
            formData.append('cpdRequired', cpdRequired);
            formData.append('isCpdUploadRequired', isCpdUploadRequired);
            formData.append('descOfUpload', descOfUpload);
            formData.append('notcurrent_start', notcurrent_start);
            formData.append('notcurrent_finish', notcurrent_finish);
            formData.append('notcurrent_period', notcurrent_period);
            formData.append('notcurrent_fee', notcurrent_fee);
            formData.append('expired_period', expired_period);

        }

        var files = $('#regulation_image')[0].files;
        if(files.length > 0 )
        {
           formData.append('file',files[0]);
        }

       var currentUrl = $("#regulation_image_url").attr('src');
       formData.append('currentImage', currentUrl);
        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData,
            success: function(data)
            {

                if (data.output)
                {
                    cmsLoadingStatus = false;
                    loadRegulationFormData(regulationId);
                    reload_regulations_table();

                    $('#alert-course-regulation').addClass("alert-success");
                    $('#alert-course-regulation').html("Regulation successfully updated");
                    $("#alert-course-regulation").fadeIn(300).delay(1500).fadeOut(400);
                }
                else
                {
                    cmsLoadingStatus = false;
                    loadRegulationFormData(regulationId);
                    reload_regulations_table();
                    $('#alert-course-regulation').addClass("alert-danger");
                    $('#alert-course-regulation').html("Regulation could not be updated");
                    $("#alert-course-regulation").fadeIn(300).delay(1500).fadeOut(400);
                }
              
            }
        });
    }
});

$(document).on('click', '.availability-certification', function() 
{
    var contentid    = $(this).attr("data-content-id");
    var availability = $(this).attr("data-content-availability");
    var button       = $(this);
    var svg          = button.find('.svg-inline--fa');
    var token        = $("input[name=token]").val();
    var action       = "deactivate_certification";

    if (availability === 'deleted')
    {
        action = "activate_certification";
    }

    svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

    $.ajax({
        url: '../cms/ajax_cms.php',
        dataType: "json",
        data: {
            id        : contentid,
            action    : action,
            ptToken   : token
        },
        success: function(data)
        {
            reload_Certifications_table();
        }
    });
});

function deleteCertification(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_certification';

    var confirmation = confirm("Are you sure you want to delete this certificate?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action  : action,
                ptToken : ptToken,
                id      : id
            },
            success: function (data)
            {
                reload_Certifications_table();
                cmsLoadingStatus = false;
            }
        });
    }
}

function deleteRegulation(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_regulation';

    var confirmation = confirm("Are you sure you want to delete this regulation?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action  : action,
                ptToken : ptToken,
                id      : id
            },
            success: function (data)
            {
                reload_regulations_table();
                cmsLoadingStatus = false;
            }
        });
    }
}

function deleteKnowledgeTest(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_knowledge_test';

    var confirmation = confirm("Are you sure you want to delete this test?");

    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action  : action,
                ptToken : ptToken,
                id      : id
            },
            success: function (data)
            {
                reload_knowledge_tests_table();
            }
        });
    }
}

function deleteQualRequirements(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_qualification_requirements';

    var confirmation = confirm("Are you sure you want to delete this requirement?");

    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action  : action,
                ptToken : ptToken,
                id      : id
            },
            success: function (data)
            {
               location.reload();
            }
        });
    }
}

function deleteQualification(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_qualification';

    var confirmation = confirm("Are you sure you want to delete this qualification?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action  : action,
                ptToken : ptToken,
                id      : id
            },
            success: function (data)
            {
                location.reload();
                cmsLoadingStatus = false;
            }
        });
    }
}

function saveQualRequirements(req_id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'save_qualification_and_or';
    var required     = $("#and_or_" + req_id).val();

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url : '../cms/ajax_cms.php',
        dataType: "json",
        data: {
            action  : action,
            ptToken : ptToken,
            id      : req_id,
            option  : required
        },
        success: function (data)
        {
            location.reload();
            cmsLoadingStatus = false;
        }
    });

}

function deleteCourseCertification(courseId, certificationId)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_course_certification';

    var confirmation = confirm("Are you sure you want to delete this course?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action           : action,
                ptToken          : ptToken,
                course_id        : courseId,
                certification_id : certificationId
            },
            success: function (data)
            {
                cmsLoadingStatus = false;
                loadCertificationFormData(certificationId);
                reload_Certifications_table();                
            }
        });
    }
}

function deleteRegulationCourse(courseId, regulationId)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_course_regulation';

    var confirmation = confirm("Are you sure you want to delete this course from this regulation?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action           : action,
                ptToken          : ptToken,
                course_id        : courseId,
                regulation_id : regulationId
            },
            success: function (data)
            {
                cmsLoadingStatus = false;
                loadRegulationFormData(regulationId);
                reload_regulations_table();                
            }
        });
    } 
}

// get the audio name and data
$(document).on('change', '#input-pdf-upload', function(e) {

    var file   = e.target.files[0];    
    var reader = new FileReader();
    reader.onload = function(e) 
    {
        $('#input-pdf-upload').parents('.input-group').find('.form-control').val(file.name);
    }
    reader.readAsDataURL(file);
});

$(document).on('click', '#f2f_course_enrolment_btn', function(e) {
    $("#course_info_div").hide();
    $("#f2f_course_enrolment_div").show();
});

$(document).on('click', '#f2f_course_enrolment_back_btn', function(e) {
    $("#course_info_div").show();
    $("#f2f_course_enrolment_div").hide();
    $("#vouchercode").val("");
    $("#vouchercode_error").hide();
});

$(document).on('click', '.edit-user-details', function() {
    var userId = $(this).attr("data-content-id");         
    editUserDetails(userId)
});

function editUserDetails(userId)
{
    $('#edit-user-details-modal').remove();
    var output = 
    '<div id="edit-user-details-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-lg" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">Edit User Details</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="first-name">First Name</label>'+
                                '<input type="text" class="form-control" id="first-name"/>'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="last-name">Last Name</label>'+
                                '<input type="text" class="form-control" id="last-name"/>'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="email">Email</label>'+
                                '<input type="text" class="form-control" id="email"/>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="gender">Gender</label>'+
                                '<select class="form-control" name="gender" id="gender">'+
                                '</select>'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="year-of-birth">Year of Birth</label>'+
                                '<input type="number" class="form-control" id="year-of-birth" min="1920" max="2020"/>'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="country">Memorable Word</label>'+
                                '<input type="text" class="form-control" id="memorable-word"/>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="chosen-language">Chosen Language</label>'+
                                '<select class="form-control" name="chosen-language" id="chosen-language">'+
                                '</select>'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="country">Country</label>'+
                                '<select class="form-control" name="country" id="country">'+
                                '</select>'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="country">Region</label>'+
                                '<select class="form-control" name="region" id="region">'+
                                '</select>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<input type="hidden" id="user_id" value="'+userId+'">'+
                            '<button id="update-user_details-btn" type="button" class="btn btn-primary">Save</button>'+
                        '</div>'+                       
                    '</div>'+

                    '<div class="alert alert-certifications" role="alert" id="alert-course-certification"></div>'+

                    '<hr></hr>'+

                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div id="exTab2" class="">'+  
                                '<ul class="nav nav-tabs ml_0">'+
                                    '<li class="nav-item">'+
                                        '<a class="nav-link active" href="#courses" data-toggle="tab">Courses</a>'+
                                    '</li>'+                           
                                    '<li class="nav-item">'+
                                        '<a class="nav-link" href="#icoach" data-toggle="tab">iCoach</a>'+
                                    '</li>'+
                                    '<li class="nav-item">'+
                                        '<a class="nav-link" href="#ebooks" data-toggle="tab">eBooks</a>'+
                                    '</li>'+
                               '</ul>'+
                                '<div class="tab-content clearfix">'+
                                    '<div class="tab-pane active" id="courses">'+
                                        '<div class="row" style="padding:15px 0 5px 0;">'+
                                            '<div class="col-sm-6">'+
                                                '<div class="form-group">'+
                                                    '<h5 style="padding: 8px 3px 6px 0;" class="modal-title">User registered courses</h5>'+
                                                '</div>'+    
                                            '</div>'+                                         
                                            '<div class="col-sm-6 text-right">'+
                                                '<div class="form-group">'+
                                                    '<button id="assign-course-modal-btn" data-id="'+userId+'" type="button" class="btn btn-primary">Assign Course</button>'+
                                                '</div>'+   
                                            '</div>'+
                                        '</div>'+

                                        '<div class="role-users-wrapper">'+
                                        '</div>'+
                                    '</div>'+
                                    '<div class="tab-pane" id="icoach">'+
                                        '<div class="row" style="padding:15px 0 5px 0;">'+
                                            '<div class="col-sm-6">'+
                                                '<div class="form-group">'+
                                                    '<h5 style="padding: 8px 3px 6px 0;" class="modal-title">iCoach Subscriptions</h5>'+
                                                '</div>'+    
                                            '</div>'+                                         
                                            '<div class="col-sm-6 text-right">'+
                                                '<div class="form-group">'+
                                                    '<button id="create-subscription-modal-btn" data-id="'+userId+'" type="button" class="btn btn-primary">Create Subscription</button>'+
                                                '</div>'+    
                                            '</div>'+
                                        '</div>'+
                                        '<div class="role-users-wrapper-subscription">'+
                                        '</div>'+
                                    '</div>'+
                                     '<div class="tab-pane" id="ebooks">'+
                                        '<div class="row" style="padding:15px 0 5px 0;">'+
                                            '<div class="col-sm-6">'+
                                                '<div class="form-group">'+
                                                    '<h5 style="padding: 8px 3px 6px 0;" class="modal-title">User Books</h5>'+
                                                '</div>'+    
                                            '</div>'+     
                                        '</div>'+

                                        '<div class="role-users-books">'+
                                        '</div>'+
                                    '</div>'+
                                '</div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<hr></hr>'+

                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group" id="generate_password_reset_link-wrapper">'+
                                '<label for="description">Password Reset (Generate the link and provide to the user)</label>'+
                                '<br><u><a id="generate_password_reset_link" data-id="'+userId+'" style="cursor: pointer;">Generate password reset link</a></u>'+
                                '<div class="alert alert-certifications" role="alert" id="alert-pw-reset-link"></div>'+
                                '<div id="pw-reset-div">'+
                                    '<textarea type="text" class="form-control" rows="3" id="password-reset-link"></textarea>'+
                                    '<button style="margin-top: 3px; display:none;" data-toggle="tooltip" title="Copy to Clipboard" class="btn utils" onclick="copyTextValue('+"'password-reset-link'"+')"><i class="fas fa-copy"></i></button>'+
                                    '<button style="margin-top: 3px; margin-left: 3px; display:none;" data-toggle="tooltip" title="Clear" class="btn utils" onclick="clearText('+"'password-reset-link'"+')"><i class="fas fa-eraser"></i></button>'+
                                '</div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                '</div>'+
                '<div class="modal-footer">'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#edit-user-details-modal').modal('show');
    loadUserDetailsFormData(userId);
}

function loadUserDetailsFormData(user_id)
{
    cmsLoadingStatus = true;
    loadOverlay();
    var action   = "read_user_info";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action  : action,
            token : token,
            academy : academy,
            user_id : user_id
        },
        success: function(data)
        {
            var user = data.user[0];
            $("#user_id").val(user_id);
            $("#first-name").val(user.first_name);
            $("#last-name").val(user.last_name);
            $("#email").val(user.email);
            $("#year-of-birth").val(user.year_of_birth);
            $("#memorable-word").val(user.itf_memorable_word);
            $("#gender").html(data.gender[0]);
            $("#chosen-language").html(data.language[0]);
            $("#country").html(data.country[0]);
            $("#region").html(data.region[0]);
            $("#country").on('change', function(){
                var country_code = $(this).val();
                if (country_code != '')
                {
                    readRegionByCountry($(this).val());
                }
                else
                {
                    $("#region").val("");
                }
            });
            
            if (academy==103)
            {
                $("#first-name").attr('disabled', true);
                $("#last-name").attr('disabled', true);
                $("#email").attr('disabled', true);
                $("#year-of-birth").attr('disabled', true);           
                $("#gender").attr('disabled', true);
                $("#country").attr('disabled', false);
                $("#region").attr('disabled', true);
                $("#chosen-language").attr('disabled', true);
                $("#generate_password_reset_link-wrapper").show();
            }
            else
            {
                $("#generate_password_reset_link-wrapper").show();
            }

            $(".role-users-wrapper").html(data.course_table[0]);

            $('#existing_users_table_' + user_id).DataTable({                               
                "responsive": true,
                "pageLength": 5,
                "columnDefs": [
                    { "width": "13%", "targets": 3 },
                    { "width": "13%", "targets": 4 },
                    { "width": "5%", "targets": 5 }
                ],
            });

            $(".role-users-wrapper-subscription").html(data.sub_table[0]);

            $('#existing_users_table_subs_' + user_id).DataTable({                               
                "responsive": true,
                "order": [1, 'asc'],
                "pageLength": 5,
                "columnDefs": [
                    { "width": "13%", "targets": 3 }
                ],
            });

            $(".role-users-books").html(data.ebook_table[0]);

            $('#existing_books_table_' + user_id).DataTable({                               
                "responsive": true,
                "pageLength": 5,
                "columnDefs": [
                    { "width": "13%", "targets": 1 }
                ],
            });
        
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
            cmsLoadingStatus = false;
        }
    });
}

function readRegionByCountry(country)
{
    cmsLoadingStatus = true;
    loadOverlay();

    var action   = "read_region_by_country";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();

    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action  : action,
            token   : token,
            country : country,
            academy : academy
        },
        success: function(data)
        {
            $("#region").val(data);
            cmsLoadingStatus = false;
        }
    });
}

$(document).on('click', '#update-user_details-btn', function() 
{
    var userId         = $("#user_id").val();
    var firstName      = $("#first-name").val();
    var lastName       = $("#last-name").val();
    var email          = $("#email").val();
    var gender         = $("#gender option:selected").val();
    var yearOfBirth    = $("#year-of-birth").val();
    var memorableWord  = $("#memorable-word").val();
    var chosenLanguage = $("#chosen-language option:selected").val();
    var country        = $("#country option:selected").val();
    var region         = $("#region option:selected").val();
    var action         = "edit_user_info";
    var token          = $("input[name=token]").val();

    $('#alert-course-certification').removeClass("alert-danger");
    $('#alert-course-certification').removeClass("alert-success");

    if ((firstName == '') || (firstName == null))
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : First name not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((lastName == '') || (lastName == null))
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Last name not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((email == '') || (email == null))
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Email not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((gender == '') || (gender == null))
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Gender not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((yearOfBirth == '') || (yearOfBirth == null))
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Year Of Birth not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((memorableWord == '') || (memorableWord == null))
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Memorable Word not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((country == '') || (country == null))
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Country not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((region == '') || (region == null))
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Region not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((chosenLanguage == '') || (chosenLanguage == null))
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Chosen Language not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if (yearOfBirth.length != 4)
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Invalid Year Of Birth!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        var formData = new FormData();
        formData.append('action', action);
        formData.append('token', token);
        formData.append('user_id', userId);
        formData.append('first_name', firstName);
        formData.append('last_name', lastName);
        formData.append('email', email);
        formData.append('gender', gender);
        formData.append('year_of_birth', yearOfBirth);
        formData.append('memorable_word', memorableWord);
        formData.append('chosen_language', chosenLanguage);
        formData.append('country', country);
        formData.append('region', region);
        
        $.ajax({
            url: '../content/ajax_itf_common.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData,
            success: function(data)
            {
                cmsLoadingStatus = false;
                reload_registered_users_table();   

                $('#alert-course-certification').addClass("alert-success");
                $('#alert-course-certification').html("User details successfully updated.");
                $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400); 
            }
        });
    }
});

function reload_registered_users_table()
{
    var academyId = $("input[name=academy]").val();

    if (academyId == 103)
    {
        var data_url  = "../content/ajax_itf_common.php?action=read_user_registered&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
        $("#registration_tbl").DataTable({
            destroy: true,
            "ajax": data_url,
            "pageLength": 10, 
            "responsive": true,
            dom: 'Bfrtip',
            buttons: [
                { extend: 'excel', className: 'btn-primary' },
                { 
                        extend: 'pdfHtml5', 
                        className: 'btn-dataTable', 
                        orientation: 'landscape',   
                        pageSize: 'LEGAL',
                        exportOptions: 
                        {
                            columns: [ 0, 1, 2, 3, 4, 5, 6 ]
                        }
                }                
            ],
            "columnDefs": [
                { "width": "9%", "targets": 7 },
                { "width": "10%", "targets": 6 }
            ],
            "initComplete" : function(){            
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }
        });
    }
    else
    {
        var data_url  = "../content/ajax_itf_common.php?action=read_user_registered&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
        $("#registration_tbl").DataTable({
            destroy: true,
            "ajax": data_url,
            "pageLength": 10, 
            "responsive": true,
            dom: 'Bfrtip',
            buttons: [
                { extend: 'excel', className: 'btn-primary' },
                { 
                        extend: 'pdfHtml5', 
                        className: 'btn-dataTable', 
                        orientation: 'landscape',   
                        pageSize: 'LEGAL',
                        exportOptions: 
                        {
                            columns: [ 0, 1, 2, 3, 4, 5, 6 ]
                        }
                }                
            ],
            "columnDefs": [
                { "width": "9%", "targets": 6 },
                { "width": "10%", "targets": 5 }
            ],
            "initComplete" : function(){            
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            }
        });
    }    
}

function deleteUserJoinCourses(join_id, user_id, course_id)
{
    var token  = $("input[name=token]").val();
    var action = 'delete_user_join_courses';

    var confirmation = confirm("Are you sure you want to delete this course?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action      : action,
                token       : token,
                join_id     : join_id,
                user_id     : user_id,
                course_id   : course_id
            },
            success: function (data)
            {
                $(".role-users-wrapper").empty();
                $(".role-users-wrapper").html(data);
                $('#existing_users_table_' + user_id).DataTable({                               
                    "responsive": true,
                    "pageLength": 5,
                    "columnDefs": [
                        { "width": "13%", "targets": 3 },
                        { "width": "13%", "targets": 4 },
                        { "width": "5%", "targets": 5 }
                    ],
                });
                cmsLoadingStatus = false; 
            }
        });
    }
}

function editUserSubscription(voucher_id, start_date, expiry_date, voucher_code, user_id)
{
    $('#edit-user-subscription-modal').remove();
    $('#create-user-subscription-modal').remove();
    var output = 
    '<div id="edit-user-subscription-modal" class="modal fade bd-example-modal-md" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-md" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">Edit User Subscription</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                        '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+

                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="subscription_start_date">Voucher Code : '+ voucher_code +'</label>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="subscription_start_date">Subscription Start Date</label>'+
                                '<div id="start_date_itf_reports_div" class="input-group date" data-provide="datepicker" data-date-format="dd-mm-yyyy" >'+
                                    '<input class="datepicker form-control" name="start-date" id="start_date_itf_reports" type="text" value="'+start_date+'"/>'+
                                    '<div class="input-group-addon">'+
                                        '<span class="glyphicon glyphicon-th"></span>'+
                                    '</div>'+
                                '</div>'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="subscription_expire_date">Subscription Expire Date</label>'+
                                '<div id="end_date_itf_reports_div" class="input-group date" data-provide="datepicker" data-date-format="dd-mm-yyyy" >'+
                                    '<input class="datepicker form-control" name="end-date" id="end_date_itf_reports" type="text" value="'+expiry_date+'"/>'+
                                    '<div class="input-group-addon">'+
                                        '<span class="glyphicon glyphicon-th"></span>'+
                                    '</div>'+
                                '</div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="alert alert-certifications" role="alert" id="alert-create_subscription"></div>'+

                '</div>'+
                '<div class="modal-footer">'+
                    '<button id="edit-subscription-btn" data-id="'+voucher_id+'" data-user-id="'+user_id+'" type="button" class="btn btn-primary">Save</button>'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#edit-user-subscription-modal').modal('show');
}

$(document).on('click', '#create-subscription-modal-btn', function() 
{
    var userId = $(this).attr("data-id");
   
    $('#create-user-subscription-modal').remove();
    $('#edit-user-subscription-modal').remove();
    var output = 
    '<div id="create-user-subscription-modal" class="modal fade bd-example-modal-md" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-md" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">Create User Subscription</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                        '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+

                    '<div class="row">'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="subscription_start_date">Subscription Start Date</label>'+
                                '<div id="start_date_itf_reports_div" class="input-group date" data-provide="datepicker" data-date-format="dd-mm-yyyy" >'+
                                    '<input class="datepicker form-control" name="start-date" id="start_date_itf_reports" type="text" value=""/>'+
                                    '<div class="input-group-addon">'+
                                        '<span class="glyphicon glyphicon-th"></span>'+
                                    '</div>'+
                                '</div>'+

                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="subscription_expire_date">Subscription Expire Date</label>'+
                                '<div id="end_date_itf_reports_div" class="input-group date" data-provide="datepicker" data-date-format="dd-mm-yyyy" >'+
                                    '<input class="datepicker form-control" name="end-date" id="end_date_itf_reports" type="text" value=""/>'+
                                    '<div class="input-group-addon">'+
                                        '<span class="glyphicon glyphicon-th"></span>'+
                                    '</div>'+
                                '</div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="alert alert-certifications" role="alert" id="alert-create_subscription"></div>'+

                '</div>'+                

                '<div class="modal-footer">'+
                    '<button id="create-subscription-btn" data-id="'+userId+'"  type="button" class="btn btn-primary">Create</button>'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#create-user-subscription-modal').modal('show');

    var d = new Date();
    var currMonth = d.getMonth();
    var currYear  = d.getFullYear();
    var currDate  = d.getDate();

    var startDate = new Date(currYear, currMonth, currDate);
    $('#start_date_itf_reports').datepicker();
    $("#start_date_itf_reports").datepicker("setDate", startDate);

    var endDate = new Date((currYear+1), currMonth, currDate);
    $('#end_date_itf_reports').datepicker();
    $("#end_date_itf_reports").datepicker("setDate", endDate);
});

$(document).on('click', '#create-subscription-btn', function() 
{
    var action    = 'create_user_subscription';
    var token     = $("input[name=token]").val();
    var academy   = $("input[name=academy]").val();
    var userId    = $(this).attr("data-id");
    var startDate = $("#start_date_itf_reports").val();
    var endDate   = $("#end_date_itf_reports").val()

    var dStartDate = new Date(startDate);
    var dEndDate   = new Date(endDate);

    if ((dEndDate.getTime() < dStartDate.getTime()) || (startDate === '') || (endDate === ''))
    {
        $('#alert-create_subscription').addClass("alert-danger");
        $('#alert-create_subscription').html("Error : Invalid Date!");
        $("#alert-create_subscription").fadeIn(300).delay(1500).fadeOut(400); 
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action      : action,
                token       : token,
                academy     : academy,
                user_id     : userId,
                course_id   : 877,
                start_date  : startDate,
                end_date    : endDate
            },
            success: function (data)
            {
                $('#create-user-subscription-modal').modal('toggle');
                $(".role-users-wrapper-subscription").empty();
                $(".role-users-wrapper-subscription").html(data);
                $('#existing_users_table_subs_' + userId).DataTable({                               
                    "responsive": true,
                    "order": [1, 'asc'],
                    "pageLength": 5,
                    "columnDefs": [
                        { "width": "13%", "targets": 3 }
                    ],
                });
                cmsLoadingStatus = false; 
            }
        });
    }
});

$(document).on('click', '#edit-subscription-btn', function() 
{
    var action    = 'edit_user_subscription';
    var token     = $("input[name=token]").val();
    var voucherId = $(this).attr("data-id");
    var userId    = $(this).attr("data-user-id");
    var startDate = $("#start_date_itf_reports").val();
    var endDate   = $("#end_date_itf_reports").val()

    var dStartDate = new Date(startDate);
    var dEndDate   = new Date(endDate);

    if ((dEndDate.getTime() < dStartDate.getTime()) || (startDate === '') || (endDate === ''))
    {
        $('#alert-create_subscription').addClass("alert-danger");
        $('#alert-create_subscription').html("Error : Invalid Date!");
        $("#alert-create_subscription").fadeIn(300).delay(1500).fadeOut(400); 
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action      : action,
                token       : token,
                voucher_id  : voucherId,
                start_date  : startDate,
                end_date    : endDate,
                user_id     : userId
            },
            success: function (data)
            {
                $('#edit-user-subscription-modal').modal('toggle');

                $(".role-users-wrapper-subscription").empty();
                $(".role-users-wrapper-subscription").html(data);
                $('#existing_users_table_subs_' + userId).DataTable({                               
                    "responsive": true,
                    "order": [1, 'asc'],
                    "pageLength": 5,
                    "columnDefs": [
                        { "width": "13%", "targets": 3 }
                    ],
                });

                cmsLoadingStatus = false; 
            }
        });
    }
});


$(document).on('click', '#generate_password_reset_link', function() 
{
    var action = 'read_password_reset_link';
    var token  = $("input[name=token]").val();
    var userId = $(this).attr("data-id");

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url : '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action  : action,
            token   : token,
            user_id : userId
        },
        success: function (data)
        {
            if (data == 'access-denied')
            {
                $('.utils').hide();
                $("#password-reset-link").val("");
                $('#alert-pw-reset-link').addClass("alert-danger");
                $('#alert-pw-reset-link').html("Error : Access Denied (Your IP address has been changed. Please login again!)");
                $("#alert-pw-reset-link").fadeIn(300).delay(4000).fadeOut(400);
            }
            else
            {
                $("#password-reset-link").val(data);
                $('.utils').show();
            }
            
            cmsLoadingStatus = false;
        }
    });
});

$(document).on('click', '#assign-course-modal-btn', function() 
{
    var userId = $(this).attr("data-id");
   
    $('#assign-course-modal').remove();
    var output = 
    '<div id="assign-course-modal" class="modal fade bd-example-modal-md" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-md" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">Assign Course</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                        '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="courses">Course</label>'+
                                '<select class="form-control" name="course-list" id="course-list">'+
                                '</select>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="alert alert-certifications" role="alert" id="alert-assign-users"></div>'+
                '</div>'+
                '<div class="modal-footer">'+
                    '<button id="assign-course-user-btn" data-id="'+userId+'"  type="button" class="btn btn-primary">Assign</button>'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#assign-course-modal').modal('show');

    loadCourseList(userId);
});

function loadCourseList(userId)
{
    cmsLoadingStatus = true;
    loadOverlay();
    var action   = "read_course_list";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action  : action,
            token   : token,
            academy : academy,
            user_id : userId
        },
        success: function(data)
        {
            $("#course-list").html(data); 
            cmsLoadingStatus = false;
        }
    });
}

$(document).on('click', '#assign-course-user-btn', function() 
{
    var action    = 'assign_course_to_user';
    var token     = $("input[name=token]").val();
    var userId    = $(this).attr("data-id");
    var courseId  = $("#course-list option:selected").val();

    if ((courseId === '') || (courseId === ''))
    {
        $('#alert-assign-users').addClass("alert-danger");
        $('#alert-assign-users').html("Error : Course not found!");
        $("#alert-assign-users").fadeIn(300).delay(1500).fadeOut(400); 
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action     : action,
                token      : token,
                user_id    : userId,
                course_id  : courseId
            },
            success: function (data)
            {
                $('#assign-course-modal').modal('toggle');
                $(".role-users-wrapper").empty();
                $(".role-users-wrapper").html(data);
                $('#existing_users_table_' + userId).DataTable({                               
                    "responsive": true,
                    "pageLength": 5,
                    "columnDefs": [
                        { "width": "13%", "targets": 3 },
                        { "width": "13%", "targets": 4 },
                        { "width": "5%", "targets": 5 }
                    ],
                });

                cmsLoadingStatus = false; 
            }
        });
    }
});

function copyTextValue(elementId) 
{
    var copyText = document.getElementById(""+elementId+"");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
}

function clearText(elementId)
{
    $("#"+elementId+"").val("");
    $('.utils').hide();

}

function setDefaultValues(staff_id, waos_account)
{
    $("#search-users-txt-"+staff_id).val("");
    if ((waos_account == undefined) || (waos_account == 'undefined'))
    {
        $("#waos_account-"+staff_id).hide();
    }

    $("#search-users-txt-"+staff_id).keyup(function (e) {

        var itemValue = $("#search-users-txt-"+staff_id).val();

        if (e.which == 13) return false;
        if (itemValue.trim() != "")
        {
            $("#search-users-txt-btn"+staff_id).prop("disabled", false);
        }
        else
        {
            $("#search-users-txt-btn"+staff_id).prop("disabled", true);
        }
    });

    if ($(".staff_types").length)
    {
        $("#staff_types-"+staff_id).select2({
            placeholder: 'Please select...',
            theme: 'bootstrap-5',
            dropdownParent: $('#edit-staff-model-'+staff_id+' .modal-body')
        });
    }
}

function setDefaultValuesforFormFields(value)
{
    if ((value === '') || (value === null) || (value === undefined) || (value === 'undefined'))
    {
        value = '';
    }
    return value;
}

$(document).on('click', '#whitelabel_config_save_btn', function() 
{
    cmsLoadingStatus = true;
    loadOverlay();

    var action        = 'update_academy_whitelabel_configurations';
    var ptToken       = $("input[name=token]").val();
    var academy       = $("input[name=academy]").val();
    var id            = $("input[name=id]").val();
    var sub_academy   = $("input[name=sub_academy]").val();
    var is_super_user = $("input[name=is_super_user]").val();

    var primary_color   = setDefaultValuesforFormFields($("input[name=primary_color]").val());
    var secondary_color = setDefaultValuesforFormFields($("input[name=secondary_color]").val());
    var heading_color   = setDefaultValuesforFormFields($("input[name=heading_color]").val());

    var header_background_color = setDefaultValuesforFormFields($("input[name=header_background_color]").val());
    var header_nav_color        = setDefaultValuesforFormFields($("input[name=header_nav_color]").val());
    var body_font_color         = setDefaultValuesforFormFields($("input[name=body_font_color]").val());

    var banner_caption_bg_color      = setDefaultValuesforFormFields($("input[name=banner_caption_bg_color]").val());
    var banner_caption_heading_color = setDefaultValuesforFormFields($("input[name=banner_caption_heading_color]").val());
    var banner_caption_color         = setDefaultValuesforFormFields($("input[name=banner_caption_color]").val());

    var section_title_background_color = setDefaultValuesforFormFields($("input[name=section_title_background_color]").val());
    var section_title_color            = setDefaultValuesforFormFields($("input[name=section_title_color]").val());
    var login_background               = setDefaultValuesforFormFields($("input[name=login_background]").val());

    var login_link_colour       = setDefaultValuesforFormFields($("input[name=login_link_colour]").val());
    var login_link_hover        = setDefaultValuesforFormFields($("input[name=login_link_hover]").val());
    var btn_background_colour   = setDefaultValuesforFormFields($("input[name=btn_background_colour]").val());

    var btn_colour              = setDefaultValuesforFormFields($("input[name=btn_colour]").val());
    var btn_background_hover    = setDefaultValuesforFormFields($("input[name=btn_background_hover]").val());
    var btn_hover_colour        = setDefaultValuesforFormFields($("input[name=btn_hover_colour]").val());

    var loggedin_header_backround   = setDefaultValuesforFormFields($("input[name=loggedin_header_backround]").val());
    var loggedin_header_link_colour = setDefaultValuesforFormFields($("input[name=loggedin_header_link_colour]").val());
    var loggedin_header_link_hover  = setDefaultValuesforFormFields($("input[name=loggedin_header_link_hover]").val());

    var heading_font_family = setDefaultValuesforFormFields($("input[name=heading_font_family]").val());
    var heading_font_size   = setDefaultValuesforFormFields($("input[name=heading_font_size]").val());
    var heading_font_link   = setDefaultValuesforFormFields($("input[name=heading_font_link]").val());
    var body_font_family    = setDefaultValuesforFormFields($("input[name=body_font_family]").val());
    var body_font_size      = setDefaultValuesforFormFields( $("input[name=body_font_size]").val());
    var body_font_link      = setDefaultValuesforFormFields($("input[name=body_font_link]").val());
   
    var section_one_title_en    = setDefaultValuesforFormFields($("input[name=section_one_title_en]").val());
    var section_one_title_es    = setDefaultValuesforFormFields($("input[name=section_one_title_es]").val());
    var section_one_title_fr    = setDefaultValuesforFormFields($("input[name=section_one_title_fr]").val());
    var section_one_title_ru    = setDefaultValuesforFormFields($("input[name=section_one_title_ru]").val());
    var section_one_title_ko    = setDefaultValuesforFormFields($("input[name=section_one_title_ko]").val());
    var section_one_title_zhcn  = setDefaultValuesforFormFields($("input[name=section_one_title_zhcn]").val());
    var section_one_title_lb    = setDefaultValuesforFormFields($("input[name=section_one_title_lb]").val());
    var section_one_title_sv    = setDefaultValuesforFormFields($("input[name=section_one_title_sv]").val());
    var section_one_title_cs    = setDefaultValuesforFormFields($("input[name=section_one_title_cs]").val());
    var section_one_title_it    = setDefaultValuesforFormFields($("input[name=section_one_title_it]").val());
    var section_one_title_de    = setDefaultValuesforFormFields($("input[name=section_one_title_de]").val());
    var section_one_title_th    = setDefaultValuesforFormFields($("input[name=section_one_title_th]").val());
    var section_one_title_sk    = setDefaultValuesforFormFields($("input[name=section_one_title_sk]").val());
    var section_one_title_el    = setDefaultValuesforFormFields($("input[name=section_one_title_el]").val());
    var section_one_title_fa    = setDefaultValuesforFormFields($("input[name=section_one_title_fa]").val());

    var section_one_content_en    = setDefaultValuesforFormFields($("textarea[name=section_one_content_en]").val());
    var section_one_content_es    = setDefaultValuesforFormFields($("textarea[name=section_one_content_es]").val());
    var section_one_content_fr    = setDefaultValuesforFormFields($("textarea[name=section_one_content_fr]").val());
    var section_one_content_ru    = setDefaultValuesforFormFields($("textarea[name=section_one_content_ru]").val());
    var section_one_content_ko    = setDefaultValuesforFormFields($("textarea[name=section_one_content_ko]").val());
    var section_one_content_zhcn  = setDefaultValuesforFormFields($("textarea[name=section_one_content_zhcn]").val());
    var section_one_content_lb    = setDefaultValuesforFormFields($("textarea[name=section_one_content_lb]").val());
    var section_one_content_sv    = setDefaultValuesforFormFields($("textarea[name=section_one_content_sv]").val());
    var section_one_content_cs    = setDefaultValuesforFormFields($("textarea[name=section_one_content_cs]").val());
    var section_one_content_it    = setDefaultValuesforFormFields($("textarea[name=section_one_content_it]").val());
    var section_one_content_de    = setDefaultValuesforFormFields($("textarea[name=section_one_content_de]").val());
    var section_one_content_th    = setDefaultValuesforFormFields($("textarea[name=section_one_content_th]").val());
    var section_one_content_sk    = setDefaultValuesforFormFields($("textarea[name=section_one_content_sk]").val());
    var section_one_content_el    = setDefaultValuesforFormFields($("textarea[name=section_one_content_el]").val());
    var section_one_content_fa    = setDefaultValuesforFormFields($("textarea[name=section_one_content_fa]").val());

    var about_us_title_en    = setDefaultValuesforFormFields($("input[name=about_us_title_en]").val());
    var about_us_title_es    = setDefaultValuesforFormFields($("input[name=about_us_title_es]").val());
    var about_us_title_fr    = setDefaultValuesforFormFields($("input[name=about_us_title_fr]").val());
    var about_us_title_ru    = setDefaultValuesforFormFields($("input[name=about_us_title_ru]").val());
    var about_us_title_ko    = setDefaultValuesforFormFields($("input[name=about_us_title_ko]").val());
    var about_us_title_zhcn  = setDefaultValuesforFormFields($("input[name=about_us_title_zhcn]").val());
    var about_us_title_lb    = setDefaultValuesforFormFields($("input[name=about_us_title_lb]").val());
    var about_us_title_sv    = setDefaultValuesforFormFields($("input[name=about_us_title_sv]").val());
    var about_us_title_cs    = setDefaultValuesforFormFields($("input[name=about_us_title_cs]").val());
    var about_us_title_it    = setDefaultValuesforFormFields($("input[name=about_us_title_it]").val());
    var about_us_title_de    = setDefaultValuesforFormFields($("input[name=about_us_title_de]").val());
    var about_us_title_th    = setDefaultValuesforFormFields($("input[name=about_us_title_th]").val());
    var about_us_title_sk    = setDefaultValuesforFormFields($("input[name=about_us_title_sk]").val());
    var about_us_title_el    = setDefaultValuesforFormFields($("input[name=about_us_title_el]").val());
    var about_us_title_fa    = setDefaultValuesforFormFields($("input[name=about_us_title_fa]").val());

    var about_us_content_en    = setDefaultValuesforFormFields($("textarea[name=about_us_content_en]").val());
    var about_us_content_es    = setDefaultValuesforFormFields($("textarea[name=about_us_content_es]").val());
    var about_us_content_fr    = setDefaultValuesforFormFields($("textarea[name=about_us_content_fr]").val());
    var about_us_content_ru    = setDefaultValuesforFormFields($("textarea[name=about_us_content_ru]").val());
    var about_us_content_ko    = setDefaultValuesforFormFields($("textarea[name=about_us_content_ko]").val());
    var about_us_content_zhcn  = setDefaultValuesforFormFields($("textarea[name=about_us_content_zhcn]").val());
    var about_us_content_lb    = setDefaultValuesforFormFields($("textarea[name=about_us_content_lb]").val());
    var about_us_content_sv    = setDefaultValuesforFormFields($("textarea[name=about_us_content_sv]").val());
    var about_us_content_cs    = setDefaultValuesforFormFields($("textarea[name=about_us_content_cs]").val());
    var about_us_content_it    = setDefaultValuesforFormFields($("textarea[name=about_us_content_it]").val());
    var about_us_content_de    = setDefaultValuesforFormFields($("textarea[name=about_us_content_de]").val());
    var about_us_content_th    = setDefaultValuesforFormFields($("textarea[name=about_us_content_th]").val());
    var about_us_content_sk    = setDefaultValuesforFormFields($("textarea[name=about_us_content_sk]").val());
    var about_us_content_el    = setDefaultValuesforFormFields($("textarea[name=about_us_content_el]").val());
    var about_us_content_fa    = setDefaultValuesforFormFields($("textarea[name=about_us_content_fa]").val());

    var url_name               = $("input[name=url_name_en]").val();
    var url_name_es            = $("input[name=url_name_es]").val();
    var url_name_fr            = $("input[name=url_name_fr]").val();
    var url_name_ru            = $("input[name=url_name_ru]").val();
    var url_name_de            = $("input[name=url_name_de]").val();
   

    var url                    = $("input[name=url]").val();

    var logo                           = document.querySelector('input[name="logo"]').files[0];
    var logo_current                   = $("input[name=logo_current]").val();
    var logo_alt                       = $("input[name=logo_alt]").val();

    var secondary_logo                 = document.querySelector('input[name="secondary_logo"]').files[0];
    var secondary_logo_current         = $("input[name=secondary_logo_current]").val();
    var secondary_logo_alt              = $("input[name=secondary_logo_alt]").val();

    var favicon                        = document.querySelector('input[name="favicon"]').files[0];
    var favicon_current                = $("input[name=favicon_current]").val();

    var section_one_bg_image           = document.querySelector('input[name="section_one_bg_image"]').files[0];
    var section_one_bg_image_current   = $("input[name=section_one_bg_image_current]").val();
    var section_one_bg_image_alt       = $("input[name=section_one_bg_image_alt]").val();
    
    var section_two_bg_image           = document.querySelector('input[name="section_two_bg_image"]').files[0];
    var section_two_bg_image_current   = $("input[name=section_two_bg_image_current]").val();
    var section_two_bg_image_alt       = $("input[name=section_one_bg_image_alt]").val();

    var section_three_bg_image         = document.querySelector('input[name="section_three_bg_image"]').files[0];
    var section_three_bg_image_current = $("input[name=section_three_bg_image_current]").val();
    var section_three_bg_image_alt       = $("input[name=section_three_bg_image_alt]").val();
    
    var about_us_image                 = document.querySelector('input[name="about_us_image"]').files[0];
    var about_us_image_current         = $("input[name=about_us_image_current]").val();
    var about_us_image_alt              = $("input[name=about_us_image_alt]").val();

    var loggedin_sidebar_bg            = setDefaultValuesforFormFields($("input[name=loggedin_sidebar_bg]").val());
    var loggedin_sidebar_colour        = setDefaultValuesforFormFields($("input[name=loggedin_sidebar_colour]").val());
    var loggedin_sidebar_svg           = setDefaultValuesforFormFields($("input[name=loggedin_sidebar_svg]").val());
    var loggedin_sidebar_hover         = setDefaultValuesforFormFields($("input[name=loggedin_sidebar_hover]").val());
    var loggedin_sidebar_hover_svg     = setDefaultValuesforFormFields($("input[name=loggedin_sidebar_hover_svg]").val());
    var overall_theme                  = setDefaultValuesforFormFields($("#overall_theme").prop('checked'));

    var terms_id           = $("input[name=terms_id]").val();
    var terms_text         = setDefaultValuesforFormFields($("textarea[name=terms_text]").val());
    var lang_options_terms = $("#lang_options_terms option:selected").val();

    var privacy_terms_id   = $("input[name=privacy_terms_id]").val();
    var privacy_terms_text = setDefaultValuesforFormFields($("textarea[name=privacy_terms_text]").val());
    var lang_options_privacy_terms = $("#lang_options_privacy_terms option:selected").val();

    var course_terms_id    = $("input[name=course_terms_id]").val();
    var course_terms_text  = setDefaultValuesforFormFields($("textarea[name=course_terms_text]").val());
    var lang_options_course_terms = $("#lang_options_course_terms option:selected").val();
   
    var content_types = [];     
    $('input[name="content_types[]"]:checked').each(function() {
           content_types.push(this.value);
    });

    var section_two_title_en            = setDefaultValuesforFormFields($("input[name=section_two_title_en]").val());
    var section_two_content_en          = setDefaultValuesforFormFields($("textarea[name=section_two_content_en]").val());
    var section_two_title_es           = setDefaultValuesforFormFields($("input[name=section_two_title_es]").val());
    var section_two_content_es          = setDefaultValuesforFormFields($("textarea[name=section_two_content_es]").val());    
    var section_two_title_fr            = setDefaultValuesforFormFields($("input[name=section_two_title_fr]").val());
    var section_two_content_fr          = setDefaultValuesforFormFields($("textarea[name=section_two_content_fr]").val());
    var section_two_title_de            = setDefaultValuesforFormFields($("input[name=section_two_title_de]").val());
    var section_two_content_de          = setDefaultValuesforFormFields($("textarea[name=section_two_content_de]").val()); 
    var section_two_title_ru            = setDefaultValuesforFormFields($("input[name=section_two_title_ru]").val());
    var section_two_content_ru          = setDefaultValuesforFormFields($("textarea[name=section_two_content_ru]").val());
    var section_two_title_zhcn          = setDefaultValuesforFormFields($("input[name=section_two_title_zhcn]").val());
    var section_two_content_zhcn        = setDefaultValuesforFormFields($("textarea[name=section_two_content_zhcn]").val());

    var section_three_title_en          = setDefaultValuesforFormFields($("input[name=section_three_title_en]").val());
    var section_three_content_en        = setDefaultValuesforFormFields($("textarea[name=section_three_content_en]").val()); 
    var section_three_title_es          = setDefaultValuesforFormFields($("input[name=section_three_title_es]").val());
    var section_three_content_es        = setDefaultValuesforFormFields($("textarea[name=section_three_content_es]").val());
    var section_three_title_fr          = setDefaultValuesforFormFields($("input[name=section_three_title_fr]").val());
    var section_three_content_fr        = setDefaultValuesforFormFields($("textarea[name=section_three_content_fr]").val());
    var template                        = $('[name="white-label-templates"]:checked').val();
    var section_three_title_de          = setDefaultValuesforFormFields($("input[name=section_three_title_de]").val());
    var section_three_content_de        = setDefaultValuesforFormFields($("textarea[name=section_three_content_de]").val());

    if ((is_super_user == 1) && (template == "Whiteley")) {

        if (('input[name="banner_one_image"]').length) {

            var banner_one_image            = document.querySelector('input[name="banner_one_image"]').files[0];
            var banner_one_image_current    = $("input[name=banner_one_image_current]").val();
            var banner_two_image            = document.querySelector('input[name="banner_two_image"]').files[0];
            var banner_two_image_current    = $("input[name=banner_two_image_current]").val(); 
            var banner_three_image          = document.querySelector('input[name="banner_three_image"]').files[0];
            var banner_three_image_current  = $("input[name=banner_three_image_current]").val();
            var banner_four_image           = document.querySelector('input[name="banner_four_image"]').files[0];
            var banner_four_image_current   = $("input[name=banner_four_image_current]").val();    
        }
        
    }

    var banner_one_title            = $("input[name=banner_one_title]").val();
    
    var banner_one_description      = $("input[name=banner_one_description]").val();
    var banner_two_title            = $("input[name=banner_two_title]").val();
    var banner_two_description      = $("input[name=banner_two_description]").val();
    var banner_three_title          = $("input[name=banner_three_title]").val();
    var banner_three_description    = setDefaultValuesforFormFields($("input[name=banner_three_description]").val());
    var banner_four_title           = setDefaultValuesforFormFields($("input[name=banner_four_title]").val());
    var banner_four_description     = setDefaultValuesforFormFields($("input[name=banner_four_description]").val());

    var hasF2fHome                  = setDefaultValuesforFormFields($("#has_f2f_home_page").prop('checked'));
    var hasOnlineHome               = setDefaultValuesforFormFields($("#has_online_course_home_page").prop('checked'));
    var hasPathwayHome              = setDefaultValuesforFormFields($("#has_pathway_home_page").prop('checked'));
    var hasContentHome              = setDefaultValuesforFormFields($("#has_content_library_home_page").prop('checked'));

    var banner_one_image_alt            = $("input[name=banner_one_image_alt]").val();
    var banner_two_image_alt            = $("input[name=banner_two_image_alt]").val();
    var banner_three_image_alt          = $("input[name=banner_three_image_alt]").val();
    var banner_four_image_alt           = $("input[name=banner_four_image_alt]").val();

    var section_four_title_en            = setDefaultValuesforFormFields($("textarea[name=section_four_title_en]").val());
    var section_four_content_en          = setDefaultValuesforFormFields($("textarea[name=section_four_content_en]").val());
    var section_four_title_es           = setDefaultValuesforFormFields($("textarea[name=section_four_title_es]").val());
    var section_four_content_es          = setDefaultValuesforFormFields($("textarea[name=section_four_content_es]").val());  
   
    var formData = new FormData();
    formData.append('action', action);
    formData.append('ptToken', ptToken);
    formData.append('academy_id', academy);
    formData.append('id', id);
    formData.append('sub_academy', sub_academy);     

    formData.append('overall_theme', overall_theme);
    formData.append('primary_color', primary_color);
    formData.append('secondary_color', secondary_color);
    formData.append('heading_color', heading_color);

    formData.append('header_background_color', header_background_color);
    formData.append('header_nav_color', header_nav_color);
    formData.append('body_font_color', body_font_color);

    formData.append('banner_caption_bg_color', banner_caption_bg_color);
    formData.append('banner_caption_heading_color', banner_caption_heading_color);
    formData.append('banner_caption_color', banner_caption_color);

    formData.append('section_title_background_color', section_title_background_color);
    formData.append('section_title_color', section_title_color);
    formData.append('heading_font_family', heading_font_family);

    formData.append('heading_font_size', heading_font_size);
    formData.append('heading_font_link', heading_font_link);
    formData.append('body_font_family', body_font_family);

    formData.append('body_font_size', body_font_size);
    formData.append('body_font_link', body_font_link);
    formData.append('login_background', login_background);

    formData.append('login_link_colour', login_link_colour);
    formData.append('login_link_hover', login_link_hover);
    formData.append('btn_background_colour', btn_background_colour);

    formData.append('btn_colour', btn_colour);
    formData.append('btn_background_hover', btn_background_hover);
    formData.append('btn_hover_colour', btn_hover_colour);

    formData.append('loggedin_header_backround', loggedin_header_backround);
    formData.append('loggedin_header_link_colour', loggedin_header_link_colour);
    formData.append('loggedin_header_link_hover', loggedin_header_link_hover);

    formData.append('section_one_title_en', section_one_title_en);
    formData.append('section_one_title_es', section_one_title_es);
    formData.append('section_one_title_fr', section_one_title_fr);
    formData.append('section_one_title_ko', section_one_title_ko);
    formData.append('section_one_title_ru', section_one_title_ru);
    formData.append('section_one_title_zhcn', section_one_title_zhcn);
    formData.append('section_one_title_lb', section_one_title_lb);
    formData.append('section_one_title_sv', section_one_title_sv);
    formData.append('section_one_title_cs', section_one_title_cs);  
    formData.append('section_one_title_it', section_one_title_it);
    formData.append('section_one_title_de', section_one_title_de);
    formData.append('section_one_title_th', section_one_title_th); 
    formData.append('section_one_title_sk', section_one_title_sk);  
    formData.append('section_one_title_el', section_one_title_el); 
    formData.append('section_one_title_fa', section_one_title_fa);
   
    formData.append('section_one_content_en', section_one_content_en);
    formData.append('section_one_content_es', section_one_content_es);
    formData.append('section_one_content_fr', section_one_content_fr);
    formData.append('section_one_content_ko', section_one_content_ko);
    formData.append('section_one_content_ru', section_one_content_ru);
    formData.append('section_one_content_zhcn', section_one_content_zhcn);
    formData.append('section_one_content_lb', section_one_content_lb);
    formData.append('section_one_content_sv', section_one_content_sv); 
    formData.append('section_one_content_cs', section_one_content_cs);
    formData.append('section_one_content_it', section_one_content_it); 
    formData.append('section_one_content_de', section_one_content_de);
    formData.append('section_one_content_th', section_one_content_th);
    formData.append('section_one_content_sk', section_one_content_sk);
    formData.append('section_one_content_el', section_one_content_el);
    formData.append('section_one_content_fa', section_one_content_fa);

    formData.append('about_us_title_en', about_us_title_en);
    formData.append('about_us_title_es', about_us_title_es);
    formData.append('about_us_title_fr', about_us_title_fr);
    formData.append('about_us_title_ko', about_us_title_ko);
    formData.append('about_us_title_ru', about_us_title_ru);
    formData.append('about_us_title_zhcn', about_us_title_zhcn);
    formData.append('about_us_title_lb', about_us_title_lb);
    formData.append('about_us_title_sv', about_us_title_sv);
    formData.append('about_us_title_cs', about_us_title_cs);
    formData.append('about_us_title_it', about_us_title_it);
    formData.append('about_us_title_de', about_us_title_de);
    formData.append('about_us_title_th', about_us_title_th); 
    formData.append('about_us_title_sk', about_us_title_sk);
    formData.append('about_us_title_el', about_us_title_el);
    formData.append('about_us_title_fa', about_us_title_fa);    
   
    formData.append('about_us_content_en', about_us_content_en);
    formData.append('about_us_content_es', about_us_content_es);
    formData.append('about_us_content_fr', about_us_content_fr);
    formData.append('about_us_content_ko', about_us_content_ko);
    formData.append('about_us_content_ru', about_us_content_ru);
    formData.append('about_us_content_zhcn', about_us_content_zhcn);
    formData.append('about_us_content_lb', about_us_content_lb);
    formData.append('about_us_content_sv', about_us_content_sv);
    formData.append('about_us_content_cs', about_us_content_cs);
    formData.append('about_us_content_it', about_us_content_it); 
    formData.append('about_us_content_de', about_us_content_de);
    formData.append('about_us_content_th', about_us_content_th);
    formData.append('about_us_content_sk', about_us_content_sk);
    formData.append('about_us_content_el', about_us_content_el);
    formData.append('about_us_content_fa', about_us_content_fa);

    formData.append('url_name', url_name);
    formData.append('url_name_es', url_name_es);
    formData.append('url_name_fr', url_name_fr);
    formData.append('url_name_ru', url_name_ru);
    formData.append('url_name_de', url_name_de);

    formData.append('url', url);

    formData.append('file', logo);
    formData.append('logo_current', logo_current);

    formData.append('secondary_logo', secondary_logo);
    formData.append('secondary_logo_current', secondary_logo_current);

    formData.append('favicon', favicon);
    formData.append('favicon_current', favicon_current);

    formData.append('section_one_bg_image', section_one_bg_image);
    formData.append('section_one_bg_image_current', section_one_bg_image_current);

    formData.append('section_two_bg_image', section_two_bg_image);
    formData.append('section_two_bg_image_current', section_two_bg_image_current);

    formData.append('section_three_bg_image', section_three_bg_image);
    formData.append('section_three_bg_image_current', section_three_bg_image_current);

    formData.append('about_us_image', about_us_image);
    formData.append('about_us_image_current', about_us_image_current);

    formData.append('loggedin_sidebar_bg', loggedin_sidebar_bg);
    formData.append('loggedin_sidebar_colour', loggedin_sidebar_colour);
    formData.append('loggedin_sidebar_svg', loggedin_sidebar_svg);
    formData.append('loggedin_sidebar_hover', loggedin_sidebar_hover);
    formData.append('loggedin_sidebar_hover_svg', loggedin_sidebar_hover_svg);

    formData.append('content_types', content_types);

    formData.append('terms_id', terms_id);
    formData.append('terms_text', terms_text);
    formData.append('lang_options_terms', lang_options_terms);
    
    formData.append('privacy_terms_id', privacy_terms_id);
    formData.append('privacy_terms_text', privacy_terms_text);
    formData.append('lang_options_privacy_terms', lang_options_privacy_terms);

    formData.append('course_terms_id', course_terms_id);
    formData.append('course_terms_text', course_terms_text);
    formData.append('lang_options_course_terms', lang_options_course_terms);

    formData.append('section_two_title_en', section_two_title_en);
    formData.append('section_two_content_en', section_two_content_en);
    formData.append('section_two_title_es', section_two_title_es);
    formData.append('section_two_content_es', section_two_content_es);
    formData.append('section_two_title_fr', section_two_title_fr);
    formData.append('section_two_content_fr', section_two_content_fr);
    formData.append('section_two_title_de', section_two_title_de);
    formData.append('section_two_content_de', section_two_content_de);
    formData.append('section_two_title_ru', section_two_title_ru);
    formData.append('section_two_content_ru', section_two_content_ru);
    formData.append('section_two_title_zhcn', section_two_title_zhcn);
    formData.append('section_two_content_zhcn', section_two_content_zhcn);

    formData.append('section_three_title_en', section_three_title_en);
    formData.append('section_three_content_en', section_three_content_en);
    formData.append('section_three_title_es', section_three_title_es);
    formData.append('section_three_content_es', section_three_content_es);
    formData.append('section_three_title_fr', section_three_title_fr);
    formData.append('section_three_content_fr', section_three_content_fr);
    formData.append('section_three_title_de', section_three_title_de);
    formData.append('section_three_content_de', section_three_content_de);

    
    formData.append('banner_one_image', banner_one_image);
    formData.append('banner_one_image_current', banner_one_image_current);
    formData.append('banner_two_image', banner_two_image);
    formData.append('banner_two_image_current', banner_two_image_current);
    formData.append('banner_three_image', banner_three_image);
    formData.append('banner_three_image_current', banner_three_image_current);
    formData.append('banner_four_image', banner_four_image);
    formData.append('banner_four_image_current', banner_four_image_current);

    formData.append('banner_one_title', banner_one_title);
    formData.append('banner_one_description', banner_one_description);
    formData.append('banner_two_title', banner_two_title);
    formData.append('banner_two_description', banner_two_description);
    formData.append('banner_three_title', banner_three_title);
    formData.append('banner_three_description', banner_three_description);
    formData.append('banner_four_title', banner_four_title);
    formData.append('banner_four_description', banner_four_description);   

    formData.append('template', template);
    formData.append('has_f2f_home_page', hasF2fHome);
    formData.append('has_content_library_home_page', hasContentHome);
    formData.append('has_pathway_home_page', hasPathwayHome);
    formData.append('has_online_course_home_page', hasOnlineHome);
    formData.append('banner_one_image_alt', banner_one_image_alt);
    formData.append('banner_two_image_alt', banner_two_image_alt);
    formData.append('banner_three_image_alt', banner_three_image_alt);
    formData.append('banner_four_image_alt', banner_four_image_alt);

    formData.append('logo_alt', logo_alt);
    formData.append('secondary_logo_alt', secondary_logo_alt);
    formData.append('section_one_bg_image_alt', section_one_bg_image_alt);
    formData.append('section_two_bg_image_alt', section_two_bg_image_alt);
    formData.append('section_three_bg_image_alt', section_three_bg_image_alt);
    formData.append('about_us_image_alt', about_us_image_alt);

    formData.append('section_four_title_en', section_four_title_en);
    formData.append('section_four_content_en', section_four_content_en);
    formData.append('section_four_title_es', section_four_title_es);
    formData.append('section_four_content_es', section_four_content_es);

    
    $.ajax({
        url: '../cms/ajax_cms.php',
        type: "post",
        dataType: "json",
        data: formData,
        contentType: false,
        cache: false,
        processData:false,
        success: function(data)
        {
            var newTermsId = data.result_terms[0];
            if (terms_id == '')
            {
                $("input[name=terms_id]").val(newTermsId);
            }

            var newPrivacyTermsId = data.result_privacy_terms[0];
            if (privacy_terms_id == '')
            {
                $("input[name=privacy_terms_id]").val(newPrivacyTermsId);
            }

            var newCourseTermsId = data.result_course_terms[0];
            if (course_terms_id == '')
            {
                $("input[name=course_terms_id]").val(newCourseTermsId);
            }

            $('#alert-whitlelabel').addClass("alert-success");

            if (id == '')
            {
                $('#alert-whitlelabel').html("Configurations successfully inserted!");
            }
            else
            {                
                $('#alert-whitlelabel').html("Configurations successfully updated!");
            }           

            $("#alert-whitlelabel").fadeIn(300).delay(1500).fadeOut(400);          
            location.reload();
            cmsLoadingStatus = false;        
        }
    });
});

$(document).on('click', '.edit-custom-text', function() {
    var entryId             = $(this).attr("data-entry-id");
    var override_entry_id   = $(this).attr("data-content-id");
    editCustomText(entryId, override_entry_id);
});

function editCustomText(entryId, override_entry_id)
{
    $('#edit-custom_text-modal').remove();

    if ((override_entry_id == '') || (override_entry_id == null) || (override_entry_id == 0))
    {
        var title = "Add Custom Text";
    }
    else
    {
        var title = "Edit Custom Text";
    }

    var languageList = {'en':'English', 'ru':'Russian', 'fr':'French', 'es':'Spanish', 'ar':'Arabic', 'zhcn':'Chinese', 'ja':'Japanese', 
    'pt':'Portuguese', 'vi':'Vietnamese', 'ko':'Korean', 'lb':'Luxembourgish', 'sv':'Swedish', 'in':'Indonesian', 'tr':'Turkish', 'th':'Thai', 'sk':'Slovak', 'el':'Greek', 'fa':'Persian', 'it':'Italian'};
    var formField    = ''; 

    Object.keys(languageList).forEach(function(key) {
        var value = languageList[key];
        formField +=    '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label>'+value+'</label>'+
                                '<input type="text" class="form-control" id="'+key+'_custom_text"/>'+
                                '<div id="'+key+'_default_text" style="color: #666;"></div>'+
                            '</div>'+
                        '</div>';
    });

    var output = 
    '<div id="edit-custom_text-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-lg" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">'+title+'</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'
                        + formField +
                    '</div>'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<input type="hidden" id="entryId" value="'+entryId+'">'+
                            '<input type="hidden" id="override_entry_id" value="'+override_entry_id+'">'+
                        '</div>'+                       
                    '</div>'+

                    '<div class="alert alert-certifications" role="alert" id="alert-course-certification"></div>'+                    

                '</div>'+
                '<div class="modal-footer">'+
                    '<button id="update-custom-text-btn" type="button" class="btn btn-primary">Save</button>'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#edit-custom_text-modal').modal('show');
    loadCustomTextData(entryId, override_entry_id);
}

function loadCustomTextData(entryId, override_entry_id)
{
    cmsLoadingStatus = true;
    loadOverlay();
    var action   = "read_custom_text_data";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    $.ajax({
        url: '../cms/ajax_cms.php',
        dataType: "json",
        data: {
            action   : action,
            ptToken  : token,
            academy  : academy,
            entry_id : entryId,
            override_entry_id : override_entry_id
        },
        success: function(data)
        {
            var defaultEntries = data.default[0];
            var customEntries  = data.custom[0];
            var languageList   = ['en', 'ru', 'fr', 'es', 'ar', 'zhcn', 'ja', 'pt', 'vi', 'ko', 'lb', 'sv', 'in', 'tr', 'th', 'sk', 'el', 'fa', 'it'];

            for (var i = 0; i < languageList.length; i++)
            {
                if (defaultEntries.length > 0)
                {
                    var textEntryDefault = defaultEntries[0][languageList[i]];
                    if (textEntryDefault == null)
                    {
                        textEntryDefault = '';
                    }
                    $('#'+languageList[i]+'_default_text').html("Default : " + textEntryDefault);
                }

                if (customEntries.length > 0)
                {
                    var customEntryDefault = customEntries[0][languageList[i]];
                    if (customEntryDefault == null)
                    {
                        customEntryDefault = '';
                    }
                    $('#'+languageList[i]+'_custom_text').val(customEntryDefault);
                }
            }
            
            cmsLoadingStatus = false;
        }
    });
}

$(document).on('click', '#update-custom-text-btn', function() 
{
    var token             = $("input[name=token]").val();
    var academyId         = $("input[name=academy]").val();
    var entryId           = $("#entryId").val();
    var override_entry_id = $("#override_entry_id").val();
    var en_entry          = $('#en_custom_text').val();
    var languageList      = ['en', 'ru', 'fr', 'es', 'ar', 'zhcn', 'ja', 'pt', 'vi', 'ko', 'lb', 'sv', 'in', 'tr', 'th', 'sk', 'el', 'fa', 'it'];

    if ((override_entry_id != '') && (override_entry_id != null) && (override_entry_id != 0))
    {
        var action = "edit_custom_generic_text";
    }
    else
    {
        var action = "add_custom_generic_text";
    }

    $('#alert-course-certification').removeClass("alert-danger");
    $('#alert-course-certification').removeClass("alert-success");

    if ((en_entry == '') || (en_entry == null))
    {
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : English entry is not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        var formData = new FormData();
        formData.append('action', action);
        formData.append('ptToken', token);
        formData.append('academy', academyId);
        formData.append('entry_id', entryId);
        formData.append('override_entry_id', override_entry_id);

        for (var i = 0; i < languageList.length; i++)
        {
            formData.append(languageList[i], $('#'+languageList[i]+'_custom_text').val());
        }
        
        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData,
            success: function(data)
            {
                cmsLoadingStatus = false;
                reload_terminology_table();   

                $('#alert-course-certification').addClass("alert-success");
                if (override_entry_id != '')
                {
                    $('#alert-course-certification').html("Terminology successfully updated.");
                }
                else
                {
                    $('#alert-course-certification').html("Terminology successfully added.");
                    $('#edit-custom_text-modal').modal('toggle');
                }
                $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400); 
            }
        });
    }
});

function reload_terminology_table()
{
    var data_url = "../cms/ajax_cms.php?action=read_custom_generic_text&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $("#terminology_cofig_tbl").DataTable({
        destroy: true,
        "order": [],
        "ajax": data_url,
        "deferRender" : true,
        "pageLength": 10,
        "initComplete" : function(){
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }
    });
}

function waosColouredCourseLabels(arr) {
  let label = '';
  if (arr === 'Attendance') {
    label = `<span class="badge badge-warning">${arr}</span>`;
  } else if (arr === 'Assessment') {
    label = `<span class="badge badge-info">${arr}</span>`;
  } else if ((arr === 'Published') || (arr === 'Yes')) {
    label = `<span class="badge badge-success">${arr}</span>`;
  } else if ((arr === 'Not Published') || (arr === 'No') || (arr === 'Un-Published')) {
    label = `<span class="badge badge-danger">${arr}</span>`;
  }
  return label;
}

$(document).bind('enterKeyEducation', '#search_course_text', function(e) 
{
    cmsLoadingStatus = true;
    loadOverlay();

    var searchText      = $("#search_course_text").val();
    var action          = 'filter_course_list';
    var token           = $("input[name=token]").val();
    var academy         = $("input[name=academy]").val();
    var language        = $("input[name=language]").val();
    // var filter_audience = $("#filter_course_audience_types").val();
    var filter_interest = $('#expert-filter').val();

    console.log(urlPageVal);

    var entry           = readEntry();

    var availableCourseHtml = '';
    var ongoingCourseHtml   = '';
    var completedCourseHtml = '';

    var formData = new FormData();
    formData.append('action', action);
    formData.append('ptToken', token);
    formData.append('academy', academy);
    formData.append('searchText', searchText);
    // formData.append('filter_audience', filter_audience);
    formData.append('filter_interest', filter_interest);
    
    $.ajax({
        url: '../cms/ajax_cms.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {
            var availableCourseList = data.available_courses[0];
            var ongoingCourseList   = data.ongoing_courses[0];
            var completedCourseList = data.completed_courses[0];  

            if (urlPageVal == "ca_courses") {
                $("#cl-myCourses-dataTable").dataTable().fnDestroy();
                if ($('#cl-myCourses-dataTable').length) {
                        let myCoursesDataSet = [];
                        for (var i = 0; i < ongoingCourseList.length; i++) {
                            let c = ongoingCourseList[i];                                 
                            if (c.course_type == "online")
                            {
                                continue;
                            }                     
                            let docStatus = c.document_status;
                            let docStrStat = `<span class="badge badge-warning">Needs Review</span>`;
                            if (docStatus == "false") {
                                docStrStat = `<span class="badge badge-success">No Documents</span>`;
                            }

                            myCoursesDataSet.push([
                                `<img src="${c.course_image}" style="max-height: 100px; max-width: 100px" class="img-responsive" alt="${c.course_title}">`,
                                c.course_title,
                                c.venue,
                                waosColouredCourseLabels(c.course_type),
                                `<span class="badge badge-danger">`+entry[3134]+`</span>`,
                                `<span class="badge badge-secondary">${formatDate(c.start_date)}</span>`, 
                                c.start_date,
                                docStrStat,
                                `<a href="/?view=ca_courses&page=ca_courses&academy=${academyId}&page_id=1&course_id=${c.course_id}" class="btn btn-sm btn-default">
                                    <i class="fa fa-arrow-right"></i>
                                </a>`
                            ]);
                        }

                        for (var i = 0; i < completedCourseList.length; i++) {
                            let c = completedCourseList[i];
                            if (c.course_type == "online")
                            {
                                continue;
                            }
                            let docStatus = c.document_status;
                            let docStrStat = `<span class="badge badge-warning">Needs Review</span>`;
                            if (docStatus == "false") {
                                docStrStat = `<span class="badge badge-success">No Documents</span>`;
                            }

                            myCoursesDataSet.push([
                                `<img src="${c.course_image}" style="max-height: 100px; max-width: 100px" class="img-responsive" alt="${c.course_title}">`,
                                c.course_title,
                                c.venue,
                                waosColouredCourseLabels(c.course_type),
                                `<span class="badge badge-success">${entry[23]}</span>`,
                                `<span class="badge badge-secondary">${formatDate(c.start_date)}</span>`,
                                c.start_date,
                                docStrStat,
                                `<a href="/?view=ca_courses&page=ca_courses&academy=${academyId}&page_id=1&course_id=${c.course_id}" class="btn btn-sm btn-default">
                                    <i class="fa fa-arrow-right"></i>
                                </a>`
                            ]);
                        }


                        console.log(myCoursesDataSet);
                        let table = $('#cl-myCourses-dataTable').DataTable({
                                'data': myCoursesDataSet,
                                columns: [
                                    { 'title': entry[2959] },
                                    { 'title': entry[3306] },
                                    { 'title': entry[2209] },
                                    { 'title': entry[3307] },
                                    { 'title': entry[3308] },
                                    { 'title': entry[2210] },
                                    { 'title': 'Date Order' },
                                    { 'title': 'Document Status' },
                                    { 'title': entry[3167] }
                                ],
                                'stateSave': true,
                                'columnDefs': [
                                    { targets: 6, visible: false },
                                    { "width": "110px", "targets": 4 },
                                    { "orderData": [ 6 ], "targets": 5 },
                                ],
                                "oLanguage": {
                                    "sSearch": "Filter:"
                                }
                            });
                }

            }
            else {
                for (var i = 0; i < availableCourseList.length; i++)
                {
                    if (availableCourseList[i].course_type != "online")
                    {
                        continue;
                    }
                    var imageURL = 'https://d22u7g0jugykn9.cloudfront.net/images/courses/'+availableCourseList[i].course_id+'/'+availableCourseList[i].lead_image1;
                    availableCourseHtml += 
                    '<div class="col mb-4"><div class="card component h-100">'+
                        '<div class="background-image" style="background-image: url('+imageURL+');"></div>'+
                        '<div class="card-body"><div class="card-title">'+availableCourseList[i].course_title+'</div></div><div class="card-footer">';
                    if (availableCourseList[i].is_coming_soon == 1)
                    {
                        availableCourseHtml += '<div class="btn btn-outline-primary btn-block">-- Coming Soon --</div>';
                    }
                    else
                    {
                        availableCourseHtml += '<a class="btn btn-outline-primary btn-block" href="/?academy='+academy+'&course='+availableCourseList[i].course_id+'">'+entry[290]+'</a>';
                    }                
                    availableCourseHtml += '</div></div></div>';
                }

                for (var i = 0; i < ongoingCourseList.length; i++)
                {
                    if (ongoingCourseList[i].course_type != "online")
                    {
                        continue;
                    }
                    ongoingCourseHtml += 
                    '<div class="course_ind row">'+
                        '<div class="courseProgressBar col-md-9">'+
                            '<div class="title">'+ongoingCourseList[i].course_title+'<span>'+ongoingCourseList[i].reading_progress+'%</span></div>'+
                            '<div class="progressBar"><div style="width:'+ongoingCourseList[i].reading_progress+'%;" class="progressBarInner"></div></div>'+
                        '</div>'+
                        '<div class="col-md-3"><a href="/?academy='+academy+'&course='+ongoingCourseList[i].course_id+'" class="btn btn-primary">'+entry[2824]+'</a></div>'+
                    '</div>';
                }

                for (var i = 0; i < completedCourseList.length; i++)
                {
                    if (completedCourseList[i].course_type != "online")
                    {
                        continue;
                    }
                    completedCourseHtml +=
                    '<div class="course_ind row">'+
                        '<div class="courseProgressBar col-md-9">'+
                            '<div><a class="title" href="/?academy='+academy+'&course='+completedCourseList[i].course_id+'"><u>'+completedCourseList[i].course_title+'</u></a></div>'+
                                '<div class="progressBar"><div style="width: 100%;" class="progressBarInner"></div>'+
                            '</div>'+
                        '</div>';

                    if (completedCourseList[i].course_type == 'online')
                    {
                        completedCourseHtml += '<div class="col-md-3"><a href="content/make_pdf_certificate.php?certificate='+completedCourseList[i].certificate_filename+'&academy='+academy+'&course='+completedCourseList[i].course_id+'" class="btn btn-primary">'+entry[2522]+'</a></div>';
                    }

                    completedCourseHtml += '</div>';
                }

                if (availableCourseHtml != '')
                {
                    $("#available_courses_wrap").html(availableCourseHtml);
                }
                else
                {
                    $("#available_courses_wrap").html('<p>No courses found</p>');
                }

                if (ongoingCourseHtml != '')
                {
                    $("#course_progress_wrap").html(ongoingCourseHtml);
                }
                else
                {
                    $("#course_progress_wrap").html('<p>No courses found</p>');
                }

                if (completedCourseHtml != '')
                {
                    $("#course_completed_wrap").html(completedCourseHtml);
                }
                else
                {
                    $("#course_completed_wrap").html('<p>No courses found</p>');
                }
            }       

            

            cmsLoadingStatus = false;
        }
    });
});

$(document).on('keyup', '#search_course_text', function(e)
{
    if(e.keyCode == 13)
    {
        if ($(this).val() == '') return;
        
        $(this).trigger("enterKeyEducation");
    }
});

$(document).on('click', '.course_filters', function(e) 
{
    $('#search_course_text').trigger("enterKeyEducation");
});

$(document).on('change', '.is_certificate_enable', function() 
{
    var is_certificate_enable = $(this).val();

    if (is_certificate_enable == 0)
    {
        $('#div_course_thank_you_page_header_en').show();
        $('#div_course_thank_you_page_content_en').show();
    }
    else
    {
        $('#div_course_thank_you_page_header_en').hide();
        $('#div_course_thank_you_page_content_en').hide();
    }
});

$(document).on('click', '.btn-play-video', function() 
{
    var action     = 'create_user_resource_log';
    var token      = $("input[name=token]").val();
    var resourceId = $(this).attr("data-id");

    var formData = new FormData();
    formData.append('action', action);
    formData.append('ptToken', token);
    formData.append('resource_id', resourceId);

    $.ajax({
        url: '../cms/ajax_cms.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {
            
        }
    });
});


function launchScormWindow(dataUrl) {

    $.ajax({
        url: dataUrl,
        type: "get",
        
    }).then(function(data) {

        try {
            if(data.error) {
                alert('data');
            } else {
                renderHTML();
            }
        }
        catch(e) {
            alert('Something went wrong');
        }

    }).fail(function() {

    });

    function renderHTML() {

        var modal = `
            <div class="modal scorm-modal fade" id="scorm-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                <span class="sr-only">Close</span>
                            </button>
                            <h4 class="modal-title">Modal title</h4>
                        </div>
                        <div class="modal-body">
                            <iframe src="${dataUrl}" width="100%" style="height: 500px"></iframe>
                        </div>
                      
                    </div>
                </div>
            </div>
        `;

        $('body').append(modal);

        $('#scorm-modal').modal('show');
    }

}

$(document).on('click', '#launch-scorm-btn', function() {

    var url = $(this).data('url');

    launchScormWindow(url);

});


$(document).on('click', '.view-course-details', function() {
    var courseId   = $(this).attr("data-content-id");
    var courseName = $(this).attr("data-content-name");        
    viewCourseDetails(courseId, courseName);

    $('#exTab2').on("click", "li", function (event) {    

        var activeTab = $(this).find('a').attr('href'); 

        if (activeTab == '#feedback-forms-tab')
        {
            readFeedbackFormInfo(courseId);
        }
    });
});

function viewCourseDetails(courseId, courseName)
{
    var entry = getEntries();

    $('#view-course-details-modal').remove();
    var output = 
    '<div id="view-course-details-modal" class="modal fade bd-example-modal-xl" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-xl" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">'+entry[3383]+' - '+courseName+'</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<input type="hidden" id="courseId" name="courseId" value="'+courseId+'">'+
                    '<input type="hidden" id="programmeId" name="programmeId" value="">'+
                    '<input type="hidden" id="feedback_form_id" name="feedback_form_id" value="">'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div id="exTab2" class="">'+  
                                '<ul class="nav nav-tabs ml_0">'+
                                    '<li class="nav-item">'+
                                        '<a class="nav-link active" href="#users-join-courses-tab" data-toggle="tab">'+entry[3384]+'</a>'+
                                    '</li>'+                           
                                    '<li class="nav-item">'+
                                        '<a class="nav-link" href="#summary-tab" data-toggle="tab">'+entry[3385]+'</a>'+
                                    '</li>'+
                                    '<li class="nav-item">'+
                                        '<a class="nav-link" href="#feedback-forms-tab" data-toggle="tab">Feedback Form Reports</a>'+
                                    '</li>'+
                               '</ul>'+
                                '<div class="tab-content clearfix">'+
                                    '<div class="tab-pane active" id="users-join-courses-tab">'+
                                        '<div class="row" style="padding:15px 0 5px 0;">'+
                                            '<div class="col-sm-6">'+
                                                '<div class="form-group">'+
                                                    '<h5 style="padding: 8px 3px 6px 0;" class="modal-title">'+entry[3386]+'</h5>'+
                                                '</div>'+    
                                            '</div>'+
                                        '</div>'+
                                        '<div class="role-course-wrapper">'+
                                        '</div>'+
                                    '</div>'+
                                    '<div class="tab-pane" id="summary-tab">'+
                                        '<div class="row" style="padding:15px 0 5px 0;">'+
                                            '<div class="col-sm-12">'+
                                                '<div class="form-group">'+
                                                    '<h5 style="padding: 8px 3px 6px 0;" class="modal-title">'+entry[3387]+'</h5>'+
                                                '</div>'+    
                                            '</div>'+
                                        '</div>'+
                                        '<div class="row">'+
                                            '<div class="col-sm-6">'+
                                                '<div id="gender-chart-container" class="chart"></div>'+
                                            '</div>'+
                                            '<div class="col-sm-6">'+
                                                '<div id="completed-chart-container" class="chart"></div>'+
                                            '</div>'+
                                        '</div>'+
                                        '<div class="row">'+
                                            '<div class="col-sm-6">'+
                                                '<div id="region-chart-container" class="chart"></div>'+
                                            '</div>'+
                                            '<div class="col-sm-6">'+
                                                '<div id="registered-chart-container" class="chart"></div>'+
                                            '</div>'+
                                        '</div>'+
                                    '</div>'+
                                    '<div class="tab-pane" id="feedback-forms-tab">'+
                                        '<div class="row" style="padding:15px 0 5px 0;">'+
                                            '<div class="col-sm-12">'+
                                                '<div class="form-group">'+
                                                    '<h5 style="padding: 8px 3px 6px 0;" class="modal-title">Feedback Form Reports</h5>'+
                                                '</div>'+
                                            '</div>'+
                                        '</div>'+
                                        '<div class="row">'+
                                            '<div class="col-sm-12">'+
                                                '<div class="alert alert-certifications" role="alert" id="alert-course-certification"></div>'+
                                            '</div>'+
                                            '<div class="col-sm-12 btn-group">'+
                                                '<button class="btn btn-secondary" id="btn-download-csv-report">Download Feedback (CSV)</button>'+
                                                '<button class="btn btn-secondary" id="btn-download-excel-report">Download Feedback (Excel)</button>'+
                                                '<button class="btn btn-secondary" id="download-dashboard-btn">Download Dashboard Report</button>'+
                                            '</div>'+
                                            '<div id="feedback-report-area" style="padding: 10px;">'+
                                            '</div>'+ 
                                        '</div>'+
                                    '</div>'+
                                '</div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                '</div>'+
                '<div class="modal-footer">'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#view-course-details-modal').modal('show');
    loadCourseDetailsFormData(courseId);
}

function loadCourseDetailsFormData(courseId)
{
    cmsLoadingStatus = true;
    loadOverlay();
    var action   = "read_course_info";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    var entry    = getEntries();

    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action    : action,
            token     : token,
            course_id : courseId
        },
        success: function(data)
        {
            $(".role-course-wrapper").html(data.course_info[0]);

            var columnsList = [];
            if (academy == 107) {
                columnsList = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
            } else if (courseId == 1607) {
                columnsList = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
            } else {
                columnsList = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
            }            

            $('#existing_course_info_table_' + courseId).DataTable({                      
                "responsive": true,
                "scrollX": true,
                "pageLength": 10,
                dom: 'lBfrtip',
                "columnDefs": [
                    { "width": "10%", "targets": 5,  "orderData": [ 0 ] }             
                ],
                "order": [[ 0, "asc" ]],
                buttons: [
                    // { extend: 'excel', className: 'btn-dataTable', exportOptions: {columns: columnsList}},
                    // { extend: 'pdf', className: 'btn-dataTable', exportOptions: {columns: columnsList}}
                    { extend: 'excel', className: 'btn-dataTable'},
                    { extend: 'pdf', className: 'btn-dataTable'}
                ],
            });

            $('[data-toggle="tooltip"]').tooltip();

            cmsLoadingStatus = false;

            var genderChart = Highcharts.chart("gender-chart-container", {
                chart: {
                    type: "pie"
                },
                title: {
                    text: entry[69]
                },
                tooltip: {
                    pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: "pointer",
                        depth: 35,
                        dataLabels: {
                            enabled: true,
                            format: "{point.name}"
                        }
                    }
                },
                series: [{
                    type: "pie",
                    name: "Gender",
                    innerSize: "60%",
                    data: [
                        [entry[70], data.male],
                        [entry[71], data.female],
                        [entry[84], data.other]
                    ]
                }]
            });

            var completedChart = Highcharts.chart("completed-chart-container", {
                chart: {
                    type: "pie"
                },
                title: {
                    text: entry[3396]
                },
                tooltip: {
                    pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: "pointer",
                        depth: 35,
                        dataLabels: {
                            enabled: true,
                            format: "{point.name}"
                        }
                    }
                },
                series: [{
                    type: "pie",
                    name: "Completed",
                    innerSize: "60%",
                    data: [
                        [entry[3400], data.completed_count],
                        [entry[3401], data.not_completed_count]
                    ]
                }]
            });

            var regionChart = Highcharts.chart("region-chart-container", {
                chart: {
                    type: "pie"
                },
                title: {
                    text: entry[3395]
                },
                tooltip: {
                    pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: "pointer",
                        depth: 35,
                        dataLabels: {
                            enabled: true,
                            format: "{point.name}"
                        }
                    }
                },
                series: [{
                    type: "pie",
                    name: "Registered Continent",
                    innerSize: "60%",
                    data: [
                        [entry[3402], data.asia_count],
                        [entry[3403], data.europe_count],
                        [entry[3404], data.africa_count],
                        [entry[3405], data.oceania_count],
                        [entry[3406], data.na_count],
                        [entry[3407], data.sa_count],
                        [entry[3408], data.ca_count]
                    ]
                }]
            });

            var categories_list = [];
            for (var i = 0; i < data.categories.length; i++)
            {
                categories_list.push(data.categories[i]);
            }

            var series_list = [];
            for (var i = 0; i < data.series.length; i++)
            {
                series_list.push(parseInt(data.series[i]));
            }

            var registeredChart = Highcharts.chart("registered-chart-container", {
                chart: {
                    type: "column"
                },
                title: {
                    text: entry[3397]
                },
                xAxis: {
                    categories: categories_list,
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: entry[3398]
                    }
                },
                tooltip: {
                    useHTML: true
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },
                series: [{
                    name: entry[3399],
                    data: series_list
                }]
            });
        }
    });
}

var renderModalPrototype = {
  type: '',
  size: '',
  title: 'Modal Title',
  body: 'Example Body text',
  footer: '',
  mount: 'body',
  dismiss: true,
  renderModal: function() {
    var closeBtn = (this.dismiss) ? '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' : '';
    var footerHTML = ((this.footer == '') || (this.footer == undefined))  ? '' : '<div class="modal-footer">' + this.footer + '</div>';
    var html = '<div class="modal fade ' + this.type + '" id="global-modal">'+
      '<div class="modal-dialog ' + this.size + '" role="document">'+
        '<div class="modal-content">'+
            '<div class="modal-header">' +
            '<h4 class="modal-title">' + this.title + '</h4>'+
            closeBtn + 
          '</div>'+
          '<div class="modal-body">' + this.body + '</div>' + footerHTML + '</div>'+
      '</div>'+
    '</div>';
    
    $(this.mount).append(html);

    var modal = $('#global-modal');
    modal.modal({
        'show': true,
        'backdrop': this.dismiss
    });
  }
};

// remove modal from DOM after closing
$(document).on('hidden.bs.modal', '#global-modal', function(e) {
    
    var modal = $(this);
    modal.remove();
});

function renderAssignThemesModal(questionId) {

    var newModal = Object.create(renderModalPrototype);

    var form = 
         '<div class="row">'+
            '<div class="col-sm-12">'+
                '<div class="form-group">'+
                    '<label for="name">Question</label>'+
                    '<textarea class="form-control" id="name-question" value="" readonly></textarea>'+
                '</div>'+
            '</div>'+
            '<div class="col-sm-6">'+
                '<div class="form-group">'+
                    '<label for="questionPlayerlevels">Player Levels</label>'+
                    '<select style="width:100%" class="form-control select2-question-player-level" name="question_player_level_list[]" id="question_player_level_list" multiple="multiple"></select>'+
                '</div>'+
            '</div>'+
            '<div class="col-sm-6">'+
                '<div class="form-group">'+
                    '<label for="difficulty">Question Difficulty Level</label>'+
                    '<input type="number" class="form-control" id="question_level" min="1" max="5"/>'+
                '</div>'+
            '</div>'+
        '</div>'+
        '<div class="row" id="theme-row">'+
            '<div class="col-sm-6">'+
                '<div class="form-group">'+
                    '<label for="questionThemes">Themes</label>'+
                    '<select style="width:100%" class="form-control select2-question-themes" name="question_theme_list[]" id="question_theme_list"></select>'+
                '</div>'+
            '</div>'+
            '<div class="col-sm-6" id="sub-theme-row" style="display:none">'+
                '<div class="form-group">'+
                    '<label for="difficulty">Sub Themes</label>'+
                    '<select style="width:100%" class="form-control select2-sub-themes" name="sub_themes[]" id="sub_themes" multiple></select>'+
                '</div>'+
            '</div>'+
        '</div>'+
        '<button class="btn btn-secondary btn-block" id="btn-add-theme-row"><i class="fa fa-plus"></i> Add Theme / Sub Theme</button>'+
        '<table class="table">'+
            '<thead>'+
                '<tr>'+
                    '<th>Theme</th>'+
                    '<th>Sub Theme</th>'+
                    '<th class="text-right">Delete</th>'+
                '</tr>'+
            '</thead>'+
            '<tbody id="themes-table-mount">'+
            '</tbody>'+
        '</table>'+
        '<div class="text-right">'+
            '<button id="update-question-btn" type="button" class="btn btn-primary mt_3">Save</button>'+
        '</div>'+
        '<input type="hidden" id="question-id" value="'+questionId+'">'+
        '<div class="alert alert-certifications" role="alert" id="alert-course-certification"></div>'+
        '<hr>'+
         '<div class="row">'+
         '<div class="col-sm-12" id="answers_row">'+
        '</div>'+
    '</div>';

    newModal.size = 'modal-lg';
    newModal.title = 'Assign Themes';
    newModal.body = form;
    newModal.renderModal();
}

function renderThemeRow(themeId, themeText, subThemeId, subThemeText) {
        
    return '<tr data-theme="' + themeId + '">'+
    '<td>'+ themeText +'</td>'+
        '<td>'+ subThemeText +'</td>'+
        '<td class="text-right"><button class="btn btn-sm btn-danger btn-remove-theme-row"><i class="fa fa-times"></i></button></td>'+
    '</tr>';
}

var themeArr = [];
var themesIdArr = [];
var subThemesIdArr = [];

function primeThemes(themes_with_subs) {

    if (themes_with_subs.length < 1) return;

    for (var i = 0; i < themes_with_subs.length; i++) {
        var t = themes_with_subs[i];
        
        var subThemeIds = [];
        var subThemeText = [];

        for (var l = 0; l < t.sub_themes.length; l++) {
            var s = t.sub_themes[l];

            subThemeIds.push(s.id);
            subThemeText.push(s.name);
        }

        themeArr.push({
            'id': t.id,
            'sub_theme_id': subThemeIds,
            'sub_theme_text': subThemeText
        });

        console.log(t);

        var tableRow = renderThemeRow(t.id, t.name, subThemeIds, subThemeText);

        $('#themes-table-mount').append(tableRow);
        
    }
}



function recordThemeData(theme, subTheme) {

    var themeText = theme.text;
    var themeId = theme.id;

    var found = themeArr.some(p => p.id == themeId);

    console.log(themeArr, themeId);

    if (found) {
        alert('You cannot add 2 of the same theme');
        return;
    }

    var subThemeIds = [];
    var subThemeText = [];
    for (var i = 0; i < subTheme.length; i++) {
        var s = subTheme[i];

        subThemeIds.push(s.id);
        subThemeText.push(s.text);
    }
    
    themeArr.push({
        'id': themeId,
        'sub_theme_id': subThemeIds,
        'sub_theme_text': subThemeText
    });


    var tableRow = renderThemeRow(themeId, themeText, subThemeIds, subThemeText);

    $('#themes-table-mount').append(tableRow);

    if ($('#cms-form').length) {

        themesIdArr.push(themeId);
        subThemesIdArr.push(subThemeIds);

        $('[name="themes_cb"]').val(themesIdArr);
        $('[name="sub_themes_cb"]').val(subThemesIdArr);
        
    }

}

$(document).on('click', '#btn-add-theme-row', function() {

    var theme = $('#question_theme_list').select2('data')[0];
    var subTheme = $('#sub_themes').select2('data');
    

    recordThemeData(theme, subTheme);
});

$(document).on('click', '.btn-remove-theme-row', function() {

    var btn = $(this);
    var theme = btn.parents('tr').data('theme');
    // var subTheme = btn.parents('tr').data('subtheme');
    themeArr = themeArr.filter(p => p.id != theme);

    // console.log(theme, themeArr);

    btn.parents('tr').remove();

    if ($('#cms-form').length) {
        themesIdArr = [];
        subThemesIdArr = [];

        for (var i = 0; i < themeArr.length; i++) {
            var t = themeArr[i];

            themesIdArr.push(t.id);
            subThemesIdArr.push(t.sub_theme_id);
        }

        $('[name="themes_cb"]').val(themesIdArr);
        $('[name="sub_themes_cb"]').val(subThemesIdArr);
    }

});

$(document).on('click', '.assign_themes_questions', function(){
    var questionId = $(this).attr('attr-id');
    // console.log(questionId);
    var token    = $("input[name=token]").val();

    renderAssignThemesModal(questionId);

    /*var output = 
    '<div id="edit-certification-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-lg" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title">Assign Themes</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<div class="form-group">'+
                                '<label for="name">Question</label>'+
                                '<textarea class="form-control" id="name-question" readonly/>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="questionThemes">Themes</label>'+
                                '<select style="width:100%" class="form-control select2-question-themes" name="question_theme_list[]" id="question_theme_list" multiple="multiple"></select>'+
                            '</div>'+
                        '</div>'+

                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="questionPlayerlevels">Player Levels</label>'+
                                '<select style="width:100%" class="form-control select2-question-player-level" name="question_player_level_list[]" id="question_player_level_list" multiple="multiple"></select>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                         '<div class="col-sm-6" id="sub-theme-row" style="display:none">'+
                            '<div class="form-group">'+
                                '<label for="difficulty">Sub Themes</label>'+
                                '<select style="width:100%" class="form-control select2-sub-themes" name="sub_themes[]" id="sub_themes" multiple="multiple"></select>'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-sm-6">'+
                            '<div class="form-group">'+
                                '<label for="difficulty">Question Difficulty Level</label>'+
                                '<input type="number" class="form-control" id="question_level" min="1" max="5"/>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                         '<div class="col-sm-12" id="answers_row">'+
                        '</div>'+
                    '</div>'+

                    '<div class="row">'+
                        '<div class="col-sm-12">'+
                            '<input type="hidden" id="question-id" value="'+questionId+'">'+
                            '<button id="update-question-btn" type="button" class="btn btn-primary">Save</button>'+
                        '</div>'+                       
                    '</div>'+

                    '<div class="alert alert-certifications" role="alert" id="alert-course-certification"></div>'+

                '</div>'+
               
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);*/
    // $('#edit-certification-modal').modal('show');
    loadQuestionThemeData(questionId);
    
});

function loadQuestionThemeData(questionId)
{
    cmsLoadingStatus = true;
    loadOverlay();

    var action   = "read_question_info";
    var token    = $("input[name=token]").val();
    var advancedData;
    var result;

    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action  : action,
            token : token,
            id      : questionId
        },
        success: function(data)
        {
            console.log(data.output);
            
            result = data.output;
            var question_data = result.questions[0];
            var themeOptions = result.theme_options;
            var playerOptions = result.player_options;
            var subThemeOptions = result.sub_theme_options;
            var outputAnswersForm = "";
            var themes_with_subs = result.themes_with_subs;
            console.log(question_data.answers);
            $('#name-question').val(question_data.question);
            $('#question_level').val(question_data.difficulty);
            $("#question_theme_list").html(themeOptions);
           
            $("#question_theme_list").select2({
                placeholder: "Please select",
                theme: 'bootstrap-5',
                dropdownParent: $('.modal-body')
            });

            $("#question_player_level_list").html(playerOptions);
           
            $("#question_player_level_list").select2({
                placeholder: "Please select",
                theme: 'bootstrap-5',
                dropdownParent: $('.modal-body')
            });

            if (subThemeOptions != "0")
            {
                $('#sub-theme-row').show();
                $("#sub_themes").html(subThemeOptions);
                $("#sub_themes").select2({
                    placeholder: "Please select",
                    theme: 'bootstrap-5',
                    dropdownParent: $('.modal-body')
                });
            }
            else
            {
                $('#sub-theme-row').hide();
                $("#sub_themes").html('');
            }

            primeThemes(themes_with_subs);

             Object.keys(question_data.answers).forEach(function(key) {
                var value = question_data.answers[key];
                if (value !== null)
                {
                    var element = ` <div class="row" id="answers-area-row-`+key+`">
                                        <div class="col-sm-10">
                                            <div class="form-group">
                                                <label for="name">Answer (`+key+`)</label>
                                                <input type="text" class="form-control"  value="`+value+`" 
                                              `;

                    if (inArray(key, question_data.correct_answers))
                    {
                       element += ` style="background-color:#008f70; color:#fff;" ` ;
                        //element += ` <label style="font-size: 14px;font-weight: 500;" class="form-check-label" for="correct-answer-`+key+`">Correct Answer</label>`;
                    }
                     element +=   ` disabled> </div> </div> </div>`;
                            
                    outputAnswersForm += element;
                }
            })
          
             $('#answers_row').html(outputAnswersForm);
            cmsLoadingStatus = false;
        }
    });
}

$(document).on('click', '#update-question-btn', function() 
{
    var questionId          = $("#question-id").val();
    var playerlevel         = $("#question_player_level_list").val();
    var difficulty          = $("#question_level").val();
    var action              = "edit_question_themes";
    var token               = $("input[name=token]").val();
    // var themes              = $("#question_theme_list").val();
    // var subThemes           = $("#sub_themes").val();
    var themes              = themeArr;
    // var subThemes           = subThemeArr;
 
   
    cmsLoadingStatus = true;
    loadOverlay();

    var formData = new FormData();
    formData.append('action', action);
    formData.append('token', token);
    formData.append('id', questionId);
    // formData.append('themes', themes);
    formData.append('playerlevel', playerlevel);
    formData.append('difficulty', difficulty);
    // formData.append('subthemes', subThemes);

    for (var i = 0; i < themeArr.length; i++) {
        var t = themeArr[i];

        formData.append('themes_' + t.id, t.id);

        formData.append('sub_theme_' + t.id, t.sub_theme_id);

    }

    $.ajax({
        url: '../content/ajax_itf_common.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {
            // location.reload();
            reload_guided_learning_table();

            themeArr = [];

            $('#global-modal').modal('hide');

            cmsLoadingStatus = false;

        }
    });
    
});

$(document).on('select2:select', '#question_theme_list', function (e) {     
    var themes              = $('#question_theme_list').val(); 
    var token               = $("input[name=token]").val();
    var questionId          = $("#question-id").val();

    var action              = "read_sub_theme_by_parent";

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: '../content/ajax_itf_common.php',
        type: "post",
        dataType: "json",
        data: {
            action      : action,
            token       : token,
            theme_id    : themes,
            question_id : questionId,
        },
        success: function(data)
        {
            // if (data.output.subThemes != 0)
            // {
                var subThemeOptions = data.output.subThemes;

                var subThemesRow = $('#sub-theme-row');
                var subThemes = $('#sub_themes');

                console.log(subThemeOptions);

                subThemes.html(subThemeOptions);

                if ($('#alert-course-certification').length) {
                    subThemes.select2({
                        placeholder: 'Please select...',
                        theme: 'bootstrap-5',
                        dropdownParent: $('.modal-body')
                    });
                } else {
                     subThemes.select2({
                        placeholder: 'Please select...',
                        theme: 'bootstrap-5',
                    });
                }
                subThemesRow.show();
            // }
            
            cmsLoadingStatus = false;
            
        }
    });
});


$(document).on('select2:select', '#themes_courses_select', function (e) {     
    var themes              = $("#themes_courses_select").val();   
    var action              = "read_sub_theme_by_parent";
    var token               = $("input[name=token]").val();

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: '../content/ajax_itf_common.php',
        type: "post",
        dataType: "json",
        data: {
            action    : action,
            token     : token,
            theme_id : themes
        },
        success: function(data)
        {
            if (data.output.subThemes != 0)
            {
                var subThemeOptions = data.output.subThemes;
                $("#sub_themes_courses_div").show();
                $(".sub_themes_courses").select2({
                    placeholder: 'Please select...'
                });
                $(".sub_themes_courses").html(subThemeOptions);
                
            }
            else
            {
                $("#sub_themes_courses_div").hide();
                $(".sub_themes_courses").html('');
            }
            cmsLoadingStatus = false;
            
        }
    });


});

$(document).on('select2:unselect', '#themes_courses_select', function (e) {     
   
    var action              = "remove_sub_themes";
    var token               = $("input[name=token]").val();
    var courseId          = $("input[name=course_id]").val();
    var data            = e.params.data;  
    var sectionId       = $(this).attr('data-parent');
    var themes          = data.id;
       

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: '../content/ajax_itf_common.php',
        type: "post",
        dataType: "json",
        data: {
            action    : action,
            token     : token,
            theme_id : themes,
            course_id : courseId
        },
        success: function(data)
        {
            if (data.output.subThemes != 0)
            {
                var subThemeOptions = data.output.subThemes;
                $("#sub_themes_courses_div").show();
                $(".sub_themes_courses").select2({
                    placeholder: 'Please select...'
                });
                $(".sub_themes_courses").html(subThemeOptions);
                
            }
            else
            {
                $("#sub_themes_courses_div").hide();
                $(".sub_themes_courses").html('');
            }
            cmsLoadingStatus = false;
            
        }
    });
});

function inArray(needle, haystack) {
    var length = haystack.length;
    for(var i = 0; i < length; i++) {
        if(haystack[i] == needle) return true;
    }
    return false;
}

function capitalizeFirstLetter(string) {
    return string[0].toUpperCase() + string.slice(1);
}

function renderSaveAlert(msg, appendTo, type) {
  $('#save-alert').remove();
  var className, icon;

  if (type === 'error') {
    className = 'danger';
    icon = 'times';
  } else if (type === 'info') {
    className = 'info';
    icon = 'info';
  } else {
    className = 'success';
    icon = 'check';
  }

  $(appendTo).append("<div id=\"save-alert\" class=\"alert alert-".concat(className, " mt_5\">\n    <button type=\"button\" class=\"close ml_5\" data-dismiss=\"alert\" aria-hidden=\"true\">&times;</button>\n    <strong><i class=\"fa fa-").concat(icon, "\"></i></strong> ").concat(msg, "\n  </div>"));
  if (type === 'error' || type === 'info') return;
  setTimeout(function () {
    $('#save-alert').fadeOut();
  }, 6000);
  setTimeout(function () {
    $('#save-alert').remove();
  }, 6500);
}

function renderActivateModal(activityId) {

    var type = '';
    var title = '';
    var body = '<div class="modal-body"><h4 id="activity-msg-heading" class="text-center mb_5">You must Publish your Activity to create an intake.</h4>';
    body += '<div class="row">';
    body += '<div class="col-md-6">';
    body += '<button id="btn-approve-activity" class="btn btn-lg btn-block btn-danger" onclick="activateActivity(' + activityId + '); return false;">Publish Activity</button>';
    body += '</div>';
    body += '<div class="col-md-6">';
    body += '<a href="#" id="btn-create-intake" class="btn btn-lg btn-block disabled">Go to Intake <i class="fa fa-arrow-right"></i></a>';
    body += '</div></div></div>';
    var footer = '';

    renderModal(type, title, body, footer);    
}

function activateActivity(activityId) {

    var action = 'activate_activity';
    var token = $("input[name=token]").val();
    var pathwayId = $.urlParam('pathway_id');
    // var activityId = $.urlParam('intervention_id');
    var gamesEditionId = $.urlParam('games_edition_id');
    var academyId = $.urlParam('academy');

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: '../api/v1/activity_wizard.php',
        type: "post",
        dataType: "json",
        data: {
            action: action,
            ptToken: token,
            pathway_id: pathwayId,
            activity_id: activityId,
            games_edition_id: gamesEditionId,
        }
    }).done(function(data) {
        try {
            console.log(data);

            var courseId = data.course_id;

            var msg;
            var appendTo = '#dynamic-modal .modal-body';
            var type;
            if ('error' in data) {
                msg = data.error;
                type = 'error';
            } else {
                msg = data.success;
                type = 'success';

                $('#btn-create-intake').removeClass('disabled');
                $('#btn-create-intake').addClass('btn-success');
                $('#btn-create-intake').attr('href', '/?academy=' + academyId + '&view=cms&page=course_wizard&activity_id=' + data.activity_id + '&course_id=' + courseId);
                $('#btn-create-intake').attr('target', '_blank');

                $('#btn-approve-activity').prop('disabled', true);
                $('#btn-approve-activity').addClass('disabled');
                $('#btn-approve-activity').removeClass('btn-danger');

                $('#activity-msg-heading').text('Intake: ' + data.course_name + ' was created');

                // update publish button icon to calendar
                updateActivityIcon(activityId, courseId, academyId);

            }

            renderSaveAlert(msg, appendTo, type);
        }
        catch(e) {
            console.log(e);
        }

    }).always(function() {
        cmsLoadingStatus = false;
    });

}

function updateActivityIcon(activityId, courseId, academyId) {

    $('#' + activityId).find('.btn-publish-activity').remove();

    var btn = '<a class="green-tick interventions-btns" title="Activity Published" data-toggle="tooltip" href="/?academy=' + academyId + '&view=cms&page=course_wizard&course_id=' + courseId + '"><i class="fa fa-calendar text-info"></i></a>';

    $('#' + activityId).find('.name').append(btn);
}



function renderChangeHistoryModal(activityId) {

    var title = 'Change History';
    var body = '<div class="modal-body">';
    body += '<div class="row">';
    body += '<div class="col-md-12" id="change-history-div">';
    body += '</div>';
    body += '</div></div>';
    var footer = '';

    var action         = 'read_change_history';
    var token          = $("input[name=token]").val();
    var pathwayId      = $.urlParam('pathway_id');
    var gamesEditionId = $.urlParam('games_edition_id');

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: '../api/v1/activity_wizard.php',
        type: "post",
        dataType: "json",
        data: {
            action: action,
            ptToken: token,
            pathway_id: pathwayId,
            activity_id: activityId,
            games_edition_id: gamesEditionId
        }
    }).done(function(data) {
        try {
            var type = 'modal-lg';
            title = 'Change History - '+ data.activity_name;
            var styles = 'width: calc(100% - 40px);'
            renderModal(type, title, body, footer, styles);
            $("#change-history-div").empty();
            $("#change-history-div").html(data.result_history);
            $('#change-history-table').DataTable();       
        }
        catch(e) {
            console.log(e);
        }
    }).always(function() {
        cmsLoadingStatus = false;
    });
}



function renderDuplicateActivityModal(activityId) {
    var type = '';
    var title = 'Duplicate Activity';
    var body = '<div class="modal-body">';
    body += '<div class="row">';
    body += '<div class="col-md-12">Please select the Games Edition and Learning Pathway to duplicate this activity.</div>';
    body += '</div><br>';
    body += '<div class="row">';
    body += '<div class="col-md-12">';
    body += '<div class="form-group">'+
                '<label for="games-editions">Games Edition</label>'+
                '<select id="games_editions_list" name="games_editions_list" class="form-control" style="width:100%">'+
                    '<option></option>'+
                '</select>'+
            '</div>';
    body += '<div class="form-group">'+
                '<label for="lp-list">Learning Pathway</label>'+
                '<select id="lp_list" name="lp_list" disabled class="form-control" style="width:100%">'+
                    '<option></option>'+
                '</select>'+
            '</div>';
    body += '</div>';

    body += '<div class="col-md-12">';
    body +=     '<button id="btn-duplicate-activity" class="btn btn-danger" onclick="duplicateActivity(' + activityId + '); return false;">Duplicate Activity</button>';
    body += '</div>';

    body += '</div><div class="alert" role="alert" id="copy-activity-alert" style="margin-top:4px;"></div></div>';
    var footer = '';

    var action         = 'read_duplicate_activity';
    var token          = $("input[name=token]").val();
    var pathwayId      = $.urlParam('pathway_id');
    var gamesEditionId = $.urlParam('games_edition_id');

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: '../api/v1/activity_wizard.php',
        type: "post",
        dataType: "json",
        data: {
            action: action,
            ptToken: token,
            pathway_id: pathwayId,
            activity_id: activityId,
            games_edition_id: gamesEditionId
        }
    }).done(function(data) {
        try {
            title = 'Duplicate Activity - '+ data.activity_name;
            renderModal(type, title, body, footer);    

            $("#games_editions_list").empty();
            $("#games_editions_list").html(data.games_editions);
            
            $("#games_editions_list").select2({
                placeholder: '-- Please select --',
                theme: 'bootstrap-5',
                dropdownParent: $('.modal-body')
            });

            $.fn.modal.Constructor.prototype.enforceFocus = function() {};
        }
        catch(e) {
            console.log(e);
        }
    }).always(function() {
        cmsLoadingStatus = false;
    });
}

$(document).on('select2:select', '#games_editions_list', function (e) {

    var functionType = "read_pathways_by_games_editions";
    var ge_id        = $("#games_editions_list").val();
    var token        = $('input[name="token"]').val();

    if ((ge_id == "0") || (ge_id == ""))
    {
        $("#lp_list").prop("disabled", true);
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../course_admin/ajax_publish_intervention_as_course.php',
            dataType: "json",
            data: {
                function: functionType,
                ptToken : token,
                ge_id   : ge_id
            },
            success: function (data)
            {
                $("#lp_list").html(data.output);
                $("#lp_list").prop("disabled", false);

                $("#lp_list").select2({
                    placeholder: '-- Please select --'
                });

                cmsLoadingStatus = false;
            }
        });
    }
});

function duplicateActivity(activityId) {

    var token  = $('input[name="token"]').val();
    var geId   = $("#games_editions_list").val();
    var lpId   = $("#lp_list").val();
    var action = 'duplicate_activity';

    $('#copy-activity-alert').removeClass("alert-danger");

    if (activityId == '')
    {
        showErrorMessage("Error : Activity not found!");
    }
    else if ((geId == "0") || (geId == ""))
    {
        showErrorMessage("Error : Games edition not found!");            
    }
    else if ((lpId == "0") || (lpId == ""))
    {
        showErrorMessage("Error : Learning pathway not found!");
    }
    else
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url: '../api/v1/activity_wizard.php',
            type: "post",
            dataType: "json",
            data: {
                action: action,
                ptToken: token,
                activity_id: activityId,
                pathway_id: lpId,
                games_edition_id: geId
            }
        }).done(function(data) {
            try {
                var url     = window.location.href;
                var urlPart = url.split("games_edition_id=");
                var newUrl  = urlPart[0]+"games_edition_id="+geId+"&pathway_id="+lpId+"&ogl_activity_wizard=1&activity_id="+data.activity_id;

                $('#copy-activity-alert').addClass("alert-success");
                $('#copy-activity-alert').html("<p>Success : Activity successfully duplicated!</p><p>Duplicated Activity: <a href='"+newUrl+"' target='_blank'>"+data.activity_name+"</a></p>");
            }
            catch(e) {
                console.log(e);
            }
        }).always(function() {
            cmsLoadingStatus = false;
        });
    }   
}

function update2faUsers() {

    $('body').on('click', '.2fa', function() {

        var token   = $('input[name="token"]').val();
        var button  = $(this);
        var svg     = button.find('.svg-inline--fa');
        var roleId  = $(this).attr("data-content-id");
        var has_2fa = $(this).attr("data-content-has_2fa");
        var action  = "disable_2fa";

        if ((has_2fa == '0') || (has_2fa == ''))
        {
            action = "enable_2fa";
        }

        console.log(has_2fa);
        console.log(action);

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../course_admin/ajax_course_admin.php',
            dataType: "json",
            data: {
                function  : action,
                role_id   : roleId,
                ptToken   : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        setTimeout(function(){
                            if (action == "enable_2fa")
                            {
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-on fa-w-18 fa");
                                button.attr("data-original-title", "Deactivate user");
                            }
                            else
                            {
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-off fa-w-18 fa");
                                button.attr("data-original-title", "Activate user");
                            }
                        },500);
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

var certificateFile = [];

function renderCreateTemplateModal(templateId) {
    var type  = 'modal-lg';
    var title = 'Create Certificate Template';
    var body  = '<div class="modal-body">';
    var previewTemplate  = 'disabled'
    var previewLink      = '';
    var previewLinkStyle = "display:none;";

    if (templateId != ''){
        previewTemplate  = '';
        previewLink      = '../content/preview_pdf_certificate.php?template_id='+templateId;
        previewLinkStyle = '';
    }
    
    body += '<div id="certificate-template-container">';
    body += '<div class="row">';
    body += '<div class="col-md-12">';
    body += '<div class="form-group">'+
                '<label for="name">Name</label>'+
                '<input type="text" id="template_name" name="template_name" class="form-control">'+
            '</div></div>';

    body += '<div class="col-md-4">';
    body += '<div class="form-group">'+
                '<label for="template_format">Template Format</label>'+
                '<select id="template_format" name="template_format" class="form-control" style="width:100%">'+
                    '<option value="verticle" selected="selected">Portrait</option>'+
                    '<option value="horizontal">Landscape</option>'+
                '</select>'+
            '</div></div>';

    body += '<div class="col-md-4">';
    body += '<div class="form-group">'+
                '<label for="justification">Justification</label>'+
                '<select id="justification" name="justification" class="form-control" style="width:100%">'+
                    '<option value="L">Left</option>'+
                    '<option value="C" selected="selected">Center</option>'+
                    '<option value="R">Right</option>'+
                '</select>'+
            '</div></div>';

    body += '<div class="col-md-4">';
    body += '<div class="form-group">'+
                '<label for="template_type">Type</label>'+
                '<select id="template_type" name="template_type" class="form-control" style="width:100%">'+
                    '<option value="online" selected="selected">Online</option>'+
                    '<option value="f2f">Face to Face</option>'+
                    '<option value="blended_learning">Blended Learning</option>'+
                    '<option value="pathway">Pathway</option>'+
                    '<option value="webinar">Webinar</option>'+
                '</select>'+
            '</div></div>';

    body += '<div id="properties-mount" class="col-md-12"></div>';        

    body += '<div class="col-md-12">';
    body += '<h4>Upload Template File</h4>';
    // file field start ---/>
    body += '<div class="row mb_5">'+
                '<div id="file_upload_fields"></div>'+
            '</div>';
    // file field end ----/>            
    body += '</div>';

    body += '<div class="col-md-3">';
    body +=     '<button id="btn-save-certificate-template" class="btn btn-primary" onclick="saveCertificateTemplate('+templateId+'); return false;">Save Template</button>';
    body += '</div>';

    body += '<div id="template_preview_btn" class="col-md-3" style="margin-left: -58px;'+previewLinkStyle+'">';
    body +=     '<a id="btn-preview-certificate-template" class="btn btn-warning" '+previewTemplate+' target="_blank" href="'+previewLink+'">Preview Template</a>';
    body += '</div>';
    body += '</div>';

    body += '</div><div class="alert alert-certifications" style="margin-top: 12px; !important" role="alert" id="alert-course-certification"></div></div>';
    var footer = '';
    
    renderModal(type, title, body, footer);

    // clear files array when modal opens
    certificateFile = [];

    ajaxGetUploadFields();
  
}

function renderEditTemplateModal(templateId)
{
    renderCreateTemplateModal(templateId);

    var action = 'read_certificate_template';
    var token  = $("input[name=token]").val();

    $.ajax({
        url: '../cms/ajax_cms.php',
        dataType: "json",
        async: false,
        type: "post",
        data: {
            action: action,
            ptToken: token,
            template_id: templateId
        }
    }).done(function(data) {
        try {

            $('#template_name').val(data.name);
            $('#template_format').val(data.format);
            $('#justification').val(data.justification);
            $('#template_type').val(data.template_type);

            var fields       = data.fields;
            var templateType = data.template_type;
            addVenueProperties(templateType);

            for (var i = 1; i < fields.length; i++) {
                $('#inputX-axis'+i).val("");
                $('#inputY-axis'+i).val("");
                $('#inputWidth'+i).val("");
                $('#inputHeight'+i).val("");
                $('#inputFont-family'+i).val("");
                $('#inputFont-colour'+i).val("");
                $('#fontSize'+i).val("");
            }                        

            var fields = data.fields;
            for (var i = 0; i < fields.length; i++) {
                $('#inputX-axis'+fields[i].id).val(fields[i].xAxis);
                $('#inputY-axis'+fields[i].id).val(fields[i].yAxis);
                $('#inputWidth'+fields[i].id).val(fields[i].width);
                $('#inputHeight'+fields[i].id).val(fields[i].height);
                $('#inputFont-family'+fields[i].id).val(fields[i].font);
                $('#inputFont-colour'+fields[i].id).val(fields[i].font_colour);
                $('#fontSize'+fields[i].id).val(fields[i].font_size);
            }

            var hidePreviewBtn = true;

            for (var i = 0; (certificateLanguages.length > i); i++) {

                if ((data.lan_urls[certificateLanguages[i]] != null) && (data.lan_urls[certificateLanguages[i]] != '')) {
                    hidePreviewBtn = false;
                    $('#uploaded_pdf_file_'+certificateLanguages[i]).html('<i class="fas fa-check"></i><a class="uploaded-pdf-path-cc" href="'+data.lan_urls[certificateLanguages[i]]+'" target="_blank">'+"Template File"+'</a>');
                } else {
                    $('#uploaded_pdf_file_'+certificateLanguages[i]).html("");
                }
            }

            if (hidePreviewBtn) {
                $('#template_preview_btn').css('display', 'none');
            } else {
                $('#template_preview_btn').css('display', 'block');
                var previewLink = '../content/preview_pdf_certificate.php?template_id='+templateId;
                $('#template_preview_btn').html('<a id="btn-preview-certificate-template" class="btn btn-warning" target="_blank" href="'+previewLink+'">Preview Template</a>'); 
            }

        } catch(e) {
            console.log(e);
        }
    }).always(function() {
       
    });
}

$(document).on('change keyup', '#certificate-template-container .form-control', function() {

    $('#btn-preview-certificate-template').attr('disabled', 'disabled');
    $('#btn-preview-certificate-template').attr('onclick', 'return false;');
});

var certificateLanguages = [];
var languageList         = {'en':'English', 'ru':'Russian', 'fr':'French', 'es':'Spanish', 'ar':'Arabic', 'zhcn':'Chinese', 
'ja':'Japanese', 'pt':'Portuguese', 'vi':'Vietnamese', 'ko':'Korean', 'lb':'Luxembourgish', 'sv':'Swedish', 'fi':'Finnish', 'cs':'Czech', 
'it':'Italian', 'in':'Indonesian', 'tr': 'Turkish'};

function ajaxGetUploadFields() {
    var action = 'read_academy_languages';
    var token  = $("input[name=token]").val();

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: '../cms/ajax_cms.php',
        dataType: "json",
        async: false,
        type: "post",
        data: {
            action: action,
            ptToken: token
        }
    }).done(function(data) {
        try {
            certificateLanguages = data;
            renderCertificateUploads();             
        }
        catch(e) {
            console.log(e);
        }
    }).always(function() {
        cmsLoadingStatus = false;
    });
}

var props = [
    {
        'id'    : 1,
        'name'  : 'Participant Name Properties',
        'xAxis' : 10,
        'yAxis' : 101,
        'width' : 190,
        'height': 10,
        'fontSize': 20,
        'colour': '#000000'
    }, {
        'id': 2,
        'name': 'Course Name Properties',
        'xAxis' : 10,
        'yAxis' : 150,
        'width' : 190,
        'height': 10,
        'fontSize': 25,
        'colour': '#000000'
    }, {
        'id': 3,
        'name': 'Completed Date Properties',
        'xAxis' : 10,
        'yAxis' : 175,
        'width' : 190,
        'height': 20,
        'fontSize': 20,
        'colour': '#000000'
    }
];

function renderCertificateUploads() {
    var fileUploadFields = '';

    if (certificateLanguages.length == 0)
    {
        fileUploadFields = '<div class="col-md-7" style="margin-bottom: 5px;">Academy languages are not found!</div>';
    }

    for (var i = 0; (certificateLanguages.length > i); i++) {
        fileUploadFields += '<div class="col-md-7" style="margin-bottom: 5px;">'+
                                '<label>'+languageList[certificateLanguages[i]]+'</label>'+
                                '<div class="input-group">'+
                                    '<label class="input-group-btn">'+
                                        '<span class="btn btn-primary btn-block">Browse&hellip; '+
                                            '<input id="inputCertificate_'+certificateLanguages[i]+'" name="certificate_'+certificateLanguages[i]+'" class="generic-file-input inputCertificate form-control" type="file"  style="display: none;">'+
                                        '</span>'+
                                    '</label>'+
                                    '<input type="text" class="form-control" value="" readonly>'+
                                '</div>'+
                                '<div id="uploaded_pdf_file_'+certificateLanguages[i]+'" class="uploaded-pdf-cc"></div>'+
                            '</div>';
    }

    var formProperties = certificateProperties(props);

    $('#properties-mount').append(formProperties);
    $("#file_upload_fields").empty();
    $("#file_upload_fields").html(fileUploadFields); 
}

function certificateProperties(props) {
    
    var rows = '';
    props.map(function(items) {

        rows += '<h4>' + items.name + '</h4>'+
        '<div class="row">'+
            '<div class="col-md-2">'+
                '<div class="form-group">'+
                    '<label>X</label>'+
                    '<input type="number" id="inputX-axis' + items.id + '" name="x-axis" class="form-control" value="'+ items.xAxis +'">'+
                '</div>'+
            '</div>'+
            '<div class="col-md-2">'+
                '<div class="form-group">'+
                    '<label>Y</label>'+
                    '<input type="number" id="inputY-axis' + items.id + '" name="y-axis" class="form-control" value="'+ items.yAxis +'">'+
                '</div>'+
            '</div>'+
            '<div class="col-md-2">'+
                '<div class="form-group">'+
                    '<label>Width</label>'+
                    '<input type="number" id="inputWidth' + items.id + '" name="width" class="form-control" value="'+ items.width +'">'+
                '</div>'+
            '</div>'+
            '<div class="col-md-2">'+
                '<div class="form-group">'+
                    '<label>Height</label>'+
                    '<input type="number" id="inputHeight' + items.id + '" name="height" class="form-control" value="'+ items.height +'">'+
                '</div>'+
            '</div>'+
            '<div class="col-md-2">'+
                '<div class="form-group">'+
                    '<label>Font Family</label>'+
                     '<select id="inputFont-family' + items.id + '" name="font-family" class="form-control" style="width:100%">'+
                        '<option value="times" selected="selected">Times</option>'+
                        '<option value="arial">Arial</option>'+
                        '<option value="helvetica">Helvetica</option>'+
                        '<option value="cid0cs">Chinese</option>'+
                        '<option value="cid0jp">Japanese</option>'+
                        '<option value="cid0kr">Korean</option>'+
                    '</select>'+
                '</div>'+
            '</div>'+
            '<div class="col-md-2">'+
                '<div class="form-group">'+
                    '<label>Font Size</label>'+
                    '<input type="number" id="fontSize' + items.id + '" name="fontSize" class="form-control" value="'+ items.fontSize +'">'+
                '</div>'+
            '</div>'+
            '<div class="col-md-2">'+
                '<div class="form-group">'+
                    '<label>Font Colour</label>'+
                    '<input type="color" id="inputFont-colour' + items.id + '" name="font-colour" class="form-control" value="'+ items.colour +'">'+
                '</div>'+
            '</div>'+
        '</div>';
    });

    return rows;
}

$(document).on('change', '#template_type', function() {
    var templateType = $(this).val();
    addVenueProperties(templateType);
});

function addVenueProperties(templateType)
{
    if ((templateType == 'f2f') || (templateType == 'blended_learning') || (templateType == 'webinar')) {
        var obj         = {};
        obj["id"]       = 4;
        obj["name"]     = 'Venue Properties';
        obj["xAxis"]    = 10;
        obj["yAxis"]    = 200;
        obj["width"]    = 190;
        obj["height"]   = 10;
        obj["fontSize"] = 20;
        obj["colour"]   = '#000000';
        if (props.length <= 3) 
        {
            props.push(obj);     
        }
    }    

    if ((templateType == 'f2f') || (templateType == 'blended_learning') || (templateType == 'webinar')) {
        var objExp         = {};
        objExp["id"]       = 5;
        objExp["name"]     = 'Expiry Date Properties';
        objExp["xAxis"]    = 10;
        objExp["yAxis"]    = 200;
        objExp["width"]    = 190;
        objExp["height"]   = 10;
        objExp["fontSize"] = 20;
        objExp["colour"]   = '#000000';
        if (props.length <= 4) 
        {
            props.push(objExp);    
        }
            
    }

    var formProperties = certificateProperties(props);
    $('#properties-mount').html(formProperties);

   
}

// attach the `fileselect` event to all file inputs on the page
$(document).on('change', '.generic-file-input', function() {
    var input = $(this),
        numFiles = input.get(0).files ? input.get(0).files.length : 1,
        label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
    input.trigger('fileselect', [numFiles, label]);
});

// watch for our custom `fileselect` event
$(document).on('fileselect', '.generic-file-input', function(event, numFiles, label) {

    var input = $(this).parents('.input-group-btn').next(':text'),
        log = numFiles > 1 ? numFiles + ' files selected' : label;

    var fileName = event.target.files[0];
    var fileType = fileName['type'];

    if( input.length ) {
        input.val(log);
    } else {
        if(log) console.log(log); 
    }
});

// get the html name and data
$(document).on('change', '.inputCertificate', function(e) {

    var fileFileName = e.target.files[0];
    var fileType = fileFileName['type'];
    var fileName = fileFileName['name'];
    var fileSize = fileFileName['size'];
    var validFileTypes = ['application/pdf'];

    var id = $(this).attr('id');
    
    certificateFile.push({'id': id, 'file': e.target.files[0]});
    
    if (!validFileTypes.includes(fileType)) {
        alert('! Acceptable file types are: .pdf');
        return;
    }

    var reader = new FileReader();

    reader.onload = function(e) {
        
       let fileTempFile = e.target.result;
    }

    reader.readAsDataURL(fileFileName);
});


function saveCertificateTemplate(templateId) {
    cmsLoadingStatus = true;
    loadOverlay();

    var token          = $('input[name="token"]').val();
    var formData       = new FormData();

    formData.append('action', 'create_certificate_template');
    formData.append('ptToken', token);
    formData.append('template_id', templateId);    
      
    $('.modal-body').find('.form-control').each(function() {
        var ele = $(this);
        if ((!ele.attr('readonly')) && (!ele.hasClass('generic-file-input'))) {

            var name = ele.prop('id');
            var value = ele.val();
            formData.append(name, value);
        }
    });

    if (certificateFile.length) {
        $.each(certificateFile, function(i, file) {
            formData.append(file.id, file.file);
        });
        certificateFile = [];
    }

    $('#alert-course-certification').removeClass("alert-danger");
    $('#alert-course-certification').removeClass("alert-success");

    var template_name = $('#template_name').val();

    if (template_name == '')
    {
        cmsLoadingStatus = false;
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Template Name not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData
        }).done(function(data) {
            try {
                var templates      = data.templates;
                var hidePreviewBtn = true;
                for (var key of Object.keys(templates)) {
                    if ((templates[key] != '') && (templates[key] != null)) {
                        hidePreviewBtn = false;
                        $('#uploaded_pdf_file_'+key).html('<i class="fas fa-check"></i><a class="uploaded-pdf-path-cc" href="'+templates[key]+'" target="_blank">'+"Template File"+'</a>');
                    }
                }

                templateId = data.template_id;
                $("#btn-save-certificate-template").attr("onclick","saveCertificateTemplate('"+templateId+"')");

                if (hidePreviewBtn) {
                    $('#template_preview_btn').css('display', 'none');
                } else {
                    $('#template_preview_btn').css('display', 'block');
                    var previewLink = '../content/preview_pdf_certificate.php?template_id='+templateId;
                    $('#template_preview_btn').html('<a id="btn-preview-certificate-template" class="btn btn-warning" target="_blank" href="'+previewLink+'">Preview Template</a>'); 
                }

                $('#alert-course-certification').addClass("alert-success");
                $('#alert-course-certification').html("Template successfully saved!.");
                $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
            }
            catch(e) {
                console.log(e);
            }
        }).always(function() {
            cmsLoadingStatus = false;
            reload_certification_table();
        });
    }
}

function reload_certification_table()
{
    var data_url = "../cms/ajax_cms.php?action=read_certification_table&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $('#tbl_certificate_template').DataTable().ajax.url(data_url).load();
}

function reload_academy_administrators_table()
{
    var data_url = "../cms/ajax_cms.php?action=read_academy_administrators_table&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $('#tbl_academy_administrators').DataTable().ajax.url(data_url).load();
}

function reload_academy_valid_domain_table()
{
    var data_url = "../cms/ajax_cms.php?action=read_academy_registration_domains&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $("#tbl_registration_domains").DataTable().ajax.url(data_url).load();
}

function reload_academy_valid_email_table()
{
    var data_url = "../cms/ajax_cms.php?action=read_academy_registration_emails&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $("#tbl_registration_emails").DataTable().ajax.url(data_url).load();
}

function renderInvalidTokenModal(msg) {

    console.log(msg);

    if (cmsLoadingStatus)
    {
        cmsLoadingStatus = false;
    }

    var academyId = $.urlParam('academy');
     
    var newModal = Object.create(renderModalPrototype);
    newModal.dismiss = false;

    if (msg == 'Inputs contain invalid codes.')
    {
        newModal.title  = '<i class="fa fa-exclamation-triangle"></i> ' + msg;
        newModal.body   = '<p>' + msg + ' Please try again.</p>';
        newModal.footer = '<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>';
    }
    else
    {
        newModal.title = '<i class="fa fa-exclamation-triangle"></i> Session Time Out';
        newModal.body = '<p>Your Session has timed out, please log back in again</p>';
        newModal.body += '<p><a class="btn btn-default" href="/?academy=' + academyId + '&ogkm_logout=1">Please Login Again <i class="fa fa-arrow-right"></i></a></p>';
    }

    newModal.renderModal();
}


function reload_guided_learning_table() {
    var data_url = "../content/ajax_itf_common.php?action=read_all_questions&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $('#player_questions_cms').DataTable().ajax.url(data_url).load();
}

$(document).on('click', '.delete-btn-default', function(evt) {
    evt.stopImmediatePropagation();
    return confirm('Are you sure you want to delete this?');
});

$(document).on('click', '.copy_reset_password_link', function(evt) {

    cmsLoadingStatus = true;
    loadOverlay();

    var token    = $('input[name="token"]').val();
    var userId   = $(this).attr("data-user-id");
    var link     = $(this).attr("data-index");
    var alertMsg = '';

    $.ajax({
        url: '../content/ajax_user_management.php',
        dataType: "json",
        data: {
            action     : 'edit_password_temp_requested_date',
            ptToken    : token,
            user_id    : userId
        },
        success: function(data) {

            cmsLoadingStatus = false;    

            var temp = document.createElement('textarea');

            if (typeof link == "undefined")
            {
                var err = $(this).attr('data-err');
                if (err == 'null_source_academy')
                {
                    alertMsg = 'Source academy is not set. Please set source academy for this user and retry.';
                }
                else
                {
                    alertMsg = 'Error: Link not found';
                } 
                
                /*Clear previous copy*/
                temp.value = "-";         
            }
            else
            {  
                temp.value = link;  
                alertMsg = 'Link copied';     
            }

            document.body.appendChild(temp);    
            temp.select();
            document.execCommand('copy');
            document.body.removeChild(temp);
            
            alert(alertMsg);
        }
    }).always(function (dataOrjqXHR, textStatus, jqXHRorErrorThrown) { 
        cmsLoadingStatus = false;
    });
});

function publishSubAcademy()
{
    $('body').on('click', '.sub_academy_active', function() {

        var contentid    = $(this).attr("data-content-id");
        var availability = $(this).attr("data-content-availability");
        var button       = $(this);
        var svg          = button.find('.svg-inline--fa');
        var token        = $("input[name=token]").val();

        var action = "unpublish_sub_academy";

        if (availability === '0')
        {
            action = "publish_sub_academy";
        }

        svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");

        $.ajax({
            url: '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                sub_id  : contentid,
                action    : action,
                ptToken   : token
            },
            success: function(data)
            {
                try
                {
                    if (data.output != "")
                    {
                        setTimeout(function(){
                            if (action == "publish_sub_academy")
                            {
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-on fa-w-18 fa itf-icons-success ");
                                button.attr("data-original-title", "Deactivate user");
                            }
                            else
                            {
                                button.find('.svg-inline--fa').attr("class", "svg-inline--fa fa-toggle-off fa-w-18 fa");
                                button.attr("data-original-title", "Activate user");
                            }
                        },500);
                    }
                    else if(data.errormessage !== "")
                    {
                        alert(data.errormessage);
                    }
                    reload_sub_academy_table();
                }
                catch (e)
                {
                    alert("Something went wrong.");
                }
            }
        });
    });
}

function reload_sub_academy_table()
{ 
    var data_url = "../cms/ajax_cms.php?action=read_sub_academies&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $('#tbl_sub_academies').DataTable().ajax.url(data_url).load();
} 

function deleteSubAcademy(id)
{
    var ptToken      = $("input[name=token]").val();
    var action       = 'delete_sub_academy';

    var confirmation = confirm("Are you sure you want to delete this Sub Academy?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../cms/ajax_cms.php',
            dataType: "json",
            data: {
                action: action,
                ptToken: ptToken,
                sub_id: id
            },
            success: function (data)
            {
                reload_sub_academy_table();
                cmsLoadingStatus = false;
            }
        });
    }
}

$(document).on('change', '.academy-language', function() 
{
    var elementValue = $(this).val();

    if ($('#languages_live_'+elementValue+'').is(":checked"))
    {
        $('#div_academy_title_'+elementValue+'').show();
    }
    else
    {
        $('#div_academy_title_'+elementValue+'').hide();
    }
});

function submit_first_before_submissions()
{   
    var all_forms_elememts = [];
    var fieldValue;
    var fieldType = "";
    var fieldName = "";
    var label = "";
    $("#feedback-form input, #feedback-form textarea,  #feedback-form select, .rangeslider").each(function () {
        fieldType       = this.type;
        label           = $(this).parents('.field-wrapper').find(".field-label").text();
        if (($(this).hasClass("rangeslider")) && ($(window).width() < 768)) 
        {
            fieldValue = $(this).val();
            fieldName = $(this).prop("name");
            fieldType = 'radio';
            all_forms_elememts.push({name: fieldName, type: fieldType, value: fieldValue});
        }
        if ((fieldName != $(this).prop("name")) && ((this).type != "checkbox"))
        {
            if ((fieldType == "textarea") || (fieldType == "text") || (fieldType == "number") || (fieldType == "select-one"))
            {
                fieldName = $(this).prop("name");
                fieldValue = $(this).val();
                all_forms_elememts.push({name: fieldName, type: fieldType, value: fieldValue, label: label});
            }
            else if ((this.type == "radio") && ($(window).width() > 768)) 
            {
                fieldName = $(this).prop("name");
                fieldValue = $("input[name='" + fieldName + "']:checked").val();
                all_forms_elememts.push({name: fieldName, type: fieldType, value: fieldValue, label: label});
            }
            else
            {
                fieldValue = $(this).value;
            }

            if (fieldValue == null)
            {
                fieldValue = "";
            }

            if (fieldType == "hidden") 
            {
                fieldName = $(this).prop("name");
                fieldValue = $(this).val();
                all_forms_elememts.push({name: fieldName, type: fieldType, value: fieldValue, label: label});
            }   
        }
        else
        {
            fieldName = $(this).prop("name");
            if (this.type == "checkbox")
            {
                if ($(this).is(":checked"))
                {
                    fieldValue = "Yes";
                    all_forms_elememts.push({name: fieldName, type: fieldType, value: fieldValue, label: label});
                }
                else
                {
                    fieldValue = "No";
                    all_forms_elememts.push({name: fieldName, type: fieldType, value: fieldValue, label: label});
                }
            }
            
        }
    });
    return all_forms_elememts; 
}

function renderAcademyAdministrators(id) {
    var type  = 'modal-lg';
    var title = 'Add Academy Administrator';
    var body  = '<div class="modal-body">';
    var previewTemplate  = 'disabled'
    var previewLink      = '';
    var previewLinkStyle = "display:none;";
    
    body += '<div id="certificate-template-container">';
    body += '<div class="row">';
    body += '<div class="col-md-12">';
    body += '<div class="form-group">'+
                '<label for="name">Email</label>'+
                '<input type="text" id="email" name="email" class="form-control">'+
            '</div></div>';

    body += '<div class="col-md-3">';
    body +=     '<button id="btn-save-certificate-template" class="btn btn-primary" onclick="saveAcademyAdministrator('+id+'); return false;">Add Email</button>';
    body += '</div>';

    body += '</div>';

    body += '</div><div class="alert alert-certifications" style="margin-top: 12px; !important" role="alert" id="alert-course-certification"></div></div>';
    var footer = '';
    
    renderModal(type, title, body, footer);  
}

function renderAcademyRegistrationDomains(id) {
    var type  = 'modal-lg';
    var title = 'Add Academy Valid Domain';
    var body  = '<div class="modal-body">';
    var previewTemplate  = 'disabled'
    var previewLink      = '';
    var previewLinkStyle = "display:none;";
    
    body += '<div id="certificate-template-container">';
    body += '<div class="row">';
    body += '<div class="col-md-12">';
    body += '<div class="form-group">'+
                '<label for="name">Domain</label>'+
                '<input type="text" id="domain" name="domain" class="form-control">'+
            '</div></div>';

    body += '<div class="col-md-3">';
    body +=     '<button id="btn-save-certificate-template" class="btn btn-primary" onclick="saveAcademyDomain('+id+'); return false;">Add Domain</button>';
    body += '</div>';

    body += '</div>';

    body += '</div><div class="alert alert-certifications" style="margin-top: 12px; !important" role="alert" id="alert-course-certification"></div></div>';
    var footer = '';
    
    renderModal(type, title, body, footer);  
}

function renderAcademyRegistrationEmails(id) {
    var type  = 'modal-lg';
    var title = 'Add Academy Valid Emails';
    var body  = '<div class="modal-body">';
    var previewTemplate  = 'disabled'
    var previewLink      = '';
    var previewLinkStyle = "display:none;";
    
    body += '<div id="certificate-template-container">';
    body += '<div class="row">';
    body += '<div class="col-md-12">';
    body += '<div class="form-group">'+
                '<label for="name">Email</label>'+
                '<input type="text" id="email" name="email" class="form-control">'+
            '</div></div>';

    body += '<div class="col-md-3">';
    body +=     '<button id="btn-save-certificate-template" class="btn btn-primary" onclick="saveAcademyEmail('+id+'); return false;">Add Emails</button>';
    body += '</div>';

    body += '</div>';

    body += '</div><div class="alert alert-certifications" style="margin-top: 12px; !important" role="alert" id="alert-course-certification"></div></div>';
    var footer = '';
    
    renderModal(type, title, body, footer);  
}

function renderAccreditationTypes(id) {
        var type  = 'modal-lg';
        var title = 'Add Academy Accreditation Types';
        var body  = '<div class="modal-body">';
        var previewTemplate  = 'disabled'
        var previewLink      = '';
        var previewLinkStyle = "display:none;";
        
        body += '<div id="certificate-template-container">';
        body += '<div class="row">';
        body += '<div class="col-md-12">';
        body += '<div class="form-group">'+
                    '<label for="name">Name</label>'+
                    '<input type="text" id="name" name="name" class="form-control">'+
                '</div></div>';

        body += '<div class="col-md-3">';
        body +=     '<button id="btn-save-certificate-template" class="btn btn-primary" onclick="saveAcademyAccreditation('+id+'); return false;">Add Accreditation Types</button>';
        body += '</div>';

        body += '</div>';

        body += '</div><div class="alert alert-certifications" style="margin-top: 12px; !important" role="alert" id="alert-course-certification"></div></div>';
        var footer = '';
        renderModal(type, title, body, footer);  
}   

function saveAcademyAdministrator(id) {
    cmsLoadingStatus = true;
    loadOverlay();

    var token     = $('input[name="token"]').val();
    var formData  = new FormData();
    var academyId = $("input[name=academy]").val();
    var email     = $('#email').val();

    formData.append('action', 'create_academy_administrator');
    formData.append('ptToken', token);
    formData.append('academy_id', academyId);  
    formData.append('email', email);        

    $('#alert-course-certification').removeClass("alert-danger");
    $('#alert-course-certification').removeClass("alert-success");

    if (email == '')
    {
        cmsLoadingStatus = false;
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Email not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData
        }).done(function(data) {
            try {
                if (data.error != '')
                {
                    $('#alert-course-certification').addClass("alert-danger");
                    $('#alert-course-certification').html(data.error);
                    $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
                }
                else
                {
                    $('#alert-course-certification').addClass("alert-success");
                    $('#alert-course-certification').html(data.success);
                    $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
                }
            }
            catch(e) {
                console.log(e);
            }
        }).always(function() {
            cmsLoadingStatus = false;
            reload_academy_administrators_table();
        });
    }
}

function saveAcademyDomain(id) {
    cmsLoadingStatus = true;
    loadOverlay();

    var token     = $('input[name="token"]').val();
    var formData  = new FormData();
    var academyId = $("input[name=academy]").val();
    var domain    = $('#domain').val();

    formData.append('action', 'create_academy_valid_domain');
    formData.append('ptToken', token);
    formData.append('academy_id', academyId);  
    formData.append('domain', domain);        

    $('#alert-course-certification').removeClass("alert-danger");
    $('#alert-course-certification').removeClass("alert-success");

    if (domain == '')
    {
        cmsLoadingStatus = false;
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Domain not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData
        }).done(function(data) {
            try {
                if (data.error != '')
                {
                    $('#alert-course-certification').addClass("alert-danger");
                    $('#alert-course-certification').html(data.error);
                    $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
                }
                else
                {
                    $('#alert-course-certification').addClass("alert-success");
                    $('#alert-course-certification').html(data.success);
                    $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
                }
            }
            catch(e) {
                console.log(e);
            }
        }).always(function() {
            cmsLoadingStatus = false;
            reload_academy_valid_domain_table();
        });
    }
}

function saveAcademyEmail(id) {
    cmsLoadingStatus = true;
    loadOverlay();

    var token     = $('input[name="token"]').val();
    var formData  = new FormData();
    var academyId = $("input[name=academy]").val();
    var email    = $('#email').val();

    formData.append('action', 'create_academy_valid_email');
    formData.append('ptToken', token);
    formData.append('academy_id', academyId);  
    formData.append('email', email);        

    $('#alert-course-certification').removeClass("alert-danger");
    $('#alert-course-certification').removeClass("alert-success");

    if (email == '')
    {
        cmsLoadingStatus = false;
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Email not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData
        }).done(function(data) {
            try {
                if (data.error != '')
                {
                    $('#alert-course-certification').addClass("alert-danger");
                    $('#alert-course-certification').html(data.error);
                    $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
                }
                else
                {
                    $('#alert-course-certification').addClass("alert-success");
                    $('#alert-course-certification').html(data.success);
                    $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
                }
            }
            catch(e) {
                console.log(e);
            }
        }).always(function() {
            cmsLoadingStatus = false;
            reload_academy_valid_email_table();
        });
    }
}

function saveAcademyAccreditation(id) {
    cmsLoadingStatus = true;
    loadOverlay();

    var token     = $('input[name="token"]').val();
    var formData  = new FormData();
    var academyId = $("input[name=academy]").val();
    var name    = $('#name').val();

    formData.append('action', 'save_academy_accreditation_types');
    formData.append('ptToken', token);
    formData.append('academy_id', academyId);  
    formData.append('name', name);        

    $('#alert-course-certification').removeClass("alert-danger");
    $('#alert-course-certification').removeClass("alert-success");

    if (name == '')
    {
        cmsLoadingStatus = false;
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Name not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData
        }).done(function(data) {
            try {
                    $('#alert-course-certification').addClass("alert-success");
                    $('#alert-course-certification').html(data.success);
                    $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
            }
            catch(e) {
                console.log(e);
            }
        }).always(function() {
            cmsLoadingStatus = false;
            location.reload();
        });
    }
}

function renderEditVoucherExpiryDateModal(voucher_id, expiry_date, functionType, voucher_quantity, number_of_uses, notes)
{
    renderEditVoucherExpiryDateTemplate(voucher_id, expiry_date, functionType, voucher_quantity, number_of_uses, notes);
}

function renderEditVoucherExpiryDateTemplate(voucher_id, expiry_date, functionType, voucher_quantity, number_of_uses, notes)
{
    var type  = 'modal-md';
    var title = 'Update Voucher Details';

    if (functionType == 2)
    {
        title += ' - Batch ID : '+voucher_id+' ('+voucher_quantity+' Vouchers)';
    }

    var body  = '<div class="modal-body">';
    var previewTemplate  = 'disabled'
    var previewLink      = '';
    var previewLinkStyle = "display:none;";
    
    body += '<div id="certificate-template-container">';
    body += '<div class="row">';
    body += '<div class="col-md-6">';
    body += '<div class="form-group">'+
                '<label for="name">Expiry Date</label>'+
                '<input type="date" class="form-control" data-parsley-mindate="1970-01-01" name="voucher_expiry_date" id="voucher_expiry_date" required />'+
            '</div></div>';

    body += '<div class="col-md-6">';
    body += '<div class="form-group">'+
                '<label for="name">Number of Uses</label>'+
                '<input type="number" class="form-control" id="number_of_uses" name="number_of_uses" min="1" max="9999999999" required />'+
            '</div></div>';

    body += '<div class="col-md-12">';
    body += '<div class="form-group">'+
                '<label for="name">Notes</label>'+
                '<textarea class="form-control" id="notes" name="notes" rows="4" required></textarea>'+
            '</div></div>';

    body += '<div class="col-md-3">';
    body +=     '<button id="btn-save-certificate-template" class="btn btn-primary" onclick="saveVoucherExpiryDate('+voucher_id+', '+functionType+'); return false;">Save</button>';
    body += '</div>';

    body += '</div>';

    body += '</div><div class="alert alert-certifications" style="margin-top: 12px; !important" role="alert" id="alert-course-certification"></div></div>';
    var footer = '';
    
    renderModal(type, title, body, footer);
    $('#voucher_expiry_date').val(expiry_date);
    $('#number_of_uses').val(number_of_uses);
    $('#notes').val(notes);
}

function saveVoucherExpiryDate(voucher_id, functionType) {
    cmsLoadingStatus = true;
    loadOverlay();

    var token     = $('input[name="token"]').val();
    var formData  = new FormData();
    var voucher_expiry_date = $('#voucher_expiry_date').val();
    var number_of_uses      = $('#number_of_uses').val();
    var notes               = $('#notes').val();

    formData.append('action', 'update_voucher_expiry_date');
    formData.append('ptToken', token);

    if (functionType == 2)
    {
        formData.append('batch_id', voucher_id);    
    }
    else if (functionType == 1)
    {
        formData.append('voucher_id', voucher_id);    
    }

    formData.append('voucher_expiry_date', voucher_expiry_date);
    formData.append('function_type', functionType);
    formData.append('number_of_uses', number_of_uses);
    formData.append('notes', notes);

    $('#alert-course-certification').removeClass("alert-danger");
    $('#alert-course-certification').removeClass("alert-success");

    if (voucher_expiry_date == '')
    {
        cmsLoadingStatus = false;
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Expiry Date not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else if ((number_of_uses == '') || (number_of_uses == 0))
    {
        cmsLoadingStatus = false;
        $('#alert-course-certification').addClass("alert-danger");
        $('#alert-course-certification').html("Error : Number of Users not found!");
        $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
    }
    else
    {
        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData
        }).done(function(data) {
            try {
                if (data.error != '')
                {
                    $('#alert-course-certification').addClass("alert-danger");
                    $('#alert-course-certification').html(data.error);
                    $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);
                }
                else
                {
                    $('#alert-course-certification').addClass("alert-success");
                    $('#alert-course-certification').html(data.success);
                    $("#alert-course-certification").fadeIn(300).delay(1500).fadeOut(400);

                    if (functionType == 1)
                    {
                        $('#expiry_date_div_'+voucher_id).html(voucher_expiry_date);
                        $('#number_of_uses_div_'+voucher_id).html(number_of_uses);
                    }
                    $('#note_div_'+voucher_id).html(notes);

                    setTimeout(function(){
                        location.reload();
                    }, 500);                    
                }
            }
            catch(e) {
                console.log(e);
            }
        }).always(function() {
            cmsLoadingStatus = false;          
        });
    }
}

function readFeedbackFormInfo(courseId)
{
    cmsLoadingStatus = true;
    loadOverlay();

    var token     = $('input[name="token"]').val();
    var formData  = new FormData();
    formData.append('action', 'read_feedback_info');
    formData.append('ptToken', token);
    formData.append('course_id', courseId);

    $('#alert-course-certification').removeClass("alert-warning");

    $.ajax({
        url: '../cms/ajax_cms.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData
    }).done(function(data) {
        try {

            if (data.error != '')
            {
                $('#alert-course-certification').addClass("alert-warning");
                $('#alert-course-certification').html(data.error);
                $('#alert-course-certification').show();
            }
            else
            {
                $('#alert-course-certification').hide();
                $('#programmeId').val(data.programme_id);
                $('#feedback_form_id').val(data.feedback_form_id);       
            }

            $('#feedback-report-area').html(data.report);
        }
        catch(e) {
            console.log(e);
        }
    }).always(function() {
        cmsLoadingStatus = false;
    });
}

$(document).on('click', '#btn-download-csv-report', function() {
    downloadFeedbackFormResults('csv');
});

$(document).on('click', '#btn-download-excel-report', function() {
    downloadFeedbackFormResults('excel');
});

function downloadFeedbackFormResults(type) {
    const currentDate = getCurrentDate();
    const ext = (type === 'csv') ? '.csv' : '.xlsx';
    const action = (type === 'csv') ? 'download_all_results_csv' : 'download_all_results_excel';
    const filename = "../fileshare/files/feedback_raw_all_"+ currentDate + ext;

    var token          = $('input[name="token"]').val();
    var courseId       = $('input[name="courseId"]').val();
    var programmeId    = $('input[name="programmeId"]').val();
    var feedbackFormId = $('input[name="feedback_form_id"]').val();

    $.post("../course_admin/ajax_get_course_function.php", 
    {   
        function_value: action,
        ptToken: token,
        course_id: courseId,
        programme_id: programmeId,
        form_id: feedbackFormId,
        file_name: filename,
        feedback_type: 'attendee'
    }, 
    function (result) {
        if (result == '<label>No feedback forms have been completed.</label>') {
            result = result.replace("<label>", "");
            result = result.replace("</label>", "");
            alert(result);
        } else {
            location.href = filename;
        }
    }); 
}

$(document).on('click', '.delete-custom-text', function() {
    var entryId             = $(this).attr("data-entry-id");
    var override_entry_id   = $(this).attr("data-content-id");
    var token               = $('input[name="token"]').val();
    var decision            =  confirm('Are you sure you want to delete this?');
    if (decision)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        var formData = new FormData();
        formData.append('action', 'delete_academy_generic_text');
        formData.append('ptToken', token);
        formData.append('entry_id', entryId);
        formData.append('override_entry_id', override_entry_id);
        
        $.ajax({
            url: '../cms/ajax_cms.php',
            type: "post",
            dataType: "json",
            contentType: false,
            cache: false,
            processData: false,
            data: formData,
            success: function(data)
            {
                cmsLoadingStatus = false;
                reload_terminology_table();
            }
        });
    }
});

$(document).on('click', '.collapse-sidebar-nav', function() {

    var width = $(window).width();

    if (width > 768) {
        $('body').toggleClass('collapse-sidebar');
        $('body').toggleClass('sidebar-collapse');
        $('body').removeClass('mobile-collapse-sidebar');
    } else {
        $('body').removeClass('collapse-sidebar');
        $('body').removeClass('sidebar-collapse');
        $('body').toggleClass('mobile-collapse-sidebar');
    }

    if ($('body').hasClass('collapse-sidebar')) {
        $('.sb-nav-item').tooltip({
            // placement: 'right'
        });
    } else {
        $('.sb-nav-item').tooltip('dispose');
    }

});

$(document).on('click', '#btn-mobile-close', function() {
    
    $('body').toggleClass('mobile-collapse-sidebar');

});

function startOTPTimer(duration, display) {
    var timer = duration, minutes, seconds;
    var x = setInterval(function () {
        minutes = parseInt(timer / 60, 10)
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = minutes + ":" + seconds;

        if (--timer < 0) {
            clearInterval(x);
            $("#resend-otp-div").html('<button id="otp-resend-btn" type="button" class="btn btn-default">Resend OTP</button>');
        }
    }, 1000);
}

$(document).on('click', '#otp-resend-btn', function() {

    cmsLoadingStatus = true;
    loadOverlay();

    var token = $('input[name="token"]').val();

    var formData = new FormData();
    formData.append('ptToken', token);
    
    $.ajax({
        url: '../admin/ajax_otp.php',
        type: "post",
        dataType: "json",
        contentType: false,
        cache: false,
        processData: false,
        data: formData,
        success: function(data)
        {
            cmsLoadingStatus = false;

            if (data.error) {
                renderInvalidTokenModal(data.error);
            } else {
                $("#resend-otp-div").html('Resend OTP (<span id="time">01:00</span>)');
                var display = document.querySelector('#time');
                startOTPTimer(60, display);
            }
        }
    });
});

$(document).on('click', '.is-optional-course', function() 
{
    cmsLoadingStatus = true;
    loadOverlay();

    var certificationId = $(this).attr("data-id");
    var contentid       = $(this).attr("data-content-id");
    var isOptional      = $(this).attr("data-content-is-optional");
    var button          = $(this);
    var svg             = button.find('.svg-inline--fa');

    var token           = $("input[name=token]").val();
    var action          = "make_mandatory_course";

    if (isOptional == '0')
    {
        action = "make_optional_course";
    }

    svg.attr("class", "svg-inline--fa fa-spinner fa-w-16 fa-fw fa-pulse spinner-btn");


    $.ajax({
        url: '../cms/ajax_cms.php',
        dataType: "json",
        data: {
            id        : contentid,
            action    : action,
            ptToken   : token
        },
        success: function(data)
        {
            cmsLoadingStatus = false;
            loadCertificationFormData(certificationId);
            reload_Certifications_table();     
        }
    });
});

$(document).on('click', '#download-inline-answers', function() 
{
    var token    = $('input[name="pToken"]').val();
    var courseId = $('input[name="course_id"]').val();
    window.open('/cms/ajax_cms.php?action=download_inline_answers&ptToken='+token+'&course_id='+courseId+"&type=user");
});

$(document).on('click', '#download-inline-answers-courses-page', function() 
{
    var token    = $('input[name="token"]').val();
    var courseId = $(this).attr('data-attr');
    window.open('/cms/ajax_cms.php?action=download_inline_answers&ptToken='+token+'&course_id='+courseId+"&type=user");
});

function downloadInlineAnswers(courseId, userId)
{
    var ptToken = $("input[name=token]").val();
    window.open('/cms/ajax_cms.php?action=download_inline_answers_admin&ptToken='+ptToken+'&course_id='+courseId+"&user_id="+userId);
}

$(document).on('click', '#btn-form-share', function() {
    waos.new = false;
    const formId = $(this).parent('.btn-group').data('id');
    waos.formId = formId;
    renderModalFormShare('Share Form', formId);
});

function renderModalFormShare(title, formId) {

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: '../cms/ajax_cms.php',
        dataType: "json",
        data: {
            action    : "read_form_share_link",
            ptToken   : globalVars.token,
            form_id   : formId
        },
        success: function(data)
        {
            cmsLoadingStatus = false;
            
            const modal = Object.create(renderModalPrototype);
            modal.title = title;

            var form = '<div class="row"><div class="col-sm-12"><p><i class="fas fa-link"></i> <b>Share a form link</b></p></div>';
            form += '<div class="col-sm-12"><button id="copy_form_link" class="btn btn-secondary mb_5" data-link="'+data.output.link+'"><i class="fa fa-copy"></i> Copy Form Link</button></div>';
            form += '<div class="col-sm-12"><p>Copy and paste this link anywhere to share your form.<br>For example, paste it in an email, on a website, or share it on social media.</p></div></div>';
            modal.body = form;
            modal.renderModal();
        }
    });
}

$(document).on('click', '#copy_form_link', function() {
    var temp = document.createElement('textarea');
    var link = $(this).attr("data-link");
    temp.value = link;

    document.body.appendChild(temp);    
    temp.select();
    document.execCommand('copy');
    document.body.removeChild(temp);

    alert('Link copied to clipboard.');
});

$(document).on('click', '#btn-form-view-submissions', function() {
    waos.new = false;
    const formId = $(this).parent('.btn-group').data('id');
    waos.formId = formId;
    renderModalFormSubmissions('Form Submissions', formId);
});

function renderModalFormSubmissions(title, formId) {

    cmsLoadingStatus = true;
    loadOverlay();

    $.ajax({
        url: '../cms/ajax_cms.php',
        dataType: "json",
        data: {
            action    : "read_form_submissions",
            ptToken   : globalVars.token,
            form_id   : formId
        },
        success: function(data)
        {
            cmsLoadingStatus = false;
            
            const modal = Object.create(renderModalPrototype);
            modal.title = title;
            modal.size  = 'modal-xl';
            modal.body  = data.output.submission_tabel;
            modal.renderModal();

            submission_tabel = $('#submission_tabel').DataTable({                      
                
                "responsive": {
                    // details: {
                    //     type: 'column',
                    //     target: 'tr'
                    // }
                    details: {
                        type: 'column',
                        target: -1
                    }
                },
                "scrollX": true,
                "pageLength": 10,
                "columnDefs": [
                { "targets": 1, "visible": false },
                {
                    className: 'dtr-control',
                    orderable: false,
                    targets:   -1
                },
                {
                    "orderable": false,
                    "className": 'select-checkbox',
                    "targets": 0
                }],
                "select": {
                    "style": 'multi'
                },
                "order": [[ 1, 'asc' ]],
                dom: 'Blfrtip',
                buttons: [
                    'selectAll',
                    'selectNone',
                ],
                language: {
                    buttons: {
                        selectAll: "Select all items",
                        selectNone: "Select none"
                    }
                }
            });

            $(".buttons-select-all").on('click', function(event){
                $('#download_form_submissions').show();
            });

            $(".buttons-select-none").on('click', function(event){
                $('#download_form_submissions').hide();
            });       

            submission_tabel.on('user-select', function (e, dt, type, cell, originalEvent) {
                $('#download_form_submissions').show();
            });  
        }
    });
}

$(document).on('click', '#download_form_submissions', function() {
    var selectedItems    = submission_tabel.rows( { selected: true } ).data();
    var selectedItemsArr = [];

    selectedItems.map(items => {
        selectedItemsArr.push(items[1]);
    });

    if(selectedItemsArr.length === 0) {
        alert("Please select submissions from below table.");
    } else {
        var submission_ids = selectedItemsArr.toString();
        console.log(submission_ids);
        var form_id        = $(this).attr("data-id");
        window.open('/cms/ajax_cms.php?action=download_form_submissions&ptToken='+globalVars.token+'&form_id='+form_id+'&submission_ids='+submission_ids);
    }    
});

$(document).on('change', '#level_of_english', function() {
    var value = $(this).val();
    if (value === 'English_is_not_my_native_language_but_I_do_not_have_a_language_certificate') {
        $('#div_no_language_certificate').show();
    } else {
        $('#div_no_language_certificate').hide();
    }

    if (value === 'English_is_not_my_native_language_but_I_do_have_a_language_certificate') {
        $('#div_language_certificate').show();
    } else {
        $('#div_language_certificate').hide();
    }
});

$(document).on('change', '#scholarship_question', function() {
    var value = $(this).val();
    if (value === 'Yes') {
        $('#div_yes_scholarship_question').show();
    } else {
        $('#div_yes_scholarship_question').hide();
    }
});

$(document).on('click', '#billed-monthly-btn', function() {
    $('.billed-monthly').show();
    $('.billed-yearly').hide();
});

$(document).on('click', '#billed-yearly-btn', function() {
    $('.billed-yearly').show();
    $('.billed-monthly').hide();  
});


function formatDate(date) 
{
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('/');
}

    

$(document).on('click', '.edit-academy-subscription', function() {
    var academy_id = $(this).attr("data-academy-id");  
    var plan_id    = $(this).attr("data-content-id");        
    editAcademySubsDetails(academy_id, plan_id);
});

function editAcademySubsDetails(academy_id, plan_id)
{
    $('#edit-academy-subscription-details-modal').remove();
    var output = 
    '<div id="edit-academy-subscription-details-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-lg" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title" id="academy_title">Edit</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="first-name">Change Plan</label>'+
                                 '<select class="form-control" name="chosen-plan" id="chosen-plan">'+
                                '</select>'+
                            '</div>'+
                        '</div>'+
                        
                '</div>'+
                '<div class="modal-footer">'+
                    '<button type="button" data-academy-id="'+ academy_id +'" class="btn btn-primary" id="save-academy-btn">Save</button>'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#edit-academy-subscription-details-modal').modal('show');
    loadAcademyDetailsFormData(academy_id, plan_id);
}

function loadAcademyDetailsFormData(academy_id, plan_id)
{
    cmsLoadingStatus = true;
    loadOverlay();
    var action   = "read_subscription_academy";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action      : action,
            token       : token,
            academy_id  : academy_id,
            plan_id     : plan_id            
        },
        success: function(data)
        {
            var user    = data.plans[0];
            console.log(data.academy_name);
            $("#chosen-plan").html(user);
            $("#academy_title").html(data.academy_name);
            cmsLoadingStatus = false;
        }
    });
}

$(document).on('click', '#save-academy-btn', function() {
    var academy_id  = $(this).attr("data-academy-id");  
    var plan_id     = $('#chosen-plan').val();        
    cmsLoadingStatus = true;
    loadOverlay();
    var action   = "create_subscription_academy";
    var token    = $("input[name=token]").val();

     $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action      : action,
            token       : token,
            academy_id  : academy_id,
            plan_id     : plan_id            
        },
        success: function(data)
        {          
            cmsLoadingStatus = false;
            read_academy_subscriptions_table();
            $('#edit-academy-subscription-details-modal').remove();
            $('.modal-backdrop').remove();
        }
    });
});


function renderModalUserAnalytics(userId, name)
{
    $('#table-report-data-modal').remove();
    var output = 
    '<div class="modal fade bd-example-modal-lg" id="table-report-data-modal" tabindex="-1" role="dialog">'+
    '<div class="modal-dialog modal-lg" role="document">'+
        '<div class="modal-content">'+
            '<div class="modal-header">'+
             '<h5 id="user-itf-rpt-modal-header" class="modal-title">User Information</h5>'+
               '<button type="button" class="close" id="close-btn-table" data-dismiss="modal" aria-label="Close">'+
                 '<span aria-hidden="true">&times;</span></button>'+
            '</div>'+
            '<div class="modal-body" id="table-user-info-wrapper">'+
                '<table id="user_info_itf_dt" class="table table-bordered">'+
                    '<thead>'+
                        '<th>Content</th>'+
                        '<th>Status</th>' +
                        '<th>Views</th>'+
                    '</thead>'+
                    '<tbody id="user-itf-table-info">'   +                    
                    '</tbody>'+
                '</table>'+
            '</div>'+
        '</div>'+
    '</div>'+
    '</div>';

    $('body').append(output);
    $('#table-report-data-modal').modal('show');
    loadUserAnalyticsFormData(userId, name);
}

function loadUserAnalyticsFormData(userId, name)
{
    var token    = $('input[name="token"]').val();
    cmsLoadingStatus = true;
    loadOverlay();

    var action   = "get_user_details_report";

    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {

            action      : action,
             user_id         : userId,
            token           : token,
            action          : action               
        },
        success: function(data)
        {
            try
            {               
                if (data.output)
                {                              
                    var user_info = name + ' content views history.';    
                    $('#user-itf-table-info').html();
                    $('#user-itf-table-info').html(data.output);
                    $('#user-itf-rpt-modal-header').text(user_info);
                    $('#user_info_itf_dt').dataTable({
                        "pageLength": 5
                    });
                    cmsLoadingStatus = false;
                }
                else
                {
                    cmsLoadingStatus = false;
                }

                if(data.error)
                {
                   alert("There was an error encountered. Please contact system administrator");
                }

            }
            catch (e)
            {
                console.log(e);
                alert("Something went wrong.");
            }
        },
        complete: function()
        {

        }

    });
}

function read_academy_subscriptions_table()
{
    var academyId = $("input[name=academy]").val();
    var data_url  = "../content/ajax_itf_common.php?action=read_academy_subscriptions_table&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $("#academy_plans_table").DataTable({
        destroy: true,
        "ajax": data_url,      
        "order": [1, 'desc']   
    });
      
}

$(document).on('click', '#slider_config_save_btn', function() {
    
    cmsLoadingStatus = true;
    loadOverlay();
    var ptToken         = $("input[name=token]").val();
    var sliderImage     = document.querySelector('input[name="academy_slider_image"]').files[0];
    var formData        = new FormData();
    formData.append('file', sliderImage);
    formData.append('token', ptToken);
    formData.append('action', "upload_slider_images");
 
    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        type: "post",        
        data: formData,
        contentType: false,
        cache: false,
        processData:false,
        data: formData,
        success: function(data)
        {          
            console.log(data);
            if (data == 'Success')
            {
                $('#alert-whitlelabel').html("Configurations successfully inserted!");
            }
            else
            {                
                $('#alert-whitlelabel').html("Configurations successfully updated!");
            }           

            $("#alert-whitlelabel").fadeIn(300).delay(1500).fadeOut(400);          
            location.reload();
            cmsLoadingStatus = false;            
        }
    });
});

$(document).on('click', '.edit-sub-academy-subscription', function() {
    var member_id = $(this).attr("data-academy-id");  
    var plan_id    = $(this).attr("data-content-id");        
    editSubAcademySubsDetails(member_id);
});

function editSubAcademySubsDetails(member_id)
{
    $('#edit-sub-academy-subscription-details-modal').remove();
    var output = 
    '<div id="edit-sub-academy-subscription-details-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-lg" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title" id="academy_title">Edit</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'+
                        '<div class="col-sm-4">'+
                            '<div class="form-group">'+
                                '<label for="first-name">Assign Sub Academies</label>'+
                                 '<select class="form-control" name="chosen-sub-academy[]" id="chosen-sub-academy" multiple="multiple">'+
                                '</select>'+
                            '</div>'+
                        '</div>'+
                        
                '</div>'+
                '<div class="modal-footer">'+
                    '<button type="button" data-academy-id="'+ member_id +'" class="btn btn-primary" id="save-sub-academy-btn">Save</button>'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#edit-sub-academy-subscription-details-modal').modal('show');
    loadAcademySubDetailsFormData(member_id);
}

function loadAcademySubDetailsFormData(member_id)
{
    cmsLoadingStatus = true;
    loadOverlay();
    var action   = "read_member_subscription_academy";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action      : action,
            token       : token,
            member_id  : member_id
        },
        success: function(data)
        {
            
            console.log(data["data"]);
            // $("#chosen-plan").html(user);
            // $("#academy_title").html(data.academy_name);
            $("#chosen-sub-academy").html(data["data"]);
            $("#chosen-sub-academy").select2({
                    placeholder: 'Sub Academy Access',
                    theme: "bootstrap-5",
                    dropdownParent: $('#edit-sub-academy-subscription-details-modal .modal-body')
                });
            cmsLoadingStatus = false;
        }
    });
}


$(document).on('click', '#save-sub-academy-btn', function() {
    var member_id      = $(this).attr("data-academy-id");  
    var plan_id         = $('#chosen-sub-academy').val();        
    cmsLoadingStatus    = true;
    loadOverlay();
    var action   = "create_subacademy_subscription_academy";
    var token    = $("input[name=token]").val();

     $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action      : action,
            token       : token,
            member_id   : member_id,
            plan_id     : plan_id            
        },
        success: function(data)
        {          
            cmsLoadingStatus = false;
            read_sub_academy_subscriptions_table();
            $('#edit-sub-academy-subscription-details-modal').remove();
            $('.modal-backdrop').remove();
        }
    });
});

function read_sub_academy_subscriptions_table()
{
    var academyId = $("input[name=academy]").val();
    var data_url  = "../content/ajax_itf_common.php?action=read_sub_academy_subscriptions&token="+$("input[name=token]").val();
    $("#sub_academy_member_table").DataTable({
        destroy: true,
        "ajax": data_url
    });
      
}

$(document).on('click', '.edit-user-sub-academy-details', function() {
    var snow_id     = $(this).attr("data-snow-id");  
    var user_id     = $(this).attr("data-content-id");        
    editUserSubAcademyDetails(snow_id, user_id);
});

function editUserSubAcademyDetails(snow_id, user_id)
{
    $('#edit-user-sub-academy-details-modal').remove();
    var output = 
    '<div id="edit-user-sub-academy-details-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">'+
        '<div class="modal-dialog modal-lg" role="document">'+
            '<div class="modal-content">'+
                '<div class="modal-header">'+
                    '<h5 class="modal-title" id="academy_title">Edit Member Sub Academy Access</h5>'+
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                      '<span aria-hidden="true">&times;</span>'+
                    '</button>'+
                '</div>'+
                '<div class="modal-body">'+
                    '<div class="row">'+
                        '<div class="col-sm-8">'+
                            '<div class="form-group"  id="user_sub_academy_div">'+
                                '<label for="first-name">Sub Academies</label>'+
                                 '<select class="form-control" name="chosen-user-sub-academy[]" id="chosen-user-sub-academy" multiple="multiple">'+
                                '</select>'+
                            '</div>'+
                        '</div>'+
                        
                '</div>'+
                '<div class="modal-footer">'+
                    '<button type="button" data-user-id="'+ user_id +'" class="btn btn-primary" id="save-user-sub-academy-btn">Save</button>'+
                    '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</div>';

    $('body').append(output);
    $('#edit-user-sub-academy-details-modal').modal('show');
    loadUserSubAcademySubDetailsFormData(snow_id, user_id);
}

function loadUserSubAcademySubDetailsFormData(snow_id, user_id)
{
    cmsLoadingStatus = true;
    loadOverlay();
    var action   = "read_user_member_subscription_academy";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action      : action,
            token       : token,
            snow_id     : snow_id,
            user_id     : user_id,
        },
        success: function(data)
        {          
            if (data["data"] == "N/A")
            {               
                $("#user_sub_academy_div").html("<p><b>Member is not a Coach Membership or Staff - NSTC</b></p>");
                $("#save-user-sub-academy-btn").hide();
            }
            else
            {
                $("#chosen-user-sub-academy").html(data["data"]);
                $("#chosen-user-sub-academy").select2({
                    placeholder: 'Sub Academy Access',
                    theme: "bootstrap-5",
                    dropdownParent: $('#edit-user-sub-academy-details-modal .modal-body')
                });
            
            }
            cmsLoadingStatus = false;            
        }
    });
}

$(document).on('click', '#save-user-sub-academy-btn', function() {
    var user_id         = $(this).attr("data-user-id");  
    var plan_id         = $('#chosen-user-sub-academy').val();        
    cmsLoadingStatus    = true;
    loadOverlay();
    var action   = "create_user_subacademy_subscription_academy";
    var token    = $("input[name=token]").val();

     $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action      : action,
            token       : token,
            user_id     : user_id,
            plan_id     : plan_id            
        },
        success: function(data)
        {          
            cmsLoadingStatus = false;
            reload_data_registration_table();
            $('#edit-user-sub-academy-details-modal').remove();
            $('.modal-backdrop').remove();
        }
    });
});

function reload_data_registration_table()
{
    var data_url  = "../content/ajax_itf_common.php?action=read_user_registered&token="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val();
    $("#registration_tbl").DataTable({
        destroy: true,
        "ajax": data_url
    });
}

$(document).on('change', '#master-course-drop', function(e){
    console.log('clicked');
    var programme_id = $(this).val();
     var data_url  = "../content/ajax_itf_common.php?action=reload_data_course_admin&token="+$("input[name=token]").val()+"&programme_id="+programme_id;
    $("#course_admin_tbl").DataTable({
        destroy: true,
        "ajax": data_url
    });
});

$(document).on('change', '#course-drop-type', function(e){    
    loadOverlay();
    var action   = "get_master_course_by_academy";
    var token    = $("input[name=token]").val();
    var type     = $(this).val();

    
     $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action      : action,
            token       : token,
            type        : type            
        },
        success: function(data)
        {          
            cmsLoadingStatus = false;
            $('#course-master-type').html(data['data']);
            $('#course-master-type').trigger('change');
            if (type == 1)
            {
                $('.hiddenElearning').css("display", "none");
            }
            else
            {
                $('.hiddenElearning').show();
            }

        }
    });
});


$(document).on('change', '#course-master-type', function(e){   
    var programme_id = $(this).val();  
    var type         = $("#course-drop-type").val();
    var data_url  = "../content/ajax_itf_common.php?action=reload_data_course_master_type&token="+$("input[name=token]").val()+"&programme_id="+programme_id +"&type=" + type;

    if (type == 1 || type == 2 || type == 3)
    {
        $("#course_completion_admin_tbl").DataTable({
            destroy: true,
            "ajax": data_url,
            responsive: true,   
            dom: 'lBfrtip',
             buttons: [
                        { extend: 'excel', className: 'btn-dataTable' },
                            { 
                                extend: 'pdfHtml5', 
                                className: 'btn-dataTable', 
                                orientation: 'landscape',   
                                pageSize: 'LEGAL',
                                exportOptions: 
                                {
                                    columns: [ 0, 1, 2, 3, 4, 5, 6, 7 ]
                                }
                            }                 
                        ],
                        "columnDefs": [
                            { "width": "9%", "targets": 2 },
                            { "width": "9%", "targets": 7 },
                            { "width": "10%", "targets": 6 }
                    ]
        });
        $('#course_completion_admin_tbl').show();

        if ($('#course-drop-type').val() == 1)
        {
            $('.hiddenElearning').css("display", "none");
        }
        else
        {
            $('.hiddenElearning').show();
        }               

        $("#qualification_renewal_tbl").DataTable({
            destroy: true,
        });

        $("#qualification_renewal_tbl_wrapper").hide();
        $('#qualification_renewal_tbl').hide();
    }
    else
    {
        $("#course_completion_admin_tbl").DataTable({
            destroy: true,
        });

        $("#course_completion_admin_tbl_wrapper").hide();
        $('#course_completion_admin_tbl').hide();

        $("#qualification_renewal_tbl").DataTable({
            destroy: true,
            "ajax": data_url,
            responsive: true,   
            dom: 'lBfrtip'
        });

        $('#qualification_renewal_tbl').show();
    }

    
});

function verifyRequiredQuestionIsAnswered(entityId, contentId, type)
{
    var action   = "verify_required_question_is_answered";
    var token    = $("input[name=token]").val();
    var result   = true; 
    
    $.ajax({
        url: '../cms/ajax_course_builder.php',
        dataType: "json",
        async: false,
        data: {
            action      : action,
            ptToken     : token,
            entityId    : entityId,
            contentId   : contentId,
            type        : type            
        },
        success: function(data)
        {     
            result = data.result;       
        }
    });
    
    return result;
}

$(document).on('change', '#vc-dropdown', function() {

    if ($(this).val() == 2)
    {
        $('#book-voucher').show();
        $('#prog_fee_voucher').hide();
        $('#programme-voucher').hide();
        $('#book_fee_voucher').show();
    }
    else if ($(this).val() == 3)
    {
        $('#renewal-voucher').show();
        $('#prog_fee_voucher').hide();
        $('#programme-voucher').hide();
        $('#renewal_fee_voucher').show();
    }
    else
    {
        $('#book-voucher').hide();
        $('#prog_fee_voucher').show();
        $('#programme-voucher').show();
        $('#book_fee_voucher').hide();
        $('#renewal_fee_voucher').hide();
        $('#renewal-voucher').hide();
    }
});

$(document).on('change', "#book-dropdown", function() {
    cmsLoadingStatus = true;
    loadOverlay();
    var action   = "read_book_price";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    var bookId    = $(this).val();
    $.ajax({
        url: '../content/ajax_ebook_common.php',
        dataType: "json",
        data: {
            action      : action,
            token       : token,
            book_id     : bookId,           
        },
        success: function(data)
        {          
            console.log(data.output);
            $('#book-fee').html(data.output);
            $("#voucher-discount-wrapper").removeClass('d-none');
            updateVoucherDiscountValBook();
            cmsLoadingStatus = false;            
        }
    });
});

$(document).on('change', "#renewal-dropdown", function() {
    cmsLoadingStatus = true;
    loadOverlay();
    var action   = "read_renewal_requirement_price";
    var token    = $("input[name=token]").val();
    var academy  = $("input[name=academy]").val();
    var renewalId    = $(this).val();
    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action      : action,
            token       : token,
            renewal_id     : renewalId,           
        },
        success: function(data)
        {          
            console.log(data.output);
            $('#renewal-fee').html(data.output);
            $("#voucher-discount-wrapper").removeClass('d-none');
            updateVoucherDiscountValRenewal();
            cmsLoadingStatus = false;            
        }
    });
});

$(document).on('click', '.btn-add-voucher-renewal', function() {
    cmsLoadingStatus = true;
    loadOverlay();
    var action   = "redeemed_renewal_voucher";
    var token    = $("input[name=token]").val();
    var voucher  = $("#voucher_code").val();
    var renewalId = $(this).attr("data-regulation");
  
    console.log(voucher);
    $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action          : action,
            token           : token,
            renewal_id      : renewalId,   
            voucher         : voucher        
        },
        success: function(data)
        {          
            console.log(data.output);
            location.reload();
           
            cmsLoadingStatus = false;            
        }
    });

});

function searchGissCerts(e)
{
    e.preventDefault();
    $("#search-certs .alert").hide();
    $("#spinner-parent").show();
    $("#cert-info").hide();
    $("#cert-info").html("");
    var user_id = $("#user-id-for-cert").val();

    $.ajax({
        url : 'https://ahx-api.caseflies.com/api/base/searchUserCerts',            
        type:'post',
        data: {
            user_id    : user_id
        },
        success: function (data) 
        {
            $("#spinner-parent").hide();

            if (data.code == 1)
            {
                console.log(data);                   
                $("#cert-info").append("<p class='text-type'>Total certificates found: "+data.list.length+"</p>");                 

                for (var i=0; i<data.list.length; i++)
                {
                    $("#cert-info").append("<p style='cursor:pointer;' id='cert-id-parent-"+data.list[i].id+"' class='mt-2 text-type'>Certificate #: " + (i+1) + "</p>");
                    $("#cert-info").append('<section>'+
                                              '<div class="container h-100">'+
                                                '<div class="row d-flex h-100">'+
                                                  '<div class="col col-lg-12 mb-4 mb-lg-0">'+
                                                    '<div class="card mb-3" style="border-radius: .5rem;">'+
                                                      '<div class="row g-0">'+
                                                        
                                                        '<div class="col-md-5 gradient-custom text-center text-white mb-3"'+
                                                          'style="border-top-left-radius: .5rem; border-bottom-left-radius: .5rem;">'+
                                                          '<a href="" target="_blank">'+
                                                            '<img id="cert-image-'+i+'" src=""'+
                                                            'alt="Avatar" class="img-fluid my-5"/>'+
                                                          '</a>'+
                                                          '<h3></h3>'  +                 
                                                          '<a target="_blank" id="cert-url-'+i+'" href="">Certificate URL <i class="far fa-edit"></i> </a>'+
                                                        '</div>'+
                                                        
                                                        '<div class="col-md-7 text-left">'+
                                                          '<div class="card-body p-4">'+
                                                            '<h6 class="text-left">Information</h6>'+
                                                            '<hr class="mt-0 mb-4">'+
                                                            '<h4 style="display:inline-block;" class="text-left" id="user-name-'+i+'"></h4> '+
                                                            '<span id="span-user-name-'+i+'"></span>'+
                                                            '<div id="info-detail-'+i+'" class="row pt-5">'+
                                                            '<!-- Content goes here -->' + 
                                                            '</div>' + 
                                                          '</div>'+
                                                        '</div>'+
                                                      '</div>'+
                                                    '</div>'+
                                                  '</div>'+
                                                '</div>'+
                                              '</div>'+
                                            '</section><hr>');
                    
                    $("#cert-id-parent-"+data.list[i].id).on('click', function(){
                        $(this).next().slideToggle();
                    });

                    for (var key in data.list[i]) {
                        if (data.list[i].hasOwnProperty(key)) {
                            if (key == "id" || key == "user_id" || key == "type" || key == "url" || key == "name") {                                
                                continue;
                            }

                            var key_new = key.replace("_", " ");
                            key_new = key_new.toProperCase();
                            
                            if (data.list[i][key] == "")
                            {
                                data.list[i][key] = "-";
                            }

                            $("#info-detail-"+i).append('<div class="col-12 text-left mb-5">'+
                                                        '<span>'+key_new+': </span>'+
                                                            '<span>'+ data.list[i][key] +'</span>'+
                                                     '</div>');
                        }
                    }
                    
                    $("#user-name-"+i).html(data.list[i].name);
                    $("#span-user-name-"+i).html(" - " + user_id);
                    $("#cert-image-"+i).attr("src", data.list[i].url);
                    $("#cert-image-"+i).parent().attr("href", data.list[i].url);
                    $("#cert-url-"+i).attr("href", data.list[i].url);
                    $("#cert-url-"+i).css("text-decoration", "underline");
                    $("#user-name-"+i).css("color", "#053F90");
                    $("#cert-url-"+i).css("color", "#053F90");
                    
                }  
                
                $("#search-certs-wrapper #cert-info").fadeIn();
            }
            else
            {
                $("#search-certs .alert").addClass("alert-danger").html("No certificates found for the requested user id").slideDown();
            }
        }
    }); 
}

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};

function handlePaypalPaymentConfirmation(orderData, actionType="", itemId="")
{
    $("#paypal-error-msg").hide();
    $("#paypal-error-msg").removeClass('alert-danger');
    $("#paypal-error-msg").removeClass('alert-success');

    var functionType = 'confirmOrder';
    var token    = $("input[name=token]").val();
    $.ajax({
        url : '../paypal/handle_paypal_payment_callback.php',
        dataType: "json",
        type: "post",        
        data: {
            function    : functionType,
            ptToken     : token,
            orderData   : orderData,
            actionType  : actionType,
            itemId      : itemId
        },
        success: function (data) 
        {
            if (data.output == "success")
            {
                $("#paypal-error-msg").addClass('alert-success');                
                $("#paypal-error-msg").html("<p>Processing payment. Please wait...</p>")
                $("#paypal-button-container").fadeOut();
                $("#paypal-error-msg").fadeIn();
                setTimeout(function(){
                    var pageURL = window.location.href + "&paypal=showdetails";
                    window.location.href = pageURL;
                }, 500);                
            } 
            else
            {
                $("#paypal-error-msg").addClass('alert-danger');               
                $("#paypal-error-msg").html("<p>"+data.errorMessage+"</p>");
                $("#paypal-error-msg").fadeIn();
            }    
        }
    });
}

$(document).on('click', '.btn-submit-platform', function() { 
    var value = $('input[name="cell_answer_1"]:checked').val();
    loadOverlay();
    var action   = "save_user_submission_platform";
    var token    = $("input[name=token]").val();
    var view     = urlViewVal;
    if (value != undefined || value != null)
    {
        $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action      : action,
                token       : token,
                view        : view,
                value       : value           
            },
            success: function(data)
            {          
                cmsLoadingStatus = false;
                alert("Thank you for your feedback.");
                $('.floating-footer').hide();
            }
        });    
    }
    else
    {
        cmsLoadingStatus = false;
        alert("Select a scale from 1 to 5 and click the Rate button to provide feedback.");
    }
    
});

$(document).on('click', '.btn-submit-guided', function() {  
    loadOverlay();
    var action   = "save_user_submission_platform";
    var token    = $("input[name=token]").val();
    var view     = urlViewVal;
    var value = $(this).attr("data-attr");
     $.ajax({
        url: '../content/ajax_itf_common.php',
        dataType: "json",
        data: {
            action      : action,
            token       : token,
            view        : view,
            value       : value           
        },
        success: function(data)
        {          
            cmsLoadingStatus = false;
            alert("Thank you for your feedback.");
            $('.floating-footer').hide();
        }
    });    
});

$(window).resize(function() {
     if ($('#academy-elearning-dashboard').length) {
        if ($(window).width() < 1444) { 
            calculateMobileHeightF2F();
        } else {
             calculateHeightF2F();
        }
    }

    if ($("#registrationForm").length) {
        if ($(window).width() <= 768) { 
            adjustFooterCss();
        }
    }
});

function calculateHeightF2F() {   
    var f2fHeight        = $('#my-face-to-face-progress').height();
    var elearningHeight  = $('#my-elearning-progress').height();

    if (elearningHeight <= 365) {
        if (elearningHeight > f2fHeight) {
            $('#my-face-to-face-progress').height(elearningHeight);
            $('#dashboard-progress-f2f').height(elearningHeight - 30);
        } else {
            $('#my-face-to-face-progress').height(f2fHeight);
            $('#dashboard-progress-f2f').height(f2fHeight - 30);
        }        
    }

    if (f2fHeight <= 365) {
        if (f2fHeight > elearningHeight) {
            $('#my-elearning-progress').height(f2fHeight);
            $('#dashboard-progress-elearning').height(f2fHeight - 30);
        } else {
            $('#my-elearning-progress').height(elearningHeight);
            $('#dashboard-progress-elearning').height(elearningHeight - 30);
        }
       
    }
}

function hide_and_show_dashboard_elements() {

    if ($(window).width() < 768) {
        $('.show-in-mobile').show();
        $('.show-in-desktop').hide();   
    }
    else {

        $('.academy-courses-dashboard-common').each(function() {
            let currentMargin = parseInt($(this).css("margin-left"));            
            $(this).css("margin-left", currentMargin - 2 + "px");
        })
    }
}

function calculateMobileHeightF2F() {   
    var f2fHeight        = $('#my-face-to-face-progress').attr("data-min");
    var elearningHeight  = $('.progress-elearning-courses').attr("data-min");  

    if (elearningHeight < 365) {     
        $('#my-elearning-progress').height(elearningHeight);
        $('#dashboard-progress-elearning').height(elearningHeight - 30);
    }
   
    if (f2fHeight < 365) {
        $('#my-face-to-face-progress').height(f2fHeight);
        $('#dashboard-progress-f2f').height(f2fHeight - 30); 
    }
}


$(document).on('click', ".change-session-roles-itf", function(e) {
    loadOverlay();
    var action  = "save_user_role_types";
    var token   = $("input[name=token]").val();
    var type    = "role";
    var value   = $(this).attr("data-id");
    e.preventDefault();
    $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            data: {             
                token           : token,
                action          : action,
                type            : type,
                role_id         : value
            },          
            success: function(data)
            {     
                cmsLoadingStatus = false;
                location.reload(); 
            }
        });        
});

function adjustFooterCss() {    
    $('.new-main-footer').css("position", "relative");
}

$(document).on('click', ".remove_login_slider", function(e) {
    loadOverlay();
    var action      = "remove_slider_login";
    var token       = $("input[name=token]").val();
    var urlImage    = $(this).attr("data-attr");
    e.preventDefault();
    $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            data: {             
                token           : token,
                action          : action,
                image           : urlImage
                
            },          
            success: function(data)
            {     
                cmsLoadingStatus = false;
                alert("Image Removed Successfully.")
                location.reload(); 
            }
        });        
});

$(document).on('click', ".update-btn-zip", function(e) {
    loadOverlay();
    var action      = "update_btn_zip";
    var state       = $("#state").val();
    var zip         = $("#zip_code").val();
    var token       = $("input[name=token]").val();
    e.preventDefault();
    $.ajax({
            url: '../content/ajax_itf_common.php',
            dataType: "json",
            data: {             
                token           : token,
                action          : action,
                state           : state,
                zip             : zip
                
            },          
            success: function(data)
            {     
                cmsLoadingStatus = false;
                location.reload(); 
            }
        });        
});

//Hide info popovers on general clicks 
$(document).on('click', function(e) {
    var $target = $(e.target);

    // Check if the clicked element is outside the popover and the button
    if (!$target.closest('.popover').length && !$target.closest('.btn-info-popover').length) {
      $('.btn-info-popover').popover('hide');
    }
  });


function toggleVoucherCodeWrapperDisplay() {
    $("#online-voucher-code-wrapper").slideToggle();
}


function updatePageTitleForQuarterlyReports()
{
    var activeTabText   = $(".nav-link.active").text();
    var selectedAcademy = $("#qr-academy-dropdown option:selected").text();
    var selectedQuarter = $("#qr-quarter-dropdown option:selected").text();
    var selectedYear    = $("#qr-year-dropdown option:selected").text();

    document.title = selectedAcademy + " | " + activeTabText + " | " + selectedQuarter + " | " + selectedYear;
}

function loadQuarterlyReportsActiveUsersTable()
{       
    cmsLoadingStatus = true;
    loadOverlay();

    var selectedAcademy = $("#qr-academy-dropdown").val();
    var selectedQuarter = $("#qr-quarter-dropdown").val(); 
    var selectedYear    = $("#qr-year-dropdown").val();      
    var columnDefs;

    if (selectedAcademy == 103)  
    {
        columnDefs = [{ targets: [4, 5], visible: true }];
    } 
    else 
    {
        columnDefs = [{ targets: [4, 5], visible: false }];
    }  

    $("#qr-active-users-table").dataTable({
        destroy: true,
        "ajax": "../content/ajax_itf_common.php?action=read_active_users_quarterly_reports&year=" + selectedYear + "&&quarter=" + selectedQuarter + "&token=" + $("input[name=token]").val() + "&academy=" + selectedAcademy,
        "deferRender": true,
        "pageLength": 10,
        order: [[1, 'desc']],
        dom: 'lBfrtip',
        scrollX: true,
        scrollCollapse: true,
        fixedColumns: {
            left: 1
        },
        columnDefs: columnDefs,
        buttons: [
            {
                extend: 'excel',
                className: 'btn-dataTable',
                title: null,
                customize: function(xlsx) {
                    customizeExcelExportQuarterlyReports(xlsx);
                }
            }                
        ],
        "initComplete": function () {
            cmsLoadingStatus = false;
            updatePageTitleForQuarterlyReports();
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }
    });        
}

function loadQuarterlyReportsAssessmentsTable()
{       
    cmsLoadingStatus = true;
    loadOverlay();

    var selectedAcademy = $("#qr-academy-dropdown").val();
    var selectedQuarter = $("#qr-quarter-dropdown").val(); 
    var selectedYear    = $("#qr-year-dropdown").val(); 

    $("#qr-assessment-courses-table").dataTable({
        destroy: true,
        "ajax": "../content/ajax_itf_common.php?action=read_assessment_courses_quarterly_reports&year="+ selectedYear +"&&quarter="+ selectedQuarter +"&token="+$("input[name=token]").val()+"&academy="+selectedAcademy,
        "deferRender" : true,
        "pageLength": 10,
        order: [[5, 'desc']],
        dom: 'lBfrtip',
        scrollX: true,
        scrollCollapse: true, // Optional: allows the table to collapse when fewer columns are present
        fixedColumns: {
            left: 1 // Optional: fix the first column in place while scrolling
        },          
        buttons: [
            {
                extend: 'excel',
                className: 'btn-dataTable',
                title: null,
                customize: function(xlsx) {
                    customizeExcelExportQuarterlyReports(xlsx);
                }
            }                
        ],
        "initComplete" : function(){
            cmsLoadingStatus = false;
            updatePageTitleForQuarterlyReports();
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }
    });        
}

function loadQuarterlyReportsEcommTable()
{       
    cmsLoadingStatus = true;
    loadOverlay();

    var selectedAcademy = $("#qr-academy-dropdown").val();
    var selectedQuarter = $("#qr-quarter-dropdown").val(); 
    var selectedYear    = $("#qr-year-dropdown").val();      

    $("#qr-ecommerce-transactions-table").dataTable({
        destroy: true,
        "ajax": "../content/ajax_itf_common.php?action=read_ecommerce_course_transactions_quarterly_reports&year="+ selectedYear +"&&quarter="+ selectedQuarter +"&token="+$("input[name=token]").val()+"&academy="+selectedAcademy,
        "deferRender" : true,
        "pageLength": 10,
        order: [[4, 'desc']],
        dom: 'lBfrtip',
        scrollX: true,
        scrollCollapse: true, // Optional: allows the table to collapse when fewer columns are present
        fixedColumns: {
            left: 1 // Optional: fix the first column in place while scrolling
        },          
        buttons: [
            {
                extend: 'excel',
                className: 'btn-dataTable',
                title: null,
                customize: function(xlsx) {
                    customizeExcelExportQuarterlyReports(xlsx);
                }
            }                
        ],
        "initComplete" : function(){
            cmsLoadingStatus = false;
            updatePageTitleForQuarterlyReports();
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }
    });        
}

function loadQuarterlyReportsEbooksEcommTable()
{       
    cmsLoadingStatus = true;
    loadOverlay();

    var selectedAcademy = $("#qr-academy-dropdown").val();
    var selectedQuarter = $("#qr-quarter-dropdown").val(); 
    var selectedYear    = $("#qr-year-dropdown").val();  

    $("#qr-ebooks-transactions-table").dataTable({
        destroy: true,
        "ajax": "../content/ajax_itf_common.php?action=read_ecommerce_ebooks_transactions_quarterly_reports&year="+ selectedYear +"&&quarter="+ selectedQuarter +"&token="+$("input[name=token]").val()+"&academy="+selectedAcademy,
        "deferRender" : true,
        "pageLength": 10,
        order: [[4, 'desc']],
        dom: 'lBfrtip',
        scrollX: true,
        scrollCollapse: true, // Optional: allows the table to collapse when fewer columns are present
        fixedColumns: {
            left: 1 // Optional: fix the first column in place while scrolling
        },          
        buttons: [
            {
                extend: 'excel',
                className: 'btn-dataTable',
                title: null,
                customize: function(xlsx) {
                    customizeExcelExportQuarterlyReports(xlsx);
                }
            }                
        ],
        "initComplete" : function(){
            cmsLoadingStatus = false;
            updatePageTitleForQuarterlyReports();
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }
    });        
}


$(document).on('show.bs.modal', '#water-safety-approve-modal', function (event) {
    var span        = $(event.relatedTarget);
    var documentId  = span.attr('data-request-id');
    var modal       = $(this);
    modal.find('.btn-approved-ils-document').attr("data-request-id", documentId);
    modal.find('#btn-reject-water-safety').attr("data-request-id", documentId);
});


function customizeExcelExportQuarterlyReports(xlsx) {
    var sheet = xlsx.xl.worksheets['sheet1.xml'];
    
    // Get all rows
    var rows = $('row', sheet);
    
    // For each cell in each row, update its column reference
    // to shift it one column to the right
    rows.each(function() {
        $(this).children('c').each(function() {
            var cellRef = $(this).attr('r');
            if (cellRef) {
                // Increment the column letter (e.g., A1 becomes B1)
                var newRef = cellRef.replace(/([A-Z]+)(\d+)/, function(match, col, row) {
                    var nextCol = String.fromCharCode(col.charCodeAt(0) + 1);
                    return nextCol + row;
                });
                $(this).attr('r', newRef);
            }
        });
    });
    
    // Add new filename column
    var headerRow = rows.first();
    headerRow.prepend('<c r="A1" s="2" t="inlineStr"><is><t>Filename</t></is></c>');
    
    // Add page title to all data rows
    var rowNum = 2;
    rows.not(':first').each(function() {
        $(this).prepend('<c r="A' + rowNum + '" t="inlineStr"><is><t>' + document.title + '</t></is></c>');
        rowNum++;
    });
}

$(document).on('click', '.btn-approved-ils-document', function() {
    var action              = "approve_ils_document_upload";
    var token               = $("input[name=token]").val();
    var documentId          = $(this).attr('data-request-id');
    var documentNotes       = $('#document_notes').val();
    var documentDate        = $('#date_achieved_ils').val();
    console.log(documentId);
    
    var confirmation = confirm("Are you sure you want to approve this document upload?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action          : action,
                token           : token,
                id              : documentId,
                notes           : documentNotes,
                date_achieved   : documentDate
            },
            success: function (data)
            {
                cmsLoadingStatus = false;
                location.reload();           
            }
        });
    } 

});

$(document).on('show.bs.modal', '#view-rejection-document-modal', function (event) {
    var span = $(event.relatedTarget);
    var name = span.attr('data-qualification-notes');
    var modal = $(this);
    modal.find('#rejectMessage').html(name);
});

$(document).on('click', '#btn-reject-water-safety', function() {
    var action              = "reject_ils_document_upload";
    var token               = $("input[name=token]").val();
    var documentId         = $(this).attr('data-request-id');
    var documentNotes      = $('#document_notes').val();
    console.log(documentId);
    
    var confirmation = confirm("Are you sure you want to reject this document?");
    if (confirmation == true)
    {
        cmsLoadingStatus = true;
        loadOverlay();

        $.ajax({
            url : '../content/ajax_itf_common.php',
            dataType: "json",
            data: {
                action          : action,
                token           : token,
                id              : documentId,
                notes           : documentNotes
            },
            success: function (data)
            {
                cmsLoadingStatus = false;
                location.reload();           
            }
        });
    } 

});

function loadAssessmentQuestionBank()
{
    cmsLoadingStatus = true;
    loadOverlay();
    tbl_assessment_question_bank = 
    $("#tbl_ab_question_bank").DataTable({
        "destroy": true,
        "ajax": "../cms/ajax_cms.php?action=read_assessment_question_bank_tbl&ptToken="+$("input[name=token]").val()+"&academy="+$("input[name=academy]").val(),
        "pageLength": 50, 
        "responsive": true,
        "order": [[0, 'desc']],
        /*"columnDefs": [                        
            { targets: 0, visible: false },
            { targets: 1, visible: false }               
        ],*/
        "initComplete" : function(){
            cmsLoadingStatus = false;
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        }  
    });          
}

$(document).on('show.bs.modal', '#view-rejection-document-modal-ils', function (event) {
    var span = $(event.relatedTarget);
    var name = span.attr('data-qualification-notes');
    var modal = $(this);
    modal.find('#rejectMessage').html(name);
});


$(document).on('show.bs.modal', '#qualification-approve-modal', function (event) {
        var span                = $(event.relatedTarget) // span that triggered the modal
        var requestId           = span.attr('data-request-id'); // Extract info from data-* attributes
        var name                = span.attr('data-name');
        var userQualificationId = span.attr('data-user-qualification-id');

        var action              = "read_renewal_request_by_id";
        var token               = $("input[name=token]").val();
        var modal               = $(this);
        modal.find('#username').html(name);
        console.log("hellio");
      
        $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action             : action,
                    token              : token,
                    requestId          : requestId,
                    user_qualification_id : userQualificationId
                   
                },
                success: function(data)
                {                           
                    modal.find('#activity_type').html(data.output);
                }
        });
        
});


$(document).on('click', '.btn-approve-cpd-submission', function() {
        var action              = "approve_cpd_request";
        var token               = $("input[name=token]").val();
        var cpdId               = $(this).attr("data-id");
        var valueAttained       = $("#allocate_" + cpdId ).val();
        var requestId           = $("#renewal_request_id").val();
        var userQualificationId = $("#user_qualification_id").val();

        var activityAllocations = [];
        activityAllocations.push({
                    "id": cpdId,
                    "valueAttained": valueAttained
        });
       

         // Create FormData object
        var formData = new FormData();
        formData.append('action', action);
        formData.append('token', token);
        formData.append('activityAllocations', JSON.stringify(activityAllocations)); 
        formData.append('request_id', requestId);
        formData.append('user_qualification_id', userQualificationId);
        
        $.ajax({
            url: '../content/ajax_itf_common.php',
            type: 'POST', 
            data: formData,
            contentType: false, 
            processData: false, 
            dataType: "json",
            success: function(data) {    
                if (data.error != null) {
                
                    alert(data.error);   
                    cmsLoadingStatus = false;               
                } 
                else {

                    location.reload();  
                }                           
                                     
            }
        });

     });

    $(document).on('click', '.btn-edit-cpd-submission', function() {
        var cpdId               = $(this).attr("id");
        $("#allocate_" + cpdId).removeAttr('disabled');
        $("#approvecpd_" + cpdId).removeAttr('disabled');
        $("#approvecpd_" + cpdId).text('Approve');
     });

  $(document).on('click', '#btn-approve-qualification', function() {

        var action              = "approve_renewal_request";
        var token               = $("input[name=token]").val();
        var description         = $("#cpd_comments").val();
        var requestId           = $("#renewal_request_id").val();
        var userQualificationId = $("#user_qualification_id").val();
        var dateApproved        = $("#date_approved").val();

        var activityAllocations = [];
        cmsLoadingStatus = true;
        loadOverlay();

        $("[id^='allocate_']").each(function() {
            var id               = $(this).attr('id'); 
            var nextid           = id.split('_')[1]; 
            var valueAttained    = $(this).val();
            
            activityAllocations.push({
                        "id": nextid,
                        "valueAttained": valueAttained
            });
        });

         // Create FormData object
        var formData = new FormData();
        formData.append('action', action);
        formData.append('token', token);
        formData.append('description', description);
        formData.append('activityAllocations', JSON.stringify(activityAllocations)); 
        formData.append('request_id', requestId);
        formData.append('user_qualification_id', userQualificationId);
        formData.append('date_approved', dateApproved);
        
        $.ajax({
            url: '../content/ajax_itf_common.php',
            type: 'POST', 
            data: formData,
            contentType: false, 
            processData: false, 
            dataType: "json",
            success: function(data) {    
                if (data.error != null) {
                
                    alert(data.error);   
                    cmsLoadingStatus = false;               
                } 
                else {

                    location.reload();  
                }                           
                                     
            }
        });

     });

    $(document).on('click', '#btn-reject-qualification', function() {

        var action              = "reject_renewal_request";
        var token               = $("input[name=token]").val();
        var description         = $("#cpd_comments").val();
        var requestId           = $("#renewal_request_id").val();
        var userQualificationId = $("#user_qualification_id").val();
        cmsLoadingStatus = true;
        loadOverlay();

        var activityAllocations = [];

        $("[id^='allocate_']").each(function() {
            var id               = $(this).attr('id'); 
            var nextid           = id.split('_')[1]; 
            var valueAttained    = $(this).val();
            
            activityAllocations.push({
                        "id": nextid,
                        "valueAttained": valueAttained
            });
        });

         // Create FormData object
        var formData = new FormData();
        formData.append('action', action);
        formData.append('token', token);
        formData.append('description', description);
        formData.append('activityAllocations', JSON.stringify(activityAllocations)); 
        formData.append('request_id', requestId);
        formData.append('user_qualification_id', userQualificationId);
        
        $.ajax({
            url: '../content/ajax_itf_common.php',
            type: 'POST', 
            data: formData,
            contentType: false, 
            processData: false, 
            dataType: "json",
            success: function(data) {    
                if (data.error != null) {
                
                    alert(data.error);   
                    cmsLoadingStatus = false;               
                } 
                else {

                    location.reload();  
                }                           
                                     
            }
        });
});


$(document).on('show.bs.modal', '#edit-qualification-upload-modal', function (event) {
        var span                = $(event.relatedTarget) 
        var requestId           = span.attr('data-request-id');
        var name                = span.attr('data-qualification-name');
        var qualificationId     = span.attr('data-qualification-id');
        var qualificationDate   = span.attr('data-qualification-date');

        var action              = "read_renewal_request_open_for_edit_by_id";
        var token               = $("input[name=token]").val();
        var modal               = $(this);

        var optionHtml          = '<option value="'+qualificationId+'" selected="true">'+name+'</option>';

        modal.find('#qualification_name').html(optionHtml);
        modal.find('#qualification_name').val(qualificationId);

        modal.find('#qualification_id').val(qualificationId);
        var formattedDate = qualificationDate.split(" ")[0];
        modal.find('#date_achieved').val(formattedDate).trigger("change");
       
        console.log("changed");
        console.log($('#edit-qualification-upload-modal').find('#date_achieved').val());
        $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action             : action,
                    token              : token,
                    requestId          : requestId,
                    qualification_id   : qualificationId,
                },
                success: function(data)
                {                           
                    modal.find('#edit_activity_cpd_row').html(data.output);
                }
        });
        
});

$(document).on('click', '#add-qualification-activity-btn', function() {
        var openModal       = $(".modal:visible");
        var count   = openModal.find("[id^='activityType_']").length;
        var nextid  = count + 1;
        

        var reqHtml = ` <div class="row mt-3 activity-row">
                            <div class="col-md-6">
                                <label>Select Activity Type</label>
                                <select class="form-control activity_types_select" id="activityType_`+nextid+`">
                                    <option value="0">Please select</option>  
                                    <option value="judging">Judging Hours</option>  
                                    <!--option value="coaching">Coaching Hours</option>  
                                    <option value="conference">Conference attendance</option>  
                                    <option value="national">National Course</option-->     
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label>Number of Hours</label>
                                <input type="number" class="form-control hours_attained" id="hoursAttained_`+nextid+`" />
                            </div>
                        </div>
                        <div class="row mt-3 activity-row">
                            <div class="col-md-12">
                                <label>Description</label>
                                <textarea class="form-control description_of_cpd" id="descriptionofCpd_`+nextid+`" rows="3"></textarea>
                            </div>
                        </div>
                        <div class="row mt-3 activity-row">
                        <div class="col-md-12">
                                    <label>Upload Files</label>
                                    <input type="file" id="cpd_upload_attached_`+nextid+`" name="attached_documents_`+nextid+`" multiple/>
                        </div></div>`;
        console.log(reqHtml);
        $("#activity_cpd_row").append(reqHtml);
       
});


$(document).on('click', '#edit-qualification-activity-btn', function() {
        var openModal       = $(".modal:visible");
        var count   = openModal.find("[id^='activityType_']").length;
        var nextid  = count + 1;
        

        var reqHtml = ` <div class="row mt-3 activity-row">
                            <div class="col-md-6">
                                <label>Select Activity Type</label>
                                <select class="form-control activity_types_select" id="activityType_`+nextid+`">
                                    <option value="0">Please select</option>  
                                    <option value="judging">Judging Hours</option>  
                                    <!--option value="coaching">Coaching Hours</option>  
                                    <option value="conference">Conference attendance</option>  
                                    <option value="national">National Course</option-->     
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label>Number of Hours</label>
                                <input type="number" class="form-control hours_attained" id="hoursAttained_`+nextid+`" />
                            </div>
                        </div>
                        <div class="row mt-3 activity-row">
                            <div class="col-md-12">
                                <label>Description</label>
                                <textarea class="form-control description_of_cpd" id="descriptionofCpd_`+nextid+`" rows="3"></textarea>
                            </div>
                        </div>
                        <div class="row mt-3 activity-row">
                        <div class="col-md-12">
                                    <label>Upload Files</label>
                                    <input type="file" id="cpd_upload_attached_`+nextid+`" name="attached_documents_`+nextid+`" multiple/>
                        </div></div>`;
        console.log(reqHtml);
        $("#edit_activity_cpd_row").append(reqHtml);
       
});

$(document).on("click", ".btn-qualification-request", function(){
        var action          = "create_qualification_request";
        var openModal       = $(".modal:visible");
        var token           = $("input[name=token]").val();
        var qualification   = openModal.find('#qualification_name').val();
        var activityType    = openModal.find('#activity_type').val();
        var hoursAttained   = openModal.find('#hours_attained').val();
        var description     = openModal.find('#description_of_cpd').val();
        var actionType      = $(this).attr("data-attr");
        var qualificationId = $("input[name=qualification_id]").val();
        var typeQualification = $('.btn-qualification-request').attr("data-type");
        
        var dateAchieved    = openModal.find('#date_achieved').val();
        console.log(dateAchieved);

        cmsLoadingStatus = true;
        loadOverlay();

        var allQualifications   = [];
        var formData            = new FormData();
        var fileQualification   = $('#files_for_qualification')[0].files;

        openModal.find("[id^='activityType_']").each(function() {
            var id              = $(this).attr('id'); 
            var nextid          = id.split('_')[1]; 
            var activityType    = $(this).val();
            var hours           = openModal.find('#hoursAttained_' + nextid).val();
            var description     = openModal.find('#descriptionofCpd_' + nextid).val();
            var files           = openModal.find('#cpd_upload_attached_' + nextid)[0].files;
           
            if (typeQualification == "judging") {
                 if (hours == "" || hours == null)  {
                    alert("Delivery hours achieved of the qualification is required.");
                    cmsLoadingStatus = false;
                    return;
                }
            }

            // Combine the data for this specific pair
            allQualifications.push({
                        "activity": activityType,
                        "hours": hours,
                        "description": description,
                        "id" : nextid
            });

            if (files.length > 0) {
                for (var i = 0; i < files.length; i++) {
                    formData.append('cpd_upload_attached_' + nextid + '[]', files[i]);
                }
           }

        });

        for (var i = 0; i < fileQualification.length; i++) {
            formData.append('files_for_qualification[]', fileQualification[i]);
        }

        // Create FormData object
        formData.append('action', action);
        formData.append('token', token);
        formData.append('qualification', qualification);
        formData.append('allQualification', JSON.stringify(allQualifications)); 
        formData.append('btnAction', actionType);
        formData.append('qualificationId', qualificationId);
        formData.append('dateAchieved', dateAchieved);

        if ((allQualifications.length === 0) && (typeQualification == "judging")) {
            alert("No qualification will be uploaded as there are no activity.");
            cmsLoadingStatus = false;
        }
        else if (dateAchieved === "") {
            alert("Date achieved of the qualification is required.");
            cmsLoadingStatus = false;
        }
        else {
        

            $.ajax({
                url: '../content/ajax_itf_common.php',
                type: 'POST', 
                data: formData,
                contentType: false, 
                processData: false, 
                dataType: "json",
                success: function(data) {    
                    if (data.error != null) {
                        alert(data.error);   
                        cmsLoadingStatus = false;    

                    } 
                    else {
                        cmsLoadingStatus = false;
                       
                        setTimeout(function() {
                            openModal.modal('hide'); 
                        }, 1000); 
                        location.reload();
                    }                           
                                         
                }
            });
        }
});

function reload_national_coaching_tbl()
{ 
    var data_url = "../content/ajax_itf_common.php?action=reload_national_coaching&token="+$("input[name=token]").val()+"&table_name=national_coaching_tbl";
    $('#national_coaching_tbl').DataTable().ajax.url(data_url).load();
}

function reload_national_training_tbl()
{ 
    var data_url = "../content/ajax_itf_common.php?action=reload_national_coaching&token="+$("input[name=token]").val()+"&table_name=national_training_tbl";
    $('#national_training_tbl').DataTable().ajax.url(data_url).load();
}

$(document).on('show.bs.modal', '#assign-accred-modal', function (event) {
        var span                = $(event.relatedTarget) 
        var countryid           = span.attr('data-country-id');
        var countryname         = span.attr('data-country-name');
        var accredId            = span.attr('data-accred-id');
        var token               = $("input[name=token]").val();
        var modal               = $(this);
        console.log(countryname);
        modal.find('#countryName').html(countryname);
        modal.find('#country_id').val(countryid);
        modal.find('#accredLevel').val(accredId);
});

$(document).on("click", "#btn-send-for-approve-accred", function() {
        var action              = "assign_level_for_country";
        var token               = $("input[name=token]").val();
        var country_id         = $("#country_id").val();
        var level_id           = $("#accred_level").val();
        var accredId           = $("#accredLevel").val();
       
        cmsLoadingStatus = true;
        loadOverlay();

         $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action             : action,
                    token              : token,
                    country_id          : country_id,
                    level_id            : level_id,
                    accredId            : accredId,
                },
                success: function(data)
                {                           
                    location.reload();
                    //cmsLoadingStatus = false;
                    //$("#assign-accred-modal").modal("hide"); 
                }
        });
});

$(document).on('show.bs.modal', '#assign-accreditation-modal', function (event) {
        var span                = $(event.relatedTarget) 
        var countryid           = span.attr('data-country-id');
        var countryname         = span.attr('data-country-name');
        var accredId            = span.attr('data-accred-id');
        var token               = $("input[name=token]").val();
        var modal               = $(this);
        console.log(countryname);
        modal.find('#countryName').html(countryname);
        modal.find('#country_id_val').val(countryid);
});

$(document).on("click", "#approve-accreditation", function() {

  
        var action              = "approve_accreditation";
        var token               = $("input[name=token]").val();
        var oal_id              = $(this).attr("data-allocation-id");
        var notes               = $('#approve-accred-notes').val();
        var countryId           = $(this).attr("data-country-id");
        var activityId          = $(this).attr("data-accred-id");


        cmsLoadingStatus = true;
        loadOverlay();

         $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action             : action,
                    token              : token,
                    oal_id             : oal_id,
                    notes              : notes,
                    country_id         : countryId,
                    activity_id        : activityId,
                },
                success: function(data)
                {                           
                   location.reload();
                }
        });
     
});


$(document).on('show.bs.modal', '#approve-accreditation-modal', function (event) {
        var span                = $(event.relatedTarget) 
        var accredLevel         = span.attr('data-accred-type');
        var countryname         = span.attr('data-country-name');
        var accredId            = span.attr('data-accred-id');
        var accredType          = span.attr('data-allocation-id');
        var token               = $("input[name=token]").val();
        var countryId           = span.attr('data-country-id');
        var activityId           = span.attr('data-activity-id');

        var modal               = $(this);
        console.log(countryname);
        modal.find('#countryNameApprove').html(countryname);
        modal.find('#level').html(accredLevel);
        modal.find('#accredType').html(accredType);

        modal.find('#approve-accreditation').attr("data-allocation-id", accredId);
        modal.find('#btn-reject-accreditaion').attr("data-allocation-id", accredId);

        modal.find('#approve-accreditation').attr("data-country-id", countryId);
        modal.find('#btn-reject-accreditaion').attr("data-country-id", countryId);

        modal.find('#approve-accreditation').attr("data-accred-id", activityId);
        modal.find('#btn-reject-accreditaion').attr("data-accred-id", activityId);
});

$(document).on("click", "#btn-reject-accreditaion", function() {

    var confirmation = confirm("Are you sure you want to reject this accreditation?");

    if (confirmation == true)
    {
        var action              = "reject_accreditation";
        var token               = $("input[name=token]").val();
        var oal_id              = $(this).attr("data-allocation-id");
        var notes               = $('#approve-accred-notes').val();

        var countryId           = $(this).attr("data-country-id");
        var activityId          = $(this).attr("data-accred-id");
        
        cmsLoadingStatus = true;
        loadOverlay();

         $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action             : action,
                    token              : token,
                    oal_id             : oal_id,
                    notes              : notes,
                    country_id         : countryId,
                    activity_id        : activityId,
                },
                success: function(data)
                {                           
                    location.reload();
                }
        });
    }
     
});

$(document).on("click", "#btn-send-for_approve-training", function() {
        var action              = "assign_level_for_country";
        var token               = $("input[name=token]").val();
        var country_id         = $("#country_id_val").val();
        var level_id           = $("#accred_level_training").val();
       
        cmsLoadingStatus = true;
        loadOverlay();

         $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action             : action,
                    token              : token,
                    country_id          : country_id,
                    level_id            : level_id,
                },
                success: function(data)
                {                           
                    // reload_national_training_tbl();
                    cmsLoadingStatus = false;
                    // $("#assign-accreditation-modal").modal("hide"); 
                    location.reload();
                }
        });
});

$(document).on('show.bs.modal', '#add-organisation-modal', function (event) {
        var span                = $(event.relatedTarget);
        var token               = $("input[name=token]").val();
        var modal               = $(this);
        cmsLoadingStatus = true;
        loadOverlay();

         $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action             : "read_html_organisation",
                    token              : token
                },
                success: function(data)
                {   
                    cmsLoadingStatus = false;
                    modal.find('#add-organisation-html').html(data.output);
                }
        });
});

$(document).on("click", "#add-organisation", function() {
        var action              = "add_organisation_for_country";
        var token               = $("input[name=token]").val();
        var country_id          = $("#country").val();
        var name                = $("#name").val();
        var address             = $("#address").val();
        var city                = $("#city").val();
        var zip                 = $("#zip").val();



        if (!country_id || !name || !address || !city || !zip) {

             alert("Please fill in all the required fields.");
        } else {
            cmsLoadingStatus = true;
            loadOverlay();

             $.ajax({
                    url: '../content/ajax_itf_common.php',
                    dataType: "json",
                    data: {
                        action             : action,
                        token              : token,
                        country_id          : country_id,
                        name                : name,
                        address             : address,
                        city                : city,
                        zip                : zip
                    },
                    success: function(data)
                    {                           
                        location.reload();
                       
                    }
            });
     }
});

$(document).on('show.bs.modal', '#edit-organisation-modal', function (event) {
        var span                = $(event.relatedTarget);
        var token               = $("input[name=token]").val();
        var organisationId         = span.attr('data-content-id');
        var modal               = $(this);
        cmsLoadingStatus = true;
        loadOverlay();

         $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action             : "read_html_organisation_by_id",
                    token              : token,
                    id                 : organisationId
                },
                success: function(data)
                {   
                    cmsLoadingStatus = false;
                    modal.find('#edit-organisation-html').html(data.output);
                }
        });
});

$(document).on("click", "#edit-organisation", function() {
        var action              = "edit_organisation_for_country";
        var token               = $("input[name=token]").val();
        var country_id          = $("#country").val();
        var name                = $("#name").val();
        var address             = $("#address").val();
        var city                = $("#city").val();
        var zip                 = $("#zip").val();
        var id                  = $("#organisation_id").val();

        cmsLoadingStatus = true;
        loadOverlay();

         $.ajax({
                url: '../content/ajax_itf_common.php',
                dataType: "json",
                data: {
                    action             : action,
                    token              : token,
                    country_id         : country_id,
                    name               : name,
                    address            : address,
                    city               : city,
                    zip                : zip,
                    id                 : id
                },
                success: function(data)
                {                           
                    location.reload();
                   
                }
        });
     
});

$(document).on("change", "#select-options-regions", function() {
        var action              = "filter_accreditation_list";
        var token               = $("input[name=token]").val();
        var region              = $(this).val();
       

        cmsLoadingStatus = true;
        loadOverlay();

         $.ajax({
                url: '../cms/ajax_cms.php',
                dataType: "json",
                type: "post",
                data: {
                    action             : action,
                    ptToken            : token,
                    region             : region
                },
                success: function(data)
                {  
                   var html = data.output;                         
                   $("#accreditation-container").html('');
                   cmsLoadingStatus = false;
                   $("#accreditation-container").html(html);
                }
        });
     
});


  
